var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a;
function ascending(a2, b) {
  return a2 == null || b == null ? NaN : a2 < b ? -1 : a2 > b ? 1 : a2 >= b ? 0 : NaN;
}
function descending(a2, b) {
  return a2 == null || b == null ? NaN : b < a2 ? -1 : b > a2 ? 1 : b >= a2 ? 0 : NaN;
}
function bisector(f2) {
  let compare1, compare2, delta;
  if (f2.length !== 2) {
    compare1 = ascending;
    compare2 = (d, x2) => ascending(f2(d), x2);
    delta = (d, x2) => f2(d) - x2;
  } else {
    compare1 = f2 === ascending || f2 === descending ? f2 : zero$1;
    compare2 = f2;
    delta = f2;
  }
  function left(a2, x2, lo = 0, hi = a2.length) {
    if (lo < hi) {
      if (compare1(x2, x2) !== 0)
        return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a2[mid], x2) < 0)
          lo = mid + 1;
        else
          hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function right(a2, x2, lo = 0, hi = a2.length) {
    if (lo < hi) {
      if (compare1(x2, x2) !== 0)
        return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a2[mid], x2) <= 0)
          lo = mid + 1;
        else
          hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function center(a2, x2, lo = 0, hi = a2.length) {
    const i2 = left(a2, x2, lo, hi - 1);
    return i2 > lo && delta(a2[i2 - 1], x2) > -delta(a2[i2], x2) ? i2 - 1 : i2;
  }
  return { left, center, right };
}
function zero$1() {
  return 0;
}
function number$1(x2) {
  return x2 === null ? NaN : +x2;
}
const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
bisector(number$1).center;
const bisect = bisectRight;
class InternMap extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } });
    if (entries != null)
      for (const [key2, value] of entries)
        this.set(key2, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
}
function intern_get({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key))
    return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}
function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start, stop, count2) {
  const step = (stop - start) / Math.max(0, count2), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
  let i1, i2, inc;
  if (power < 0) {
    inc = Math.pow(10, -power) / factor;
    i1 = Math.round(start * inc);
    i2 = Math.round(stop * inc);
    if (i1 / inc < start)
      ++i1;
    if (i2 / inc > stop)
      --i2;
    inc = -inc;
  } else {
    inc = Math.pow(10, power) * factor;
    i1 = Math.round(start / inc);
    i2 = Math.round(stop / inc);
    if (i1 * inc < start)
      ++i1;
    if (i2 * inc > stop)
      --i2;
  }
  if (i2 < i1 && 0.5 <= count2 && count2 < 2)
    return tickSpec(start, stop, count2 * 2);
  return [i1, i2, inc];
}
function ticks(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  if (!(count2 > 0))
    return [];
  if (start === stop)
    return [start];
  const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count2) : tickSpec(start, stop, count2);
  if (!(i2 >= i1))
    return [];
  const n2 = i2 - i1 + 1, ticks2 = new Array(n2);
  if (reverse) {
    if (inc < 0)
      for (let i3 = 0; i3 < n2; ++i3)
        ticks2[i3] = (i2 - i3) / -inc;
    else
      for (let i3 = 0; i3 < n2; ++i3)
        ticks2[i3] = (i2 - i3) * inc;
  } else {
    if (inc < 0)
      for (let i3 = 0; i3 < n2; ++i3)
        ticks2[i3] = (i1 + i3) / -inc;
    else
      for (let i3 = 0; i3 < n2; ++i3)
        ticks2[i3] = (i1 + i3) * inc;
  }
  return ticks2;
}
function tickIncrement(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  return tickSpec(start, stop, count2)[2];
}
function tickStep(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count2) : tickIncrement(start, stop, count2);
  return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}
function max$1(values, valueof) {
  let max2;
  if (valueof === void 0) {
    for (const value of values) {
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index2, values)) != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  }
  return max2;
}
function min$1(values, valueof) {
  let min2;
  if (valueof === void 0) {
    for (const value of values) {
      if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index2, values)) != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  }
  return min2;
}
function range(start, stop, step) {
  start = +start, stop = +stop, step = (n2 = arguments.length) < 2 ? (stop = start, start = 0, 1) : n2 < 3 ? 1 : +step;
  var i2 = -1, n2 = Math.max(0, Math.ceil((stop - start) / step)) | 0, range2 = new Array(n2);
  while (++i2 < n2) {
    range2[i2] = start + i2 * step;
  }
  return range2;
}
function sum$1(values, valueof) {
  let sum2 = 0;
  if (valueof === void 0) {
    for (let value of values) {
      if (value = +value) {
        sum2 += value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if (value = +valueof(value, ++index2, values)) {
        sum2 += value;
      }
    }
  }
  return sum2;
}
function formatDecimal(x2) {
  return Math.abs(x2 = Math.round(x2)) >= 1e21 ? x2.toLocaleString("en").replace(/,/g, "") : x2.toString(10);
}
function formatDecimalParts(x2, p2) {
  if ((i2 = (x2 = p2 ? x2.toExponential(p2 - 1) : x2.toExponential()).indexOf("e")) < 0)
    return null;
  var i2, coefficient = x2.slice(0, i2);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x2.slice(i2 + 1)
  ];
}
function exponent(x2) {
  return x2 = formatDecimalParts(Math.abs(x2)), x2 ? x2[1] : NaN;
}
function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i2 = value.length, t2 = [], j = 0, g = grouping[0], length2 = 0;
    while (i2 > 0 && g > 0) {
      if (length2 + g + 1 > width)
        g = Math.max(1, width - length2);
      t2.push(value.substring(i2 -= g, i2 + g));
      if ((length2 += g + 1) > width)
        break;
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t2.reverse().join(thousands);
  };
}
function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i2) {
      return numerals[+i2];
    });
  };
}
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match2 = re.exec(specifier)))
    throw new Error("invalid format: " + specifier);
  var match2;
  return new FormatSpecifier({
    fill: match2[1],
    align: match2[2],
    sign: match2[3],
    symbol: match2[4],
    zero: match2[5],
    width: match2[6],
    comma: match2[7],
    precision: match2[8] && match2[8].slice(1),
    trim: match2[9],
    type: match2[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(s2) {
  out:
    for (var n2 = s2.length, i2 = 1, i0 = -1, i1; i2 < n2; ++i2) {
      switch (s2[i2]) {
        case ".":
          i0 = i1 = i2;
          break;
        case "0":
          if (i0 === 0)
            i0 = i2;
          i1 = i2;
          break;
        default:
          if (!+s2[i2])
            break out;
          if (i0 > 0)
            i0 = 0;
          break;
      }
    }
  return i0 > 0 ? s2.slice(0, i0) + s2.slice(i1 + 1) : s2;
}
var prefixExponent;
function formatPrefixAuto(x2, p2) {
  var d = formatDecimalParts(x2, p2);
  if (!d)
    return x2 + "";
  var coefficient = d[0], exponent2 = d[1], i2 = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n2 = coefficient.length;
  return i2 === n2 ? coefficient : i2 > n2 ? coefficient + new Array(i2 - n2 + 1).join("0") : i2 > 0 ? coefficient.slice(0, i2) + "." + coefficient.slice(i2) : "0." + new Array(1 - i2).join("0") + formatDecimalParts(x2, Math.max(0, p2 + i2 - 1))[0];
}
function formatRounded(x2, p2) {
  var d = formatDecimalParts(x2, p2);
  if (!d)
    return x2 + "";
  var coefficient = d[0], exponent2 = d[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
const formatTypes = {
  "%": (x2, p2) => (x2 * 100).toFixed(p2),
  "b": (x2) => Math.round(x2).toString(2),
  "c": (x2) => x2 + "",
  "d": formatDecimal,
  "e": (x2, p2) => x2.toExponential(p2),
  "f": (x2, p2) => x2.toFixed(p2),
  "g": (x2, p2) => x2.toPrecision(p2),
  "o": (x2) => Math.round(x2).toString(8),
  "p": (x2, p2) => formatRounded(x2 * 100, p2),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x2) => Math.round(x2).toString(16).toUpperCase(),
  "x": (x2) => Math.round(x2).toString(16)
};
function identity$1(x2) {
  return x2;
}
var map = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale(locale2) {
  var group = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$1 : formatGroup(map.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity$1 : formatNumerals(map.call(locale2.numerals, String)), percent = locale2.percent === void 0 ? "%" : locale2.percent + "", minus = locale2.minus === void 0 ? "−" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align = specifier.align, sign2 = specifier.sign, symbol2 = specifier.symbol, zero2 = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim2 = specifier.trim, type2 = specifier.type;
    if (type2 === "n")
      comma = true, type2 = "g";
    else if (!formatTypes[type2])
      precision === void 0 && (precision = 12), trim2 = true, type2 = "g";
    if (zero2 || fill === "0" && align === "=")
      zero2 = true, fill = "0", align = "=";
    var prefix2 = symbol2 === "$" ? currencyPrefix : symbol2 === "#" && /[boxX]/.test(type2) ? "0" + type2.toLowerCase() : "", suffix2 = symbol2 === "$" ? currencySuffix : /[%p]/.test(type2) ? percent : "";
    var formatType = formatTypes[type2], maybeSuffix = /[defgprs%]/.test(type2);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type2) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix2, valueSuffix = suffix2, i2, n2, c2;
      if (type2 === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim2)
          value = formatTrim(value);
        if (valueNegative && +value === 0 && sign2 !== "+")
          valueNegative = false;
        valuePrefix = (valueNegative ? sign2 === "(" ? sign2 : minus : sign2 === "-" || sign2 === "(" ? "" : sign2) + valuePrefix;
        valueSuffix = (type2 === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign2 === "(" ? ")" : "");
        if (maybeSuffix) {
          i2 = -1, n2 = value.length;
          while (++i2 < n2) {
            if (c2 = value.charCodeAt(i2), 48 > c2 || c2 > 57) {
              valueSuffix = (c2 === 46 ? decimal + value.slice(i2 + 1) : value.slice(i2)) + valueSuffix;
              value = value.slice(0, i2);
              break;
            }
          }
        }
      }
      if (comma && !zero2)
        value = group(value, Infinity);
      var length2 = valuePrefix.length + value.length + valueSuffix.length, padding2 = length2 < width ? new Array(width - length2 + 1).join(fill) : "";
      if (comma && zero2)
        value = group(padding2 + value, padding2.length ? width - valueSuffix.length : Infinity), padding2 = "";
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding2;
          break;
        case "=":
          value = valuePrefix + padding2 + value + valueSuffix;
          break;
        case "^":
          value = padding2.slice(0, length2 = padding2.length >> 1) + valuePrefix + value + valueSuffix + padding2.slice(length2);
          break;
        default:
          value = padding2 + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value) {
    var f2 = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e3 = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k = Math.pow(10, -e3), prefix2 = prefixes[8 + e3 / 3];
    return function(value2) {
      return f2(k * value2) + prefix2;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
var locale;
var format;
var formatPrefix;
defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}
function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}
function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}
function precisionRound(step, max2) {
  step = Math.abs(step), max2 = Math.abs(max2) - step;
  return Math.max(0, exponent(max2) - exponent(step)) + 1;
}
function initRange(domain, range2) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain);
      break;
    default:
      this.range(range2).domain(domain);
      break;
  }
  return this;
}
const implicit = Symbol("implicit");
function ordinal() {
  var index2 = new InternMap(), domain = [], range2 = [], unknown = implicit;
  function scale(d) {
    let i2 = index2.get(d);
    if (i2 === void 0) {
      if (unknown !== implicit)
        return unknown;
      index2.set(d, i2 = domain.push(d) - 1);
    }
    return range2[i2 % range2.length];
  }
  scale.domain = function(_2) {
    if (!arguments.length)
      return domain.slice();
    domain = [], index2 = new InternMap();
    for (const value of _2) {
      if (index2.has(value))
        continue;
      index2.set(value, domain.push(value) - 1);
    }
    return scale;
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), scale) : range2.slice();
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown = _2, scale) : unknown;
  };
  scale.copy = function() {
    return ordinal(domain, range2).unknown(unknown);
  };
  initRange.apply(scale, arguments);
  return scale;
}
function band() {
  var scale = ordinal().unknown(void 0), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round2 = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
  delete scale.unknown;
  function rescale() {
    var n2 = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n2 - paddingInner + paddingOuter * 2);
    if (round2)
      step = Math.floor(step);
    start += (stop - start - step * (n2 - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round2)
      start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = range(n2).map(function(i2) {
      return start + step * i2;
    });
    return ordinalRange(reverse ? values.reverse() : values);
  }
  scale.domain = function(_2) {
    return arguments.length ? (domain(_2), rescale()) : domain();
  };
  scale.range = function(_2) {
    return arguments.length ? ([r0, r1] = _2, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale.rangeRound = function(_2) {
    return [r0, r1] = _2, r0 = +r0, r1 = +r1, round2 = true, rescale();
  };
  scale.bandwidth = function() {
    return bandwidth;
  };
  scale.step = function() {
    return step;
  };
  scale.round = function(_2) {
    return arguments.length ? (round2 = !!_2, rescale()) : round2;
  };
  scale.padding = function(_2) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_2), rescale()) : paddingInner;
  };
  scale.paddingInner = function(_2) {
    return arguments.length ? (paddingInner = Math.min(1, _2), rescale()) : paddingInner;
  };
  scale.paddingOuter = function(_2) {
    return arguments.length ? (paddingOuter = +_2, rescale()) : paddingOuter;
  };
  scale.align = function(_2) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _2)), rescale()) : align;
  };
  scale.copy = function() {
    return band(domain(), [r0, r1]).round(round2).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };
  return initRange.apply(rescale(), arguments);
}
function pointish(scale) {
  var copy2 = scale.copy;
  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;
  scale.copy = function() {
    return pointish(copy2());
  };
  return scale;
}
function point$1() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}
function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition)
    prototype[key] = definition[key];
  return prototype;
}
function Color() {
}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format2) {
  var m2, l2;
  format2 = (format2 + "").trim().toLowerCase();
  return (m2 = reHex.exec(format2)) ? (l2 = m2[1].length, m2 = parseInt(m2[1], 16), l2 === 6 ? rgbn(m2) : l2 === 3 ? new Rgb(m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, (m2 & 15) << 4 | m2 & 15, 1) : l2 === 8 ? rgba(m2 >> 24 & 255, m2 >> 16 & 255, m2 >> 8 & 255, (m2 & 255) / 255) : l2 === 4 ? rgba(m2 >> 12 & 15 | m2 >> 8 & 240, m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, ((m2 & 15) << 4 | m2 & 15) / 255) : null) : (m2 = reRgbInteger.exec(format2)) ? new Rgb(m2[1], m2[2], m2[3], 1) : (m2 = reRgbPercent.exec(format2)) ? new Rgb(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, 1) : (m2 = reRgbaInteger.exec(format2)) ? rgba(m2[1], m2[2], m2[3], m2[4]) : (m2 = reRgbaPercent.exec(format2)) ? rgba(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, m2[4]) : (m2 = reHslPercent.exec(format2)) ? hsla(m2[1], m2[2] / 100, m2[3] / 100, 1) : (m2 = reHslaPercent.exec(format2)) ? hsla(m2[1], m2[2] / 100, m2[3] / 100, m2[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n2) {
  return new Rgb(n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255, 1);
}
function rgba(r2, g, b, a2) {
  if (a2 <= 0)
    r2 = g = b = NaN;
  return new Rgb(r2, g, b, a2);
}
function rgbConvert(o2) {
  if (!(o2 instanceof Color))
    o2 = color(o2);
  if (!o2)
    return new Rgb();
  o2 = o2.rgb();
  return new Rgb(o2.r, o2.g, o2.b, o2.opacity);
}
function rgb(r2, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r2) : new Rgb(r2, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r2, g, b, opacity) {
  this.r = +r2;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define(Rgb, rgb, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a2 = clampa(this.opacity);
  return `${a2 === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a2 === 1 ? ")" : `, ${a2})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h2, s2, l2, a2) {
  if (a2 <= 0)
    h2 = s2 = l2 = NaN;
  else if (l2 <= 0 || l2 >= 1)
    h2 = s2 = NaN;
  else if (s2 <= 0)
    h2 = NaN;
  return new Hsl(h2, s2, l2, a2);
}
function hslConvert(o2) {
  if (o2 instanceof Hsl)
    return new Hsl(o2.h, o2.s, o2.l, o2.opacity);
  if (!(o2 instanceof Color))
    o2 = color(o2);
  if (!o2)
    return new Hsl();
  if (o2 instanceof Hsl)
    return o2;
  o2 = o2.rgb();
  var r2 = o2.r / 255, g = o2.g / 255, b = o2.b / 255, min2 = Math.min(r2, g, b), max2 = Math.max(r2, g, b), h2 = NaN, s2 = max2 - min2, l2 = (max2 + min2) / 2;
  if (s2) {
    if (r2 === max2)
      h2 = (g - b) / s2 + (g < b) * 6;
    else if (g === max2)
      h2 = (b - r2) / s2 + 2;
    else
      h2 = (r2 - g) / s2 + 4;
    s2 /= l2 < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h2 *= 60;
  } else {
    s2 = l2 > 0 && l2 < 1 ? 0 : h2;
  }
  return new Hsl(h2, s2, l2, o2.opacity);
}
function hsl(h2, s2, l2, opacity) {
  return arguments.length === 1 ? hslConvert(h2) : new Hsl(h2, s2, l2, opacity == null ? 1 : opacity);
}
function Hsl(h2, s2, l2, opacity) {
  this.h = +h2;
  this.s = +s2;
  this.l = +l2;
  this.opacity = +opacity;
}
define(Hsl, hsl, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb() {
    var h2 = this.h % 360 + (this.h < 0) * 360, s2 = isNaN(h2) || isNaN(this.s) ? 0 : this.s, l2 = this.l, m2 = l2 + (l2 < 0.5 ? l2 : 1 - l2) * s2, m1 = 2 * l2 - m2;
    return new Rgb(
      hsl2rgb(h2 >= 240 ? h2 - 240 : h2 + 120, m1, m2),
      hsl2rgb(h2, m1, m2),
      hsl2rgb(h2 < 120 ? h2 + 240 : h2 - 120, m1, m2),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a2 = clampa(this.opacity);
    return `${a2 === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a2 === 1 ? ")" : `, ${a2})`}`;
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
function hsl2rgb(h2, m1, m2) {
  return (h2 < 60 ? m1 + (m2 - m1) * h2 / 60 : h2 < 180 ? m2 : h2 < 240 ? m1 + (m2 - m1) * (240 - h2) / 60 : m1) * 255;
}
const constant$3 = (x2) => () => x2;
function linear$1(a2, d) {
  return function(t2) {
    return a2 + t2 * d;
  };
}
function exponential(a2, b, y2) {
  return a2 = Math.pow(a2, y2), b = Math.pow(b, y2) - a2, y2 = 1 / y2, function(t2) {
    return Math.pow(a2 + t2 * b, y2);
  };
}
function gamma(y2) {
  return (y2 = +y2) === 1 ? nogamma : function(a2, b) {
    return b - a2 ? exponential(a2, b, y2) : constant$3(isNaN(a2) ? b : a2);
  };
}
function nogamma(a2, b) {
  var d = b - a2;
  return d ? linear$1(a2, d) : constant$3(isNaN(a2) ? b : a2);
}
const interpolateRgb = function rgbGamma(y2) {
  var color2 = gamma(y2);
  function rgb$1(start, end) {
    var r2 = color2((start = rgb(start)).r, (end = rgb(end)).r), g = color2(start.g, end.g), b = color2(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
    return function(t2) {
      start.r = r2(t2);
      start.g = g(t2);
      start.b = b(t2);
      start.opacity = opacity(t2);
      return start + "";
    };
  }
  rgb$1.gamma = rgbGamma;
  return rgb$1;
}(1);
function numberArray(a2, b) {
  if (!b)
    b = [];
  var n2 = a2 ? Math.min(b.length, a2.length) : 0, c2 = b.slice(), i2;
  return function(t2) {
    for (i2 = 0; i2 < n2; ++i2)
      c2[i2] = a2[i2] * (1 - t2) + b[i2] * t2;
    return c2;
  };
}
function isNumberArray(x2) {
  return ArrayBuffer.isView(x2) && !(x2 instanceof DataView);
}
function genericArray(a2, b) {
  var nb = b ? b.length : 0, na = a2 ? Math.min(nb, a2.length) : 0, x2 = new Array(na), c2 = new Array(nb), i2;
  for (i2 = 0; i2 < na; ++i2)
    x2[i2] = interpolate(a2[i2], b[i2]);
  for (; i2 < nb; ++i2)
    c2[i2] = b[i2];
  return function(t2) {
    for (i2 = 0; i2 < na; ++i2)
      c2[i2] = x2[i2](t2);
    return c2;
  };
}
function date(a2, b) {
  var d = /* @__PURE__ */ new Date();
  return a2 = +a2, b = +b, function(t2) {
    return d.setTime(a2 * (1 - t2) + b * t2), d;
  };
}
function interpolateNumber(a2, b) {
  return a2 = +a2, b = +b, function(t2) {
    return a2 * (1 - t2) + b * t2;
  };
}
function object(a2, b) {
  var i2 = {}, c2 = {}, k;
  if (a2 === null || typeof a2 !== "object")
    a2 = {};
  if (b === null || typeof b !== "object")
    b = {};
  for (k in b) {
    if (k in a2) {
      i2[k] = interpolate(a2[k], b[k]);
    } else {
      c2[k] = b[k];
    }
  }
  return function(t2) {
    for (k in i2)
      c2[k] = i2[k](t2);
    return c2;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
  return function() {
    return b;
  };
}
function one(b) {
  return function(t2) {
    return b(t2) + "";
  };
}
function interpolateString(a2, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i2 = -1, s2 = [], q = [];
  a2 = a2 + "", b = b + "";
  while ((am = reA.exec(a2)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      bs = b.slice(bi, bs);
      if (s2[i2])
        s2[i2] += bs;
      else
        s2[++i2] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s2[i2])
        s2[i2] += bm;
      else
        s2[++i2] = bm;
    } else {
      s2[++i2] = null;
      q.push({ i: i2, x: interpolateNumber(am, bm) });
    }
    bi = reB.lastIndex;
  }
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s2[i2])
      s2[i2] += bs;
    else
      s2[++i2] = bs;
  }
  return s2.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t2) {
    for (var i3 = 0, o2; i3 < b; ++i3)
      s2[(o2 = q[i3]).i] = o2.x(t2);
    return s2.join("");
  });
}
function interpolate(a2, b) {
  var t2 = typeof b, c2;
  return b == null || t2 === "boolean" ? constant$3(b) : (t2 === "number" ? interpolateNumber : t2 === "string" ? (c2 = color(b)) ? (b = c2, interpolateRgb) : interpolateString : b instanceof color ? interpolateRgb : b instanceof Date ? date : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object : interpolateNumber)(a2, b);
}
function interpolateRound(a2, b) {
  return a2 = +a2, b = +b, function(t2) {
    return Math.round(a2 * (1 - t2) + b * t2);
  };
}
function constants(x2) {
  return function() {
    return x2;
  };
}
function number(x2) {
  return +x2;
}
var unit = [0, 1];
function identity(x2) {
  return x2;
}
function normalize(a2, b) {
  return (b -= a2 = +a2) ? function(x2) {
    return (x2 - a2) / b;
  } : constants(isNaN(b) ? NaN : 0.5);
}
function clamper(a2, b) {
  var t2;
  if (a2 > b)
    t2 = a2, a2 = b, b = t2;
  return function(x2) {
    return Math.max(a2, Math.min(b, x2));
  };
}
function bimap(domain, range2, interpolate2) {
  var d0 = domain[0], d1 = domain[1], r0 = range2[0], r1 = range2[1];
  if (d1 < d0)
    d0 = normalize(d1, d0), r0 = interpolate2(r1, r0);
  else
    d0 = normalize(d0, d1), r0 = interpolate2(r0, r1);
  return function(x2) {
    return r0(d0(x2));
  };
}
function polymap(domain, range2, interpolate2) {
  var j = Math.min(domain.length, range2.length) - 1, d = new Array(j), r2 = new Array(j), i2 = -1;
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range2 = range2.slice().reverse();
  }
  while (++i2 < j) {
    d[i2] = normalize(domain[i2], domain[i2 + 1]);
    r2[i2] = interpolate2(range2[i2], range2[i2 + 1]);
  }
  return function(x2) {
    var i3 = bisect(domain, x2, 1, j) - 1;
    return r2[i3](d[i3](x2));
  };
}
function copy$1(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
  var domain = unit, range2 = unit, interpolate$1 = interpolate, transform, untransform, unknown, clamp = identity, piecewise, output, input;
  function rescale() {
    var n2 = Math.min(domain.length, range2.length);
    if (clamp !== identity)
      clamp = clamper(domain[0], domain[n2 - 1]);
    piecewise = n2 > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown : (output || (output = piecewise(domain.map(transform), range2, interpolate$1)))(transform(clamp(x2)));
  }
  scale.invert = function(y2) {
    return clamp(untransform((input || (input = piecewise(range2, domain.map(transform), interpolateNumber)))(y2)));
  };
  scale.domain = function(_2) {
    return arguments.length ? (domain = Array.from(_2, number), rescale()) : domain.slice();
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), rescale()) : range2.slice();
  };
  scale.rangeRound = function(_2) {
    return range2 = Array.from(_2), interpolate$1 = interpolateRound, rescale();
  };
  scale.clamp = function(_2) {
    return arguments.length ? (clamp = _2 ? true : identity, rescale()) : clamp !== identity;
  };
  scale.interpolate = function(_2) {
    return arguments.length ? (interpolate$1 = _2, rescale()) : interpolate$1;
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown = _2, scale) : unknown;
  };
  return function(t2, u2) {
    transform = t2, untransform = u2;
    return rescale();
  };
}
function continuous() {
  return transformer()(identity, identity);
}
function tickFormat(start, stop, count2, specifier) {
  var step = tickStep(start, stop, count2), precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value)))
        specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop)))))
        specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step)))
        specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}
function linearish(scale) {
  var domain = scale.domain;
  scale.ticks = function(count2) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count2 == null ? 10 : count2);
  };
  scale.tickFormat = function(count2, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count2 == null ? 10 : count2, specifier);
  };
  scale.nice = function(count2) {
    if (count2 == null)
      count2 = 10;
    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count2);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale;
  };
  return scale;
}
function linear() {
  var scale = continuous();
  scale.copy = function() {
    return copy$1(scale, linear());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function noop$2() {
}
function assign$1(tar, src) {
  for (const k in src)
    tar[k] = src[k];
  return (
    /** @type {T & S} */
    tar
  );
}
function run(fn) {
  return fn();
}
function blank_object() {
  return /* @__PURE__ */ Object.create(null);
}
function run_all(fns) {
  fns.forEach(run);
}
function is_function(thing) {
  return typeof thing === "function";
}
function safe_not_equal(a2, b) {
  return a2 != a2 ? b == b : a2 !== b || a2 && typeof a2 === "object" || typeof a2 === "function";
}
function is_empty(obj) {
  return Object.keys(obj).length === 0;
}
function subscribe(store, ...callbacks) {
  if (store == null) {
    for (const callback of callbacks) {
      callback(void 0);
    }
    return noop$2;
  }
  const unsub = store.subscribe(...callbacks);
  return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
}
function get_store_value(store) {
  let value;
  subscribe(store, (_2) => value = _2)();
  return value;
}
function component_subscribe(component, store, callback) {
  component.$$.on_destroy.push(subscribe(store, callback));
}
function create_slot(definition, ctx2, $$scope, fn) {
  if (definition) {
    const slot_ctx = get_slot_context(definition, ctx2, $$scope, fn);
    return definition[0](slot_ctx);
  }
}
function get_slot_context(definition, ctx2, $$scope, fn) {
  return definition[1] && fn ? assign$1($$scope.ctx.slice(), definition[1](fn(ctx2))) : $$scope.ctx;
}
function get_slot_changes(definition, $$scope, dirty, fn) {
  if (definition[2] && fn) {
    const lets = definition[2](fn(dirty));
    if ($$scope.dirty === void 0) {
      return lets;
    }
    if (typeof lets === "object") {
      const merged = [];
      const len = Math.max($$scope.dirty.length, lets.length);
      for (let i2 = 0; i2 < len; i2 += 1) {
        merged[i2] = $$scope.dirty[i2] | lets[i2];
      }
      return merged;
    }
    return $$scope.dirty | lets;
  }
  return $$scope.dirty;
}
function update_slot_base(slot, slot_definition, ctx2, $$scope, slot_changes, get_slot_context_fn) {
  if (slot_changes) {
    const slot_context = get_slot_context(slot_definition, ctx2, $$scope, get_slot_context_fn);
    slot.p(slot_context, slot_changes);
  }
}
function get_all_dirty_from_scope($$scope) {
  if ($$scope.ctx.length > 32) {
    const dirty = [];
    const length2 = $$scope.ctx.length / 32;
    for (let i2 = 0; i2 < length2; i2++) {
      dirty[i2] = -1;
    }
    return dirty;
  }
  return -1;
}
function set_store_value(store, ret, value) {
  store.set(value);
  return ret;
}
function action_destroyer(action_result) {
  return action_result && is_function(action_result.destroy) ? action_result.destroy : noop$2;
}
const contenteditable_truthy_values = ["", true, 1, "true", "contenteditable"];
function append$2(target, node2) {
  target.appendChild(node2);
}
function insert(target, node2, anchor) {
  target.insertBefore(node2, anchor || null);
}
function detach(node2) {
  if (node2.parentNode) {
    node2.parentNode.removeChild(node2);
  }
}
function destroy_each(iterations, detaching) {
  for (let i2 = 0; i2 < iterations.length; i2 += 1) {
    if (iterations[i2])
      iterations[i2].d(detaching);
  }
}
function element(name) {
  return document.createElement(name);
}
function svg_element(name) {
  return document.createElementNS("http://www.w3.org/2000/svg", name);
}
function text(data) {
  return document.createTextNode(data);
}
function space() {
  return text(" ");
}
function empty() {
  return text("");
}
function listen(node2, event, handler, options) {
  node2.addEventListener(event, handler, options);
  return () => node2.removeEventListener(event, handler, options);
}
function attr(node2, attribute, value) {
  if (value == null)
    node2.removeAttribute(attribute);
  else if (node2.getAttribute(attribute) !== value)
    node2.setAttribute(attribute, value);
}
function set_svg_attributes(node2, attributes) {
  for (const key in attributes) {
    attr(node2, key, attributes[key]);
  }
}
function children(element2) {
  return Array.from(element2.childNodes);
}
function set_data(text2, data) {
  data = "" + data;
  if (text2.data === data)
    return;
  text2.data = /** @type {string} */
  data;
}
function set_data_contenteditable(text2, data) {
  data = "" + data;
  if (text2.wholeText === data)
    return;
  text2.data = /** @type {string} */
  data;
}
function set_data_maybe_contenteditable(text2, data, attr_value) {
  if (~contenteditable_truthy_values.indexOf(attr_value)) {
    set_data_contenteditable(text2, data);
  } else {
    set_data(text2, data);
  }
}
function set_style(node2, key, value, important) {
  if (value == null) {
    node2.style.removeProperty(key);
  } else {
    node2.style.setProperty(key, value, important ? "important" : "");
  }
}
function construct_svelte_component(component, props) {
  return new component(props);
}
let current_component;
function set_current_component(component) {
  current_component = component;
}
function get_current_component() {
  if (!current_component)
    throw new Error("Function called outside component initialization");
  return current_component;
}
function onMount(fn) {
  get_current_component().$$.on_mount.push(fn);
}
function onDestroy(fn) {
  get_current_component().$$.on_destroy.push(fn);
}
function setContext(key, context) {
  get_current_component().$$.context.set(key, context);
  return context;
}
function getContext(key) {
  return get_current_component().$$.context.get(key);
}
const dirty_components = [];
const binding_callbacks = [];
let render_callbacks = [];
const flush_callbacks = [];
const resolved_promise = /* @__PURE__ */ Promise.resolve();
let update_scheduled = false;
function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}
function tick() {
  schedule_update();
  return resolved_promise;
}
function add_render_callback(fn) {
  render_callbacks.push(fn);
}
const seen_callbacks = /* @__PURE__ */ new Set();
let flushidx = 0;
function flush() {
  if (flushidx !== 0) {
    return;
  }
  const saved_component = current_component;
  do {
    try {
      while (flushidx < dirty_components.length) {
        const component = dirty_components[flushidx];
        flushidx++;
        set_current_component(component);
        update(component.$$);
      }
    } catch (e3) {
      dirty_components.length = 0;
      flushidx = 0;
      throw e3;
    }
    set_current_component(null);
    dirty_components.length = 0;
    flushidx = 0;
    while (binding_callbacks.length)
      binding_callbacks.pop()();
    for (let i2 = 0; i2 < render_callbacks.length; i2 += 1) {
      const callback = render_callbacks[i2];
      if (!seen_callbacks.has(callback)) {
        seen_callbacks.add(callback);
        callback();
      }
    }
    render_callbacks.length = 0;
  } while (dirty_components.length);
  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }
  update_scheduled = false;
  seen_callbacks.clear();
  set_current_component(saved_component);
}
function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    const dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}
function flush_render_callbacks(fns) {
  const filtered = [];
  const targets = [];
  render_callbacks.forEach((c2) => fns.indexOf(c2) === -1 ? filtered.push(c2) : targets.push(c2));
  targets.forEach((c2) => c2());
  render_callbacks = filtered;
}
const outroing = /* @__PURE__ */ new Set();
let outros;
function group_outros() {
  outros = {
    r: 0,
    c: [],
    p: outros
    // parent group
  };
}
function check_outros() {
  if (!outros.r) {
    run_all(outros.c);
  }
  outros = outros.p;
}
function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}
function transition_out(block, local, detach2, callback) {
  if (block && block.o) {
    if (outroing.has(block))
      return;
    outroing.add(block);
    outros.c.push(() => {
      outroing.delete(block);
      if (callback) {
        if (detach2)
          block.d(1);
        callback();
      }
    });
    block.o(local);
  } else if (callback) {
    callback();
  }
}
function ensure_array_like(array_like_or_iterator) {
  return (array_like_or_iterator == null ? void 0 : array_like_or_iterator.length) !== void 0 ? array_like_or_iterator : Array.from(array_like_or_iterator);
}
function destroy_block(block, lookup2) {
  block.d(1);
  lookup2.delete(block.key);
}
function outro_and_destroy_block(block, lookup2) {
  transition_out(block, 1, 1, () => {
    lookup2.delete(block.key);
  });
}
function update_keyed_each(old_blocks, dirty, get_key, dynamic, ctx2, list, lookup2, node2, destroy, create_each_block2, next2, get_context) {
  let o2 = old_blocks.length;
  let n2 = list.length;
  let i2 = o2;
  const old_indexes = {};
  while (i2--)
    old_indexes[old_blocks[i2].key] = i2;
  const new_blocks = [];
  const new_lookup = /* @__PURE__ */ new Map();
  const deltas = /* @__PURE__ */ new Map();
  const updates = [];
  i2 = n2;
  while (i2--) {
    const child_ctx = get_context(ctx2, list, i2);
    const key = get_key(child_ctx);
    let block = lookup2.get(key);
    if (!block) {
      block = create_each_block2(key, child_ctx);
      block.c();
    } else if (dynamic) {
      updates.push(() => block.p(child_ctx, dirty));
    }
    new_lookup.set(key, new_blocks[i2] = block);
    if (key in old_indexes)
      deltas.set(key, Math.abs(i2 - old_indexes[key]));
  }
  const will_move = /* @__PURE__ */ new Set();
  const did_move = /* @__PURE__ */ new Set();
  function insert2(block) {
    transition_in(block, 1);
    block.m(node2, next2);
    lookup2.set(block.key, block);
    next2 = block.first;
    n2--;
  }
  while (o2 && n2) {
    const new_block = new_blocks[n2 - 1];
    const old_block = old_blocks[o2 - 1];
    const new_key = new_block.key;
    const old_key = old_block.key;
    if (new_block === old_block) {
      next2 = new_block.first;
      o2--;
      n2--;
    } else if (!new_lookup.has(old_key)) {
      destroy(old_block, lookup2);
      o2--;
    } else if (!lookup2.has(new_key) || will_move.has(new_key)) {
      insert2(new_block);
    } else if (did_move.has(old_key)) {
      o2--;
    } else if (deltas.get(new_key) > deltas.get(old_key)) {
      did_move.add(new_key);
      insert2(new_block);
    } else {
      will_move.add(old_key);
      o2--;
    }
  }
  while (o2--) {
    const old_block = old_blocks[o2];
    if (!new_lookup.has(old_block.key))
      destroy(old_block, lookup2);
  }
  while (n2)
    insert2(new_blocks[n2 - 1]);
  run_all(updates);
  return new_blocks;
}
function get_spread_update(levels, updates) {
  const update2 = {};
  const to_null_out = {};
  const accounted_for = { $$scope: 1 };
  let i2 = levels.length;
  while (i2--) {
    const o2 = levels[i2];
    const n2 = updates[i2];
    if (n2) {
      for (const key in o2) {
        if (!(key in n2))
          to_null_out[key] = 1;
      }
      for (const key in n2) {
        if (!accounted_for[key]) {
          update2[key] = n2[key];
          accounted_for[key] = 1;
        }
      }
      levels[i2] = n2;
    } else {
      for (const key in o2) {
        accounted_for[key] = 1;
      }
    }
  }
  for (const key in to_null_out) {
    if (!(key in update2))
      update2[key] = void 0;
  }
  return update2;
}
function create_component(block) {
  block && block.c();
}
function mount_component(component, target, anchor) {
  const { fragment, after_update } = component.$$;
  fragment && fragment.m(target, anchor);
  add_render_callback(() => {
    const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
    if (component.$$.on_destroy) {
      component.$$.on_destroy.push(...new_on_destroy);
    } else {
      run_all(new_on_destroy);
    }
    component.$$.on_mount = [];
  });
  after_update.forEach(add_render_callback);
}
function destroy_component(component, detaching) {
  const $$ = component.$$;
  if ($$.fragment !== null) {
    flush_render_callbacks($$.after_update);
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching);
    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}
function make_dirty(component, i2) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }
  component.$$.dirty[i2 / 31 | 0] |= 1 << i2 % 31;
}
function init(component, options, instance2, create_fragment2, not_equal, props, append_styles, dirty = [-1]) {
  const parent_component = current_component;
  set_current_component(component);
  const $$ = component.$$ = {
    fragment: null,
    ctx: [],
    // state
    props,
    update: noop$2,
    not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
    // everything else
    callbacks: blank_object(),
    dirty,
    skip_bound: false,
    root: options.target || parent_component.$$.root
  };
  append_styles && append_styles($$.root);
  let ready = false;
  $$.ctx = instance2 ? instance2(component, options.props || {}, (i2, ret, ...rest) => {
    const value = rest.length ? rest[0] : ret;
    if ($$.ctx && not_equal($$.ctx[i2], $$.ctx[i2] = value)) {
      if (!$$.skip_bound && $$.bound[i2])
        $$.bound[i2](value);
      if (ready)
        make_dirty(component, i2);
    }
    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update);
  $$.fragment = create_fragment2 ? create_fragment2($$.ctx) : false;
  if (options.target) {
    if (options.hydrate) {
      const nodes = children(options.target);
      $$.fragment && $$.fragment.l(nodes);
      nodes.forEach(detach);
    } else {
      $$.fragment && $$.fragment.c();
    }
    if (options.intro)
      transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor);
    flush();
  }
  set_current_component(parent_component);
}
class SvelteComponent {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    __publicField(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    __publicField(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    destroy_component(this, 1);
    this.$destroy = noop$2;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(type2, callback) {
    if (!is_function(callback)) {
      return noop$2;
    }
    const callbacks = this.$$.callbacks[type2] || (this.$$.callbacks[type2] = []);
    callbacks.push(callback);
    return () => {
      const index2 = callbacks.indexOf(callback);
      if (index2 !== -1)
        callbacks.splice(index2, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(props) {
    if (this.$$set && !is_empty(props)) {
      this.$$.skip_bound = true;
      this.$$set(props);
      this.$$.skip_bound = false;
    }
  }
}
const PUBLIC_VERSION = "4";
const subscriber_queue = [];
function readable(value, start) {
  return {
    subscribe: writable(value, start).subscribe
  };
}
function writable(value, start = noop$2) {
  let stop;
  const subscribers = /* @__PURE__ */ new Set();
  function set2(new_value) {
    if (safe_not_equal(value, new_value)) {
      value = new_value;
      if (stop) {
        const run_queue = !subscriber_queue.length;
        for (const subscriber of subscribers) {
          subscriber[1]();
          subscriber_queue.push(subscriber, value);
        }
        if (run_queue) {
          for (let i2 = 0; i2 < subscriber_queue.length; i2 += 2) {
            subscriber_queue[i2][0](subscriber_queue[i2 + 1]);
          }
          subscriber_queue.length = 0;
        }
      }
    }
  }
  function update2(fn) {
    set2(fn(value));
  }
  function subscribe2(run2, invalidate = noop$2) {
    const subscriber = [run2, invalidate];
    subscribers.add(subscriber);
    if (subscribers.size === 1) {
      stop = start(set2, update2) || noop$2;
    }
    run2(value);
    return () => {
      subscribers.delete(subscriber);
      if (subscribers.size === 0 && stop) {
        stop();
        stop = null;
      }
    };
  }
  return { set: set2, update: update2, subscribe: subscribe2 };
}
function derived(stores, fn, initial_value) {
  const single = !Array.isArray(stores);
  const stores_array = single ? [stores] : stores;
  if (!stores_array.every(Boolean)) {
    throw new Error("derived() expects stores as input, got a falsy value");
  }
  const auto = fn.length < 2;
  return readable(initial_value, (set2, update2) => {
    let started = false;
    const values = [];
    let pending = 0;
    let cleanup = noop$2;
    const sync = () => {
      if (pending) {
        return;
      }
      cleanup();
      const result = fn(single ? values[0] : values, set2, update2);
      if (auto) {
        set2(result);
      } else {
        cleanup = is_function(result) ? result : noop$2;
      }
    };
    const unsubscribers = stores_array.map(
      (store, i2) => subscribe(
        store,
        (value) => {
          values[i2] = value;
          pending &= ~(1 << i2);
          if (started) {
            sync();
          }
        },
        () => {
          pending |= 1 << i2;
        }
      )
    );
    started = true;
    sync();
    return function stop() {
      run_all(unsubscribers);
      cleanup();
      started = false;
    };
  });
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var buffer = {};
var base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$2 = 0, len = code.length; i$2 < len; ++i$2) {
  lookup[i$2] = code[i$2];
  revLookup[code.charCodeAt(i$2)] = i$2;
}
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error("Invalid string. Length must be a multiple of 4");
  }
  var validLen = b64.indexOf("=");
  if (validLen === -1)
    validLen = len;
  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
}
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  var curByte = 0;
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
  var i2;
  for (i2 = 0; i2 < len; i2 += 4) {
    tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
    arr[curByte++] = tmp >> 16 & 255;
    arr[curByte++] = tmp >> 8 & 255;
    arr[curByte++] = tmp & 255;
  }
  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
    arr[curByte++] = tmp & 255;
  }
  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 255;
    arr[curByte++] = tmp & 255;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
}
function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i2 = start; i2 < end; i2 += 3) {
    tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
    output.push(tripletToBase64(tmp));
  }
  return output.join("");
}
function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3;
  var parts = [];
  var maxChunkLength = 16383;
  for (var i2 = 0, len2 = len - extraBytes; i2 < len2; i2 += maxChunkLength) {
    parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len2 ? len2 : i2 + maxChunkLength));
  }
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(
      lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
    );
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(
      lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
    );
  }
  return parts.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(buffer2, offset, isLE, mLen, nBytes) {
  var e3, m2;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i2 = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s2 = buffer2[offset + i2];
  i2 += d;
  e3 = s2 & (1 << -nBits) - 1;
  s2 >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e3 = e3 * 256 + buffer2[offset + i2], i2 += d, nBits -= 8) {
  }
  m2 = e3 & (1 << -nBits) - 1;
  e3 >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m2 = m2 * 256 + buffer2[offset + i2], i2 += d, nBits -= 8) {
  }
  if (e3 === 0) {
    e3 = 1 - eBias;
  } else if (e3 === eMax) {
    return m2 ? NaN : (s2 ? -1 : 1) * Infinity;
  } else {
    m2 = m2 + Math.pow(2, mLen);
    e3 = e3 - eBias;
  }
  return (s2 ? -1 : 1) * m2 * Math.pow(2, e3 - mLen);
};
ieee754.write = function(buffer2, value, offset, isLE, mLen, nBytes) {
  var e3, m2, c2;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i2 = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s2 = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m2 = isNaN(value) ? 1 : 0;
    e3 = eMax;
  } else {
    e3 = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c2 = Math.pow(2, -e3)) < 1) {
      e3--;
      c2 *= 2;
    }
    if (e3 + eBias >= 1) {
      value += rt / c2;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c2 >= 2) {
      e3++;
      c2 /= 2;
    }
    if (e3 + eBias >= eMax) {
      m2 = 0;
      e3 = eMax;
    } else if (e3 + eBias >= 1) {
      m2 = (value * c2 - 1) * Math.pow(2, mLen);
      e3 = e3 + eBias;
    } else {
      m2 = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e3 = 0;
    }
  }
  for (; mLen >= 8; buffer2[offset + i2] = m2 & 255, i2 += d, m2 /= 256, mLen -= 8) {
  }
  e3 = e3 << mLen | m2;
  eLen += mLen;
  for (; eLen > 0; buffer2[offset + i2] = e3 & 255, i2 += d, e3 /= 256, eLen -= 8) {
  }
  buffer2[offset + i2 - d] |= s2 * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(exports) {
  const base64 = base64Js;
  const ieee754$1 = ieee754;
  const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
  exports.Buffer = Buffer2;
  exports.SlowBuffer = SlowBuffer;
  exports.INSPECT_MAX_BYTES = 50;
  const K_MAX_LENGTH = 2147483647;
  exports.kMaxLength = K_MAX_LENGTH;
  Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
  if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
    console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
  }
  function typedArraySupport() {
    try {
      const arr = new Uint8Array(1);
      const proto = { foo: function() {
        return 42;
      } };
      Object.setPrototypeOf(proto, Uint8Array.prototype);
      Object.setPrototypeOf(arr, proto);
      return arr.foo() === 42;
    } catch (e3) {
      return false;
    }
  }
  Object.defineProperty(Buffer2.prototype, "parent", {
    enumerable: true,
    get: function() {
      if (!Buffer2.isBuffer(this))
        return void 0;
      return this.buffer;
    }
  });
  Object.defineProperty(Buffer2.prototype, "offset", {
    enumerable: true,
    get: function() {
      if (!Buffer2.isBuffer(this))
        return void 0;
      return this.byteOffset;
    }
  });
  function createBuffer(length2) {
    if (length2 > K_MAX_LENGTH) {
      throw new RangeError('The value "' + length2 + '" is invalid for option "size"');
    }
    const buf = new Uint8Array(length2);
    Object.setPrototypeOf(buf, Buffer2.prototype);
    return buf;
  }
  function Buffer2(arg, encodingOrOffset, length2) {
    if (typeof arg === "number") {
      if (typeof encodingOrOffset === "string") {
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      }
      return allocUnsafe(arg);
    }
    return from2(arg, encodingOrOffset, length2);
  }
  Buffer2.poolSize = 8192;
  function from2(value, encodingOrOffset, length2) {
    if (typeof value === "string") {
      return fromString(value, encodingOrOffset);
    }
    if (ArrayBuffer.isView(value)) {
      return fromArrayView(value);
    }
    if (value == null) {
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
      );
    }
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
      return fromArrayBuffer(value, encodingOrOffset, length2);
    }
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
      return fromArrayBuffer(value, encodingOrOffset, length2);
    }
    if (typeof value === "number") {
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    }
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) {
      return Buffer2.from(valueOf, encodingOrOffset, length2);
    }
    const b = fromObject(value);
    if (b)
      return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
      return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length2);
    }
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
    );
  }
  Buffer2.from = function(value, encodingOrOffset, length2) {
    return from2(value, encodingOrOffset, length2);
  };
  Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
  Object.setPrototypeOf(Buffer2, Uint8Array);
  function assertSize(size) {
    if (typeof size !== "number") {
      throw new TypeError('"size" argument must be of type number');
    } else if (size < 0) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
  }
  function alloc2(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
      return createBuffer(size);
    }
    if (fill !== void 0) {
      return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    }
    return createBuffer(size);
  }
  Buffer2.alloc = function(size, fill, encoding) {
    return alloc2(size, fill, encoding);
  };
  function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
  }
  Buffer2.allocUnsafe = function(size) {
    return allocUnsafe(size);
  };
  Buffer2.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
  };
  function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") {
      encoding = "utf8";
    }
    if (!Buffer2.isEncoding(encoding)) {
      throw new TypeError("Unknown encoding: " + encoding);
    }
    const length2 = byteLength2(string, encoding) | 0;
    let buf = createBuffer(length2);
    const actual = buf.write(string, encoding);
    if (actual !== length2) {
      buf = buf.slice(0, actual);
    }
    return buf;
  }
  function fromArrayLike(array2) {
    const length2 = array2.length < 0 ? 0 : checked(array2.length) | 0;
    const buf = createBuffer(length2);
    for (let i2 = 0; i2 < length2; i2 += 1) {
      buf[i2] = array2[i2] & 255;
    }
    return buf;
  }
  function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
      const copy2 = new Uint8Array(arrayView);
      return fromArrayBuffer(copy2.buffer, copy2.byteOffset, copy2.byteLength);
    }
    return fromArrayLike(arrayView);
  }
  function fromArrayBuffer(array2, byteOffset, length2) {
    if (byteOffset < 0 || array2.byteLength < byteOffset) {
      throw new RangeError('"offset" is outside of buffer bounds');
    }
    if (array2.byteLength < byteOffset + (length2 || 0)) {
      throw new RangeError('"length" is outside of buffer bounds');
    }
    let buf;
    if (byteOffset === void 0 && length2 === void 0) {
      buf = new Uint8Array(array2);
    } else if (length2 === void 0) {
      buf = new Uint8Array(array2, byteOffset);
    } else {
      buf = new Uint8Array(array2, byteOffset, length2);
    }
    Object.setPrototypeOf(buf, Buffer2.prototype);
    return buf;
  }
  function fromObject(obj) {
    if (Buffer2.isBuffer(obj)) {
      const len = checked(obj.length) | 0;
      const buf = createBuffer(len);
      if (buf.length === 0) {
        return buf;
      }
      obj.copy(buf, 0, 0, len);
      return buf;
    }
    if (obj.length !== void 0) {
      if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
        return createBuffer(0);
      }
      return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) {
      return fromArrayLike(obj.data);
    }
  }
  function checked(length2) {
    if (length2 >= K_MAX_LENGTH) {
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    }
    return length2 | 0;
  }
  function SlowBuffer(length2) {
    if (+length2 != length2) {
      length2 = 0;
    }
    return Buffer2.alloc(+length2);
  }
  Buffer2.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer2.prototype;
  };
  Buffer2.compare = function compare(a2, b) {
    if (isInstance(a2, Uint8Array))
      a2 = Buffer2.from(a2, a2.offset, a2.byteLength);
    if (isInstance(b, Uint8Array))
      b = Buffer2.from(b, b.offset, b.byteLength);
    if (!Buffer2.isBuffer(a2) || !Buffer2.isBuffer(b)) {
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    }
    if (a2 === b)
      return 0;
    let x2 = a2.length;
    let y2 = b.length;
    for (let i2 = 0, len = Math.min(x2, y2); i2 < len; ++i2) {
      if (a2[i2] !== b[i2]) {
        x2 = a2[i2];
        y2 = b[i2];
        break;
      }
    }
    if (x2 < y2)
      return -1;
    if (y2 < x2)
      return 1;
    return 0;
  };
  Buffer2.isEncoding = function isEncoding(encoding) {
    switch (String(encoding).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return true;
      default:
        return false;
    }
  };
  Buffer2.concat = function concat(list, length2) {
    if (!Array.isArray(list)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    if (list.length === 0) {
      return Buffer2.alloc(0);
    }
    let i2;
    if (length2 === void 0) {
      length2 = 0;
      for (i2 = 0; i2 < list.length; ++i2) {
        length2 += list[i2].length;
      }
    }
    const buffer2 = Buffer2.allocUnsafe(length2);
    let pos = 0;
    for (i2 = 0; i2 < list.length; ++i2) {
      let buf = list[i2];
      if (isInstance(buf, Uint8Array)) {
        if (pos + buf.length > buffer2.length) {
          if (!Buffer2.isBuffer(buf))
            buf = Buffer2.from(buf);
          buf.copy(buffer2, pos);
        } else {
          Uint8Array.prototype.set.call(
            buffer2,
            buf,
            pos
          );
        }
      } else if (!Buffer2.isBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      } else {
        buf.copy(buffer2, pos);
      }
      pos += buf.length;
    }
    return buffer2;
  };
  function byteLength2(string, encoding) {
    if (Buffer2.isBuffer(string)) {
      return string.length;
    }
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
      return string.byteLength;
    }
    if (typeof string !== "string") {
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string
      );
    }
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0)
      return 0;
    let loweredCase = false;
    for (; ; ) {
      switch (encoding) {
        case "ascii":
        case "latin1":
        case "binary":
          return len;
        case "utf8":
        case "utf-8":
          return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return len * 2;
        case "hex":
          return len >>> 1;
        case "base64":
          return base64ToBytes(string).length;
        default:
          if (loweredCase) {
            return mustMatch ? -1 : utf8ToBytes(string).length;
          }
          encoding = ("" + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer2.byteLength = byteLength2;
  function slowToString(encoding, start, end) {
    let loweredCase = false;
    if (start === void 0 || start < 0) {
      start = 0;
    }
    if (start > this.length) {
      return "";
    }
    if (end === void 0 || end > this.length) {
      end = this.length;
    }
    if (end <= 0) {
      return "";
    }
    end >>>= 0;
    start >>>= 0;
    if (end <= start) {
      return "";
    }
    if (!encoding)
      encoding = "utf8";
    while (true) {
      switch (encoding) {
        case "hex":
          return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
          return utf8Slice(this, start, end);
        case "ascii":
          return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
          return latin1Slice(this, start, end);
        case "base64":
          return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return utf16leSlice(this, start, end);
        default:
          if (loweredCase)
            throw new TypeError("Unknown encoding: " + encoding);
          encoding = (encoding + "").toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer2.prototype._isBuffer = true;
  function swap(b, n2, m2) {
    const i2 = b[n2];
    b[n2] = b[m2];
    b[m2] = i2;
  }
  Buffer2.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    }
    for (let i2 = 0; i2 < len; i2 += 2) {
      swap(this, i2, i2 + 1);
    }
    return this;
  };
  Buffer2.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    }
    for (let i2 = 0; i2 < len; i2 += 4) {
      swap(this, i2, i2 + 3);
      swap(this, i2 + 1, i2 + 2);
    }
    return this;
  };
  Buffer2.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    }
    for (let i2 = 0; i2 < len; i2 += 8) {
      swap(this, i2, i2 + 7);
      swap(this, i2 + 1, i2 + 6);
      swap(this, i2 + 2, i2 + 5);
      swap(this, i2 + 3, i2 + 4);
    }
    return this;
  };
  Buffer2.prototype.toString = function toString() {
    const length2 = this.length;
    if (length2 === 0)
      return "";
    if (arguments.length === 0)
      return utf8Slice(this, 0, length2);
    return slowToString.apply(this, arguments);
  };
  Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
  Buffer2.prototype.equals = function equals(b) {
    if (!Buffer2.isBuffer(b))
      throw new TypeError("Argument must be a Buffer");
    if (this === b)
      return true;
    return Buffer2.compare(this, b) === 0;
  };
  Buffer2.prototype.inspect = function inspect() {
    let str = "";
    const max2 = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max2).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max2)
      str += " ... ";
    return "<Buffer " + str + ">";
  };
  if (customInspectSymbol) {
    Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
  }
  Buffer2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) {
      target = Buffer2.from(target, target.offset, target.byteLength);
    }
    if (!Buffer2.isBuffer(target)) {
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target
      );
    }
    if (start === void 0) {
      start = 0;
    }
    if (end === void 0) {
      end = target ? target.length : 0;
    }
    if (thisStart === void 0) {
      thisStart = 0;
    }
    if (thisEnd === void 0) {
      thisEnd = this.length;
    }
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError("out of range index");
    }
    if (thisStart >= thisEnd && start >= end) {
      return 0;
    }
    if (thisStart >= thisEnd) {
      return -1;
    }
    if (start >= end) {
      return 1;
    }
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target)
      return 0;
    let x2 = thisEnd - thisStart;
    let y2 = end - start;
    const len = Math.min(x2, y2);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for (let i2 = 0; i2 < len; ++i2) {
      if (thisCopy[i2] !== targetCopy[i2]) {
        x2 = thisCopy[i2];
        y2 = targetCopy[i2];
        break;
      }
    }
    if (x2 < y2)
      return -1;
    if (y2 < x2)
      return 1;
    return 0;
  };
  function bidirectionalIndexOf(buffer2, val, byteOffset, encoding, dir) {
    if (buffer2.length === 0)
      return -1;
    if (typeof byteOffset === "string") {
      encoding = byteOffset;
      byteOffset = 0;
    } else if (byteOffset > 2147483647) {
      byteOffset = 2147483647;
    } else if (byteOffset < -2147483648) {
      byteOffset = -2147483648;
    }
    byteOffset = +byteOffset;
    if (numberIsNaN(byteOffset)) {
      byteOffset = dir ? 0 : buffer2.length - 1;
    }
    if (byteOffset < 0)
      byteOffset = buffer2.length + byteOffset;
    if (byteOffset >= buffer2.length) {
      if (dir)
        return -1;
      else
        byteOffset = buffer2.length - 1;
    } else if (byteOffset < 0) {
      if (dir)
        byteOffset = 0;
      else
        return -1;
    }
    if (typeof val === "string") {
      val = Buffer2.from(val, encoding);
    }
    if (Buffer2.isBuffer(val)) {
      if (val.length === 0) {
        return -1;
      }
      return arrayIndexOf(buffer2, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
      val = val & 255;
      if (typeof Uint8Array.prototype.indexOf === "function") {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer2, val, byteOffset);
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer2, val, byteOffset);
        }
      }
      return arrayIndexOf(buffer2, [val], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
  }
  function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== void 0) {
      encoding = String(encoding).toLowerCase();
      if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
        if (arr.length < 2 || val.length < 2) {
          return -1;
        }
        indexSize = 2;
        arrLength /= 2;
        valLength /= 2;
        byteOffset /= 2;
      }
    }
    function read(buf, i3) {
      if (indexSize === 1) {
        return buf[i3];
      } else {
        return buf.readUInt16BE(i3 * indexSize);
      }
    }
    let i2;
    if (dir) {
      let foundIndex = -1;
      for (i2 = byteOffset; i2 < arrLength; i2++) {
        if (read(arr, i2) === read(val, foundIndex === -1 ? 0 : i2 - foundIndex)) {
          if (foundIndex === -1)
            foundIndex = i2;
          if (i2 - foundIndex + 1 === valLength)
            return foundIndex * indexSize;
        } else {
          if (foundIndex !== -1)
            i2 -= i2 - foundIndex;
          foundIndex = -1;
        }
      }
    } else {
      if (byteOffset + valLength > arrLength)
        byteOffset = arrLength - valLength;
      for (i2 = byteOffset; i2 >= 0; i2--) {
        let found = true;
        for (let j = 0; j < valLength; j++) {
          if (read(arr, i2 + j) !== read(val, j)) {
            found = false;
            break;
          }
        }
        if (found)
          return i2;
      }
    }
    return -1;
  }
  Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
  };
  Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
  };
  Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
  };
  function hexWrite(buf, string, offset, length2) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length2) {
      length2 = remaining;
    } else {
      length2 = Number(length2);
      if (length2 > remaining) {
        length2 = remaining;
      }
    }
    const strLen = string.length;
    if (length2 > strLen / 2) {
      length2 = strLen / 2;
    }
    let i2;
    for (i2 = 0; i2 < length2; ++i2) {
      const parsed = parseInt(string.substr(i2 * 2, 2), 16);
      if (numberIsNaN(parsed))
        return i2;
      buf[offset + i2] = parsed;
    }
    return i2;
  }
  function utf8Write(buf, string, offset, length2) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length2);
  }
  function asciiWrite(buf, string, offset, length2) {
    return blitBuffer(asciiToBytes(string), buf, offset, length2);
  }
  function base64Write(buf, string, offset, length2) {
    return blitBuffer(base64ToBytes(string), buf, offset, length2);
  }
  function ucs2Write(buf, string, offset, length2) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length2);
  }
  Buffer2.prototype.write = function write(string, offset, length2, encoding) {
    if (offset === void 0) {
      encoding = "utf8";
      length2 = this.length;
      offset = 0;
    } else if (length2 === void 0 && typeof offset === "string") {
      encoding = offset;
      length2 = this.length;
      offset = 0;
    } else if (isFinite(offset)) {
      offset = offset >>> 0;
      if (isFinite(length2)) {
        length2 = length2 >>> 0;
        if (encoding === void 0)
          encoding = "utf8";
      } else {
        encoding = length2;
        length2 = void 0;
      }
    } else {
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    }
    const remaining = this.length - offset;
    if (length2 === void 0 || length2 > remaining)
      length2 = remaining;
    if (string.length > 0 && (length2 < 0 || offset < 0) || offset > this.length) {
      throw new RangeError("Attempt to write outside buffer bounds");
    }
    if (!encoding)
      encoding = "utf8";
    let loweredCase = false;
    for (; ; ) {
      switch (encoding) {
        case "hex":
          return hexWrite(this, string, offset, length2);
        case "utf8":
        case "utf-8":
          return utf8Write(this, string, offset, length2);
        case "ascii":
        case "latin1":
        case "binary":
          return asciiWrite(this, string, offset, length2);
        case "base64":
          return base64Write(this, string, offset, length2);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ucs2Write(this, string, offset, length2);
        default:
          if (loweredCase)
            throw new TypeError("Unknown encoding: " + encoding);
          encoding = ("" + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  };
  Buffer2.prototype.toJSON = function toJSON() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) {
      return base64.fromByteArray(buf);
    } else {
      return base64.fromByteArray(buf.slice(start, end));
    }
  }
  function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i2 = start;
    while (i2 < end) {
      const firstByte = buf[i2];
      let codePoint = null;
      let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
      if (i2 + bytesPerSequence <= end) {
        let secondByte, thirdByte, fourthByte, tempCodePoint;
        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 128) {
              codePoint = firstByte;
            }
            break;
          case 2:
            secondByte = buf[i2 + 1];
            if ((secondByte & 192) === 128) {
              tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
              if (tempCodePoint > 127) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 3:
            secondByte = buf[i2 + 1];
            thirdByte = buf[i2 + 2];
            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
              tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
              if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 4:
            secondByte = buf[i2 + 1];
            thirdByte = buf[i2 + 2];
            fourthByte = buf[i2 + 3];
            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
              tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
              if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                codePoint = tempCodePoint;
              }
            }
        }
      }
      if (codePoint === null) {
        codePoint = 65533;
        bytesPerSequence = 1;
      } else if (codePoint > 65535) {
        codePoint -= 65536;
        res.push(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
      }
      res.push(codePoint);
      i2 += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
  }
  const MAX_ARGUMENTS_LENGTH = 4096;
  function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints);
    }
    let res = "";
    let i2 = 0;
    while (i2 < len) {
      res += String.fromCharCode.apply(
        String,
        codePoints.slice(i2, i2 += MAX_ARGUMENTS_LENGTH)
      );
    }
    return res;
  }
  function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for (let i2 = start; i2 < end; ++i2) {
      ret += String.fromCharCode(buf[i2] & 127);
    }
    return ret;
  }
  function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for (let i2 = start; i2 < end; ++i2) {
      ret += String.fromCharCode(buf[i2]);
    }
    return ret;
  }
  function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0)
      start = 0;
    if (!end || end < 0 || end > len)
      end = len;
    let out = "";
    for (let i2 = start; i2 < end; ++i2) {
      out += hexSliceLookupTable[buf[i2]];
    }
    return out;
  }
  function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    for (let i2 = 0; i2 < bytes.length - 1; i2 += 2) {
      res += String.fromCharCode(bytes[i2] + bytes[i2 + 1] * 256);
    }
    return res;
  }
  Buffer2.prototype.slice = function slice2(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === void 0 ? len : ~~end;
    if (start < 0) {
      start += len;
      if (start < 0)
        start = 0;
    } else if (start > len) {
      start = len;
    }
    if (end < 0) {
      end += len;
      if (end < 0)
        end = 0;
    } else if (end > len) {
      end = len;
    }
    if (end < start)
      end = start;
    const newBuf = this.subarray(start, end);
    Object.setPrototypeOf(newBuf, Buffer2.prototype);
    return newBuf;
  };
  function checkOffset(offset, ext, length2) {
    if (offset % 1 !== 0 || offset < 0)
      throw new RangeError("offset is not uint");
    if (offset + ext > length2)
      throw new RangeError("Trying to access beyond buffer length");
  }
  Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    let val = this[offset];
    let mul = 1;
    let i2 = 0;
    while (++i2 < byteLength3 && (mul *= 256)) {
      val += this[offset + i2] * mul;
    }
    return val;
  };
  Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      checkOffset(offset, byteLength3, this.length);
    }
    let val = this[offset + --byteLength3];
    let mul = 1;
    while (byteLength3 > 0 && (mul *= 256)) {
      val += this[offset + --byteLength3] * mul;
    }
    return val;
  };
  Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 1, this.length);
    return this[offset];
  };
  Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
  };
  Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
  };
  Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
  };
  Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
  };
  Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
  });
  Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
  });
  Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    let val = this[offset];
    let mul = 1;
    let i2 = 0;
    while (++i2 < byteLength3 && (mul *= 256)) {
      val += this[offset + i2] * mul;
    }
    mul *= 128;
    if (val >= mul)
      val -= Math.pow(2, 8 * byteLength3);
    return val;
  };
  Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    let i2 = byteLength3;
    let mul = 1;
    let val = this[offset + --i2];
    while (i2 > 0 && (mul *= 256)) {
      val += this[offset + --i2] * mul;
    }
    mul *= 128;
    if (val >= mul)
      val -= Math.pow(2, 8 * byteLength3);
    return val;
  };
  Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 1, this.length);
    if (!(this[offset] & 128))
      return this[offset];
    return (255 - this[offset] + 1) * -1;
  };
  Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 32768 ? val | 4294901760 : val;
  };
  Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 32768 ? val | 4294901760 : val;
  };
  Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
  };
  Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
  };
  Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last << 24);
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
  });
  Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last);
  });
  Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return ieee754$1.read(this, offset, true, 23, 4);
  };
  Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return ieee754$1.read(this, offset, false, 23, 4);
  };
  Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 8, this.length);
    return ieee754$1.read(this, offset, true, 52, 8);
  };
  Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 8, this.length);
    return ieee754$1.read(this, offset, false, 52, 8);
  };
  function checkInt(buf, value, offset, ext, max2, min2) {
    if (!Buffer2.isBuffer(buf))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max2 || value < min2)
      throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length)
      throw new RangeError("Index out of range");
  }
  Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      const maxBytes = Math.pow(2, 8 * byteLength3) - 1;
      checkInt(this, value, offset, byteLength3, maxBytes, 0);
    }
    let mul = 1;
    let i2 = 0;
    this[offset] = value & 255;
    while (++i2 < byteLength3 && (mul *= 256)) {
      this[offset + i2] = value / mul & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      const maxBytes = Math.pow(2, 8 * byteLength3) - 1;
      checkInt(this, value, offset, byteLength3, maxBytes, 0);
    }
    let i2 = byteLength3 - 1;
    let mul = 1;
    this[offset + i2] = value & 255;
    while (--i2 >= 0 && (mul *= 256)) {
      this[offset + i2] = value / mul & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 1, 255, 0);
    this[offset] = value & 255;
    return offset + 1;
  };
  Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 65535, 0);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    return offset + 2;
  };
  Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 65535, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 255;
    return offset + 2;
  };
  Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 4294967295, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 255;
    return offset + 4;
  };
  Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 4294967295, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 255;
    return offset + 4;
  };
  function wrtBigUInt64LE(buf, value, offset, min2, max2) {
    checkIntBI(value, min2, max2, buf, offset, 7);
    let lo = Number(value & BigInt(4294967295));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(4294967295));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
  }
  function wrtBigUInt64BE(buf, value, offset, min2, max2) {
    checkIntBI(value, min2, max2, buf, offset, 7);
    let lo = Number(value & BigInt(4294967295));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(4294967295));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
  }
  Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
  });
  Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
  });
  Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      const limit = Math.pow(2, 8 * byteLength3 - 1);
      checkInt(this, value, offset, byteLength3, limit - 1, -limit);
    }
    let i2 = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 255;
    while (++i2 < byteLength3 && (mul *= 256)) {
      if (value < 0 && sub === 0 && this[offset + i2 - 1] !== 0) {
        sub = 1;
      }
      this[offset + i2] = (value / mul >> 0) - sub & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      const limit = Math.pow(2, 8 * byteLength3 - 1);
      checkInt(this, value, offset, byteLength3, limit - 1, -limit);
    }
    let i2 = byteLength3 - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i2] = value & 255;
    while (--i2 >= 0 && (mul *= 256)) {
      if (value < 0 && sub === 0 && this[offset + i2 + 1] !== 0) {
        sub = 1;
      }
      this[offset + i2] = (value / mul >> 0) - sub & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 1, 127, -128);
    if (value < 0)
      value = 255 + value + 1;
    this[offset] = value & 255;
    return offset + 1;
  };
  Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 32767, -32768);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    return offset + 2;
  };
  Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 32767, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 255;
    return offset + 2;
  };
  Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 2147483647, -2147483648);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
  };
  Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 2147483647, -2147483648);
    if (value < 0)
      value = 4294967295 + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 255;
    return offset + 4;
  };
  Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function checkIEEE754(buf, value, offset, ext, max2, min2) {
    if (offset + ext > buf.length)
      throw new RangeError("Index out of range");
    if (offset < 0)
      throw new RangeError("Index out of range");
  }
  function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 4);
    }
    ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
  }
  Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
  };
  Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
  };
  function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 8);
    }
    ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
  }
  Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
  };
  Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
  };
  Buffer2.prototype.copy = function copy2(target, targetStart, start, end) {
    if (!Buffer2.isBuffer(target))
      throw new TypeError("argument should be a Buffer");
    if (!start)
      start = 0;
    if (!end && end !== 0)
      end = this.length;
    if (targetStart >= target.length)
      targetStart = target.length;
    if (!targetStart)
      targetStart = 0;
    if (end > 0 && end < start)
      end = start;
    if (end === start)
      return 0;
    if (target.length === 0 || this.length === 0)
      return 0;
    if (targetStart < 0) {
      throw new RangeError("targetStart out of bounds");
    }
    if (start < 0 || start >= this.length)
      throw new RangeError("Index out of range");
    if (end < 0)
      throw new RangeError("sourceEnd out of bounds");
    if (end > this.length)
      end = this.length;
    if (target.length - targetStart < end - start) {
      end = target.length - targetStart + start;
    }
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
      this.copyWithin(targetStart, start, end);
    } else {
      Uint8Array.prototype.set.call(
        target,
        this.subarray(start, end),
        targetStart
      );
    }
    return len;
  };
  Buffer2.prototype.fill = function fill(val, start, end, encoding) {
    if (typeof val === "string") {
      if (typeof start === "string") {
        encoding = start;
        start = 0;
        end = this.length;
      } else if (typeof end === "string") {
        encoding = end;
        end = this.length;
      }
      if (encoding !== void 0 && typeof encoding !== "string") {
        throw new TypeError("encoding must be a string");
      }
      if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      if (val.length === 1) {
        const code2 = val.charCodeAt(0);
        if (encoding === "utf8" && code2 < 128 || encoding === "latin1") {
          val = code2;
        }
      }
    } else if (typeof val === "number") {
      val = val & 255;
    } else if (typeof val === "boolean") {
      val = Number(val);
    }
    if (start < 0 || this.length < start || this.length < end) {
      throw new RangeError("Out of range index");
    }
    if (end <= start) {
      return this;
    }
    start = start >>> 0;
    end = end === void 0 ? this.length : end >>> 0;
    if (!val)
      val = 0;
    let i2;
    if (typeof val === "number") {
      for (i2 = start; i2 < end; ++i2) {
        this[i2] = val;
      }
    } else {
      const bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
      const len = bytes.length;
      if (len === 0) {
        throw new TypeError('The value "' + val + '" is invalid for argument "value"');
      }
      for (i2 = 0; i2 < end - start; ++i2) {
        this[i2 + start] = bytes[i2 % len];
      }
    }
    return this;
  };
  const errors = {};
  function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
      constructor() {
        super();
        Object.defineProperty(this, "message", {
          value: getMessage.apply(this, arguments),
          writable: true,
          configurable: true
        });
        this.name = `${this.name} [${sym}]`;
        this.stack;
        delete this.name;
      }
      get code() {
        return sym;
      }
      set code(value) {
        Object.defineProperty(this, "code", {
          configurable: true,
          enumerable: true,
          value,
          writable: true
        });
      }
      toString() {
        return `${this.name} [${sym}]: ${this.message}`;
      }
    };
  }
  E(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(name) {
      if (name) {
        return `${name} is outside of buffer bounds`;
      }
      return "Attempt to access memory outside buffer bounds";
    },
    RangeError
  );
  E(
    "ERR_INVALID_ARG_TYPE",
    function(name, actual) {
      return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
    },
    TypeError
  );
  E(
    "ERR_OUT_OF_RANGE",
    function(str, range2, input) {
      let msg = `The value of "${str}" is out of range.`;
      let received = input;
      if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
        received = addNumericalSeparator(String(input));
      } else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
          received = addNumericalSeparator(received);
        }
        received += "n";
      }
      msg += ` It must be ${range2}. Received ${received}`;
      return msg;
    },
    RangeError
  );
  function addNumericalSeparator(val) {
    let res = "";
    let i2 = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for (; i2 >= start + 4; i2 -= 3) {
      res = `_${val.slice(i2 - 3, i2)}${res}`;
    }
    return `${val.slice(0, i2)}${res}`;
  }
  function checkBounds(buf, offset, byteLength3) {
    validateNumber(offset, "offset");
    if (buf[offset] === void 0 || buf[offset + byteLength3] === void 0) {
      boundsError(offset, buf.length - (byteLength3 + 1));
    }
  }
  function checkIntBI(value, min2, max2, buf, offset, byteLength3) {
    if (value > max2 || value < min2) {
      const n2 = typeof min2 === "bigint" ? "n" : "";
      let range2;
      if (byteLength3 > 3) {
        if (min2 === 0 || min2 === BigInt(0)) {
          range2 = `>= 0${n2} and < 2${n2} ** ${(byteLength3 + 1) * 8}${n2}`;
        } else {
          range2 = `>= -(2${n2} ** ${(byteLength3 + 1) * 8 - 1}${n2}) and < 2 ** ${(byteLength3 + 1) * 8 - 1}${n2}`;
        }
      } else {
        range2 = `>= ${min2}${n2} and <= ${max2}${n2}`;
      }
      throw new errors.ERR_OUT_OF_RANGE("value", range2, value);
    }
    checkBounds(buf, offset, byteLength3);
  }
  function validateNumber(value, name) {
    if (typeof value !== "number") {
      throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
    }
  }
  function boundsError(value, length2, type2) {
    if (Math.floor(value) !== value) {
      validateNumber(value, type2);
      throw new errors.ERR_OUT_OF_RANGE(type2 || "offset", "an integer", value);
    }
    if (length2 < 0) {
      throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    }
    throw new errors.ERR_OUT_OF_RANGE(
      type2 || "offset",
      `>= ${type2 ? 1 : 0} and <= ${length2}`,
      value
    );
  }
  const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
  function base64clean(str) {
    str = str.split("=")[0];
    str = str.trim().replace(INVALID_BASE64_RE, "");
    if (str.length < 2)
      return "";
    while (str.length % 4 !== 0) {
      str = str + "=";
    }
    return str;
  }
  function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length2 = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for (let i2 = 0; i2 < length2; ++i2) {
      codePoint = string.charCodeAt(i2);
      if (codePoint > 55295 && codePoint < 57344) {
        if (!leadSurrogate) {
          if (codePoint > 56319) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            continue;
          } else if (i2 + 1 === length2) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            continue;
          }
          leadSurrogate = codePoint;
          continue;
        }
        if (codePoint < 56320) {
          if ((units -= 3) > -1)
            bytes.push(239, 191, 189);
          leadSurrogate = codePoint;
          continue;
        }
        codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
      } else if (leadSurrogate) {
        if ((units -= 3) > -1)
          bytes.push(239, 191, 189);
      }
      leadSurrogate = null;
      if (codePoint < 128) {
        if ((units -= 1) < 0)
          break;
        bytes.push(codePoint);
      } else if (codePoint < 2048) {
        if ((units -= 2) < 0)
          break;
        bytes.push(
          codePoint >> 6 | 192,
          codePoint & 63 | 128
        );
      } else if (codePoint < 65536) {
        if ((units -= 3) < 0)
          break;
        bytes.push(
          codePoint >> 12 | 224,
          codePoint >> 6 & 63 | 128,
          codePoint & 63 | 128
        );
      } else if (codePoint < 1114112) {
        if ((units -= 4) < 0)
          break;
        bytes.push(
          codePoint >> 18 | 240,
          codePoint >> 12 & 63 | 128,
          codePoint >> 6 & 63 | 128,
          codePoint & 63 | 128
        );
      } else {
        throw new Error("Invalid code point");
      }
    }
    return bytes;
  }
  function asciiToBytes(str) {
    const byteArray = [];
    for (let i2 = 0; i2 < str.length; ++i2) {
      byteArray.push(str.charCodeAt(i2) & 255);
    }
    return byteArray;
  }
  function utf16leToBytes(str, units) {
    let c2, hi, lo;
    const byteArray = [];
    for (let i2 = 0; i2 < str.length; ++i2) {
      if ((units -= 2) < 0)
        break;
      c2 = str.charCodeAt(i2);
      hi = c2 >> 8;
      lo = c2 % 256;
      byteArray.push(lo);
      byteArray.push(hi);
    }
    return byteArray;
  }
  function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
  }
  function blitBuffer(src, dst, offset, length2) {
    let i2;
    for (i2 = 0; i2 < length2; ++i2) {
      if (i2 + offset >= dst.length || i2 >= src.length)
        break;
      dst[i2 + offset] = src[i2];
    }
    return i2;
  }
  function isInstance(obj, type2) {
    return obj instanceof type2 || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type2.name;
  }
  function numberIsNaN(obj) {
    return obj !== obj;
  }
  const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for (let i2 = 0; i2 < 16; ++i2) {
      const i16 = i2 * 16;
      for (let j = 0; j < 16; ++j) {
        table[i16 + j] = alphabet[i2] + alphabet[j];
      }
    }
    return table;
  }();
  function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
  }
  function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
  }
})(buffer);
function dataUrlToBase64(dataUrl) {
  var _a2;
  return (_a2 = dataUrl.split(",")[1]) != null ? _a2 : "";
}
function base64ToBinary(base64) {
  return buffer.Buffer.from(base64, "base64").toString("binary");
}
function binaryToUint8Array(binary) {
  const bytes = new Uint8Array(binary.length);
  for (let i2 = 0; i2 < binary.length; i2++) {
    bytes[i2] = binary.charCodeAt(i2);
  }
  return bytes;
}
function uint8ArrayToBase64(arr) {
  return buffer.Buffer.from(arr).toString("base64");
}
function dataUrlToUint8Array(dataUrl) {
  const base64 = dataUrlToBase64(dataUrl);
  const binary = base64ToBinary(base64);
  return binaryToUint8Array(binary);
}
var raf$1 = { exports: {} };
var performanceNow = { exports: {} };
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    performanceNow.exports = function() {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    performanceNow.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    performanceNow.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    performanceNow.exports = function() {
      return (/* @__PURE__ */ new Date()).getTime() - loadTime;
    };
    loadTime = (/* @__PURE__ */ new Date()).getTime();
  }
}).call(commonjsGlobal);
var performanceNowExports = performanceNow.exports;
var now$1 = performanceNowExports, root = typeof window === "undefined" ? commonjsGlobal : window, vendors = ["moz", "webkit"], suffix = "AnimationFrame", raf = root["request" + suffix], caf = root["cancel" + suffix] || root["cancelRequest" + suffix];
for (var i$1 = 0; !raf && i$1 < vendors.length; i$1++) {
  raf = root[vendors[i$1] + "Request" + suffix];
  caf = root[vendors[i$1] + "Cancel" + suffix] || root[vendors[i$1] + "CancelRequest" + suffix];
}
if (!raf || !caf) {
  var last = 0, id$1 = 0, queue = [], frameDuration = 1e3 / 60;
  raf = function(callback) {
    if (queue.length === 0) {
      var _now = now$1(), next2 = Math.max(0, frameDuration - (_now - last));
      last = next2 + _now;
      setTimeout(function() {
        var cp = queue.slice(0);
        queue.length = 0;
        for (var i2 = 0; i2 < cp.length; i2++) {
          if (!cp[i2].cancelled) {
            try {
              cp[i2].callback(last);
            } catch (e3) {
              setTimeout(function() {
                throw e3;
              }, 0);
            }
          }
        }
      }, Math.round(next2));
    }
    queue.push({
      handle: ++id$1,
      callback,
      cancelled: false
    });
    return id$1;
  };
  caf = function(handle) {
    for (var i2 = 0; i2 < queue.length; i2++) {
      if (queue[i2].handle === handle) {
        queue[i2].cancelled = true;
      }
    }
  };
}
raf$1.exports = function(fn) {
  return raf.call(root, fn);
};
raf$1.exports.cancel = function() {
  caf.apply(root, arguments);
};
raf$1.exports.polyfill = function(object2) {
  if (!object2) {
    object2 = root;
  }
  object2.requestAnimationFrame = raf;
  object2.cancelAnimationFrame = caf;
};
var rafExports = raf$1.exports;
const requestAnimationFrame$1 = /* @__PURE__ */ getDefaultExportFromCjs(rafExports);
var rgbcolor = function(color_string) {
  this.ok = false;
  this.alpha = 1;
  if (color_string.charAt(0) == "#") {
    color_string = color_string.substr(1, 6);
  }
  color_string = color_string.replace(/ /g, "");
  color_string = color_string.toLowerCase();
  var simple_colors = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dodgerblue: "1e90ff",
    feldspar: "d19275",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgrey: "d3d3d3",
    lightgreen: "90ee90",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslateblue: "8470ff",
    lightslategray: "778899",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "00ff00",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "ff00ff",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370d8",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "d87093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "ff0000",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    violetred: "d02090",
    wheat: "f5deb3",
    white: "ffffff",
    whitesmoke: "f5f5f5",
    yellow: "ffff00",
    yellowgreen: "9acd32"
  };
  color_string = simple_colors[color_string] || color_string;
  var color_defs = [
    {
      re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
      example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
      process: function(bits2) {
        return [
          parseInt(bits2[1]),
          parseInt(bits2[2]),
          parseInt(bits2[3]),
          parseFloat(bits2[4])
        ];
      }
    },
    {
      re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
      example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
      process: function(bits2) {
        return [
          parseInt(bits2[1]),
          parseInt(bits2[2]),
          parseInt(bits2[3])
        ];
      }
    },
    {
      re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      example: ["#00ff00", "336699"],
      process: function(bits2) {
        return [
          parseInt(bits2[1], 16),
          parseInt(bits2[2], 16),
          parseInt(bits2[3], 16)
        ];
      }
    },
    {
      re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      example: ["#fb0", "f0f"],
      process: function(bits2) {
        return [
          parseInt(bits2[1] + bits2[1], 16),
          parseInt(bits2[2] + bits2[2], 16),
          parseInt(bits2[3] + bits2[3], 16)
        ];
      }
    }
  ];
  for (var i2 = 0; i2 < color_defs.length; i2++) {
    var re2 = color_defs[i2].re;
    var processor = color_defs[i2].process;
    var bits = re2.exec(color_string);
    if (bits) {
      var channels = processor(bits);
      this.r = channels[0];
      this.g = channels[1];
      this.b = channels[2];
      if (channels.length > 3) {
        this.alpha = channels[3];
      }
      this.ok = true;
    }
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r;
  this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g;
  this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b;
  this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha;
  this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  };
  this.toRGBA = function() {
    return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
  };
  this.toHex = function() {
    var r2 = this.r.toString(16);
    var g = this.g.toString(16);
    var b = this.b.toString(16);
    if (r2.length == 1)
      r2 = "0" + r2;
    if (g.length == 1)
      g = "0" + g;
    if (b.length == 1)
      b = "0" + b;
    return "#" + r2 + g + b;
  };
  this.getHelpXML = function() {
    var examples = new Array();
    for (var i3 = 0; i3 < color_defs.length; i3++) {
      var example = color_defs[i3].example;
      for (var j = 0; j < example.length; j++) {
        examples[examples.length] = example[j];
      }
    }
    for (var sc in simple_colors) {
      examples[examples.length] = sc;
    }
    var xml = document.createElement("ul");
    xml.setAttribute("id", "rgbcolor-examples");
    for (var i3 = 0; i3 < examples.length; i3++) {
      try {
        var list_item = document.createElement("li");
        var list_color = new RGBColor(examples[i3]);
        var example_div = document.createElement("div");
        example_div.style.cssText = "margin: 3px; border: 1px solid black; background:" + list_color.toHex() + "; color:" + list_color.toHex();
        example_div.appendChild(document.createTextNode("test"));
        var list_item_value = document.createTextNode(
          " " + examples[i3] + " -> " + list_color.toRGB() + " -> " + list_color.toHex()
        );
        list_item.appendChild(example_div);
        list_item.appendChild(list_item_value);
        xml.appendChild(list_item);
      } catch (e3) {
      }
    }
    return xml;
  };
};
const RGBColor$1 = /* @__PURE__ */ getDefaultExportFromCjs(rgbcolor);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var t = function(r2, e3) {
  return (t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t2, r3) {
    t2.__proto__ = r3;
  } || function(t2, r3) {
    for (var e4 in r3)
      Object.prototype.hasOwnProperty.call(r3, e4) && (t2[e4] = r3[e4]);
  })(r2, e3);
};
function r(r2, e3) {
  if ("function" != typeof e3 && null !== e3)
    throw new TypeError("Class extends value " + String(e3) + " is not a constructor or null");
  function i2() {
    this.constructor = r2;
  }
  t(r2, e3), r2.prototype = null === e3 ? Object.create(e3) : (i2.prototype = e3.prototype, new i2());
}
function e(t2) {
  var r2 = "";
  Array.isArray(t2) || (t2 = [t2]);
  for (var e3 = 0; e3 < t2.length; e3++) {
    var i2 = t2[e3];
    if (i2.type === _.CLOSE_PATH)
      r2 += "z";
    else if (i2.type === _.HORIZ_LINE_TO)
      r2 += (i2.relative ? "h" : "H") + i2.x;
    else if (i2.type === _.VERT_LINE_TO)
      r2 += (i2.relative ? "v" : "V") + i2.y;
    else if (i2.type === _.MOVE_TO)
      r2 += (i2.relative ? "m" : "M") + i2.x + " " + i2.y;
    else if (i2.type === _.LINE_TO)
      r2 += (i2.relative ? "l" : "L") + i2.x + " " + i2.y;
    else if (i2.type === _.CURVE_TO)
      r2 += (i2.relative ? "c" : "C") + i2.x1 + " " + i2.y1 + " " + i2.x2 + " " + i2.y2 + " " + i2.x + " " + i2.y;
    else if (i2.type === _.SMOOTH_CURVE_TO)
      r2 += (i2.relative ? "s" : "S") + i2.x2 + " " + i2.y2 + " " + i2.x + " " + i2.y;
    else if (i2.type === _.QUAD_TO)
      r2 += (i2.relative ? "q" : "Q") + i2.x1 + " " + i2.y1 + " " + i2.x + " " + i2.y;
    else if (i2.type === _.SMOOTH_QUAD_TO)
      r2 += (i2.relative ? "t" : "T") + i2.x + " " + i2.y;
    else {
      if (i2.type !== _.ARC)
        throw new Error('Unexpected command type "' + i2.type + '" at index ' + e3 + ".");
      r2 += (i2.relative ? "a" : "A") + i2.rX + " " + i2.rY + " " + i2.xRot + " " + +i2.lArcFlag + " " + +i2.sweepFlag + " " + i2.x + " " + i2.y;
    }
  }
  return r2;
}
function i(t2, r2) {
  var e3 = t2[0], i2 = t2[1];
  return [e3 * Math.cos(r2) - i2 * Math.sin(r2), e3 * Math.sin(r2) + i2 * Math.cos(r2)];
}
function a$1() {
  for (var t2 = [], r2 = 0; r2 < arguments.length; r2++)
    t2[r2] = arguments[r2];
  for (var e3 = 0; e3 < t2.length; e3++)
    if ("number" != typeof t2[e3])
      throw new Error("assertNumbers arguments[" + e3 + "] is not a number. " + typeof t2[e3] + " == typeof " + t2[e3]);
  return true;
}
var n = Math.PI;
function o(t2, r2, e3) {
  t2.lArcFlag = 0 === t2.lArcFlag ? 0 : 1, t2.sweepFlag = 0 === t2.sweepFlag ? 0 : 1;
  var a2 = t2.rX, o2 = t2.rY, s2 = t2.x, u2 = t2.y;
  a2 = Math.abs(t2.rX), o2 = Math.abs(t2.rY);
  var h2 = i([(r2 - s2) / 2, (e3 - u2) / 2], -t2.xRot / 180 * n), c2 = h2[0], y2 = h2[1], p2 = Math.pow(c2, 2) / Math.pow(a2, 2) + Math.pow(y2, 2) / Math.pow(o2, 2);
  1 < p2 && (a2 *= Math.sqrt(p2), o2 *= Math.sqrt(p2)), t2.rX = a2, t2.rY = o2;
  var m2 = Math.pow(a2, 2) * Math.pow(y2, 2) + Math.pow(o2, 2) * Math.pow(c2, 2), O2 = (t2.lArcFlag !== t2.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(a2, 2) * Math.pow(o2, 2) - m2) / m2)), l2 = a2 * y2 / o2 * O2, T2 = -o2 * c2 / a2 * O2, v2 = i([l2, T2], t2.xRot / 180 * n);
  t2.cX = v2[0] + (r2 + s2) / 2, t2.cY = v2[1] + (e3 + u2) / 2, t2.phi1 = Math.atan2((y2 - T2) / o2, (c2 - l2) / a2), t2.phi2 = Math.atan2((-y2 - T2) / o2, (-c2 - l2) / a2), 0 === t2.sweepFlag && t2.phi2 > t2.phi1 && (t2.phi2 -= 2 * n), 1 === t2.sweepFlag && t2.phi2 < t2.phi1 && (t2.phi2 += 2 * n), t2.phi1 *= 180 / n, t2.phi2 *= 180 / n;
}
function s(t2, r2, e3) {
  a$1(t2, r2, e3);
  var i2 = t2 * t2 + r2 * r2 - e3 * e3;
  if (0 > i2)
    return [];
  if (0 === i2)
    return [[t2 * e3 / (t2 * t2 + r2 * r2), r2 * e3 / (t2 * t2 + r2 * r2)]];
  var n2 = Math.sqrt(i2);
  return [[(t2 * e3 + r2 * n2) / (t2 * t2 + r2 * r2), (r2 * e3 - t2 * n2) / (t2 * t2 + r2 * r2)], [(t2 * e3 - r2 * n2) / (t2 * t2 + r2 * r2), (r2 * e3 + t2 * n2) / (t2 * t2 + r2 * r2)]];
}
var u, h = Math.PI / 180;
function c$2(t2, r2, e3) {
  return (1 - e3) * t2 + e3 * r2;
}
function y$3(t2, r2, e3, i2) {
  return t2 + Math.cos(i2 / 180 * n) * r2 + Math.sin(i2 / 180 * n) * e3;
}
function p(t2, r2, e3, i2) {
  var a2 = 1e-6, n2 = r2 - t2, o2 = e3 - r2, s2 = 3 * n2 + 3 * (i2 - e3) - 6 * o2, u2 = 6 * (o2 - n2), h2 = 3 * n2;
  return Math.abs(s2) < a2 ? [-h2 / u2] : function(t3, r3, e4) {
    void 0 === e4 && (e4 = 1e-6);
    var i3 = t3 * t3 / 4 - r3;
    if (i3 < -e4)
      return [];
    if (i3 <= e4)
      return [-t3 / 2];
    var a3 = Math.sqrt(i3);
    return [-t3 / 2 - a3, -t3 / 2 + a3];
  }(u2 / s2, h2 / s2, a2);
}
function m$2(t2, r2, e3, i2, a2) {
  var n2 = 1 - a2;
  return t2 * (n2 * n2 * n2) + r2 * (3 * n2 * n2 * a2) + e3 * (3 * n2 * a2 * a2) + i2 * (a2 * a2 * a2);
}
!function(t2) {
  function r2() {
    return u2(function(t3, r3, e4) {
      return t3.relative && (void 0 !== t3.x1 && (t3.x1 += r3), void 0 !== t3.y1 && (t3.y1 += e4), void 0 !== t3.x2 && (t3.x2 += r3), void 0 !== t3.y2 && (t3.y2 += e4), void 0 !== t3.x && (t3.x += r3), void 0 !== t3.y && (t3.y += e4), t3.relative = false), t3;
    });
  }
  function e3() {
    var t3 = NaN, r3 = NaN, e4 = NaN, i2 = NaN;
    return u2(function(a2, n3, o2) {
      return a2.type & _.SMOOTH_CURVE_TO && (a2.type = _.CURVE_TO, t3 = isNaN(t3) ? n3 : t3, r3 = isNaN(r3) ? o2 : r3, a2.x1 = a2.relative ? n3 - t3 : 2 * n3 - t3, a2.y1 = a2.relative ? o2 - r3 : 2 * o2 - r3), a2.type & _.CURVE_TO ? (t3 = a2.relative ? n3 + a2.x2 : a2.x2, r3 = a2.relative ? o2 + a2.y2 : a2.y2) : (t3 = NaN, r3 = NaN), a2.type & _.SMOOTH_QUAD_TO && (a2.type = _.QUAD_TO, e4 = isNaN(e4) ? n3 : e4, i2 = isNaN(i2) ? o2 : i2, a2.x1 = a2.relative ? n3 - e4 : 2 * n3 - e4, a2.y1 = a2.relative ? o2 - i2 : 2 * o2 - i2), a2.type & _.QUAD_TO ? (e4 = a2.relative ? n3 + a2.x1 : a2.x1, i2 = a2.relative ? o2 + a2.y1 : a2.y1) : (e4 = NaN, i2 = NaN), a2;
    });
  }
  function n2() {
    var t3 = NaN, r3 = NaN;
    return u2(function(e4, i2, a2) {
      if (e4.type & _.SMOOTH_QUAD_TO && (e4.type = _.QUAD_TO, t3 = isNaN(t3) ? i2 : t3, r3 = isNaN(r3) ? a2 : r3, e4.x1 = e4.relative ? i2 - t3 : 2 * i2 - t3, e4.y1 = e4.relative ? a2 - r3 : 2 * a2 - r3), e4.type & _.QUAD_TO) {
        t3 = e4.relative ? i2 + e4.x1 : e4.x1, r3 = e4.relative ? a2 + e4.y1 : e4.y1;
        var n3 = e4.x1, o2 = e4.y1;
        e4.type = _.CURVE_TO, e4.x1 = ((e4.relative ? 0 : i2) + 2 * n3) / 3, e4.y1 = ((e4.relative ? 0 : a2) + 2 * o2) / 3, e4.x2 = (e4.x + 2 * n3) / 3, e4.y2 = (e4.y + 2 * o2) / 3;
      } else
        t3 = NaN, r3 = NaN;
      return e4;
    });
  }
  function u2(t3) {
    var r3 = 0, e4 = 0, i2 = NaN, a2 = NaN;
    return function(n3) {
      if (isNaN(i2) && !(n3.type & _.MOVE_TO))
        throw new Error("path must start with moveto");
      var o2 = t3(n3, r3, e4, i2, a2);
      return n3.type & _.CLOSE_PATH && (r3 = i2, e4 = a2), void 0 !== n3.x && (r3 = n3.relative ? r3 + n3.x : n3.x), void 0 !== n3.y && (e4 = n3.relative ? e4 + n3.y : n3.y), n3.type & _.MOVE_TO && (i2 = r3, a2 = e4), o2;
    };
  }
  function O2(t3, r3, e4, i2, n3, o2) {
    return a$1(t3, r3, e4, i2, n3, o2), u2(function(a2, s2, u3, h2) {
      var c2 = a2.x1, y2 = a2.x2, p2 = a2.relative && !isNaN(h2), m2 = void 0 !== a2.x ? a2.x : p2 ? 0 : s2, O3 = void 0 !== a2.y ? a2.y : p2 ? 0 : u3;
      function l3(t4) {
        return t4 * t4;
      }
      a2.type & _.HORIZ_LINE_TO && 0 !== r3 && (a2.type = _.LINE_TO, a2.y = a2.relative ? 0 : u3), a2.type & _.VERT_LINE_TO && 0 !== e4 && (a2.type = _.LINE_TO, a2.x = a2.relative ? 0 : s2), void 0 !== a2.x && (a2.x = a2.x * t3 + O3 * e4 + (p2 ? 0 : n3)), void 0 !== a2.y && (a2.y = m2 * r3 + a2.y * i2 + (p2 ? 0 : o2)), void 0 !== a2.x1 && (a2.x1 = a2.x1 * t3 + a2.y1 * e4 + (p2 ? 0 : n3)), void 0 !== a2.y1 && (a2.y1 = c2 * r3 + a2.y1 * i2 + (p2 ? 0 : o2)), void 0 !== a2.x2 && (a2.x2 = a2.x2 * t3 + a2.y2 * e4 + (p2 ? 0 : n3)), void 0 !== a2.y2 && (a2.y2 = y2 * r3 + a2.y2 * i2 + (p2 ? 0 : o2));
      var T2 = t3 * i2 - r3 * e4;
      if (void 0 !== a2.xRot && (1 !== t3 || 0 !== r3 || 0 !== e4 || 1 !== i2))
        if (0 === T2)
          delete a2.rX, delete a2.rY, delete a2.xRot, delete a2.lArcFlag, delete a2.sweepFlag, a2.type = _.LINE_TO;
        else {
          var v2 = a2.xRot * Math.PI / 180, f2 = Math.sin(v2), N2 = Math.cos(v2), x2 = 1 / l3(a2.rX), d = 1 / l3(a2.rY), E = l3(N2) * x2 + l3(f2) * d, A = 2 * f2 * N2 * (x2 - d), C = l3(f2) * x2 + l3(N2) * d, M = E * i2 * i2 - A * r3 * i2 + C * r3 * r3, R = A * (t3 * i2 + r3 * e4) - 2 * (E * e4 * i2 + C * t3 * r3), g = E * e4 * e4 - A * t3 * e4 + C * t3 * t3, I = (Math.atan2(R, M - g) + Math.PI) % Math.PI / 2, S = Math.sin(I), L = Math.cos(I);
          a2.rX = Math.abs(T2) / Math.sqrt(M * l3(L) + R * S * L + g * l3(S)), a2.rY = Math.abs(T2) / Math.sqrt(M * l3(S) - R * S * L + g * l3(L)), a2.xRot = 180 * I / Math.PI;
        }
      return void 0 !== a2.sweepFlag && 0 > T2 && (a2.sweepFlag = +!a2.sweepFlag), a2;
    });
  }
  function l2() {
    return function(t3) {
      var r3 = {};
      for (var e4 in t3)
        r3[e4] = t3[e4];
      return r3;
    };
  }
  t2.ROUND = function(t3) {
    function r3(r4) {
      return Math.round(r4 * t3) / t3;
    }
    return void 0 === t3 && (t3 = 1e13), a$1(t3), function(t4) {
      return void 0 !== t4.x1 && (t4.x1 = r3(t4.x1)), void 0 !== t4.y1 && (t4.y1 = r3(t4.y1)), void 0 !== t4.x2 && (t4.x2 = r3(t4.x2)), void 0 !== t4.y2 && (t4.y2 = r3(t4.y2)), void 0 !== t4.x && (t4.x = r3(t4.x)), void 0 !== t4.y && (t4.y = r3(t4.y)), void 0 !== t4.rX && (t4.rX = r3(t4.rX)), void 0 !== t4.rY && (t4.rY = r3(t4.rY)), t4;
    };
  }, t2.TO_ABS = r2, t2.TO_REL = function() {
    return u2(function(t3, r3, e4) {
      return t3.relative || (void 0 !== t3.x1 && (t3.x1 -= r3), void 0 !== t3.y1 && (t3.y1 -= e4), void 0 !== t3.x2 && (t3.x2 -= r3), void 0 !== t3.y2 && (t3.y2 -= e4), void 0 !== t3.x && (t3.x -= r3), void 0 !== t3.y && (t3.y -= e4), t3.relative = true), t3;
    });
  }, t2.NORMALIZE_HVZ = function(t3, r3, e4) {
    return void 0 === t3 && (t3 = true), void 0 === r3 && (r3 = true), void 0 === e4 && (e4 = true), u2(function(i2, a2, n3, o2, s2) {
      if (isNaN(o2) && !(i2.type & _.MOVE_TO))
        throw new Error("path must start with moveto");
      return r3 && i2.type & _.HORIZ_LINE_TO && (i2.type = _.LINE_TO, i2.y = i2.relative ? 0 : n3), e4 && i2.type & _.VERT_LINE_TO && (i2.type = _.LINE_TO, i2.x = i2.relative ? 0 : a2), t3 && i2.type & _.CLOSE_PATH && (i2.type = _.LINE_TO, i2.x = i2.relative ? o2 - a2 : o2, i2.y = i2.relative ? s2 - n3 : s2), i2.type & _.ARC && (0 === i2.rX || 0 === i2.rY) && (i2.type = _.LINE_TO, delete i2.rX, delete i2.rY, delete i2.xRot, delete i2.lArcFlag, delete i2.sweepFlag), i2;
    });
  }, t2.NORMALIZE_ST = e3, t2.QT_TO_C = n2, t2.INFO = u2, t2.SANITIZE = function(t3) {
    void 0 === t3 && (t3 = 0), a$1(t3);
    var r3 = NaN, e4 = NaN, i2 = NaN, n3 = NaN;
    return u2(function(a2, o2, s2, u3, h2) {
      var c2 = Math.abs, y2 = false, p2 = 0, m2 = 0;
      if (a2.type & _.SMOOTH_CURVE_TO && (p2 = isNaN(r3) ? 0 : o2 - r3, m2 = isNaN(e4) ? 0 : s2 - e4), a2.type & (_.CURVE_TO | _.SMOOTH_CURVE_TO) ? (r3 = a2.relative ? o2 + a2.x2 : a2.x2, e4 = a2.relative ? s2 + a2.y2 : a2.y2) : (r3 = NaN, e4 = NaN), a2.type & _.SMOOTH_QUAD_TO ? (i2 = isNaN(i2) ? o2 : 2 * o2 - i2, n3 = isNaN(n3) ? s2 : 2 * s2 - n3) : a2.type & _.QUAD_TO ? (i2 = a2.relative ? o2 + a2.x1 : a2.x1, n3 = a2.relative ? s2 + a2.y1 : a2.y2) : (i2 = NaN, n3 = NaN), a2.type & _.LINE_COMMANDS || a2.type & _.ARC && (0 === a2.rX || 0 === a2.rY || !a2.lArcFlag) || a2.type & _.CURVE_TO || a2.type & _.SMOOTH_CURVE_TO || a2.type & _.QUAD_TO || a2.type & _.SMOOTH_QUAD_TO) {
        var O3 = void 0 === a2.x ? 0 : a2.relative ? a2.x : a2.x - o2, l3 = void 0 === a2.y ? 0 : a2.relative ? a2.y : a2.y - s2;
        p2 = isNaN(i2) ? void 0 === a2.x1 ? p2 : a2.relative ? a2.x : a2.x1 - o2 : i2 - o2, m2 = isNaN(n3) ? void 0 === a2.y1 ? m2 : a2.relative ? a2.y : a2.y1 - s2 : n3 - s2;
        var T2 = void 0 === a2.x2 ? 0 : a2.relative ? a2.x : a2.x2 - o2, v2 = void 0 === a2.y2 ? 0 : a2.relative ? a2.y : a2.y2 - s2;
        c2(O3) <= t3 && c2(l3) <= t3 && c2(p2) <= t3 && c2(m2) <= t3 && c2(T2) <= t3 && c2(v2) <= t3 && (y2 = true);
      }
      return a2.type & _.CLOSE_PATH && c2(o2 - u3) <= t3 && c2(s2 - h2) <= t3 && (y2 = true), y2 ? [] : a2;
    });
  }, t2.MATRIX = O2, t2.ROTATE = function(t3, r3, e4) {
    void 0 === r3 && (r3 = 0), void 0 === e4 && (e4 = 0), a$1(t3, r3, e4);
    var i2 = Math.sin(t3), n3 = Math.cos(t3);
    return O2(n3, i2, -i2, n3, r3 - r3 * n3 + e4 * i2, e4 - r3 * i2 - e4 * n3);
  }, t2.TRANSLATE = function(t3, r3) {
    return void 0 === r3 && (r3 = 0), a$1(t3, r3), O2(1, 0, 0, 1, t3, r3);
  }, t2.SCALE = function(t3, r3) {
    return void 0 === r3 && (r3 = t3), a$1(t3, r3), O2(t3, 0, 0, r3, 0, 0);
  }, t2.SKEW_X = function(t3) {
    return a$1(t3), O2(1, 0, Math.atan(t3), 1, 0, 0);
  }, t2.SKEW_Y = function(t3) {
    return a$1(t3), O2(1, Math.atan(t3), 0, 1, 0, 0);
  }, t2.X_AXIS_SYMMETRY = function(t3) {
    return void 0 === t3 && (t3 = 0), a$1(t3), O2(-1, 0, 0, 1, t3, 0);
  }, t2.Y_AXIS_SYMMETRY = function(t3) {
    return void 0 === t3 && (t3 = 0), a$1(t3), O2(1, 0, 0, -1, 0, t3);
  }, t2.A_TO_C = function() {
    return u2(function(t3, r3, e4) {
      return _.ARC === t3.type ? function(t4, r4, e6) {
        var a2, n3, s2, u3;
        t4.cX || o(t4, r4, e6);
        for (var y2 = Math.min(t4.phi1, t4.phi2), p2 = Math.max(t4.phi1, t4.phi2) - y2, m2 = Math.ceil(p2 / 90), O3 = new Array(m2), l3 = r4, T2 = e6, v2 = 0; v2 < m2; v2++) {
          var f2 = c$2(t4.phi1, t4.phi2, v2 / m2), N2 = c$2(t4.phi1, t4.phi2, (v2 + 1) / m2), x2 = N2 - f2, d = 4 / 3 * Math.tan(x2 * h / 4), E = [Math.cos(f2 * h) - d * Math.sin(f2 * h), Math.sin(f2 * h) + d * Math.cos(f2 * h)], A = E[0], C = E[1], M = [Math.cos(N2 * h), Math.sin(N2 * h)], R = M[0], g = M[1], I = [R + d * Math.sin(N2 * h), g - d * Math.cos(N2 * h)], S = I[0], L = I[1];
          O3[v2] = { relative: t4.relative, type: _.CURVE_TO };
          var H = function(r5, e7) {
            var a3 = i([r5 * t4.rX, e7 * t4.rY], t4.xRot), n4 = a3[0], o2 = a3[1];
            return [t4.cX + n4, t4.cY + o2];
          };
          a2 = H(A, C), O3[v2].x1 = a2[0], O3[v2].y1 = a2[1], n3 = H(S, L), O3[v2].x2 = n3[0], O3[v2].y2 = n3[1], s2 = H(R, g), O3[v2].x = s2[0], O3[v2].y = s2[1], t4.relative && (O3[v2].x1 -= l3, O3[v2].y1 -= T2, O3[v2].x2 -= l3, O3[v2].y2 -= T2, O3[v2].x -= l3, O3[v2].y -= T2), l3 = (u3 = [O3[v2].x, O3[v2].y])[0], T2 = u3[1];
        }
        return O3;
      }(t3, t3.relative ? 0 : r3, t3.relative ? 0 : e4) : t3;
    });
  }, t2.ANNOTATE_ARCS = function() {
    return u2(function(t3, r3, e4) {
      return t3.relative && (r3 = 0, e4 = 0), _.ARC === t3.type && o(t3, r3, e4), t3;
    });
  }, t2.CLONE = l2, t2.CALCULATE_BOUNDS = function() {
    var t3 = function(t4) {
      var r3 = {};
      for (var e4 in t4)
        r3[e4] = t4[e4];
      return r3;
    }, i2 = r2(), a2 = n2(), h2 = e3(), c2 = u2(function(r3, e4, n3) {
      var u3 = h2(a2(i2(t3(r3))));
      function O3(t4) {
        t4 > c2.maxX && (c2.maxX = t4), t4 < c2.minX && (c2.minX = t4);
      }
      function l3(t4) {
        t4 > c2.maxY && (c2.maxY = t4), t4 < c2.minY && (c2.minY = t4);
      }
      if (u3.type & _.DRAWING_COMMANDS && (O3(e4), l3(n3)), u3.type & _.HORIZ_LINE_TO && O3(u3.x), u3.type & _.VERT_LINE_TO && l3(u3.y), u3.type & _.LINE_TO && (O3(u3.x), l3(u3.y)), u3.type & _.CURVE_TO) {
        O3(u3.x), l3(u3.y);
        for (var T2 = 0, v2 = p(e4, u3.x1, u3.x2, u3.x); T2 < v2.length; T2++) {
          0 < (w = v2[T2]) && 1 > w && O3(m$2(e4, u3.x1, u3.x2, u3.x, w));
        }
        for (var f2 = 0, N2 = p(n3, u3.y1, u3.y2, u3.y); f2 < N2.length; f2++) {
          0 < (w = N2[f2]) && 1 > w && l3(m$2(n3, u3.y1, u3.y2, u3.y, w));
        }
      }
      if (u3.type & _.ARC) {
        O3(u3.x), l3(u3.y), o(u3, e4, n3);
        for (var x2 = u3.xRot / 180 * Math.PI, d = Math.cos(x2) * u3.rX, E = Math.sin(x2) * u3.rX, A = -Math.sin(x2) * u3.rY, C = Math.cos(x2) * u3.rY, M = u3.phi1 < u3.phi2 ? [u3.phi1, u3.phi2] : -180 > u3.phi2 ? [u3.phi2 + 360, u3.phi1 + 360] : [u3.phi2, u3.phi1], R = M[0], g = M[1], I = function(t4) {
          var r4 = t4[0], e6 = t4[1], i3 = 180 * Math.atan2(e6, r4) / Math.PI;
          return i3 < R ? i3 + 360 : i3;
        }, S = 0, L = s(A, -d, 0).map(I); S < L.length; S++) {
          (w = L[S]) > R && w < g && O3(y$3(u3.cX, d, A, w));
        }
        for (var H = 0, U = s(C, -E, 0).map(I); H < U.length; H++) {
          var w;
          (w = U[H]) > R && w < g && l3(y$3(u3.cY, E, C, w));
        }
      }
      return r3;
    });
    return c2.minX = 1 / 0, c2.maxX = -1 / 0, c2.minY = 1 / 0, c2.maxY = -1 / 0, c2;
  };
}(u || (u = {}));
var O, l = function() {
  function t2() {
  }
  return t2.prototype.round = function(t3) {
    return this.transform(u.ROUND(t3));
  }, t2.prototype.toAbs = function() {
    return this.transform(u.TO_ABS());
  }, t2.prototype.toRel = function() {
    return this.transform(u.TO_REL());
  }, t2.prototype.normalizeHVZ = function(t3, r2, e3) {
    return this.transform(u.NORMALIZE_HVZ(t3, r2, e3));
  }, t2.prototype.normalizeST = function() {
    return this.transform(u.NORMALIZE_ST());
  }, t2.prototype.qtToC = function() {
    return this.transform(u.QT_TO_C());
  }, t2.prototype.aToC = function() {
    return this.transform(u.A_TO_C());
  }, t2.prototype.sanitize = function(t3) {
    return this.transform(u.SANITIZE(t3));
  }, t2.prototype.translate = function(t3, r2) {
    return this.transform(u.TRANSLATE(t3, r2));
  }, t2.prototype.scale = function(t3, r2) {
    return this.transform(u.SCALE(t3, r2));
  }, t2.prototype.rotate = function(t3, r2, e3) {
    return this.transform(u.ROTATE(t3, r2, e3));
  }, t2.prototype.matrix = function(t3, r2, e3, i2, a2, n2) {
    return this.transform(u.MATRIX(t3, r2, e3, i2, a2, n2));
  }, t2.prototype.skewX = function(t3) {
    return this.transform(u.SKEW_X(t3));
  }, t2.prototype.skewY = function(t3) {
    return this.transform(u.SKEW_Y(t3));
  }, t2.prototype.xSymmetry = function(t3) {
    return this.transform(u.X_AXIS_SYMMETRY(t3));
  }, t2.prototype.ySymmetry = function(t3) {
    return this.transform(u.Y_AXIS_SYMMETRY(t3));
  }, t2.prototype.annotateArcs = function() {
    return this.transform(u.ANNOTATE_ARCS());
  }, t2;
}(), T = function(t2) {
  return " " === t2 || "	" === t2 || "\r" === t2 || "\n" === t2;
}, v = function(t2) {
  return "0".charCodeAt(0) <= t2.charCodeAt(0) && t2.charCodeAt(0) <= "9".charCodeAt(0);
}, f = function(t2) {
  function e3() {
    var r2 = t2.call(this) || this;
    return r2.curNumber = "", r2.curCommandType = -1, r2.curCommandRelative = false, r2.canParseCommandOrComma = true, r2.curNumberHasExp = false, r2.curNumberHasExpDigits = false, r2.curNumberHasDecimal = false, r2.curArgs = [], r2;
  }
  return r(e3, t2), e3.prototype.finish = function(t3) {
    if (void 0 === t3 && (t3 = []), this.parse(" ", t3), 0 !== this.curArgs.length || !this.canParseCommandOrComma)
      throw new SyntaxError("Unterminated command at the path end.");
    return t3;
  }, e3.prototype.parse = function(t3, r2) {
    var e4 = this;
    void 0 === r2 && (r2 = []);
    for (var i2 = function(t4) {
      r2.push(t4), e4.curArgs.length = 0, e4.canParseCommandOrComma = true;
    }, a2 = 0; a2 < t3.length; a2++) {
      var n2 = t3[a2], o2 = !(this.curCommandType !== _.ARC || 3 !== this.curArgs.length && 4 !== this.curArgs.length || 1 !== this.curNumber.length || "0" !== this.curNumber && "1" !== this.curNumber), s2 = v(n2) && ("0" === this.curNumber && "0" === n2 || o2);
      if (!v(n2) || s2)
        if ("e" !== n2 && "E" !== n2)
          if ("-" !== n2 && "+" !== n2 || !this.curNumberHasExp || this.curNumberHasExpDigits)
            if ("." !== n2 || this.curNumberHasExp || this.curNumberHasDecimal || o2) {
              if (this.curNumber && -1 !== this.curCommandType) {
                var u2 = Number(this.curNumber);
                if (isNaN(u2))
                  throw new SyntaxError("Invalid number ending at " + a2);
                if (this.curCommandType === _.ARC) {
                  if (0 === this.curArgs.length || 1 === this.curArgs.length) {
                    if (0 > u2)
                      throw new SyntaxError('Expected positive number, got "' + u2 + '" at index "' + a2 + '"');
                  } else if ((3 === this.curArgs.length || 4 === this.curArgs.length) && "0" !== this.curNumber && "1" !== this.curNumber)
                    throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + a2 + '"');
                }
                this.curArgs.push(u2), this.curArgs.length === N[this.curCommandType] && (_.HORIZ_LINE_TO === this.curCommandType ? i2({ type: _.HORIZ_LINE_TO, relative: this.curCommandRelative, x: u2 }) : _.VERT_LINE_TO === this.curCommandType ? i2({ type: _.VERT_LINE_TO, relative: this.curCommandRelative, y: u2 }) : this.curCommandType === _.MOVE_TO || this.curCommandType === _.LINE_TO || this.curCommandType === _.SMOOTH_QUAD_TO ? (i2({ type: this.curCommandType, relative: this.curCommandRelative, x: this.curArgs[0], y: this.curArgs[1] }), _.MOVE_TO === this.curCommandType && (this.curCommandType = _.LINE_TO)) : this.curCommandType === _.CURVE_TO ? i2({ type: _.CURVE_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x2: this.curArgs[2], y2: this.curArgs[3], x: this.curArgs[4], y: this.curArgs[5] }) : this.curCommandType === _.SMOOTH_CURVE_TO ? i2({ type: _.SMOOTH_CURVE_TO, relative: this.curCommandRelative, x2: this.curArgs[0], y2: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === _.QUAD_TO ? i2({ type: _.QUAD_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === _.ARC && i2({ type: _.ARC, relative: this.curCommandRelative, rX: this.curArgs[0], rY: this.curArgs[1], xRot: this.curArgs[2], lArcFlag: this.curArgs[3], sweepFlag: this.curArgs[4], x: this.curArgs[5], y: this.curArgs[6] })), this.curNumber = "", this.curNumberHasExpDigits = false, this.curNumberHasExp = false, this.curNumberHasDecimal = false, this.canParseCommandOrComma = true;
              }
              if (!T(n2))
                if ("," === n2 && this.canParseCommandOrComma)
                  this.canParseCommandOrComma = false;
                else if ("+" !== n2 && "-" !== n2 && "." !== n2)
                  if (s2)
                    this.curNumber = n2, this.curNumberHasDecimal = false;
                  else {
                    if (0 !== this.curArgs.length)
                      throw new SyntaxError("Unterminated command at index " + a2 + ".");
                    if (!this.canParseCommandOrComma)
                      throw new SyntaxError('Unexpected character "' + n2 + '" at index ' + a2 + ". Command cannot follow comma");
                    if (this.canParseCommandOrComma = false, "z" !== n2 && "Z" !== n2)
                      if ("h" === n2 || "H" === n2)
                        this.curCommandType = _.HORIZ_LINE_TO, this.curCommandRelative = "h" === n2;
                      else if ("v" === n2 || "V" === n2)
                        this.curCommandType = _.VERT_LINE_TO, this.curCommandRelative = "v" === n2;
                      else if ("m" === n2 || "M" === n2)
                        this.curCommandType = _.MOVE_TO, this.curCommandRelative = "m" === n2;
                      else if ("l" === n2 || "L" === n2)
                        this.curCommandType = _.LINE_TO, this.curCommandRelative = "l" === n2;
                      else if ("c" === n2 || "C" === n2)
                        this.curCommandType = _.CURVE_TO, this.curCommandRelative = "c" === n2;
                      else if ("s" === n2 || "S" === n2)
                        this.curCommandType = _.SMOOTH_CURVE_TO, this.curCommandRelative = "s" === n2;
                      else if ("q" === n2 || "Q" === n2)
                        this.curCommandType = _.QUAD_TO, this.curCommandRelative = "q" === n2;
                      else if ("t" === n2 || "T" === n2)
                        this.curCommandType = _.SMOOTH_QUAD_TO, this.curCommandRelative = "t" === n2;
                      else {
                        if ("a" !== n2 && "A" !== n2)
                          throw new SyntaxError('Unexpected character "' + n2 + '" at index ' + a2 + ".");
                        this.curCommandType = _.ARC, this.curCommandRelative = "a" === n2;
                      }
                    else
                      r2.push({ type: _.CLOSE_PATH }), this.canParseCommandOrComma = true, this.curCommandType = -1;
                  }
                else
                  this.curNumber = n2, this.curNumberHasDecimal = "." === n2;
            } else
              this.curNumber += n2, this.curNumberHasDecimal = true;
          else
            this.curNumber += n2;
        else
          this.curNumber += n2, this.curNumberHasExp = true;
      else
        this.curNumber += n2, this.curNumberHasExpDigits = this.curNumberHasExp;
    }
    return r2;
  }, e3.prototype.transform = function(t3) {
    return Object.create(this, { parse: { value: function(r2, e4) {
      void 0 === e4 && (e4 = []);
      for (var i2 = 0, a2 = Object.getPrototypeOf(this).parse.call(this, r2); i2 < a2.length; i2++) {
        var n2 = a2[i2], o2 = t3(n2);
        Array.isArray(o2) ? e4.push.apply(e4, o2) : e4.push(o2);
      }
      return e4;
    } } });
  }, e3;
}(l), _ = function(t2) {
  function i2(r2) {
    var e3 = t2.call(this) || this;
    return e3.commands = "string" == typeof r2 ? i2.parse(r2) : r2, e3;
  }
  return r(i2, t2), i2.prototype.encode = function() {
    return i2.encode(this.commands);
  }, i2.prototype.getBounds = function() {
    var t3 = u.CALCULATE_BOUNDS();
    return this.transform(t3), t3;
  }, i2.prototype.transform = function(t3) {
    for (var r2 = [], e3 = 0, i3 = this.commands; e3 < i3.length; e3++) {
      var a2 = t3(i3[e3]);
      Array.isArray(a2) ? r2.push.apply(r2, a2) : r2.push(a2);
    }
    return this.commands = r2, this;
  }, i2.encode = function(t3) {
    return e(t3);
  }, i2.parse = function(t3) {
    var r2 = new f(), e3 = [];
    return r2.parse(t3, e3), r2.finish(e3), e3;
  }, i2.CLOSE_PATH = 1, i2.MOVE_TO = 2, i2.HORIZ_LINE_TO = 4, i2.VERT_LINE_TO = 8, i2.LINE_TO = 16, i2.CURVE_TO = 32, i2.SMOOTH_CURVE_TO = 64, i2.QUAD_TO = 128, i2.SMOOTH_QUAD_TO = 256, i2.ARC = 512, i2.LINE_COMMANDS = i2.LINE_TO | i2.HORIZ_LINE_TO | i2.VERT_LINE_TO, i2.DRAWING_COMMANDS = i2.HORIZ_LINE_TO | i2.VERT_LINE_TO | i2.LINE_TO | i2.CURVE_TO | i2.SMOOTH_CURVE_TO | i2.QUAD_TO | i2.SMOOTH_QUAD_TO | i2.ARC, i2;
}(l), N = ((O = {})[_.MOVE_TO] = 2, O[_.LINE_TO] = 2, O[_.HORIZ_LINE_TO] = 1, O[_.VERT_LINE_TO] = 1, O[_.CLOSE_PATH] = 0, O[_.QUAD_TO] = 4, O[_.SMOOTH_QUAD_TO] = 2, O[_.CURVE_TO] = 6, O[_.SMOOTH_CURVE_TO] = 4, O[_.ARC] = 7, O);
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var mulTable = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259];
var shgTable = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
function getImageDataFromCanvas(canvas, topX, topY, width, height) {
  if (typeof canvas === "string") {
    canvas = document.getElementById(canvas);
  }
  if (!canvas || _typeof(canvas) !== "object" || !("getContext" in canvas)) {
    throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
  }
  var context = canvas.getContext("2d");
  try {
    return context.getImageData(topX, topY, width, height);
  } catch (e3) {
    throw new Error("unable to access image data: " + e3);
  }
}
function processCanvasRGBA(canvas, topX, topY, width, height, radius) {
  if (isNaN(radius) || radius < 1) {
    return;
  }
  radius |= 0;
  var imageData = getImageDataFromCanvas(canvas, topX, topY, width, height);
  imageData = processImageDataRGBA(imageData, topX, topY, width, height, radius);
  canvas.getContext("2d").putImageData(imageData, topX, topY);
}
function processImageDataRGBA(imageData, topX, topY, width, height, radius) {
  var pixels = imageData.data;
  var div = 2 * radius + 1;
  var widthMinus1 = width - 1;
  var heightMinus1 = height - 1;
  var radiusPlus1 = radius + 1;
  var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;
  var stackStart = new BlurStack();
  var stack = stackStart;
  var stackEnd;
  for (var i2 = 1; i2 < div; i2++) {
    stack = stack.next = new BlurStack();
    if (i2 === radiusPlus1) {
      stackEnd = stack;
    }
  }
  stack.next = stackStart;
  var stackIn = null, stackOut = null, yw = 0, yi = 0;
  var mulSum = mulTable[radius];
  var shgSum = shgTable[radius];
  for (var y2 = 0; y2 < height; y2++) {
    stack = stackStart;
    var pr = pixels[yi], pg = pixels[yi + 1], pb = pixels[yi + 2], pa = pixels[yi + 3];
    for (var _i = 0; _i < radiusPlus1; _i++) {
      stack.r = pr;
      stack.g = pg;
      stack.b = pb;
      stack.a = pa;
      stack = stack.next;
    }
    var rInSum = 0, gInSum = 0, bInSum = 0, aInSum = 0, rOutSum = radiusPlus1 * pr, gOutSum = radiusPlus1 * pg, bOutSum = radiusPlus1 * pb, aOutSum = radiusPlus1 * pa, rSum = sumFactor * pr, gSum = sumFactor * pg, bSum = sumFactor * pb, aSum = sumFactor * pa;
    for (var _i2 = 1; _i2 < radiusPlus1; _i2++) {
      var p2 = yi + ((widthMinus1 < _i2 ? widthMinus1 : _i2) << 2);
      var r2 = pixels[p2], g = pixels[p2 + 1], b = pixels[p2 + 2], a2 = pixels[p2 + 3];
      var rbs = radiusPlus1 - _i2;
      rSum += (stack.r = r2) * rbs;
      gSum += (stack.g = g) * rbs;
      bSum += (stack.b = b) * rbs;
      aSum += (stack.a = a2) * rbs;
      rInSum += r2;
      gInSum += g;
      bInSum += b;
      aInSum += a2;
      stack = stack.next;
    }
    stackIn = stackStart;
    stackOut = stackEnd;
    for (var x2 = 0; x2 < width; x2++) {
      var paInitial = aSum * mulSum >> shgSum;
      pixels[yi + 3] = paInitial;
      if (paInitial !== 0) {
        var _a2 = 255 / paInitial;
        pixels[yi] = (rSum * mulSum >> shgSum) * _a2;
        pixels[yi + 1] = (gSum * mulSum >> shgSum) * _a2;
        pixels[yi + 2] = (bSum * mulSum >> shgSum) * _a2;
      } else {
        pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
      }
      rSum -= rOutSum;
      gSum -= gOutSum;
      bSum -= bOutSum;
      aSum -= aOutSum;
      rOutSum -= stackIn.r;
      gOutSum -= stackIn.g;
      bOutSum -= stackIn.b;
      aOutSum -= stackIn.a;
      var _p = x2 + radius + 1;
      _p = yw + (_p < widthMinus1 ? _p : widthMinus1) << 2;
      rInSum += stackIn.r = pixels[_p];
      gInSum += stackIn.g = pixels[_p + 1];
      bInSum += stackIn.b = pixels[_p + 2];
      aInSum += stackIn.a = pixels[_p + 3];
      rSum += rInSum;
      gSum += gInSum;
      bSum += bInSum;
      aSum += aInSum;
      stackIn = stackIn.next;
      var _stackOut = stackOut, _r = _stackOut.r, _g = _stackOut.g, _b = _stackOut.b, _a3 = _stackOut.a;
      rOutSum += _r;
      gOutSum += _g;
      bOutSum += _b;
      aOutSum += _a3;
      rInSum -= _r;
      gInSum -= _g;
      bInSum -= _b;
      aInSum -= _a3;
      stackOut = stackOut.next;
      yi += 4;
    }
    yw += width;
  }
  for (var _x = 0; _x < width; _x++) {
    yi = _x << 2;
    var _pr = pixels[yi], _pg = pixels[yi + 1], _pb = pixels[yi + 2], _pa = pixels[yi + 3], _rOutSum = radiusPlus1 * _pr, _gOutSum = radiusPlus1 * _pg, _bOutSum = radiusPlus1 * _pb, _aOutSum = radiusPlus1 * _pa, _rSum = sumFactor * _pr, _gSum = sumFactor * _pg, _bSum = sumFactor * _pb, _aSum = sumFactor * _pa;
    stack = stackStart;
    for (var _i3 = 0; _i3 < radiusPlus1; _i3++) {
      stack.r = _pr;
      stack.g = _pg;
      stack.b = _pb;
      stack.a = _pa;
      stack = stack.next;
    }
    var yp = width;
    var _gInSum = 0, _bInSum = 0, _aInSum = 0, _rInSum = 0;
    for (var _i4 = 1; _i4 <= radius; _i4++) {
      yi = yp + _x << 2;
      var _rbs = radiusPlus1 - _i4;
      _rSum += (stack.r = _pr = pixels[yi]) * _rbs;
      _gSum += (stack.g = _pg = pixels[yi + 1]) * _rbs;
      _bSum += (stack.b = _pb = pixels[yi + 2]) * _rbs;
      _aSum += (stack.a = _pa = pixels[yi + 3]) * _rbs;
      _rInSum += _pr;
      _gInSum += _pg;
      _bInSum += _pb;
      _aInSum += _pa;
      stack = stack.next;
      if (_i4 < heightMinus1) {
        yp += width;
      }
    }
    yi = _x;
    stackIn = stackStart;
    stackOut = stackEnd;
    for (var _y = 0; _y < height; _y++) {
      var _p2 = yi << 2;
      pixels[_p2 + 3] = _pa = _aSum * mulSum >> shgSum;
      if (_pa > 0) {
        _pa = 255 / _pa;
        pixels[_p2] = (_rSum * mulSum >> shgSum) * _pa;
        pixels[_p2 + 1] = (_gSum * mulSum >> shgSum) * _pa;
        pixels[_p2 + 2] = (_bSum * mulSum >> shgSum) * _pa;
      } else {
        pixels[_p2] = pixels[_p2 + 1] = pixels[_p2 + 2] = 0;
      }
      _rSum -= _rOutSum;
      _gSum -= _gOutSum;
      _bSum -= _bOutSum;
      _aSum -= _aOutSum;
      _rOutSum -= stackIn.r;
      _gOutSum -= stackIn.g;
      _bOutSum -= stackIn.b;
      _aOutSum -= stackIn.a;
      _p2 = _x + ((_p2 = _y + radiusPlus1) < heightMinus1 ? _p2 : heightMinus1) * width << 2;
      _rSum += _rInSum += stackIn.r = pixels[_p2];
      _gSum += _gInSum += stackIn.g = pixels[_p2 + 1];
      _bSum += _bInSum += stackIn.b = pixels[_p2 + 2];
      _aSum += _aInSum += stackIn.a = pixels[_p2 + 3];
      stackIn = stackIn.next;
      _rOutSum += _pr = stackOut.r;
      _gOutSum += _pg = stackOut.g;
      _bOutSum += _pb = stackOut.b;
      _aOutSum += _pa = stackOut.a;
      _rInSum -= _pr;
      _gInSum -= _pg;
      _bInSum -= _pb;
      _aInSum -= _pa;
      stackOut = stackOut.next;
      yi += width;
    }
  }
  return imageData;
}
var BlurStack = (
  /**
   * Set properties.
   */
  function BlurStack2() {
    _classCallCheck(this, BlurStack2);
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
  }
);
function compressSpaces(str) {
  return str.replace(/(?!\u3000)\s+/gm, " ");
}
function trimLeft(str) {
  return str.replace(/^[\n \t]+/, "");
}
function trimRight(str) {
  return str.replace(/[\n \t]+$/, "");
}
function toNumbers(str) {
  const matches = str.match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm);
  return matches ? matches.map(parseFloat) : [];
}
function toMatrixValue(str) {
  const numbers = toNumbers(str);
  const matrix = [
    numbers[0] || 0,
    numbers[1] || 0,
    numbers[2] || 0,
    numbers[3] || 0,
    numbers[4] || 0,
    numbers[5] || 0
  ];
  return matrix;
}
const allUppercase = /^[A-Z-]+$/;
function normalizeAttributeName(name) {
  if (allUppercase.test(name)) {
    return name.toLowerCase();
  }
  return name;
}
function parseExternalUrl(url) {
  const urlMatch = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(url);
  if (!urlMatch) {
    return "";
  }
  return urlMatch[2] || urlMatch[3] || urlMatch[4] || "";
}
function normalizeColor(color2) {
  if (!color2.startsWith("rgb")) {
    return color2;
  }
  let rgbParts = 3;
  const normalizedColor = color2.replace(
    /\d+(\.\d+)?/g,
    (num, isFloat) => rgbParts-- && isFloat ? String(Math.round(parseFloat(num))) : num
  );
  return normalizedColor;
}
const attributeRegex = /(\[[^\]]+\])/g;
const idRegex = /(#[^\s+>~.[:]+)/g;
const classRegex = /(\.[^\s+>~.[:]+)/g;
const pseudoElementRegex = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi;
const pseudoClassWithBracketsRegex = /(:[\w-]+\([^)]*\))/gi;
const pseudoClassRegex = /(:[^\s+>~.[:]+)/g;
const elementRegex = /([^\s+>~.[:]+)/g;
function findSelectorMatch(selector, regex) {
  const matches = regex.exec(selector);
  if (!matches) {
    return [
      selector,
      0
    ];
  }
  return [
    selector.replace(regex, " "),
    matches.length
  ];
}
function getSelectorSpecificity(selector) {
  const specificity = [
    0,
    0,
    0
  ];
  let currentSelector = selector.replace(/:not\(([^)]*)\)/g, "     $1 ").replace(/{[\s\S]*/gm, " ");
  let delta = 0;
  [currentSelector, delta] = findSelectorMatch(currentSelector, attributeRegex);
  specificity[1] += delta;
  [currentSelector, delta] = findSelectorMatch(currentSelector, idRegex);
  specificity[0] += delta;
  [currentSelector, delta] = findSelectorMatch(currentSelector, classRegex);
  specificity[1] += delta;
  [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoElementRegex);
  specificity[2] += delta;
  [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoClassWithBracketsRegex);
  specificity[1] += delta;
  [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoClassRegex);
  specificity[1] += delta;
  currentSelector = currentSelector.replace(/[*\s+>~]/g, " ").replace(/[#.]/g, " ");
  [currentSelector, delta] = findSelectorMatch(currentSelector, elementRegex);
  specificity[2] += delta;
  return specificity.join("");
}
const PSEUDO_ZERO = 1e-8;
function vectorMagnitude(v2) {
  return Math.sqrt(Math.pow(v2[0], 2) + Math.pow(v2[1], 2));
}
function vectorsRatio(u2, v2) {
  return (u2[0] * v2[0] + u2[1] * v2[1]) / (vectorMagnitude(u2) * vectorMagnitude(v2));
}
function vectorsAngle(u2, v2) {
  return (u2[0] * v2[1] < u2[1] * v2[0] ? -1 : 1) * Math.acos(vectorsRatio(u2, v2));
}
function CB1(t2) {
  return t2 * t2 * t2;
}
function CB2(t2) {
  return 3 * t2 * t2 * (1 - t2);
}
function CB3(t2) {
  return 3 * t2 * (1 - t2) * (1 - t2);
}
function CB4(t2) {
  return (1 - t2) * (1 - t2) * (1 - t2);
}
function QB1(t2) {
  return t2 * t2;
}
function QB2(t2) {
  return 2 * t2 * (1 - t2);
}
function QB3(t2) {
  return (1 - t2) * (1 - t2);
}
class Property {
  static empty(document2) {
    return new Property(document2, "EMPTY", "");
  }
  split() {
    let separator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ";
    const { document: document2, name } = this;
    return compressSpaces(this.getString()).trim().split(separator).map(
      (value) => new Property(document2, name, value)
    );
  }
  hasValue(zeroIsValue) {
    const value = this.value;
    return value !== null && value !== "" && (zeroIsValue || value !== 0) && typeof value !== "undefined";
  }
  isString(regexp) {
    const { value } = this;
    const result = typeof value === "string";
    if (!result || !regexp) {
      return result;
    }
    return regexp.test(value);
  }
  isUrlDefinition() {
    return this.isString(/^url\(/);
  }
  isPixels() {
    if (!this.hasValue()) {
      return false;
    }
    const asString = this.getString();
    switch (true) {
      case asString.endsWith("px"):
      case /^[0-9]+$/.test(asString):
        return true;
      default:
        return false;
    }
  }
  setValue(value) {
    this.value = value;
    return this;
  }
  getValue(def) {
    if (typeof def === "undefined" || this.hasValue()) {
      return this.value;
    }
    return def;
  }
  getNumber(def) {
    if (!this.hasValue()) {
      if (typeof def === "undefined") {
        return 0;
      }
      return parseFloat(def);
    }
    const { value } = this;
    let n2 = parseFloat(value);
    if (this.isString(/%$/)) {
      n2 /= 100;
    }
    return n2;
  }
  getString(def) {
    if (typeof def === "undefined" || this.hasValue()) {
      return typeof this.value === "undefined" ? "" : String(this.value);
    }
    return String(def);
  }
  getColor(def) {
    let color2 = this.getString(def);
    if (this.isNormalizedColor) {
      return color2;
    }
    this.isNormalizedColor = true;
    color2 = normalizeColor(color2);
    this.value = color2;
    return color2;
  }
  getDpi() {
    return 96;
  }
  getRem() {
    return this.document.rootEmSize;
  }
  getEm() {
    return this.document.emSize;
  }
  getUnits() {
    return this.getString().replace(/[0-9.-]/g, "");
  }
  getPixels(axisOrIsFontSize) {
    let processPercent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!this.hasValue()) {
      return 0;
    }
    const [axis, isFontSize] = typeof axisOrIsFontSize === "boolean" ? [
      void 0,
      axisOrIsFontSize
    ] : [
      axisOrIsFontSize
    ];
    const { viewPort } = this.document.screen;
    switch (true) {
      case this.isString(/vmin$/):
        return this.getNumber() / 100 * Math.min(viewPort.computeSize("x"), viewPort.computeSize("y"));
      case this.isString(/vmax$/):
        return this.getNumber() / 100 * Math.max(viewPort.computeSize("x"), viewPort.computeSize("y"));
      case this.isString(/vw$/):
        return this.getNumber() / 100 * viewPort.computeSize("x");
      case this.isString(/vh$/):
        return this.getNumber() / 100 * viewPort.computeSize("y");
      case this.isString(/rem$/):
        return this.getNumber() * this.getRem();
      case this.isString(/em$/):
        return this.getNumber() * this.getEm();
      case this.isString(/ex$/):
        return this.getNumber() * this.getEm() / 2;
      case this.isString(/px$/):
        return this.getNumber();
      case this.isString(/pt$/):
        return this.getNumber() * this.getDpi() * (1 / 72);
      case this.isString(/pc$/):
        return this.getNumber() * 15;
      case this.isString(/cm$/):
        return this.getNumber() * this.getDpi() / 2.54;
      case this.isString(/mm$/):
        return this.getNumber() * this.getDpi() / 25.4;
      case this.isString(/in$/):
        return this.getNumber() * this.getDpi();
      case (this.isString(/%$/) && isFontSize):
        return this.getNumber() * this.getEm();
      case this.isString(/%$/):
        return this.getNumber() * viewPort.computeSize(axis);
      default: {
        const n2 = this.getNumber();
        if (processPercent && n2 < 1) {
          return n2 * viewPort.computeSize(axis);
        }
        return n2;
      }
    }
  }
  getMilliseconds() {
    if (!this.hasValue()) {
      return 0;
    }
    if (this.isString(/ms$/)) {
      return this.getNumber();
    }
    return this.getNumber() * 1e3;
  }
  getRadians() {
    if (!this.hasValue()) {
      return 0;
    }
    switch (true) {
      case this.isString(/deg$/):
        return this.getNumber() * (Math.PI / 180);
      case this.isString(/grad$/):
        return this.getNumber() * (Math.PI / 200);
      case this.isString(/rad$/):
        return this.getNumber();
      default:
        return this.getNumber() * (Math.PI / 180);
    }
  }
  getDefinition() {
    const asString = this.getString();
    const match2 = /#([^)'"]+)/.exec(asString);
    const name = (match2 === null || match2 === void 0 ? void 0 : match2[1]) || asString;
    return this.document.definitions[name];
  }
  getFillStyleDefinition(element2, opacity) {
    let def = this.getDefinition();
    if (!def) {
      return null;
    }
    if (typeof def.createGradient === "function" && "getBoundingBox" in element2) {
      return def.createGradient(this.document.ctx, element2, opacity);
    }
    if (typeof def.createPattern === "function") {
      if (def.getHrefAttribute().hasValue()) {
        const patternTransform = def.getAttribute("patternTransform");
        def = def.getHrefAttribute().getDefinition();
        if (def && patternTransform.hasValue()) {
          def.getAttribute("patternTransform", true).setValue(patternTransform.value);
        }
      }
      if (def) {
        return def.createPattern(this.document.ctx, element2, opacity);
      }
    }
    return null;
  }
  getTextBaseline() {
    if (!this.hasValue()) {
      return null;
    }
    const key = this.getString();
    return Property.textBaselineMapping[key] || null;
  }
  addOpacity(opacity) {
    let value = this.getColor();
    const len = value.length;
    let commas = 0;
    for (let i2 = 0; i2 < len; i2++) {
      if (value[i2] === ",") {
        commas++;
      }
      if (commas === 3) {
        break;
      }
    }
    if (opacity.hasValue() && this.isString() && commas !== 3) {
      const color2 = new RGBColor$1(value);
      if (color2.ok) {
        color2.alpha = opacity.getNumber();
        value = color2.toRGBA();
      }
    }
    return new Property(this.document, this.name, value);
  }
  constructor(document2, name, value) {
    this.document = document2;
    this.name = name;
    this.value = value;
    this.isNormalizedColor = false;
  }
}
Property.textBaselineMapping = {
  "baseline": "alphabetic",
  "before-edge": "top",
  "text-before-edge": "top",
  "middle": "middle",
  "central": "middle",
  "after-edge": "bottom",
  "text-after-edge": "bottom",
  "ideographic": "ideographic",
  "alphabetic": "alphabetic",
  "hanging": "hanging",
  "mathematical": "alphabetic"
};
class ViewPort {
  clear() {
    this.viewPorts = [];
  }
  setCurrent(width, height) {
    this.viewPorts.push({
      width,
      height
    });
  }
  removeCurrent() {
    this.viewPorts.pop();
  }
  getRoot() {
    const [root2] = this.viewPorts;
    if (!root2) {
      return getDefault();
    }
    return root2;
  }
  getCurrent() {
    const { viewPorts } = this;
    const current = viewPorts[viewPorts.length - 1];
    if (!current) {
      return getDefault();
    }
    return current;
  }
  get width() {
    return this.getCurrent().width;
  }
  get height() {
    return this.getCurrent().height;
  }
  computeSize(d) {
    if (typeof d === "number") {
      return d;
    }
    if (d === "x") {
      return this.width;
    }
    if (d === "y") {
      return this.height;
    }
    return Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
  }
  constructor() {
    this.viewPorts = [];
  }
}
ViewPort.DEFAULT_VIEWPORT_WIDTH = 800;
ViewPort.DEFAULT_VIEWPORT_HEIGHT = 600;
function getDefault() {
  return {
    width: ViewPort.DEFAULT_VIEWPORT_WIDTH,
    height: ViewPort.DEFAULT_VIEWPORT_HEIGHT
  };
}
let Point$2 = class Point {
  static parse(point2) {
    let defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const [x2 = defaultValue, y2 = defaultValue] = toNumbers(point2);
    return new Point(x2, y2);
  }
  static parseScale(scale) {
    let defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    const [x2 = defaultValue, y2 = x2] = toNumbers(scale);
    return new Point(x2, y2);
  }
  static parsePath(path) {
    const points = toNumbers(path);
    const len = points.length;
    const pathPoints = [];
    for (let i2 = 0; i2 < len; i2 += 2) {
      pathPoints.push(new Point(points[i2], points[i2 + 1]));
    }
    return pathPoints;
  }
  angleTo(point2) {
    return Math.atan2(point2.y - this.y, point2.x - this.x);
  }
  applyTransform(transform) {
    const { x: x2, y: y2 } = this;
    const xp = x2 * transform[0] + y2 * transform[2] + transform[4];
    const yp = x2 * transform[1] + y2 * transform[3] + transform[5];
    this.x = xp;
    this.y = yp;
  }
  constructor(x2, y2) {
    this.x = x2;
    this.y = y2;
  }
};
class Mouse {
  isWorking() {
    return this.working;
  }
  start() {
    if (this.working) {
      return;
    }
    const { screen, onClick, onMouseMove } = this;
    const canvas = screen.ctx.canvas;
    canvas.onclick = onClick;
    canvas.onmousemove = onMouseMove;
    this.working = true;
  }
  stop() {
    if (!this.working) {
      return;
    }
    const canvas = this.screen.ctx.canvas;
    this.working = false;
    canvas.onclick = null;
    canvas.onmousemove = null;
  }
  hasEvents() {
    return this.working && this.events.length > 0;
  }
  runEvents() {
    if (!this.working) {
      return;
    }
    const { screen: document2, events, eventElements } = this;
    const { style } = document2.ctx.canvas;
    let element2;
    if (style) {
      style.cursor = "";
    }
    events.forEach((param, i2) => {
      let { run: run2 } = param;
      element2 = eventElements[i2];
      while (element2) {
        run2(element2);
        element2 = element2.parent;
      }
    });
    this.events = [];
    this.eventElements = [];
  }
  checkPath(element2, ctx2) {
    if (!this.working || !ctx2) {
      return;
    }
    const { events, eventElements } = this;
    events.forEach((param, i2) => {
      let { x: x2, y: y2 } = param;
      if (!eventElements[i2] && ctx2.isPointInPath && ctx2.isPointInPath(x2, y2)) {
        eventElements[i2] = element2;
      }
    });
  }
  checkBoundingBox(element2, boundingBox) {
    if (!this.working || !boundingBox) {
      return;
    }
    const { events, eventElements } = this;
    events.forEach((param, i2) => {
      let { x: x2, y: y2 } = param;
      if (!eventElements[i2] && boundingBox.isPointInBox(x2, y2)) {
        eventElements[i2] = element2;
      }
    });
  }
  mapXY(x2, y2) {
    const { window: window2, ctx: ctx2 } = this.screen;
    const point2 = new Point$2(x2, y2);
    let element2 = ctx2.canvas;
    while (element2) {
      point2.x -= element2.offsetLeft;
      point2.y -= element2.offsetTop;
      element2 = element2.offsetParent;
    }
    if (window2 === null || window2 === void 0 ? void 0 : window2.scrollX) {
      point2.x += window2.scrollX;
    }
    if (window2 === null || window2 === void 0 ? void 0 : window2.scrollY) {
      point2.y += window2.scrollY;
    }
    return point2;
  }
  onClick(event) {
    const { x: x2, y: y2 } = this.mapXY(event.clientX, event.clientY);
    this.events.push({
      type: "onclick",
      x: x2,
      y: y2,
      run(eventTarget) {
        if (eventTarget.onClick) {
          eventTarget.onClick();
        }
      }
    });
  }
  onMouseMove(event) {
    const { x: x2, y: y2 } = this.mapXY(event.clientX, event.clientY);
    this.events.push({
      type: "onmousemove",
      x: x2,
      y: y2,
      run(eventTarget) {
        if (eventTarget.onMouseMove) {
          eventTarget.onMouseMove();
        }
      }
    });
  }
  constructor(screen) {
    this.screen = screen;
    this.working = false;
    this.events = [];
    this.eventElements = [];
    this.onClick = this.onClick.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
  }
}
const defaultWindow = typeof window !== "undefined" ? window : null;
const defaultFetch$1 = typeof fetch !== "undefined" ? fetch.bind(void 0) : void 0;
class Screen {
  wait(checker) {
    this.waits.push(checker);
  }
  ready() {
    if (!this.readyPromise) {
      return Promise.resolve();
    }
    return this.readyPromise;
  }
  isReady() {
    if (this.isReadyLock) {
      return true;
    }
    const isReadyLock = this.waits.every(
      (_2) => _2()
    );
    if (isReadyLock) {
      this.waits = [];
      if (this.resolveReady) {
        this.resolveReady();
      }
    }
    this.isReadyLock = isReadyLock;
    return isReadyLock;
  }
  setDefaults(ctx2) {
    ctx2.strokeStyle = "rgba(0,0,0,0)";
    ctx2.lineCap = "butt";
    ctx2.lineJoin = "miter";
    ctx2.miterLimit = 4;
  }
  setViewBox(param) {
    let { document: document2, ctx: ctx2, aspectRatio, width, desiredWidth, height, desiredHeight, minX = 0, minY = 0, refX, refY, clip = false, clipX = 0, clipY = 0 } = param;
    const cleanAspectRatio = compressSpaces(aspectRatio).replace(/^defer\s/, "");
    const [aspectRatioAlign, aspectRatioMeetOrSlice] = cleanAspectRatio.split(" ");
    const align = aspectRatioAlign || "xMidYMid";
    const meetOrSlice = aspectRatioMeetOrSlice || "meet";
    const scaleX = width / desiredWidth;
    const scaleY = height / desiredHeight;
    const scaleMin = Math.min(scaleX, scaleY);
    const scaleMax = Math.max(scaleX, scaleY);
    let finalDesiredWidth = desiredWidth;
    let finalDesiredHeight = desiredHeight;
    if (meetOrSlice === "meet") {
      finalDesiredWidth *= scaleMin;
      finalDesiredHeight *= scaleMin;
    }
    if (meetOrSlice === "slice") {
      finalDesiredWidth *= scaleMax;
      finalDesiredHeight *= scaleMax;
    }
    const refXProp = new Property(document2, "refX", refX);
    const refYProp = new Property(document2, "refY", refY);
    const hasRefs = refXProp.hasValue() && refYProp.hasValue();
    if (hasRefs) {
      ctx2.translate(-scaleMin * refXProp.getPixels("x"), -scaleMin * refYProp.getPixels("y"));
    }
    if (clip) {
      const scaledClipX = scaleMin * clipX;
      const scaledClipY = scaleMin * clipY;
      ctx2.beginPath();
      ctx2.moveTo(scaledClipX, scaledClipY);
      ctx2.lineTo(width, scaledClipY);
      ctx2.lineTo(width, height);
      ctx2.lineTo(scaledClipX, height);
      ctx2.closePath();
      ctx2.clip();
    }
    if (!hasRefs) {
      const isMeetMinY = meetOrSlice === "meet" && scaleMin === scaleY;
      const isSliceMaxY = meetOrSlice === "slice" && scaleMax === scaleY;
      const isMeetMinX = meetOrSlice === "meet" && scaleMin === scaleX;
      const isSliceMaxX = meetOrSlice === "slice" && scaleMax === scaleX;
      if (align.startsWith("xMid") && (isMeetMinY || isSliceMaxY)) {
        ctx2.translate(width / 2 - finalDesiredWidth / 2, 0);
      }
      if (align.endsWith("YMid") && (isMeetMinX || isSliceMaxX)) {
        ctx2.translate(0, height / 2 - finalDesiredHeight / 2);
      }
      if (align.startsWith("xMax") && (isMeetMinY || isSliceMaxY)) {
        ctx2.translate(width - finalDesiredWidth, 0);
      }
      if (align.endsWith("YMax") && (isMeetMinX || isSliceMaxX)) {
        ctx2.translate(0, height - finalDesiredHeight);
      }
    }
    switch (true) {
      case align === "none":
        ctx2.scale(scaleX, scaleY);
        break;
      case meetOrSlice === "meet":
        ctx2.scale(scaleMin, scaleMin);
        break;
      case meetOrSlice === "slice":
        ctx2.scale(scaleMax, scaleMax);
        break;
    }
    ctx2.translate(-minX, -minY);
  }
  start(element2) {
    let { enableRedraw = false, ignoreMouse = false, ignoreAnimation = false, ignoreDimensions = false, ignoreClear = false, forceRedraw, scaleWidth, scaleHeight, offsetX, offsetY } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { mouse } = this;
    const frameDuration = 1e3 / Screen.FRAMERATE;
    this.isReadyLock = false;
    this.frameDuration = frameDuration;
    this.readyPromise = new Promise((resolve) => {
      this.resolveReady = resolve;
    });
    if (this.isReady()) {
      this.render(element2, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);
    }
    if (!enableRedraw) {
      return;
    }
    let now2 = Date.now();
    let then = now2;
    let delta = 0;
    const tick2 = () => {
      now2 = Date.now();
      delta = now2 - then;
      if (delta >= frameDuration) {
        then = now2 - delta % frameDuration;
        if (this.shouldUpdate(ignoreAnimation, forceRedraw)) {
          this.render(element2, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);
          mouse.runEvents();
        }
      }
      this.intervalId = requestAnimationFrame$1(tick2);
    };
    if (!ignoreMouse) {
      mouse.start();
    }
    this.intervalId = requestAnimationFrame$1(tick2);
  }
  stop() {
    if (this.intervalId) {
      requestAnimationFrame$1.cancel(this.intervalId);
      this.intervalId = null;
    }
    this.mouse.stop();
  }
  shouldUpdate(ignoreAnimation, forceRedraw) {
    if (!ignoreAnimation) {
      const { frameDuration } = this;
      const shouldUpdate1 = this.animations.reduce(
        (shouldUpdate, animation) => animation.update(frameDuration) || shouldUpdate,
        false
      );
      if (shouldUpdate1) {
        return true;
      }
    }
    if (typeof forceRedraw === "function" && forceRedraw()) {
      return true;
    }
    if (!this.isReadyLock && this.isReady()) {
      return true;
    }
    if (this.mouse.hasEvents()) {
      return true;
    }
    return false;
  }
  render(element2, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY) {
    const { viewPort, ctx: ctx2, isFirstRender } = this;
    const canvas = ctx2.canvas;
    viewPort.clear();
    if (canvas.width && canvas.height) {
      viewPort.setCurrent(canvas.width, canvas.height);
    }
    const widthStyle = element2.getStyle("width");
    const heightStyle = element2.getStyle("height");
    if (!ignoreDimensions && (isFirstRender || typeof scaleWidth !== "number" && typeof scaleHeight !== "number")) {
      if (widthStyle.hasValue()) {
        canvas.width = widthStyle.getPixels("x");
        if (canvas.style) {
          canvas.style.width = "".concat(canvas.width, "px");
        }
      }
      if (heightStyle.hasValue()) {
        canvas.height = heightStyle.getPixels("y");
        if (canvas.style) {
          canvas.style.height = "".concat(canvas.height, "px");
        }
      }
    }
    let cWidth = canvas.clientWidth || canvas.width;
    let cHeight = canvas.clientHeight || canvas.height;
    if (ignoreDimensions && widthStyle.hasValue() && heightStyle.hasValue()) {
      cWidth = widthStyle.getPixels("x");
      cHeight = heightStyle.getPixels("y");
    }
    viewPort.setCurrent(cWidth, cHeight);
    if (typeof offsetX === "number") {
      element2.getAttribute("x", true).setValue(offsetX);
    }
    if (typeof offsetY === "number") {
      element2.getAttribute("y", true).setValue(offsetY);
    }
    if (typeof scaleWidth === "number" || typeof scaleHeight === "number") {
      const viewBox = toNumbers(element2.getAttribute("viewBox").getString());
      let xRatio = 0;
      let yRatio = 0;
      if (typeof scaleWidth === "number") {
        const widthStyle2 = element2.getStyle("width");
        if (widthStyle2.hasValue()) {
          xRatio = widthStyle2.getPixels("x") / scaleWidth;
        } else if (viewBox[2] && !isNaN(viewBox[2])) {
          xRatio = viewBox[2] / scaleWidth;
        }
      }
      if (typeof scaleHeight === "number") {
        const heightStyle2 = element2.getStyle("height");
        if (heightStyle2.hasValue()) {
          yRatio = heightStyle2.getPixels("y") / scaleHeight;
        } else if (viewBox[3] && !isNaN(viewBox[3])) {
          yRatio = viewBox[3] / scaleHeight;
        }
      }
      if (!xRatio) {
        xRatio = yRatio;
      }
      if (!yRatio) {
        yRatio = xRatio;
      }
      element2.getAttribute("width", true).setValue(scaleWidth);
      element2.getAttribute("height", true).setValue(scaleHeight);
      const transformStyle = element2.getStyle("transform", true, true);
      transformStyle.setValue("".concat(transformStyle.getString(), " scale(").concat(1 / xRatio, ", ").concat(1 / yRatio, ")"));
    }
    if (!ignoreClear) {
      ctx2.clearRect(0, 0, cWidth, cHeight);
    }
    element2.render(ctx2);
    if (isFirstRender) {
      this.isFirstRender = false;
    }
  }
  constructor(ctx2, { fetch: fetch2 = defaultFetch$1, window: window2 = defaultWindow } = {}) {
    this.ctx = ctx2;
    this.viewPort = new ViewPort();
    this.mouse = new Mouse(this);
    this.animations = [];
    this.waits = [];
    this.frameDuration = 0;
    this.isReadyLock = false;
    this.isFirstRender = true;
    this.intervalId = null;
    this.window = window2;
    if (!fetch2) {
      throw new Error("Can't find 'fetch' in 'globalThis', please provide it via options");
    }
    this.fetch = fetch2;
  }
}
Screen.defaultWindow = defaultWindow;
Screen.defaultFetch = defaultFetch$1;
Screen.FRAMERATE = 30;
Screen.MAX_VIRTUAL_PIXELS = 3e4;
const { defaultFetch } = Screen;
const DefaultDOMParser = typeof DOMParser !== "undefined" ? DOMParser : void 0;
class Parser {
  async parse(resource) {
    if (resource.startsWith("<")) {
      return this.parseFromString(resource);
    }
    return this.load(resource);
  }
  parseFromString(xml) {
    const parser = new this.DOMParser();
    try {
      return this.checkDocument(parser.parseFromString(xml, "image/svg+xml"));
    } catch (err) {
      return this.checkDocument(parser.parseFromString(xml, "text/xml"));
    }
  }
  checkDocument(document2) {
    const parserError = document2.getElementsByTagName("parsererror")[0];
    if (parserError) {
      throw new Error(parserError.textContent || "Unknown parse error");
    }
    return document2;
  }
  async load(url) {
    const response = await this.fetch(url);
    const xml = await response.text();
    return this.parseFromString(xml);
  }
  constructor({ fetch: fetch2 = defaultFetch, DOMParser: DOMParser2 = DefaultDOMParser } = {}) {
    if (!fetch2) {
      throw new Error("Can't find 'fetch' in 'globalThis', please provide it via options");
    }
    if (!DOMParser2) {
      throw new Error("Can't find 'DOMParser' in 'globalThis', please provide it via options");
    }
    this.fetch = fetch2;
    this.DOMParser = DOMParser2;
  }
}
class Translate {
  apply(ctx2) {
    const { x: x2, y: y2 } = this.point;
    ctx2.translate(x2 || 0, y2 || 0);
  }
  unapply(ctx2) {
    const { x: x2, y: y2 } = this.point;
    ctx2.translate(-1 * x2 || 0, -1 * y2 || 0);
  }
  applyToPoint(point2) {
    const { x: x2, y: y2 } = this.point;
    point2.applyTransform([
      1,
      0,
      0,
      1,
      x2 || 0,
      y2 || 0
    ]);
  }
  constructor(_2, point2) {
    this.type = "translate";
    this.point = Point$2.parse(point2);
  }
}
class Rotate {
  apply(ctx2) {
    const { cx, cy, originX, originY, angle } = this;
    const tx = cx + originX.getPixels("x");
    const ty = cy + originY.getPixels("y");
    ctx2.translate(tx, ty);
    ctx2.rotate(angle.getRadians());
    ctx2.translate(-tx, -ty);
  }
  unapply(ctx2) {
    const { cx, cy, originX, originY, angle } = this;
    const tx = cx + originX.getPixels("x");
    const ty = cy + originY.getPixels("y");
    ctx2.translate(tx, ty);
    ctx2.rotate(-1 * angle.getRadians());
    ctx2.translate(-tx, -ty);
  }
  applyToPoint(point2) {
    const { cx, cy, angle } = this;
    const rad = angle.getRadians();
    point2.applyTransform([
      1,
      0,
      0,
      1,
      cx || 0,
      cy || 0
      // this.p.y
    ]);
    point2.applyTransform([
      Math.cos(rad),
      Math.sin(rad),
      -Math.sin(rad),
      Math.cos(rad),
      0,
      0
    ]);
    point2.applyTransform([
      1,
      0,
      0,
      1,
      -cx || 0,
      -cy || 0
      // -this.p.y
    ]);
  }
  constructor(document2, rotate, transformOrigin) {
    this.type = "rotate";
    const numbers = toNumbers(rotate);
    this.angle = new Property(document2, "angle", numbers[0]);
    this.originX = transformOrigin[0];
    this.originY = transformOrigin[1];
    this.cx = numbers[1] || 0;
    this.cy = numbers[2] || 0;
  }
}
class Scale {
  apply(ctx2) {
    const { scale: { x: x2, y: y2 }, originX, originY } = this;
    const tx = originX.getPixels("x");
    const ty = originY.getPixels("y");
    ctx2.translate(tx, ty);
    ctx2.scale(x2, y2 || x2);
    ctx2.translate(-tx, -ty);
  }
  unapply(ctx2) {
    const { scale: { x: x2, y: y2 }, originX, originY } = this;
    const tx = originX.getPixels("x");
    const ty = originY.getPixels("y");
    ctx2.translate(tx, ty);
    ctx2.scale(1 / x2, 1 / y2 || x2);
    ctx2.translate(-tx, -ty);
  }
  applyToPoint(point2) {
    const { x: x2, y: y2 } = this.scale;
    point2.applyTransform([
      x2 || 0,
      0,
      0,
      y2 || 0,
      0,
      0
    ]);
  }
  constructor(_2, scale, transformOrigin) {
    this.type = "scale";
    const scaleSize = Point$2.parseScale(scale);
    if (scaleSize.x === 0 || scaleSize.y === 0) {
      scaleSize.x = PSEUDO_ZERO;
      scaleSize.y = PSEUDO_ZERO;
    }
    this.scale = scaleSize;
    this.originX = transformOrigin[0];
    this.originY = transformOrigin[1];
  }
}
class Matrix {
  apply(ctx2) {
    const { originX, originY, matrix } = this;
    const tx = originX.getPixels("x");
    const ty = originY.getPixels("y");
    ctx2.translate(tx, ty);
    ctx2.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
    ctx2.translate(-tx, -ty);
  }
  unapply(ctx2) {
    const { originX, originY, matrix } = this;
    const a2 = matrix[0];
    const b = matrix[2];
    const c2 = matrix[4];
    const d = matrix[1];
    const e3 = matrix[3];
    const f2 = matrix[5];
    const g = 0;
    const h2 = 0;
    const i2 = 1;
    const det = 1 / (a2 * (e3 * i2 - f2 * h2) - b * (d * i2 - f2 * g) + c2 * (d * h2 - e3 * g));
    const tx = originX.getPixels("x");
    const ty = originY.getPixels("y");
    ctx2.translate(tx, ty);
    ctx2.transform(det * (e3 * i2 - f2 * h2), det * (f2 * g - d * i2), det * (c2 * h2 - b * i2), det * (a2 * i2 - c2 * g), det * (b * f2 - c2 * e3), det * (c2 * d - a2 * f2));
    ctx2.translate(-tx, -ty);
  }
  applyToPoint(point2) {
    point2.applyTransform(this.matrix);
  }
  constructor(_2, matrix, transformOrigin) {
    this.type = "matrix";
    this.matrix = toMatrixValue(matrix);
    this.originX = transformOrigin[0];
    this.originY = transformOrigin[1];
  }
}
class Skew extends Matrix {
  constructor(document2, skew, transformOrigin) {
    super(document2, skew, transformOrigin);
    this.type = "skew";
    this.angle = new Property(document2, "angle", skew);
  }
}
class SkewX extends Skew {
  constructor(document2, skew, transformOrigin) {
    super(document2, skew, transformOrigin);
    this.type = "skewX";
    this.matrix = [
      1,
      0,
      Math.tan(this.angle.getRadians()),
      1,
      0,
      0
    ];
  }
}
class SkewY extends Skew {
  constructor(document2, skew, transformOrigin) {
    super(document2, skew, transformOrigin);
    this.type = "skewY";
    this.matrix = [
      1,
      Math.tan(this.angle.getRadians()),
      0,
      1,
      0,
      0
    ];
  }
}
function parseTransforms(transform) {
  return compressSpaces(transform).trim().replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/);
}
function parseTransform(transform) {
  const [type2 = "", value = ""] = transform.split("(");
  return [
    type2.trim(),
    value.trim().replace(")", "")
  ];
}
let Transform$1 = class Transform {
  static fromElement(document2, element2) {
    const transformStyle = element2.getStyle("transform", false, true);
    if (transformStyle.hasValue()) {
      const [transformOriginXProperty, transformOriginYProperty = transformOriginXProperty] = element2.getStyle("transform-origin", false, true).split();
      if (transformOriginXProperty && transformOriginYProperty) {
        const transformOrigin = [
          transformOriginXProperty,
          transformOriginYProperty
        ];
        return new Transform(document2, transformStyle.getString(), transformOrigin);
      }
    }
    return null;
  }
  apply(ctx2) {
    this.transforms.forEach(
      (transform) => transform.apply(ctx2)
    );
  }
  unapply(ctx2) {
    this.transforms.forEach(
      (transform) => transform.unapply(ctx2)
    );
  }
  // TODO: applyToPoint unused ... remove?
  applyToPoint(point2) {
    this.transforms.forEach(
      (transform) => transform.applyToPoint(point2)
    );
  }
  constructor(document2, transform1, transformOrigin) {
    this.document = document2;
    this.transforms = [];
    const data = parseTransforms(transform1);
    data.forEach((transform) => {
      if (transform === "none") {
        return;
      }
      const [type2, value] = parseTransform(transform);
      const TransformType = Transform.transformTypes[type2];
      if (TransformType) {
        this.transforms.push(new TransformType(this.document, value, transformOrigin));
      }
    });
  }
};
Transform$1.transformTypes = {
  translate: Translate,
  rotate: Rotate,
  scale: Scale,
  matrix: Matrix,
  skewX: SkewX,
  skewY: SkewY
};
class Element {
  getAttribute(name) {
    let createIfNotExists = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const attr2 = this.attributes[name];
    if (!attr2 && createIfNotExists) {
      const attr3 = new Property(this.document, name, "");
      this.attributes[name] = attr3;
      return attr3;
    }
    return attr2 || Property.empty(this.document);
  }
  getHrefAttribute() {
    let href;
    for (const key in this.attributes) {
      if (key === "href" || key.endsWith(":href")) {
        href = this.attributes[key];
        break;
      }
    }
    return href || Property.empty(this.document);
  }
  getStyle(name) {
    let createIfNotExists = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, skipAncestors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const style = this.styles[name];
    if (style) {
      return style;
    }
    const attr2 = this.getAttribute(name);
    if (attr2.hasValue()) {
      this.styles[name] = attr2;
      return attr2;
    }
    if (!skipAncestors) {
      const { parent } = this;
      if (parent) {
        const parentStyle = parent.getStyle(name);
        if (parentStyle.hasValue()) {
          return parentStyle;
        }
      }
    }
    if (createIfNotExists) {
      const style2 = new Property(this.document, name, "");
      this.styles[name] = style2;
      return style2;
    }
    return Property.empty(this.document);
  }
  render(ctx2) {
    if (this.getStyle("display").getString() === "none" || this.getStyle("visibility").getString() === "hidden") {
      return;
    }
    ctx2.save();
    if (this.getStyle("mask").hasValue()) {
      const mask = this.getStyle("mask").getDefinition();
      if (mask) {
        this.applyEffects(ctx2);
        mask.apply(ctx2, this);
      }
    } else if (this.getStyle("filter").getValue("none") !== "none") {
      const filter = this.getStyle("filter").getDefinition();
      if (filter) {
        this.applyEffects(ctx2);
        filter.apply(ctx2, this);
      }
    } else {
      this.setContext(ctx2);
      this.renderChildren(ctx2);
      this.clearContext(ctx2);
    }
    ctx2.restore();
  }
  setContext(_2) {
  }
  applyEffects(ctx2) {
    const transform = Transform$1.fromElement(this.document, this);
    if (transform) {
      transform.apply(ctx2);
    }
    const clipPathStyleProp = this.getStyle("clip-path", false, true);
    if (clipPathStyleProp.hasValue()) {
      const clip = clipPathStyleProp.getDefinition();
      if (clip) {
        clip.apply(ctx2);
      }
    }
  }
  clearContext(_2) {
  }
  renderChildren(ctx2) {
    this.children.forEach((child) => {
      child.render(ctx2);
    });
  }
  addChild(childNode) {
    const child = childNode instanceof Element ? childNode : this.document.createElement(childNode);
    child.parent = this;
    if (!Element.ignoreChildTypes.includes(child.type)) {
      this.children.push(child);
    }
  }
  matchesSelector(selector) {
    var ref;
    const { node: node2 } = this;
    if (typeof node2.matches === "function") {
      return node2.matches(selector);
    }
    const styleClasses = (ref = node2.getAttribute) === null || ref === void 0 ? void 0 : ref.call(node2, "class");
    if (!styleClasses || styleClasses === "") {
      return false;
    }
    return styleClasses.split(" ").some(
      (styleClass) => ".".concat(styleClass) === selector
    );
  }
  addStylesFromStyleDefinition() {
    const { styles, stylesSpecificity } = this.document;
    let styleProp;
    for (const selector in styles) {
      if (!selector.startsWith("@") && this.matchesSelector(selector)) {
        const style = styles[selector];
        const specificity = stylesSpecificity[selector];
        if (style) {
          for (const name in style) {
            let existingSpecificity = this.stylesSpecificity[name];
            if (typeof existingSpecificity === "undefined") {
              existingSpecificity = "000";
            }
            if (specificity && specificity >= existingSpecificity) {
              styleProp = style[name];
              if (styleProp) {
                this.styles[name] = styleProp;
              }
              this.stylesSpecificity[name] = specificity;
            }
          }
        }
      }
    }
  }
  removeStyles(element2, ignoreStyles) {
    const toRestore1 = ignoreStyles.reduce((toRestore, name) => {
      const styleProp = element2.getStyle(name);
      if (!styleProp.hasValue()) {
        return toRestore;
      }
      const value = styleProp.getString();
      styleProp.setValue("");
      return [
        ...toRestore,
        [
          name,
          value
        ]
      ];
    }, []);
    return toRestore1;
  }
  restoreStyles(element2, styles) {
    styles.forEach((param) => {
      let [name, value] = param;
      element2.getStyle(name, true).setValue(value);
    });
  }
  isFirstChild() {
    var ref;
    return ((ref = this.parent) === null || ref === void 0 ? void 0 : ref.children.indexOf(this)) === 0;
  }
  constructor(document2, node2, captureTextNodes = false) {
    this.document = document2;
    this.node = node2;
    this.captureTextNodes = captureTextNodes;
    this.type = "";
    this.attributes = {};
    this.styles = {};
    this.stylesSpecificity = {};
    this.animationFrozen = false;
    this.animationFrozenValue = "";
    this.parent = null;
    this.children = [];
    if (!node2 || node2.nodeType !== 1) {
      return;
    }
    Array.from(node2.attributes).forEach((attribute) => {
      const nodeName = normalizeAttributeName(attribute.nodeName);
      this.attributes[nodeName] = new Property(document2, nodeName, attribute.value);
    });
    this.addStylesFromStyleDefinition();
    if (this.getAttribute("style").hasValue()) {
      const styles = this.getAttribute("style").getString().split(";").map(
        (_2) => _2.trim()
      );
      styles.forEach((style) => {
        if (!style) {
          return;
        }
        const [name, value] = style.split(":").map(
          (_2) => _2.trim()
        );
        if (name) {
          this.styles[name] = new Property(document2, name, value);
        }
      });
    }
    const { definitions } = document2;
    const id2 = this.getAttribute("id");
    if (id2.hasValue()) {
      if (!definitions[id2.getString()]) {
        definitions[id2.getString()] = this;
      }
    }
    Array.from(node2.childNodes).forEach((childNode) => {
      if (childNode.nodeType === 1) {
        this.addChild(childNode);
      } else if (captureTextNodes && (childNode.nodeType === 3 || childNode.nodeType === 4)) {
        const textNode = document2.createTextNode(childNode);
        if (textNode.getText().length > 0) {
          this.addChild(textNode);
        }
      }
    });
  }
}
Element.ignoreChildTypes = [
  "title"
];
class UnknownElement extends Element {
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
  }
}
function wrapFontFamily(fontFamily) {
  const trimmed = fontFamily.trim();
  return /^('|")/.test(trimmed) ? trimmed : '"'.concat(trimmed, '"');
}
function prepareFontFamily(fontFamily) {
  return typeof process === "undefined" ? fontFamily : fontFamily.trim().split(",").map(wrapFontFamily).join(",");
}
function prepareFontStyle(fontStyle) {
  if (!fontStyle) {
    return "";
  }
  const targetFontStyle = fontStyle.trim().toLowerCase();
  switch (targetFontStyle) {
    case "normal":
    case "italic":
    case "oblique":
    case "inherit":
    case "initial":
    case "unset":
      return targetFontStyle;
    default:
      if (/^oblique\s+(-|)\d+deg$/.test(targetFontStyle)) {
        return targetFontStyle;
      }
      return "";
  }
}
function prepareFontWeight(fontWeight) {
  if (!fontWeight) {
    return "";
  }
  const targetFontWeight = fontWeight.trim().toLowerCase();
  switch (targetFontWeight) {
    case "normal":
    case "bold":
    case "lighter":
    case "bolder":
    case "inherit":
    case "initial":
    case "unset":
      return targetFontWeight;
    default:
      if (/^[\d.]+$/.test(targetFontWeight)) {
        return targetFontWeight;
      }
      return "";
  }
}
class Font {
  static parse() {
    let font = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", inherit = arguments.length > 1 ? arguments[1] : void 0;
    let fontStyle = "";
    let fontVariant = "";
    let fontWeight = "";
    let fontSize = "";
    let fontFamily = "";
    const parts = compressSpaces(font).trim().split(" ");
    const set2 = {
      fontSize: false,
      fontStyle: false,
      fontWeight: false,
      fontVariant: false
    };
    parts.forEach((part) => {
      switch (true) {
        case (!set2.fontStyle && Font.styles.includes(part)):
          if (part !== "inherit") {
            fontStyle = part;
          }
          set2.fontStyle = true;
          break;
        case (!set2.fontVariant && Font.variants.includes(part)):
          if (part !== "inherit") {
            fontVariant = part;
          }
          set2.fontStyle = true;
          set2.fontVariant = true;
          break;
        case (!set2.fontWeight && Font.weights.includes(part)):
          if (part !== "inherit") {
            fontWeight = part;
          }
          set2.fontStyle = true;
          set2.fontVariant = true;
          set2.fontWeight = true;
          break;
        case !set2.fontSize:
          if (part !== "inherit") {
            fontSize = part.split("/")[0] || "";
          }
          set2.fontStyle = true;
          set2.fontVariant = true;
          set2.fontWeight = true;
          set2.fontSize = true;
          break;
        default:
          if (part !== "inherit") {
            fontFamily += part;
          }
      }
    });
    return new Font(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit);
  }
  toString() {
    return [
      prepareFontStyle(this.fontStyle),
      this.fontVariant,
      prepareFontWeight(this.fontWeight),
      this.fontSize,
      // Wrap fontFamily only on nodejs and only for canvas.ctx
      prepareFontFamily(this.fontFamily)
    ].join(" ").trim();
  }
  constructor(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit) {
    const inheritFont = inherit ? typeof inherit === "string" ? Font.parse(inherit) : inherit : {};
    this.fontFamily = fontFamily || inheritFont.fontFamily;
    this.fontSize = fontSize || inheritFont.fontSize;
    this.fontStyle = fontStyle || inheritFont.fontStyle;
    this.fontWeight = fontWeight || inheritFont.fontWeight;
    this.fontVariant = fontVariant || inheritFont.fontVariant;
  }
}
Font.styles = "normal|italic|oblique|inherit";
Font.variants = "normal|small-caps|inherit";
Font.weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit";
class BoundingBox {
  get x() {
    return this.x1;
  }
  get y() {
    return this.y1;
  }
  get width() {
    return this.x2 - this.x1;
  }
  get height() {
    return this.y2 - this.y1;
  }
  addPoint(x2, y2) {
    if (typeof x2 !== "undefined") {
      if (isNaN(this.x1) || isNaN(this.x2)) {
        this.x1 = x2;
        this.x2 = x2;
      }
      if (x2 < this.x1) {
        this.x1 = x2;
      }
      if (x2 > this.x2) {
        this.x2 = x2;
      }
    }
    if (typeof y2 !== "undefined") {
      if (isNaN(this.y1) || isNaN(this.y2)) {
        this.y1 = y2;
        this.y2 = y2;
      }
      if (y2 < this.y1) {
        this.y1 = y2;
      }
      if (y2 > this.y2) {
        this.y2 = y2;
      }
    }
  }
  addX(x2) {
    this.addPoint(x2, 0);
  }
  addY(y2) {
    this.addPoint(0, y2);
  }
  addBoundingBox(boundingBox) {
    if (!boundingBox) {
      return;
    }
    const { x1, y1, x2, y2 } = boundingBox;
    this.addPoint(x1, y1);
    this.addPoint(x2, y2);
  }
  sumCubic(t2, p0, p1, p2, p3) {
    return Math.pow(1 - t2, 3) * p0 + 3 * Math.pow(1 - t2, 2) * t2 * p1 + 3 * (1 - t2) * Math.pow(t2, 2) * p2 + Math.pow(t2, 3) * p3;
  }
  bezierCurveAdd(forX, p0, p1, p2, p3) {
    const b = 6 * p0 - 12 * p1 + 6 * p2;
    const a2 = -3 * p0 + 9 * p1 - 9 * p2 + 3 * p3;
    const c2 = 3 * p1 - 3 * p0;
    if (a2 === 0) {
      if (b === 0) {
        return;
      }
      const t3 = -c2 / b;
      if (0 < t3 && t3 < 1) {
        if (forX) {
          this.addX(this.sumCubic(t3, p0, p1, p2, p3));
        } else {
          this.addY(this.sumCubic(t3, p0, p1, p2, p3));
        }
      }
      return;
    }
    const b2ac = Math.pow(b, 2) - 4 * c2 * a2;
    if (b2ac < 0) {
      return;
    }
    const t1 = (-b + Math.sqrt(b2ac)) / (2 * a2);
    if (0 < t1 && t1 < 1) {
      if (forX) {
        this.addX(this.sumCubic(t1, p0, p1, p2, p3));
      } else {
        this.addY(this.sumCubic(t1, p0, p1, p2, p3));
      }
    }
    const t2 = (-b - Math.sqrt(b2ac)) / (2 * a2);
    if (0 < t2 && t2 < 1) {
      if (forX) {
        this.addX(this.sumCubic(t2, p0, p1, p2, p3));
      } else {
        this.addY(this.sumCubic(t2, p0, p1, p2, p3));
      }
    }
  }
  // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
  addBezierCurve(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
    this.addPoint(p0x, p0y);
    this.addPoint(p3x, p3y);
    this.bezierCurveAdd(true, p0x, p1x, p2x, p3x);
    this.bezierCurveAdd(false, p0y, p1y, p2y, p3y);
  }
  addQuadraticCurve(p0x, p0y, p1x, p1y, p2x, p2y) {
    const cp1x = p0x + 2 / 3 * (p1x - p0x);
    const cp1y = p0y + 2 / 3 * (p1y - p0y);
    const cp2x = cp1x + 1 / 3 * (p2x - p0x);
    const cp2y = cp1y + 1 / 3 * (p2y - p0y);
    this.addBezierCurve(p0x, p0y, cp1x, cp2x, cp1y, cp2y, p2x, p2y);
  }
  isPointInBox(x2, y2) {
    const { x1, y1, x2: x22, y2: y22 } = this;
    return x1 <= x2 && x2 <= x22 && y1 <= y2 && y2 <= y22;
  }
  constructor(x1 = Number.NaN, y1 = Number.NaN, x2 = Number.NaN, y2 = Number.NaN) {
    this.x1 = x1;
    this.y1 = y1;
    this.x2 = x2;
    this.y2 = y2;
    this.addPoint(x1, y1);
    this.addPoint(x2, y2);
  }
}
class RenderedElement extends Element {
  calculateOpacity() {
    let opacity = 1;
    let element2 = this;
    while (element2) {
      const opacityStyle = element2.getStyle("opacity", false, true);
      if (opacityStyle.hasValue(true)) {
        opacity *= opacityStyle.getNumber();
      }
      element2 = element2.parent;
    }
    return opacity;
  }
  setContext(ctx2) {
    let fromMeasure = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!fromMeasure) {
      const fillStyleProp = this.getStyle("fill");
      const fillOpacityStyleProp = this.getStyle("fill-opacity");
      const strokeStyleProp = this.getStyle("stroke");
      const strokeOpacityProp = this.getStyle("stroke-opacity");
      if (fillStyleProp.isUrlDefinition()) {
        const fillStyle = fillStyleProp.getFillStyleDefinition(this, fillOpacityStyleProp);
        if (fillStyle) {
          ctx2.fillStyle = fillStyle;
        }
      } else if (fillStyleProp.hasValue()) {
        if (fillStyleProp.getString() === "currentColor") {
          fillStyleProp.setValue(this.getStyle("color").getColor());
        }
        const fillStyle = fillStyleProp.getColor();
        if (fillStyle !== "inherit") {
          ctx2.fillStyle = fillStyle === "none" ? "rgba(0,0,0,0)" : fillStyle;
        }
      }
      if (fillOpacityStyleProp.hasValue()) {
        const fillStyle = new Property(this.document, "fill", ctx2.fillStyle).addOpacity(fillOpacityStyleProp).getColor();
        ctx2.fillStyle = fillStyle;
      }
      if (strokeStyleProp.isUrlDefinition()) {
        const strokeStyle = strokeStyleProp.getFillStyleDefinition(this, strokeOpacityProp);
        if (strokeStyle) {
          ctx2.strokeStyle = strokeStyle;
        }
      } else if (strokeStyleProp.hasValue()) {
        if (strokeStyleProp.getString() === "currentColor") {
          strokeStyleProp.setValue(this.getStyle("color").getColor());
        }
        const strokeStyle = strokeStyleProp.getString();
        if (strokeStyle !== "inherit") {
          ctx2.strokeStyle = strokeStyle === "none" ? "rgba(0,0,0,0)" : strokeStyle;
        }
      }
      if (strokeOpacityProp.hasValue()) {
        const strokeStyle = new Property(this.document, "stroke", ctx2.strokeStyle).addOpacity(strokeOpacityProp).getString();
        ctx2.strokeStyle = strokeStyle;
      }
      const strokeWidthStyleProp = this.getStyle("stroke-width");
      if (strokeWidthStyleProp.hasValue()) {
        const newLineWidth = strokeWidthStyleProp.getPixels();
        ctx2.lineWidth = !newLineWidth ? PSEUDO_ZERO : newLineWidth;
      }
      const strokeLinecapStyleProp = this.getStyle("stroke-linecap");
      const strokeLinejoinStyleProp = this.getStyle("stroke-linejoin");
      const strokeMiterlimitProp = this.getStyle("stroke-miterlimit");
      const strokeDasharrayStyleProp = this.getStyle("stroke-dasharray");
      const strokeDashoffsetProp = this.getStyle("stroke-dashoffset");
      if (strokeLinecapStyleProp.hasValue()) {
        ctx2.lineCap = strokeLinecapStyleProp.getString();
      }
      if (strokeLinejoinStyleProp.hasValue()) {
        ctx2.lineJoin = strokeLinejoinStyleProp.getString();
      }
      if (strokeMiterlimitProp.hasValue()) {
        ctx2.miterLimit = strokeMiterlimitProp.getNumber();
      }
      if (strokeDasharrayStyleProp.hasValue() && strokeDasharrayStyleProp.getString() !== "none") {
        const gaps = toNumbers(strokeDasharrayStyleProp.getString());
        if (typeof ctx2.setLineDash !== "undefined") {
          ctx2.setLineDash(gaps);
        } else if (typeof ctx2.webkitLineDash !== "undefined") {
          ctx2.webkitLineDash = gaps;
        } else if (typeof ctx2.mozDash !== "undefined" && !(gaps.length === 1 && gaps[0] === 0)) {
          ctx2.mozDash = gaps;
        }
        const offset = strokeDashoffsetProp.getPixels();
        if (typeof ctx2.lineDashOffset !== "undefined") {
          ctx2.lineDashOffset = offset;
        } else if (typeof ctx2.webkitLineDashOffset !== "undefined") {
          ctx2.webkitLineDashOffset = offset;
        } else if (typeof ctx2.mozDashOffset !== "undefined") {
          ctx2.mozDashOffset = offset;
        }
      }
    }
    this.modifiedEmSizeStack = false;
    if (typeof ctx2.font !== "undefined") {
      const fontStyleProp = this.getStyle("font");
      const fontStyleStyleProp = this.getStyle("font-style");
      const fontVariantStyleProp = this.getStyle("font-variant");
      const fontWeightStyleProp = this.getStyle("font-weight");
      const fontSizeStyleProp = this.getStyle("font-size");
      const fontFamilyStyleProp = this.getStyle("font-family");
      const font = new Font(fontStyleStyleProp.getString(), fontVariantStyleProp.getString(), fontWeightStyleProp.getString(), fontSizeStyleProp.hasValue() ? "".concat(fontSizeStyleProp.getPixels(true), "px") : "", fontFamilyStyleProp.getString(), Font.parse(fontStyleProp.getString(), ctx2.font));
      fontStyleStyleProp.setValue(font.fontStyle);
      fontVariantStyleProp.setValue(font.fontVariant);
      fontWeightStyleProp.setValue(font.fontWeight);
      fontSizeStyleProp.setValue(font.fontSize);
      fontFamilyStyleProp.setValue(font.fontFamily);
      ctx2.font = font.toString();
      if (fontSizeStyleProp.isPixels()) {
        this.document.emSize = fontSizeStyleProp.getPixels();
        this.modifiedEmSizeStack = true;
      }
    }
    if (!fromMeasure) {
      this.applyEffects(ctx2);
      ctx2.globalAlpha = this.calculateOpacity();
    }
  }
  clearContext(ctx2) {
    super.clearContext(ctx2);
    if (this.modifiedEmSizeStack) {
      this.document.popEmSize();
    }
  }
  constructor(...args) {
    super(...args);
    this.modifiedEmSizeStack = false;
  }
}
class TextElement extends RenderedElement {
  setContext(ctx2) {
    let fromMeasure = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    super.setContext(ctx2, fromMeasure);
    const textBaseline = this.getStyle("dominant-baseline").getTextBaseline() || this.getStyle("alignment-baseline").getTextBaseline();
    if (textBaseline) {
      ctx2.textBaseline = textBaseline;
    }
  }
  initializeCoordinates() {
    this.x = 0;
    this.y = 0;
    this.leafTexts = [];
    this.textChunkStart = 0;
    this.minX = Number.POSITIVE_INFINITY;
    this.maxX = Number.NEGATIVE_INFINITY;
  }
  getBoundingBox(ctx2) {
    if (this.type !== "text") {
      return this.getTElementBoundingBox(ctx2);
    }
    this.initializeCoordinates();
    this.adjustChildCoordinatesRecursive(ctx2);
    let boundingBox = null;
    this.children.forEach((_2, i2) => {
      const childBoundingBox = this.getChildBoundingBox(ctx2, this, this, i2);
      if (!boundingBox) {
        boundingBox = childBoundingBox;
      } else {
        boundingBox.addBoundingBox(childBoundingBox);
      }
    });
    return boundingBox;
  }
  getFontSize() {
    const { document: document2, parent } = this;
    const inheritFontSize = Font.parse(document2.ctx.font).fontSize;
    const fontSize = parent.getStyle("font-size").getNumber(inheritFontSize);
    return fontSize;
  }
  getTElementBoundingBox(ctx2) {
    const fontSize = this.getFontSize();
    return new BoundingBox(this.x, this.y - fontSize, this.x + this.measureText(ctx2), this.y);
  }
  getGlyph(font, text2, i2) {
    const char2 = text2[i2];
    let glyph;
    if (font.isArabic) {
      var ref;
      const len = text2.length;
      const prevChar = text2[i2 - 1];
      const nextChar = text2[i2 + 1];
      let arabicForm = "isolated";
      if ((i2 === 0 || prevChar === " ") && i2 < len - 1 && nextChar !== " ") {
        arabicForm = "terminal";
      }
      if (i2 > 0 && prevChar !== " " && i2 < len - 1 && nextChar !== " ") {
        arabicForm = "medial";
      }
      if (i2 > 0 && prevChar !== " " && (i2 === len - 1 || nextChar === " ")) {
        arabicForm = "initial";
      }
      glyph = ((ref = font.arabicGlyphs[char2]) === null || ref === void 0 ? void 0 : ref[arabicForm]) || font.glyphs[char2];
    } else {
      glyph = font.glyphs[char2];
    }
    if (!glyph) {
      glyph = font.missingGlyph;
    }
    return glyph;
  }
  getText() {
    return "";
  }
  getTextFromNode(node2) {
    const textNode = node2 || this.node;
    const childNodes = Array.from(textNode.parentNode.childNodes);
    const index2 = childNodes.indexOf(textNode);
    const lastIndex = childNodes.length - 1;
    let text2 = compressSpaces(
      // textNode.value
      // || textNode.text
      textNode.textContent || ""
    );
    if (index2 === 0) {
      text2 = trimLeft(text2);
    }
    if (index2 === lastIndex) {
      text2 = trimRight(text2);
    }
    return text2;
  }
  renderChildren(ctx2) {
    if (this.type !== "text") {
      this.renderTElementChildren(ctx2);
      return;
    }
    this.initializeCoordinates();
    this.adjustChildCoordinatesRecursive(ctx2);
    this.children.forEach((_2, i2) => {
      this.renderChild(ctx2, this, this, i2);
    });
    const { mouse } = this.document.screen;
    if (mouse.isWorking()) {
      mouse.checkBoundingBox(this, this.getBoundingBox(ctx2));
    }
  }
  renderTElementChildren(ctx2) {
    const { document: document2, parent } = this;
    const renderText = this.getText();
    const customFont = parent.getStyle("font-family").getDefinition();
    if (customFont) {
      const { unitsPerEm } = customFont.fontFace;
      const ctxFont = Font.parse(document2.ctx.font);
      const fontSize = parent.getStyle("font-size").getNumber(ctxFont.fontSize);
      const fontStyle = parent.getStyle("font-style").getString(ctxFont.fontStyle);
      const scale = fontSize / unitsPerEm;
      const text2 = customFont.isRTL ? renderText.split("").reverse().join("") : renderText;
      const dx = toNumbers(parent.getAttribute("dx").getString());
      const len = text2.length;
      for (let i2 = 0; i2 < len; i2++) {
        const glyph = this.getGlyph(customFont, text2, i2);
        ctx2.translate(this.x, this.y);
        ctx2.scale(scale, -scale);
        const lw = ctx2.lineWidth;
        ctx2.lineWidth = ctx2.lineWidth * unitsPerEm / fontSize;
        if (fontStyle === "italic") {
          ctx2.transform(1, 0, 0.4, 1, 0, 0);
        }
        glyph.render(ctx2);
        if (fontStyle === "italic") {
          ctx2.transform(1, 0, -0.4, 1, 0, 0);
        }
        ctx2.lineWidth = lw;
        ctx2.scale(1 / scale, -1 / scale);
        ctx2.translate(-this.x, -this.y);
        this.x += fontSize * (glyph.horizAdvX || customFont.horizAdvX) / unitsPerEm;
        if (typeof dx[i2] !== "undefined" && !isNaN(dx[i2])) {
          this.x += dx[i2];
        }
      }
      return;
    }
    const { x: x2, y: y2 } = this;
    if (ctx2.fillStyle) {
      ctx2.fillText(renderText, x2, y2);
    }
    if (ctx2.strokeStyle) {
      ctx2.strokeText(renderText, x2, y2);
    }
  }
  applyAnchoring() {
    if (this.textChunkStart >= this.leafTexts.length) {
      return;
    }
    const firstElement = this.leafTexts[this.textChunkStart];
    const textAnchor = firstElement.getStyle("text-anchor").getString("start");
    const isRTL = false;
    let shift = 0;
    if (textAnchor === "start" && !isRTL || textAnchor === "end" && isRTL) {
      shift = firstElement.x - this.minX;
    } else if (textAnchor === "end" && !isRTL || textAnchor === "start" && isRTL) {
      shift = firstElement.x - this.maxX;
    } else {
      shift = firstElement.x - (this.minX + this.maxX) / 2;
    }
    for (let i2 = this.textChunkStart; i2 < this.leafTexts.length; i2++) {
      this.leafTexts[i2].x += shift;
    }
    this.minX = Number.POSITIVE_INFINITY;
    this.maxX = Number.NEGATIVE_INFINITY;
    this.textChunkStart = this.leafTexts.length;
  }
  adjustChildCoordinatesRecursive(ctx2) {
    this.children.forEach((_2, i2) => {
      this.adjustChildCoordinatesRecursiveCore(ctx2, this, this, i2);
    });
    this.applyAnchoring();
  }
  adjustChildCoordinatesRecursiveCore(ctx2, textParent, parent, i1) {
    const child = parent.children[i1];
    if (child.children.length > 0) {
      child.children.forEach((_2, i2) => {
        textParent.adjustChildCoordinatesRecursiveCore(ctx2, textParent, child, i2);
      });
    } else {
      this.adjustChildCoordinates(ctx2, textParent, parent, i1);
    }
  }
  adjustChildCoordinates(ctx2, textParent, parent, i2) {
    const child = parent.children[i2];
    if (typeof child.measureText !== "function") {
      return child;
    }
    ctx2.save();
    child.setContext(ctx2, true);
    const xAttr = child.getAttribute("x");
    const yAttr = child.getAttribute("y");
    const dxAttr = child.getAttribute("dx");
    const dyAttr = child.getAttribute("dy");
    const customFont = child.getStyle("font-family").getDefinition();
    const isRTL = Boolean(customFont === null || customFont === void 0 ? void 0 : customFont.isRTL);
    if (i2 === 0) {
      if (!xAttr.hasValue()) {
        xAttr.setValue(child.getInheritedAttribute("x"));
      }
      if (!yAttr.hasValue()) {
        yAttr.setValue(child.getInheritedAttribute("y"));
      }
      if (!dxAttr.hasValue()) {
        dxAttr.setValue(child.getInheritedAttribute("dx"));
      }
      if (!dyAttr.hasValue()) {
        dyAttr.setValue(child.getInheritedAttribute("dy"));
      }
    }
    const width = child.measureText(ctx2);
    if (isRTL) {
      textParent.x -= width;
    }
    if (xAttr.hasValue()) {
      textParent.applyAnchoring();
      child.x = xAttr.getPixels("x");
      if (dxAttr.hasValue()) {
        child.x += dxAttr.getPixels("x");
      }
    } else {
      if (dxAttr.hasValue()) {
        textParent.x += dxAttr.getPixels("x");
      }
      child.x = textParent.x;
    }
    textParent.x = child.x;
    if (!isRTL) {
      textParent.x += width;
    }
    if (yAttr.hasValue()) {
      child.y = yAttr.getPixels("y");
      if (dyAttr.hasValue()) {
        child.y += dyAttr.getPixels("y");
      }
    } else {
      if (dyAttr.hasValue()) {
        textParent.y += dyAttr.getPixels("y");
      }
      child.y = textParent.y;
    }
    textParent.y = child.y;
    textParent.leafTexts.push(child);
    textParent.minX = Math.min(textParent.minX, child.x, child.x + width);
    textParent.maxX = Math.max(textParent.maxX, child.x, child.x + width);
    child.clearContext(ctx2);
    ctx2.restore();
    return child;
  }
  getChildBoundingBox(ctx2, textParent, parent, i2) {
    const child = parent.children[i2];
    if (typeof child.getBoundingBox !== "function") {
      return null;
    }
    const boundingBox = child.getBoundingBox(ctx2);
    if (boundingBox) {
      child.children.forEach((_2, i3) => {
        const childBoundingBox = textParent.getChildBoundingBox(ctx2, textParent, child, i3);
        boundingBox.addBoundingBox(childBoundingBox);
      });
    }
    return boundingBox;
  }
  renderChild(ctx2, textParent, parent, i3) {
    const child = parent.children[i3];
    child.render(ctx2);
    child.children.forEach((_2, i2) => {
      textParent.renderChild(ctx2, textParent, child, i2);
    });
  }
  measureText(ctx2) {
    const { measureCache } = this;
    if (~measureCache) {
      return measureCache;
    }
    const renderText = this.getText();
    const measure = this.measureTargetText(ctx2, renderText);
    this.measureCache = measure;
    return measure;
  }
  measureTargetText(ctx2, targetText) {
    if (!targetText.length) {
      return 0;
    }
    const { parent } = this;
    const customFont = parent.getStyle("font-family").getDefinition();
    if (customFont) {
      const fontSize = this.getFontSize();
      const text2 = customFont.isRTL ? targetText.split("").reverse().join("") : targetText;
      const dx = toNumbers(parent.getAttribute("dx").getString());
      const len = text2.length;
      let measure2 = 0;
      for (let i2 = 0; i2 < len; i2++) {
        const glyph = this.getGlyph(customFont, text2, i2);
        measure2 += (glyph.horizAdvX || customFont.horizAdvX) * fontSize / customFont.fontFace.unitsPerEm;
        if (typeof dx[i2] !== "undefined" && !isNaN(dx[i2])) {
          measure2 += dx[i2];
        }
      }
      return measure2;
    }
    if (!ctx2.measureText) {
      return targetText.length * 10;
    }
    ctx2.save();
    this.setContext(ctx2, true);
    const { width: measure } = ctx2.measureText(targetText);
    this.clearContext(ctx2);
    ctx2.restore();
    return measure;
  }
  /**
  * Inherits positional attributes from {@link TextElement} parent(s). Attributes
  * are only inherited from a parent to its first child.
  * @param name - The attribute name.
  * @returns The attribute value or null.
  */
  getInheritedAttribute(name) {
    let current = this;
    while (current instanceof TextElement && current.isFirstChild() && current.parent) {
      const parentAttr = current.parent.getAttribute(name);
      if (parentAttr.hasValue(true)) {
        return parentAttr.getString("0");
      }
      current = current.parent;
    }
    return null;
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, new.target === TextElement ? true : captureTextNodes);
    this.type = "text";
    this.x = 0;
    this.y = 0;
    this.leafTexts = [];
    this.textChunkStart = 0;
    this.minX = Number.POSITIVE_INFINITY;
    this.maxX = Number.NEGATIVE_INFINITY;
    this.measureCache = -1;
  }
}
class TSpanElement extends TextElement {
  getText() {
    return this.text;
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, new.target === TSpanElement ? true : captureTextNodes);
    this.type = "tspan";
    this.text = this.children.length > 0 ? "" : this.getTextFromNode();
  }
}
class TextNode extends TSpanElement {
  constructor(...args) {
    super(...args);
    this.type = "textNode";
  }
}
class PathParser extends _ {
  reset() {
    this.i = -1;
    this.command = null;
    this.previousCommand = null;
    this.start = new Point$2(0, 0);
    this.control = new Point$2(0, 0);
    this.current = new Point$2(0, 0);
    this.points = [];
    this.angles = [];
  }
  isEnd() {
    const { i: i2, commands } = this;
    return i2 >= commands.length - 1;
  }
  next() {
    const command = this.commands[++this.i];
    this.previousCommand = this.command;
    this.command = command;
    return command;
  }
  getPoint() {
    let xProp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "x", yProp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "y";
    const point2 = new Point$2(this.command[xProp], this.command[yProp]);
    return this.makeAbsolute(point2);
  }
  getAsControlPoint(xProp, yProp) {
    const point2 = this.getPoint(xProp, yProp);
    this.control = point2;
    return point2;
  }
  getAsCurrentPoint(xProp, yProp) {
    const point2 = this.getPoint(xProp, yProp);
    this.current = point2;
    return point2;
  }
  getReflectedControlPoint() {
    const previousCommand = this.previousCommand.type;
    if (previousCommand !== _.CURVE_TO && previousCommand !== _.SMOOTH_CURVE_TO && previousCommand !== _.QUAD_TO && previousCommand !== _.SMOOTH_QUAD_TO) {
      return this.current;
    }
    const { current: { x: cx, y: cy }, control: { x: ox, y: oy } } = this;
    const point2 = new Point$2(2 * cx - ox, 2 * cy - oy);
    return point2;
  }
  makeAbsolute(point2) {
    if (this.command.relative) {
      const { x: x2, y: y2 } = this.current;
      point2.x += x2;
      point2.y += y2;
    }
    return point2;
  }
  addMarker(point2, from2, priorTo) {
    const { points, angles } = this;
    if (priorTo && angles.length > 0 && !angles[angles.length - 1]) {
      angles[angles.length - 1] = points[points.length - 1].angleTo(priorTo);
    }
    this.addMarkerAngle(point2, from2 ? from2.angleTo(point2) : null);
  }
  addMarkerAngle(point2, angle) {
    this.points.push(point2);
    this.angles.push(angle);
  }
  getMarkerPoints() {
    return this.points;
  }
  getMarkerAngles() {
    const { angles } = this;
    const len = angles.length;
    for (let i2 = 0; i2 < len; i2++) {
      if (!angles[i2]) {
        for (let j = i2 + 1; j < len; j++) {
          if (angles[j]) {
            angles[i2] = angles[j];
            break;
          }
        }
      }
    }
    return angles;
  }
  constructor(path) {
    super(path.replace(/([+\-.])\s+/gm, "$1").replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, ""));
    this.control = new Point$2(0, 0);
    this.start = new Point$2(0, 0);
    this.current = new Point$2(0, 0);
    this.command = null;
    this.commands = this.commands;
    this.i = -1;
    this.previousCommand = null;
    this.points = [];
    this.angles = [];
  }
}
class PathElement extends RenderedElement {
  path(ctx2) {
    const { pathParser } = this;
    const boundingBox = new BoundingBox();
    pathParser.reset();
    if (ctx2) {
      ctx2.beginPath();
    }
    while (!pathParser.isEnd()) {
      switch (pathParser.next().type) {
        case PathParser.MOVE_TO:
          this.pathM(ctx2, boundingBox);
          break;
        case PathParser.LINE_TO:
          this.pathL(ctx2, boundingBox);
          break;
        case PathParser.HORIZ_LINE_TO:
          this.pathH(ctx2, boundingBox);
          break;
        case PathParser.VERT_LINE_TO:
          this.pathV(ctx2, boundingBox);
          break;
        case PathParser.CURVE_TO:
          this.pathC(ctx2, boundingBox);
          break;
        case PathParser.SMOOTH_CURVE_TO:
          this.pathS(ctx2, boundingBox);
          break;
        case PathParser.QUAD_TO:
          this.pathQ(ctx2, boundingBox);
          break;
        case PathParser.SMOOTH_QUAD_TO:
          this.pathT(ctx2, boundingBox);
          break;
        case PathParser.ARC:
          this.pathA(ctx2, boundingBox);
          break;
        case PathParser.CLOSE_PATH:
          this.pathZ(ctx2, boundingBox);
          break;
      }
    }
    return boundingBox;
  }
  getBoundingBox(_ctx) {
    return this.path();
  }
  getMarkers() {
    const { pathParser } = this;
    const points = pathParser.getMarkerPoints();
    const angles = pathParser.getMarkerAngles();
    const markers = points.map(
      (point2, i2) => [
        point2,
        angles[i2]
      ]
    );
    return markers;
  }
  renderChildren(ctx2) {
    this.path(ctx2);
    this.document.screen.mouse.checkPath(this, ctx2);
    const fillRuleStyleProp = this.getStyle("fill-rule");
    if (ctx2.fillStyle !== "") {
      if (fillRuleStyleProp.getString("inherit") !== "inherit") {
        ctx2.fill(fillRuleStyleProp.getString());
      } else {
        ctx2.fill();
      }
    }
    if (ctx2.strokeStyle !== "") {
      if (this.getAttribute("vector-effect").getString() === "non-scaling-stroke") {
        ctx2.save();
        ctx2.setTransform(1, 0, 0, 1, 0, 0);
        ctx2.stroke();
        ctx2.restore();
      } else {
        ctx2.stroke();
      }
    }
    const markers = this.getMarkers();
    if (markers) {
      const markersLastIndex = markers.length - 1;
      const markerStartStyleProp = this.getStyle("marker-start");
      const markerMidStyleProp = this.getStyle("marker-mid");
      const markerEndStyleProp = this.getStyle("marker-end");
      if (markerStartStyleProp.isUrlDefinition()) {
        const marker = markerStartStyleProp.getDefinition();
        const [point2, angle] = markers[0];
        marker.render(ctx2, point2, angle);
      }
      if (markerMidStyleProp.isUrlDefinition()) {
        const marker = markerMidStyleProp.getDefinition();
        for (let i2 = 1; i2 < markersLastIndex; i2++) {
          const [point2, angle] = markers[i2];
          marker.render(ctx2, point2, angle);
        }
      }
      if (markerEndStyleProp.isUrlDefinition()) {
        const marker = markerEndStyleProp.getDefinition();
        const [point2, angle] = markers[markersLastIndex];
        marker.render(ctx2, point2, angle);
      }
    }
  }
  static pathM(pathParser) {
    const point2 = pathParser.getAsCurrentPoint();
    pathParser.start = pathParser.current;
    return {
      point: point2
    };
  }
  pathM(ctx2, boundingBox) {
    const { pathParser } = this;
    const { point: point2 } = PathElement.pathM(pathParser);
    const { x: x2, y: y2 } = point2;
    pathParser.addMarker(point2);
    boundingBox.addPoint(x2, y2);
    if (ctx2) {
      ctx2.moveTo(x2, y2);
    }
  }
  static pathL(pathParser) {
    const { current } = pathParser;
    const point2 = pathParser.getAsCurrentPoint();
    return {
      current,
      point: point2
    };
  }
  pathL(ctx2, boundingBox) {
    const { pathParser } = this;
    const { current, point: point2 } = PathElement.pathL(pathParser);
    const { x: x2, y: y2 } = point2;
    pathParser.addMarker(point2, current);
    boundingBox.addPoint(x2, y2);
    if (ctx2) {
      ctx2.lineTo(x2, y2);
    }
  }
  static pathH(pathParser) {
    const { current, command } = pathParser;
    const point2 = new Point$2((command.relative ? current.x : 0) + command.x, current.y);
    pathParser.current = point2;
    return {
      current,
      point: point2
    };
  }
  pathH(ctx2, boundingBox) {
    const { pathParser } = this;
    const { current, point: point2 } = PathElement.pathH(pathParser);
    const { x: x2, y: y2 } = point2;
    pathParser.addMarker(point2, current);
    boundingBox.addPoint(x2, y2);
    if (ctx2) {
      ctx2.lineTo(x2, y2);
    }
  }
  static pathV(pathParser) {
    const { current, command } = pathParser;
    const point2 = new Point$2(current.x, (command.relative ? current.y : 0) + command.y);
    pathParser.current = point2;
    return {
      current,
      point: point2
    };
  }
  pathV(ctx2, boundingBox) {
    const { pathParser } = this;
    const { current, point: point2 } = PathElement.pathV(pathParser);
    const { x: x2, y: y2 } = point2;
    pathParser.addMarker(point2, current);
    boundingBox.addPoint(x2, y2);
    if (ctx2) {
      ctx2.lineTo(x2, y2);
    }
  }
  static pathC(pathParser) {
    const { current } = pathParser;
    const point2 = pathParser.getPoint("x1", "y1");
    const controlPoint = pathParser.getAsControlPoint("x2", "y2");
    const currentPoint = pathParser.getAsCurrentPoint();
    return {
      current,
      point: point2,
      controlPoint,
      currentPoint
    };
  }
  pathC(ctx2, boundingBox) {
    const { pathParser } = this;
    const { current, point: point2, controlPoint, currentPoint } = PathElement.pathC(pathParser);
    pathParser.addMarker(currentPoint, controlPoint, point2);
    boundingBox.addBezierCurve(current.x, current.y, point2.x, point2.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    if (ctx2) {
      ctx2.bezierCurveTo(point2.x, point2.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
  }
  static pathS(pathParser) {
    const { current } = pathParser;
    const point2 = pathParser.getReflectedControlPoint();
    const controlPoint = pathParser.getAsControlPoint("x2", "y2");
    const currentPoint = pathParser.getAsCurrentPoint();
    return {
      current,
      point: point2,
      controlPoint,
      currentPoint
    };
  }
  pathS(ctx2, boundingBox) {
    const { pathParser } = this;
    const { current, point: point2, controlPoint, currentPoint } = PathElement.pathS(pathParser);
    pathParser.addMarker(currentPoint, controlPoint, point2);
    boundingBox.addBezierCurve(current.x, current.y, point2.x, point2.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    if (ctx2) {
      ctx2.bezierCurveTo(point2.x, point2.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
  }
  static pathQ(pathParser) {
    const { current } = pathParser;
    const controlPoint = pathParser.getAsControlPoint("x1", "y1");
    const currentPoint = pathParser.getAsCurrentPoint();
    return {
      current,
      controlPoint,
      currentPoint
    };
  }
  pathQ(ctx2, boundingBox) {
    const { pathParser } = this;
    const { current, controlPoint, currentPoint } = PathElement.pathQ(pathParser);
    pathParser.addMarker(currentPoint, controlPoint, controlPoint);
    boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    if (ctx2) {
      ctx2.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
  }
  static pathT(pathParser) {
    const { current } = pathParser;
    const controlPoint = pathParser.getReflectedControlPoint();
    pathParser.control = controlPoint;
    const currentPoint = pathParser.getAsCurrentPoint();
    return {
      current,
      controlPoint,
      currentPoint
    };
  }
  pathT(ctx2, boundingBox) {
    const { pathParser } = this;
    const { current, controlPoint, currentPoint } = PathElement.pathT(pathParser);
    pathParser.addMarker(currentPoint, controlPoint, controlPoint);
    boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    if (ctx2) {
      ctx2.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
  }
  static pathA(pathParser) {
    const { current, command } = pathParser;
    let { rX, rY, xRot, lArcFlag, sweepFlag } = command;
    const xAxisRotation = xRot * (Math.PI / 180);
    const currentPoint = pathParser.getAsCurrentPoint();
    const currp = new Point$2(Math.cos(xAxisRotation) * (current.x - currentPoint.x) / 2 + Math.sin(xAxisRotation) * (current.y - currentPoint.y) / 2, -Math.sin(xAxisRotation) * (current.x - currentPoint.x) / 2 + Math.cos(xAxisRotation) * (current.y - currentPoint.y) / 2);
    const l2 = Math.pow(currp.x, 2) / Math.pow(rX, 2) + Math.pow(currp.y, 2) / Math.pow(rY, 2);
    if (l2 > 1) {
      rX *= Math.sqrt(l2);
      rY *= Math.sqrt(l2);
    }
    let s2 = (lArcFlag === sweepFlag ? -1 : 1) * Math.sqrt((Math.pow(rX, 2) * Math.pow(rY, 2) - Math.pow(rX, 2) * Math.pow(currp.y, 2) - Math.pow(rY, 2) * Math.pow(currp.x, 2)) / (Math.pow(rX, 2) * Math.pow(currp.y, 2) + Math.pow(rY, 2) * Math.pow(currp.x, 2)));
    if (isNaN(s2)) {
      s2 = 0;
    }
    const cpp = new Point$2(s2 * rX * currp.y / rY, s2 * -rY * currp.x / rX);
    const centp = new Point$2((current.x + currentPoint.x) / 2 + Math.cos(xAxisRotation) * cpp.x - Math.sin(xAxisRotation) * cpp.y, (current.y + currentPoint.y) / 2 + Math.sin(xAxisRotation) * cpp.x + Math.cos(xAxisRotation) * cpp.y);
    const a1 = vectorsAngle([
      1,
      0
    ], [
      (currp.x - cpp.x) / rX,
      (currp.y - cpp.y) / rY
    ]);
    const u2 = [
      (currp.x - cpp.x) / rX,
      (currp.y - cpp.y) / rY
    ];
    const v2 = [
      (-currp.x - cpp.x) / rX,
      (-currp.y - cpp.y) / rY
    ];
    let ad = vectorsAngle(u2, v2);
    if (vectorsRatio(u2, v2) <= -1) {
      ad = Math.PI;
    }
    if (vectorsRatio(u2, v2) >= 1) {
      ad = 0;
    }
    return {
      currentPoint,
      rX,
      rY,
      sweepFlag,
      xAxisRotation,
      centp,
      a1,
      ad
    };
  }
  pathA(ctx2, boundingBox) {
    const { pathParser } = this;
    const { currentPoint, rX, rY, sweepFlag, xAxisRotation, centp, a1, ad } = PathElement.pathA(pathParser);
    const dir = 1 - sweepFlag ? 1 : -1;
    const ah = a1 + dir * (ad / 2);
    const halfWay = new Point$2(centp.x + rX * Math.cos(ah), centp.y + rY * Math.sin(ah));
    pathParser.addMarkerAngle(halfWay, ah - dir * Math.PI / 2);
    pathParser.addMarkerAngle(currentPoint, ah - dir * Math.PI);
    boundingBox.addPoint(currentPoint.x, currentPoint.y);
    if (ctx2 && !isNaN(a1) && !isNaN(ad)) {
      const r2 = rX > rY ? rX : rY;
      const sx = rX > rY ? 1 : rX / rY;
      const sy = rX > rY ? rY / rX : 1;
      ctx2.translate(centp.x, centp.y);
      ctx2.rotate(xAxisRotation);
      ctx2.scale(sx, sy);
      ctx2.arc(0, 0, r2, a1, a1 + ad, Boolean(1 - sweepFlag));
      ctx2.scale(1 / sx, 1 / sy);
      ctx2.rotate(-xAxisRotation);
      ctx2.translate(-centp.x, -centp.y);
    }
  }
  static pathZ(pathParser) {
    pathParser.current = pathParser.start;
  }
  pathZ(ctx2, boundingBox) {
    PathElement.pathZ(this.pathParser);
    if (ctx2) {
      if (boundingBox.x1 !== boundingBox.x2 && boundingBox.y1 !== boundingBox.y2) {
        ctx2.closePath();
      }
    }
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "path";
    this.pathParser = new PathParser(this.getAttribute("d").getString());
  }
}
class SVGElement extends RenderedElement {
  setContext(ctx2) {
    var ref;
    const { document: document2 } = this;
    const { screen, window: window2 } = document2;
    const canvas = ctx2.canvas;
    screen.setDefaults(ctx2);
    if ("style" in canvas && typeof ctx2.font !== "undefined" && window2 && typeof window2.getComputedStyle !== "undefined") {
      ctx2.font = window2.getComputedStyle(canvas).getPropertyValue("font");
      const fontSizeProp = new Property(document2, "fontSize", Font.parse(ctx2.font).fontSize);
      if (fontSizeProp.hasValue()) {
        document2.rootEmSize = fontSizeProp.getPixels("y");
        document2.emSize = document2.rootEmSize;
      }
    }
    if (!this.getAttribute("x").hasValue()) {
      this.getAttribute("x", true).setValue(0);
    }
    if (!this.getAttribute("y").hasValue()) {
      this.getAttribute("y", true).setValue(0);
    }
    let { width, height } = screen.viewPort;
    if (!this.getStyle("width").hasValue()) {
      this.getStyle("width", true).setValue("100%");
    }
    if (!this.getStyle("height").hasValue()) {
      this.getStyle("height", true).setValue("100%");
    }
    if (!this.getStyle("color").hasValue()) {
      this.getStyle("color", true).setValue("black");
    }
    const refXAttr = this.getAttribute("refX");
    const refYAttr = this.getAttribute("refY");
    const viewBoxAttr = this.getAttribute("viewBox");
    const viewBox = viewBoxAttr.hasValue() ? toNumbers(viewBoxAttr.getString()) : null;
    const clip = !this.root && this.getStyle("overflow").getValue("hidden") !== "visible";
    let minX = 0;
    let minY = 0;
    let clipX = 0;
    let clipY = 0;
    if (viewBox) {
      minX = viewBox[0];
      minY = viewBox[1];
    }
    if (!this.root) {
      width = this.getStyle("width").getPixels("x");
      height = this.getStyle("height").getPixels("y");
      if (this.type === "marker") {
        clipX = minX;
        clipY = minY;
        minX = 0;
        minY = 0;
      }
    }
    screen.viewPort.setCurrent(width, height);
    if (this.node && (!this.parent || ((ref = this.node.parentNode) === null || ref === void 0 ? void 0 : ref.nodeName) === "foreignObject") && this.getStyle("transform", false, true).hasValue() && !this.getStyle("transform-origin", false, true).hasValue()) {
      this.getStyle("transform-origin", true, true).setValue("50% 50%");
    }
    super.setContext(ctx2);
    ctx2.translate(this.getAttribute("x").getPixels("x"), this.getAttribute("y").getPixels("y"));
    if (viewBox) {
      width = viewBox[2];
      height = viewBox[3];
    }
    document2.setViewBox({
      ctx: ctx2,
      aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
      width: screen.viewPort.width,
      desiredWidth: width,
      height: screen.viewPort.height,
      desiredHeight: height,
      minX,
      minY,
      refX: refXAttr.getValue(),
      refY: refYAttr.getValue(),
      clip,
      clipX,
      clipY
    });
    if (viewBox) {
      screen.viewPort.removeCurrent();
      screen.viewPort.setCurrent(width, height);
    }
  }
  clearContext(ctx2) {
    super.clearContext(ctx2);
    this.document.screen.viewPort.removeCurrent();
  }
  /**
  * Resize SVG to fit in given size.
  * @param width
  * @param height
  * @param preserveAspectRatio
  */
  resize(width) {
    let height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : width, preserveAspectRatio = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const widthAttr = this.getAttribute("width", true);
    const heightAttr = this.getAttribute("height", true);
    const viewBoxAttr = this.getAttribute("viewBox");
    const styleAttr = this.getAttribute("style");
    const originWidth = widthAttr.getNumber(0);
    const originHeight = heightAttr.getNumber(0);
    if (preserveAspectRatio) {
      if (typeof preserveAspectRatio === "string") {
        this.getAttribute("preserveAspectRatio", true).setValue(preserveAspectRatio);
      } else {
        const preserveAspectRatioAttr = this.getAttribute("preserveAspectRatio");
        if (preserveAspectRatioAttr.hasValue()) {
          preserveAspectRatioAttr.setValue(preserveAspectRatioAttr.getString().replace(/^\s*(\S.*\S)\s*$/, "$1"));
        }
      }
    }
    widthAttr.setValue(width);
    heightAttr.setValue(height);
    if (!viewBoxAttr.hasValue()) {
      viewBoxAttr.setValue("0 0 ".concat(originWidth || width, " ").concat(originHeight || height));
    }
    if (styleAttr.hasValue()) {
      const widthStyle = this.getStyle("width");
      const heightStyle = this.getStyle("height");
      if (widthStyle.hasValue()) {
        widthStyle.setValue("".concat(width, "px"));
      }
      if (heightStyle.hasValue()) {
        heightStyle.setValue("".concat(height, "px"));
      }
    }
  }
  constructor(...args) {
    super(...args);
    this.type = "svg";
    this.root = false;
  }
}
class RectElement extends PathElement {
  path(ctx2) {
    const x2 = this.getAttribute("x").getPixels("x");
    const y2 = this.getAttribute("y").getPixels("y");
    const width = this.getStyle("width", false, true).getPixels("x");
    const height = this.getStyle("height", false, true).getPixels("y");
    const rxAttr = this.getAttribute("rx");
    const ryAttr = this.getAttribute("ry");
    let rx = rxAttr.getPixels("x");
    let ry = ryAttr.getPixels("y");
    if (rxAttr.hasValue() && !ryAttr.hasValue()) {
      ry = rx;
    }
    if (ryAttr.hasValue() && !rxAttr.hasValue()) {
      rx = ry;
    }
    rx = Math.min(rx, width / 2);
    ry = Math.min(ry, height / 2);
    if (ctx2) {
      const KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
      ctx2.beginPath();
      if (height > 0 && width > 0) {
        ctx2.moveTo(x2 + rx, y2);
        ctx2.lineTo(x2 + width - rx, y2);
        ctx2.bezierCurveTo(x2 + width - rx + KAPPA * rx, y2, x2 + width, y2 + ry - KAPPA * ry, x2 + width, y2 + ry);
        ctx2.lineTo(x2 + width, y2 + height - ry);
        ctx2.bezierCurveTo(x2 + width, y2 + height - ry + KAPPA * ry, x2 + width - rx + KAPPA * rx, y2 + height, x2 + width - rx, y2 + height);
        ctx2.lineTo(x2 + rx, y2 + height);
        ctx2.bezierCurveTo(x2 + rx - KAPPA * rx, y2 + height, x2, y2 + height - ry + KAPPA * ry, x2, y2 + height - ry);
        ctx2.lineTo(x2, y2 + ry);
        ctx2.bezierCurveTo(x2, y2 + ry - KAPPA * ry, x2 + rx - KAPPA * rx, y2, x2 + rx, y2);
        ctx2.closePath();
      }
    }
    return new BoundingBox(x2, y2, x2 + width, y2 + height);
  }
  getMarkers() {
    return null;
  }
  constructor(...args) {
    super(...args);
    this.type = "rect";
  }
}
class CircleElement extends PathElement {
  path(ctx2) {
    const cx = this.getAttribute("cx").getPixels("x");
    const cy = this.getAttribute("cy").getPixels("y");
    const r2 = this.getAttribute("r").getPixels();
    if (ctx2 && r2 > 0) {
      ctx2.beginPath();
      ctx2.arc(cx, cy, r2, 0, Math.PI * 2, false);
      ctx2.closePath();
    }
    return new BoundingBox(cx - r2, cy - r2, cx + r2, cy + r2);
  }
  getMarkers() {
    return null;
  }
  constructor(...args) {
    super(...args);
    this.type = "circle";
  }
}
class EllipseElement extends PathElement {
  path(ctx2) {
    const KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
    const rx = this.getAttribute("rx").getPixels("x");
    const ry = this.getAttribute("ry").getPixels("y");
    const cx = this.getAttribute("cx").getPixels("x");
    const cy = this.getAttribute("cy").getPixels("y");
    if (ctx2 && rx > 0 && ry > 0) {
      ctx2.beginPath();
      ctx2.moveTo(cx + rx, cy);
      ctx2.bezierCurveTo(cx + rx, cy + KAPPA * ry, cx + KAPPA * rx, cy + ry, cx, cy + ry);
      ctx2.bezierCurveTo(cx - KAPPA * rx, cy + ry, cx - rx, cy + KAPPA * ry, cx - rx, cy);
      ctx2.bezierCurveTo(cx - rx, cy - KAPPA * ry, cx - KAPPA * rx, cy - ry, cx, cy - ry);
      ctx2.bezierCurveTo(cx + KAPPA * rx, cy - ry, cx + rx, cy - KAPPA * ry, cx + rx, cy);
      ctx2.closePath();
    }
    return new BoundingBox(cx - rx, cy - ry, cx + rx, cy + ry);
  }
  getMarkers() {
    return null;
  }
  constructor(...args) {
    super(...args);
    this.type = "ellipse";
  }
}
class LineElement extends PathElement {
  getPoints() {
    return [
      new Point$2(this.getAttribute("x1").getPixels("x"), this.getAttribute("y1").getPixels("y")),
      new Point$2(this.getAttribute("x2").getPixels("x"), this.getAttribute("y2").getPixels("y"))
    ];
  }
  path(ctx2) {
    const [{ x: x0, y: y0 }, { x: x1, y: y1 }] = this.getPoints();
    if (ctx2) {
      ctx2.beginPath();
      ctx2.moveTo(x0, y0);
      ctx2.lineTo(x1, y1);
    }
    return new BoundingBox(x0, y0, x1, y1);
  }
  getMarkers() {
    const [p0, p1] = this.getPoints();
    const a2 = p0.angleTo(p1);
    return [
      [
        p0,
        a2
      ],
      [
        p1,
        a2
      ]
    ];
  }
  constructor(...args) {
    super(...args);
    this.type = "line";
  }
}
class PolylineElement extends PathElement {
  path(ctx2) {
    const { points } = this;
    const [{ x: x0, y: y0 }] = points;
    const boundingBox = new BoundingBox(x0, y0);
    if (ctx2) {
      ctx2.beginPath();
      ctx2.moveTo(x0, y0);
    }
    points.forEach((param) => {
      let { x: x2, y: y2 } = param;
      boundingBox.addPoint(x2, y2);
      if (ctx2) {
        ctx2.lineTo(x2, y2);
      }
    });
    return boundingBox;
  }
  getMarkers() {
    const { points } = this;
    const lastIndex = points.length - 1;
    const markers = [];
    points.forEach((point2, i2) => {
      if (i2 === lastIndex) {
        return;
      }
      markers.push([
        point2,
        point2.angleTo(points[i2 + 1])
      ]);
    });
    if (markers.length > 0) {
      markers.push([
        points[points.length - 1],
        markers[markers.length - 1][1]
      ]);
    }
    return markers;
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "polyline";
    this.points = [];
    this.points = Point$2.parsePath(this.getAttribute("points").getString());
  }
}
class PolygonElement extends PolylineElement {
  path(ctx2) {
    const boundingBox = super.path(ctx2);
    const [{ x: x2, y: y2 }] = this.points;
    if (ctx2) {
      ctx2.lineTo(x2, y2);
      ctx2.closePath();
    }
    return boundingBox;
  }
  constructor(...args) {
    super(...args);
    this.type = "polygon";
  }
}
class PatternElement extends Element {
  createPattern(ctx2, _2, parentOpacityProp) {
    const width = this.getStyle("width").getPixels("x", true);
    const height = this.getStyle("height").getPixels("y", true);
    const patternSvg = new SVGElement(this.document, null);
    patternSvg.attributes.viewBox = new Property(this.document, "viewBox", this.getAttribute("viewBox").getValue());
    patternSvg.attributes.width = new Property(this.document, "width", "".concat(width, "px"));
    patternSvg.attributes.height = new Property(this.document, "height", "".concat(height, "px"));
    patternSvg.attributes.transform = new Property(this.document, "transform", this.getAttribute("patternTransform").getValue());
    patternSvg.children = this.children;
    const patternCanvas = this.document.createCanvas(width, height);
    const patternCtx = patternCanvas.getContext("2d");
    const xAttr = this.getAttribute("x");
    const yAttr = this.getAttribute("y");
    if (xAttr.hasValue() && yAttr.hasValue()) {
      patternCtx.translate(xAttr.getPixels("x", true), yAttr.getPixels("y", true));
    }
    if (parentOpacityProp.hasValue()) {
      this.styles["fill-opacity"] = parentOpacityProp;
    } else {
      Reflect.deleteProperty(this.styles, "fill-opacity");
    }
    for (let x2 = -1; x2 <= 1; x2++) {
      for (let y2 = -1; y2 <= 1; y2++) {
        patternCtx.save();
        patternSvg.attributes.x = new Property(this.document, "x", x2 * patternCanvas.width);
        patternSvg.attributes.y = new Property(this.document, "y", y2 * patternCanvas.height);
        patternSvg.render(patternCtx);
        patternCtx.restore();
      }
    }
    const pattern = ctx2.createPattern(patternCanvas, "repeat");
    return pattern;
  }
  constructor(...args) {
    super(...args);
    this.type = "pattern";
  }
}
class MarkerElement extends Element {
  render(ctx2, point2, angle) {
    if (!point2) {
      return;
    }
    const { x: x2, y: y2 } = point2;
    const orient = this.getAttribute("orient").getString("auto");
    const markerUnits = this.getAttribute("markerUnits").getString("strokeWidth");
    ctx2.translate(x2, y2);
    if (orient === "auto") {
      ctx2.rotate(angle);
    }
    if (markerUnits === "strokeWidth") {
      ctx2.scale(ctx2.lineWidth, ctx2.lineWidth);
    }
    ctx2.save();
    const markerSvg = new SVGElement(this.document);
    markerSvg.type = this.type;
    markerSvg.attributes.viewBox = new Property(this.document, "viewBox", this.getAttribute("viewBox").getValue());
    markerSvg.attributes.refX = new Property(this.document, "refX", this.getAttribute("refX").getValue());
    markerSvg.attributes.refY = new Property(this.document, "refY", this.getAttribute("refY").getValue());
    markerSvg.attributes.width = new Property(this.document, "width", this.getAttribute("markerWidth").getValue());
    markerSvg.attributes.height = new Property(this.document, "height", this.getAttribute("markerHeight").getValue());
    markerSvg.attributes.overflow = new Property(this.document, "overflow", this.getAttribute("overflow").getValue());
    markerSvg.attributes.fill = new Property(this.document, "fill", this.getAttribute("fill").getColor("black"));
    markerSvg.attributes.stroke = new Property(this.document, "stroke", this.getAttribute("stroke").getValue("none"));
    markerSvg.children = this.children;
    markerSvg.render(ctx2);
    ctx2.restore();
    if (markerUnits === "strokeWidth") {
      ctx2.scale(1 / ctx2.lineWidth, 1 / ctx2.lineWidth);
    }
    if (orient === "auto") {
      ctx2.rotate(-angle);
    }
    ctx2.translate(-x2, -y2);
  }
  constructor(...args) {
    super(...args);
    this.type = "marker";
  }
}
class DefsElement extends Element {
  render() {
  }
  constructor(...args) {
    super(...args);
    this.type = "defs";
  }
}
class GElement extends RenderedElement {
  getBoundingBox(ctx2) {
    const boundingBox = new BoundingBox();
    this.children.forEach((child) => {
      boundingBox.addBoundingBox(child.getBoundingBox(ctx2));
    });
    return boundingBox;
  }
  constructor(...args) {
    super(...args);
    this.type = "g";
  }
}
class GradientElement extends Element {
  getGradientUnits() {
    return this.getAttribute("gradientUnits").getString("objectBoundingBox");
  }
  createGradient(ctx2, element2, parentOpacityProp) {
    let stopsContainer = this;
    if (this.getHrefAttribute().hasValue()) {
      stopsContainer = this.getHrefAttribute().getDefinition();
      this.inheritStopContainer(stopsContainer);
    }
    const { stops } = stopsContainer;
    const gradient = this.getGradient(ctx2, element2);
    if (!gradient) {
      return this.addParentOpacity(parentOpacityProp, stops[stops.length - 1].color);
    }
    stops.forEach((stop) => {
      gradient.addColorStop(stop.offset, this.addParentOpacity(parentOpacityProp, stop.color));
    });
    if (this.getAttribute("gradientTransform").hasValue()) {
      const { document: document2 } = this;
      const { MAX_VIRTUAL_PIXELS } = Screen;
      const { viewPort } = document2.screen;
      const rootView = viewPort.getRoot();
      const rect = new RectElement(document2);
      rect.attributes.x = new Property(document2, "x", -MAX_VIRTUAL_PIXELS / 3);
      rect.attributes.y = new Property(document2, "y", -MAX_VIRTUAL_PIXELS / 3);
      rect.attributes.width = new Property(document2, "width", MAX_VIRTUAL_PIXELS);
      rect.attributes.height = new Property(document2, "height", MAX_VIRTUAL_PIXELS);
      const group = new GElement(document2);
      group.attributes.transform = new Property(document2, "transform", this.getAttribute("gradientTransform").getValue());
      group.children = [
        rect
      ];
      const patternSvg = new SVGElement(document2);
      patternSvg.attributes.x = new Property(document2, "x", 0);
      patternSvg.attributes.y = new Property(document2, "y", 0);
      patternSvg.attributes.width = new Property(document2, "width", rootView.width);
      patternSvg.attributes.height = new Property(document2, "height", rootView.height);
      patternSvg.children = [
        group
      ];
      const patternCanvas = document2.createCanvas(rootView.width, rootView.height);
      const patternCtx = patternCanvas.getContext("2d");
      patternCtx.fillStyle = gradient;
      patternSvg.render(patternCtx);
      return patternCtx.createPattern(patternCanvas, "no-repeat");
    }
    return gradient;
  }
  inheritStopContainer(stopsContainer) {
    this.attributesToInherit.forEach((attributeToInherit) => {
      if (!this.getAttribute(attributeToInherit).hasValue() && stopsContainer.getAttribute(attributeToInherit).hasValue()) {
        this.getAttribute(attributeToInherit, true).setValue(stopsContainer.getAttribute(attributeToInherit).getValue());
      }
    });
  }
  addParentOpacity(parentOpacityProp, color2) {
    if (parentOpacityProp.hasValue()) {
      const colorProp = new Property(this.document, "color", color2);
      return colorProp.addOpacity(parentOpacityProp).getColor();
    }
    return color2;
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.attributesToInherit = [
      "gradientUnits"
    ];
    this.stops = [];
    const { stops, children: children2 } = this;
    children2.forEach((child) => {
      if (child.type === "stop") {
        stops.push(child);
      }
    });
  }
}
class LinearGradientElement extends GradientElement {
  getGradient(ctx2, element2) {
    const isBoundingBoxUnits = this.getGradientUnits() === "objectBoundingBox";
    const boundingBox = isBoundingBoxUnits ? element2.getBoundingBox(ctx2) : null;
    if (isBoundingBoxUnits && !boundingBox) {
      return null;
    }
    if (!this.getAttribute("x1").hasValue() && !this.getAttribute("y1").hasValue() && !this.getAttribute("x2").hasValue() && !this.getAttribute("y2").hasValue()) {
      this.getAttribute("x1", true).setValue(0);
      this.getAttribute("y1", true).setValue(0);
      this.getAttribute("x2", true).setValue(1);
      this.getAttribute("y2", true).setValue(0);
    }
    const x1 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute("x1").getNumber() : this.getAttribute("x1").getPixels("x");
    const y1 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute("y1").getNumber() : this.getAttribute("y1").getPixels("y");
    const x2 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute("x2").getNumber() : this.getAttribute("x2").getPixels("x");
    const y2 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute("y2").getNumber() : this.getAttribute("y2").getPixels("y");
    if (x1 === x2 && y1 === y2) {
      return null;
    }
    return ctx2.createLinearGradient(x1, y1, x2, y2);
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "linearGradient";
    this.attributesToInherit.push("x1", "y1", "x2", "y2");
  }
}
class RadialGradientElement extends GradientElement {
  getGradient(ctx2, element2) {
    const isBoundingBoxUnits = this.getGradientUnits() === "objectBoundingBox";
    const boundingBox = element2.getBoundingBox(ctx2);
    if (isBoundingBoxUnits && !boundingBox) {
      return null;
    }
    if (!this.getAttribute("cx").hasValue()) {
      this.getAttribute("cx", true).setValue("50%");
    }
    if (!this.getAttribute("cy").hasValue()) {
      this.getAttribute("cy", true).setValue("50%");
    }
    if (!this.getAttribute("r").hasValue()) {
      this.getAttribute("r", true).setValue("50%");
    }
    const cx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute("cx").getNumber() : this.getAttribute("cx").getPixels("x");
    const cy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute("cy").getNumber() : this.getAttribute("cy").getPixels("y");
    let fx = cx;
    let fy = cy;
    if (this.getAttribute("fx").hasValue()) {
      fx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute("fx").getNumber() : this.getAttribute("fx").getPixels("x");
    }
    if (this.getAttribute("fy").hasValue()) {
      fy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute("fy").getNumber() : this.getAttribute("fy").getPixels("y");
    }
    const r2 = isBoundingBoxUnits ? (boundingBox.width + boundingBox.height) / 2 * this.getAttribute("r").getNumber() : this.getAttribute("r").getPixels();
    const fr = this.getAttribute("fr").getPixels();
    return ctx2.createRadialGradient(fx, fy, fr, cx, cy, r2);
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "radialGradient";
    this.attributesToInherit.push("cx", "cy", "r", "fx", "fy", "fr");
  }
}
class StopElement extends Element {
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "stop";
    const offset = Math.max(0, Math.min(1, this.getAttribute("offset").getNumber()));
    const stopOpacity = this.getStyle("stop-opacity");
    let stopColor = this.getStyle("stop-color", true);
    if (stopColor.getString() === "") {
      stopColor.setValue("#000");
    }
    if (stopOpacity.hasValue()) {
      stopColor = stopColor.addOpacity(stopOpacity);
    }
    this.offset = offset;
    this.color = stopColor.getColor();
  }
}
class AnimateElement extends Element {
  getProperty() {
    const attributeType = this.getAttribute("attributeType").getString();
    const attributeName = this.getAttribute("attributeName").getString();
    if (attributeType === "CSS") {
      return this.parent.getStyle(attributeName, true);
    }
    return this.parent.getAttribute(attributeName, true);
  }
  calcValue() {
    const { initialUnits } = this;
    const { progress, from: from2, to } = this.getProgress();
    let newValue = from2.getNumber() + (to.getNumber() - from2.getNumber()) * progress;
    if (initialUnits === "%") {
      newValue *= 100;
    }
    return "".concat(newValue).concat(initialUnits);
  }
  update(delta) {
    const { parent } = this;
    const prop = this.getProperty();
    if (!this.initialValue) {
      this.initialValue = prop.getString();
      this.initialUnits = prop.getUnits();
    }
    if (this.duration > this.maxDuration) {
      const fill = this.getAttribute("fill").getString("remove");
      if (this.getAttribute("repeatCount").getString() === "indefinite" || this.getAttribute("repeatDur").getString() === "indefinite") {
        this.duration = 0;
      } else if (fill === "freeze" && !this.frozen) {
        this.frozen = true;
        if (parent && prop) {
          parent.animationFrozen = true;
          parent.animationFrozenValue = prop.getString();
        }
      } else if (fill === "remove" && !this.removed) {
        this.removed = true;
        if (parent && prop) {
          prop.setValue(parent.animationFrozen ? parent.animationFrozenValue : this.initialValue);
        }
        return true;
      }
      return false;
    }
    this.duration += delta;
    let updated = false;
    if (this.begin < this.duration) {
      let newValue = this.calcValue();
      const typeAttr = this.getAttribute("type");
      if (typeAttr.hasValue()) {
        const type2 = typeAttr.getString();
        newValue = "".concat(type2, "(").concat(newValue, ")");
      }
      prop.setValue(newValue);
      updated = true;
    }
    return updated;
  }
  getProgress() {
    const { document: document2, values } = this;
    let progress = (this.duration - this.begin) / (this.maxDuration - this.begin);
    let from2;
    let to;
    if (values.hasValue()) {
      const p2 = progress * (values.getValue().length - 1);
      const lb = Math.floor(p2);
      const ub = Math.ceil(p2);
      let value;
      value = values.getValue()[lb];
      from2 = new Property(document2, "from", value ? parseFloat(value) : 0);
      value = values.getValue()[ub];
      to = new Property(document2, "to", value ? parseFloat(value) : 0);
      progress = (p2 - lb) / (ub - lb);
    } else {
      from2 = this.from;
      to = this.to;
    }
    return {
      progress,
      from: from2,
      to
    };
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "animate";
    this.duration = 0;
    this.initialUnits = "";
    this.removed = false;
    this.frozen = false;
    document2.screen.animations.push(this);
    this.begin = this.getAttribute("begin").getMilliseconds();
    this.maxDuration = this.begin + this.getAttribute("dur").getMilliseconds();
    this.from = this.getAttribute("from");
    this.to = this.getAttribute("to");
    this.values = new Property(document2, "values", null);
    const valuesAttr = this.getAttribute("values");
    if (valuesAttr.hasValue()) {
      this.values.setValue(valuesAttr.getString().split(";"));
    }
  }
}
class AnimateColorElement extends AnimateElement {
  calcValue() {
    const { progress, from: from2, to } = this.getProgress();
    const colorFrom = new RGBColor$1(from2.getColor());
    const colorTo = new RGBColor$1(to.getColor());
    if (colorFrom.ok && colorTo.ok) {
      const r2 = colorFrom.r + (colorTo.r - colorFrom.r) * progress;
      const g = colorFrom.g + (colorTo.g - colorFrom.g) * progress;
      const b = colorFrom.b + (colorTo.b - colorFrom.b) * progress;
      return "rgb(".concat(Math.floor(r2), ", ").concat(Math.floor(g), ", ").concat(Math.floor(b), ")");
    }
    return this.getAttribute("from").getColor();
  }
  constructor(...args) {
    super(...args);
    this.type = "animateColor";
  }
}
class AnimateTransformElement extends AnimateElement {
  calcValue() {
    const { progress, from: from1, to: to1 } = this.getProgress();
    const transformFrom = toNumbers(from1.getString());
    const transformTo = toNumbers(to1.getString());
    const newValue = transformFrom.map((from2, i2) => {
      const to = transformTo[i2];
      return from2 + (to - from2) * progress;
    }).join(" ");
    return newValue;
  }
  constructor(...args) {
    super(...args);
    this.type = "animateTransform";
  }
}
class FontFaceElement extends Element {
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "font-face";
    this.ascent = this.getAttribute("ascent").getNumber();
    this.descent = this.getAttribute("descent").getNumber();
    this.unitsPerEm = this.getAttribute("units-per-em").getNumber();
  }
}
class GlyphElement extends PathElement {
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "glyph";
    this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
    this.unicode = this.getAttribute("unicode").getString();
    this.arabicForm = this.getAttribute("arabic-form").getString();
  }
}
class MissingGlyphElement extends GlyphElement {
  constructor(...args) {
    super(...args);
    this.type = "missing-glyph";
    this.horizAdvX = 0;
  }
}
class FontElement extends Element {
  render() {
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "font";
    this.isArabic = false;
    this.glyphs = {};
    this.arabicGlyphs = {};
    this.isRTL = false;
    this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
    const { definitions } = document2;
    const { children: children2 } = this;
    for (const child of children2) {
      if (child instanceof FontFaceElement) {
        this.fontFace = child;
        const fontFamilyStyle = child.getStyle("font-family");
        if (fontFamilyStyle.hasValue()) {
          definitions[fontFamilyStyle.getString()] = this;
        }
      } else if (child instanceof MissingGlyphElement) {
        this.missingGlyph = child;
      } else if (child instanceof GlyphElement) {
        if (child.arabicForm) {
          this.isRTL = true;
          this.isArabic = true;
          const arabicGlyph = this.arabicGlyphs[child.unicode];
          if (typeof arabicGlyph === "undefined") {
            this.arabicGlyphs[child.unicode] = {
              [child.arabicForm]: child
            };
          } else {
            arabicGlyph[child.arabicForm] = child;
          }
        } else {
          this.glyphs[child.unicode] = child;
        }
      }
    }
  }
}
class TRefElement extends TextElement {
  getText() {
    const element2 = this.getHrefAttribute().getDefinition();
    if (element2) {
      const firstChild = element2.children[0];
      if (firstChild) {
        return firstChild.getText();
      }
    }
    return "";
  }
  constructor(...args) {
    super(...args);
    this.type = "tref";
  }
}
class AElement extends TextElement {
  getText() {
    return this.text;
  }
  renderChildren(ctx2) {
    if (this.hasText) {
      super.renderChildren(ctx2);
      const { document: document2, x: x2, y: y2 } = this;
      const { mouse } = document2.screen;
      const fontSize = new Property(document2, "fontSize", Font.parse(document2.ctx.font).fontSize);
      if (mouse.isWorking()) {
        mouse.checkBoundingBox(this, new BoundingBox(x2, y2 - fontSize.getPixels("y"), x2 + this.measureText(ctx2), y2));
      }
    } else if (this.children.length > 0) {
      const g = new GElement(this.document);
      g.children = this.children;
      g.parent = this;
      g.render(ctx2);
    }
  }
  onClick() {
    const { window: window2 } = this.document;
    if (window2) {
      window2.open(this.getHrefAttribute().getString());
    }
  }
  onMouseMove() {
    const ctx2 = this.document.ctx;
    ctx2.canvas.style.cursor = "pointer";
  }
  constructor(document2, node1, captureTextNodes) {
    super(document2, node1, captureTextNodes);
    this.type = "a";
    const { childNodes } = node1;
    const firstChild = childNodes[0];
    const hasText = childNodes.length > 0 && Array.from(childNodes).every(
      (node2) => node2.nodeType === 3
    );
    this.hasText = hasText;
    this.text = hasText ? this.getTextFromNode(firstChild) : "";
  }
}
class TextPathElement extends TextElement {
  getText() {
    return this.text;
  }
  path(ctx2) {
    const { dataArray } = this;
    if (ctx2) {
      ctx2.beginPath();
    }
    dataArray.forEach((param) => {
      let { type: type2, points } = param;
      switch (type2) {
        case PathParser.LINE_TO:
          if (ctx2) {
            ctx2.lineTo(points[0], points[1]);
          }
          break;
        case PathParser.MOVE_TO:
          if (ctx2) {
            ctx2.moveTo(points[0], points[1]);
          }
          break;
        case PathParser.CURVE_TO:
          if (ctx2) {
            ctx2.bezierCurveTo(points[0], points[1], points[2], points[3], points[4], points[5]);
          }
          break;
        case PathParser.QUAD_TO:
          if (ctx2) {
            ctx2.quadraticCurveTo(points[0], points[1], points[2], points[3]);
          }
          break;
        case PathParser.ARC: {
          const [cx, cy, rx, ry, theta, dTheta, psi, fs] = points;
          const r2 = rx > ry ? rx : ry;
          const scaleX = rx > ry ? 1 : rx / ry;
          const scaleY = rx > ry ? ry / rx : 1;
          if (ctx2) {
            ctx2.translate(cx, cy);
            ctx2.rotate(psi);
            ctx2.scale(scaleX, scaleY);
            ctx2.arc(0, 0, r2, theta, theta + dTheta, Boolean(1 - fs));
            ctx2.scale(1 / scaleX, 1 / scaleY);
            ctx2.rotate(-psi);
            ctx2.translate(-cx, -cy);
          }
          break;
        }
        case PathParser.CLOSE_PATH:
          if (ctx2) {
            ctx2.closePath();
          }
          break;
      }
    });
  }
  renderChildren(ctx2) {
    this.setTextData(ctx2);
    ctx2.save();
    const textDecoration = this.parent.getStyle("text-decoration").getString();
    const fontSize = this.getFontSize();
    const { glyphInfo } = this;
    const fill = ctx2.fillStyle;
    if (textDecoration === "underline") {
      ctx2.beginPath();
    }
    glyphInfo.forEach((glyph, i2) => {
      const { p0, p1, rotation, text: partialText } = glyph;
      ctx2.save();
      ctx2.translate(p0.x, p0.y);
      ctx2.rotate(rotation);
      if (ctx2.fillStyle) {
        ctx2.fillText(partialText, 0, 0);
      }
      if (ctx2.strokeStyle) {
        ctx2.strokeText(partialText, 0, 0);
      }
      ctx2.restore();
      if (textDecoration === "underline") {
        if (i2 === 0) {
          ctx2.moveTo(p0.x, p0.y + fontSize / 8);
        }
        ctx2.lineTo(p1.x, p1.y + fontSize / 5);
      }
    });
    if (textDecoration === "underline") {
      ctx2.lineWidth = fontSize / 20;
      ctx2.strokeStyle = fill;
      ctx2.stroke();
      ctx2.closePath();
    }
    ctx2.restore();
  }
  getLetterSpacingAt() {
    let idx = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return this.letterSpacingCache[idx] || 0;
  }
  findSegmentToFitChar(ctx2, anchor, textFullWidth, fullPathWidth, spacesNumber, inputOffset, dy, c2, charI) {
    let offset = inputOffset;
    let glyphWidth = this.measureText(ctx2, c2);
    if (c2 === " " && anchor === "justify" && textFullWidth < fullPathWidth) {
      glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
    }
    if (charI > -1) {
      offset += this.getLetterSpacingAt(charI);
    }
    const splineStep = this.textHeight / 20;
    const p0 = this.getEquidistantPointOnPath(offset, splineStep, 0);
    const p1 = this.getEquidistantPointOnPath(offset + glyphWidth, splineStep, 0);
    const segment = {
      p0,
      p1
    };
    const rotation = p0 && p1 ? Math.atan2(p1.y - p0.y, p1.x - p0.x) : 0;
    if (dy) {
      const dyX = Math.cos(Math.PI / 2 + rotation) * dy;
      const dyY = Math.cos(-rotation) * dy;
      segment.p0 = {
        ...p0,
        x: p0.x + dyX,
        y: p0.y + dyY
      };
      segment.p1 = {
        ...p1,
        x: p1.x + dyX,
        y: p1.y + dyY
      };
    }
    offset += glyphWidth;
    return {
      offset,
      segment,
      rotation
    };
  }
  measureText(ctx2, text2) {
    const { measuresCache } = this;
    const targetText = text2 || this.getText();
    if (measuresCache.has(targetText)) {
      return measuresCache.get(targetText);
    }
    const measure = this.measureTargetText(ctx2, targetText);
    measuresCache.set(targetText, measure);
    return measure;
  }
  // This method supposes what all custom fonts already loaded.
  // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
  // You need to call this method manually to update glyphs cache.
  setTextData(ctx2) {
    if (this.glyphInfo) {
      return;
    }
    const renderText = this.getText();
    const chars = renderText.split("");
    const spacesNumber = renderText.split(" ").length - 1;
    const dx = this.parent.getAttribute("dx").split().map(
      (_2) => _2.getPixels("x")
    );
    const dy = this.parent.getAttribute("dy").getPixels("y");
    const anchor = this.parent.getStyle("text-anchor").getString("start");
    const thisSpacing = this.getStyle("letter-spacing");
    const parentSpacing = this.parent.getStyle("letter-spacing");
    let letterSpacing = 0;
    if (!thisSpacing.hasValue() || thisSpacing.getValue() === "inherit") {
      letterSpacing = parentSpacing.getPixels();
    } else if (thisSpacing.hasValue()) {
      if (thisSpacing.getValue() !== "initial" && thisSpacing.getValue() !== "unset") {
        letterSpacing = thisSpacing.getPixels();
      }
    }
    const letterSpacingCache = [];
    const textLen = renderText.length;
    this.letterSpacingCache = letterSpacingCache;
    for (let i1 = 0; i1 < textLen; i1++) {
      letterSpacingCache.push(typeof dx[i1] !== "undefined" ? dx[i1] : letterSpacing);
    }
    const dxSum = letterSpacingCache.reduce(
      (acc, cur, i2) => i2 === 0 ? 0 : acc + cur || 0,
      0
    );
    const textWidth = this.measureText(ctx2);
    const textFullWidth = Math.max(textWidth + dxSum, 0);
    this.textWidth = textWidth;
    this.textHeight = this.getFontSize();
    this.glyphInfo = [];
    const fullPathWidth = this.getPathLength();
    const startOffset = this.getStyle("startOffset").getNumber(0) * fullPathWidth;
    let offset = 0;
    if (anchor === "middle" || anchor === "center") {
      offset = -textFullWidth / 2;
    }
    if (anchor === "end" || anchor === "right") {
      offset = -textFullWidth;
    }
    offset += startOffset;
    chars.forEach((char2, i2) => {
      const { offset: nextOffset, segment, rotation } = this.findSegmentToFitChar(ctx2, anchor, textFullWidth, fullPathWidth, spacesNumber, offset, dy, char2, i2);
      offset = nextOffset;
      if (!segment.p0 || !segment.p1) {
        return;
      }
      this.glyphInfo.push({
        // transposeX: midpoint.x,
        // transposeY: midpoint.y,
        text: chars[i2],
        p0: segment.p0,
        p1: segment.p1,
        rotation
      });
    });
  }
  parsePathData(path) {
    this.pathLength = -1;
    if (!path) {
      return [];
    }
    const pathCommands = [];
    const { pathParser } = path;
    pathParser.reset();
    while (!pathParser.isEnd()) {
      const { current } = pathParser;
      const startX = current ? current.x : 0;
      const startY = current ? current.y : 0;
      const command = pathParser.next();
      let nextCommandType = command.type;
      let points = [];
      switch (command.type) {
        case PathParser.MOVE_TO:
          this.pathM(pathParser, points);
          break;
        case PathParser.LINE_TO:
          nextCommandType = this.pathL(pathParser, points);
          break;
        case PathParser.HORIZ_LINE_TO:
          nextCommandType = this.pathH(pathParser, points);
          break;
        case PathParser.VERT_LINE_TO:
          nextCommandType = this.pathV(pathParser, points);
          break;
        case PathParser.CURVE_TO:
          this.pathC(pathParser, points);
          break;
        case PathParser.SMOOTH_CURVE_TO:
          nextCommandType = this.pathS(pathParser, points);
          break;
        case PathParser.QUAD_TO:
          this.pathQ(pathParser, points);
          break;
        case PathParser.SMOOTH_QUAD_TO:
          nextCommandType = this.pathT(pathParser, points);
          break;
        case PathParser.ARC:
          points = this.pathA(pathParser);
          break;
        case PathParser.CLOSE_PATH:
          PathElement.pathZ(pathParser);
          break;
      }
      if (command.type !== PathParser.CLOSE_PATH) {
        pathCommands.push({
          type: nextCommandType,
          points,
          start: {
            x: startX,
            y: startY
          },
          pathLength: this.calcLength(startX, startY, nextCommandType, points)
        });
      } else {
        pathCommands.push({
          type: PathParser.CLOSE_PATH,
          points: [],
          pathLength: 0
        });
      }
    }
    return pathCommands;
  }
  pathM(pathParser, points) {
    const { x: x2, y: y2 } = PathElement.pathM(pathParser).point;
    points.push(x2, y2);
  }
  pathL(pathParser, points) {
    const { x: x2, y: y2 } = PathElement.pathL(pathParser).point;
    points.push(x2, y2);
    return PathParser.LINE_TO;
  }
  pathH(pathParser, points) {
    const { x: x2, y: y2 } = PathElement.pathH(pathParser).point;
    points.push(x2, y2);
    return PathParser.LINE_TO;
  }
  pathV(pathParser, points) {
    const { x: x2, y: y2 } = PathElement.pathV(pathParser).point;
    points.push(x2, y2);
    return PathParser.LINE_TO;
  }
  pathC(pathParser, points) {
    const { point: point2, controlPoint, currentPoint } = PathElement.pathC(pathParser);
    points.push(point2.x, point2.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
  }
  pathS(pathParser, points) {
    const { point: point2, controlPoint, currentPoint } = PathElement.pathS(pathParser);
    points.push(point2.x, point2.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    return PathParser.CURVE_TO;
  }
  pathQ(pathParser, points) {
    const { controlPoint, currentPoint } = PathElement.pathQ(pathParser);
    points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
  }
  pathT(pathParser, points) {
    const { controlPoint, currentPoint } = PathElement.pathT(pathParser);
    points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    return PathParser.QUAD_TO;
  }
  pathA(pathParser) {
    let { rX, rY, sweepFlag, xAxisRotation, centp, a1, ad } = PathElement.pathA(pathParser);
    if (sweepFlag === 0 && ad > 0) {
      ad -= 2 * Math.PI;
    }
    if (sweepFlag === 1 && ad < 0) {
      ad += 2 * Math.PI;
    }
    return [
      centp.x,
      centp.y,
      rX,
      rY,
      a1,
      ad,
      xAxisRotation,
      sweepFlag
    ];
  }
  calcLength(x2, y2, commandType, points) {
    let len = 0;
    let p1 = null;
    let p2 = null;
    let t2 = 0;
    switch (commandType) {
      case PathParser.LINE_TO:
        return this.getLineLength(x2, y2, points[0], points[1]);
      case PathParser.CURVE_TO:
        len = 0;
        p1 = this.getPointOnCubicBezier(0, x2, y2, points[0], points[1], points[2], points[3], points[4], points[5]);
        for (t2 = 0.01; t2 <= 1; t2 += 0.01) {
          p2 = this.getPointOnCubicBezier(t2, x2, y2, points[0], points[1], points[2], points[3], points[4], points[5]);
          len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
          p1 = p2;
        }
        return len;
      case PathParser.QUAD_TO:
        len = 0;
        p1 = this.getPointOnQuadraticBezier(0, x2, y2, points[0], points[1], points[2], points[3]);
        for (t2 = 0.01; t2 <= 1; t2 += 0.01) {
          p2 = this.getPointOnQuadraticBezier(t2, x2, y2, points[0], points[1], points[2], points[3]);
          len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
          p1 = p2;
        }
        return len;
      case PathParser.ARC: {
        len = 0;
        const start = points[4];
        const dTheta = points[5];
        const end = points[4] + dTheta;
        let inc = Math.PI / 180;
        if (Math.abs(start - end) < inc) {
          inc = Math.abs(start - end);
        }
        p1 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
        if (dTheta < 0) {
          for (t2 = start - inc; t2 > end; t2 -= inc) {
            p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t2, 0);
            len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
            p1 = p2;
          }
        } else {
          for (t2 = start + inc; t2 < end; t2 += inc) {
            p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t2, 0);
            len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
            p1 = p2;
          }
        }
        p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
        len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
        return len;
      }
    }
    return 0;
  }
  getPointOnLine(dist2, p1x, p1y, p2x, p2y) {
    let fromX = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : p1x, fromY = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : p1y;
    const m2 = (p2y - p1y) / (p2x - p1x + PSEUDO_ZERO);
    let run2 = Math.sqrt(dist2 * dist2 / (1 + m2 * m2));
    if (p2x < p1x) {
      run2 *= -1;
    }
    let rise = m2 * run2;
    let pt = null;
    if (p2x === p1x) {
      pt = {
        x: fromX,
        y: fromY + rise
      };
    } else if ((fromY - p1y) / (fromX - p1x + PSEUDO_ZERO) === m2) {
      pt = {
        x: fromX + run2,
        y: fromY + rise
      };
    } else {
      let ix = 0;
      let iy = 0;
      const len = this.getLineLength(p1x, p1y, p2x, p2y);
      if (len < PSEUDO_ZERO) {
        return null;
      }
      let u2 = (fromX - p1x) * (p2x - p1x) + (fromY - p1y) * (p2y - p1y);
      u2 /= len * len;
      ix = p1x + u2 * (p2x - p1x);
      iy = p1y + u2 * (p2y - p1y);
      const pRise = this.getLineLength(fromX, fromY, ix, iy);
      const pRun = Math.sqrt(dist2 * dist2 - pRise * pRise);
      run2 = Math.sqrt(pRun * pRun / (1 + m2 * m2));
      if (p2x < p1x) {
        run2 *= -1;
      }
      rise = m2 * run2;
      pt = {
        x: ix + run2,
        y: iy + rise
      };
    }
    return pt;
  }
  getPointOnPath(distance2) {
    const fullLen = this.getPathLength();
    let cumulativePathLength = 0;
    let p2 = null;
    if (distance2 < -5e-5 || distance2 - 5e-5 > fullLen) {
      return null;
    }
    const { dataArray } = this;
    for (const command of dataArray) {
      if (command && (command.pathLength < 5e-5 || cumulativePathLength + command.pathLength + 5e-5 < distance2)) {
        cumulativePathLength += command.pathLength;
        continue;
      }
      const delta = distance2 - cumulativePathLength;
      let currentT = 0;
      switch (command.type) {
        case PathParser.LINE_TO:
          p2 = this.getPointOnLine(delta, command.start.x, command.start.y, command.points[0], command.points[1], command.start.x, command.start.y);
          break;
        case PathParser.ARC: {
          const start = command.points[4];
          const dTheta = command.points[5];
          const end = command.points[4] + dTheta;
          currentT = start + delta / command.pathLength * dTheta;
          if (dTheta < 0 && currentT < end || dTheta >= 0 && currentT > end) {
            break;
          }
          p2 = this.getPointOnEllipticalArc(command.points[0], command.points[1], command.points[2], command.points[3], currentT, command.points[6]);
          break;
        }
        case PathParser.CURVE_TO:
          currentT = delta / command.pathLength;
          if (currentT > 1) {
            currentT = 1;
          }
          p2 = this.getPointOnCubicBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3], command.points[4], command.points[5]);
          break;
        case PathParser.QUAD_TO:
          currentT = delta / command.pathLength;
          if (currentT > 1) {
            currentT = 1;
          }
          p2 = this.getPointOnQuadraticBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3]);
          break;
      }
      if (p2) {
        return p2;
      }
      break;
    }
    return null;
  }
  getLineLength(x1, y1, x2, y2) {
    return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
  }
  getPathLength() {
    if (this.pathLength === -1) {
      this.pathLength = this.dataArray.reduce(
        (length2, command) => command.pathLength > 0 ? length2 + command.pathLength : length2,
        0
      );
    }
    return this.pathLength;
  }
  getPointOnCubicBezier(pct, p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
    const x2 = p4x * CB1(pct) + p3x * CB2(pct) + p2x * CB3(pct) + p1x * CB4(pct);
    const y2 = p4y * CB1(pct) + p3y * CB2(pct) + p2y * CB3(pct) + p1y * CB4(pct);
    return {
      x: x2,
      y: y2
    };
  }
  getPointOnQuadraticBezier(pct, p1x, p1y, p2x, p2y, p3x, p3y) {
    const x2 = p3x * QB1(pct) + p2x * QB2(pct) + p1x * QB3(pct);
    const y2 = p3y * QB1(pct) + p2y * QB2(pct) + p1y * QB3(pct);
    return {
      x: x2,
      y: y2
    };
  }
  getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
    const cosPsi = Math.cos(psi);
    const sinPsi = Math.sin(psi);
    const pt = {
      x: rx * Math.cos(theta),
      y: ry * Math.sin(theta)
    };
    return {
      x: cx + (pt.x * cosPsi - pt.y * sinPsi),
      y: cy + (pt.x * sinPsi + pt.y * cosPsi)
    };
  }
  // TODO need some optimisations. possibly build cache only for curved segments?
  buildEquidistantCache(inputStep, inputPrecision) {
    const fullLen = this.getPathLength();
    const precision = inputPrecision || 0.25;
    const step = inputStep || fullLen / 100;
    if (!this.equidistantCache || this.equidistantCache.step !== step || this.equidistantCache.precision !== precision) {
      this.equidistantCache = {
        step,
        precision,
        points: []
      };
      let s2 = 0;
      for (let l2 = 0; l2 <= fullLen; l2 += precision) {
        const p0 = this.getPointOnPath(l2);
        const p1 = this.getPointOnPath(l2 + precision);
        if (!p0 || !p1) {
          continue;
        }
        s2 += this.getLineLength(p0.x, p0.y, p1.x, p1.y);
        if (s2 >= step) {
          this.equidistantCache.points.push({
            x: p0.x,
            y: p0.y,
            distance: l2
          });
          s2 -= step;
        }
      }
    }
  }
  getEquidistantPointOnPath(targetDistance, step, precision) {
    this.buildEquidistantCache(step, precision);
    if (targetDistance < 0 || targetDistance - this.getPathLength() > 5e-5) {
      return null;
    }
    const idx = Math.round(targetDistance / this.getPathLength() * (this.equidistantCache.points.length - 1));
    return this.equidistantCache.points[idx] || null;
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "textPath";
    this.textWidth = 0;
    this.textHeight = 0;
    this.pathLength = -1;
    this.glyphInfo = null;
    this.letterSpacingCache = [];
    this.measuresCache = /* @__PURE__ */ new Map([
      [
        "",
        0
      ]
    ]);
    const pathElement = this.getHrefAttribute().getDefinition();
    this.text = this.getTextFromNode();
    this.dataArray = this.parsePathData(pathElement);
  }
}
const dataUriRegex = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
class ImageElement extends RenderedElement {
  async loadImage(href) {
    try {
      const image = await this.document.createImage(href);
      this.image = image;
    } catch (err) {
      console.error('Error while loading image "'.concat(href, '":'), err);
    }
    this.loaded = true;
  }
  async loadSvg(href) {
    const match2 = dataUriRegex.exec(href);
    if (match2) {
      const data = match2[5];
      if (data) {
        if (match2[4] === "base64") {
          this.image = atob(data);
        } else {
          this.image = decodeURIComponent(data);
        }
      }
    } else {
      try {
        const response = await this.document.fetch(href);
        const svg = await response.text();
        this.image = svg;
      } catch (err) {
        console.error('Error while loading image "'.concat(href, '":'), err);
      }
    }
    this.loaded = true;
  }
  renderChildren(ctx2) {
    const { document: document2, image, loaded } = this;
    const x2 = this.getAttribute("x").getPixels("x");
    const y2 = this.getAttribute("y").getPixels("y");
    const width = this.getStyle("width").getPixels("x");
    const height = this.getStyle("height").getPixels("y");
    if (!loaded || !image || !width || !height) {
      return;
    }
    ctx2.save();
    ctx2.translate(x2, y2);
    if (typeof image === "string") {
      const subDocument = document2.canvg.forkString(ctx2, image, {
        ignoreMouse: true,
        ignoreAnimation: true,
        ignoreDimensions: true,
        ignoreClear: true,
        offsetX: 0,
        offsetY: 0,
        scaleWidth: width,
        scaleHeight: height
      });
      const { documentElement } = subDocument.document;
      if (documentElement) {
        documentElement.parent = this;
      }
      void subDocument.render();
    } else {
      document2.setViewBox({
        ctx: ctx2,
        aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
        width,
        desiredWidth: image.width,
        height,
        desiredHeight: image.height
      });
      if (this.loaded) {
        if (!("complete" in image) || image.complete) {
          ctx2.drawImage(image, 0, 0);
        }
      }
    }
    ctx2.restore();
  }
  getBoundingBox() {
    const x2 = this.getAttribute("x").getPixels("x");
    const y2 = this.getAttribute("y").getPixels("y");
    const width = this.getStyle("width").getPixels("x");
    const height = this.getStyle("height").getPixels("y");
    return new BoundingBox(x2, y2, x2 + width, y2 + height);
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "image";
    this.loaded = false;
    const href = this.getHrefAttribute().getString();
    if (!href) {
      return;
    }
    const isSvg = href.endsWith(".svg") || /^\s*data:image\/svg\+xml/i.test(href);
    document2.images.push(this);
    if (!isSvg) {
      void this.loadImage(href);
    } else {
      void this.loadSvg(href);
    }
  }
}
class SymbolElement extends RenderedElement {
  render(_2) {
  }
  constructor(...args) {
    super(...args);
    this.type = "symbol";
  }
}
class SVGFontLoader {
  async load(fontFamily, url) {
    try {
      const { document: document2 } = this;
      const svgDocument = await document2.canvg.parser.load(url);
      const fonts = svgDocument.getElementsByTagName("font");
      Array.from(fonts).forEach((fontNode) => {
        const font = document2.createElement(fontNode);
        document2.definitions[fontFamily] = font;
      });
    } catch (err) {
      console.error('Error while loading font "'.concat(url, '":'), err);
    }
    this.loaded = true;
  }
  constructor(document2) {
    this.document = document2;
    this.loaded = false;
    document2.fonts.push(this);
  }
}
class StyleElement extends Element {
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "style";
    const css = compressSpaces(
      Array.from(node2.childNodes).map(
        (_2) => _2.textContent
      ).join("").replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "").replace(/@import.*;/g, "")
      // remove imports
    );
    const cssDefs = css.split("}");
    cssDefs.forEach((_1) => {
      const def = _1.trim();
      if (!def) {
        return;
      }
      const cssParts = def.split("{");
      const cssClasses = cssParts[0].split(",");
      const cssProps = cssParts[1].split(";");
      cssClasses.forEach((_2) => {
        const cssClass = _2.trim();
        if (!cssClass) {
          return;
        }
        const props = document2.styles[cssClass] || {};
        cssProps.forEach((cssProp) => {
          const prop = cssProp.indexOf(":");
          const name = cssProp.substr(0, prop).trim();
          const value = cssProp.substr(prop + 1, cssProp.length - prop).trim();
          if (name && value) {
            props[name] = new Property(document2, name, value);
          }
        });
        document2.styles[cssClass] = props;
        document2.stylesSpecificity[cssClass] = getSelectorSpecificity(cssClass);
        if (cssClass === "@font-face") {
          const fontFamily = props["font-family"].getString().replace(/"|'/g, "");
          const srcs = props.src.getString().split(",");
          srcs.forEach((src) => {
            if (src.indexOf('format("svg")') > 0) {
              const url = parseExternalUrl(src);
              if (url) {
                void new SVGFontLoader(document2).load(fontFamily, url);
              }
            }
          });
        }
      });
    });
  }
}
StyleElement.parseExternalUrl = parseExternalUrl;
class UseElement extends RenderedElement {
  setContext(ctx2) {
    super.setContext(ctx2);
    const xAttr = this.getAttribute("x");
    const yAttr = this.getAttribute("y");
    if (xAttr.hasValue()) {
      ctx2.translate(xAttr.getPixels("x"), 0);
    }
    if (yAttr.hasValue()) {
      ctx2.translate(0, yAttr.getPixels("y"));
    }
  }
  path(ctx2) {
    const { element: element2 } = this;
    if (element2) {
      element2.path(ctx2);
    }
  }
  renderChildren(ctx2) {
    const { document: document2, element: element2 } = this;
    if (element2) {
      let tempSvg = element2;
      if (element2.type === "symbol") {
        tempSvg = new SVGElement(document2);
        tempSvg.attributes.viewBox = new Property(document2, "viewBox", element2.getAttribute("viewBox").getString());
        tempSvg.attributes.preserveAspectRatio = new Property(document2, "preserveAspectRatio", element2.getAttribute("preserveAspectRatio").getString());
        tempSvg.attributes.overflow = new Property(document2, "overflow", element2.getAttribute("overflow").getString());
        tempSvg.children = element2.children;
        element2.styles.opacity = new Property(document2, "opacity", this.calculateOpacity());
      }
      if (tempSvg.type === "svg") {
        const widthStyle = this.getStyle("width", false, true);
        const heightStyle = this.getStyle("height", false, true);
        if (widthStyle.hasValue()) {
          tempSvg.attributes.width = new Property(document2, "width", widthStyle.getString());
        }
        if (heightStyle.hasValue()) {
          tempSvg.attributes.height = new Property(document2, "height", heightStyle.getString());
        }
      }
      const oldParent = tempSvg.parent;
      tempSvg.parent = this;
      tempSvg.render(ctx2);
      tempSvg.parent = oldParent;
    }
  }
  getBoundingBox(ctx2) {
    const { element: element2 } = this;
    if (element2) {
      return element2.getBoundingBox(ctx2);
    }
    return null;
  }
  elementTransform() {
    const { document: document2, element: element2 } = this;
    if (!element2) {
      return null;
    }
    return Transform$1.fromElement(document2, element2);
  }
  get element() {
    if (!this.cachedElement) {
      this.cachedElement = this.getHrefAttribute().getDefinition();
    }
    return this.cachedElement;
  }
  constructor(...args) {
    super(...args);
    this.type = "use";
  }
}
function imGet(img, x2, y2, width, _height, rgba2) {
  return img[y2 * width * 4 + x2 * 4 + rgba2];
}
function imSet(img, x2, y2, width, _height, rgba2, val) {
  img[y2 * width * 4 + x2 * 4 + rgba2] = val;
}
function m$1(matrix, i2, v2) {
  const mi = matrix[i2];
  return mi * v2;
}
function c$1(a2, m1, m2, m3) {
  return m1 + Math.cos(a2) * m2 + Math.sin(a2) * m3;
}
class FeColorMatrixElement extends Element {
  apply(ctx2, _x, _y, width, height) {
    const { includeOpacity, matrix } = this;
    const srcData = ctx2.getImageData(0, 0, width, height);
    for (let y2 = 0; y2 < height; y2++) {
      for (let x2 = 0; x2 < width; x2++) {
        const r2 = imGet(srcData.data, x2, y2, width, height, 0);
        const g = imGet(srcData.data, x2, y2, width, height, 1);
        const b = imGet(srcData.data, x2, y2, width, height, 2);
        const a2 = imGet(srcData.data, x2, y2, width, height, 3);
        let nr = m$1(matrix, 0, r2) + m$1(matrix, 1, g) + m$1(matrix, 2, b) + m$1(matrix, 3, a2) + m$1(matrix, 4, 1);
        let ng = m$1(matrix, 5, r2) + m$1(matrix, 6, g) + m$1(matrix, 7, b) + m$1(matrix, 8, a2) + m$1(matrix, 9, 1);
        let nb = m$1(matrix, 10, r2) + m$1(matrix, 11, g) + m$1(matrix, 12, b) + m$1(matrix, 13, a2) + m$1(matrix, 14, 1);
        let na = m$1(matrix, 15, r2) + m$1(matrix, 16, g) + m$1(matrix, 17, b) + m$1(matrix, 18, a2) + m$1(matrix, 19, 1);
        if (includeOpacity) {
          nr = 0;
          ng = 0;
          nb = 0;
          na *= a2 / 255;
        }
        imSet(srcData.data, x2, y2, width, height, 0, nr);
        imSet(srcData.data, x2, y2, width, height, 1, ng);
        imSet(srcData.data, x2, y2, width, height, 2, nb);
        imSet(srcData.data, x2, y2, width, height, 3, na);
      }
    }
    ctx2.clearRect(0, 0, width, height);
    ctx2.putImageData(srcData, 0, 0);
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "feColorMatrix";
    let matrix = toNumbers(this.getAttribute("values").getString());
    switch (this.getAttribute("type").getString("matrix")) {
      case "saturate": {
        const s2 = matrix[0];
        matrix = [
          0.213 + 0.787 * s2,
          0.715 - 0.715 * s2,
          0.072 - 0.072 * s2,
          0,
          0,
          0.213 - 0.213 * s2,
          0.715 + 0.285 * s2,
          0.072 - 0.072 * s2,
          0,
          0,
          0.213 - 0.213 * s2,
          0.715 - 0.715 * s2,
          0.072 + 0.928 * s2,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1
        ];
        break;
      }
      case "hueRotate": {
        const a2 = matrix[0] * Math.PI / 180;
        matrix = [
          c$1(a2, 0.213, 0.787, -0.213),
          c$1(a2, 0.715, -0.715, -0.715),
          c$1(a2, 0.072, -0.072, 0.928),
          0,
          0,
          c$1(a2, 0.213, -0.213, 0.143),
          c$1(a2, 0.715, 0.285, 0.14),
          c$1(a2, 0.072, -0.072, -0.283),
          0,
          0,
          c$1(a2, 0.213, -0.213, -0.787),
          c$1(a2, 0.715, -0.715, 0.715),
          c$1(a2, 0.072, 0.928, 0.072),
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1
        ];
        break;
      }
      case "luminanceToAlpha":
        matrix = [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.2125,
          0.7154,
          0.0721,
          0,
          0,
          0,
          0,
          0,
          0,
          1
        ];
        break;
    }
    this.matrix = matrix;
    this.includeOpacity = this.getAttribute("includeOpacity").hasValue();
  }
}
class MaskElement extends Element {
  apply(ctx2, element2) {
    const { document: document2 } = this;
    let x2 = this.getAttribute("x").getPixels("x");
    let y2 = this.getAttribute("y").getPixels("y");
    let width = this.getStyle("width").getPixels("x");
    let height = this.getStyle("height").getPixels("y");
    if (!width && !height) {
      const boundingBox = new BoundingBox();
      this.children.forEach((child) => {
        boundingBox.addBoundingBox(child.getBoundingBox(ctx2));
      });
      x2 = Math.floor(boundingBox.x1);
      y2 = Math.floor(boundingBox.y1);
      width = Math.floor(boundingBox.width);
      height = Math.floor(boundingBox.height);
    }
    const ignoredStyles = this.removeStyles(element2, MaskElement.ignoreStyles);
    const maskCanvas = document2.createCanvas(x2 + width, y2 + height);
    const maskCtx = maskCanvas.getContext("2d");
    document2.screen.setDefaults(maskCtx);
    this.renderChildren(maskCtx);
    new FeColorMatrixElement(document2, {
      nodeType: 1,
      childNodes: [],
      attributes: [
        {
          nodeName: "type",
          value: "luminanceToAlpha"
        },
        {
          nodeName: "includeOpacity",
          value: "true"
        }
      ]
    }).apply(maskCtx, 0, 0, x2 + width, y2 + height);
    const tmpCanvas = document2.createCanvas(x2 + width, y2 + height);
    const tmpCtx = tmpCanvas.getContext("2d");
    document2.screen.setDefaults(tmpCtx);
    element2.render(tmpCtx);
    tmpCtx.globalCompositeOperation = "destination-in";
    tmpCtx.fillStyle = maskCtx.createPattern(maskCanvas, "no-repeat");
    tmpCtx.fillRect(0, 0, x2 + width, y2 + height);
    ctx2.fillStyle = tmpCtx.createPattern(tmpCanvas, "no-repeat");
    ctx2.fillRect(0, 0, x2 + width, y2 + height);
    this.restoreStyles(element2, ignoredStyles);
  }
  render(_2) {
  }
  constructor(...args) {
    super(...args);
    this.type = "mask";
  }
}
MaskElement.ignoreStyles = [
  "mask",
  "transform",
  "clip-path"
];
const noop$1 = () => {
};
class ClipPathElement extends Element {
  apply(ctx2) {
    const { document: document2 } = this;
    const contextProto = Reflect.getPrototypeOf(ctx2);
    const { beginPath, closePath } = ctx2;
    if (contextProto) {
      contextProto.beginPath = noop$1;
      contextProto.closePath = noop$1;
    }
    Reflect.apply(beginPath, ctx2, []);
    this.children.forEach((child) => {
      if (!("path" in child)) {
        return;
      }
      let transform = "elementTransform" in child ? child.elementTransform() : null;
      if (!transform) {
        transform = Transform$1.fromElement(document2, child);
      }
      if (transform) {
        transform.apply(ctx2);
      }
      child.path(ctx2);
      if (contextProto) {
        contextProto.closePath = closePath;
      }
      if (transform) {
        transform.unapply(ctx2);
      }
    });
    Reflect.apply(closePath, ctx2, []);
    ctx2.clip();
    if (contextProto) {
      contextProto.beginPath = beginPath;
      contextProto.closePath = closePath;
    }
  }
  render(_2) {
  }
  constructor(...args) {
    super(...args);
    this.type = "clipPath";
  }
}
class FilterElement extends Element {
  apply(ctx2, element2) {
    const { document: document2, children: children2 } = this;
    const boundingBox = "getBoundingBox" in element2 ? element2.getBoundingBox(ctx2) : null;
    if (!boundingBox) {
      return;
    }
    let px = 0;
    let py = 0;
    children2.forEach((child) => {
      const efd = child.extraFilterDistance || 0;
      px = Math.max(px, efd);
      py = Math.max(py, efd);
    });
    const width = Math.floor(boundingBox.width);
    const height = Math.floor(boundingBox.height);
    const tmpCanvasWidth = width + 2 * px;
    const tmpCanvasHeight = height + 2 * py;
    if (tmpCanvasWidth < 1 || tmpCanvasHeight < 1) {
      return;
    }
    const x2 = Math.floor(boundingBox.x);
    const y2 = Math.floor(boundingBox.y);
    const ignoredStyles = this.removeStyles(element2, FilterElement.ignoreStyles);
    const tmpCanvas = document2.createCanvas(tmpCanvasWidth, tmpCanvasHeight);
    const tmpCtx = tmpCanvas.getContext("2d");
    document2.screen.setDefaults(tmpCtx);
    tmpCtx.translate(-x2 + px, -y2 + py);
    element2.render(tmpCtx);
    children2.forEach((child) => {
      if (typeof child.apply === "function") {
        child.apply(tmpCtx, 0, 0, tmpCanvasWidth, tmpCanvasHeight);
      }
    });
    ctx2.drawImage(tmpCanvas, 0, 0, tmpCanvasWidth, tmpCanvasHeight, x2 - px, y2 - py, tmpCanvasWidth, tmpCanvasHeight);
    this.restoreStyles(element2, ignoredStyles);
  }
  render(_2) {
  }
  constructor(...args) {
    super(...args);
    this.type = "filter";
  }
}
FilterElement.ignoreStyles = [
  "filter",
  "transform",
  "clip-path"
];
class FeDropShadowElement extends Element {
  apply(_2, _x, _y, _width, _height) {
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "feDropShadow";
    this.addStylesFromStyleDefinition();
  }
}
class FeMorphologyElement extends Element {
  apply(_2, _x, _y, _width, _height) {
  }
  constructor(...args) {
    super(...args);
    this.type = "feMorphology";
  }
}
class FeCompositeElement extends Element {
  apply(_2, _x, _y, _width, _height) {
  }
  constructor(...args) {
    super(...args);
    this.type = "feComposite";
  }
}
class FeGaussianBlurElement extends Element {
  apply(ctx2, x2, y2, width, height) {
    const { document: document2, blurRadius } = this;
    const body = document2.window ? document2.window.document.body : null;
    const canvas = ctx2.canvas;
    canvas.id = document2.getUniqueId();
    if (body) {
      canvas.style.display = "none";
      body.appendChild(canvas);
    }
    processCanvasRGBA(canvas, x2, y2, width, height, blurRadius);
    if (body) {
      body.removeChild(canvas);
    }
  }
  constructor(document2, node2, captureTextNodes) {
    super(document2, node2, captureTextNodes);
    this.type = "feGaussianBlur";
    this.blurRadius = Math.floor(this.getAttribute("stdDeviation").getNumber());
    this.extraFilterDistance = this.blurRadius;
  }
}
class TitleElement extends Element {
  constructor(...args) {
    super(...args);
    this.type = "title";
  }
}
class DescElement extends Element {
  constructor(...args) {
    super(...args);
    this.type = "desc";
  }
}
const elements = {
  "svg": SVGElement,
  "rect": RectElement,
  "circle": CircleElement,
  "ellipse": EllipseElement,
  "line": LineElement,
  "polyline": PolylineElement,
  "polygon": PolygonElement,
  "path": PathElement,
  "pattern": PatternElement,
  "marker": MarkerElement,
  "defs": DefsElement,
  "linearGradient": LinearGradientElement,
  "radialGradient": RadialGradientElement,
  "stop": StopElement,
  "animate": AnimateElement,
  "animateColor": AnimateColorElement,
  "animateTransform": AnimateTransformElement,
  "font": FontElement,
  "font-face": FontFaceElement,
  "missing-glyph": MissingGlyphElement,
  "glyph": GlyphElement,
  "text": TextElement,
  "tspan": TSpanElement,
  "tref": TRefElement,
  "a": AElement,
  "textPath": TextPathElement,
  "image": ImageElement,
  "g": GElement,
  "symbol": SymbolElement,
  "style": StyleElement,
  "use": UseElement,
  "mask": MaskElement,
  "clipPath": ClipPathElement,
  "filter": FilterElement,
  "feDropShadow": FeDropShadowElement,
  "feMorphology": FeMorphologyElement,
  "feComposite": FeCompositeElement,
  "feColorMatrix": FeColorMatrixElement,
  "feGaussianBlur": FeGaussianBlurElement,
  "title": TitleElement,
  "desc": DescElement
};
function createCanvas(width, height) {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  return canvas;
}
async function createImage(src) {
  let anonymousCrossOrigin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  const image = document.createElement("img");
  if (anonymousCrossOrigin) {
    image.crossOrigin = "Anonymous";
  }
  return new Promise((resolve, reject) => {
    image.onload = () => {
      resolve(image);
    };
    image.onerror = (_event, _source, _lineno, _colno, error) => {
      reject(error);
    };
    image.src = src;
  });
}
const DEFAULT_EM_SIZE = 12;
class Document {
  bindCreateImage(createImage1, anonymousCrossOrigin) {
    if (typeof anonymousCrossOrigin === "boolean") {
      return (source, forceAnonymousCrossOrigin) => createImage1(source, typeof forceAnonymousCrossOrigin === "boolean" ? forceAnonymousCrossOrigin : anonymousCrossOrigin);
    }
    return createImage1;
  }
  get window() {
    return this.screen.window;
  }
  get fetch() {
    return this.screen.fetch;
  }
  get ctx() {
    return this.screen.ctx;
  }
  get emSize() {
    const { emSizeStack } = this;
    return emSizeStack[emSizeStack.length - 1] || DEFAULT_EM_SIZE;
  }
  set emSize(value) {
    const { emSizeStack } = this;
    emSizeStack.push(value);
  }
  popEmSize() {
    const { emSizeStack } = this;
    emSizeStack.pop();
  }
  getUniqueId() {
    return "canvg".concat(++this.uniqueId);
  }
  isImagesLoaded() {
    return this.images.every(
      (_2) => _2.loaded
    );
  }
  isFontsLoaded() {
    return this.fonts.every(
      (_2) => _2.loaded
    );
  }
  createDocumentElement(document2) {
    const documentElement = this.createElement(document2.documentElement);
    documentElement.root = true;
    documentElement.addStylesFromStyleDefinition();
    this.documentElement = documentElement;
    return documentElement;
  }
  createElement(node2) {
    const elementType = node2.nodeName.replace(/^[^:]+:/, "");
    const ElementType = Document.elementTypes[elementType];
    if (ElementType) {
      return new ElementType(this, node2);
    }
    return new UnknownElement(this, node2);
  }
  createTextNode(node2) {
    return new TextNode(this, node2);
  }
  setViewBox(config) {
    this.screen.setViewBox({
      document: this,
      ...config
    });
  }
  constructor(canvg, { rootEmSize = DEFAULT_EM_SIZE, emSize = DEFAULT_EM_SIZE, createCanvas: createCanvas1 = Document.createCanvas, createImage: createImage2 = Document.createImage, anonymousCrossOrigin } = {}) {
    this.canvg = canvg;
    this.definitions = {};
    this.styles = {};
    this.stylesSpecificity = {};
    this.images = [];
    this.fonts = [];
    this.emSizeStack = [];
    this.uniqueId = 0;
    this.screen = canvg.screen;
    this.rootEmSize = rootEmSize;
    this.emSize = emSize;
    this.createCanvas = createCanvas1;
    this.createImage = this.bindCreateImage(createImage2, anonymousCrossOrigin);
    this.screen.wait(
      () => this.isImagesLoaded()
    );
    this.screen.wait(
      () => this.isFontsLoaded()
    );
  }
}
Document.createCanvas = createCanvas;
Document.createImage = createImage;
Document.elementTypes = elements;
class Canvg {
  /**
  * Create Canvg instance from SVG source string or URL.
  * @param ctx - Rendering context.
  * @param svg - SVG source string or URL.
  * @param options - Rendering options.
  * @returns Canvg instance.
  */
  static async from(ctx2, svg) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const parser = new Parser(options);
    const svgDocument = await parser.parse(svg);
    return new Canvg(ctx2, svgDocument, options);
  }
  /**
  * Create Canvg instance from SVG source string.
  * @param ctx - Rendering context.
  * @param svg - SVG source string.
  * @param options - Rendering options.
  * @returns Canvg instance.
  */
  static fromString(ctx2, svg) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const parser = new Parser(options);
    const svgDocument = parser.parseFromString(svg);
    return new Canvg(ctx2, svgDocument, options);
  }
  /**
  * Create new Canvg instance with inherited options.
  * @param ctx - Rendering context.
  * @param svg - SVG source string or URL.
  * @param options - Rendering options.
  * @returns Canvg instance.
  */
  fork(ctx2, svg) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Canvg.from(ctx2, svg, {
      ...this.options,
      ...options
    });
  }
  /**
  * Create new Canvg instance with inherited options.
  * @param ctx - Rendering context.
  * @param svg - SVG source string.
  * @param options - Rendering options.
  * @returns Canvg instance.
  */
  forkString(ctx2, svg) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Canvg.fromString(ctx2, svg, {
      ...this.options,
      ...options
    });
  }
  /**
  * Document is ready promise.
  * @returns Ready promise.
  */
  ready() {
    return this.screen.ready();
  }
  /**
  * Document is ready value.
  * @returns Is ready or not.
  */
  isReady() {
    return this.screen.isReady();
  }
  /**
  * Render only first frame, ignoring animations and mouse.
  * @param options - Rendering options.
  */
  async render() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.start({
      enableRedraw: true,
      ignoreAnimation: true,
      ignoreMouse: true,
      ...options
    });
    await this.ready();
    this.stop();
  }
  /**
  * Start rendering.
  * @param options - Render options.
  */
  start() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { documentElement, screen, options: baseOptions } = this;
    screen.start(documentElement, {
      enableRedraw: true,
      ...baseOptions,
      ...options
    });
  }
  /**
  * Stop rendering.
  */
  stop() {
    this.screen.stop();
  }
  /**
  * Resize SVG to fit in given size.
  * @param width
  * @param height
  * @param preserveAspectRatio
  */
  resize(width) {
    let height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : width, preserveAspectRatio = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    this.documentElement.resize(width, height, preserveAspectRatio);
  }
  /**
  * Main constructor.
  * @param ctx - Rendering context.
  * @param svg - SVG Document.
  * @param options - Rendering options.
  */
  constructor(ctx2, svg, options = {}) {
    this.parser = new Parser(options);
    this.screen = new Screen(ctx2, options);
    this.options = options;
    const document2 = new Document(this, options);
    const documentElement = document2.createDocumentElement(svg);
    this.document = document2;
    this.documentElement = documentElement;
  }
}
let Point$1 = class Point2 {
  constructor(options) {
    __publicField(this, "x");
    __publicField(this, "y");
    this.x = options.x;
    this.y = options.y;
  }
};
class Polygon {
  constructor(options) {
    __publicField(this, "points");
    this.points = options.points;
  }
  intersect(polygon) {
    return doPolygonsOverlap(this, polygon);
  }
}
let ctx$1;
const cache$2 = {};
function getTextSize(text2, fontSize, fontFamily) {
  const { width } = measureText$1(text2, fontSize, fontFamily);
  const {
    actualBoundingBoxAscent,
    actualBoundingBoxDescent,
    width: width2
  } = measureText$1("国", fontSize, fontFamily);
  return {
    x: 0,
    y: 0,
    width,
    height: actualBoundingBoxAscent + actualBoundingBoxDescent,
    actualBoundingBoxAscent,
    actualBoundingBoxDescent
  };
}
function measureText$1(text2, fontSize, fontFamily) {
  if (!ctx$1) {
    const { canvas: _canvas, ctx: _ctx } = getCanvas();
    ctx$1 = _ctx;
  }
  if (!ctx$1) {
    throw new Error();
  }
  const font = `${fontSize}px ${fontFamily}`;
  const key = `${text2}__${font}`;
  if (!cache$2[key]) {
    ctx$1.font = font;
    const measure = ctx$1.measureText(text2);
    cache$2[key] = measure;
  }
  return cache$2[key];
}
function getCanvas() {
  const canvas2 = document.createElement("canvas");
  const ctx2 = canvas2.getContext("2d");
  return { canvas: canvas2, ctx: ctx2 };
}
function doPolygonsOverlap(polygon1, polygon2) {
  function doLinesOverlap(line1Start, line1End, line2Start, line2End) {
    const crossProduct = (point1, point2) => point1.x * point2.y - point1.y * point2.x;
    const line1Vector = {
      x: line1End.x - line1Start.x,
      y: line1End.y - line1Start.y
    };
    const line2Vector = {
      x: line2End.x - line2Start.x,
      y: line2End.y - line2Start.y
    };
    const crossProduct1 = crossProduct(line2Vector, {
      x: line1Start.x - line2Start.x,
      y: line1Start.y - line2Start.y
    });
    const crossProduct2 = crossProduct(line2Vector, {
      x: line1End.x - line2Start.x,
      y: line1End.y - line2Start.y
    });
    const crossProduct3 = crossProduct(line1Vector, {
      x: line2Start.x - line1Start.x,
      y: line2Start.y - line1Start.y
    });
    const crossProduct4 = crossProduct(line1Vector, {
      x: line2End.x - line1Start.x,
      y: line2End.y - line1Start.y
    });
    return crossProduct1 * crossProduct2 < 0 && crossProduct3 * crossProduct4 < 0;
  }
  function checkEdgeIntersection(poly1, poly2) {
    for (let i2 = 0; i2 < poly1.points.length; i2++) {
      const p1 = poly1.points[i2];
      const p2 = poly1.points[(i2 + 1) % poly1.points.length];
      for (let j = 0; j < poly2.points.length; j++) {
        const p3 = poly2.points[j];
        const p4 = poly2.points[(j + 1) % poly2.points.length];
        if (doLinesOverlap(p1, p2, p3, p4)) {
          return true;
        }
      }
    }
    return false;
  }
  function isPolygonInside(polygon12, polygon22) {
    for (let i2 = 0; i2 < polygon12.points.length; i2++) {
      const point2 = polygon12.points[i2];
      if (!isPointInsidePolygon(point2, polygon22)) {
        return false;
      }
    }
    return true;
  }
  function isPointInsidePolygon(point2, polygon) {
    let inside = false;
    const [x2, y2] = [point2.x, point2.y];
    for (let i2 = 0, j = polygon.points.length - 1; i2 < polygon.points.length; j = i2++) {
      const xi = polygon.points[i2].x;
      const yi = polygon.points[i2].y;
      const xj = polygon.points[j].x;
      const yj = polygon.points[j].y;
      const intersect2 = yi > y2 !== yj > y2 && x2 < (xj - xi) * (y2 - yi) / (yj - yi) + xi;
      if (intersect2) {
        inside = !inside;
      }
    }
    return inside;
  }
  if (checkEdgeIntersection(polygon1, polygon2))
    return true;
  if (checkEdgeIntersection(polygon2, polygon1))
    return true;
  if (isPolygonInside(polygon1, polygon2))
    return true;
  if (isPolygonInside(polygon2, polygon1))
    return true;
  return false;
}
async function exportSvgData(instance2) {
  await instance2.wait();
  instance2.downloading.set(true);
  await tick();
  const svg = instance2.getSvg();
  if (!svg) {
    throw new Error("no svg");
  }
  const svgData = new XMLSerializer().serializeToString(svg);
  instance2.downloading.set(false);
  return svgData;
}
async function exportCanvas(instance2, devicePixelRatio) {
  var _a2;
  await instance2.wait();
  const svgData = await exportSvgData(instance2);
  const { canvas, ctx: ctx2 } = getCanvas();
  const width = get_store_value(instance2.chartWidth);
  const height = get_store_value(instance2.chartHeight);
  const scale = (_a2 = devicePixelRatio != null ? devicePixelRatio : get_store_value(instance2.devicePixelRatio)) != null ? _a2 : window.devicePixelRatio;
  const scaleWidth = width * scale;
  const scaleHeight = height * scale;
  const v2 = Canvg.fromString(ctx2, svgData, {
    // forceRedraw: () => true,
    ...{}
  });
  await v2.resize(scaleWidth, scaleHeight);
  const FRAME_COUNT = 3;
  let frames = 0;
  v2.start({
    enableRedraw: true,
    // 謎の黄金比 for canvg v3.0.9以降
    offsetX: width * (scale / 2 - 1 / 2),
    offsetY: height * (scale / 2 - 1 / 2),
    scaleWidth: scaleWidth * scale,
    scaleHeight: scaleHeight * scale,
    forceRedraw: () => {
      return frames++ < FRAME_COUNT;
    }
  });
  await new Promise((resolve) => {
    let timer2 = setInterval(() => {
      if (frames > FRAME_COUNT - 1) {
        clearInterval(timer2);
        resolve(null);
      }
    });
  });
  await v2.ready();
  v2.stop();
  return canvas;
}
async function exportDataUrl(instance2, imageType, devicePixelRatio) {
  await instance2.wait();
  if (imageType === "svg") {
    const svgData = await exportSvgData(instance2);
    return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgData);
  }
  const canvas = await exportCanvas(instance2, devicePixelRatio);
  return canvas.toDataURL("image/png");
}
const download = async (instance2, imageType) => {
  const a2 = document.createElement("a");
  a2.href = await exportDataUrl(instance2, imageType);
  a2.setAttribute("download", `image.${imageType}`);
  a2.dispatchEvent(new MouseEvent("click"));
};
const copyToClipboard = async (instance2) => {
  const dataUrl = await exportDataUrl(instance2, "png");
  const m2 = dataUrl.match(/^data:(.*?);base64,(.*?)$/);
  if (!m2) {
    throw new Error("invalid data url");
  }
  const [_2, mimeType, base64] = m2;
  const buf = buffer.Buffer.from(base64, "base64");
  const blob = new Blob([buf], {
    type: mimeType
  });
  if (navigator.clipboard.write && window.ClipboardItem) {
    navigator.clipboard.write([
      new window.ClipboardItem({
        [mimeType]: blob
      })
    ]);
  }
};
function sqrt$1(x2) {
  const n2 = Math.sqrt(x2);
  if (n2 < 0) {
    return 0;
  }
  if (isNaN(n2)) {
    return 0;
  }
  return n2;
}
const keyWithPx = [
  "width",
  "maxWidth",
  "minWidth",
  "height",
  "minHeight",
  "maxHeight",
  "top",
  "bottom",
  "left",
  "right",
  "fontSize",
  "padding",
  "margin",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "borderRadius",
  "outlineOffset"
];
const styleToString = (style) => {
  return Object.keys(style).reduce((acc, key) => {
    const value = style[key];
    const styleKey = key.split(/(?=[A-Z])/).join("-").toLowerCase();
    return acc + (value != null ? `${styleKey}:${typeof value === "number" && keyWithPx.includes(key) ? `${value}px` : value};` : "");
  }, "");
};
class Style {
  constructor(cssObject) {
    __publicField(this, "cssObject");
    this.cssObject = cssObject != null ? cssObject : {};
  }
  toString() {
    return styleToString(this.cssObject);
  }
}
const ALPHA$1 = 1e-6;
const formatComma = (n2) => {
  if (isNaN(n2)) {
    return "-";
  }
  return format(",.0f")(n2);
};
const formatPercent = (n2) => {
  if (n2 == null || isNaN(n2)) {
    return "-";
  }
  return format(".1%")(n2);
};
const axisFormatPercent = (n2) => {
  if (n2 == null || isNaN(n2)) {
    return "-";
  }
  return format(".0%")(n2);
};
function emptyHandler() {
}
function asAny(value) {
  return value;
}
function asValidNumber(n2, allowNegative = true) {
  if (isValidNumber(n2)) {
    if (!allowNegative && n2 < 0) {
      return 0;
    }
    return n2;
  }
  return 0;
}
function isValidNumber(n2) {
  if (n2 == null) {
    return false;
  }
  if (isNaN(n2)) {
    return false;
  }
  if (!isFinite(n2)) {
    return false;
  }
  return true;
}
function round$1(n2, digits) {
  if (isNaN(n2)) {
    return NaN;
  }
  return Number(n2.toFixed(digits));
}
function sum(data, handler) {
  let total = 0;
  data.forEach((row, i2) => {
    const value = handler(row, i2);
    total += asValidNumber(value);
  });
  return total;
}
function dataMapper(data, columns) {
  return data.map((record) => {
    const row = {};
    columns.forEach(({ key, column: column2 }) => {
      var _a2, _b;
      if (column2.type === "category") {
        row[key] = (_a2 = column2.valueGetter(record)) != null ? _a2 : "";
      } else {
        row[key] = (_b = column2.valueGetter(record)) != null ? _b : 0;
      }
    });
    return { ...record, ...row };
  }).filter((row) => {
    for (let i2 = 0; i2 < columns.length; i2++) {
      const { key, column: column2 } = columns[i2];
      const value = row[key];
      if (column2.type === "value") {
        if (column2.min != null && value < column2.min) {
          return false;
        }
        if (column2.max != null && value > column2.max) {
          return false;
        }
      } else if (column2.type === "category") {
        if (column2.domain && !column2.domain.includes(value)) {
          return false;
        }
      }
    }
    return true;
  });
}
class Group {
  constructor(data, keyHandler, filterHandler = () => true, valueHandler = () => null) {
    __publicField(this, "storeData");
    __publicField(this, "valueHander", () => null);
    this.storeData = [];
    this.valueHander = valueHandler;
    const { storeData } = this;
    for (let i2 = 0; i2 < data.length; i2++) {
      const row = data[i2];
      if (filterHandler(row)) {
        const key = keyHandler(row);
        const index2 = this.findIndex(key);
        if (index2 > -1) {
          storeData[index2].rows.push(row);
        } else {
          storeData.push({
            key,
            rows: [row],
            value: null
          });
        }
      }
    }
    for (let i2 = 0; i2 < storeData.length; i2++) {
      storeData[i2].value = valueHandler(
        storeData[i2].rows,
        storeData[i2].key
      );
    }
  }
  keys() {
    return this.storeData.map(({ key }) => key);
  }
  findIndex(key) {
    const index2 = this.storeData.findIndex((n2) => {
      if (Array.isArray(n2.key) && Array.isArray(key)) {
        if (n2.key.length !== key.length) {
          return false;
        }
        return n2.key.every((keyItem, i2) => keyItem === key[i2]);
      } else {
        return n2.key === key;
      }
    });
    return index2;
  }
  findAll(key) {
    return this.storeData.filter((n2) => {
      if (Array.isArray(n2.key) && Array.isArray(key)) {
        return key.every((keyItem) => n2.key.includes(keyItem));
      } else {
        return n2.key === key;
      }
    });
  }
  getRows(key) {
    const index2 = this.findIndex(key);
    if (index2 > -1) {
      return this.storeData[index2].rows;
    }
  }
  getValue(key) {
    const index2 = this.findIndex(key);
    if (index2 > -1) {
      return this.storeData[index2].value;
    }
  }
  // get all value included when key is Array
  getTotalValue(key) {
    let totalRows = [];
    this.findAll(key).forEach(({ rows }) => {
      totalRows = [...totalRows, ...rows];
    });
    return this.valueHander(totalRows, key);
  }
}
function parseCategoryColumn(params) {
  var _a2;
  const { column: column2 } = params;
  const valueGetter = (d) => {
    var _a3, _b;
    if (column2.valueGetter) {
      return String((_a3 = column2.valueGetter(d)) != null ? _a3 : "");
    }
    const _d = d;
    return String((_b = _d[column2.key]) != null ? _b : "");
  };
  const mapping = column2.mapping;
  let formatter;
  if (column2.formatter) {
    formatter = column2.formatter;
  } else if (mapping) {
    if (mapping instanceof Map) {
      formatter = (s2) => {
        var _a3;
        return (_a3 = mapping.get(s2)) != null ? _a3 : "";
      };
    } else {
      formatter = (s2) => {
        var _a3;
        return (_a3 = mapping[s2]) != null ? _a3 : "";
      };
    }
  } else {
    formatter = (s2) => s2;
  }
  const {
    axisFormatter = formatter,
    labelFormatter = formatter,
    tooltipFormatter = formatter,
    sort,
    colorMapping: _colorMapping
  } = column2;
  const colorMapping = /* @__PURE__ */ new Map();
  if (_colorMapping) {
    if (_colorMapping instanceof Map) {
      _colorMapping.forEach((value, key) => {
        colorMapping.set(key, value);
      });
    } else {
      Object.keys(_colorMapping).forEach((key) => {
        colorMapping.set(key, _colorMapping[key]);
      });
    }
  }
  const parsedColumn = {
    type: "category",
    key: column2.key,
    title: (_a2 = column2.title) != null ? _a2 : column2.key,
    domain: column2.domain,
    valueGetter,
    formatter,
    axisFormatter,
    labelFormatter,
    tooltipFormatter,
    sort,
    colorMapping
  };
  return parsedColumn;
}
function parseCategoryArrayColumn(params) {
  var _a2;
  const { column: column2 } = params;
  const valueGetter = (d) => {
    var _a3, _b;
    if (column2.valueGetter) {
      return (_a3 = column2.valueGetter(d)) != null ? _a3 : [];
    }
    return (_b = d[column2.key]) != null ? _b : [];
  };
  const mapping = column2.mapping;
  let formatter;
  if (column2.formatter) {
    formatter = column2.formatter;
  } else if (mapping) {
    if (mapping instanceof Map) {
      formatter = (s2) => {
        var _a3;
        return (_a3 = mapping.get(s2)) != null ? _a3 : "";
      };
    } else {
      formatter = (s2) => {
        var _a3;
        return (_a3 = mapping[s2]) != null ? _a3 : "";
      };
    }
  } else {
    formatter = (s2) => s2;
  }
  const {
    axisFormatter = formatter,
    labelFormatter = formatter,
    tooltipFormatter = formatter,
    colorMapping: _colorMapping
  } = column2;
  const colorMapping = /* @__PURE__ */ new Map();
  if (_colorMapping) {
    if (_colorMapping instanceof Map) {
      _colorMapping.forEach((value, key) => {
        colorMapping.set(key, value);
      });
    } else {
      Object.keys(_colorMapping).forEach((key) => {
        colorMapping.set(key, _colorMapping[key]);
      });
    }
  }
  const parsedColumn = {
    type: "categoryArray",
    key: column2.key,
    title: (_a2 = column2.title) != null ? _a2 : column2.key,
    domain: column2.domain,
    valueGetter,
    formatter,
    axisFormatter,
    labelFormatter,
    tooltipFormatter,
    colorMapping
  };
  return parsedColumn;
}
function parseValueColumn(params) {
  var _a2, _b;
  const { column: column2 } = params;
  const valueGetter = (_a2 = column2.valueGetter) != null ? _a2 : (d) => d[column2.key];
  let formatter;
  if (column2.formatter) {
    formatter = column2.formatter;
  } else if (column2.decimal) {
    formatter = (value) => value == null ? "-" : format(",.2f")(value);
  } else if (column2.percent) {
    formatter = (value) => value == null ? "-" : format(".0%")(value);
  } else {
    formatter = (value) => value == null ? "-" : format(",.0f")(value);
  }
  const {
    axisFormatter = formatter,
    labelFormatter = formatter,
    tooltipFormatter = formatter
  } = column2;
  const parsedColumn = {
    type: "value",
    key: column2.key,
    title: (_b = column2.title) != null ? _b : column2.key,
    min: column2.min,
    max: column2.max,
    valueGetter,
    formatter,
    axisFormatter,
    labelFormatter,
    tooltipFormatter
  };
  return parsedColumn;
}
function parseColorUtils({
  colorColumn,
  data,
  instance: instance2,
  colors: _colors
}) {
  var _a2, _b, _c, _d;
  const { color: color2, colorLegendActives } = instance2;
  const colorDomain = colorColumn.type === "category" ? [
    ...colorColumn.domain || new Group(data, (row) => row.color).keys()
  ] : [];
  const colorRange = colorColumn.type === "value" ? [
    (_b = (_a2 = colorColumn.min) != null ? _a2 : min$1(data, (d) => d.color)) != null ? _b : 0,
    (_d = (_c = colorColumn.max) != null ? _c : max$1(data, (d) => d.color)) != null ? _d : 0
  ] : [0, 0];
  const getColor = derived([color2], ([$color]) => {
    const colors2 = _colors || $color.colors;
    if (colorColumn.type === "category") {
      return (_value) => {
        const value = _value;
        const _color = colorColumn.colorMapping.get(value);
        if (_color) {
          return _color;
        }
        const index2 = colorDomain.indexOf(value);
        return colors2[index2 % colors2.length];
      };
    }
    const colorScale1 = linear().domain(colorRange).range([0, 1]);
    const colorScale2 = linear().domain(
      new Array(colors2.length).fill(0).map((_2, i2) => i2 / (colors2.length - 1))
    ).range(colors2);
    return (value) => {
      const v2 = colorScale1(value);
      return colorScale2(v2);
    };
  });
  const isColorActive = derived(
    [colorLegendActives],
    ([$colorLegendActives]) => {
      if (colorColumn.type === "category") {
        return (value) => {
          return $colorLegendActives.includes(value);
        };
      }
      return (value) => {
        return true;
      };
    }
  );
  return { colorDomain, colorRange, getColor, isColorActive };
}
function computeWidth({ x1, x2 }) {
  return {
    x: Math.min(x1, x2),
    width: Math.max(x1, x2) - Math.min(x1, x2)
  };
}
function computeHeight$1({ y1, y2 }) {
  return {
    y: Math.min(y1, y2),
    height: Math.max(y1, y2) - Math.min(y1, y2)
  };
}
function sortDomain({
  column: column2,
  domain,
  valueByDomain
}) {
  if (column2.sort) {
    const { sort: _sort, reverse } = column2.sort;
    let sort = typeof _sort === "function" ? _sort : _sort === "ALPHABETICAL" ? function(a2, b) {
      return a2.key.localeCompare(b.key);
    } : function(a2, b) {
      return b.value - a2.value;
    };
    if (sort) {
      domain.sort(
        (a2, b) => {
          var _a2, _b;
          return sort(
            {
              key: a2,
              value: (_a2 = valueByDomain.get(a2)) != null ? _a2 : 0
            },
            { key: b, value: (_b = valueByDomain.get(b)) != null ? _b : 0 }
          );
        }
      );
      if (reverse) {
        domain.reverse();
      }
    }
  }
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i2 = 0; i2 < document.styleSheets.length; i2++) {
    if (document.styleSheets[i2].ownerNode === tag) {
      return document.styleSheets[i2];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert2(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e3) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush2() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs$1 = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append$1(value, array2) {
  return array2.push(value), value;
}
function combine(array2, callback) {
  return array2.map(callback).join("");
}
var line$1 = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root2, parent, type2, props, children2, length2) {
  return { value, root: root2, parent, type: type2, props, children: children2, line: line$1, column, length: length2, return: "" };
}
function copy(root2, props) {
  return assign(node("", null, null, "", null, null, 0), root2, { length: -root2.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line$1--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line$1++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type2) {
  switch (type2) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line$1 = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type2) {
  return trim(slice(position - 1, delimiter(type2 === 91 ? type2 + 2 : type2 === 40 ? type2 + 1 : type2)));
}
function whitespace(type2) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type2) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count2) {
  while (--count2 && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret() + (count2 < 6 && peek() == 32 && next() == 32));
}
function delimiter(type2) {
  while (next())
    switch (character) {
      case type2:
        return position;
      case 34:
      case 39:
        if (type2 !== 34 && type2 !== 39)
          delimiter(character);
        break;
      case 40:
        if (type2 === 41)
          delimiter(type2);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type2, index2) {
  while (next())
    if (type2 + character === 47 + 10)
      break;
    else if (type2 + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position - 1) + "*" + from(type2 === 47 ? type2 : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice(index2, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root2, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type2 = "";
  var props = rules;
  var children2 = rulesets;
  var reference = rule;
  var characters2 = type2;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append$1(comment(commenter(next(), caret()), root2, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset:
            if (ampersand == -1)
              characters2 = replace(characters2, /\f/g, "");
            if (property > 0 && strlen(characters2) - length2)
              append$1(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append$1(reference = ruleset(characters2, root2, parent, index2, offset, rules, points, type2, props = [], children2 = [], length2), rulesets);
            if (character2 === 123)
              if (offset === 0)
                parse(characters2, root2, reference, reference, props, rulesets, length2, points, children2);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(value, reference, reference, rule && append$1(ruleset(value, reference, reference, 0, 0, rules, points, type2, rules, props = [], length2), children2), rules, children2, length2, points, rule ? props : children2);
                    break;
                  default:
                    parse(characters2, reference, reference, reference, [""], children2, 0, points, children2);
                }
        }
        index2 = offset = property = 0, variable = ampersand = 1, type2 = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset = length2 = strlen(type2 = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root2, parent, index2, offset, rules, points, type2, props, children2, length2) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i2 = 0, j = 0, k = 0; i2 < index2; ++i2)
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs$1(j = points[i2])), z = value; x2 < size; ++x2)
      if (z = trim(j > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2])))
        props[k++] = z;
  return node(value, root2, parent, offset === 0 ? RULESET : type2, props, children2, length2);
}
function comment(value, root2, parent) {
  return node(value, root2, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root2, parent, length2) {
  return node(value, root2, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize(children2, callback) {
  var output = "";
  var length2 = sizeof(children2);
  for (var i2 = 0; i2 < length2; i2++)
    output += callback(children2[i2], i2, children2, callback) || "";
  return output;
}
function stringify(element2, index2, children2, callback) {
  switch (element2.type) {
    case LAYER:
      if (element2.children.length)
        break;
    case IMPORT:
    case DECLARATION:
      return element2.return = element2.return || element2.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element2.return = element2.value + "{" + serialize(element2.children, callback) + "}";
    case RULESET:
      element2.value = element2.props.join(",");
  }
  return strlen(children2 = serialize(element2.children, callback)) ? element2.return = element2.value + "{" + children2 + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element2, index2, children2, callback) {
    var output = "";
    for (var i2 = 0; i2 < length2; i2++)
      output += collection[i2](element2, index2, children2, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element2) {
    if (!element2.root) {
      if (element2 = element2.return)
        callback(element2);
    }
  };
}
function memoize(fn) {
  var cache2 = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache2[arg] === void 0)
      cache2[arg] = fn(arg);
    return cache2[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element2) {
  if (element2.type !== "rule" || !element2.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element2.length < 1) {
    return;
  }
  var value = element2.value, parent = element2.parent;
  var isImplicitRule = element2.column === parent.column && element2.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent)
      return;
  }
  if (element2.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element2, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i2 = 0, k = 0; i2 < rules.length; i2++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element2.props[k] = points[i2] ? rules[i2].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i2];
    }
  }
};
var removeLabel = function removeLabel2(element2) {
  if (element2.type === "decl") {
    var value = element2.value;
    if (
      // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98
    ) {
      element2["return"] = "";
      element2.value = "";
    }
  }
};
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element2, index2, children2, callback) {
  if (element2.length > -1) {
    if (!element2["return"])
      switch (element2.type) {
        case DECLARATION:
          element2["return"] = prefix(element2.value, element2.length);
          break;
        case KEYFRAMES:
          return serialize([copy(element2, {
            value: replace(element2.value, "@", "@" + WEBKIT)
          })], callback);
        case RULESET:
          if (element2.length)
            return combine(element2.props, function(value) {
              switch (match(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize([copy(element2, {
                    props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
                  })], callback);
                case "::placeholder":
                  return serialize([copy(element2, {
                    props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                  }), copy(element2, {
                    props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
                  }), copy(element2, {
                    props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
                  })], callback);
              }
              return "";
            });
      }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options) {
  var key = options.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i2 = 1; i2 < attrib.length; i2++) {
          inserted[attrib[i2]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function insert2(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache2.inserted[serialized.name] = true;
      }
    };
  }
  var cache2 = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache2.sheet.hydrate(nodesToHydrate);
  return cache2;
};
function murmur2(str) {
  var h2 = 0;
  var k, i2 = 0, len = str.length;
  for (; len >= 4; ++i2, len -= 4) {
    k = str.charCodeAt(i2) & 255 | (str.charCodeAt(++i2) & 255) << 8 | (str.charCodeAt(++i2) & 255) << 16 | (str.charCodeAt(++i2) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h2 = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i2 + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i2 + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i2) & 255;
      h2 = /* Math.imul(h, m): */
      (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = /* Math.imul(h, m): */
  (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next2 = interpolation.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles = interpolation.styles + ";";
        return styles;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i2 = 0; i2 < obj.length; i2++) {
      string += handleInterpolation(mergedProps, registered, obj[i2]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    styles += strings[0];
  }
  for (var i2 = 1; i2 < args.length; i2++) {
    styles += handleInterpolation(mergedProps, registered, args[i2]);
    if (stringMode) {
      styles += strings[i2];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles)) !== null) {
    identifierName += "-" + // $FlowFixMe we know it's not null
    match2[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name,
    styles,
    next: cursor
  };
};
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = "";
  classNames.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache2, serialized, isStringTag) {
  var className = cache2.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache2.registered[className] === void 0
  ) {
    cache2.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache2, serialized, isStringTag) {
  registerStyles(cache2, serialized, isStringTag);
  var className = cache2.key + "-" + serialized.name;
  if (cache2.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache2.insert(serialized === current ? "." + className : "", current, cache2.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function insertWithoutScoping(cache2, serialized) {
  if (cache2.inserted[serialized.name] === void 0) {
    return cache2.insert("", serialized, cache2.sheet, true);
  }
}
function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css(registeredStyles);
}
var createEmotion = function createEmotion2(options) {
  var cache2 = createCache(options);
  cache2.sheet.speedy = function(value) {
    this.isSpeedy = value;
  };
  cache2.compat = true;
  var css = function css2() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache2.registered, void 0);
    insertStyles(cache2, serialized, false);
    return cache2.key + "-" + serialized.name;
  };
  var keyframes = function keyframes2() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var serialized = serializeStyles(args, cache2.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache2, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };
  var injectGlobal2 = function injectGlobal3() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    var serialized = serializeStyles(args, cache2.registered);
    insertWithoutScoping(cache2, serialized);
  };
  var cx = function cx2() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return merge(cache2.registered, css, classnames(args));
  };
  return {
    css,
    cx,
    injectGlobal: injectGlobal2,
    keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function(key) {
        cache2.inserted[key] = true;
      });
    },
    flush: function flush2() {
      cache2.registered = {};
      cache2.inserted = {};
      cache2.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache2.sheet,
    cache: cache2,
    getRegisteredStyles: getRegisteredStyles.bind(null, cache2.registered),
    merge: merge.bind(null, cache2.registered, css)
  };
};
var classnames = function classnames2(args) {
  var cls = "";
  for (var i2 = 0; i2 < args.length; i2++) {
    var arg = args[i2];
    if (arg == null)
      continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(arg)) {
          toAdd = classnames2(arg);
        } else {
          toAdd = "";
          for (var k in arg) {
            if (arg[k] && k) {
              toAdd && (toAdd += " ");
              toAdd += k;
            }
          }
        }
        break;
      }
      default: {
        toAdd = arg;
      }
    }
    if (toAdd) {
      cls && (cls += " ");
      cls += toAdd;
    }
  }
  return cls;
};
var _createEmotion = createEmotion({
  key: "css"
}), injectGlobal = _createEmotion.injectGlobal;
{
  injectGlobal(`
        @font-face {
            font-family: Emoji;
            src: local('Segoe UI Emoji'), local('Segoe UI Symbol'),
                local('Apple Color Emoji'), local('Noto Color Emoji'),
                local('Noto Emoji');
            unicode-range: /*U+23, U+2A, U+30-39,*/ U+A9, U+AE, U+200D, U+203C,
                U+2049, U+20E3, U+2122, U+2139, U+2194-2199, U+21A9-21AA,
                U+231A-231B, U+2328, U+23CF, U+23E9-23F3, U+23F8-23FA, U+24C2,
                U+25AA-25AB, U+25B6, U+25C0, U+25FB-25FE, U+2600-2604, U+260E,
                U+2611, U+2614-2615, U+2618, U+261D, U+2620, U+2622-2623, U+2626,
                U+262A, U+262E-262F, U+2638-263A, U+2640, U+2642, U+2648-2653,
                U+2660, U+2663, U+2665-2666, U+2668, U+267B, U+267F, U+2692-2697,
                U+2699, U+269B-269C, U+26A0-26A1, U+26AA-26AB, U+26B0-26B1,
                U+26BD-26BE, U+26C4-26C5, U+26C8, U+26CE-26CF, U+26D1, U+26D3-26D4,
                U+26E9-26EA, U+26F0-26F5, U+26F7-26FA, U+26FD, U+2702, U+2705,
                U+2708-270D, U+270F, U+2712, U+2714, U+2716, U+271D, U+2721, U+2728,
                U+2733-2734, U+2744, U+2747, U+274C, U+274E, U+2753-2755, U+2757,
                U+2763-2764, U+2795-2797, U+27A1, U+27B0, U+27BF, U+2934-2935,
                U+2B05-2B07, U+2B1B-2B1C, U+2B50, U+2B55, U+3030, U+303D, U+3297,
                U+3299, U+FE0F, U+1F004, U+1F0CF, U+1F170-1F171, U+1F17E-1F17F,
                U+1F18E, U+1F191-1F19A, U+1F1E6-1F1FF, U+1F201-1F202, U+1F21A,
                U+1F22F, U+1F232-1F23A, U+1F250-1F251, U+1F300-1F321, U+1F324-1F393,
                U+1F396-1F397, U+1F399-1F39B, U+1F39E-1F3F0, U+1F3F3-1F3F5,
                U+1F3F7-1F4FD, U+1F4FF-1F53D, U+1F549-1F54E, U+1F550-1F567,
                U+1F56F-1F570, U+1F573-1F57A, U+1F587, U+1F58A-1F58D, U+1F590,
                U+1F595-1F596, U+1F5A4-1F5A5, U+1F5A8, U+1F5B1-1F5B2, U+1F5BC,
                U+1F5C2-1F5C4, U+1F5D1-1F5D3, U+1F5DC-1F5DE, U+1F5E1, U+1F5E3,
                U+1F5E8, U+1F5EF, U+1F5F3, U+1F5FA-1F64F, U+1F680-1F6C5,
                U+1F6CB-1F6D2, U+1F6E0-1F6E5, U+1F6E9, U+1F6EB-1F6EC, U+1F6F0,
                U+1F6F3-1F6F8, U+1F910-1F93A, U+1F93C-1F93E, U+1F940-1F945,
                U+1F947-1F94C, U+1F950-1F96B, U+1F980-1F997, U+1F9C0, U+1F9D0-1F9E6,
                U+E0062-E0063, U+E0065, U+E0067, U+E006C, U+E006E, U+E0073-E0074,
                U+E0077, U+E007F;
        }
        @font-face {
            font-family: Emoji;
            font-weight: bold;
            src: local('Segoe UI Emoji'), local('Segoe UI Symbol'),
                local('Apple Color Emoji'), local('Noto Color Emoji'),
                local('Noto Emoji');
            unicode-range: /*U+23, U+2A, U+30-39,*/ U+A9, U+AE, U+200D, U+203C,
                U+2049, U+20E3, U+2122, U+2139, U+2194-2199, U+21A9-21AA,
                U+231A-231B, U+2328, U+23CF, U+23E9-23F3, U+23F8-23FA, U+24C2,
                U+25AA-25AB, U+25B6, U+25C0, U+25FB-25FE, U+2600-2604, U+260E,
                U+2611, U+2614-2615, U+2618, U+261D, U+2620, U+2622-2623, U+2626,
                U+262A, U+262E-262F, U+2638-263A, U+2640, U+2642, U+2648-2653,
                U+2660, U+2663, U+2665-2666, U+2668, U+267B, U+267F, U+2692-2697,
                U+2699, U+269B-269C, U+26A0-26A1, U+26AA-26AB, U+26B0-26B1,
                U+26BD-26BE, U+26C4-26C5, U+26C8, U+26CE-26CF, U+26D1, U+26D3-26D4,
                U+26E9-26EA, U+26F0-26F5, U+26F7-26FA, U+26FD, U+2702, U+2705,
                U+2708-270D, U+270F, U+2712, U+2714, U+2716, U+271D, U+2721, U+2728,
                U+2733-2734, U+2744, U+2747, U+274C, U+274E, U+2753-2755, U+2757,
                U+2763-2764, U+2795-2797, U+27A1, U+27B0, U+27BF, U+2934-2935,
                U+2B05-2B07, U+2B1B-2B1C, U+2B50, U+2B55, U+3030, U+303D, U+3297,
                U+3299, U+FE0F, U+1F004, U+1F0CF, U+1F170-1F171, U+1F17E-1F17F,
                U+1F18E, U+1F191-1F19A, U+1F1E6-1F1FF, U+1F201-1F202, U+1F21A,
                U+1F22F, U+1F232-1F23A, U+1F250-1F251, U+1F300-1F321, U+1F324-1F393,
                U+1F396-1F397, U+1F399-1F39B, U+1F39E-1F3F0, U+1F3F3-1F3F5,
                U+1F3F7-1F4FD, U+1F4FF-1F53D, U+1F549-1F54E, U+1F550-1F567,
                U+1F56F-1F570, U+1F573-1F57A, U+1F587, U+1F58A-1F58D, U+1F590,
                U+1F595-1F596, U+1F5A4-1F5A5, U+1F5A8, U+1F5B1-1F5B2, U+1F5BC,
                U+1F5C2-1F5C4, U+1F5D1-1F5D3, U+1F5DC-1F5DE, U+1F5E1, U+1F5E3,
                U+1F5E8, U+1F5EF, U+1F5F3, U+1F5FA-1F64F, U+1F680-1F6C5,
                U+1F6CB-1F6D2, U+1F6E0-1F6E5, U+1F6E9, U+1F6EB-1F6EC, U+1F6F0,
                U+1F6F3-1F6F8, U+1F910-1F93A, U+1F93C-1F93E, U+1F940-1F945,
                U+1F947-1F94C, U+1F950-1F96B, U+1F980-1F997, U+1F9C0, U+1F9D0-1F9E6,
                U+E0062-E0063, U+E0065, U+E0067, U+E006C, U+E006E, U+E0073-E0074,
                U+E0077, U+E007F;
        }
    `);
}
styleToString({
  display: "inline-block",
  borderRadius: "50%",
  width: 12,
  height: 12,
  margin: "auto 8px auto 0"
});
const symbol = (args) => styleToString({
  display: "inline-block",
  borderRadius: "50%",
  width: args.width,
  height: args.height,
  backgroundColor: args.color,
  margin: "auto 8px auto 0"
});
const tooltipOuter = new Style({
  padding: 8
});
const tooltipItem = styleToString({
  display: "flex"
});
const tooltipItemLabel = styleToString({
  flex: 1,
  overflow: "hidden",
  margin: "auto 0",
  minWidth: 80
});
const tooltipItemValue = styleToString({
  margin: "auto 0",
  overflow: "hidden",
  textAlign: "right",
  minWidth: 80
});
if (typeof window !== "undefined")
  (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(PUBLIC_VERSION);
const chartType$f = "line";
function constant$2(x2) {
  return function constant2() {
    return x2;
  };
}
const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max = Math.max;
const min = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;
const epsilon$1 = 1e-12;
const pi$1 = Math.PI;
const halfPi = pi$1 / 2;
const tau$1 = 2 * pi$1;
function acos(x2) {
  return x2 > 1 ? 0 : x2 < -1 ? pi$1 : Math.acos(x2);
}
function asin(x2) {
  return x2 >= 1 ? halfPi : x2 <= -1 ? -halfPi : Math.asin(x2);
}
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(strings) {
  this._ += strings[0];
  for (let i2 = 1, n2 = strings.length; i2 < n2; ++i2) {
    this._ += arguments[i2] + strings[i2];
  }
}
function appendRound(digits) {
  let d = Math.floor(digits);
  if (!(d >= 0))
    throw new Error(`invalid digits: ${digits}`);
  if (d > 15)
    return append;
  const k = 10 ** d;
  return function(strings) {
    this._ += strings[0];
    for (let i2 = 1, n2 = strings.length; i2 < n2; ++i2) {
      this._ += Math.round(arguments[i2] * k) / k + strings[i2];
    }
  };
}
class Path {
  constructor(digits) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null;
    this._ = "";
    this._append = digits == null ? append : appendRound(digits);
  }
  moveTo(x2, y2) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._append`Z`;
    }
  }
  lineTo(x2, y2) {
    this._append`L${this._x1 = +x2},${this._y1 = +y2}`;
  }
  quadraticCurveTo(x1, y1, x2, y2) {
    this._append`Q${+x1},${+y1},${this._x1 = +x2},${this._y1 = +y2}`;
  }
  bezierCurveTo(x1, y1, x2, y2, x3, y3) {
    this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x3},${this._y1 = +y3}`;
  }
  arcTo(x1, y1, x2, y2, r2) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r2 = +r2;
    if (r2 < 0)
      throw new Error(`negative radius: ${r2}`);
    let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
    if (this._x1 === null) {
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    } else if (!(l01_2 > epsilon))
      ;
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r2) {
      this._append`L${this._x1 = x1},${this._y1 = y1}`;
    } else {
      let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l2 = r2 * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l2 / l01, t21 = l2 / l21;
      if (Math.abs(t01 - 1) > epsilon) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }
      this._append`A${r2},${r2},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
    }
  }
  arc(x2, y2, r2, a0, a1, ccw) {
    x2 = +x2, y2 = +y2, r2 = +r2, ccw = !!ccw;
    if (r2 < 0)
      throw new Error(`negative radius: ${r2}`);
    let dx = r2 * Math.cos(a0), dy = r2 * Math.sin(a0), x0 = x2 + dx, y0 = y2 + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    } else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._append`L${x0},${y0}`;
    }
    if (!r2)
      return;
    if (da < 0)
      da = da % tau + tau;
    if (da > tauEpsilon) {
      this._append`A${r2},${r2},0,1,${cw},${x2 - dx},${y2 - dy}A${r2},${r2},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
    } else if (da > epsilon) {
      this._append`A${r2},${r2},0,${+(da >= pi)},${cw},${this._x1 = x2 + r2 * Math.cos(a1)},${this._y1 = y2 + r2 * Math.sin(a1)}`;
    }
  }
  rect(x2, y2, w, h2) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}h${w = +w}v${+h2}h${-w}Z`;
  }
  toString() {
    return this._;
  }
}
function withPath(shape) {
  let digits = 3;
  shape.digits = function(_2) {
    if (!arguments.length)
      return digits;
    if (_2 == null) {
      digits = null;
    } else {
      const d = Math.floor(_2);
      if (!(d >= 0))
        throw new RangeError(`invalid digits: ${_2}`);
      digits = d;
    }
    return shape;
  };
  return () => new Path(digits);
}
function arcInnerRadius(d) {
  return d.innerRadius;
}
function arcOuterRadius(d) {
  return d.outerRadius;
}
function arcStartAngle(d) {
  return d.startAngle;
}
function arcEndAngle(d) {
  return d.endAngle;
}
function arcPadAngle(d) {
  return d && d.padAngle;
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t2 = y32 * x10 - x32 * y10;
  if (t2 * t2 < epsilon$1)
    return;
  t2 = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t2;
  return [x0 + t2 * x10, y0 + t2 * y10];
}
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r2 = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * sqrt(max(0, r2 * r2 * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1)
    cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r2 - 1),
    y11: cy0 * (r1 / r2 - 1)
  };
}
function arc() {
  var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = constant$2(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path = withPath(arc2);
  function arc2() {
    var buffer2, r2, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi, a1 = endAngle.apply(this, arguments) - halfPi, da = abs(a1 - a0), cw = a1 > a0;
    if (!context)
      context = buffer2 = path();
    if (r1 < r0)
      r2 = r1, r1 = r0, r0 = r2;
    if (!(r1 > epsilon$1))
      context.moveTo(0, 0);
    else if (da > tau$1 - epsilon$1) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$1) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    } else {
      var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon$1 && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)), rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
      if (rp > epsilon$1) {
        var p0 = asin(rp / r0 * sin(ap)), p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon$1)
          p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
        else
          da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$1)
          p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
        else
          da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos(a01), y01 = r1 * sin(a01), x10 = r0 * cos(a10), y10 = r0 * sin(a10);
      if (rc > epsilon$1) {
        var x11 = r1 * cos(a11), y11 = r1 * sin(a11), x00 = r0 * cos(a00), y00 = r0 * sin(a00), oc;
        if (da < pi$1) {
          if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2), lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
            rc0 = min(rc, (r0 - lc) / (kc - 1));
            rc1 = min(rc, (r1 - lc) / (kc + 1));
          } else {
            rc0 = rc1 = 0;
          }
        }
      }
      if (!(da1 > epsilon$1))
        context.moveTo(x01, y01);
      else if (rc1 > epsilon$1) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
        if (rc1 < rc)
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      } else
        context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
      if (!(r0 > epsilon$1) || !(da0 > epsilon$1))
        context.lineTo(x10, y10);
      else if (rc0 > epsilon$1) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
        if (rc0 < rc)
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      } else
        context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer2)
      return context = null, buffer2 + "" || null;
  }
  arc2.centroid = function() {
    var r2 = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a2 = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$1 / 2;
    return [cos(a2) * r2, sin(a2) * r2];
  };
  arc2.innerRadius = function(_2) {
    return arguments.length ? (innerRadius = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : innerRadius;
  };
  arc2.outerRadius = function(_2) {
    return arguments.length ? (outerRadius = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : outerRadius;
  };
  arc2.cornerRadius = function(_2) {
    return arguments.length ? (cornerRadius = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : cornerRadius;
  };
  arc2.padRadius = function(_2) {
    return arguments.length ? (padRadius = _2 == null ? null : typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : padRadius;
  };
  arc2.startAngle = function(_2) {
    return arguments.length ? (startAngle = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : startAngle;
  };
  arc2.endAngle = function(_2) {
    return arguments.length ? (endAngle = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : endAngle;
  };
  arc2.padAngle = function(_2) {
    return arguments.length ? (padAngle = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : padAngle;
  };
  arc2.context = function(_2) {
    return arguments.length ? (context = _2 == null ? null : _2, arc2) : context;
  };
  return arc2;
}
function array(x2) {
  return typeof x2 === "object" && "length" in x2 ? x2 : Array.from(x2);
}
function Linear(context) {
  this._context = context;
}
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(x2, y2);
        break;
    }
  }
};
function curveLinear(context) {
  return new Linear(context);
}
function x$2(p2) {
  return p2[0];
}
function y$2(p2) {
  return p2[1];
}
function line(x2, y2) {
  var defined = constant$2(true), context = null, curve = curveLinear, output = null, path = withPath(line2);
  x2 = typeof x2 === "function" ? x2 : x2 === void 0 ? x$2 : constant$2(x2);
  y2 = typeof y2 === "function" ? y2 : y2 === void 0 ? y$2 : constant$2(y2);
  function line2(data) {
    var i2, n2 = (data = array(data)).length, d, defined0 = false, buffer2;
    if (context == null)
      output = curve(buffer2 = path());
    for (i2 = 0; i2 <= n2; ++i2) {
      if (!(i2 < n2 && defined(d = data[i2], i2, data)) === defined0) {
        if (defined0 = !defined0)
          output.lineStart();
        else
          output.lineEnd();
      }
      if (defined0)
        output.point(+x2(d, i2, data), +y2(d, i2, data));
    }
    if (buffer2)
      return output = null, buffer2 + "" || null;
  }
  line2.x = function(_2) {
    return arguments.length ? (x2 = typeof _2 === "function" ? _2 : constant$2(+_2), line2) : x2;
  };
  line2.y = function(_2) {
    return arguments.length ? (y2 = typeof _2 === "function" ? _2 : constant$2(+_2), line2) : y2;
  };
  line2.defined = function(_2) {
    return arguments.length ? (defined = typeof _2 === "function" ? _2 : constant$2(!!_2), line2) : defined;
  };
  line2.curve = function(_2) {
    return arguments.length ? (curve = _2, context != null && (output = curve(context)), line2) : curve;
  };
  line2.context = function(_2) {
    return arguments.length ? (_2 == null ? context = output = null : output = curve(context = _2), line2) : context;
  };
  return line2;
}
function area(x0, y0, y1) {
  var x1 = null, defined = constant$2(true), context = null, curve = curveLinear, output = null, path = withPath(area2);
  x0 = typeof x0 === "function" ? x0 : x0 === void 0 ? x$2 : constant$2(+x0);
  y0 = typeof y0 === "function" ? y0 : y0 === void 0 ? constant$2(0) : constant$2(+y0);
  y1 = typeof y1 === "function" ? y1 : y1 === void 0 ? y$2 : constant$2(+y1);
  function area2(data) {
    var i2, j, k, n2 = (data = array(data)).length, d, defined0 = false, buffer2, x0z = new Array(n2), y0z = new Array(n2);
    if (context == null)
      output = curve(buffer2 = path());
    for (i2 = 0; i2 <= n2; ++i2) {
      if (!(i2 < n2 && defined(d = data[i2], i2, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i2;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i2 - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i2] = +x0(d, i2, data), y0z[i2] = +y0(d, i2, data);
        output.point(x1 ? +x1(d, i2, data) : x0z[i2], y1 ? +y1(d, i2, data) : y0z[i2]);
      }
    }
    if (buffer2)
      return output = null, buffer2 + "" || null;
  }
  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }
  area2.x = function(_2) {
    return arguments.length ? (x0 = typeof _2 === "function" ? _2 : constant$2(+_2), x1 = null, area2) : x0;
  };
  area2.x0 = function(_2) {
    return arguments.length ? (x0 = typeof _2 === "function" ? _2 : constant$2(+_2), area2) : x0;
  };
  area2.x1 = function(_2) {
    return arguments.length ? (x1 = _2 == null ? null : typeof _2 === "function" ? _2 : constant$2(+_2), area2) : x1;
  };
  area2.y = function(_2) {
    return arguments.length ? (y0 = typeof _2 === "function" ? _2 : constant$2(+_2), y1 = null, area2) : y0;
  };
  area2.y0 = function(_2) {
    return arguments.length ? (y0 = typeof _2 === "function" ? _2 : constant$2(+_2), area2) : y0;
  };
  area2.y1 = function(_2) {
    return arguments.length ? (y1 = _2 == null ? null : typeof _2 === "function" ? _2 : constant$2(+_2), area2) : y1;
  };
  area2.lineX0 = area2.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };
  area2.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };
  area2.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };
  area2.defined = function(_2) {
    return arguments.length ? (defined = typeof _2 === "function" ? _2 : constant$2(!!_2), area2) : defined;
  };
  area2.curve = function(_2) {
    return arguments.length ? (curve = _2, context != null && (output = curve(context)), area2) : curve;
  };
  area2.context = function(_2) {
    return arguments.length ? (_2 == null ? context = output = null : output = curve(context = _2), area2) : context;
  };
  return area2;
}
function sign(x2) {
  return x2 < 0 ? -1 : 1;
}
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p2 = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p2)) || 0;
}
function slope2(that, t2) {
  var h2 = that._x1 - that._x0;
  return h2 ? (3 * (that._y1 - that._y0) / h2 - t2) / 2 : t2;
}
function point(that, t0, t1) {
  var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
  this._context = context;
}
MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point(this, this._t0, slope2(this, this._t0));
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    var t1 = NaN;
    x2 = +x2, y2 = +y2;
    if (x2 === this._x1 && y2 === this._y1)
      return;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        point(this, slope2(this, t1 = slope3(this, x2, y2)), t1);
        break;
      default:
        point(this, this._t0, t1 = slope3(this, x2, y2));
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
    this._t0 = t1;
  }
};
function MonotoneY(context) {
  this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x2, y2) {
  MonotoneX.prototype.point.call(this, y2, x2);
};
function ReflectContext(context) {
  this._context = context;
}
ReflectContext.prototype = {
  moveTo: function(x2, y2) {
    this._context.moveTo(y2, x2);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(x2, y2) {
    this._context.lineTo(y2, x2);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x3, y3) {
    this._context.bezierCurveTo(y1, x1, y2, x2, y3, x3);
  }
};
function monotoneX(context) {
  return new MonotoneX(context);
}
function monotoneY(context) {
  return new MonotoneY(context);
}
class EventDispatcher {
  constructor(events = {}) {
    __publicField(this, "events", {});
    Object.keys(events).forEach((_key) => {
      const key = _key;
      this.events[key] = events[key];
    });
  }
  listen(eventName, handler) {
    const name = eventName;
    this.events[name] = handler;
  }
  dispatch(eventName, e3) {
    let event = this.events[eventName];
    if (event) {
      if ("subscribe" in event) {
        const storedevent = get_store_value(event);
        if (storedevent) {
          return storedevent(e3);
        }
      } else {
        return event(e3);
      }
    }
  }
}
class BoundingRect {
  constructor() {
    __publicField(this, "x", 0);
    __publicField(this, "y", 0);
    __publicField(this, "width", 0);
    __publicField(this, "height", 0);
    __publicField(this, "visible", true);
  }
  contain(x2, y2) {
    if (this.visible === false) {
      return false;
    }
    if (x2 >= this.x && x2 <= this.x + this.width && y2 >= this.y && y2 <= this.y + this.height) {
      return true;
    }
    return false;
  }
  intersect(rect) {
    if (this.visible === false) {
      return false;
    }
    let xOverlap = false;
    if (this.x <= rect.x && this.x + this.width >= rect.x) {
      xOverlap = true;
    } else if (this.x <= rect.x + rect.width && this.x + this.width >= rect.x + rect.width) {
      xOverlap = true;
    } else if (rect.x <= this.x && rect.x + rect.width >= this.x) {
      xOverlap = true;
    } else if (rect.x <= this.x + this.width && rect.x + rect.width >= this.x + this.width) {
      xOverlap = true;
    }
    if (xOverlap === false) {
      return false;
    }
    let yOverlap = false;
    if (this.y <= rect.y && this.y + this.height >= rect.y) {
      yOverlap = true;
    } else if (this.y <= rect.y + rect.height && this.y + this.height >= rect.y + rect.height) {
      yOverlap = true;
    } else if (rect.y <= this.y && rect.y + rect.height >= this.y) {
      yOverlap = true;
    } else if (rect.y <= this.y + this.height && rect.y + rect.height >= this.y + this.height) {
      yOverlap = true;
    }
    if (yOverlap === false) {
      return false;
    }
    return true;
  }
}
let id = 0;
class BaseShape {
  constructor(option) {
    __publicField(this, "id");
    __publicField(this, "instance");
    __publicField(this, "shapeid", null);
    __publicField(this, "hoveredComponent");
    __publicField(this, "focusedComponent");
    __publicField(this, "priority");
    // props
    __publicField(this, "visible", writable(false));
    __publicField(this, "clickable", writable(false));
    __publicField(this, "hoverable", writable(false));
    // cursor
    __publicField(this, "cursor");
    __publicField(this, "events", new EventDispatcher());
    // state
    __publicField(this, "focused");
    __publicField(this, "hovered");
    __publicField(this, "inactive");
    __publicField(this, "data");
    // cache boundinRect
    __publicField(this, "_boundingRect", null);
    __publicField(this, "_containCache", {});
    __publicField(this, "_polygon", null);
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i;
    this.id = ++id;
    this.instance = (_a2 = option.instance) != null ? _a2 : getInstance();
    this.priority = (_b = option.priority) != null ? _b : readable(-1);
    this.visible.set((_c = option.visible) != null ? _c : true);
    this.clickable.set((_d = option.clickable) != null ? _d : false);
    this.hoverable.set((_e = option.hoverable) != null ? _e : false);
    this.cursor = option.cursor;
    this.focused = (_f = option.focused) != null ? _f : readable(false);
    this.hovered = (_g = option.hovered) != null ? _g : readable(false);
    this.inactive = (_h = option.inactive) != null ? _h : readable(false);
    this.data = (_i = option.data) != null ? _i : {};
    const optionEvents = option.events;
    if (optionEvents) {
      Object.keys(optionEvents).forEach((eventName) => {
        this.events.listen(
          eventName,
          optionEvents[eventName]
        );
      });
    }
  }
  apply() {
    this._boundingRect = null;
    this._containCache = {};
    return this;
  }
  _getBoundingRect() {
    const rect = new BoundingRect();
    return rect;
  }
  getBoundingRect() {
    if (!this._boundingRect) {
      this._boundingRect = this._getBoundingRect();
    }
    return this._boundingRect;
  }
  _getPolygon() {
    return new Polygon({ points: [] });
  }
  getPolygon() {
    if (!this._polygon) {
      this._polygon = this._getPolygon();
    }
    return this._polygon;
  }
  _contain(x2, y2) {
    return this.getBoundingRect().contain(x2, y2);
  }
  contain(_x, _y) {
    const x2 = round$1(_x, 0);
    const y2 = round$1(_y, 0);
    const key = `${x2}:${y2}`;
    if (!this._containCache[key]) {
      this._containCache[key] = this._contain(x2, y2);
    }
    return this._containCache[key];
  }
  intersect(boundingRect) {
    return this.getBoundingRect().intersect(boundingRect);
  }
  destroy() {
  }
}
function create_if_block$E(ctx2) {
  let if_block_anchor;
  function select_block_type(ctx3, dirty) {
    if (
      /*state*/
      ctx3[1] === "hover"
    )
      return create_if_block_1$g;
    if (
      /*state*/
      ctx3[1] === "focus"
    )
      return create_if_block_2$a;
    return create_else_block$e;
  }
  let current_block_type = select_block_type(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (current_block_type === (current_block_type = select_block_type(ctx3)) && if_block) {
        if_block.p(ctx3, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx3);
        if (if_block) {
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if_block.d(detaching);
    }
  };
}
function create_else_block$e(ctx2) {
  let path;
  let path_levels = [
    {
      .../*$props*/
      ctx2[5],
      .../*baseProps*/
      ctx2[2]
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*$props, baseProps*/
        36 && {
          .../*$props*/
          ctx3[5],
          .../*baseProps*/
          ctx3[2]
        }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_if_block_2$a(ctx2) {
  let path;
  let path_stroke_value;
  let path_stroke_width_value;
  let path_visibility_value;
  let path_levels = [
    /*baseProps*/
    ctx2[2],
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: path_stroke_value = "#333" },
    {
      "stroke-width": path_stroke_width_value = 2
    },
    {
      visibility: path_visibility_value = /*$focused*/
      ctx2[4] ? "" : "hidden"
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps*/
        4 && /*baseProps*/
        ctx3[2],
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: path_stroke_value },
        { "stroke-width": path_stroke_width_value },
        dirty & /*$focused*/
        16 && path_visibility_value !== (path_visibility_value = /*$focused*/
        ctx3[4] ? "" : "hidden") && { visibility: path_visibility_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_if_block_1$g(ctx2) {
  let path;
  let path_stroke_value;
  let path_stroke_width_value;
  let path_visibility_value;
  let path_levels = [
    /*baseProps*/
    ctx2[2],
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: path_stroke_value = "#333" },
    {
      "stroke-width": path_stroke_width_value = 1
    },
    {
      visibility: path_visibility_value = /*$hovered*/
      ctx2[3] ? "" : "hidden"
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps*/
        4 && /*baseProps*/
        ctx3[2],
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: path_stroke_value },
        { "stroke-width": path_stroke_width_value },
        dirty & /*$hovered*/
        8 && path_visibility_value !== (path_visibility_value = /*$hovered*/
        ctx3[3] ? "" : "hidden") && { visibility: path_visibility_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_fragment$M(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$E(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$E(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$s($$self, $$props, $$invalidate) {
  let baseProps;
  let $inactive;
  let $visible;
  let $dpath;
  let $hovered;
  let $focused;
  let $props;
  let { shapeInstance } = $$props;
  let { state = null } = $$props;
  const { focused, hovered, inactive, visible, props, dpath } = shapeInstance;
  component_subscribe($$self, focused, (value) => $$invalidate(4, $focused = value));
  component_subscribe($$self, hovered, (value) => $$invalidate(3, $hovered = value));
  component_subscribe($$self, inactive, (value) => $$invalidate(12, $inactive = value));
  component_subscribe($$self, visible, (value) => $$invalidate(13, $visible = value));
  component_subscribe($$self, props, (value) => $$invalidate(5, $props = value));
  component_subscribe($$self, dpath, (value) => $$invalidate(14, $dpath = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
    if ("state" in $$props2)
      $$invalidate(1, state = $$props2.state);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$dpath, $visible, $inactive*/
    28672) {
      $$invalidate(2, baseProps = (() => {
        return {
          d: $dpath,
          visibility: $visible ? "" : "hidden",
          ...$inactive ? { opacity: 0.2 } : {}
        };
      })());
    }
  };
  return [
    shapeInstance,
    state,
    baseProps,
    $hovered,
    $focused,
    $props,
    focused,
    hovered,
    inactive,
    visible,
    props,
    dpath,
    $inactive,
    $visible,
    $dpath
  ];
}
let Component$c = class Component extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$s, create_fragment$M, safe_not_equal, { shapeInstance: 0, state: 1 });
  }
};
const AreaShapeComponent = Component$c;
class AreaShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "polyline");
    __publicField(this, "shapeProps", writable({
      layout: "vertical",
      points: [],
      smooth: false
    }));
    __publicField(this, "props");
    __publicField(this, "component", Component$c);
    __publicField(this, "hoveredComponent", Component$c);
    __publicField(this, "focusedComponent", Component$c);
    __publicField(this, "dpath");
    this.shapeProps.update((shapeProps) => {
      return {
        ...shapeProps,
        ...option
      };
    });
    this.shapeProps.subscribe(() => {
      this.apply();
    });
    this.dpath = derived([this.shapeProps], ([$shapeProps]) => {
      const { layout, points, smooth } = $shapeProps;
      if (points.length === 0) {
        return "";
      }
      const l2 = layout === "vertical" ? area().x((d) => {
        var _a3;
        return (_a3 = d.x) != null ? _a3 : 0;
      }).y0((d) => {
        var _a3;
        return (_a3 = d.y0) != null ? _a3 : 0;
      }).y1((d) => {
        var _a3;
        return (_a3 = d.y1) != null ? _a3 : 0;
      }).curve(smooth ? monotoneX : curveLinear) : area().x0((d) => {
        var _a3;
        return (_a3 = d.x0) != null ? _a3 : 0;
      }).x1((d) => {
        var _a3;
        return (_a3 = d.x1) != null ? _a3 : 0;
      }).y((d) => {
        var _a3;
        return (_a3 = d.y) != null ? _a3 : 0;
      }).curve(smooth ? monotoneY : curveLinear);
      return l2(points) || "";
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
}
var chroma$1 = { exports: {} };
/**
 * chroma.js - JavaScript library for color conversions
 *
 * Copyright (c) 2011-2019, Gregor Aisch
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 * derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * -------------------------------------------------------
 *
 * chroma.js includes colors from colorbrewer2.org, which are released under
 * the following license:
 *
 * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
 * and The Pennsylvania State University.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 *
 * ------------------------------------------------------
 *
 * Named colors are taken from X11 Color Names.
 * http://www.w3.org/TR/css3-color/#svg-color
 *
 * @preserve
 */
(function(module, exports) {
  (function(global2, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    var limit$2 = function(x2, min3, max3) {
      if (min3 === void 0)
        min3 = 0;
      if (max3 === void 0)
        max3 = 1;
      return x2 < min3 ? min3 : x2 > max3 ? max3 : x2;
    };
    var limit$1 = limit$2;
    var clip_rgb$3 = function(rgb3) {
      rgb3._clipped = false;
      rgb3._unclipped = rgb3.slice(0);
      for (var i3 = 0; i3 <= 3; i3++) {
        if (i3 < 3) {
          if (rgb3[i3] < 0 || rgb3[i3] > 255) {
            rgb3._clipped = true;
          }
          rgb3[i3] = limit$1(rgb3[i3], 0, 255);
        } else if (i3 === 3) {
          rgb3[i3] = limit$1(rgb3[i3], 0, 1);
        }
      }
      return rgb3;
    };
    var classToType = {};
    for (var i$1 = 0, list$1 = ["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp", "Undefined", "Null"]; i$1 < list$1.length; i$1 += 1) {
      var name = list$1[i$1];
      classToType["[object " + name + "]"] = name.toLowerCase();
    }
    var type$p = function(obj) {
      return classToType[Object.prototype.toString.call(obj)] || "object";
    };
    var type$o = type$p;
    var unpack$B = function(args, keyOrder) {
      if (keyOrder === void 0)
        keyOrder = null;
      if (args.length >= 3) {
        return Array.prototype.slice.call(args);
      }
      if (type$o(args[0]) == "object" && keyOrder) {
        return keyOrder.split("").filter(function(k) {
          return args[0][k] !== void 0;
        }).map(function(k) {
          return args[0][k];
        });
      }
      return args[0];
    };
    var type$n = type$p;
    var last$4 = function(args) {
      if (args.length < 2) {
        return null;
      }
      var l2 = args.length - 1;
      if (type$n(args[l2]) == "string") {
        return args[l2].toLowerCase();
      }
      return null;
    };
    var PI$2 = Math.PI;
    var utils = {
      clip_rgb: clip_rgb$3,
      limit: limit$2,
      type: type$p,
      unpack: unpack$B,
      last: last$4,
      PI: PI$2,
      TWOPI: PI$2 * 2,
      PITHIRD: PI$2 / 3,
      DEG2RAD: PI$2 / 180,
      RAD2DEG: 180 / PI$2
    };
    var input$h = {
      format: {},
      autodetect: []
    };
    var last$3 = utils.last;
    var clip_rgb$2 = utils.clip_rgb;
    var type$m = utils.type;
    var _input = input$h;
    var Color$D = function Color3() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var me = this;
      if (type$m(args[0]) === "object" && args[0].constructor && args[0].constructor === this.constructor) {
        return args[0];
      }
      var mode = last$3(args);
      var autodetect = false;
      if (!mode) {
        autodetect = true;
        if (!_input.sorted) {
          _input.autodetect = _input.autodetect.sort(function(a2, b) {
            return b.p - a2.p;
          });
          _input.sorted = true;
        }
        for (var i3 = 0, list2 = _input.autodetect; i3 < list2.length; i3 += 1) {
          var chk = list2[i3];
          mode = chk.test.apply(chk, args);
          if (mode) {
            break;
          }
        }
      }
      if (_input.format[mode]) {
        var rgb3 = _input.format[mode].apply(null, autodetect ? args : args.slice(0, -1));
        me._rgb = clip_rgb$2(rgb3);
      } else {
        throw new Error("unknown format: " + args);
      }
      if (me._rgb.length === 3) {
        me._rgb.push(1);
      }
    };
    Color$D.prototype.toString = function toString() {
      if (type$m(this.hex) == "function") {
        return this.hex();
      }
      return "[" + this._rgb.join(",") + "]";
    };
    var Color_1 = Color$D;
    var chroma$k = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(chroma$k.Color, [null].concat(args)))();
    };
    chroma$k.Color = Color_1;
    chroma$k.version = "2.4.2";
    var chroma_1 = chroma$k;
    var unpack$A = utils.unpack;
    var max$2 = Math.max;
    var rgb2cmyk$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var ref = unpack$A(args, "rgb");
      var r2 = ref[0];
      var g = ref[1];
      var b = ref[2];
      r2 = r2 / 255;
      g = g / 255;
      b = b / 255;
      var k = 1 - max$2(r2, max$2(g, b));
      var f2 = k < 1 ? 1 / (1 - k) : 0;
      var c2 = (1 - r2 - k) * f2;
      var m2 = (1 - g - k) * f2;
      var y2 = (1 - b - k) * f2;
      return [c2, m2, y2, k];
    };
    var rgb2cmyk_1 = rgb2cmyk$1;
    var unpack$z = utils.unpack;
    var cmyk2rgb = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      args = unpack$z(args, "cmyk");
      var c2 = args[0];
      var m2 = args[1];
      var y2 = args[2];
      var k = args[3];
      var alpha = args.length > 4 ? args[4] : 1;
      if (k === 1) {
        return [0, 0, 0, alpha];
      }
      return [
        c2 >= 1 ? 0 : 255 * (1 - c2) * (1 - k),
        // r
        m2 >= 1 ? 0 : 255 * (1 - m2) * (1 - k),
        // g
        y2 >= 1 ? 0 : 255 * (1 - y2) * (1 - k),
        // b
        alpha
      ];
    };
    var cmyk2rgb_1 = cmyk2rgb;
    var chroma$j = chroma_1;
    var Color$C = Color_1;
    var input$g = input$h;
    var unpack$y = utils.unpack;
    var type$l = utils.type;
    var rgb2cmyk = rgb2cmyk_1;
    Color$C.prototype.cmyk = function() {
      return rgb2cmyk(this._rgb);
    };
    chroma$j.cmyk = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$C, [null].concat(args, ["cmyk"])))();
    };
    input$g.format.cmyk = cmyk2rgb_1;
    input$g.autodetect.push({
      p: 2,
      test: function() {
        var args = [], len = arguments.length;
        while (len--)
          args[len] = arguments[len];
        args = unpack$y(args, "cmyk");
        if (type$l(args) === "array" && args.length === 4) {
          return "cmyk";
        }
      }
    });
    var unpack$x = utils.unpack;
    var last$2 = utils.last;
    var rnd = function(a2) {
      return Math.round(a2 * 100) / 100;
    };
    var hsl2css$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var hsla2 = unpack$x(args, "hsla");
      var mode = last$2(args) || "lsa";
      hsla2[0] = rnd(hsla2[0] || 0);
      hsla2[1] = rnd(hsla2[1] * 100) + "%";
      hsla2[2] = rnd(hsla2[2] * 100) + "%";
      if (mode === "hsla" || hsla2.length > 3 && hsla2[3] < 1) {
        hsla2[3] = hsla2.length > 3 ? hsla2[3] : 1;
        mode = "hsla";
      } else {
        hsla2.length = 3;
      }
      return mode + "(" + hsla2.join(",") + ")";
    };
    var hsl2css_1 = hsl2css$1;
    var unpack$w = utils.unpack;
    var rgb2hsl$3 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      args = unpack$w(args, "rgba");
      var r2 = args[0];
      var g = args[1];
      var b = args[2];
      r2 /= 255;
      g /= 255;
      b /= 255;
      var min3 = Math.min(r2, g, b);
      var max3 = Math.max(r2, g, b);
      var l2 = (max3 + min3) / 2;
      var s2, h2;
      if (max3 === min3) {
        s2 = 0;
        h2 = Number.NaN;
      } else {
        s2 = l2 < 0.5 ? (max3 - min3) / (max3 + min3) : (max3 - min3) / (2 - max3 - min3);
      }
      if (r2 == max3) {
        h2 = (g - b) / (max3 - min3);
      } else if (g == max3) {
        h2 = 2 + (b - r2) / (max3 - min3);
      } else if (b == max3) {
        h2 = 4 + (r2 - g) / (max3 - min3);
      }
      h2 *= 60;
      if (h2 < 0) {
        h2 += 360;
      }
      if (args.length > 3 && args[3] !== void 0) {
        return [h2, s2, l2, args[3]];
      }
      return [h2, s2, l2];
    };
    var rgb2hsl_1 = rgb2hsl$3;
    var unpack$v = utils.unpack;
    var last$1 = utils.last;
    var hsl2css = hsl2css_1;
    var rgb2hsl$2 = rgb2hsl_1;
    var round$6 = Math.round;
    var rgb2css$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var rgba2 = unpack$v(args, "rgba");
      var mode = last$1(args) || "rgb";
      if (mode.substr(0, 3) == "hsl") {
        return hsl2css(rgb2hsl$2(rgba2), mode);
      }
      rgba2[0] = round$6(rgba2[0]);
      rgba2[1] = round$6(rgba2[1]);
      rgba2[2] = round$6(rgba2[2]);
      if (mode === "rgba" || rgba2.length > 3 && rgba2[3] < 1) {
        rgba2[3] = rgba2.length > 3 ? rgba2[3] : 1;
        mode = "rgba";
      }
      return mode + "(" + rgba2.slice(0, mode === "rgb" ? 3 : 4).join(",") + ")";
    };
    var rgb2css_1 = rgb2css$1;
    var unpack$u = utils.unpack;
    var round$5 = Math.round;
    var hsl2rgb$1 = function() {
      var assign2;
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      args = unpack$u(args, "hsl");
      var h2 = args[0];
      var s2 = args[1];
      var l2 = args[2];
      var r2, g, b;
      if (s2 === 0) {
        r2 = g = b = l2 * 255;
      } else {
        var t3 = [0, 0, 0];
        var c2 = [0, 0, 0];
        var t2 = l2 < 0.5 ? l2 * (1 + s2) : l2 + s2 - l2 * s2;
        var t1 = 2 * l2 - t2;
        var h_ = h2 / 360;
        t3[0] = h_ + 1 / 3;
        t3[1] = h_;
        t3[2] = h_ - 1 / 3;
        for (var i3 = 0; i3 < 3; i3++) {
          if (t3[i3] < 0) {
            t3[i3] += 1;
          }
          if (t3[i3] > 1) {
            t3[i3] -= 1;
          }
          if (6 * t3[i3] < 1) {
            c2[i3] = t1 + (t2 - t1) * 6 * t3[i3];
          } else if (2 * t3[i3] < 1) {
            c2[i3] = t2;
          } else if (3 * t3[i3] < 2) {
            c2[i3] = t1 + (t2 - t1) * (2 / 3 - t3[i3]) * 6;
          } else {
            c2[i3] = t1;
          }
        }
        assign2 = [round$5(c2[0] * 255), round$5(c2[1] * 255), round$5(c2[2] * 255)], r2 = assign2[0], g = assign2[1], b = assign2[2];
      }
      if (args.length > 3) {
        return [r2, g, b, args[3]];
      }
      return [r2, g, b, 1];
    };
    var hsl2rgb_1 = hsl2rgb$1;
    var hsl2rgb2 = hsl2rgb_1;
    var input$f = input$h;
    var RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
    var RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
    var RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
    var round$4 = Math.round;
    var css2rgb$1 = function(css) {
      css = css.toLowerCase().trim();
      var m2;
      if (input$f.format.named) {
        try {
          return input$f.format.named(css);
        } catch (e3) {
        }
      }
      if (m2 = css.match(RE_RGB)) {
        var rgb3 = m2.slice(1, 4);
        for (var i3 = 0; i3 < 3; i3++) {
          rgb3[i3] = +rgb3[i3];
        }
        rgb3[3] = 1;
        return rgb3;
      }
      if (m2 = css.match(RE_RGBA)) {
        var rgb$1 = m2.slice(1, 5);
        for (var i$12 = 0; i$12 < 4; i$12++) {
          rgb$1[i$12] = +rgb$1[i$12];
        }
        return rgb$1;
      }
      if (m2 = css.match(RE_RGB_PCT)) {
        var rgb$2 = m2.slice(1, 4);
        for (var i$2 = 0; i$2 < 3; i$2++) {
          rgb$2[i$2] = round$4(rgb$2[i$2] * 2.55);
        }
        rgb$2[3] = 1;
        return rgb$2;
      }
      if (m2 = css.match(RE_RGBA_PCT)) {
        var rgb$3 = m2.slice(1, 5);
        for (var i$3 = 0; i$3 < 3; i$3++) {
          rgb$3[i$3] = round$4(rgb$3[i$3] * 2.55);
        }
        rgb$3[3] = +rgb$3[3];
        return rgb$3;
      }
      if (m2 = css.match(RE_HSL)) {
        var hsl3 = m2.slice(1, 4);
        hsl3[1] *= 0.01;
        hsl3[2] *= 0.01;
        var rgb$4 = hsl2rgb2(hsl3);
        rgb$4[3] = 1;
        return rgb$4;
      }
      if (m2 = css.match(RE_HSLA)) {
        var hsl$1 = m2.slice(1, 4);
        hsl$1[1] *= 0.01;
        hsl$1[2] *= 0.01;
        var rgb$5 = hsl2rgb2(hsl$1);
        rgb$5[3] = +m2[4];
        return rgb$5;
      }
    };
    css2rgb$1.test = function(s2) {
      return RE_RGB.test(s2) || RE_RGBA.test(s2) || RE_RGB_PCT.test(s2) || RE_RGBA_PCT.test(s2) || RE_HSL.test(s2) || RE_HSLA.test(s2);
    };
    var css2rgb_1 = css2rgb$1;
    var chroma$i = chroma_1;
    var Color$B = Color_1;
    var input$e = input$h;
    var type$k = utils.type;
    var rgb2css = rgb2css_1;
    var css2rgb = css2rgb_1;
    Color$B.prototype.css = function(mode) {
      return rgb2css(this._rgb, mode);
    };
    chroma$i.css = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$B, [null].concat(args, ["css"])))();
    };
    input$e.format.css = css2rgb;
    input$e.autodetect.push({
      p: 5,
      test: function(h2) {
        var rest = [], len = arguments.length - 1;
        while (len-- > 0)
          rest[len] = arguments[len + 1];
        if (!rest.length && type$k(h2) === "string" && css2rgb.test(h2)) {
          return "css";
        }
      }
    });
    var Color$A = Color_1;
    var chroma$h = chroma_1;
    var input$d = input$h;
    var unpack$t = utils.unpack;
    input$d.format.gl = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var rgb3 = unpack$t(args, "rgba");
      rgb3[0] *= 255;
      rgb3[1] *= 255;
      rgb3[2] *= 255;
      return rgb3;
    };
    chroma$h.gl = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$A, [null].concat(args, ["gl"])))();
    };
    Color$A.prototype.gl = function() {
      var rgb3 = this._rgb;
      return [rgb3[0] / 255, rgb3[1] / 255, rgb3[2] / 255, rgb3[3]];
    };
    var unpack$s = utils.unpack;
    var rgb2hcg$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var ref = unpack$s(args, "rgb");
      var r2 = ref[0];
      var g = ref[1];
      var b = ref[2];
      var min3 = Math.min(r2, g, b);
      var max3 = Math.max(r2, g, b);
      var delta = max3 - min3;
      var c2 = delta * 100 / 255;
      var _g = min3 / (255 - delta) * 100;
      var h2;
      if (delta === 0) {
        h2 = Number.NaN;
      } else {
        if (r2 === max3) {
          h2 = (g - b) / delta;
        }
        if (g === max3) {
          h2 = 2 + (b - r2) / delta;
        }
        if (b === max3) {
          h2 = 4 + (r2 - g) / delta;
        }
        h2 *= 60;
        if (h2 < 0) {
          h2 += 360;
        }
      }
      return [h2, c2, _g];
    };
    var rgb2hcg_1 = rgb2hcg$1;
    var unpack$r = utils.unpack;
    var floor$3 = Math.floor;
    var hcg2rgb = function() {
      var assign2, assign$12, assign$2, assign$3, assign$4, assign$5;
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      args = unpack$r(args, "hcg");
      var h2 = args[0];
      var c2 = args[1];
      var _g = args[2];
      var r2, g, b;
      _g = _g * 255;
      var _c = c2 * 255;
      if (c2 === 0) {
        r2 = g = b = _g;
      } else {
        if (h2 === 360) {
          h2 = 0;
        }
        if (h2 > 360) {
          h2 -= 360;
        }
        if (h2 < 0) {
          h2 += 360;
        }
        h2 /= 60;
        var i3 = floor$3(h2);
        var f2 = h2 - i3;
        var p2 = _g * (1 - c2);
        var q = p2 + _c * (1 - f2);
        var t2 = p2 + _c * f2;
        var v2 = p2 + _c;
        switch (i3) {
          case 0:
            assign2 = [v2, t2, p2], r2 = assign2[0], g = assign2[1], b = assign2[2];
            break;
          case 1:
            assign$12 = [q, v2, p2], r2 = assign$12[0], g = assign$12[1], b = assign$12[2];
            break;
          case 2:
            assign$2 = [p2, v2, t2], r2 = assign$2[0], g = assign$2[1], b = assign$2[2];
            break;
          case 3:
            assign$3 = [p2, q, v2], r2 = assign$3[0], g = assign$3[1], b = assign$3[2];
            break;
          case 4:
            assign$4 = [t2, p2, v2], r2 = assign$4[0], g = assign$4[1], b = assign$4[2];
            break;
          case 5:
            assign$5 = [v2, p2, q], r2 = assign$5[0], g = assign$5[1], b = assign$5[2];
            break;
        }
      }
      return [r2, g, b, args.length > 3 ? args[3] : 1];
    };
    var hcg2rgb_1 = hcg2rgb;
    var unpack$q = utils.unpack;
    var type$j = utils.type;
    var chroma$g = chroma_1;
    var Color$z = Color_1;
    var input$c = input$h;
    var rgb2hcg = rgb2hcg_1;
    Color$z.prototype.hcg = function() {
      return rgb2hcg(this._rgb);
    };
    chroma$g.hcg = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$z, [null].concat(args, ["hcg"])))();
    };
    input$c.format.hcg = hcg2rgb_1;
    input$c.autodetect.push({
      p: 1,
      test: function() {
        var args = [], len = arguments.length;
        while (len--)
          args[len] = arguments[len];
        args = unpack$q(args, "hcg");
        if (type$j(args) === "array" && args.length === 3) {
          return "hcg";
        }
      }
    });
    var unpack$p = utils.unpack;
    var last = utils.last;
    var round$3 = Math.round;
    var rgb2hex$2 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var ref = unpack$p(args, "rgba");
      var r2 = ref[0];
      var g = ref[1];
      var b = ref[2];
      var a2 = ref[3];
      var mode = last(args) || "auto";
      if (a2 === void 0) {
        a2 = 1;
      }
      if (mode === "auto") {
        mode = a2 < 1 ? "rgba" : "rgb";
      }
      r2 = round$3(r2);
      g = round$3(g);
      b = round$3(b);
      var u2 = r2 << 16 | g << 8 | b;
      var str = "000000" + u2.toString(16);
      str = str.substr(str.length - 6);
      var hxa = "0" + round$3(a2 * 255).toString(16);
      hxa = hxa.substr(hxa.length - 2);
      switch (mode.toLowerCase()) {
        case "rgba":
          return "#" + str + hxa;
        case "argb":
          return "#" + hxa + str;
        default:
          return "#" + str;
      }
    };
    var rgb2hex_1 = rgb2hex$2;
    var RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    var RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
    var hex2rgb$1 = function(hex2) {
      if (hex2.match(RE_HEX)) {
        if (hex2.length === 4 || hex2.length === 7) {
          hex2 = hex2.substr(1);
        }
        if (hex2.length === 3) {
          hex2 = hex2.split("");
          hex2 = hex2[0] + hex2[0] + hex2[1] + hex2[1] + hex2[2] + hex2[2];
        }
        var u2 = parseInt(hex2, 16);
        var r2 = u2 >> 16;
        var g = u2 >> 8 & 255;
        var b = u2 & 255;
        return [r2, g, b, 1];
      }
      if (hex2.match(RE_HEXA)) {
        if (hex2.length === 5 || hex2.length === 9) {
          hex2 = hex2.substr(1);
        }
        if (hex2.length === 4) {
          hex2 = hex2.split("");
          hex2 = hex2[0] + hex2[0] + hex2[1] + hex2[1] + hex2[2] + hex2[2] + hex2[3] + hex2[3];
        }
        var u$1 = parseInt(hex2, 16);
        var r$1 = u$1 >> 24 & 255;
        var g$1 = u$1 >> 16 & 255;
        var b$1 = u$1 >> 8 & 255;
        var a2 = Math.round((u$1 & 255) / 255 * 100) / 100;
        return [r$1, g$1, b$1, a2];
      }
      throw new Error("unknown hex color: " + hex2);
    };
    var hex2rgb_1 = hex2rgb$1;
    var chroma$f = chroma_1;
    var Color$y = Color_1;
    var type$i = utils.type;
    var input$b = input$h;
    var rgb2hex$1 = rgb2hex_1;
    Color$y.prototype.hex = function(mode) {
      return rgb2hex$1(this._rgb, mode);
    };
    chroma$f.hex = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$y, [null].concat(args, ["hex"])))();
    };
    input$b.format.hex = hex2rgb_1;
    input$b.autodetect.push({
      p: 4,
      test: function(h2) {
        var rest = [], len = arguments.length - 1;
        while (len-- > 0)
          rest[len] = arguments[len + 1];
        if (!rest.length && type$i(h2) === "string" && [3, 4, 5, 6, 7, 8, 9].indexOf(h2.length) >= 0) {
          return "hex";
        }
      }
    });
    var unpack$o = utils.unpack;
    var TWOPI$2 = utils.TWOPI;
    var min$2 = Math.min;
    var sqrt$4 = Math.sqrt;
    var acos2 = Math.acos;
    var rgb2hsi$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var ref = unpack$o(args, "rgb");
      var r2 = ref[0];
      var g = ref[1];
      var b = ref[2];
      r2 /= 255;
      g /= 255;
      b /= 255;
      var h2;
      var min_ = min$2(r2, g, b);
      var i3 = (r2 + g + b) / 3;
      var s2 = i3 > 0 ? 1 - min_ / i3 : 0;
      if (s2 === 0) {
        h2 = NaN;
      } else {
        h2 = (r2 - g + (r2 - b)) / 2;
        h2 /= sqrt$4((r2 - g) * (r2 - g) + (r2 - b) * (g - b));
        h2 = acos2(h2);
        if (b > g) {
          h2 = TWOPI$2 - h2;
        }
        h2 /= TWOPI$2;
      }
      return [h2 * 360, s2, i3];
    };
    var rgb2hsi_1 = rgb2hsi$1;
    var unpack$n = utils.unpack;
    var limit = utils.limit;
    var TWOPI$1 = utils.TWOPI;
    var PITHIRD = utils.PITHIRD;
    var cos$4 = Math.cos;
    var hsi2rgb = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      args = unpack$n(args, "hsi");
      var h2 = args[0];
      var s2 = args[1];
      var i3 = args[2];
      var r2, g, b;
      if (isNaN(h2)) {
        h2 = 0;
      }
      if (isNaN(s2)) {
        s2 = 0;
      }
      if (h2 > 360) {
        h2 -= 360;
      }
      if (h2 < 0) {
        h2 += 360;
      }
      h2 /= 360;
      if (h2 < 1 / 3) {
        b = (1 - s2) / 3;
        r2 = (1 + s2 * cos$4(TWOPI$1 * h2) / cos$4(PITHIRD - TWOPI$1 * h2)) / 3;
        g = 1 - (b + r2);
      } else if (h2 < 2 / 3) {
        h2 -= 1 / 3;
        r2 = (1 - s2) / 3;
        g = (1 + s2 * cos$4(TWOPI$1 * h2) / cos$4(PITHIRD - TWOPI$1 * h2)) / 3;
        b = 1 - (r2 + g);
      } else {
        h2 -= 2 / 3;
        g = (1 - s2) / 3;
        b = (1 + s2 * cos$4(TWOPI$1 * h2) / cos$4(PITHIRD - TWOPI$1 * h2)) / 3;
        r2 = 1 - (g + b);
      }
      r2 = limit(i3 * r2 * 3);
      g = limit(i3 * g * 3);
      b = limit(i3 * b * 3);
      return [r2 * 255, g * 255, b * 255, args.length > 3 ? args[3] : 1];
    };
    var hsi2rgb_1 = hsi2rgb;
    var unpack$m = utils.unpack;
    var type$h = utils.type;
    var chroma$e = chroma_1;
    var Color$x = Color_1;
    var input$a = input$h;
    var rgb2hsi = rgb2hsi_1;
    Color$x.prototype.hsi = function() {
      return rgb2hsi(this._rgb);
    };
    chroma$e.hsi = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$x, [null].concat(args, ["hsi"])))();
    };
    input$a.format.hsi = hsi2rgb_1;
    input$a.autodetect.push({
      p: 2,
      test: function() {
        var args = [], len = arguments.length;
        while (len--)
          args[len] = arguments[len];
        args = unpack$m(args, "hsi");
        if (type$h(args) === "array" && args.length === 3) {
          return "hsi";
        }
      }
    });
    var unpack$l = utils.unpack;
    var type$g = utils.type;
    var chroma$d = chroma_1;
    var Color$w = Color_1;
    var input$9 = input$h;
    var rgb2hsl$1 = rgb2hsl_1;
    Color$w.prototype.hsl = function() {
      return rgb2hsl$1(this._rgb);
    };
    chroma$d.hsl = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$w, [null].concat(args, ["hsl"])))();
    };
    input$9.format.hsl = hsl2rgb_1;
    input$9.autodetect.push({
      p: 2,
      test: function() {
        var args = [], len = arguments.length;
        while (len--)
          args[len] = arguments[len];
        args = unpack$l(args, "hsl");
        if (type$g(args) === "array" && args.length === 3) {
          return "hsl";
        }
      }
    });
    var unpack$k = utils.unpack;
    var min$12 = Math.min;
    var max$12 = Math.max;
    var rgb2hsl = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      args = unpack$k(args, "rgb");
      var r2 = args[0];
      var g = args[1];
      var b = args[2];
      var min_ = min$12(r2, g, b);
      var max_ = max$12(r2, g, b);
      var delta = max_ - min_;
      var h2, s2, v2;
      v2 = max_ / 255;
      if (max_ === 0) {
        h2 = Number.NaN;
        s2 = 0;
      } else {
        s2 = delta / max_;
        if (r2 === max_) {
          h2 = (g - b) / delta;
        }
        if (g === max_) {
          h2 = 2 + (b - r2) / delta;
        }
        if (b === max_) {
          h2 = 4 + (r2 - g) / delta;
        }
        h2 *= 60;
        if (h2 < 0) {
          h2 += 360;
        }
      }
      return [h2, s2, v2];
    };
    var rgb2hsv$1 = rgb2hsl;
    var unpack$j = utils.unpack;
    var floor$2 = Math.floor;
    var hsv2rgb = function() {
      var assign2, assign$12, assign$2, assign$3, assign$4, assign$5;
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      args = unpack$j(args, "hsv");
      var h2 = args[0];
      var s2 = args[1];
      var v2 = args[2];
      var r2, g, b;
      v2 *= 255;
      if (s2 === 0) {
        r2 = g = b = v2;
      } else {
        if (h2 === 360) {
          h2 = 0;
        }
        if (h2 > 360) {
          h2 -= 360;
        }
        if (h2 < 0) {
          h2 += 360;
        }
        h2 /= 60;
        var i3 = floor$2(h2);
        var f2 = h2 - i3;
        var p2 = v2 * (1 - s2);
        var q = v2 * (1 - s2 * f2);
        var t2 = v2 * (1 - s2 * (1 - f2));
        switch (i3) {
          case 0:
            assign2 = [v2, t2, p2], r2 = assign2[0], g = assign2[1], b = assign2[2];
            break;
          case 1:
            assign$12 = [q, v2, p2], r2 = assign$12[0], g = assign$12[1], b = assign$12[2];
            break;
          case 2:
            assign$2 = [p2, v2, t2], r2 = assign$2[0], g = assign$2[1], b = assign$2[2];
            break;
          case 3:
            assign$3 = [p2, q, v2], r2 = assign$3[0], g = assign$3[1], b = assign$3[2];
            break;
          case 4:
            assign$4 = [t2, p2, v2], r2 = assign$4[0], g = assign$4[1], b = assign$4[2];
            break;
          case 5:
            assign$5 = [v2, p2, q], r2 = assign$5[0], g = assign$5[1], b = assign$5[2];
            break;
        }
      }
      return [r2, g, b, args.length > 3 ? args[3] : 1];
    };
    var hsv2rgb_1 = hsv2rgb;
    var unpack$i = utils.unpack;
    var type$f = utils.type;
    var chroma$c = chroma_1;
    var Color$v = Color_1;
    var input$8 = input$h;
    var rgb2hsv = rgb2hsv$1;
    Color$v.prototype.hsv = function() {
      return rgb2hsv(this._rgb);
    };
    chroma$c.hsv = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$v, [null].concat(args, ["hsv"])))();
    };
    input$8.format.hsv = hsv2rgb_1;
    input$8.autodetect.push({
      p: 2,
      test: function() {
        var args = [], len = arguments.length;
        while (len--)
          args[len] = arguments[len];
        args = unpack$i(args, "hsv");
        if (type$f(args) === "array" && args.length === 3) {
          return "hsv";
        }
      }
    });
    var labConstants = {
      // Corresponds roughly to RGB brighter/darker
      Kn: 18,
      // D65 standard referent
      Xn: 0.95047,
      Yn: 1,
      Zn: 1.08883,
      t0: 0.137931034,
      // 4 / 29
      t1: 0.206896552,
      // 6 / 29
      t2: 0.12841855,
      // 3 * t1 * t1
      t3: 8856452e-9
      // t1 * t1 * t1
    };
    var LAB_CONSTANTS$3 = labConstants;
    var unpack$h = utils.unpack;
    var pow$a = Math.pow;
    var rgb2lab$2 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var ref = unpack$h(args, "rgb");
      var r2 = ref[0];
      var g = ref[1];
      var b = ref[2];
      var ref$1 = rgb2xyz(r2, g, b);
      var x2 = ref$1[0];
      var y2 = ref$1[1];
      var z = ref$1[2];
      var l2 = 116 * y2 - 16;
      return [l2 < 0 ? 0 : l2, 500 * (x2 - y2), 200 * (y2 - z)];
    };
    var rgb_xyz = function(r2) {
      if ((r2 /= 255) <= 0.04045) {
        return r2 / 12.92;
      }
      return pow$a((r2 + 0.055) / 1.055, 2.4);
    };
    var xyz_lab = function(t2) {
      if (t2 > LAB_CONSTANTS$3.t3) {
        return pow$a(t2, 1 / 3);
      }
      return t2 / LAB_CONSTANTS$3.t2 + LAB_CONSTANTS$3.t0;
    };
    var rgb2xyz = function(r2, g, b) {
      r2 = rgb_xyz(r2);
      g = rgb_xyz(g);
      b = rgb_xyz(b);
      var x2 = xyz_lab((0.4124564 * r2 + 0.3575761 * g + 0.1804375 * b) / LAB_CONSTANTS$3.Xn);
      var y2 = xyz_lab((0.2126729 * r2 + 0.7151522 * g + 0.072175 * b) / LAB_CONSTANTS$3.Yn);
      var z = xyz_lab((0.0193339 * r2 + 0.119192 * g + 0.9503041 * b) / LAB_CONSTANTS$3.Zn);
      return [x2, y2, z];
    };
    var rgb2lab_1 = rgb2lab$2;
    var LAB_CONSTANTS$2 = labConstants;
    var unpack$g = utils.unpack;
    var pow$9 = Math.pow;
    var lab2rgb$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      args = unpack$g(args, "lab");
      var l2 = args[0];
      var a2 = args[1];
      var b = args[2];
      var x2, y2, z, r2, g, b_;
      y2 = (l2 + 16) / 116;
      x2 = isNaN(a2) ? y2 : y2 + a2 / 500;
      z = isNaN(b) ? y2 : y2 - b / 200;
      y2 = LAB_CONSTANTS$2.Yn * lab_xyz(y2);
      x2 = LAB_CONSTANTS$2.Xn * lab_xyz(x2);
      z = LAB_CONSTANTS$2.Zn * lab_xyz(z);
      r2 = xyz_rgb(3.2404542 * x2 - 1.5371385 * y2 - 0.4985314 * z);
      g = xyz_rgb(-0.969266 * x2 + 1.8760108 * y2 + 0.041556 * z);
      b_ = xyz_rgb(0.0556434 * x2 - 0.2040259 * y2 + 1.0572252 * z);
      return [r2, g, b_, args.length > 3 ? args[3] : 1];
    };
    var xyz_rgb = function(r2) {
      return 255 * (r2 <= 304e-5 ? 12.92 * r2 : 1.055 * pow$9(r2, 1 / 2.4) - 0.055);
    };
    var lab_xyz = function(t2) {
      return t2 > LAB_CONSTANTS$2.t1 ? t2 * t2 * t2 : LAB_CONSTANTS$2.t2 * (t2 - LAB_CONSTANTS$2.t0);
    };
    var lab2rgb_1 = lab2rgb$1;
    var unpack$f = utils.unpack;
    var type$e = utils.type;
    var chroma$b = chroma_1;
    var Color$u = Color_1;
    var input$7 = input$h;
    var rgb2lab$1 = rgb2lab_1;
    Color$u.prototype.lab = function() {
      return rgb2lab$1(this._rgb);
    };
    chroma$b.lab = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$u, [null].concat(args, ["lab"])))();
    };
    input$7.format.lab = lab2rgb_1;
    input$7.autodetect.push({
      p: 2,
      test: function() {
        var args = [], len = arguments.length;
        while (len--)
          args[len] = arguments[len];
        args = unpack$f(args, "lab");
        if (type$e(args) === "array" && args.length === 3) {
          return "lab";
        }
      }
    });
    var unpack$e = utils.unpack;
    var RAD2DEG = utils.RAD2DEG;
    var sqrt$3 = Math.sqrt;
    var atan2$2 = Math.atan2;
    var round$2 = Math.round;
    var lab2lch$2 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var ref = unpack$e(args, "lab");
      var l2 = ref[0];
      var a2 = ref[1];
      var b = ref[2];
      var c2 = sqrt$3(a2 * a2 + b * b);
      var h2 = (atan2$2(b, a2) * RAD2DEG + 360) % 360;
      if (round$2(c2 * 1e4) === 0) {
        h2 = Number.NaN;
      }
      return [l2, c2, h2];
    };
    var lab2lch_1 = lab2lch$2;
    var unpack$d = utils.unpack;
    var rgb2lab = rgb2lab_1;
    var lab2lch$1 = lab2lch_1;
    var rgb2lch$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var ref = unpack$d(args, "rgb");
      var r2 = ref[0];
      var g = ref[1];
      var b = ref[2];
      var ref$1 = rgb2lab(r2, g, b);
      var l2 = ref$1[0];
      var a2 = ref$1[1];
      var b_ = ref$1[2];
      return lab2lch$1(l2, a2, b_);
    };
    var rgb2lch_1 = rgb2lch$1;
    var unpack$c = utils.unpack;
    var DEG2RAD = utils.DEG2RAD;
    var sin$3 = Math.sin;
    var cos$3 = Math.cos;
    var lch2lab$2 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var ref = unpack$c(args, "lch");
      var l2 = ref[0];
      var c2 = ref[1];
      var h2 = ref[2];
      if (isNaN(h2)) {
        h2 = 0;
      }
      h2 = h2 * DEG2RAD;
      return [l2, cos$3(h2) * c2, sin$3(h2) * c2];
    };
    var lch2lab_1 = lch2lab$2;
    var unpack$b = utils.unpack;
    var lch2lab$1 = lch2lab_1;
    var lab2rgb = lab2rgb_1;
    var lch2rgb$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      args = unpack$b(args, "lch");
      var l2 = args[0];
      var c2 = args[1];
      var h2 = args[2];
      var ref = lch2lab$1(l2, c2, h2);
      var L = ref[0];
      var a2 = ref[1];
      var b_ = ref[2];
      var ref$1 = lab2rgb(L, a2, b_);
      var r2 = ref$1[0];
      var g = ref$1[1];
      var b = ref$1[2];
      return [r2, g, b, args.length > 3 ? args[3] : 1];
    };
    var lch2rgb_1 = lch2rgb$1;
    var unpack$a = utils.unpack;
    var lch2rgb = lch2rgb_1;
    var hcl2rgb = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var hcl = unpack$a(args, "hcl").reverse();
      return lch2rgb.apply(void 0, hcl);
    };
    var hcl2rgb_1 = hcl2rgb;
    var unpack$9 = utils.unpack;
    var type$d = utils.type;
    var chroma$a = chroma_1;
    var Color$t = Color_1;
    var input$6 = input$h;
    var rgb2lch = rgb2lch_1;
    Color$t.prototype.lch = function() {
      return rgb2lch(this._rgb);
    };
    Color$t.prototype.hcl = function() {
      return rgb2lch(this._rgb).reverse();
    };
    chroma$a.lch = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$t, [null].concat(args, ["lch"])))();
    };
    chroma$a.hcl = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$t, [null].concat(args, ["hcl"])))();
    };
    input$6.format.lch = lch2rgb_1;
    input$6.format.hcl = hcl2rgb_1;
    ["lch", "hcl"].forEach(function(m2) {
      return input$6.autodetect.push({
        p: 2,
        test: function() {
          var args = [], len = arguments.length;
          while (len--)
            args[len] = arguments[len];
          args = unpack$9(args, m2);
          if (type$d(args) === "array" && args.length === 3) {
            return m2;
          }
        }
      });
    });
    var w3cx11$1 = {
      aliceblue: "#f0f8ff",
      antiquewhite: "#faebd7",
      aqua: "#00ffff",
      aquamarine: "#7fffd4",
      azure: "#f0ffff",
      beige: "#f5f5dc",
      bisque: "#ffe4c4",
      black: "#000000",
      blanchedalmond: "#ffebcd",
      blue: "#0000ff",
      blueviolet: "#8a2be2",
      brown: "#a52a2a",
      burlywood: "#deb887",
      cadetblue: "#5f9ea0",
      chartreuse: "#7fff00",
      chocolate: "#d2691e",
      coral: "#ff7f50",
      cornflower: "#6495ed",
      cornflowerblue: "#6495ed",
      cornsilk: "#fff8dc",
      crimson: "#dc143c",
      cyan: "#00ffff",
      darkblue: "#00008b",
      darkcyan: "#008b8b",
      darkgoldenrod: "#b8860b",
      darkgray: "#a9a9a9",
      darkgreen: "#006400",
      darkgrey: "#a9a9a9",
      darkkhaki: "#bdb76b",
      darkmagenta: "#8b008b",
      darkolivegreen: "#556b2f",
      darkorange: "#ff8c00",
      darkorchid: "#9932cc",
      darkred: "#8b0000",
      darksalmon: "#e9967a",
      darkseagreen: "#8fbc8f",
      darkslateblue: "#483d8b",
      darkslategray: "#2f4f4f",
      darkslategrey: "#2f4f4f",
      darkturquoise: "#00ced1",
      darkviolet: "#9400d3",
      deeppink: "#ff1493",
      deepskyblue: "#00bfff",
      dimgray: "#696969",
      dimgrey: "#696969",
      dodgerblue: "#1e90ff",
      firebrick: "#b22222",
      floralwhite: "#fffaf0",
      forestgreen: "#228b22",
      fuchsia: "#ff00ff",
      gainsboro: "#dcdcdc",
      ghostwhite: "#f8f8ff",
      gold: "#ffd700",
      goldenrod: "#daa520",
      gray: "#808080",
      green: "#008000",
      greenyellow: "#adff2f",
      grey: "#808080",
      honeydew: "#f0fff0",
      hotpink: "#ff69b4",
      indianred: "#cd5c5c",
      indigo: "#4b0082",
      ivory: "#fffff0",
      khaki: "#f0e68c",
      laserlemon: "#ffff54",
      lavender: "#e6e6fa",
      lavenderblush: "#fff0f5",
      lawngreen: "#7cfc00",
      lemonchiffon: "#fffacd",
      lightblue: "#add8e6",
      lightcoral: "#f08080",
      lightcyan: "#e0ffff",
      lightgoldenrod: "#fafad2",
      lightgoldenrodyellow: "#fafad2",
      lightgray: "#d3d3d3",
      lightgreen: "#90ee90",
      lightgrey: "#d3d3d3",
      lightpink: "#ffb6c1",
      lightsalmon: "#ffa07a",
      lightseagreen: "#20b2aa",
      lightskyblue: "#87cefa",
      lightslategray: "#778899",
      lightslategrey: "#778899",
      lightsteelblue: "#b0c4de",
      lightyellow: "#ffffe0",
      lime: "#00ff00",
      limegreen: "#32cd32",
      linen: "#faf0e6",
      magenta: "#ff00ff",
      maroon: "#800000",
      maroon2: "#7f0000",
      maroon3: "#b03060",
      mediumaquamarine: "#66cdaa",
      mediumblue: "#0000cd",
      mediumorchid: "#ba55d3",
      mediumpurple: "#9370db",
      mediumseagreen: "#3cb371",
      mediumslateblue: "#7b68ee",
      mediumspringgreen: "#00fa9a",
      mediumturquoise: "#48d1cc",
      mediumvioletred: "#c71585",
      midnightblue: "#191970",
      mintcream: "#f5fffa",
      mistyrose: "#ffe4e1",
      moccasin: "#ffe4b5",
      navajowhite: "#ffdead",
      navy: "#000080",
      oldlace: "#fdf5e6",
      olive: "#808000",
      olivedrab: "#6b8e23",
      orange: "#ffa500",
      orangered: "#ff4500",
      orchid: "#da70d6",
      palegoldenrod: "#eee8aa",
      palegreen: "#98fb98",
      paleturquoise: "#afeeee",
      palevioletred: "#db7093",
      papayawhip: "#ffefd5",
      peachpuff: "#ffdab9",
      peru: "#cd853f",
      pink: "#ffc0cb",
      plum: "#dda0dd",
      powderblue: "#b0e0e6",
      purple: "#800080",
      purple2: "#7f007f",
      purple3: "#a020f0",
      rebeccapurple: "#663399",
      red: "#ff0000",
      rosybrown: "#bc8f8f",
      royalblue: "#4169e1",
      saddlebrown: "#8b4513",
      salmon: "#fa8072",
      sandybrown: "#f4a460",
      seagreen: "#2e8b57",
      seashell: "#fff5ee",
      sienna: "#a0522d",
      silver: "#c0c0c0",
      skyblue: "#87ceeb",
      slateblue: "#6a5acd",
      slategray: "#708090",
      slategrey: "#708090",
      snow: "#fffafa",
      springgreen: "#00ff7f",
      steelblue: "#4682b4",
      tan: "#d2b48c",
      teal: "#008080",
      thistle: "#d8bfd8",
      tomato: "#ff6347",
      turquoise: "#40e0d0",
      violet: "#ee82ee",
      wheat: "#f5deb3",
      white: "#ffffff",
      whitesmoke: "#f5f5f5",
      yellow: "#ffff00",
      yellowgreen: "#9acd32"
    };
    var w3cx11_1 = w3cx11$1;
    var Color$s = Color_1;
    var input$5 = input$h;
    var type$c = utils.type;
    var w3cx11 = w3cx11_1;
    var hex2rgb = hex2rgb_1;
    var rgb2hex = rgb2hex_1;
    Color$s.prototype.name = function() {
      var hex2 = rgb2hex(this._rgb, "rgb");
      for (var i3 = 0, list2 = Object.keys(w3cx11); i3 < list2.length; i3 += 1) {
        var n2 = list2[i3];
        if (w3cx11[n2] === hex2) {
          return n2.toLowerCase();
        }
      }
      return hex2;
    };
    input$5.format.named = function(name2) {
      name2 = name2.toLowerCase();
      if (w3cx11[name2]) {
        return hex2rgb(w3cx11[name2]);
      }
      throw new Error("unknown color name: " + name2);
    };
    input$5.autodetect.push({
      p: 5,
      test: function(h2) {
        var rest = [], len = arguments.length - 1;
        while (len-- > 0)
          rest[len] = arguments[len + 1];
        if (!rest.length && type$c(h2) === "string" && w3cx11[h2.toLowerCase()]) {
          return "named";
        }
      }
    });
    var unpack$8 = utils.unpack;
    var rgb2num$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var ref = unpack$8(args, "rgb");
      var r2 = ref[0];
      var g = ref[1];
      var b = ref[2];
      return (r2 << 16) + (g << 8) + b;
    };
    var rgb2num_1 = rgb2num$1;
    var type$b = utils.type;
    var num2rgb = function(num2) {
      if (type$b(num2) == "number" && num2 >= 0 && num2 <= 16777215) {
        var r2 = num2 >> 16;
        var g = num2 >> 8 & 255;
        var b = num2 & 255;
        return [r2, g, b, 1];
      }
      throw new Error("unknown num color: " + num2);
    };
    var num2rgb_1 = num2rgb;
    var chroma$9 = chroma_1;
    var Color$r = Color_1;
    var input$4 = input$h;
    var type$a = utils.type;
    var rgb2num = rgb2num_1;
    Color$r.prototype.num = function() {
      return rgb2num(this._rgb);
    };
    chroma$9.num = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$r, [null].concat(args, ["num"])))();
    };
    input$4.format.num = num2rgb_1;
    input$4.autodetect.push({
      p: 5,
      test: function() {
        var args = [], len = arguments.length;
        while (len--)
          args[len] = arguments[len];
        if (args.length === 1 && type$a(args[0]) === "number" && args[0] >= 0 && args[0] <= 16777215) {
          return "num";
        }
      }
    });
    var chroma$8 = chroma_1;
    var Color$q = Color_1;
    var input$3 = input$h;
    var unpack$7 = utils.unpack;
    var type$9 = utils.type;
    var round$12 = Math.round;
    Color$q.prototype.rgb = function(rnd2) {
      if (rnd2 === void 0)
        rnd2 = true;
      if (rnd2 === false) {
        return this._rgb.slice(0, 3);
      }
      return this._rgb.slice(0, 3).map(round$12);
    };
    Color$q.prototype.rgba = function(rnd2) {
      if (rnd2 === void 0)
        rnd2 = true;
      return this._rgb.slice(0, 4).map(function(v2, i3) {
        return i3 < 3 ? rnd2 === false ? v2 : round$12(v2) : v2;
      });
    };
    chroma$8.rgb = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$q, [null].concat(args, ["rgb"])))();
    };
    input$3.format.rgb = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var rgba2 = unpack$7(args, "rgba");
      if (rgba2[3] === void 0) {
        rgba2[3] = 1;
      }
      return rgba2;
    };
    input$3.autodetect.push({
      p: 3,
      test: function() {
        var args = [], len = arguments.length;
        while (len--)
          args[len] = arguments[len];
        args = unpack$7(args, "rgba");
        if (type$9(args) === "array" && (args.length === 3 || args.length === 4 && type$9(args[3]) == "number" && args[3] >= 0 && args[3] <= 1)) {
          return "rgb";
        }
      }
    });
    var log$1 = Math.log;
    var temperature2rgb$1 = function(kelvin) {
      var temp = kelvin / 100;
      var r2, g, b;
      if (temp < 66) {
        r2 = 255;
        g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log$1(g);
        b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log$1(b);
      } else {
        r2 = 351.97690566805693 + 0.114206453784165 * (r2 = temp - 55) - 40.25366309332127 * log$1(r2);
        g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log$1(g);
        b = 255;
      }
      return [r2, g, b, 1];
    };
    var temperature2rgb_1 = temperature2rgb$1;
    var temperature2rgb = temperature2rgb_1;
    var unpack$6 = utils.unpack;
    var round2 = Math.round;
    var rgb2temperature$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var rgb3 = unpack$6(args, "rgb");
      var r2 = rgb3[0], b = rgb3[2];
      var minTemp = 1e3;
      var maxTemp = 4e4;
      var eps = 0.4;
      var temp;
      while (maxTemp - minTemp > eps) {
        temp = (maxTemp + minTemp) * 0.5;
        var rgb$1 = temperature2rgb(temp);
        if (rgb$1[2] / rgb$1[0] >= b / r2) {
          maxTemp = temp;
        } else {
          minTemp = temp;
        }
      }
      return round2(temp);
    };
    var rgb2temperature_1 = rgb2temperature$1;
    var chroma$7 = chroma_1;
    var Color$p = Color_1;
    var input$2 = input$h;
    var rgb2temperature = rgb2temperature_1;
    Color$p.prototype.temp = Color$p.prototype.kelvin = Color$p.prototype.temperature = function() {
      return rgb2temperature(this._rgb);
    };
    chroma$7.temp = chroma$7.kelvin = chroma$7.temperature = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$p, [null].concat(args, ["temp"])))();
    };
    input$2.format.temp = input$2.format.kelvin = input$2.format.temperature = temperature2rgb_1;
    var unpack$5 = utils.unpack;
    var cbrt = Math.cbrt;
    var pow$8 = Math.pow;
    var sign$1 = Math.sign;
    var rgb2oklab$2 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var ref = unpack$5(args, "rgb");
      var r2 = ref[0];
      var g = ref[1];
      var b = ref[2];
      var ref$1 = [rgb2lrgb(r2 / 255), rgb2lrgb(g / 255), rgb2lrgb(b / 255)];
      var lr = ref$1[0];
      var lg = ref$1[1];
      var lb = ref$1[2];
      var l2 = cbrt(0.4122214708 * lr + 0.5363325363 * lg + 0.0514459929 * lb);
      var m2 = cbrt(0.2119034982 * lr + 0.6806995451 * lg + 0.1073969566 * lb);
      var s2 = cbrt(0.0883024619 * lr + 0.2817188376 * lg + 0.6299787005 * lb);
      return [
        0.2104542553 * l2 + 0.793617785 * m2 - 0.0040720468 * s2,
        1.9779984951 * l2 - 2.428592205 * m2 + 0.4505937099 * s2,
        0.0259040371 * l2 + 0.7827717662 * m2 - 0.808675766 * s2
      ];
    };
    var rgb2oklab_1 = rgb2oklab$2;
    function rgb2lrgb(c2) {
      var abs3 = Math.abs(c2);
      if (abs3 < 0.04045) {
        return c2 / 12.92;
      }
      return (sign$1(c2) || 1) * pow$8((abs3 + 0.055) / 1.055, 2.4);
    }
    var unpack$4 = utils.unpack;
    var pow$7 = Math.pow;
    var sign2 = Math.sign;
    var oklab2rgb$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      args = unpack$4(args, "lab");
      var L = args[0];
      var a2 = args[1];
      var b = args[2];
      var l2 = pow$7(L + 0.3963377774 * a2 + 0.2158037573 * b, 3);
      var m2 = pow$7(L - 0.1055613458 * a2 - 0.0638541728 * b, 3);
      var s2 = pow$7(L - 0.0894841775 * a2 - 1.291485548 * b, 3);
      return [
        255 * lrgb2rgb(4.0767416621 * l2 - 3.3077115913 * m2 + 0.2309699292 * s2),
        255 * lrgb2rgb(-1.2684380046 * l2 + 2.6097574011 * m2 - 0.3413193965 * s2),
        255 * lrgb2rgb(-0.0041960863 * l2 - 0.7034186147 * m2 + 1.707614701 * s2),
        args.length > 3 ? args[3] : 1
      ];
    };
    var oklab2rgb_1 = oklab2rgb$1;
    function lrgb2rgb(c2) {
      var abs3 = Math.abs(c2);
      if (abs3 > 31308e-7) {
        return (sign2(c2) || 1) * (1.055 * pow$7(abs3, 1 / 2.4) - 0.055);
      }
      return c2 * 12.92;
    }
    var unpack$3 = utils.unpack;
    var type$8 = utils.type;
    var chroma$6 = chroma_1;
    var Color$o = Color_1;
    var input$1 = input$h;
    var rgb2oklab$1 = rgb2oklab_1;
    Color$o.prototype.oklab = function() {
      return rgb2oklab$1(this._rgb);
    };
    chroma$6.oklab = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$o, [null].concat(args, ["oklab"])))();
    };
    input$1.format.oklab = oklab2rgb_1;
    input$1.autodetect.push({
      p: 3,
      test: function() {
        var args = [], len = arguments.length;
        while (len--)
          args[len] = arguments[len];
        args = unpack$3(args, "oklab");
        if (type$8(args) === "array" && args.length === 3) {
          return "oklab";
        }
      }
    });
    var unpack$2 = utils.unpack;
    var rgb2oklab = rgb2oklab_1;
    var lab2lch = lab2lch_1;
    var rgb2oklch$1 = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      var ref = unpack$2(args, "rgb");
      var r2 = ref[0];
      var g = ref[1];
      var b = ref[2];
      var ref$1 = rgb2oklab(r2, g, b);
      var l2 = ref$1[0];
      var a2 = ref$1[1];
      var b_ = ref$1[2];
      return lab2lch(l2, a2, b_);
    };
    var rgb2oklch_1 = rgb2oklch$1;
    var unpack$1 = utils.unpack;
    var lch2lab = lch2lab_1;
    var oklab2rgb = oklab2rgb_1;
    var oklch2rgb = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      args = unpack$1(args, "lch");
      var l2 = args[0];
      var c2 = args[1];
      var h2 = args[2];
      var ref = lch2lab(l2, c2, h2);
      var L = ref[0];
      var a2 = ref[1];
      var b_ = ref[2];
      var ref$1 = oklab2rgb(L, a2, b_);
      var r2 = ref$1[0];
      var g = ref$1[1];
      var b = ref$1[2];
      return [r2, g, b, args.length > 3 ? args[3] : 1];
    };
    var oklch2rgb_1 = oklch2rgb;
    var unpack = utils.unpack;
    var type$7 = utils.type;
    var chroma$5 = chroma_1;
    var Color$n = Color_1;
    var input = input$h;
    var rgb2oklch = rgb2oklch_1;
    Color$n.prototype.oklch = function() {
      return rgb2oklch(this._rgb);
    };
    chroma$5.oklch = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      return new (Function.prototype.bind.apply(Color$n, [null].concat(args, ["oklch"])))();
    };
    input.format.oklch = oklch2rgb_1;
    input.autodetect.push({
      p: 3,
      test: function() {
        var args = [], len = arguments.length;
        while (len--)
          args[len] = arguments[len];
        args = unpack(args, "oklch");
        if (type$7(args) === "array" && args.length === 3) {
          return "oklch";
        }
      }
    });
    var Color$m = Color_1;
    var type$6 = utils.type;
    Color$m.prototype.alpha = function(a2, mutate) {
      if (mutate === void 0)
        mutate = false;
      if (a2 !== void 0 && type$6(a2) === "number") {
        if (mutate) {
          this._rgb[3] = a2;
          return this;
        }
        return new Color$m([this._rgb[0], this._rgb[1], this._rgb[2], a2], "rgb");
      }
      return this._rgb[3];
    };
    var Color$l = Color_1;
    Color$l.prototype.clipped = function() {
      return this._rgb._clipped || false;
    };
    var Color$k = Color_1;
    var LAB_CONSTANTS$1 = labConstants;
    Color$k.prototype.darken = function(amount) {
      if (amount === void 0)
        amount = 1;
      var me = this;
      var lab2 = me.lab();
      lab2[0] -= LAB_CONSTANTS$1.Kn * amount;
      return new Color$k(lab2, "lab").alpha(me.alpha(), true);
    };
    Color$k.prototype.brighten = function(amount) {
      if (amount === void 0)
        amount = 1;
      return this.darken(-amount);
    };
    Color$k.prototype.darker = Color$k.prototype.darken;
    Color$k.prototype.brighter = Color$k.prototype.brighten;
    var Color$j = Color_1;
    Color$j.prototype.get = function(mc) {
      var ref = mc.split(".");
      var mode = ref[0];
      var channel = ref[1];
      var src = this[mode]();
      if (channel) {
        var i3 = mode.indexOf(channel) - (mode.substr(0, 2) === "ok" ? 2 : 0);
        if (i3 > -1) {
          return src[i3];
        }
        throw new Error("unknown channel " + channel + " in mode " + mode);
      } else {
        return src;
      }
    };
    var Color$i = Color_1;
    var type$5 = utils.type;
    var pow$6 = Math.pow;
    var EPS = 1e-7;
    var MAX_ITER = 20;
    Color$i.prototype.luminance = function(lum) {
      if (lum !== void 0 && type$5(lum) === "number") {
        if (lum === 0) {
          return new Color$i([0, 0, 0, this._rgb[3]], "rgb");
        }
        if (lum === 1) {
          return new Color$i([255, 255, 255, this._rgb[3]], "rgb");
        }
        var cur_lum = this.luminance();
        var mode = "rgb";
        var max_iter = MAX_ITER;
        var test = function(low, high) {
          var mid = low.interpolate(high, 0.5, mode);
          var lm = mid.luminance();
          if (Math.abs(lum - lm) < EPS || !max_iter--) {
            return mid;
          }
          return lm > lum ? test(low, mid) : test(mid, high);
        };
        var rgb3 = (cur_lum > lum ? test(new Color$i([0, 0, 0]), this) : test(this, new Color$i([255, 255, 255]))).rgb();
        return new Color$i(rgb3.concat([this._rgb[3]]));
      }
      return rgb2luminance.apply(void 0, this._rgb.slice(0, 3));
    };
    var rgb2luminance = function(r2, g, b) {
      r2 = luminance_x(r2);
      g = luminance_x(g);
      b = luminance_x(b);
      return 0.2126 * r2 + 0.7152 * g + 0.0722 * b;
    };
    var luminance_x = function(x2) {
      x2 /= 255;
      return x2 <= 0.03928 ? x2 / 12.92 : pow$6((x2 + 0.055) / 1.055, 2.4);
    };
    var interpolator$1 = {};
    var Color$h = Color_1;
    var type$4 = utils.type;
    var interpolator = interpolator$1;
    var mix$1 = function(col1, col2, f2) {
      if (f2 === void 0)
        f2 = 0.5;
      var rest = [], len = arguments.length - 3;
      while (len-- > 0)
        rest[len] = arguments[len + 3];
      var mode = rest[0] || "lrgb";
      if (!interpolator[mode] && !rest.length) {
        mode = Object.keys(interpolator)[0];
      }
      if (!interpolator[mode]) {
        throw new Error("interpolation mode " + mode + " is not defined");
      }
      if (type$4(col1) !== "object") {
        col1 = new Color$h(col1);
      }
      if (type$4(col2) !== "object") {
        col2 = new Color$h(col2);
      }
      return interpolator[mode](col1, col2, f2).alpha(col1.alpha() + f2 * (col2.alpha() - col1.alpha()));
    };
    var Color$g = Color_1;
    var mix = mix$1;
    Color$g.prototype.mix = Color$g.prototype.interpolate = function(col2, f2) {
      if (f2 === void 0)
        f2 = 0.5;
      var rest = [], len = arguments.length - 2;
      while (len-- > 0)
        rest[len] = arguments[len + 2];
      return mix.apply(void 0, [this, col2, f2].concat(rest));
    };
    var Color$f = Color_1;
    Color$f.prototype.premultiply = function(mutate) {
      if (mutate === void 0)
        mutate = false;
      var rgb3 = this._rgb;
      var a2 = rgb3[3];
      if (mutate) {
        this._rgb = [rgb3[0] * a2, rgb3[1] * a2, rgb3[2] * a2, a2];
        return this;
      } else {
        return new Color$f([rgb3[0] * a2, rgb3[1] * a2, rgb3[2] * a2, a2], "rgb");
      }
    };
    var Color$e = Color_1;
    var LAB_CONSTANTS = labConstants;
    Color$e.prototype.saturate = function(amount) {
      if (amount === void 0)
        amount = 1;
      var me = this;
      var lch2 = me.lch();
      lch2[1] += LAB_CONSTANTS.Kn * amount;
      if (lch2[1] < 0) {
        lch2[1] = 0;
      }
      return new Color$e(lch2, "lch").alpha(me.alpha(), true);
    };
    Color$e.prototype.desaturate = function(amount) {
      if (amount === void 0)
        amount = 1;
      return this.saturate(-amount);
    };
    var Color$d = Color_1;
    var type$3 = utils.type;
    Color$d.prototype.set = function(mc, value, mutate) {
      if (mutate === void 0)
        mutate = false;
      var ref = mc.split(".");
      var mode = ref[0];
      var channel = ref[1];
      var src = this[mode]();
      if (channel) {
        var i3 = mode.indexOf(channel) - (mode.substr(0, 2) === "ok" ? 2 : 0);
        if (i3 > -1) {
          if (type$3(value) == "string") {
            switch (value.charAt(0)) {
              case "+":
                src[i3] += +value;
                break;
              case "-":
                src[i3] += +value;
                break;
              case "*":
                src[i3] *= +value.substr(1);
                break;
              case "/":
                src[i3] /= +value.substr(1);
                break;
              default:
                src[i3] = +value;
            }
          } else if (type$3(value) === "number") {
            src[i3] = value;
          } else {
            throw new Error("unsupported value for Color.set");
          }
          var out = new Color$d(src, mode);
          if (mutate) {
            this._rgb = out._rgb;
            return this;
          }
          return out;
        }
        throw new Error("unknown channel " + channel + " in mode " + mode);
      } else {
        return src;
      }
    };
    var Color$c = Color_1;
    var rgb2 = function(col1, col2, f2) {
      var xyz0 = col1._rgb;
      var xyz1 = col2._rgb;
      return new Color$c(
        xyz0[0] + f2 * (xyz1[0] - xyz0[0]),
        xyz0[1] + f2 * (xyz1[1] - xyz0[1]),
        xyz0[2] + f2 * (xyz1[2] - xyz0[2]),
        "rgb"
      );
    };
    interpolator$1.rgb = rgb2;
    var Color$b = Color_1;
    var sqrt$2 = Math.sqrt;
    var pow$5 = Math.pow;
    var lrgb = function(col1, col2, f2) {
      var ref = col1._rgb;
      var x1 = ref[0];
      var y1 = ref[1];
      var z1 = ref[2];
      var ref$1 = col2._rgb;
      var x2 = ref$1[0];
      var y2 = ref$1[1];
      var z2 = ref$1[2];
      return new Color$b(
        sqrt$2(pow$5(x1, 2) * (1 - f2) + pow$5(x2, 2) * f2),
        sqrt$2(pow$5(y1, 2) * (1 - f2) + pow$5(y2, 2) * f2),
        sqrt$2(pow$5(z1, 2) * (1 - f2) + pow$5(z2, 2) * f2),
        "rgb"
      );
    };
    interpolator$1.lrgb = lrgb;
    var Color$a = Color_1;
    var lab = function(col1, col2, f2) {
      var xyz0 = col1.lab();
      var xyz1 = col2.lab();
      return new Color$a(
        xyz0[0] + f2 * (xyz1[0] - xyz0[0]),
        xyz0[1] + f2 * (xyz1[1] - xyz0[1]),
        xyz0[2] + f2 * (xyz1[2] - xyz0[2]),
        "lab"
      );
    };
    interpolator$1.lab = lab;
    var Color$9 = Color_1;
    var _hsx = function(col1, col2, f2, m2) {
      var assign2, assign$12;
      var xyz0, xyz1;
      if (m2 === "hsl") {
        xyz0 = col1.hsl();
        xyz1 = col2.hsl();
      } else if (m2 === "hsv") {
        xyz0 = col1.hsv();
        xyz1 = col2.hsv();
      } else if (m2 === "hcg") {
        xyz0 = col1.hcg();
        xyz1 = col2.hcg();
      } else if (m2 === "hsi") {
        xyz0 = col1.hsi();
        xyz1 = col2.hsi();
      } else if (m2 === "lch" || m2 === "hcl") {
        m2 = "hcl";
        xyz0 = col1.hcl();
        xyz1 = col2.hcl();
      } else if (m2 === "oklch") {
        xyz0 = col1.oklch().reverse();
        xyz1 = col2.oklch().reverse();
      }
      var hue0, hue1, sat0, sat1, lbv0, lbv1;
      if (m2.substr(0, 1) === "h" || m2 === "oklch") {
        assign2 = xyz0, hue0 = assign2[0], sat0 = assign2[1], lbv0 = assign2[2];
        assign$12 = xyz1, hue1 = assign$12[0], sat1 = assign$12[1], lbv1 = assign$12[2];
      }
      var sat, hue, lbv, dh;
      if (!isNaN(hue0) && !isNaN(hue1)) {
        if (hue1 > hue0 && hue1 - hue0 > 180) {
          dh = hue1 - (hue0 + 360);
        } else if (hue1 < hue0 && hue0 - hue1 > 180) {
          dh = hue1 + 360 - hue0;
        } else {
          dh = hue1 - hue0;
        }
        hue = hue0 + f2 * dh;
      } else if (!isNaN(hue0)) {
        hue = hue0;
        if ((lbv1 == 1 || lbv1 == 0) && m2 != "hsv") {
          sat = sat0;
        }
      } else if (!isNaN(hue1)) {
        hue = hue1;
        if ((lbv0 == 1 || lbv0 == 0) && m2 != "hsv") {
          sat = sat1;
        }
      } else {
        hue = Number.NaN;
      }
      if (sat === void 0) {
        sat = sat0 + f2 * (sat1 - sat0);
      }
      lbv = lbv0 + f2 * (lbv1 - lbv0);
      return m2 === "oklch" ? new Color$9([lbv, sat, hue], m2) : new Color$9([hue, sat, lbv], m2);
    };
    var interpolate_hsx$5 = _hsx;
    var lch = function(col1, col2, f2) {
      return interpolate_hsx$5(col1, col2, f2, "lch");
    };
    interpolator$1.lch = lch;
    interpolator$1.hcl = lch;
    var Color$8 = Color_1;
    var num = function(col1, col2, f2) {
      var c1 = col1.num();
      var c2 = col2.num();
      return new Color$8(c1 + f2 * (c2 - c1), "num");
    };
    interpolator$1.num = num;
    var interpolate_hsx$4 = _hsx;
    var hcg = function(col1, col2, f2) {
      return interpolate_hsx$4(col1, col2, f2, "hcg");
    };
    interpolator$1.hcg = hcg;
    var interpolate_hsx$3 = _hsx;
    var hsi = function(col1, col2, f2) {
      return interpolate_hsx$3(col1, col2, f2, "hsi");
    };
    interpolator$1.hsi = hsi;
    var interpolate_hsx$2 = _hsx;
    var hsl2 = function(col1, col2, f2) {
      return interpolate_hsx$2(col1, col2, f2, "hsl");
    };
    interpolator$1.hsl = hsl2;
    var interpolate_hsx$1 = _hsx;
    var hsv = function(col1, col2, f2) {
      return interpolate_hsx$1(col1, col2, f2, "hsv");
    };
    interpolator$1.hsv = hsv;
    var Color$7 = Color_1;
    var oklab = function(col1, col2, f2) {
      var xyz0 = col1.oklab();
      var xyz1 = col2.oklab();
      return new Color$7(
        xyz0[0] + f2 * (xyz1[0] - xyz0[0]),
        xyz0[1] + f2 * (xyz1[1] - xyz0[1]),
        xyz0[2] + f2 * (xyz1[2] - xyz0[2]),
        "oklab"
      );
    };
    interpolator$1.oklab = oklab;
    var interpolate_hsx = _hsx;
    var oklch = function(col1, col2, f2) {
      return interpolate_hsx(col1, col2, f2, "oklch");
    };
    interpolator$1.oklch = oklch;
    var Color$6 = Color_1;
    var clip_rgb$1 = utils.clip_rgb;
    var pow$4 = Math.pow;
    var sqrt$12 = Math.sqrt;
    var PI$1 = Math.PI;
    var cos$2 = Math.cos;
    var sin$2 = Math.sin;
    var atan2$1 = Math.atan2;
    var average = function(colors2, mode, weights) {
      if (mode === void 0)
        mode = "lrgb";
      if (weights === void 0)
        weights = null;
      var l2 = colors2.length;
      if (!weights) {
        weights = Array.from(new Array(l2)).map(function() {
          return 1;
        });
      }
      var k = l2 / weights.reduce(function(a2, b) {
        return a2 + b;
      });
      weights.forEach(function(w, i4) {
        weights[i4] *= k;
      });
      colors2 = colors2.map(function(c2) {
        return new Color$6(c2);
      });
      if (mode === "lrgb") {
        return _average_lrgb(colors2, weights);
      }
      var first = colors2.shift();
      var xyz = first.get(mode);
      var cnt = [];
      var dx = 0;
      var dy = 0;
      for (var i3 = 0; i3 < xyz.length; i3++) {
        xyz[i3] = (xyz[i3] || 0) * weights[0];
        cnt.push(isNaN(xyz[i3]) ? 0 : weights[0]);
        if (mode.charAt(i3) === "h" && !isNaN(xyz[i3])) {
          var A = xyz[i3] / 180 * PI$1;
          dx += cos$2(A) * weights[0];
          dy += sin$2(A) * weights[0];
        }
      }
      var alpha = first.alpha() * weights[0];
      colors2.forEach(function(c2, ci) {
        var xyz2 = c2.get(mode);
        alpha += c2.alpha() * weights[ci + 1];
        for (var i4 = 0; i4 < xyz.length; i4++) {
          if (!isNaN(xyz2[i4])) {
            cnt[i4] += weights[ci + 1];
            if (mode.charAt(i4) === "h") {
              var A2 = xyz2[i4] / 180 * PI$1;
              dx += cos$2(A2) * weights[ci + 1];
              dy += sin$2(A2) * weights[ci + 1];
            } else {
              xyz[i4] += xyz2[i4] * weights[ci + 1];
            }
          }
        }
      });
      for (var i$12 = 0; i$12 < xyz.length; i$12++) {
        if (mode.charAt(i$12) === "h") {
          var A$1 = atan2$1(dy / cnt[i$12], dx / cnt[i$12]) / PI$1 * 180;
          while (A$1 < 0) {
            A$1 += 360;
          }
          while (A$1 >= 360) {
            A$1 -= 360;
          }
          xyz[i$12] = A$1;
        } else {
          xyz[i$12] = xyz[i$12] / cnt[i$12];
        }
      }
      alpha /= l2;
      return new Color$6(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
    };
    var _average_lrgb = function(colors2, weights) {
      var l2 = colors2.length;
      var xyz = [0, 0, 0, 0];
      for (var i3 = 0; i3 < colors2.length; i3++) {
        var col = colors2[i3];
        var f2 = weights[i3] / l2;
        var rgb3 = col._rgb;
        xyz[0] += pow$4(rgb3[0], 2) * f2;
        xyz[1] += pow$4(rgb3[1], 2) * f2;
        xyz[2] += pow$4(rgb3[2], 2) * f2;
        xyz[3] += rgb3[3] * f2;
      }
      xyz[0] = sqrt$12(xyz[0]);
      xyz[1] = sqrt$12(xyz[1]);
      xyz[2] = sqrt$12(xyz[2]);
      if (xyz[3] > 0.9999999) {
        xyz[3] = 1;
      }
      return new Color$6(clip_rgb$1(xyz));
    };
    var chroma$4 = chroma_1;
    var type$2 = utils.type;
    var pow$3 = Math.pow;
    var scale$2 = function(colors2) {
      var _mode = "rgb";
      var _nacol = chroma$4("#ccc");
      var _spread = 0;
      var _domain = [0, 1];
      var _pos = [];
      var _padding = [0, 0];
      var _classes = false;
      var _colors = [];
      var _out = false;
      var _min = 0;
      var _max = 1;
      var _correctLightness = false;
      var _colorCache = {};
      var _useCache = true;
      var _gamma = 1;
      var setColors = function(colors3) {
        colors3 = colors3 || ["#fff", "#000"];
        if (colors3 && type$2(colors3) === "string" && chroma$4.brewer && chroma$4.brewer[colors3.toLowerCase()]) {
          colors3 = chroma$4.brewer[colors3.toLowerCase()];
        }
        if (type$2(colors3) === "array") {
          if (colors3.length === 1) {
            colors3 = [colors3[0], colors3[0]];
          }
          colors3 = colors3.slice(0);
          for (var c2 = 0; c2 < colors3.length; c2++) {
            colors3[c2] = chroma$4(colors3[c2]);
          }
          _pos.length = 0;
          for (var c$12 = 0; c$12 < colors3.length; c$12++) {
            _pos.push(c$12 / (colors3.length - 1));
          }
        }
        resetCache();
        return _colors = colors3;
      };
      var getClass = function(value) {
        if (_classes != null) {
          var n2 = _classes.length - 1;
          var i3 = 0;
          while (i3 < n2 && value >= _classes[i3]) {
            i3++;
          }
          return i3 - 1;
        }
        return 0;
      };
      var tMapLightness = function(t2) {
        return t2;
      };
      var tMapDomain = function(t2) {
        return t2;
      };
      var getColor = function(val, bypassMap) {
        var col, t2;
        if (bypassMap == null) {
          bypassMap = false;
        }
        if (isNaN(val) || val === null) {
          return _nacol;
        }
        if (!bypassMap) {
          if (_classes && _classes.length > 2) {
            var c2 = getClass(val);
            t2 = c2 / (_classes.length - 2);
          } else if (_max !== _min) {
            t2 = (val - _min) / (_max - _min);
          } else {
            t2 = 1;
          }
        } else {
          t2 = val;
        }
        t2 = tMapDomain(t2);
        if (!bypassMap) {
          t2 = tMapLightness(t2);
        }
        if (_gamma !== 1) {
          t2 = pow$3(t2, _gamma);
        }
        t2 = _padding[0] + t2 * (1 - _padding[0] - _padding[1]);
        t2 = Math.min(1, Math.max(0, t2));
        var k = Math.floor(t2 * 1e4);
        if (_useCache && _colorCache[k]) {
          col = _colorCache[k];
        } else {
          if (type$2(_colors) === "array") {
            for (var i3 = 0; i3 < _pos.length; i3++) {
              var p2 = _pos[i3];
              if (t2 <= p2) {
                col = _colors[i3];
                break;
              }
              if (t2 >= p2 && i3 === _pos.length - 1) {
                col = _colors[i3];
                break;
              }
              if (t2 > p2 && t2 < _pos[i3 + 1]) {
                t2 = (t2 - p2) / (_pos[i3 + 1] - p2);
                col = chroma$4.interpolate(_colors[i3], _colors[i3 + 1], t2, _mode);
                break;
              }
            }
          } else if (type$2(_colors) === "function") {
            col = _colors(t2);
          }
          if (_useCache) {
            _colorCache[k] = col;
          }
        }
        return col;
      };
      var resetCache = function() {
        return _colorCache = {};
      };
      setColors(colors2);
      var f2 = function(v2) {
        var c2 = chroma$4(getColor(v2));
        if (_out && c2[_out]) {
          return c2[_out]();
        } else {
          return c2;
        }
      };
      f2.classes = function(classes) {
        if (classes != null) {
          if (type$2(classes) === "array") {
            _classes = classes;
            _domain = [classes[0], classes[classes.length - 1]];
          } else {
            var d = chroma$4.analyze(_domain);
            if (classes === 0) {
              _classes = [d.min, d.max];
            } else {
              _classes = chroma$4.limits(d, "e", classes);
            }
          }
          return f2;
        }
        return _classes;
      };
      f2.domain = function(domain) {
        if (!arguments.length) {
          return _domain;
        }
        _min = domain[0];
        _max = domain[domain.length - 1];
        _pos = [];
        var k = _colors.length;
        if (domain.length === k && _min !== _max) {
          for (var i3 = 0, list2 = Array.from(domain); i3 < list2.length; i3 += 1) {
            var d = list2[i3];
            _pos.push((d - _min) / (_max - _min));
          }
        } else {
          for (var c2 = 0; c2 < k; c2++) {
            _pos.push(c2 / (k - 1));
          }
          if (domain.length > 2) {
            var tOut = domain.map(function(d2, i4) {
              return i4 / (domain.length - 1);
            });
            var tBreaks = domain.map(function(d2) {
              return (d2 - _min) / (_max - _min);
            });
            if (!tBreaks.every(function(val, i4) {
              return tOut[i4] === val;
            })) {
              tMapDomain = function(t2) {
                if (t2 <= 0 || t2 >= 1) {
                  return t2;
                }
                var i4 = 0;
                while (t2 >= tBreaks[i4 + 1]) {
                  i4++;
                }
                var f3 = (t2 - tBreaks[i4]) / (tBreaks[i4 + 1] - tBreaks[i4]);
                var out = tOut[i4] + f3 * (tOut[i4 + 1] - tOut[i4]);
                return out;
              };
            }
          }
        }
        _domain = [_min, _max];
        return f2;
      };
      f2.mode = function(_m) {
        if (!arguments.length) {
          return _mode;
        }
        _mode = _m;
        resetCache();
        return f2;
      };
      f2.range = function(colors3, _pos2) {
        setColors(colors3);
        return f2;
      };
      f2.out = function(_o) {
        _out = _o;
        return f2;
      };
      f2.spread = function(val) {
        if (!arguments.length) {
          return _spread;
        }
        _spread = val;
        return f2;
      };
      f2.correctLightness = function(v2) {
        if (v2 == null) {
          v2 = true;
        }
        _correctLightness = v2;
        resetCache();
        if (_correctLightness) {
          tMapLightness = function(t2) {
            var L0 = getColor(0, true).lab()[0];
            var L1 = getColor(1, true).lab()[0];
            var pol = L0 > L1;
            var L_actual = getColor(t2, true).lab()[0];
            var L_ideal = L0 + (L1 - L0) * t2;
            var L_diff = L_actual - L_ideal;
            var t0 = 0;
            var t1 = 1;
            var max_iter = 20;
            while (Math.abs(L_diff) > 0.01 && max_iter-- > 0) {
              (function() {
                if (pol) {
                  L_diff *= -1;
                }
                if (L_diff < 0) {
                  t0 = t2;
                  t2 += (t1 - t2) * 0.5;
                } else {
                  t1 = t2;
                  t2 += (t0 - t2) * 0.5;
                }
                L_actual = getColor(t2, true).lab()[0];
                return L_diff = L_actual - L_ideal;
              })();
            }
            return t2;
          };
        } else {
          tMapLightness = function(t2) {
            return t2;
          };
        }
        return f2;
      };
      f2.padding = function(p2) {
        if (p2 != null) {
          if (type$2(p2) === "number") {
            p2 = [p2, p2];
          }
          _padding = p2;
          return f2;
        } else {
          return _padding;
        }
      };
      f2.colors = function(numColors, out) {
        if (arguments.length < 2) {
          out = "hex";
        }
        var result = [];
        if (arguments.length === 0) {
          result = _colors.slice(0);
        } else if (numColors === 1) {
          result = [f2(0.5)];
        } else if (numColors > 1) {
          var dm = _domain[0];
          var dd = _domain[1] - dm;
          result = __range__(0, numColors, false).map(function(i4) {
            return f2(dm + i4 / (numColors - 1) * dd);
          });
        } else {
          colors2 = [];
          var samples = [];
          if (_classes && _classes.length > 2) {
            for (var i3 = 1, end = _classes.length, asc = 1 <= end; asc ? i3 < end : i3 > end; asc ? i3++ : i3--) {
              samples.push((_classes[i3 - 1] + _classes[i3]) * 0.5);
            }
          } else {
            samples = _domain;
          }
          result = samples.map(function(v2) {
            return f2(v2);
          });
        }
        if (chroma$4[out]) {
          result = result.map(function(c2) {
            return c2[out]();
          });
        }
        return result;
      };
      f2.cache = function(c2) {
        if (c2 != null) {
          _useCache = c2;
          return f2;
        } else {
          return _useCache;
        }
      };
      f2.gamma = function(g) {
        if (g != null) {
          _gamma = g;
          return f2;
        } else {
          return _gamma;
        }
      };
      f2.nodata = function(d) {
        if (d != null) {
          _nacol = chroma$4(d);
          return f2;
        } else {
          return _nacol;
        }
      };
      return f2;
    };
    function __range__(left, right, inclusive) {
      var range2 = [];
      var ascending2 = left < right;
      var end = !inclusive ? right : ascending2 ? right + 1 : right - 1;
      for (var i3 = left; ascending2 ? i3 < end : i3 > end; ascending2 ? i3++ : i3--) {
        range2.push(i3);
      }
      return range2;
    }
    var Color$5 = Color_1;
    var scale$1 = scale$2;
    var binom_row = function(n2) {
      var row = [1, 1];
      for (var i3 = 1; i3 < n2; i3++) {
        var newrow = [1];
        for (var j = 1; j <= row.length; j++) {
          newrow[j] = (row[j] || 0) + row[j - 1];
        }
        row = newrow;
      }
      return row;
    };
    var bezier = function(colors2) {
      var assign2, assign$12, assign$2;
      var I, lab0, lab1, lab2;
      colors2 = colors2.map(function(c2) {
        return new Color$5(c2);
      });
      if (colors2.length === 2) {
        assign2 = colors2.map(function(c2) {
          return c2.lab();
        }), lab0 = assign2[0], lab1 = assign2[1];
        I = function(t2) {
          var lab4 = [0, 1, 2].map(function(i3) {
            return lab0[i3] + t2 * (lab1[i3] - lab0[i3]);
          });
          return new Color$5(lab4, "lab");
        };
      } else if (colors2.length === 3) {
        assign$12 = colors2.map(function(c2) {
          return c2.lab();
        }), lab0 = assign$12[0], lab1 = assign$12[1], lab2 = assign$12[2];
        I = function(t2) {
          var lab4 = [0, 1, 2].map(function(i3) {
            return (1 - t2) * (1 - t2) * lab0[i3] + 2 * (1 - t2) * t2 * lab1[i3] + t2 * t2 * lab2[i3];
          });
          return new Color$5(lab4, "lab");
        };
      } else if (colors2.length === 4) {
        var lab3;
        assign$2 = colors2.map(function(c2) {
          return c2.lab();
        }), lab0 = assign$2[0], lab1 = assign$2[1], lab2 = assign$2[2], lab3 = assign$2[3];
        I = function(t2) {
          var lab4 = [0, 1, 2].map(function(i3) {
            return (1 - t2) * (1 - t2) * (1 - t2) * lab0[i3] + 3 * (1 - t2) * (1 - t2) * t2 * lab1[i3] + 3 * (1 - t2) * t2 * t2 * lab2[i3] + t2 * t2 * t2 * lab3[i3];
          });
          return new Color$5(lab4, "lab");
        };
      } else if (colors2.length >= 5) {
        var labs, row, n2;
        labs = colors2.map(function(c2) {
          return c2.lab();
        });
        n2 = colors2.length - 1;
        row = binom_row(n2);
        I = function(t2) {
          var u2 = 1 - t2;
          var lab4 = [0, 1, 2].map(function(i3) {
            return labs.reduce(function(sum2, el, j) {
              return sum2 + row[j] * Math.pow(u2, n2 - j) * Math.pow(t2, j) * el[i3];
            }, 0);
          });
          return new Color$5(lab4, "lab");
        };
      } else {
        throw new RangeError("No point in running bezier with only one color.");
      }
      return I;
    };
    var bezier_1 = function(colors2) {
      var f2 = bezier(colors2);
      f2.scale = function() {
        return scale$1(f2);
      };
      return f2;
    };
    var chroma$3 = chroma_1;
    var blend = function(bottom, top, mode) {
      if (!blend[mode]) {
        throw new Error("unknown blend mode " + mode);
      }
      return blend[mode](bottom, top);
    };
    var blend_f = function(f2) {
      return function(bottom, top) {
        var c0 = chroma$3(top).rgb();
        var c1 = chroma$3(bottom).rgb();
        return chroma$3.rgb(f2(c0, c1));
      };
    };
    var each = function(f2) {
      return function(c0, c1) {
        var out = [];
        out[0] = f2(c0[0], c1[0]);
        out[1] = f2(c0[1], c1[1]);
        out[2] = f2(c0[2], c1[2]);
        return out;
      };
    };
    var normal = function(a2) {
      return a2;
    };
    var multiply = function(a2, b) {
      return a2 * b / 255;
    };
    var darken = function(a2, b) {
      return a2 > b ? b : a2;
    };
    var lighten = function(a2, b) {
      return a2 > b ? a2 : b;
    };
    var screen = function(a2, b) {
      return 255 * (1 - (1 - a2 / 255) * (1 - b / 255));
    };
    var overlay = function(a2, b) {
      return b < 128 ? 2 * a2 * b / 255 : 255 * (1 - 2 * (1 - a2 / 255) * (1 - b / 255));
    };
    var burn = function(a2, b) {
      return 255 * (1 - (1 - b / 255) / (a2 / 255));
    };
    var dodge = function(a2, b) {
      if (a2 === 255) {
        return 255;
      }
      a2 = 255 * (b / 255) / (1 - a2 / 255);
      return a2 > 255 ? 255 : a2;
    };
    blend.normal = blend_f(each(normal));
    blend.multiply = blend_f(each(multiply));
    blend.screen = blend_f(each(screen));
    blend.overlay = blend_f(each(overlay));
    blend.darken = blend_f(each(darken));
    blend.lighten = blend_f(each(lighten));
    blend.dodge = blend_f(each(dodge));
    blend.burn = blend_f(each(burn));
    var blend_1 = blend;
    var type$1 = utils.type;
    var clip_rgb = utils.clip_rgb;
    var TWOPI = utils.TWOPI;
    var pow$2 = Math.pow;
    var sin$1 = Math.sin;
    var cos$1 = Math.cos;
    var chroma$2 = chroma_1;
    var cubehelix = function(start, rotations, hue, gamma2, lightness) {
      if (start === void 0)
        start = 300;
      if (rotations === void 0)
        rotations = -1.5;
      if (hue === void 0)
        hue = 1;
      if (gamma2 === void 0)
        gamma2 = 1;
      if (lightness === void 0)
        lightness = [0, 1];
      var dh = 0, dl;
      if (type$1(lightness) === "array") {
        dl = lightness[1] - lightness[0];
      } else {
        dl = 0;
        lightness = [lightness, lightness];
      }
      var f2 = function(fract) {
        var a2 = TWOPI * ((start + 120) / 360 + rotations * fract);
        var l2 = pow$2(lightness[0] + dl * fract, gamma2);
        var h2 = dh !== 0 ? hue[0] + fract * dh : hue;
        var amp = h2 * l2 * (1 - l2) / 2;
        var cos_a = cos$1(a2);
        var sin_a = sin$1(a2);
        var r2 = l2 + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
        var g = l2 + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
        var b = l2 + amp * (1.97294 * cos_a);
        return chroma$2(clip_rgb([r2 * 255, g * 255, b * 255, 1]));
      };
      f2.start = function(s2) {
        if (s2 == null) {
          return start;
        }
        start = s2;
        return f2;
      };
      f2.rotations = function(r2) {
        if (r2 == null) {
          return rotations;
        }
        rotations = r2;
        return f2;
      };
      f2.gamma = function(g) {
        if (g == null) {
          return gamma2;
        }
        gamma2 = g;
        return f2;
      };
      f2.hue = function(h2) {
        if (h2 == null) {
          return hue;
        }
        hue = h2;
        if (type$1(hue) === "array") {
          dh = hue[1] - hue[0];
          if (dh === 0) {
            hue = hue[1];
          }
        } else {
          dh = 0;
        }
        return f2;
      };
      f2.lightness = function(h2) {
        if (h2 == null) {
          return lightness;
        }
        if (type$1(h2) === "array") {
          lightness = h2;
          dl = h2[1] - h2[0];
        } else {
          lightness = [h2, h2];
          dl = 0;
        }
        return f2;
      };
      f2.scale = function() {
        return chroma$2.scale(f2);
      };
      f2.hue(hue);
      return f2;
    };
    var Color$4 = Color_1;
    var digits = "0123456789abcdef";
    var floor$1 = Math.floor;
    var random = Math.random;
    var random_1 = function() {
      var code2 = "#";
      for (var i3 = 0; i3 < 6; i3++) {
        code2 += digits.charAt(floor$1(random() * 16));
      }
      return new Color$4(code2, "hex");
    };
    var type2 = type$p;
    var log = Math.log;
    var pow$1 = Math.pow;
    var floor2 = Math.floor;
    var abs$12 = Math.abs;
    var analyze = function(data, key2) {
      if (key2 === void 0)
        key2 = null;
      var r2 = {
        min: Number.MAX_VALUE,
        max: Number.MAX_VALUE * -1,
        sum: 0,
        values: [],
        count: 0
      };
      if (type2(data) === "object") {
        data = Object.values(data);
      }
      data.forEach(function(val) {
        if (key2 && type2(val) === "object") {
          val = val[key2];
        }
        if (val !== void 0 && val !== null && !isNaN(val)) {
          r2.values.push(val);
          r2.sum += val;
          if (val < r2.min) {
            r2.min = val;
          }
          if (val > r2.max) {
            r2.max = val;
          }
          r2.count += 1;
        }
      });
      r2.domain = [r2.min, r2.max];
      r2.limits = function(mode, num2) {
        return limits(r2, mode, num2);
      };
      return r2;
    };
    var limits = function(data, mode, num2) {
      if (mode === void 0)
        mode = "equal";
      if (num2 === void 0)
        num2 = 7;
      if (type2(data) == "array") {
        data = analyze(data);
      }
      var min3 = data.min;
      var max3 = data.max;
      var values = data.values.sort(function(a2, b) {
        return a2 - b;
      });
      if (num2 === 1) {
        return [min3, max3];
      }
      var limits2 = [];
      if (mode.substr(0, 1) === "c") {
        limits2.push(min3);
        limits2.push(max3);
      }
      if (mode.substr(0, 1) === "e") {
        limits2.push(min3);
        for (var i3 = 1; i3 < num2; i3++) {
          limits2.push(min3 + i3 / num2 * (max3 - min3));
        }
        limits2.push(max3);
      } else if (mode.substr(0, 1) === "l") {
        if (min3 <= 0) {
          throw new Error("Logarithmic scales are only possible for values > 0");
        }
        var min_log = Math.LOG10E * log(min3);
        var max_log = Math.LOG10E * log(max3);
        limits2.push(min3);
        for (var i$12 = 1; i$12 < num2; i$12++) {
          limits2.push(pow$1(10, min_log + i$12 / num2 * (max_log - min_log)));
        }
        limits2.push(max3);
      } else if (mode.substr(0, 1) === "q") {
        limits2.push(min3);
        for (var i$2 = 1; i$2 < num2; i$2++) {
          var p2 = (values.length - 1) * i$2 / num2;
          var pb = floor2(p2);
          if (pb === p2) {
            limits2.push(values[pb]);
          } else {
            var pr = p2 - pb;
            limits2.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
          }
        }
        limits2.push(max3);
      } else if (mode.substr(0, 1) === "k") {
        var cluster;
        var n2 = values.length;
        var assignments = new Array(n2);
        var clusterSizes = new Array(num2);
        var repeat = true;
        var nb_iters = 0;
        var centroids = null;
        centroids = [];
        centroids.push(min3);
        for (var i$3 = 1; i$3 < num2; i$3++) {
          centroids.push(min3 + i$3 / num2 * (max3 - min3));
        }
        centroids.push(max3);
        while (repeat) {
          for (var j = 0; j < num2; j++) {
            clusterSizes[j] = 0;
          }
          for (var i$4 = 0; i$4 < n2; i$4++) {
            var value = values[i$4];
            var mindist = Number.MAX_VALUE;
            var best = void 0;
            for (var j$1 = 0; j$1 < num2; j$1++) {
              var dist2 = abs$12(centroids[j$1] - value);
              if (dist2 < mindist) {
                mindist = dist2;
                best = j$1;
              }
              clusterSizes[best]++;
              assignments[i$4] = best;
            }
          }
          var newCentroids = new Array(num2);
          for (var j$2 = 0; j$2 < num2; j$2++) {
            newCentroids[j$2] = null;
          }
          for (var i$5 = 0; i$5 < n2; i$5++) {
            cluster = assignments[i$5];
            if (newCentroids[cluster] === null) {
              newCentroids[cluster] = values[i$5];
            } else {
              newCentroids[cluster] += values[i$5];
            }
          }
          for (var j$3 = 0; j$3 < num2; j$3++) {
            newCentroids[j$3] *= 1 / clusterSizes[j$3];
          }
          repeat = false;
          for (var j$4 = 0; j$4 < num2; j$4++) {
            if (newCentroids[j$4] !== centroids[j$4]) {
              repeat = true;
              break;
            }
          }
          centroids = newCentroids;
          nb_iters++;
          if (nb_iters > 200) {
            repeat = false;
          }
        }
        var kClusters = {};
        for (var j$5 = 0; j$5 < num2; j$5++) {
          kClusters[j$5] = [];
        }
        for (var i$6 = 0; i$6 < n2; i$6++) {
          cluster = assignments[i$6];
          kClusters[cluster].push(values[i$6]);
        }
        var tmpKMeansBreaks = [];
        for (var j$6 = 0; j$6 < num2; j$6++) {
          tmpKMeansBreaks.push(kClusters[j$6][0]);
          tmpKMeansBreaks.push(kClusters[j$6][kClusters[j$6].length - 1]);
        }
        tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a2, b) {
          return a2 - b;
        });
        limits2.push(tmpKMeansBreaks[0]);
        for (var i$7 = 1; i$7 < tmpKMeansBreaks.length; i$7 += 2) {
          var v2 = tmpKMeansBreaks[i$7];
          if (!isNaN(v2) && limits2.indexOf(v2) === -1) {
            limits2.push(v2);
          }
        }
      }
      return limits2;
    };
    var analyze_1 = { analyze, limits };
    var Color$3 = Color_1;
    var contrast = function(a2, b) {
      a2 = new Color$3(a2);
      b = new Color$3(b);
      var l1 = a2.luminance();
      var l2 = b.luminance();
      return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
    };
    var Color$2 = Color_1;
    var sqrt2 = Math.sqrt;
    var pow = Math.pow;
    var min2 = Math.min;
    var max2 = Math.max;
    var atan22 = Math.atan2;
    var abs2 = Math.abs;
    var cos2 = Math.cos;
    var sin2 = Math.sin;
    var exp = Math.exp;
    var PI = Math.PI;
    var deltaE = function(a2, b, Kl, Kc, Kh) {
      if (Kl === void 0)
        Kl = 1;
      if (Kc === void 0)
        Kc = 1;
      if (Kh === void 0)
        Kh = 1;
      var rad2deg = function(rad) {
        return 360 * rad / (2 * PI);
      };
      var deg2rad = function(deg) {
        return 2 * PI * deg / 360;
      };
      a2 = new Color$2(a2);
      b = new Color$2(b);
      var ref = Array.from(a2.lab());
      var L1 = ref[0];
      var a1 = ref[1];
      var b1 = ref[2];
      var ref$1 = Array.from(b.lab());
      var L2 = ref$1[0];
      var a22 = ref$1[1];
      var b2 = ref$1[2];
      var avgL = (L1 + L2) / 2;
      var C1 = sqrt2(pow(a1, 2) + pow(b1, 2));
      var C2 = sqrt2(pow(a22, 2) + pow(b2, 2));
      var avgC = (C1 + C2) / 2;
      var G = 0.5 * (1 - sqrt2(pow(avgC, 7) / (pow(avgC, 7) + pow(25, 7))));
      var a1p = a1 * (1 + G);
      var a2p = a22 * (1 + G);
      var C1p = sqrt2(pow(a1p, 2) + pow(b1, 2));
      var C2p = sqrt2(pow(a2p, 2) + pow(b2, 2));
      var avgCp = (C1p + C2p) / 2;
      var arctan1 = rad2deg(atan22(b1, a1p));
      var arctan2 = rad2deg(atan22(b2, a2p));
      var h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
      var h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
      var avgHp = abs2(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
      var T2 = 1 - 0.17 * cos2(deg2rad(avgHp - 30)) + 0.24 * cos2(deg2rad(2 * avgHp)) + 0.32 * cos2(deg2rad(3 * avgHp + 6)) - 0.2 * cos2(deg2rad(4 * avgHp - 63));
      var deltaHp = h2p - h1p;
      deltaHp = abs2(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
      deltaHp = 2 * sqrt2(C1p * C2p) * sin2(deg2rad(deltaHp) / 2);
      var deltaL = L2 - L1;
      var deltaCp = C2p - C1p;
      var sl = 1 + 0.015 * pow(avgL - 50, 2) / sqrt2(20 + pow(avgL - 50, 2));
      var sc = 1 + 0.045 * avgCp;
      var sh = 1 + 0.015 * avgCp * T2;
      var deltaTheta = 30 * exp(-pow((avgHp - 275) / 25, 2));
      var Rc = 2 * sqrt2(pow(avgCp, 7) / (pow(avgCp, 7) + pow(25, 7)));
      var Rt = -Rc * sin2(2 * deg2rad(deltaTheta));
      var result = sqrt2(pow(deltaL / (Kl * sl), 2) + pow(deltaCp / (Kc * sc), 2) + pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
      return max2(0, min2(100, result));
    };
    var Color$1 = Color_1;
    var distance2 = function(a2, b, mode) {
      if (mode === void 0)
        mode = "lab";
      a2 = new Color$1(a2);
      b = new Color$1(b);
      var l1 = a2.get(mode);
      var l2 = b.get(mode);
      var sum_sq = 0;
      for (var i3 in l1) {
        var d = (l1[i3] || 0) - (l2[i3] || 0);
        sum_sq += d * d;
      }
      return Math.sqrt(sum_sq);
    };
    var Color2 = Color_1;
    var valid = function() {
      var args = [], len = arguments.length;
      while (len--)
        args[len] = arguments[len];
      try {
        new (Function.prototype.bind.apply(Color2, [null].concat(args)))();
        return true;
      } catch (e3) {
        return false;
      }
    };
    var chroma$12 = chroma_1;
    var scale = scale$2;
    var scales = {
      cool: function cool() {
        return scale([chroma$12.hsl(180, 1, 0.9), chroma$12.hsl(250, 0.7, 0.4)]);
      },
      hot: function hot() {
        return scale(["#000", "#f00", "#ff0", "#fff"]).mode("rgb");
      }
    };
    var colorbrewer = {
      // sequential
      OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"],
      PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"],
      BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"],
      Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"],
      BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"],
      YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"],
      YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"],
      Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"],
      RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"],
      Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"],
      YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
      Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"],
      GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"],
      Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
      YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"],
      PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"],
      Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"],
      PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"],
      Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"],
      // diverging
      Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
      RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
      RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
      PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
      PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
      RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
      BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
      RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
      PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
      // qualitative
      Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
      Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
      Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"],
      Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"],
      Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"],
      Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"],
      Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"],
      Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
    };
    for (var i2 = 0, list = Object.keys(colorbrewer); i2 < list.length; i2 += 1) {
      var key = list[i2];
      colorbrewer[key.toLowerCase()] = colorbrewer[key];
    }
    var colorbrewer_1 = colorbrewer;
    var chroma2 = chroma_1;
    chroma2.average = average;
    chroma2.bezier = bezier_1;
    chroma2.blend = blend_1;
    chroma2.cubehelix = cubehelix;
    chroma2.mix = chroma2.interpolate = mix$1;
    chroma2.random = random_1;
    chroma2.scale = scale$2;
    chroma2.analyze = analyze_1.analyze;
    chroma2.contrast = contrast;
    chroma2.deltaE = deltaE;
    chroma2.distance = distance2;
    chroma2.limits = analyze_1.limits;
    chroma2.valid = valid;
    chroma2.scales = scales;
    chroma2.colors = w3cx11_1;
    chroma2.brewer = colorbrewer_1;
    var chroma_js = chroma2;
    return chroma_js;
  });
})(chroma$1);
var chromaExports = chroma$1.exports;
const chroma = /* @__PURE__ */ getDefaultExportFromCjs(chromaExports);
function get_each_context_2$3(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[34] = list[i2];
  child_ctx[36] = i2;
  return child_ctx;
}
function get_each_context_1$3(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[34] = list[i2];
  child_ctx[36] = i2;
  return child_ctx;
}
function get_each_context$c(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[34] = list[i2];
  child_ctx[36] = i2;
  return child_ctx;
}
function create_if_block$D(ctx2) {
  let if_block_anchor;
  function select_block_type(ctx3, dirty) {
    if (
      /*state*/
      ctx3[1] === "hover"
    )
      return create_if_block_1$f;
    if (
      /*state*/
      ctx3[1] === "focus"
    )
      return create_if_block_3$2;
    return create_else_block$d;
  }
  let current_block_type = select_block_type(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (current_block_type === (current_block_type = select_block_type(ctx3)) && if_block) {
        if_block.p(ctx3, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx3);
        if (if_block) {
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if_block.d(detaching);
    }
  };
}
function create_else_block$d(ctx2) {
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let each_1_anchor;
  let each_value_2 = ensure_array_like(
    /*$displayTexts*/
    ctx2[4]
  );
  const get_key = (ctx3) => (
    /*i*/
    ctx3[36]
  );
  for (let i2 = 0; i2 < each_value_2.length; i2 += 1) {
    let child_ctx = get_each_context_2$3(ctx2, each_value_2, i2);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i2] = create_each_block_2$3(key, child_ctx));
  }
  return {
    c() {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(target, anchor);
        }
      }
      insert(target, each_1_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*transforms, $displayTexts, baseProps, _props*/
      240) {
        each_value_2 = ensure_array_like(
          /*$displayTexts*/
          ctx3[4]
        );
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx3, each_value_2, each_1_lookup, each_1_anchor.parentNode, destroy_block, create_each_block_2$3, each_1_anchor, get_each_context_2$3);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(each_1_anchor);
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d(detaching);
      }
    }
  };
}
function create_if_block_3$2(ctx2) {
  let if_block_anchor;
  let if_block = !/*$shapeProps*/
  ctx2[3].link && create_if_block_4$3(ctx2);
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (!/*$shapeProps*/
      ctx3[3].link) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block_4$3(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_if_block_1$f(ctx2) {
  let if_block_anchor;
  let if_block = !/*$shapeProps*/
  ctx2[3].link && create_if_block_2$9(ctx2);
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (!/*$shapeProps*/
      ctx3[3].link) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block_2$9(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_each_block_2$3(key_1, ctx2) {
  let g;
  let text_1;
  let t_value = (
    /*text*/
    ctx2[34] + ""
  );
  let t2;
  let g_transform_value;
  let text_1_levels = [
    {
      .../*baseProps*/
      ctx2[5],
      .../*_props*/
      ctx2[6]
    }
  ];
  let text_data = {};
  for (let i2 = 0; i2 < text_1_levels.length; i2 += 1) {
    text_data = assign$1(text_data, text_1_levels[i2]);
  }
  return {
    key: key_1,
    first: null,
    c() {
      g = svg_element("g");
      text_1 = svg_element("text");
      t2 = text(t_value);
      set_svg_attributes(text_1, text_data);
      attr(g, "transform", g_transform_value = /*transforms*/
      ctx2[7][
        /*i*/
        ctx2[36]
      ]);
      this.first = g;
    },
    m(target, anchor) {
      insert(target, g, anchor);
      append$2(g, text_1);
      append$2(text_1, t2);
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (dirty[0] & /*$displayTexts*/
      16 && t_value !== (t_value = /*text*/
      ctx2[34] + ""))
        set_data_maybe_contenteditable(t2, t_value, text_data["contenteditable"]);
      set_svg_attributes(text_1, text_data = get_spread_update(text_1_levels, [
        dirty[0] & /*baseProps, _props*/
        96 && {
          .../*baseProps*/
          ctx2[5],
          .../*_props*/
          ctx2[6]
        }
      ]));
      if (dirty[0] & /*transforms, $displayTexts*/
      144 && g_transform_value !== (g_transform_value = /*transforms*/
      ctx2[7][
        /*i*/
        ctx2[36]
      ])) {
        attr(g, "transform", g_transform_value);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(g);
      }
    }
  };
}
function create_if_block_4$3(ctx2) {
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let each_1_anchor;
  let each_value_1 = ensure_array_like(
    /*$displayTexts*/
    ctx2[4]
  );
  const get_key = (ctx3) => (
    /*i*/
    ctx3[36]
  );
  for (let i2 = 0; i2 < each_value_1.length; i2 += 1) {
    let child_ctx = get_each_context_1$3(ctx2, each_value_1, i2);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i2] = create_each_block_1$3(key, child_ctx));
  }
  return {
    c() {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(target, anchor);
        }
      }
      insert(target, each_1_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*baseProps, transforms, $displayTexts, $focused*/
      688) {
        each_value_1 = ensure_array_like(
          /*$displayTexts*/
          ctx3[4]
        );
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx3, each_value_1, each_1_lookup, each_1_anchor.parentNode, destroy_block, create_each_block_1$3, each_1_anchor, get_each_context_1$3);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(each_1_anchor);
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d(detaching);
      }
    }
  };
}
function create_each_block_1$3(key_1, ctx2) {
  let text_1;
  let t_value = (
    /*text*/
    ctx2[34] + ""
  );
  let t2;
  let text_1_stroke_width_value;
  let text_1_visibility_value;
  let text_1_levels = [
    {
      .../*baseProps*/
      ctx2[5],
      transform: (
        /*transforms*/
        ctx2[7][
          /*i*/
          ctx2[36]
        ]
      )
    },
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: "#333" },
    {
      "stroke-width": text_1_stroke_width_value = 2
    },
    {
      visibility: text_1_visibility_value = /*$focused*/
      ctx2[9] ? "visible" : "hidden"
    }
  ];
  let text_data = {};
  for (let i2 = 0; i2 < text_1_levels.length; i2 += 1) {
    text_data = assign$1(text_data, text_1_levels[i2]);
  }
  return {
    key: key_1,
    first: null,
    c() {
      text_1 = svg_element("text");
      t2 = text(t_value);
      set_svg_attributes(text_1, text_data);
      this.first = text_1;
    },
    m(target, anchor) {
      insert(target, text_1, anchor);
      append$2(text_1, t2);
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (dirty[0] & /*$displayTexts*/
      16 && t_value !== (t_value = /*text*/
      ctx2[34] + ""))
        set_data_maybe_contenteditable(t2, t_value, text_data["contenteditable"]);
      set_svg_attributes(text_1, text_data = get_spread_update(text_1_levels, [
        dirty[0] & /*baseProps, transforms, $displayTexts*/
        176 && {
          .../*baseProps*/
          ctx2[5],
          transform: (
            /*transforms*/
            ctx2[7][
              /*i*/
              ctx2[36]
            ]
          )
        },
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: "#333" },
        {
          "stroke-width": text_1_stroke_width_value
        },
        dirty[0] & /*$focused*/
        512 && text_1_visibility_value !== (text_1_visibility_value = /*$focused*/
        ctx2[9] ? "visible" : "hidden") && { visibility: text_1_visibility_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(text_1);
      }
    }
  };
}
function create_if_block_2$9(ctx2) {
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let each_1_anchor;
  let each_value = ensure_array_like(
    /*$displayTexts*/
    ctx2[4]
  );
  const get_key = (ctx3) => (
    /*i*/
    ctx3[36]
  );
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    let child_ctx = get_each_context$c(ctx2, each_value, i2);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i2] = create_each_block$c(key, child_ctx));
  }
  return {
    c() {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(target, anchor);
        }
      }
      insert(target, each_1_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*baseProps, transforms, $displayTexts, $hovered*/
      180) {
        each_value = ensure_array_like(
          /*$displayTexts*/
          ctx3[4]
        );
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx3, each_value, each_1_lookup, each_1_anchor.parentNode, destroy_block, create_each_block$c, each_1_anchor, get_each_context$c);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(each_1_anchor);
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d(detaching);
      }
    }
  };
}
function create_each_block$c(key_1, ctx2) {
  let text_1;
  let t_value = (
    /*text*/
    ctx2[34] + ""
  );
  let t2;
  let text_1_stroke_width_value;
  let text_1_visibility_value;
  let text_1_levels = [
    {
      .../*baseProps*/
      ctx2[5],
      transform: (
        /*transforms*/
        ctx2[7][
          /*i*/
          ctx2[36]
        ]
      )
    },
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: "#333" },
    {
      "stroke-width": text_1_stroke_width_value = 1
    },
    {
      visibility: text_1_visibility_value = /*$hovered*/
      ctx2[2] ? "visible" : "hidden"
    }
  ];
  let text_data = {};
  for (let i2 = 0; i2 < text_1_levels.length; i2 += 1) {
    text_data = assign$1(text_data, text_1_levels[i2]);
  }
  return {
    key: key_1,
    first: null,
    c() {
      text_1 = svg_element("text");
      t2 = text(t_value);
      set_svg_attributes(text_1, text_data);
      this.first = text_1;
    },
    m(target, anchor) {
      insert(target, text_1, anchor);
      append$2(text_1, t2);
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (dirty[0] & /*$displayTexts*/
      16 && t_value !== (t_value = /*text*/
      ctx2[34] + ""))
        set_data_maybe_contenteditable(t2, t_value, text_data["contenteditable"]);
      set_svg_attributes(text_1, text_data = get_spread_update(text_1_levels, [
        dirty[0] & /*baseProps, transforms, $displayTexts*/
        176 && {
          .../*baseProps*/
          ctx2[5],
          transform: (
            /*transforms*/
            ctx2[7][
              /*i*/
              ctx2[36]
            ]
          )
        },
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: "#333" },
        {
          "stroke-width": text_1_stroke_width_value
        },
        dirty[0] & /*$hovered*/
        4 && text_1_visibility_value !== (text_1_visibility_value = /*$hovered*/
        ctx2[2] ? "visible" : "hidden") && { visibility: text_1_visibility_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(text_1);
      }
    }
  };
}
function create_fragment$L(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && /*$visible*/
    ctx2[8] && create_if_block$D(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (
        /*shapeInstance*/
        ctx3[0] && /*$visible*/
        ctx3[8]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$D(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$I($$self, $$props, $$invalidate) {
  let fillColor;
  let transforms;
  let _props;
  let $props;
  let $inactive;
  let $hovered;
  let $font;
  let $chartHeight;
  let $chartWidth;
  let $shapeProps;
  let $displayTexts;
  let $visible;
  let $focused;
  let { shapeInstance } = $$props;
  let { parentX = 0 } = $$props;
  let { parentY = 0 } = $$props;
  let { state = null } = $$props;
  const { focused, hovered, inactive, visible, props, shapeProps, displayTexts } = shapeInstance;
  component_subscribe($$self, focused, (value) => $$invalidate(9, $focused = value));
  component_subscribe($$self, hovered, (value) => $$invalidate(2, $hovered = value));
  component_subscribe($$self, inactive, (value) => $$invalidate(27, $inactive = value));
  component_subscribe($$self, visible, (value) => $$invalidate(8, $visible = value));
  component_subscribe($$self, props, (value) => $$invalidate(26, $props = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(3, $shapeProps = value));
  component_subscribe($$self, displayTexts, (value) => $$invalidate(4, $displayTexts = value));
  const instance2 = getInstance();
  const { chartWidth, chartHeight, font, ssr } = instance2;
  component_subscribe($$self, chartWidth, (value) => $$invalidate(30, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(29, $chartHeight = value));
  component_subscribe($$self, font, (value) => $$invalidate(28, $font = value));
  let baseProps;
  let dx;
  let dy;
  let rect;
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
    if ("parentX" in $$props2)
      $$invalidate(20, parentX = $$props2.parentX);
    if ("parentY" in $$props2)
      $$invalidate(21, parentY = $$props2.parentY);
    if ("state" in $$props2)
      $$invalidate(1, state = $$props2.state);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$shapeProps*/
    8) {
      $$invalidate(25, fillColor = (() => {
        const { backgroundColor = "#fff" } = $shapeProps;
        if (chroma.valid(backgroundColor)) {
          return chroma(backgroundColor).luminance() < 0.5 ? "#fff" : "#333";
        }
        return "#333";
      })());
    }
    if ($$self.$$.dirty[0] & /*$shapeProps*/
    8) {
      (() => {
        const { backgroundColor = "#fff" } = $shapeProps;
        if (chroma.valid(backgroundColor)) {
          return chroma(backgroundColor).luminance() < 0.5 ? "#333" : "#fff";
        }
        return "#fff";
      })();
    }
    if ($$self.$$.dirty[0] & /*$shapeProps, shapeInstance*/
    9) {
      {
        $$invalidate(24, rect = shapeInstance.getBoundingRect());
      }
    }
    if ($$self.$$.dirty[0] & /*$shapeProps, $displayTexts, shapeInstance, dx, dy*/
    12582937) {
      $$invalidate(7, transforms = (() => {
        const { x: x2 = 0, y: y2 = 0, rotation } = $shapeProps;
        return $displayTexts.map((text2, i2) => {
          const startPoint = shapeInstance.getStartPoint(text2, i2, $displayTexts.length);
          $$invalidate(22, dx = asValidNumber(startPoint.x));
          $$invalidate(23, dy = asValidNumber(startPoint.y));
          let transform = "";
          if (isValidNumber(x2) && isValidNumber(y2)) {
            transform += ` translate(${x2 + dx},${y2 + dy})`;
          }
          if (rotation != null && rotation !== 0) {
            transform += ` rotate(${rotation})`;
          }
          return transform;
        });
      })());
    }
    if ($$self.$$.dirty[0] & /*$shapeProps, parentX, rect, $chartWidth, parentY, $chartHeight, state, shapeInstance, $font, fillColor, $hovered, $inactive*/
    2066743311) {
      {
        try {
          const { fontSize, fontFamily, width, height, overflow, link } = $shapeProps;
          let shown = true;
          if (overflow === "hidden") {
            if (parentX + rect.x < 0 || parentX + rect.x + rect.width > $chartWidth || parentY + rect.y < 0 || parentY + rect.y + rect.height > $chartHeight) {
              shown = false;
            }
            if (width != null && rect.width > width) {
              shown = false;
            }
            if (height != null && rect.height > height) {
              shown = false;
            }
          }
          if (state == null) {
            shapeInstance.setVisible(shown);
          }
          $$invalidate(5, baseProps = {
            "text-anchor": "start",
            // 'dominant-baseline': 'central',
            "dominant-baseline": "auto",
            "font-size": `${fontSize}px`,
            "font-family": fontFamily || $font.family,
            fill: fillColor,
            visibility: shown ? "" : "hidden",
            ...link && $hovered ? { "text-decoration": "underline" } : {},
            ...$inactive ? { opacity: 0.2 } : {}
          });
        } catch (e3) {
          console.log(e3);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$props*/
    67108864) {
      $$invalidate(6, _props = (() => {
        const p2 = { ...$props };
        Object.keys(p2).forEach((key) => {
          if (p2[key] === void 0) {
            delete p2[key];
          }
        });
        return p2;
      })());
    }
  };
  return [
    shapeInstance,
    state,
    $hovered,
    $shapeProps,
    $displayTexts,
    baseProps,
    _props,
    transforms,
    $visible,
    $focused,
    focused,
    hovered,
    inactive,
    visible,
    props,
    shapeProps,
    displayTexts,
    chartWidth,
    chartHeight,
    font,
    parentX,
    parentY,
    dx,
    dy,
    rect,
    fillColor,
    $props,
    $inactive,
    $font,
    $chartHeight,
    $chartWidth
  ];
}
let Component$b = class Component2 extends SvelteComponent {
  constructor(options) {
    super();
    init(
      this,
      options,
      instance_1$I,
      create_fragment$L,
      safe_not_equal,
      {
        shapeInstance: 0,
        parentX: 20,
        parentY: 21,
        state: 1
      },
      null,
      [-1, -1]
    );
  }
};
const textAlignMap = /* @__PURE__ */ new Map();
textAlignMap.set("center", "middle");
textAlignMap.set("left", "start");
textAlignMap.set("start", "start");
textAlignMap.set("right", "end");
textAlignMap.set("end", "end");
const textBaselineMap = /* @__PURE__ */ new Map();
textBaselineMap.set("middle", "central");
textBaselineMap.set("hanging", "text-before-edge");
textBaselineMap.set("top", "text-before-edge");
textBaselineMap.set("ideographic", "text-after-edge");
textBaselineMap.set("bottom", "text-after-edge");
const lineHeight$1 = 1;
const indent$1 = 0;
function normalizeRad(rad) {
  if (rad > Math.PI * 2) {
    return normalizeRad(rad - Math.PI * 2);
  } else if (rad < 0) {
    return normalizeRad(rad + Math.PI * 2);
  }
  return rad;
}
function calcRad$1(r2, dx, dy) {
  let rad = Math.acos(dx / r2);
  if (dy < 0) {
    return normalizeRad(-rad);
  }
  return rad;
}
function makeRect({
  x: x2,
  y: y2,
  width,
  height,
  textAlign,
  textBaseline
}) {
  const rect = new BoundingRect();
  rect.width = width;
  rect.height = height;
  if (textAlign === "left") {
    rect.x = x2;
  } else if (textAlign === "center") {
    rect.x = x2 - width / 2;
  } else if (textAlign === "right") {
    rect.x = x2 - width;
  }
  if (textBaseline === "top") {
    rect.y = y2;
  } else if (textBaseline === "middle") {
    rect.y = y2 - height / 2;
  } else if (textBaseline === "bottom") {
    rect.y = y2 - height;
  }
  return rect;
}
function makePoints(rect, {
  x: x2,
  y: y2,
  rotation
}) {
  const rad = rotation * (Math.PI / 180);
  const points = [];
  points.push(new Point$1({ x: rect.x, y: rect.y }));
  points.push(new Point$1({ x: rect.x + rect.width, y: rect.y }));
  points.push(new Point$1({ x: rect.x, y: rect.y + rect.height }));
  points.push(new Point$1({ x: rect.x + rect.width, y: rect.y + rect.height }));
  for (let i2 = 0; i2 < points.length; i2++) {
    const dx = points[i2].x - x2;
    const dy = points[i2].y - y2;
    const r2 = Math.max(1e-4, Math.sqrt(dx * dx + dy * dy));
    const rad2 = calcRad$1(r2, dx, dy);
    points[i2].x = x2 + r2 * Math.cos(rad + rad2);
    points[i2].y = y2 + r2 * Math.sin(rad + rad2);
  }
  return points;
}
function pointsToRect(points) {
  const rect = new BoundingRect();
  let left = 0;
  let right = 0;
  let top = 0;
  let bottom = 0;
  for (let j = 0; j < points.length; j++) {
    const point2 = points[j];
    if (j === 0) {
      left = point2.x;
      right = point2.x;
      top = point2.y;
      bottom = point2.y;
    } else {
      left = Math.min(left, point2.x);
      right = Math.max(right, point2.x);
      top = Math.min(top, point2.y);
      bottom = Math.max(bottom, point2.y);
    }
  }
  rect.x = left;
  rect.y = top;
  rect.width = right - left;
  rect.height = bottom - top;
  return rect;
}
class TextShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "text");
    __publicField(this, "shapeProps", writable({
      x: 0,
      y: 0,
      text: "",
      fontSize: 12,
      fontFamily: DEFAULT_FONT_FAMILY,
      textAlign: "center",
      textBaseline: "middle",
      padding: 4,
      backgroundColor: "#fff",
      width: null,
      height: null,
      rotation: 0,
      overflow: "hidden",
      link: null
    }));
    __publicField(this, "props");
    __publicField(this, "component", Component$b);
    __publicField(this, "hoveredComponent", Component$b);
    __publicField(this, "focusedComponent", Component$b);
    __publicField(this, "displayTexts", writable([]));
    // 物理的に見えている状態かどうか
    __publicField(this, "isVisible", false);
    __publicField(this, "textAlignMap", textAlignMap);
    __publicField(this, "textBaselineMap", textBaselineMap);
    this.shapeProps.update((shapeProps) => {
      const props = {
        ...shapeProps,
        ...option,
        fontFamily: option.fontFamily || shapeProps.fontFamily || DEFAULT_FONT_FAMILY
      };
      props.text = String(props.text || "").replace(/(\r\n|\n|\r)/g, " ").replace(/\s+/g, " ").trim();
      return props;
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
    this.shapeProps.subscribe(() => {
      this.apply();
      this.displayTexts.set(this.getDisplayTexts());
    });
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
  setVisible(visible) {
    this.isVisible = visible;
  }
  getDisplayTexts() {
    const { text: text2, width, height, overflow, padding: padding2 } = this.$shapeProps;
    const rect = this.measureText(text2);
    const textWidth = rect.width + padding2 * 2;
    const textHeight = rect.height + padding2 * 2;
    if (overflow === "ellipsis") {
      if (width != null && textWidth > width || height != null && textHeight > height) {
        let i2 = text2.length + 1;
        while (i2--) {
          const t2 = text2.substring(0, i2);
          const dt = `${t2}...`;
          const rect2 = this.measureText(dt);
          const textWidth2 = rect2.width + padding2 * 2;
          const textHeight2 = rect2.height + padding2 * 2;
          if ((width == null || textWidth2 < width) && (height == null || textHeight2 < height)) {
            return [dt];
          }
        }
        return [];
      }
      return [text2];
    }
    if (overflow === "break") {
      if (width != null && textWidth > width || height != null && textHeight > height) {
        const texts = [];
        let start = 0;
        let rows = 0;
        let i2 = text2.length + 1;
        while (i2--) {
          const t2 = text2.substring(start, start + i2);
          const rect2 = this.measureText(t2);
          const textWidth2 = rect2.width + padding2 * 2;
          const textHeight2 = rect2.height;
          if (t2.length > 0 && width != null && textWidth2 < width) {
            rows += 1;
            if (height != null && height < textHeight2 * rows + padding2 * 2) {
              break;
            }
            texts.push(t2);
            start = start + i2;
            i2 = text2.length - start + 1;
          }
        }
        return texts;
      }
      return [text2];
    }
    return [text2];
  }
  getStartPoint(text2, index2, length2) {
    const {
      x: x2,
      y: y2,
      padding: padding2,
      fontSize,
      fontFamily,
      rotation,
      textAlign,
      textBaseline
    } = this.$shapeProps;
    const {
      width,
      height,
      actualBoundingBoxAscent,
      actualBoundingBoxDescent
    } = getTextSize(text2, fontSize, fontFamily);
    const rad = rotation * (Math.PI / 180);
    let left = 0;
    let top = 0;
    let shapeWidth = width + padding2 * 2;
    left = x2 + padding2;
    if (textAlign == "left") {
      left -= 0;
    } else if (textAlign == "center") {
      left -= shapeWidth / 2;
    } else if (textAlign == "right") {
      left -= shapeWidth;
    }
    const textHeight = height * lineHeight$1;
    const topIndent = height * indent$1;
    let shapeHeight = textHeight * length2 + padding2 * 2;
    top = y2 + index2 * textHeight + topIndent + padding2;
    if (textBaseline === "top") {
      top -= 0;
    } else if (textBaseline === "middle") {
      top -= shapeHeight / 2;
    } else if (textBaseline === "bottom") {
      top -= shapeHeight;
    }
    const point2 = { x: left, y: top + actualBoundingBoxAscent };
    const dx = point2.x - x2;
    const dy = point2.y - y2;
    const r2 = Math.max(1e-4, Math.sqrt(dx * dx + dy * dy));
    const rad2 = calcRad$1(r2, dx, dy);
    point2.x = r2 * Math.cos(rad + rad2);
    point2.y = r2 * Math.sin(rad + rad2);
    return point2;
  }
  measureText(text2) {
    const {
      fontSize,
      fontFamily,
      x: x2,
      y: y2,
      textAlign,
      textBaseline,
      rotation
    } = this.$shapeProps;
    const { width, height: _height } = getTextSize(
      text2,
      fontSize,
      fontFamily
    );
    const height = _height * lineHeight$1;
    const rect = makeRect({ x: x2, y: y2, width, height, textAlign, textBaseline });
    const points = makePoints(rect, { x: x2, y: y2, rotation });
    const boundingRect = pointsToRect(points);
    return boundingRect;
  }
  getPoints() {
    const texts = get_store_value(this.displayTexts);
    const {
      fontSize,
      fontFamily,
      x: x2,
      y: y2,
      textAlign,
      textBaseline,
      rotation,
      padding: padding2
    } = this.$shapeProps;
    let width = 0;
    for (let i2 = 0; i2 < texts.length; i2++) {
      const text2 = texts[i2];
      width = Math.max(
        width,
        getTextSize(text2, fontSize, fontFamily).width
      );
    }
    width += padding2 * 2;
    let height = 0;
    if (texts.length > 0) {
      height = getTextSize("", fontSize, fontFamily).height * lineHeight$1 * texts.length;
    }
    height += padding2 * 2;
    const rect = makeRect({ x: x2, y: y2, width, height, textAlign, textBaseline });
    const points = makePoints(rect, { x: x2, y: y2, rotation });
    return points;
  }
  _getPolygon() {
    const points = this.getPoints();
    return new Polygon({ points });
  }
  _getBoundingRect() {
    const points = this.getPoints();
    const boundingRect = pointsToRect(points);
    boundingRect.visible = get_store_value(this.visible);
    return boundingRect;
  }
  _contain(x2, y2) {
    if (!get_store_value(this.visible)) {
      return false;
    }
    const rect = this.getBoundingRect();
    if (x2 >= rect.x && x2 <= rect.x + rect.width && y2 >= rect.y && y2 <= rect.y + rect.height) {
      return true;
    }
    return false;
  }
  intersect(rect) {
    return this.getBoundingRect().intersect(rect);
  }
}
function get_each_context_2$2(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[32] = list[i2];
  child_ctx[34] = i2;
  return child_ctx;
}
function get_each_context_1$2(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[32] = list[i2];
  child_ctx[34] = i2;
  return child_ctx;
}
function get_each_context$b(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[32] = list[i2];
  child_ctx[34] = i2;
  return child_ctx;
}
function create_if_block$C(ctx2) {
  let if_block_anchor;
  function select_block_type(ctx3, dirty) {
    if (
      /*state*/
      ctx3[1] === "hover"
    )
      return create_if_block_1$e;
    if (
      /*state*/
      ctx3[1] === "focus"
    )
      return create_if_block_3$1;
    return create_else_block$c;
  }
  let current_block_type = select_block_type(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (current_block_type === (current_block_type = select_block_type(ctx3)) && if_block) {
        if_block.p(ctx3, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx3);
        if (if_block) {
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if_block.d(detaching);
    }
  };
}
function create_else_block$c(ctx2) {
  let rect;
  let rect_fill_value;
  let rect_stroke_value;
  let rect_x_value;
  let rect_y_value;
  let rect_width_value;
  let rect_height_value;
  let t2;
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let each_1_anchor;
  let each_value_2 = ensure_array_like(
    /*$displayTexts*/
    ctx2[4]
  );
  const get_key = (ctx3) => (
    /*i*/
    ctx3[34]
  );
  for (let i2 = 0; i2 < each_value_2.length; i2 += 1) {
    let child_ctx = get_each_context_2$2(ctx2, each_value_2, i2);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i2] = create_each_block_2$2(key, child_ctx));
  }
  return {
    c() {
      var _a2;
      rect = svg_element("rect");
      t2 = space();
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      each_1_anchor = empty();
      attr(rect, "fill", rect_fill_value = /*$shapeProps*/
      (_a2 = ctx2[3].backgroundColor) != null ? _a2 : "none");
      attr(rect, "stroke", rect_stroke_value = /*$shapeProps*/
      ctx2[3].border);
      attr(rect, "x", rect_x_value = /*$shapeProps*/
      ctx2[3].x);
      attr(rect, "y", rect_y_value = /*$shapeProps*/
      ctx2[3].y);
      attr(rect, "width", rect_width_value = /*$shapeProps*/
      ctx2[3].width);
      attr(rect, "height", rect_height_value = /*$shapeProps*/
      ctx2[3].height);
    },
    m(target, anchor) {
      insert(target, rect, anchor);
      insert(target, t2, anchor);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(target, anchor);
        }
      }
      insert(target, each_1_anchor, anchor);
    },
    p(ctx3, dirty) {
      var _a2;
      if (dirty[0] & /*$shapeProps*/
      8 && rect_fill_value !== (rect_fill_value = /*$shapeProps*/
      (_a2 = ctx3[3].backgroundColor) != null ? _a2 : "none")) {
        attr(rect, "fill", rect_fill_value);
      }
      if (dirty[0] & /*$shapeProps*/
      8 && rect_stroke_value !== (rect_stroke_value = /*$shapeProps*/
      ctx3[3].border)) {
        attr(rect, "stroke", rect_stroke_value);
      }
      if (dirty[0] & /*$shapeProps*/
      8 && rect_x_value !== (rect_x_value = /*$shapeProps*/
      ctx3[3].x)) {
        attr(rect, "x", rect_x_value);
      }
      if (dirty[0] & /*$shapeProps*/
      8 && rect_y_value !== (rect_y_value = /*$shapeProps*/
      ctx3[3].y)) {
        attr(rect, "y", rect_y_value);
      }
      if (dirty[0] & /*$shapeProps*/
      8 && rect_width_value !== (rect_width_value = /*$shapeProps*/
      ctx3[3].width)) {
        attr(rect, "width", rect_width_value);
      }
      if (dirty[0] & /*$shapeProps*/
      8 && rect_height_value !== (rect_height_value = /*$shapeProps*/
      ctx3[3].height)) {
        attr(rect, "height", rect_height_value);
      }
      if (dirty[0] & /*transforms, $displayTexts, baseProps, _props*/
      240) {
        each_value_2 = ensure_array_like(
          /*$displayTexts*/
          ctx3[4]
        );
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx3, each_value_2, each_1_lookup, each_1_anchor.parentNode, destroy_block, create_each_block_2$2, each_1_anchor, get_each_context_2$2);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(rect);
        detach(t2);
        detach(each_1_anchor);
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d(detaching);
      }
    }
  };
}
function create_if_block_3$1(ctx2) {
  let if_block_anchor;
  let if_block = !/*$shapeProps*/
  ctx2[3].link && create_if_block_4$2(ctx2);
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (!/*$shapeProps*/
      ctx3[3].link) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block_4$2(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_if_block_1$e(ctx2) {
  let if_block_anchor;
  let if_block = !/*$shapeProps*/
  ctx2[3].link && create_if_block_2$8(ctx2);
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (!/*$shapeProps*/
      ctx3[3].link) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block_2$8(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_each_block_2$2(key_1, ctx2) {
  let g;
  let text_1;
  let t_value = (
    /*text*/
    ctx2[32] + ""
  );
  let t2;
  let g_transform_value;
  let text_1_levels = [
    {
      .../*baseProps*/
      ctx2[5],
      .../*_props*/
      ctx2[6]
    }
  ];
  let text_data = {};
  for (let i2 = 0; i2 < text_1_levels.length; i2 += 1) {
    text_data = assign$1(text_data, text_1_levels[i2]);
  }
  return {
    key: key_1,
    first: null,
    c() {
      g = svg_element("g");
      text_1 = svg_element("text");
      t2 = text(t_value);
      set_svg_attributes(text_1, text_data);
      attr(g, "transform", g_transform_value = /*transforms*/
      ctx2[7][
        /*i*/
        ctx2[34]
      ]);
      this.first = g;
    },
    m(target, anchor) {
      insert(target, g, anchor);
      append$2(g, text_1);
      append$2(text_1, t2);
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (dirty[0] & /*$displayTexts*/
      16 && t_value !== (t_value = /*text*/
      ctx2[32] + ""))
        set_data_maybe_contenteditable(t2, t_value, text_data["contenteditable"]);
      set_svg_attributes(text_1, text_data = get_spread_update(text_1_levels, [
        dirty[0] & /*baseProps, _props*/
        96 && {
          .../*baseProps*/
          ctx2[5],
          .../*_props*/
          ctx2[6]
        }
      ]));
      if (dirty[0] & /*transforms, $displayTexts*/
      144 && g_transform_value !== (g_transform_value = /*transforms*/
      ctx2[7][
        /*i*/
        ctx2[34]
      ])) {
        attr(g, "transform", g_transform_value);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(g);
      }
    }
  };
}
function create_if_block_4$2(ctx2) {
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let each_1_anchor;
  let each_value_1 = ensure_array_like(
    /*$displayTexts*/
    ctx2[4]
  );
  const get_key = (ctx3) => (
    /*i*/
    ctx3[34]
  );
  for (let i2 = 0; i2 < each_value_1.length; i2 += 1) {
    let child_ctx = get_each_context_1$2(ctx2, each_value_1, i2);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i2] = create_each_block_1$2(key, child_ctx));
  }
  return {
    c() {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(target, anchor);
        }
      }
      insert(target, each_1_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*baseProps, transforms, $displayTexts, $focused*/
      688) {
        each_value_1 = ensure_array_like(
          /*$displayTexts*/
          ctx3[4]
        );
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx3, each_value_1, each_1_lookup, each_1_anchor.parentNode, destroy_block, create_each_block_1$2, each_1_anchor, get_each_context_1$2);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(each_1_anchor);
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d(detaching);
      }
    }
  };
}
function create_each_block_1$2(key_1, ctx2) {
  let text_1;
  let t_value = (
    /*text*/
    ctx2[32] + ""
  );
  let t2;
  let text_1_stroke_width_value;
  let text_1_visibility_value;
  let text_1_levels = [
    {
      .../*baseProps*/
      ctx2[5],
      transform: (
        /*transforms*/
        ctx2[7][
          /*i*/
          ctx2[34]
        ]
      )
    },
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: "#333" },
    {
      "stroke-width": text_1_stroke_width_value = 2
    },
    {
      visibility: text_1_visibility_value = /*$focused*/
      ctx2[9] ? "visible" : "hidden"
    }
  ];
  let text_data = {};
  for (let i2 = 0; i2 < text_1_levels.length; i2 += 1) {
    text_data = assign$1(text_data, text_1_levels[i2]);
  }
  return {
    key: key_1,
    first: null,
    c() {
      text_1 = svg_element("text");
      t2 = text(t_value);
      set_svg_attributes(text_1, text_data);
      this.first = text_1;
    },
    m(target, anchor) {
      insert(target, text_1, anchor);
      append$2(text_1, t2);
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (dirty[0] & /*$displayTexts*/
      16 && t_value !== (t_value = /*text*/
      ctx2[32] + ""))
        set_data_maybe_contenteditable(t2, t_value, text_data["contenteditable"]);
      set_svg_attributes(text_1, text_data = get_spread_update(text_1_levels, [
        dirty[0] & /*baseProps, transforms, $displayTexts*/
        176 && {
          .../*baseProps*/
          ctx2[5],
          transform: (
            /*transforms*/
            ctx2[7][
              /*i*/
              ctx2[34]
            ]
          )
        },
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: "#333" },
        {
          "stroke-width": text_1_stroke_width_value
        },
        dirty[0] & /*$focused*/
        512 && text_1_visibility_value !== (text_1_visibility_value = /*$focused*/
        ctx2[9] ? "visible" : "hidden") && { visibility: text_1_visibility_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(text_1);
      }
    }
  };
}
function create_if_block_2$8(ctx2) {
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let each_1_anchor;
  let each_value = ensure_array_like(
    /*$displayTexts*/
    ctx2[4]
  );
  const get_key = (ctx3) => (
    /*i*/
    ctx3[34]
  );
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    let child_ctx = get_each_context$b(ctx2, each_value, i2);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i2] = create_each_block$b(key, child_ctx));
  }
  return {
    c() {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      each_1_anchor = empty();
    },
    m(target, anchor) {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(target, anchor);
        }
      }
      insert(target, each_1_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*baseProps, transforms, $displayTexts, $hovered*/
      180) {
        each_value = ensure_array_like(
          /*$displayTexts*/
          ctx3[4]
        );
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx3, each_value, each_1_lookup, each_1_anchor.parentNode, destroy_block, create_each_block$b, each_1_anchor, get_each_context$b);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(each_1_anchor);
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d(detaching);
      }
    }
  };
}
function create_each_block$b(key_1, ctx2) {
  let text_1;
  let t_value = (
    /*text*/
    ctx2[32] + ""
  );
  let t2;
  let text_1_stroke_width_value;
  let text_1_visibility_value;
  let text_1_levels = [
    {
      .../*baseProps*/
      ctx2[5],
      transform: (
        /*transforms*/
        ctx2[7][
          /*i*/
          ctx2[34]
        ]
      )
    },
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: "#333" },
    {
      "stroke-width": text_1_stroke_width_value = 1
    },
    {
      visibility: text_1_visibility_value = /*$hovered*/
      ctx2[2] ? "visible" : "hidden"
    }
  ];
  let text_data = {};
  for (let i2 = 0; i2 < text_1_levels.length; i2 += 1) {
    text_data = assign$1(text_data, text_1_levels[i2]);
  }
  return {
    key: key_1,
    first: null,
    c() {
      text_1 = svg_element("text");
      t2 = text(t_value);
      set_svg_attributes(text_1, text_data);
      this.first = text_1;
    },
    m(target, anchor) {
      insert(target, text_1, anchor);
      append$2(text_1, t2);
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (dirty[0] & /*$displayTexts*/
      16 && t_value !== (t_value = /*text*/
      ctx2[32] + ""))
        set_data_maybe_contenteditable(t2, t_value, text_data["contenteditable"]);
      set_svg_attributes(text_1, text_data = get_spread_update(text_1_levels, [
        dirty[0] & /*baseProps, transforms, $displayTexts*/
        176 && {
          .../*baseProps*/
          ctx2[5],
          transform: (
            /*transforms*/
            ctx2[7][
              /*i*/
              ctx2[34]
            ]
          )
        },
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: "#333" },
        {
          "stroke-width": text_1_stroke_width_value
        },
        dirty[0] & /*$hovered*/
        4 && text_1_visibility_value !== (text_1_visibility_value = /*$hovered*/
        ctx2[2] ? "visible" : "hidden") && { visibility: text_1_visibility_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(text_1);
      }
    }
  };
}
function create_fragment$K(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && /*$visible*/
    ctx2[8] && create_if_block$C(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (
        /*shapeInstance*/
        ctx3[0] && /*$visible*/
        ctx3[8]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$C(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$H($$self, $$props, $$invalidate) {
  let fillColor;
  let transforms;
  let _props;
  let $props;
  let $inactive;
  let $hovered;
  let $font;
  let $shapeProps;
  let $displayTexts;
  let $visible;
  let $focused;
  let { shapeInstance } = $$props;
  let { parentX = 0 } = $$props;
  let { parentY = 0 } = $$props;
  let { state = null } = $$props;
  const { focused, hovered, inactive, visible, props, shapeProps, displayTexts } = shapeInstance;
  component_subscribe($$self, focused, (value) => $$invalidate(9, $focused = value));
  component_subscribe($$self, hovered, (value) => $$invalidate(2, $hovered = value));
  component_subscribe($$self, inactive, (value) => $$invalidate(24, $inactive = value));
  component_subscribe($$self, visible, (value) => $$invalidate(8, $visible = value));
  component_subscribe($$self, props, (value) => $$invalidate(23, $props = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(3, $shapeProps = value));
  component_subscribe($$self, displayTexts, (value) => $$invalidate(4, $displayTexts = value));
  const instance2 = getInstance();
  const { chartWidth, chartHeight, font, ssr } = instance2;
  component_subscribe($$self, font, (value) => $$invalidate(25, $font = value));
  let baseProps;
  let dx;
  let dy;
  onMount(() => {
  });
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
    if ("parentX" in $$props2)
      $$invalidate(18, parentX = $$props2.parentX);
    if ("parentY" in $$props2)
      $$invalidate(19, parentY = $$props2.parentY);
    if ("state" in $$props2)
      $$invalidate(1, state = $$props2.state);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$shapeProps*/
    8) {
      $$invalidate(22, fillColor = (() => {
        const backgroundColor = $shapeProps.backgroundColor || "#fff";
        if (chroma.valid(backgroundColor)) {
          return chroma(backgroundColor).luminance() < 0.5 ? "#fff" : "#333";
        }
        return "#333";
      })());
    }
    if ($$self.$$.dirty[0] & /*$shapeProps*/
    8) {
      (() => {
        const backgroundColor = $shapeProps.backgroundColor || "#fff";
        if (chroma.valid(backgroundColor)) {
          return chroma(backgroundColor).luminance() < 0.5 ? "#333" : "#fff";
        }
        return "#fff";
      })();
    }
    if ($$self.$$.dirty[0] & /*$shapeProps, $displayTexts, shapeInstance, dx, dy*/
    3145753) {
      $$invalidate(7, transforms = (() => {
        const { x: x2 = 0, y: y2 = 0, rotation } = $shapeProps;
        return $displayTexts.map((text2, i2) => {
          const startPoint = shapeInstance.getStartPoint(text2, i2, $displayTexts.length);
          $$invalidate(20, dx = asValidNumber(startPoint.x));
          $$invalidate(21, dy = asValidNumber(startPoint.y));
          let transform = "";
          if (isValidNumber(x2) && isValidNumber(y2)) {
            transform += ` translate(${x2 + dx},${y2 + dy})`;
          }
          if (rotation != null && rotation !== 0) {
            transform += ` rotate(${rotation})`;
          }
          return transform;
        });
      })());
    }
    if ($$self.$$.dirty[0] & /*$shapeProps, state, shapeInstance, $font, fillColor, $hovered, $inactive*/
    54525967) {
      {
        try {
          const { fontSize, fontFamily, width, height, overflow, link } = $shapeProps;
          let shown = true;
          if (state == null) {
            shapeInstance.setVisible(shown);
          }
          $$invalidate(5, baseProps = {
            "text-anchor": "start",
            // 'dominant-baseline': 'central',
            "dominant-baseline": "auto",
            "font-size": `${fontSize}px`,
            "font-family": fontFamily || $font.family,
            fill: fillColor,
            visibility: shown ? "" : "hidden",
            ...link && $hovered ? { "text-decoration": "underline" } : {},
            ...$inactive ? { opacity: 0.2 } : {}
          });
        } catch (e3) {
          console.log(e3);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$props*/
    8388608) {
      $$invalidate(6, _props = (() => {
        const p2 = { ...$props };
        Object.keys(p2).forEach((key) => {
          if (p2[key] === void 0) {
            delete p2[key];
          }
        });
        return p2;
      })());
    }
  };
  return [
    shapeInstance,
    state,
    $hovered,
    $shapeProps,
    $displayTexts,
    baseProps,
    _props,
    transforms,
    $visible,
    $focused,
    focused,
    hovered,
    inactive,
    visible,
    props,
    shapeProps,
    displayTexts,
    font,
    parentX,
    parentY,
    dx,
    dy,
    fillColor,
    $props,
    $inactive,
    $font
  ];
}
let Component$a = class Component3 extends SvelteComponent {
  constructor(options) {
    super();
    init(
      this,
      options,
      instance_1$H,
      create_fragment$K,
      safe_not_equal,
      {
        shapeInstance: 0,
        parentX: 18,
        parentY: 19,
        state: 1
      },
      null,
      [-1, -1]
    );
  }
};
const lineHeight = 1.2;
const indent = 0.1;
function calcRad(r2, dx, dy) {
  let rad = Math.acos(dx / r2);
  if (dy < 0) {
    return normalizeRad(-rad);
  }
  return rad;
}
class BoxTextShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "text");
    __publicField(this, "shapeProps", writable({
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      text: "",
      fontSize: 12,
      fontFamily: DEFAULT_FONT_FAMILY,
      textAlign: "center",
      textBaseline: "middle",
      padding: 4,
      backgroundColor: null,
      rotation: 0,
      overflow: "hidden",
      link: null,
      border: null
    }));
    __publicField(this, "props");
    __publicField(this, "component", Component$a);
    __publicField(this, "hoveredComponent", Component$a);
    __publicField(this, "focusedComponent", Component$a);
    __publicField(this, "displayTexts", writable([]));
    // 物理的に見えている状態かどうか
    __publicField(this, "isVisible", false);
    __publicField(this, "textAlignMap", textAlignMap);
    __publicField(this, "textBaselineMap", textBaselineMap);
    this.shapeProps.update((shapeProps) => {
      const props = {
        ...shapeProps,
        ...option,
        fontFamily: option.fontFamily || shapeProps.fontFamily || DEFAULT_FONT_FAMILY
      };
      props.text = String(props.text || "").replace(/(\r\n|\n|\r)/g, " ").replace(/\s+/g, " ").trim();
      return props;
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
    this.shapeProps.subscribe(() => {
      this.apply();
      this.displayTexts.set(this.getDisplayTexts());
    });
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
  setVisible(visible) {
    this.isVisible = visible;
  }
  getDisplayTexts() {
    const { text: text2, width, height, overflow, padding: padding2 } = this.$shapeProps;
    const rect = this.measureText(text2);
    const textWidth = rect.width + padding2 * 2;
    const textHeight = rect.height + padding2 * 2;
    if (overflow === "hidden") {
      if (textWidth > width || textHeight > height) {
        return [];
      }
      return [text2];
    }
    if (overflow === "ellipsis") {
      if (width != null && textWidth > width || height != null && textHeight > height) {
        let i2 = text2.length + 1;
        while (i2--) {
          const t2 = text2.substring(0, i2);
          const dt = `${t2}...`;
          const rect2 = this.measureText(dt);
          const textWidth2 = rect2.width + padding2 * 2;
          const textHeight2 = rect2.height + padding2 * 2;
          if ((width == null || textWidth2 < width) && (height == null || textHeight2 < height)) {
            return [dt];
          }
        }
        return [];
      }
      return [text2];
    }
    if (overflow === "break") {
      if (width != null && textWidth > width || height != null && textHeight > height) {
        const texts = [];
        let start = 0;
        let rows = 0;
        let i2 = text2.length + 1;
        while (i2--) {
          const t2 = text2.substring(start, start + i2);
          const rect2 = this.measureText(t2);
          const textWidth2 = rect2.width + padding2 * 2;
          const textHeight2 = rect2.height;
          if (t2.length > 0 && width != null && textWidth2 < width) {
            rows += 1;
            if (height != null && height < textHeight2 * rows + padding2 * 2) {
              break;
            }
            texts.push(t2);
            start = start + i2;
            i2 = text2.length - start + 1;
          }
        }
        return texts;
      }
      return [text2];
    }
    return [text2];
  }
  getStartPoint(text2, index2, length2) {
    const {
      x: x2,
      y: y2,
      padding: padding2,
      fontSize,
      fontFamily,
      rotation,
      textAlign,
      textBaseline
    } = this.$shapeProps;
    const {
      width,
      height,
      actualBoundingBoxAscent,
      actualBoundingBoxDescent
    } = getTextSize(text2, fontSize, fontFamily);
    const rad = rotation * (Math.PI / 180);
    let left = 0;
    let top = 0;
    let shapeWidth = width + padding2 * 2;
    left = x2 + padding2;
    if (textAlign == "left") {
      left += 0;
    } else if (textAlign == "center") {
      left += this.$shapeProps.width / 2;
    } else if (textAlign == "right") {
      left += this.$shapeProps.width;
    }
    if (textAlign == "left") {
      left -= 0;
    } else if (textAlign == "center") {
      left -= shapeWidth / 2;
    } else if (textAlign == "right") {
      left -= shapeWidth;
    }
    const textHeight = height * lineHeight;
    const topIndent = height * indent;
    let shapeHeight = textHeight * length2 + padding2 * 2;
    top = y2 + index2 * textHeight + topIndent + padding2;
    if (textBaseline === "top") {
      top += 0;
    } else if (textBaseline === "middle") {
      top += this.$shapeProps.height / 2;
    } else if (textBaseline === "bottom") {
      top += this.$shapeProps.height;
    }
    if (textBaseline === "top") {
      top -= 0;
    } else if (textBaseline === "middle") {
      top -= shapeHeight / 2;
    } else if (textBaseline === "bottom") {
      top -= shapeHeight;
    }
    const point2 = { x: left, y: top + actualBoundingBoxAscent };
    const dx = point2.x - x2;
    const dy = point2.y - y2;
    const r2 = Math.max(1e-4, Math.sqrt(dx * dx + dy * dy));
    const rad2 = calcRad(r2, dx, dy);
    point2.x = r2 * Math.cos(rad + rad2);
    point2.y = r2 * Math.sin(rad + rad2);
    return point2;
  }
  measureText(text2) {
    const {
      fontSize,
      fontFamily,
      x: x2,
      y: y2,
      textAlign,
      textBaseline,
      rotation
    } = this.$shapeProps;
    const { width, height: _height } = getTextSize(
      text2,
      fontSize,
      fontFamily
    );
    const height = _height * lineHeight;
    const rad = rotation * (Math.PI / 180);
    const rect = new BoundingRect();
    rect.width = width;
    rect.height = height;
    if (textAlign === "left") {
      rect.x = x2;
    } else if (textAlign === "center") {
      rect.x = x2 - width / 2;
    } else if (textAlign === "right") {
      rect.x = x2 - width;
    }
    if (textBaseline === "top") {
      rect.y = y2;
    } else if (textBaseline === "middle") {
      rect.y = y2 - height / 2;
    } else if (textBaseline === "bottom") {
      rect.y = y2 - height;
    }
    const points = [];
    points.push(new Point$1({ x: rect.x, y: rect.y }));
    points.push(new Point$1({ x: rect.x + rect.width, y: rect.y }));
    points.push(new Point$1({ x: rect.x, y: rect.y + rect.height }));
    points.push(
      new Point$1({ x: rect.x + rect.width, y: rect.y + rect.height })
    );
    for (let i2 = 0; i2 < points.length; i2++) {
      const dx = points[i2].x - x2;
      const dy = points[i2].y - y2;
      const r2 = Math.max(1e-4, Math.sqrt(dx * dx + dy * dy));
      const rad2 = calcRad(r2, dx, dy);
      points[i2].x = x2 + r2 * Math.cos(rad + rad2);
      points[i2].y = y2 + r2 * Math.sin(rad + rad2);
    }
    let left = 0;
    let right = 0;
    let top = 0;
    let bottom = 0;
    for (let j = 0; j < points.length; j++) {
      const point2 = points[j];
      if (j == 0) {
        left = point2.x;
        right = point2.x;
        top = point2.y;
        bottom = point2.y;
      } else {
        left = Math.min(left, point2.x);
        top = Math.min(top, point2.y);
        right = Math.max(right, point2.x);
        bottom = Math.max(bottom, point2.y);
      }
    }
    rect.x = left;
    rect.y = top;
    rect.width = right - left;
    rect.height = bottom - top;
    return rect;
  }
  _getBoundingRect() {
    const { x: x2, y: y2, width, height } = this.$shapeProps;
    const visible = get_store_value(this.visible);
    const rect = new BoundingRect();
    rect.x = x2;
    rect.y = y2;
    rect.width = width;
    rect.height = height;
    rect.visible = visible;
    return rect;
  }
  _contain(x2, y2) {
    if (!get_store_value(this.visible)) {
      return false;
    }
    const rect = this.getBoundingRect();
    if (x2 >= rect.x && x2 <= rect.x + rect.width && y2 >= rect.y && y2 <= rect.y + rect.height) {
      return true;
    }
    return false;
  }
  intersect(rect) {
    return this.getBoundingRect().intersect(rect);
  }
}
function create_if_block$B(ctx2) {
  let if_block_anchor;
  function select_block_type(ctx3, dirty) {
    if (
      /*state*/
      ctx3[1] === "hover"
    )
      return create_if_block_1$d;
    if (
      /*state*/
      ctx3[1] === "focus"
    )
      return create_if_block_2$7;
    return create_else_block$b;
  }
  let current_block_type = select_block_type(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (current_block_type === (current_block_type = select_block_type(ctx3)) && if_block) {
        if_block.p(ctx3, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx3);
        if (if_block) {
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if_block.d(detaching);
    }
  };
}
function create_else_block$b(ctx2) {
  let circle0;
  let circle1;
  let circle1_stroke_width_value;
  let circle0_levels = [
    {
      .../*$props*/
      ctx2[7],
      .../*baseProps*/
      ctx2[4]
    }
  ];
  let circle_data_1 = {};
  for (let i2 = 0; i2 < circle0_levels.length; i2 += 1) {
    circle_data_1 = assign$1(circle_data_1, circle0_levels[i2]);
  }
  let circle1_levels = [
    {
      .../*$props*/
      ctx2[7],
      .../*baseProps*/
      ctx2[4]
    },
    { stroke: "#fff" },
    {
      "stroke-width": circle1_stroke_width_value = /*$shapeProps*/
      ctx2[3].padding
    },
    { fill: "none" }
  ];
  let circle_data = {};
  for (let i2 = 0; i2 < circle1_levels.length; i2 += 1) {
    circle_data = assign$1(circle_data, circle1_levels[i2]);
  }
  return {
    c() {
      circle0 = svg_element("circle");
      circle1 = svg_element("circle");
      set_svg_attributes(circle0, circle_data_1);
      set_svg_attributes(circle1, circle_data);
    },
    m(target, anchor) {
      insert(target, circle0, anchor);
      insert(target, circle1, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(circle0, circle_data_1 = get_spread_update(circle0_levels, [
        dirty & /*$props, baseProps*/
        144 && {
          .../*$props*/
          ctx3[7],
          .../*baseProps*/
          ctx3[4]
        }
      ]));
      set_svg_attributes(circle1, circle_data = get_spread_update(circle1_levels, [
        dirty & /*$props, baseProps*/
        144 && {
          .../*$props*/
          ctx3[7],
          .../*baseProps*/
          ctx3[4]
        },
        { stroke: "#fff" },
        dirty & /*$shapeProps*/
        8 && circle1_stroke_width_value !== (circle1_stroke_width_value = /*$shapeProps*/
        ctx3[3].padding) && {
          "stroke-width": circle1_stroke_width_value
        },
        { fill: "none" }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(circle0);
        detach(circle1);
      }
    }
  };
}
function create_if_block_2$7(ctx2) {
  let circle;
  let circle_stroke_width_value;
  let circle_visibility_value;
  let circle_levels = [
    { .../*baseProps*/
    ctx2[4] },
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: "#333" },
    {
      "stroke-width": circle_stroke_width_value = 2
    },
    {
      visibility: circle_visibility_value = /*$focused*/
      ctx2[6] ? "visible" : "hidden"
    }
  ];
  let circle_data = {};
  for (let i2 = 0; i2 < circle_levels.length; i2 += 1) {
    circle_data = assign$1(circle_data, circle_levels[i2]);
  }
  return {
    c() {
      circle = svg_element("circle");
      set_svg_attributes(circle, circle_data);
    },
    m(target, anchor) {
      insert(target, circle, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(circle, circle_data = get_spread_update(circle_levels, [
        dirty & /*baseProps*/
        16 && { .../*baseProps*/
        ctx3[4] },
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: "#333" },
        {
          "stroke-width": circle_stroke_width_value
        },
        dirty & /*$focused*/
        64 && circle_visibility_value !== (circle_visibility_value = /*$focused*/
        ctx3[6] ? "visible" : "hidden") && { visibility: circle_visibility_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(circle);
      }
    }
  };
}
function create_if_block_1$d(ctx2) {
  let circle;
  let circle_stroke_width_value;
  let circle_visibility_value;
  let circle_levels = [
    { .../*baseProps*/
    ctx2[4] },
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: "#333" },
    {
      "stroke-width": circle_stroke_width_value = 1
    },
    {
      visibility: circle_visibility_value = /*$hovered*/
      ctx2[5] ? "visible" : "hidden"
    }
  ];
  let circle_data = {};
  for (let i2 = 0; i2 < circle_levels.length; i2 += 1) {
    circle_data = assign$1(circle_data, circle_levels[i2]);
  }
  return {
    c() {
      circle = svg_element("circle");
      set_svg_attributes(circle, circle_data);
    },
    m(target, anchor) {
      insert(target, circle, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(circle, circle_data = get_spread_update(circle_levels, [
        dirty & /*baseProps*/
        16 && { .../*baseProps*/
        ctx3[4] },
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: "#333" },
        {
          "stroke-width": circle_stroke_width_value
        },
        dirty & /*$hovered*/
        32 && circle_visibility_value !== (circle_visibility_value = /*$hovered*/
        ctx3[5] ? "visible" : "hidden") && { visibility: circle_visibility_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(circle);
      }
    }
  };
}
function create_fragment$J(ctx2) {
  let g;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && /*$visible*/
    ctx2[2] && create_if_block$B(ctx2)
  );
  return {
    c() {
      g = svg_element("g");
      if (if_block)
        if_block.c();
      attr(g, "class", "circle");
    },
    m(target, anchor) {
      insert(target, g, anchor);
      if (if_block)
        if_block.m(g, null);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0] && /*$visible*/
        ctx3[2]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$B(ctx3);
          if_block.c();
          if_block.m(g, null);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(g);
      }
      if (if_block)
        if_block.d();
    }
  };
}
function instance$r($$self, $$props, $$invalidate) {
  let baseProps;
  let $inactive;
  let $visible;
  let $shapeProps;
  let $hovered;
  let $focused;
  let $props;
  let { shapeInstance } = $$props;
  let { state = null } = $$props;
  const { inactive, shapeProps, props, visible, focused, hovered } = shapeInstance;
  component_subscribe($$self, inactive, (value) => $$invalidate(14, $inactive = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(3, $shapeProps = value));
  component_subscribe($$self, props, (value) => $$invalidate(7, $props = value));
  component_subscribe($$self, visible, (value) => $$invalidate(2, $visible = value));
  component_subscribe($$self, focused, (value) => $$invalidate(6, $focused = value));
  component_subscribe($$self, hovered, (value) => $$invalidate(5, $hovered = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
    if ("state" in $$props2)
      $$invalidate(1, state = $$props2.state);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$shapeProps, $visible, $inactive*/
    16396) {
      $$invalidate(4, baseProps = (() => {
        const { cx, cy, r: r2, padding: padding2 } = $shapeProps;
        return {
          cx: asValidNumber(cx),
          cy: asValidNumber(cy),
          r: asValidNumber(r2 - padding2, false),
          visibility: $visible ? "" : "hidden",
          ...$inactive ? { opacity: 0.2 } : {}
        };
      })());
    }
  };
  return [
    shapeInstance,
    state,
    $visible,
    $shapeProps,
    baseProps,
    $hovered,
    $focused,
    $props,
    inactive,
    shapeProps,
    props,
    visible,
    focused,
    hovered,
    $inactive
  ];
}
let Component$9 = class Component4 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$r, create_fragment$J, safe_not_equal, { shapeInstance: 0, state: 1 });
  }
};
class CircleShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "circle");
    __publicField(this, "shapeProps", writable({
      cx: 0,
      cy: 0,
      r: 0,
      padding: 0
    }));
    __publicField(this, "props");
    __publicField(this, "component", Component$9);
    __publicField(this, "hoveredComponent", Component$9);
    __publicField(this, "focusedComponent", Component$9);
    this.shapeProps.update((shapeProps) => {
      return {
        ...shapeProps,
        ...option
      };
    });
    this.shapeProps.subscribe(() => {
      this.apply();
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
  _getBoundingRect() {
    const { cx, cy, r: r2 } = this.$shapeProps;
    const rect = new BoundingRect();
    rect.visible = get_store_value(this.visible);
    rect.x = cx - r2;
    rect.y = cy - r2;
    rect.width = r2 * 2;
    rect.height = r2 * 2;
    return rect;
  }
  _contain(x2, y2) {
    if (!get_store_value(this.visible)) {
      return false;
    }
    const { cx, cy, r: r2 } = this.$shapeProps;
    const dx = x2 - cx;
    const dy = y2 - cy;
    const d = Math.sqrt(dx * dx + dy * dy);
    return d < r2;
  }
}
const SMALL$2 = 1e-10;
function intersectionArea(circles, stats) {
  const intersectionPoints = getIntersectionPoints(circles);
  const innerPoints = intersectionPoints.filter(
    (p2) => containedInCircles(p2, circles)
  );
  let arcArea = 0;
  let polygonArea = 0;
  const arcs = [];
  let i2;
  if (innerPoints.length > 1) {
    const center = getCenter(innerPoints);
    for (i2 = 0; i2 < innerPoints.length; ++i2) {
      const p3 = innerPoints[i2];
      p3.angle = Math.atan2(p3.x - center.x, p3.y - center.y);
    }
    innerPoints.sort((a2, b) => b.angle - a2.angle);
    let p2 = innerPoints[innerPoints.length - 1];
    for (i2 = 0; i2 < innerPoints.length; ++i2) {
      const p1 = innerPoints[i2];
      polygonArea += (p2.x + p1.x) * (p1.y - p2.y);
      const midPoint = {
        x: (p1.x + p2.x) / 2,
        y: (p1.y + p2.y) / 2
      };
      let arc2 = null;
      for (let j = 0; j < p1.parentIndex.length; ++j) {
        if (p2.parentIndex.indexOf(p1.parentIndex[j]) > -1) {
          const circle = circles[p1.parentIndex[j]];
          const a1 = Math.atan2(p1.x - circle.x, p1.y - circle.y);
          const a2 = Math.atan2(p2.x - circle.x, p2.y - circle.y);
          let angleDiff = a2 - a1;
          if (angleDiff < 0) {
            angleDiff += 2 * Math.PI;
          }
          const a3 = a2 - angleDiff / 2;
          let width = distance(midPoint, {
            x: circle.x + circle.radius * Math.sin(a3),
            y: circle.y + circle.radius * Math.cos(a3)
          });
          if (width > circle.radius * 2) {
            width = circle.radius * 2;
          }
          if (arc2 === null || arc2.width > width) {
            arc2 = {
              circle,
              width,
              p1,
              p2
            };
          }
        }
      }
      if (arc2 !== null) {
        arcs.push(arc2);
        arcArea += circleArea(arc2.circle.radius, arc2.width);
        p2 = p1;
      }
    }
  } else {
    let smallest = circles[0];
    for (i2 = 1; i2 < circles.length; ++i2) {
      if (circles[i2].radius < smallest.radius) {
        smallest = circles[i2];
      }
    }
    let disjoint = false;
    for (i2 = 0; i2 < circles.length; ++i2) {
      if (distance(circles[i2], smallest) >= Math.abs(smallest.radius - circles[i2].radius) + SMALL$2) {
        disjoint = true;
        break;
      }
    }
    if (disjoint) {
      arcArea = polygonArea = 0;
    } else {
      arcArea = smallest.radius * smallest.radius * Math.PI;
      arcs.push({
        circle: smallest,
        p1: { x: smallest.x, y: smallest.y + smallest.radius },
        p2: { x: smallest.x - SMALL$2, y: smallest.y + smallest.radius },
        width: smallest.radius * 2
      });
    }
  }
  polygonArea /= 2;
  if (stats) {
    stats.area = arcArea + polygonArea;
    stats.arcArea = arcArea;
    stats.polygonArea = polygonArea;
    stats.arcs = arcs;
    stats.innerPoints = innerPoints;
    stats.intersectionPoints = intersectionPoints;
  }
  return arcArea + polygonArea;
}
function containedInCircles(point2, circles) {
  for (let i2 = 0; i2 < circles.length; ++i2) {
    if (distance(point2, circles[i2]) >= circles[i2].radius + SMALL$2) {
      return false;
    }
  }
  return true;
}
function getIntersectionPoints(circles) {
  const ret = [];
  for (let i2 = 0; i2 < circles.length; ++i2) {
    for (let j = i2 + 1; j < circles.length; ++j) {
      const intersect2 = circleCircleIntersection(circles[i2], circles[j]);
      for (let k = 0; k < intersect2.length; ++k) {
        const p2 = intersect2[k];
        p2.parentIndex = [i2, j];
        ret.push(p2);
      }
    }
  }
  return ret;
}
function circleArea(r2, width) {
  return r2 * r2 * Math.acos(1 - width / r2) - (r2 - width) * sqrt$1(width * (2 * r2 - width));
}
function distance(p1, p2) {
  return sqrt$1((p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y));
}
function circleCircleIntersection(p1, p2) {
  const d = distance(p1, p2);
  const r1 = p1.radius;
  const r2 = p2.radius;
  if (d >= r1 + r2 + SMALL$2 || d <= Math.abs(r1 - r2) + SMALL$2) {
    return [];
  }
  const a2 = (r1 * r1 - r2 * r2 + d * d) / (2 * d);
  const h2 = sqrt$1(r1 * r1 - a2 * a2);
  const x0 = p1.x + a2 * (p2.x - p1.x) / d;
  const y0 = p1.y + a2 * (p2.y - p1.y) / d;
  const rx = -(p2.y - p1.y) * (h2 / d);
  const ry = -(p2.x - p1.x) * (h2 / d);
  return [
    { x: x0 + rx, y: y0 - ry },
    { x: x0 - rx, y: y0 + ry }
  ];
}
function getCenter(points) {
  const center = { x: 0, y: 0 };
  for (let i2 = 0; i2 < points.length; ++i2) {
    center.x += points[i2].x;
    center.y += points[i2].y;
  }
  center.x /= points.length;
  center.y /= points.length;
  return center;
}
function circlePath(x2, y2, r2) {
  const ret = [];
  ret.push("\nM", x2, y2);
  ret.push("\nm", -r2, 0);
  ret.push("\na", r2, r2, 0, 1, 0, r2 * 2, 0);
  ret.push("\na", r2, r2, 0, 1, 0, -r2 * 2, 0);
  return ret.join(" ");
}
function intersectionAreaPath(circles) {
  const stats = {};
  intersectionArea(circles, stats);
  const { arcs } = stats;
  if (arcs.length === 0) {
    return "M 0 0";
  }
  if (arcs.length == 1) {
    const { circle } = arcs[0];
    return circlePath(circle.x, circle.y, circle.radius);
  }
  const ret = ["\nM", arcs[0].p2.x, arcs[0].p2.y];
  for (let i2 = 0; i2 < arcs.length; ++i2) {
    const arc2 = arcs[i2];
    const r2 = arc2.circle.radius;
    const wide = arc2.width > r2;
    ret.push("\nA", r2, r2, 0, wide ? 1 : 0, 1, arc2.p1.x, arc2.p1.y);
  }
  return ret.join(" ");
}
function create_if_block$A(ctx2) {
  let t0;
  let path0;
  let t1;
  let path1;
  let path1_stroke_width_value;
  let if_block = !/*$inactive*/
  ctx2[1] && create_if_block_1$c(ctx2);
  let path0_levels = [
    {
      .../*baseProps*/
      ctx2[2],
      .../*$props*/
      ctx2[4]
    },
    { d: (
      /*$dpath*/
      ctx2[3]
    ) }
  ];
  let path_data_1 = {};
  for (let i2 = 0; i2 < path0_levels.length; i2 += 1) {
    path_data_1 = assign$1(path_data_1, path0_levels[i2]);
  }
  let path1_levels = [
    {
      .../*baseProps*/
      ctx2[2],
      .../*$props*/
      ctx2[4]
    },
    { d: (
      /*$dpathStroke*/
      ctx2[5]
    ) },
    { stroke: "#fff" },
    {
      "stroke-width": path1_stroke_width_value = /*$shapeProps*/
      ctx2[6].padding
    },
    { fill: "none" }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path1_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path1_levels[i2]);
  }
  return {
    c() {
      if (if_block)
        if_block.c();
      t0 = space();
      path0 = svg_element("path");
      t1 = space();
      path1 = svg_element("path");
      set_svg_attributes(path0, path_data_1);
      set_svg_attributes(path1, path_data);
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, t0, anchor);
      insert(target, path0, anchor);
      insert(target, t1, anchor);
      insert(target, path1, anchor);
    },
    p(ctx3, dirty) {
      if (!/*$inactive*/
      ctx3[1]) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block_1$c(ctx3);
          if_block.c();
          if_block.m(t0.parentNode, t0);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
      set_svg_attributes(path0, path_data_1 = get_spread_update(path0_levels, [
        dirty & /*baseProps, $props*/
        20 && {
          .../*baseProps*/
          ctx3[2],
          .../*$props*/
          ctx3[4]
        },
        dirty & /*$dpath*/
        8 && { d: (
          /*$dpath*/
          ctx3[3]
        ) }
      ]));
      set_svg_attributes(path1, path_data = get_spread_update(path1_levels, [
        dirty & /*baseProps, $props*/
        20 && {
          .../*baseProps*/
          ctx3[2],
          .../*$props*/
          ctx3[4]
        },
        dirty & /*$dpathStroke*/
        32 && { d: (
          /*$dpathStroke*/
          ctx3[5]
        ) },
        { stroke: "#fff" },
        dirty & /*$shapeProps*/
        64 && path1_stroke_width_value !== (path1_stroke_width_value = /*$shapeProps*/
        ctx3[6].padding) && { "stroke-width": path1_stroke_width_value },
        { fill: "none" }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(t0);
        detach(path0);
        detach(t1);
        detach(path1);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_if_block_1$c(ctx2) {
  let path;
  let path_levels = [{ .../*baseProps*/
  ctx2[2] }, { d: (
    /*$dpath*/
    ctx2[3]
  ) }, { fill: "#fff" }];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps*/
        4 && { .../*baseProps*/
        ctx3[2] },
        dirty & /*$dpath*/
        8 && { d: (
          /*$dpath*/
          ctx3[3]
        ) },
        { fill: "#fff" }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_fragment$I(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$A(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$A(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$q($$self, $$props, $$invalidate) {
  let baseProps;
  let $inactive;
  let $visible;
  let $dpath;
  let $props;
  let $dpathStroke;
  let $shapeProps;
  let { shapeInstance } = $$props;
  const { dpath, dpathStroke, shapeProps, visible, inactive, props } = shapeInstance;
  component_subscribe($$self, dpath, (value) => $$invalidate(3, $dpath = value));
  component_subscribe($$self, dpathStroke, (value) => $$invalidate(5, $dpathStroke = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(6, $shapeProps = value));
  component_subscribe($$self, visible, (value) => $$invalidate(13, $visible = value));
  component_subscribe($$self, inactive, (value) => $$invalidate(1, $inactive = value));
  component_subscribe($$self, props, (value) => $$invalidate(4, $props = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$visible, $inactive*/
    8194) {
      $$invalidate(2, baseProps = (() => {
        return {
          visibility: $visible ? "" : "hidden",
          ...$inactive ? { opacity: 0.2 } : {}
        };
      })());
    }
  };
  return [
    shapeInstance,
    $inactive,
    baseProps,
    $dpath,
    $props,
    $dpathStroke,
    $shapeProps,
    dpath,
    dpathStroke,
    shapeProps,
    visible,
    inactive,
    props,
    $visible
  ];
}
let Component$8 = class Component5 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$q, create_fragment$I, safe_not_equal, { shapeInstance: 0 });
  }
};
function create_if_block$z(ctx2) {
  let path;
  let path_stroke_value;
  let path_stroke_width_value;
  let path_levels = [
    { .../*baseProps*/
    ctx2[1] },
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: path_stroke_value = "#333" },
    {
      "stroke-width": path_stroke_width_value = 2
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps*/
        2 && { .../*baseProps*/
        ctx3[1] },
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: path_stroke_value },
        { "stroke-width": path_stroke_width_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_fragment$H(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$z(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$z(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$p($$self, $$props, $$invalidate) {
  let baseProps;
  let $focused;
  let $visible;
  let $dpath;
  let { shapeInstance } = $$props;
  const { dpath, visible, focused, inactive, props } = shapeInstance;
  component_subscribe($$self, dpath, (value) => $$invalidate(7, $dpath = value));
  component_subscribe($$self, visible, (value) => $$invalidate(6, $visible = value));
  component_subscribe($$self, focused, (value) => $$invalidate(5, $focused = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$dpath, $visible, $focused*/
    224) {
      $$invalidate(1, baseProps = (() => {
        return {
          d: $dpath,
          visibility: $visible && $focused ? "" : "hidden"
        };
      })());
    }
  };
  return [shapeInstance, baseProps, dpath, visible, focused, $focused, $visible, $dpath];
}
let Focused$2 = class Focused extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$p, create_fragment$H, safe_not_equal, { shapeInstance: 0 });
  }
};
function create_if_block$y(ctx2) {
  let path;
  let path_stroke_value;
  let path_stroke_width_value;
  let path_levels = [
    { .../*baseProps*/
    ctx2[1] },
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: path_stroke_value = "#333" },
    {
      "stroke-width": path_stroke_width_value = 1
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps*/
        2 && { .../*baseProps*/
        ctx3[1] },
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: path_stroke_value },
        { "stroke-width": path_stroke_width_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_fragment$G(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$y(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$y(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$o($$self, $$props, $$invalidate) {
  let baseProps;
  let $hovered;
  let $visible;
  let $dpath;
  let { shapeInstance } = $$props;
  const { dpath, visible, hovered, inactive, props } = shapeInstance;
  component_subscribe($$self, dpath, (value) => $$invalidate(7, $dpath = value));
  component_subscribe($$self, visible, (value) => $$invalidate(6, $visible = value));
  component_subscribe($$self, hovered, (value) => $$invalidate(5, $hovered = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$dpath, $visible, $hovered*/
    224) {
      $$invalidate(1, baseProps = (() => {
        return {
          d: $dpath,
          visibility: $visible && $hovered ? "" : "hidden"
        };
      })());
    }
  };
  return [shapeInstance, baseProps, dpath, visible, hovered, $hovered, $visible, $dpath];
}
let Hovered$2 = class Hovered extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$o, create_fragment$G, safe_not_equal, { shapeInstance: 0 });
  }
};
class CircleOverlapShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "circleOverlap");
    __publicField(this, "shapeProps", writable({
      padding: 2,
      circles: []
    }));
    __publicField(this, "props");
    __publicField(this, "component", Component$8);
    __publicField(this, "hoveredComponent", Hovered$2);
    __publicField(this, "focusedComponent", Focused$2);
    __publicField(this, "dpath");
    __publicField(this, "dpathStroke");
    this.shapeProps.update((shapeProps) => {
      return {
        ...shapeProps,
        ...option
      };
    });
    this.shapeProps.subscribe(() => {
      this.apply();
    });
    this.dpath = derived([this.shapeProps], ([$shapeProps]) => {
      const dpath = intersectionAreaPath(
        $shapeProps.circles.map((n2) => ({
          x: n2.$shapeProps.cx,
          y: n2.$shapeProps.cy,
          radius: n2.$shapeProps.r - $shapeProps.padding / 2
        }))
      );
      return dpath;
    });
    this.dpathStroke = derived([this.shapeProps], ([$shapeProps]) => {
      return intersectionAreaPath(
        $shapeProps.circles.map((n2) => ({
          x: n2.$shapeProps.cx,
          y: n2.$shapeProps.cy,
          radius: n2.$shapeProps.r
        }))
      );
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
  add(circle) {
    this.shapeProps.update((n2) => {
      return {
        ...n2,
        circles: [...n2.circles, circle]
      };
    });
  }
  clear() {
    this.shapeProps.update((n2) => {
      return {
        ...n2,
        circles: []
      };
    });
  }
  _contain(x2, y2) {
    return this.$shapeProps.circles.every((circle) => circle.contain(x2, y2));
  }
}
let strCounter = 1;
const id2str = {};
const str2id = {};
function getString(id2) {
  return id2str[id2];
}
function newString(str) {
  if (str2id[str]) {
    return str2id[str];
  }
  const strId = strCounter++;
  id2str[strId] = str;
  str2id[str] = strId;
  return strId;
}
let ctx;
const cache$1 = {};
function _measureText(str, font) {
  if (!ctx) {
    const { canvas: _canvas, ctx: _ctx } = getCanvas();
    ctx = _ctx;
  }
  if (!ctx) {
    throw new Error();
  }
  const key = `${str}.${font}`;
  ctx.font = font;
  if (!cache$1[key]) {
    const measure = ctx.measureText(str);
    cache$1[key] = measure;
  }
  return cache$1[key];
}
const consoleLog = (value) => console.log(value);
const measureText = (strId, fontSize, fontFamilyId) => {
  const str = getString(strId);
  const fontFamily = getString(fontFamilyId);
  return _measureText(str, `${fontSize}px ${fontFamily}`).width;
};
const measureHeight = (strId, fontSize, fontFamilyId) => {
  getString(strId);
  const fontFamily = getString(fontFamilyId);
  const measure = _measureText("国", `${fontSize}px ${fontFamily}`);
  return measure.actualBoundingBoxAscent + measure.actualBoundingBoxDescent;
};
const textSubstr = (strId, start, length2) => {
  var _a2;
  const str = (_a2 = getString(strId)) != null ? _a2 : "";
  return newString(str.substring(start, start + length2));
};
const textLength = (strId) => {
  var _a2;
  const str = (_a2 = getString(strId)) != null ? _a2 : "";
  return str.length;
};
const dotText = (strId) => {
  var _a2;
  const str = (_a2 = getString(strId)) != null ? _a2 : "";
  return newString(`${str}...`);
};
function get_each_context$a(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[10] = list[i2];
  return child_ctx;
}
function create_if_block$x(ctx2) {
  let g;
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let g_visibility_value;
  let current;
  let each_value = ensure_array_like(
    /*$shapeProps*/
    ctx2[3].children
  );
  const get_key = (ctx3) => (
    /*shape*/
    ctx3[10].id
  );
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    let child_ctx = get_each_context$a(ctx2, each_value, i2);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i2] = create_each_block$a(key, child_ctx));
  }
  let g_levels = [
    /*$props*/
    ctx2[5],
    { transform: (
      /*transform*/
      ctx2[4]
    ) },
    {
      visibility: g_visibility_value = /*$visible*/
      ctx2[6] ? "" : "hidden"
    }
  ];
  let g_data = {};
  for (let i2 = 0; i2 < g_levels.length; i2 += 1) {
    g_data = assign$1(g_data, g_levels[i2]);
  }
  return {
    c() {
      g = svg_element("g");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      set_svg_attributes(g, g_data);
    },
    m(target, anchor) {
      insert(target, g, anchor);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(g, null);
        }
      }
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty & /*$shapeProps, parentX, parentY*/
      14) {
        each_value = ensure_array_like(
          /*$shapeProps*/
          ctx3[3].children
        );
        group_outros();
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx3, each_value, each_1_lookup, g, outro_and_destroy_block, create_each_block$a, null, get_each_context$a);
        check_outros();
      }
      set_svg_attributes(g, g_data = get_spread_update(g_levels, [
        dirty & /*$props*/
        32 && /*$props*/
        ctx3[5],
        (!current || dirty & /*transform*/
        16) && { transform: (
          /*transform*/
          ctx3[4]
        ) },
        (!current || dirty & /*$visible*/
        64 && g_visibility_value !== (g_visibility_value = /*$visible*/
        ctx3[6] ? "" : "hidden")) && { visibility: g_visibility_value }
      ]));
    },
    i(local) {
      if (current)
        return;
      for (let i2 = 0; i2 < each_value.length; i2 += 1) {
        transition_in(each_blocks[i2]);
      }
      current = true;
    },
    o(local) {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        transition_out(each_blocks[i2]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(g);
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d();
      }
    }
  };
}
function create_each_block$a(key_1, ctx2) {
  let first;
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = asAny(
    /*shape*/
    ctx2[10].component
  );
  function switch_props(ctx3, dirty) {
    return {
      props: {
        shapeInstance: asAny(
          /*shape*/
          ctx3[10]
        ),
        parentX: (
          /*parentX*/
          ctx3[1] + /*$shapeProps*/
          ctx3[3].x
        ),
        parentY: (
          /*parentY*/
          ctx3[2] + /*$shapeProps*/
          ctx3[3].y
        )
      }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (dirty & /*$shapeProps*/
      8 && switch_value !== (switch_value = asAny(
        /*shape*/
        ctx2[10].component
      ))) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        const switch_instance_changes = {};
        if (dirty & /*$shapeProps*/
        8)
          switch_instance_changes.shapeInstance = asAny(
            /*shape*/
            ctx2[10]
          );
        if (dirty & /*parentX, $shapeProps*/
        10)
          switch_instance_changes.parentX = /*parentX*/
          ctx2[1] + /*$shapeProps*/
          ctx2[3].x;
        if (dirty & /*parentY, $shapeProps*/
        12)
          switch_instance_changes.parentY = /*parentY*/
          ctx2[2] + /*$shapeProps*/
          ctx2[3].y;
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(first);
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_fragment$F(ctx2) {
  let if_block_anchor;
  let current;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$x(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
          if (dirty & /*shapeInstance*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$x(ctx3);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$n($$self, $$props, $$invalidate) {
  let transform;
  let $shapeProps;
  let $props;
  let $visible;
  let { shapeInstance } = $$props;
  let { parentX = 0 } = $$props;
  let { parentY = 0 } = $$props;
  const { visible, shapeProps, props } = shapeInstance;
  component_subscribe($$self, visible, (value) => $$invalidate(6, $visible = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(3, $shapeProps = value));
  component_subscribe($$self, props, (value) => $$invalidate(5, $props = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
    if ("parentX" in $$props2)
      $$invalidate(1, parentX = $$props2.parentX);
    if ("parentY" in $$props2)
      $$invalidate(2, parentY = $$props2.parentY);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$shapeProps*/
    8) {
      $$invalidate(4, transform = (() => {
        if (isValidNumber($shapeProps.x) && isValidNumber($shapeProps.y)) {
          return `translate(${$shapeProps.x},${$shapeProps.y})`;
        }
        return "";
      })());
    }
  };
  return [
    shapeInstance,
    parentX,
    parentY,
    $shapeProps,
    transform,
    $props,
    $visible,
    visible,
    shapeProps,
    props
  ];
}
let Component$7 = class Component6 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$n, create_fragment$F, safe_not_equal, { shapeInstance: 0, parentX: 1, parentY: 2 });
  }
};
function get_each_context$9(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[9] = list[i2];
  return child_ctx;
}
function create_if_block$w(ctx2) {
  let g;
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let g_visibility_value;
  let current;
  let each_value = ensure_array_like(
    /*$shapeProps*/
    ctx2[3].children
  );
  const get_key = (ctx3) => (
    /*shape*/
    ctx3[9].id
  );
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    let child_ctx = get_each_context$9(ctx2, each_value, i2);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i2] = create_each_block$9(key, child_ctx));
  }
  return {
    c() {
      g = svg_element("g");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      attr(
        g,
        "transform",
        /*transform*/
        ctx2[4]
      );
      attr(g, "visibility", g_visibility_value = /*$visible*/
      ctx2[5] ? "" : "hidden");
    },
    m(target, anchor) {
      insert(target, g, anchor);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(g, null);
        }
      }
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty & /*$shapeProps, parentX, parentY*/
      14) {
        each_value = ensure_array_like(
          /*$shapeProps*/
          ctx3[3].children
        );
        group_outros();
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx3, each_value, each_1_lookup, g, outro_and_destroy_block, create_each_block$9, null, get_each_context$9);
        check_outros();
      }
      if (!current || dirty & /*transform*/
      16) {
        attr(
          g,
          "transform",
          /*transform*/
          ctx3[4]
        );
      }
      if (!current || dirty & /*$visible*/
      32 && g_visibility_value !== (g_visibility_value = /*$visible*/
      ctx3[5] ? "" : "hidden")) {
        attr(g, "visibility", g_visibility_value);
      }
    },
    i(local) {
      if (current)
        return;
      for (let i2 = 0; i2 < each_value.length; i2 += 1) {
        transition_in(each_blocks[i2]);
      }
      current = true;
    },
    o(local) {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        transition_out(each_blocks[i2]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(g);
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d();
      }
    }
  };
}
function create_if_block_1$b(ctx2) {
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = (
    /*shape*/
    ctx2[9].focusedComponent
  );
  function switch_props(ctx3, dirty) {
    return {
      props: {
        shapeInstance: asAny(
          /*shape*/
          ctx3[9]
        ),
        parentX: (
          /*parentX*/
          ctx3[1] + /*$shapeProps*/
          ctx3[3].x
        ),
        parentY: (
          /*parentY*/
          ctx3[2] + /*$shapeProps*/
          ctx3[3].y
        ),
        state: "focus"
      }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    c() {
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m(target, anchor) {
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty & /*$shapeProps*/
      8 && switch_value !== (switch_value = /*shape*/
      ctx3[9].focusedComponent)) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx3));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        const switch_instance_changes = {};
        if (dirty & /*$shapeProps*/
        8)
          switch_instance_changes.shapeInstance = asAny(
            /*shape*/
            ctx3[9]
          );
        if (dirty & /*parentX, $shapeProps*/
        10)
          switch_instance_changes.parentX = /*parentX*/
          ctx3[1] + /*$shapeProps*/
          ctx3[3].x;
        if (dirty & /*parentY, $shapeProps*/
        12)
          switch_instance_changes.parentY = /*parentY*/
          ctx3[2] + /*$shapeProps*/
          ctx3[3].y;
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_each_block$9(key_1, ctx2) {
  let first;
  let if_block_anchor;
  let current;
  let if_block = (
    /*shape*/
    ctx2[9].focusedComponent && create_if_block_1$b(ctx2)
  );
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (
        /*shape*/
        ctx2[9].focusedComponent
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*$shapeProps*/
          8) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_1$b(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(first);
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_fragment$E(ctx2) {
  let if_block_anchor;
  let current;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$w(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
          if (dirty & /*shapeInstance*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$w(ctx3);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$m($$self, $$props, $$invalidate) {
  let transform;
  let $shapeProps;
  let $visible;
  let { shapeInstance } = $$props;
  let { parentX = 0 } = $$props;
  let { parentY = 0 } = $$props;
  const { visible, shapeProps, props } = shapeInstance;
  component_subscribe($$self, visible, (value) => $$invalidate(5, $visible = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(3, $shapeProps = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
    if ("parentX" in $$props2)
      $$invalidate(1, parentX = $$props2.parentX);
    if ("parentY" in $$props2)
      $$invalidate(2, parentY = $$props2.parentY);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$shapeProps*/
    8) {
      $$invalidate(4, transform = (() => {
        if (isValidNumber($shapeProps.x) && isValidNumber($shapeProps.y)) {
          return `translate(${$shapeProps.x},${$shapeProps.y})`;
        }
        return "";
      })());
    }
  };
  return [
    shapeInstance,
    parentX,
    parentY,
    $shapeProps,
    transform,
    $visible,
    visible,
    shapeProps
  ];
}
let Focused$1 = class Focused2 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$m, create_fragment$E, safe_not_equal, { shapeInstance: 0, parentX: 1, parentY: 2 });
  }
};
function get_each_context$8(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[9] = list[i2];
  return child_ctx;
}
function create_if_block$v(ctx2) {
  let g;
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let g_visibility_value;
  let current;
  let each_value = ensure_array_like(
    /*$shapeProps*/
    ctx2[3].children
  );
  const get_key = (ctx3) => (
    /*shape*/
    ctx3[9].id
  );
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    let child_ctx = get_each_context$8(ctx2, each_value, i2);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i2] = create_each_block$8(key, child_ctx));
  }
  return {
    c() {
      g = svg_element("g");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      attr(
        g,
        "transform",
        /*transform*/
        ctx2[4]
      );
      attr(g, "visibility", g_visibility_value = /*$visible*/
      ctx2[5] ? "" : "hidden");
    },
    m(target, anchor) {
      insert(target, g, anchor);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(g, null);
        }
      }
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty & /*$shapeProps, parentX, parentY*/
      14) {
        each_value = ensure_array_like(
          /*$shapeProps*/
          ctx3[3].children
        );
        group_outros();
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx3, each_value, each_1_lookup, g, outro_and_destroy_block, create_each_block$8, null, get_each_context$8);
        check_outros();
      }
      if (!current || dirty & /*transform*/
      16) {
        attr(
          g,
          "transform",
          /*transform*/
          ctx3[4]
        );
      }
      if (!current || dirty & /*$visible*/
      32 && g_visibility_value !== (g_visibility_value = /*$visible*/
      ctx3[5] ? "" : "hidden")) {
        attr(g, "visibility", g_visibility_value);
      }
    },
    i(local) {
      if (current)
        return;
      for (let i2 = 0; i2 < each_value.length; i2 += 1) {
        transition_in(each_blocks[i2]);
      }
      current = true;
    },
    o(local) {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        transition_out(each_blocks[i2]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(g);
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d();
      }
    }
  };
}
function create_if_block_1$a(ctx2) {
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = (
    /*shape*/
    ctx2[9].hoveredComponent
  );
  function switch_props(ctx3, dirty) {
    return {
      props: {
        shapeInstance: asAny(
          /*shape*/
          ctx3[9]
        ),
        parentX: (
          /*parentX*/
          ctx3[1] + /*$shapeProps*/
          ctx3[3].x
        ),
        parentY: (
          /*parentY*/
          ctx3[2] + /*$shapeProps*/
          ctx3[3].y
        ),
        state: "hover"
      }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    c() {
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m(target, anchor) {
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty & /*$shapeProps*/
      8 && switch_value !== (switch_value = /*shape*/
      ctx3[9].hoveredComponent)) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx3));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        const switch_instance_changes = {};
        if (dirty & /*$shapeProps*/
        8)
          switch_instance_changes.shapeInstance = asAny(
            /*shape*/
            ctx3[9]
          );
        if (dirty & /*parentX, $shapeProps*/
        10)
          switch_instance_changes.parentX = /*parentX*/
          ctx3[1] + /*$shapeProps*/
          ctx3[3].x;
        if (dirty & /*parentY, $shapeProps*/
        12)
          switch_instance_changes.parentY = /*parentY*/
          ctx3[2] + /*$shapeProps*/
          ctx3[3].y;
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_each_block$8(key_1, ctx2) {
  let first;
  let if_block_anchor;
  let current;
  let if_block = (
    /*shape*/
    ctx2[9].hoveredComponent && create_if_block_1$a(ctx2)
  );
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (
        /*shape*/
        ctx2[9].hoveredComponent
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty & /*$shapeProps*/
          8) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_1$a(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(first);
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_fragment$D(ctx2) {
  let if_block_anchor;
  let current;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$v(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
          if (dirty & /*shapeInstance*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$v(ctx3);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$l($$self, $$props, $$invalidate) {
  let transform;
  let $shapeProps;
  let $visible;
  let { shapeInstance } = $$props;
  let { parentX = 0 } = $$props;
  let { parentY = 0 } = $$props;
  const { visible, shapeProps, props } = shapeInstance;
  component_subscribe($$self, visible, (value) => $$invalidate(5, $visible = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(3, $shapeProps = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
    if ("parentX" in $$props2)
      $$invalidate(1, parentX = $$props2.parentX);
    if ("parentY" in $$props2)
      $$invalidate(2, parentY = $$props2.parentY);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$shapeProps*/
    8) {
      $$invalidate(4, transform = (() => {
        if (isValidNumber($shapeProps.x) && isValidNumber($shapeProps.y)) {
          return `translate(${$shapeProps.x},${$shapeProps.y})`;
        }
        return "";
      })());
    }
  };
  return [
    shapeInstance,
    parentX,
    parentY,
    $shapeProps,
    transform,
    $visible,
    visible,
    shapeProps
  ];
}
let Hovered$1 = class Hovered2 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$l, create_fragment$D, safe_not_equal, { shapeInstance: 0, parentX: 1, parentY: 2 });
  }
};
const GroupShapeComponent = Component$7;
class GroupShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "group");
    __publicField(this, "shapeProps", writable({
      x: 0,
      y: 0,
      children: []
    }));
    __publicField(this, "props");
    __publicField(this, "component", GroupShapeComponent);
    __publicField(this, "hoveredComponent", Hovered$1);
    __publicField(this, "focusedComponent", Focused$1);
    this.shapeProps.update((shapeProps) => {
      return {
        ...shapeProps,
        ...option
      };
    });
    this.shapeProps.subscribe(() => {
      this.apply();
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
  add(shape) {
    this.shapeProps.update((n2) => {
      return {
        ...n2,
        children: [...n2.children, shape]
      };
    });
  }
  clear() {
    this.shapeProps.update((n2) => {
      return {
        ...n2,
        children: []
      };
    });
  }
  destroyChildren() {
    processShapes(this.$shapeProps.children, (shape) => {
      shape.destroy();
    });
  }
  _getBoundingRect() {
    const boundingRect = new BoundingRect();
    const { x: x2, y: y2, children: children2 } = this.$shapeProps;
    let left = 0;
    let right = 0;
    let top = 0;
    let bottom = 0;
    for (let i2 = 0; i2 < children2.length; i2++) {
      const child = children2[i2];
      const rect = child.getBoundingRect();
      left = Math.min(left, rect.x);
      top = Math.min(top, rect.y);
      right = Math.max(right, rect.x + rect.width);
      bottom = Math.max(bottom, rect.y + rect.height);
    }
    boundingRect.x = left + x2;
    boundingRect.y = top + y2;
    boundingRect.width = right - left;
    boundingRect.height = bottom - top;
    if (boundingRect.width < 0) {
      boundingRect.width = 0;
    }
    if (boundingRect.height < 0) {
      boundingRect.height = 0;
    }
    return boundingRect;
  }
}
function create_if_block$u(ctx2) {
  let image;
  let mounted;
  let dispose;
  let image_levels = [
    {
      .../*baseProps*/
      ctx2[1],
      .../*$props*/
      ctx2[2]
    }
  ];
  let image_data = {};
  for (let i2 = 0; i2 < image_levels.length; i2 += 1) {
    image_data = assign$1(image_data, image_levels[i2]);
  }
  return {
    c() {
      image = svg_element("image");
      set_svg_attributes(image, image_data);
    },
    m(target, anchor) {
      insert(target, image, anchor);
      if (!mounted) {
        dispose = listen(
          image,
          "error",
          /*error_handler*/
          ctx2[12]
        );
        mounted = true;
      }
    },
    p(ctx3, dirty) {
      set_svg_attributes(image, image_data = get_spread_update(image_levels, [
        dirty & /*baseProps, $props*/
        6 && {
          .../*baseProps*/
          ctx3[1],
          .../*$props*/
          ctx3[2]
        }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(image);
      }
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$C(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$u(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$u(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
const cache = {};
function fetchImage(url) {
  if (/^data:/.test(url)) {
    return new Promise((resolve) => resolve(url));
  }
  if (!cache[url]) {
    cache[url] = fetch(url).then(async (res) => {
      if (res.ok) {
        const blob = await res.blob();
        const ab = await blob.arrayBuffer();
        const type2 = blob.type;
        const buf = buffer.Buffer.from(ab);
        const base64 = buf.toString("base64");
        const dataUrl = `data:${type2};base64,${base64}`;
        return dataUrl;
      }
      throw new Error();
    });
  }
  return cache[url];
}
function instance_1$G($$self, $$props, $$invalidate) {
  let baseProps;
  let $inactive;
  let $visible;
  let $imageUrl;
  let $shapeProps;
  let $props;
  let { shapeInstance } = $$props;
  const { inactive, shapeProps, props, visible, instance: instance2 } = shapeInstance;
  component_subscribe($$self, inactive, (value) => $$invalidate(8, $inactive = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(11, $shapeProps = value));
  component_subscribe($$self, props, (value) => $$invalidate(2, $props = value));
  component_subscribe($$self, visible, (value) => $$invalidate(9, $visible = value));
  const imageUrl = writable(null);
  component_subscribe($$self, imageUrl, (value) => $$invalidate(10, $imageUrl = value));
  const counter = writable(0);
  const error_handler = (e3) => {
    imageUrl.set(null);
  };
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$shapeProps, shapeInstance*/
    2049) {
      (() => {
        const { image } = $shapeProps;
        counter.update((n2) => n2 + 1);
        const id2 = get_store_value(counter);
        const promise = (image instanceof Promise ? image : fetchImage(image)).then((dataUrl) => {
          if (get_store_value(counter) === id2) {
            imageUrl.set(dataUrl);
          }
        }).catch((e3) => {
          console.log(e3);
          if (get_store_value(counter) === id2) {
            imageUrl.set(null);
          }
        });
        shapeInstance.instance.promises.push(promise);
      })();
    }
    if ($$self.$$.dirty & /*$shapeProps, $imageUrl, $visible, $inactive*/
    3840) {
      $$invalidate(1, baseProps = (() => {
        const { x: x2, y: y2, width, height } = $shapeProps;
        return {
          x: asValidNumber(x2),
          y: asValidNumber(y2),
          width: asValidNumber(width, false),
          height: asValidNumber(height, false),
          href: $imageUrl || void 0,
          visibility: $visible ? void 0 : "hidden",
          ...$inactive ? { opacity: 0.2 } : {}
        };
      })());
    }
  };
  return [
    shapeInstance,
    baseProps,
    $props,
    inactive,
    shapeProps,
    props,
    visible,
    imageUrl,
    $inactive,
    $visible,
    $imageUrl,
    $shapeProps,
    error_handler
  ];
}
let Component$6 = class Component7 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$G, create_fragment$C, safe_not_equal, { shapeInstance: 0 });
  }
};
class ImageShape extends BaseShape {
  // hoveredComponent = Component;
  // focusedComponent = Component;
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "image");
    __publicField(this, "shapeProps", writable({
      x: 0,
      y: 0,
      image: "",
      width: 0,
      height: 0
    }));
    __publicField(this, "props");
    __publicField(this, "component", Component$6);
    this.shapeProps.update((shapeProps) => {
      return {
        ...shapeProps,
        ...option
      };
    });
    this.shapeProps.subscribe(() => {
      this.apply();
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
}
function create_if_block$t(ctx2) {
  let line2;
  let line_levels = [
    {
      .../*baseProps*/
      ctx2[1],
      .../*$props*/
      ctx2[2]
    }
  ];
  let line_data = {};
  for (let i2 = 0; i2 < line_levels.length; i2 += 1) {
    line_data = assign$1(line_data, line_levels[i2]);
  }
  return {
    c() {
      line2 = svg_element("line");
      set_svg_attributes(line2, line_data);
    },
    m(target, anchor) {
      insert(target, line2, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(line2, line_data = get_spread_update(line_levels, [
        dirty & /*baseProps, $props*/
        6 && {
          .../*baseProps*/
          ctx3[1],
          .../*$props*/
          ctx3[2]
        }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(line2);
      }
    }
  };
}
function create_fragment$B(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$t(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$t(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$k($$self, $$props, $$invalidate) {
  let baseProps;
  let $inactive;
  let $visible;
  let $shapeProps;
  let $props;
  let { shapeInstance } = $$props;
  const { shapeProps, props, visible, inactive } = shapeInstance;
  component_subscribe($$self, shapeProps, (value) => $$invalidate(9, $shapeProps = value));
  component_subscribe($$self, props, (value) => $$invalidate(2, $props = value));
  component_subscribe($$self, visible, (value) => $$invalidate(8, $visible = value));
  component_subscribe($$self, inactive, (value) => $$invalidate(7, $inactive = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$shapeProps, $visible, $inactive*/
    896) {
      $$invalidate(1, baseProps = (() => {
        const { x1, y1, x2, y2 } = $shapeProps;
        return {
          x1: asValidNumber(x1),
          x2: asValidNumber(x2),
          y1: asValidNumber(y1),
          y2: asValidNumber(y2),
          visibility: $visible ? "" : "hidden",
          ...$inactive ? { opacity: 0.2 } : {}
        };
      })());
    }
  };
  return [
    shapeInstance,
    baseProps,
    $props,
    shapeProps,
    props,
    visible,
    inactive,
    $inactive,
    $visible,
    $shapeProps
  ];
}
let Component$5 = class Component8 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$k, create_fragment$B, safe_not_equal, { shapeInstance: 0 });
  }
};
const LineShapeComponent = Component$5;
class LineShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "line");
    __publicField(this, "shapeProps", writable({
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 0
    }));
    __publicField(this, "props");
    __publicField(this, "component", LineShapeComponent);
    this.shapeProps.update((shapeProps) => {
      return {
        ...shapeProps,
        ...option
      };
    });
    this.shapeProps.subscribe(() => {
      this.apply();
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
}
function create_if_block$s(ctx2) {
  let if_block_anchor;
  function select_block_type(ctx3, dirty) {
    if (
      /*state*/
      ctx3[1] === "hover"
    )
      return create_if_block_1$9;
    if (
      /*state*/
      ctx3[1] === "focus"
    )
      return create_if_block_2$6;
    return create_else_block$a;
  }
  let current_block_type = select_block_type(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (current_block_type === (current_block_type = select_block_type(ctx3)) && if_block) {
        if_block.p(ctx3, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx3);
        if (if_block) {
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if_block.d(detaching);
    }
  };
}
function create_else_block$a(ctx2) {
  let path;
  let path_levels = [
    {
      .../*$props*/
      ctx2[5],
      .../*baseProps*/
      ctx2[2]
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*$props, baseProps*/
        36 && {
          .../*$props*/
          ctx3[5],
          .../*baseProps*/
          ctx3[2]
        }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_if_block_2$6(ctx2) {
  let path;
  let path_stroke_value;
  let path_stroke_width_value;
  let path_visibility_value;
  let path_levels = [
    /*baseProps*/
    ctx2[2],
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: path_stroke_value = "#333" },
    {
      "stroke-width": path_stroke_width_value = 2
    },
    {
      visibility: path_visibility_value = /*$focused*/
      ctx2[4] ? "" : "hidden"
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps*/
        4 && /*baseProps*/
        ctx3[2],
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: path_stroke_value },
        { "stroke-width": path_stroke_width_value },
        dirty & /*$focused*/
        16 && path_visibility_value !== (path_visibility_value = /*$focused*/
        ctx3[4] ? "" : "hidden") && { visibility: path_visibility_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_if_block_1$9(ctx2) {
  let path;
  let path_stroke_value;
  let path_stroke_width_value;
  let path_visibility_value;
  let path_levels = [
    /*baseProps*/
    ctx2[2],
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: path_stroke_value = "#333" },
    {
      "stroke-width": path_stroke_width_value = 1
    },
    {
      visibility: path_visibility_value = /*$hovered*/
      ctx2[3] ? "" : "hidden"
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps*/
        4 && /*baseProps*/
        ctx3[2],
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: path_stroke_value },
        { "stroke-width": path_stroke_width_value },
        dirty & /*$hovered*/
        8 && path_visibility_value !== (path_visibility_value = /*$hovered*/
        ctx3[3] ? "" : "hidden") && { visibility: path_visibility_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_fragment$A(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$s(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$s(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$j($$self, $$props, $$invalidate) {
  let baseProps;
  let $inactive;
  let $visible;
  let $dpath;
  let $hovered;
  let $focused;
  let $props;
  let { shapeInstance } = $$props;
  let { state = null } = $$props;
  const { focused, hovered, inactive, visible, props, dpath } = shapeInstance;
  component_subscribe($$self, focused, (value) => $$invalidate(4, $focused = value));
  component_subscribe($$self, hovered, (value) => $$invalidate(3, $hovered = value));
  component_subscribe($$self, inactive, (value) => $$invalidate(12, $inactive = value));
  component_subscribe($$self, visible, (value) => $$invalidate(13, $visible = value));
  component_subscribe($$self, props, (value) => $$invalidate(5, $props = value));
  component_subscribe($$self, dpath, (value) => $$invalidate(14, $dpath = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
    if ("state" in $$props2)
      $$invalidate(1, state = $$props2.state);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$dpath, $visible, $inactive*/
    28672) {
      $$invalidate(2, baseProps = (() => {
        return {
          d: $dpath,
          visibility: $visible ? "" : "hidden",
          ...$inactive ? { opacity: 0.2 } : {}
        };
      })());
    }
  };
  return [
    shapeInstance,
    state,
    baseProps,
    $hovered,
    $focused,
    $props,
    focused,
    hovered,
    inactive,
    visible,
    props,
    dpath,
    $inactive,
    $visible,
    $dpath
  ];
}
let Component$4 = class Component9 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$j, create_fragment$A, safe_not_equal, { shapeInstance: 0, state: 1 });
  }
};
const PolylineShapeComponent = Component$4;
class PolylineShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "polyline");
    __publicField(this, "shapeProps", writable({
      layout: "vertical",
      points: [],
      smooth: false
    }));
    __publicField(this, "props");
    __publicField(this, "component", Component$4);
    __publicField(this, "hoveredComponent", Component$4);
    __publicField(this, "focusedComponent", Component$4);
    __publicField(this, "dpath");
    this.shapeProps.update((shapeProps) => {
      return {
        ...shapeProps,
        ...option
      };
    });
    this.shapeProps.subscribe(() => {
      this.apply();
    });
    this.dpath = derived([this.shapeProps], ([$shapeProps]) => {
      const { layout, points, smooth } = $shapeProps;
      if (points.length === 0) {
        return "";
      }
      const l2 = layout === "vertical" ? line(
        (point2) => point2[0],
        (point2) => point2[1]
      ).defined(
        (point2) => isValidNumber(point2[0]) && isValidNumber(point2[1])
      ).curve(smooth ? monotoneX : curveLinear) : line(
        (point2) => point2[0],
        (point2) => point2[1]
      ).defined(
        (point2) => isValidNumber(point2[0]) && isValidNumber(point2[1])
      ).curve(smooth ? monotoneY : curveLinear);
      return l2(points) || "";
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
  _getBoundingRect() {
    const { points } = this.$shapeProps;
    const rect = new BoundingRect();
    rect.visible = get_store_value(this.visible);
    let left = 0;
    let right = 0;
    let top = 0;
    let bottom = 0;
    for (let i2 = 0; i2 < points.length; i2++) {
      const point2 = points[i2];
      if (i2 === 0) {
        left = point2[0];
        right = point2[0];
        top = point2[1];
        bottom = point2[1];
      }
      left = Math.min(left, point2[0]);
      top = Math.min(top, point2[1]);
      right = Math.max(right, point2[0]);
      bottom = Math.max(bottom, point2[1]);
    }
    rect.x = left;
    rect.y = top;
    rect.width = right - left;
    rect.height = bottom - top;
    return rect;
  }
  _contain(x2, y2) {
    if (!get_store_value(this.visible)) {
      return false;
    }
    const { points } = this.$shapeProps;
    const len = points.length;
    if (len < 3) {
      return false;
    }
    let counter = 0;
    let xInter;
    let p1 = points[0];
    for (let i2 = 1; i2 <= len; i2++) {
      const p2 = points[i2 % len];
      const minY = Math.min(p1[1], p2[1]);
      const maxY = Math.max(p1[1], p2[1]);
      const maxX = Math.max(p1[0], p2[0]);
      if (p1[1] !== p2[1] && minY < y2 && y2 <= maxY && x2 <= maxX) {
        xInter = (y2 - p1[1]) * (p2[0] - p1[0]) / (p2[1] - p1[1]) + p1[0];
        if (p1[0] === p2[0] || x2 <= xInter) {
          counter++;
        }
      }
      p1 = p2;
    }
    return counter % 2 === 1;
  }
}
function create_if_block$r(ctx2) {
  let rect;
  let rect_levels = [
    {
      .../*baseProps*/
      ctx2[1],
      .../*$props*/
      ctx2[2]
    }
  ];
  let rect_data = {};
  for (let i2 = 0; i2 < rect_levels.length; i2 += 1) {
    rect_data = assign$1(rect_data, rect_levels[i2]);
  }
  return {
    c() {
      rect = svg_element("rect");
      set_svg_attributes(rect, rect_data);
    },
    m(target, anchor) {
      insert(target, rect, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(rect, rect_data = get_spread_update(rect_levels, [
        dirty & /*baseProps, $props*/
        6 && {
          .../*baseProps*/
          ctx3[1],
          .../*$props*/
          ctx3[2]
        }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(rect);
      }
    }
  };
}
function create_fragment$z(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$r(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$r(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$i($$self, $$props, $$invalidate) {
  let baseProps;
  let $inactive;
  let $visible;
  let $shapeProps;
  let $props;
  let { shapeInstance } = $$props;
  const { inactive, shapeProps, props, visible } = shapeInstance;
  component_subscribe($$self, inactive, (value) => $$invalidate(7, $inactive = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(9, $shapeProps = value));
  component_subscribe($$self, props, (value) => $$invalidate(2, $props = value));
  component_subscribe($$self, visible, (value) => $$invalidate(8, $visible = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$shapeProps, $visible, $inactive*/
    896) {
      $$invalidate(1, baseProps = (() => {
        const { x: x2, y: y2, width, height, padding: padding2 } = $shapeProps;
        return {
          x: asValidNumber(x2 + padding2),
          y: asValidNumber(y2 + padding2),
          width: asValidNumber(width - padding2 * 2, false),
          height: asValidNumber(height - padding2 * 2, false),
          visibility: $visible ? "" : "hidden",
          ...$inactive ? { opacity: 0.2 } : {}
        };
      })());
    }
  };
  return [
    shapeInstance,
    baseProps,
    $props,
    inactive,
    shapeProps,
    props,
    visible,
    $inactive,
    $visible,
    $shapeProps
  ];
}
let Component$3 = class Component10 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$i, create_fragment$z, safe_not_equal, { shapeInstance: 0 });
  }
};
function create_if_block$q(ctx2) {
  let rect;
  let rect_stroke_value;
  let rect_stroke_width_value;
  let rect_levels = [
    /*baseProps*/
    ctx2[1],
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: rect_stroke_value = "#333" },
    {
      "stroke-width": rect_stroke_width_value = 2
    }
  ];
  let rect_data = {};
  for (let i2 = 0; i2 < rect_levels.length; i2 += 1) {
    rect_data = assign$1(rect_data, rect_levels[i2]);
  }
  return {
    c() {
      rect = svg_element("rect");
      set_svg_attributes(rect, rect_data);
    },
    m(target, anchor) {
      insert(target, rect, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(rect, rect_data = get_spread_update(rect_levels, [
        dirty & /*baseProps*/
        2 && /*baseProps*/
        ctx3[1],
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: rect_stroke_value },
        { "stroke-width": rect_stroke_width_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(rect);
      }
    }
  };
}
function create_fragment$y(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$q(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$q(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$F($$self, $$props, $$invalidate) {
  let baseProps;
  let $focused;
  let $visible;
  let $shapeProps;
  let { shapeInstance } = $$props;
  const { focused, shapeProps, props, visible } = shapeInstance;
  component_subscribe($$self, focused, (value) => $$invalidate(5, $focused = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(7, $shapeProps = value));
  component_subscribe($$self, visible, (value) => $$invalidate(6, $visible = value));
  getInstance();
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$shapeProps, $visible, $focused*/
    224) {
      $$invalidate(1, baseProps = (() => {
        const { x: x2, y: y2, width, height, padding: padding2 } = $shapeProps;
        return {
          x: asValidNumber(x2 + padding2),
          y: asValidNumber(y2 + padding2),
          width: asValidNumber(width - padding2 * 2, false),
          height: asValidNumber(height - padding2 * 2, false),
          visibility: $visible && $focused ? "" : "hidden"
        };
      })());
    }
  };
  return [
    shapeInstance,
    baseProps,
    focused,
    shapeProps,
    visible,
    $focused,
    $visible,
    $shapeProps
  ];
}
class Focused3 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$F, create_fragment$y, safe_not_equal, { shapeInstance: 0 });
  }
}
function create_if_block$p(ctx2) {
  let rect;
  let rect_stroke_value;
  let rect_stroke_width_value;
  let rect_levels = [
    /*baseProps*/
    ctx2[1],
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: rect_stroke_value = "#333" },
    {
      "stroke-width": rect_stroke_width_value = 1
    }
  ];
  let rect_data = {};
  for (let i2 = 0; i2 < rect_levels.length; i2 += 1) {
    rect_data = assign$1(rect_data, rect_levels[i2]);
  }
  return {
    c() {
      rect = svg_element("rect");
      set_svg_attributes(rect, rect_data);
    },
    m(target, anchor) {
      insert(target, rect, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(rect, rect_data = get_spread_update(rect_levels, [
        dirty & /*baseProps*/
        2 && /*baseProps*/
        ctx3[1],
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: rect_stroke_value },
        { "stroke-width": rect_stroke_width_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(rect);
      }
    }
  };
}
function create_fragment$x(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$p(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$p(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$E($$self, $$props, $$invalidate) {
  let baseProps;
  let $hovered;
  let $visible;
  let $shapeProps;
  let { shapeInstance } = $$props;
  const { hovered, shapeProps, props, visible } = shapeInstance;
  component_subscribe($$self, hovered, (value) => $$invalidate(5, $hovered = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(7, $shapeProps = value));
  component_subscribe($$self, visible, (value) => $$invalidate(6, $visible = value));
  getInstance();
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$shapeProps, $visible, $hovered*/
    224) {
      $$invalidate(1, baseProps = (() => {
        const { x: x2, y: y2, width, height, padding: padding2 } = $shapeProps;
        return {
          x: asValidNumber(x2 + padding2),
          y: asValidNumber(y2 + padding2),
          width: asValidNumber(width - padding2 * 2, false),
          height: asValidNumber(height - padding2 * 2, false),
          visibility: $visible && $hovered ? "" : "hidden"
        };
      })());
    }
  };
  return [
    shapeInstance,
    baseProps,
    hovered,
    shapeProps,
    visible,
    $hovered,
    $visible,
    $shapeProps
  ];
}
class Hovered3 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$E, create_fragment$x, safe_not_equal, { shapeInstance: 0 });
  }
}
class RectShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "rect");
    __publicField(this, "shapeProps", writable({
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      padding: 0
    }));
    __publicField(this, "props");
    __publicField(this, "component", Component$3);
    __publicField(this, "hoveredComponent", Hovered3);
    __publicField(this, "focusedComponent", Focused3);
    this.shapeProps.update((shapeProps) => {
      return {
        ...shapeProps,
        ...option
      };
    });
    this.shapeProps.subscribe(() => {
      this.apply();
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
  _getBoundingRect() {
    const { x: x2, y: y2, width, height } = this.$shapeProps;
    const visible = get_store_value(this.visible);
    const rect = new BoundingRect();
    rect.x = x2;
    rect.y = y2;
    rect.width = width;
    rect.height = height;
    rect.visible = visible;
    return rect;
  }
  _contain(x2, y2) {
    return this.getBoundingRect().contain(x2, y2);
  }
  intersect(boundingRect) {
    return this.getBoundingRect().intersect(boundingRect);
  }
}
function create_if_block$o(ctx2) {
  let if_block_anchor;
  function select_block_type(ctx3, dirty) {
    if (
      /*state*/
      ctx3[1] === "hover"
    )
      return create_if_block_1$8;
    if (
      /*state*/
      ctx3[1] === "focus"
    )
      return create_if_block_3;
    return create_else_block$9;
  }
  let current_block_type = select_block_type(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (current_block_type === (current_block_type = select_block_type(ctx3)) && if_block) {
        if_block.p(ctx3, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx3);
        if (if_block) {
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if_block.d(detaching);
    }
  };
}
function create_else_block$9(ctx2) {
  let path;
  let path_levels = [
    {
      .../*baseProps*/
      ctx2[3],
      .../*$props*/
      ctx2[6]
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps, $props*/
        72 && {
          .../*baseProps*/
          ctx3[3],
          .../*$props*/
          ctx3[6]
        }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_if_block_3(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*$focused*/
    ctx2[5] && create_if_block_4$1(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (
        /*$focused*/
        ctx3[5]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block_4$1(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_if_block_1$8(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*$hovered*/
    ctx2[4] && create_if_block_2$5(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (
        /*$hovered*/
        ctx3[4]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block_2$5(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_if_block_4$1(ctx2) {
  let path;
  let path_stroke_value;
  let path_stroke_width_value;
  let path_levels = [
    { .../*baseProps*/
    ctx2[3] },
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: path_stroke_value = "#333" },
    {
      "stroke-width": path_stroke_width_value = 2
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps*/
        8 && { .../*baseProps*/
        ctx3[3] },
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: path_stroke_value },
        { "stroke-width": path_stroke_width_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_if_block_2$5(ctx2) {
  let path;
  let path_stroke_value;
  let path_stroke_width_value;
  let path_levels = [
    { .../*baseProps*/
    ctx2[3] },
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: path_stroke_value = "#333" },
    {
      "stroke-width": path_stroke_width_value = 1
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      path = svg_element("path");
      set_svg_attributes(path, path_data);
    },
    m(target, anchor) {
      insert(target, path, anchor);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps*/
        8 && { .../*baseProps*/
        ctx3[3] },
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: path_stroke_value },
        { "stroke-width": path_stroke_width_value }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(path);
      }
    }
  };
}
function create_fragment$w(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && /*$visible*/
    ctx2[2] && create_if_block$o(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0] && /*$visible*/
        ctx3[2]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$o(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$h($$self, $$props, $$invalidate) {
  let baseProps;
  let $inactive;
  let $visible;
  let $shapeProps;
  let $hovered;
  let $focused;
  let $props;
  let { shapeInstance } = $$props;
  let { state = null } = $$props;
  const { inactive, shapeProps, props, visible, hovered, focused } = shapeInstance;
  component_subscribe($$self, inactive, (value) => $$invalidate(13, $inactive = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(14, $shapeProps = value));
  component_subscribe($$self, props, (value) => $$invalidate(6, $props = value));
  component_subscribe($$self, visible, (value) => $$invalidate(2, $visible = value));
  component_subscribe($$self, hovered, (value) => $$invalidate(4, $hovered = value));
  component_subscribe($$self, focused, (value) => $$invalidate(5, $focused = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
    if ("state" in $$props2)
      $$invalidate(1, state = $$props2.state);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$shapeProps, $visible, $inactive*/
    24580) {
      $$invalidate(3, baseProps = (() => {
        const { ax, ay, cx, cy, height } = $shapeProps;
        return {
          d: `
                M${ax},${ay}
                L${ax},${ay}
                C${ax + (cx - ax) / 2},${ay}
                ${ax + (cx - ax) / 2},${cy}
                ${cx},${cy}
                L${cx},${cy + height}
                C${ax + (cx - ax) / 2},${cy + height}
                ${ax + (cx - ax) / 2},${ay + height}
                ${ax},${ay + height}
                L${ax},${ay}
            `.replace(/\s+/g, " "),
          visibility: $visible ? "" : "hidden",
          ...$inactive ? { opacity: 0.2 } : {}
        };
      })());
    }
  };
  return [
    shapeInstance,
    state,
    $visible,
    baseProps,
    $hovered,
    $focused,
    $props,
    inactive,
    shapeProps,
    props,
    visible,
    hovered,
    focused,
    $inactive,
    $shapeProps
  ];
}
let Component$2 = class Component11 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$h, create_fragment$w, safe_not_equal, { shapeInstance: 0, state: 1 });
  }
};
function _mathPow(x2, y2) {
  let a2 = 1;
  if (y2 > 0) {
    for (let i2 = 0; i2 < y2; i2++) {
      a2 = a2 * x2;
    }
  } else if (y2 < 0) {
    for (let i2 = 0; i2 > y2; i2--) {
      a2 = a2 / x2;
    }
  }
  return a2;
}
const _powCache = {};
function mathPow(x2, y2) {
  const key = `${x2}:${y2}`;
  if (!_powCache[key]) {
    _powCache[key] = _mathPow(x2, y2);
  }
  return _powCache[key];
}
class SankeyShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "sankey");
    __publicField(this, "shapeProps", writable({
      ax: 0,
      ay: 0,
      cx: 0,
      cy: 0,
      height: 0
    }));
    __publicField(this, "props");
    __publicField(this, "component", Component$2);
    __publicField(this, "hoveredComponent", Component$2);
    __publicField(this, "focusedComponent", Component$2);
    this.shapeProps.update((shapeProps) => {
      return {
        ...shapeProps,
        ...option
      };
    });
    this.shapeProps.subscribe(() => {
      this.apply();
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
  _getBoundingRect() {
    const rect = new BoundingRect();
    rect.visible = get_store_value(this.visible);
    const { ax, ay, cx, cy, height } = this.$shapeProps;
    rect.x = Math.min(ax, cx);
    rect.y = Math.min(ay, cy);
    rect.width = Math.abs(ax - cx);
    rect.height = Math.abs(ay - cy) + height;
    return rect;
  }
  _contain(x2, y2) {
    if (!this.getBoundingRect().contain(x2, y2)) {
      return false;
    }
    const { ax, ay, cx, cy, height } = this.$shapeProps;
    const width = cx - ax;
    const x1 = ax;
    const x22 = ax + width / 2;
    const x3 = x22;
    const x4 = cx;
    const y1 = ay;
    const y22 = ay;
    const y3 = cy;
    const y4 = cy;
    function approximateT(x5) {
      let t22 = 0;
      let pow = -1;
      let tries = 0;
      while (t22 < 1 && tries++ < 1e4) {
        const n2 = 1 - t22;
        const appX = mathPow(n2, 3) * x1 + 3 * mathPow(n2, 2) * t22 * x22 + 3 * n2 * mathPow(t22, 2) * x3 + mathPow(t22, 3) * x4;
        if (x5 < appX) {
          t22 -= mathPow(10, pow);
          if (pow-- < -3) {
            break;
          }
        }
        t22 += mathPow(10, pow);
      }
      return t22;
    }
    function calcTopY(t22) {
      const n2 = 1 - t22;
      return mathPow(n2, 3) * y1 + 3 * mathPow(n2, 2) * t22 * y22 + 3 * n2 * mathPow(t22, 2) * y3 + mathPow(t22, 3) * y4;
    }
    function calcBottomY(t22) {
      const n2 = 1 - t22;
      return mathPow(n2, 3) * (y1 + height) + 3 * mathPow(n2, 2) * t22 * (y22 + height) + 3 * n2 * mathPow(t22, 2) * (y3 + height) + mathPow(t22, 3) * (y4 + height);
    }
    const t2 = approximateT(x2);
    const topY = calcTopY(t2);
    const bottomY = calcBottomY(t2);
    if (y2 >= topY && y2 <= bottomY) {
      return true;
    }
    return false;
  }
  intersect(boundingRect) {
    return this.getBoundingRect().intersect(boundingRect);
  }
}
function create_if_block$n(ctx2) {
  let if_block_anchor;
  function select_block_type(ctx3, dirty) {
    if (
      /*state*/
      ctx3[1] === "hover"
    )
      return create_if_block_1$7;
    if (
      /*state*/
      ctx3[1] === "focus"
    )
      return create_if_block_2$4;
    return create_else_block$8;
  }
  let current_block_type = select_block_type(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (current_block_type === (current_block_type = select_block_type(ctx3)) && if_block) {
        if_block.p(ctx3, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx3);
        if (if_block) {
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      }
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if_block.d(detaching);
    }
  };
}
function create_else_block$8(ctx2) {
  let g;
  let path;
  let g_transform_value;
  let path_levels = [
    {
      .../*$props*/
      ctx2[7],
      .../*baseProps*/
      ctx2[2]
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      g = svg_element("g");
      path = svg_element("path");
      set_svg_attributes(path, path_data);
      attr(g, "transform", g_transform_value = "translate(" + asValidNumber(
        /*$shapeProps*/
        ctx2[4].cx
      ) + "," + asValidNumber(
        /*$shapeProps*/
        ctx2[4].cy
      ) + ")");
    },
    m(target, anchor) {
      insert(target, g, anchor);
      append$2(g, path);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*$props, baseProps*/
        132 && {
          .../*$props*/
          ctx3[7],
          .../*baseProps*/
          ctx3[2]
        }
      ]));
      if (dirty & /*$shapeProps*/
      16 && g_transform_value !== (g_transform_value = "translate(" + asValidNumber(
        /*$shapeProps*/
        ctx3[4].cx
      ) + "," + asValidNumber(
        /*$shapeProps*/
        ctx3[4].cy
      ) + ")")) {
        attr(g, "transform", g_transform_value);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(g);
      }
    }
  };
}
function create_if_block_2$4(ctx2) {
  let g;
  let path;
  let path_stroke_value;
  let path_stroke_width_value;
  let g_transform_value;
  let g_visibility_value;
  let path_levels = [
    /*baseProps*/
    ctx2[2],
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: path_stroke_value = "#333" },
    {
      "stroke-width": path_stroke_width_value = 2
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      g = svg_element("g");
      path = svg_element("path");
      set_svg_attributes(path, path_data);
      attr(g, "transform", g_transform_value = "translate(" + asValidNumber(
        /*$shapeProps*/
        ctx2[4].cx
      ) + "," + asValidNumber(
        /*$shapeProps*/
        ctx2[4].cy
      ) + ")");
      attr(g, "visibility", g_visibility_value = /*$focused*/
      ctx2[6] ? "" : "hidden");
    },
    m(target, anchor) {
      insert(target, g, anchor);
      append$2(g, path);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps*/
        4 && /*baseProps*/
        ctx3[2],
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: path_stroke_value },
        { "stroke-width": path_stroke_width_value }
      ]));
      if (dirty & /*$shapeProps*/
      16 && g_transform_value !== (g_transform_value = "translate(" + asValidNumber(
        /*$shapeProps*/
        ctx3[4].cx
      ) + "," + asValidNumber(
        /*$shapeProps*/
        ctx3[4].cy
      ) + ")")) {
        attr(g, "transform", g_transform_value);
      }
      if (dirty & /*$focused*/
      64 && g_visibility_value !== (g_visibility_value = /*$focused*/
      ctx3[6] ? "" : "hidden")) {
        attr(g, "visibility", g_visibility_value);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(g);
      }
    }
  };
}
function create_if_block_1$7(ctx2) {
  let g;
  let path;
  let path_stroke_value;
  let path_stroke_width_value;
  let g_transform_value;
  let g_visibility_value;
  let path_levels = [
    /*baseProps*/
    ctx2[2],
    { "pointer-events": "none" },
    { fill: "none" },
    { stroke: path_stroke_value = "#333" },
    {
      "stroke-width": path_stroke_width_value = 1
    }
  ];
  let path_data = {};
  for (let i2 = 0; i2 < path_levels.length; i2 += 1) {
    path_data = assign$1(path_data, path_levels[i2]);
  }
  return {
    c() {
      g = svg_element("g");
      path = svg_element("path");
      set_svg_attributes(path, path_data);
      attr(g, "transform", g_transform_value = "translate(" + asValidNumber(
        /*$shapeProps*/
        ctx2[4].cx
      ) + "," + asValidNumber(
        /*$shapeProps*/
        ctx2[4].cy
      ) + ")");
      attr(g, "visibility", g_visibility_value = /*$hovered*/
      ctx2[5] ? "" : "hidden");
    },
    m(target, anchor) {
      insert(target, g, anchor);
      append$2(g, path);
    },
    p(ctx3, dirty) {
      set_svg_attributes(path, path_data = get_spread_update(path_levels, [
        dirty & /*baseProps*/
        4 && /*baseProps*/
        ctx3[2],
        { "pointer-events": "none" },
        { fill: "none" },
        { stroke: path_stroke_value },
        { "stroke-width": path_stroke_width_value }
      ]));
      if (dirty & /*$shapeProps*/
      16 && g_transform_value !== (g_transform_value = "translate(" + asValidNumber(
        /*$shapeProps*/
        ctx3[4].cx
      ) + "," + asValidNumber(
        /*$shapeProps*/
        ctx3[4].cy
      ) + ")")) {
        attr(g, "transform", g_transform_value);
      }
      if (dirty & /*$hovered*/
      32 && g_visibility_value !== (g_visibility_value = /*$hovered*/
      ctx3[5] ? "" : "hidden")) {
        attr(g, "visibility", g_visibility_value);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(g);
      }
    }
  };
}
function create_fragment$v(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && /*$visible*/
    ctx2[3] && create_if_block$n(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0] && /*$visible*/
        ctx3[3]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$n(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$g($$self, $$props, $$invalidate) {
  let baseProps;
  let $inactive;
  let $dpath;
  let $visible;
  let $shapeProps;
  let $hovered;
  let $focused;
  let $props;
  let { shapeInstance } = $$props;
  let { state = null } = $$props;
  const { focused, hovered, inactive, props, dpath, visible, shapeProps } = shapeInstance;
  component_subscribe($$self, focused, (value) => $$invalidate(6, $focused = value));
  component_subscribe($$self, hovered, (value) => $$invalidate(5, $hovered = value));
  component_subscribe($$self, inactive, (value) => $$invalidate(15, $inactive = value));
  component_subscribe($$self, props, (value) => $$invalidate(7, $props = value));
  component_subscribe($$self, dpath, (value) => $$invalidate(16, $dpath = value));
  component_subscribe($$self, visible, (value) => $$invalidate(3, $visible = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(4, $shapeProps = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
    if ("state" in $$props2)
      $$invalidate(1, state = $$props2.state);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$dpath, $inactive*/
    98304) {
      $$invalidate(2, baseProps = (() => {
        return {
          d: $dpath,
          ...$inactive ? { opacity: 0.2 } : {}
        };
      })());
    }
  };
  return [
    shapeInstance,
    state,
    baseProps,
    $visible,
    $shapeProps,
    $hovered,
    $focused,
    $props,
    focused,
    hovered,
    inactive,
    props,
    dpath,
    visible,
    shapeProps,
    $inactive,
    $dpath
  ];
}
let Component$1 = class Component12 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$g, create_fragment$v, safe_not_equal, { shapeInstance: 0, state: 1 });
  }
};
const ALPHA = Math.pow(10, -3);
const SectorShapeComponent = Component$1;
function isBetween$1(rad, start, end, largeArc) {
  if (start === end) {
    return largeArc;
  }
  rad = normalizeRad(rad - start);
  end = normalizeRad(end - start);
  return rad >= 0 && rad < end;
}
class SectorShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "sector");
    __publicField(this, "shapeProps", writable({
      cx: 0,
      cy: 0,
      r: 0,
      r0: 0,
      startAngle: 0,
      endAngle: 0,
      largeArc: false
    }));
    __publicField(this, "props");
    __publicField(this, "component", SectorShapeComponent);
    __publicField(this, "focusedComponent", SectorShapeComponent);
    __publicField(this, "hoveredComponent", SectorShapeComponent);
    __publicField(this, "dpath");
    this.shapeProps.update((shapeProps) => {
      return {
        ...shapeProps,
        ...option
      };
    });
    this.shapeProps.subscribe(() => {
      this.apply();
    });
    this.dpath = derived([this.shapeProps], ([$shapeProps]) => {
      const {
        cx,
        cy,
        r: r2,
        r0,
        startAngle,
        endAngle: _endAngle
      } = $shapeProps;
      let endAngle = _endAngle;
      if (normalizeRad(endAngle - startAngle) < ALPHA) {
        endAngle -= ALPHA;
      }
      const a2 = arc();
      return a2({
        innerRadius: r0,
        outerRadius: r2,
        startAngle: startAngle + Math.PI / 2,
        endAngle: endAngle + Math.PI / 2
      }) || "";
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
  _getBoundingRect() {
    const rect = new BoundingRect();
    const { cx, cy, r: r2 } = this.$shapeProps;
    rect.visible = get_store_value(this.visible);
    rect.x = cx - r2;
    rect.y = cy - r2;
    rect.width = r2 * 2;
    rect.height = r2 * 2;
    return rect;
  }
  _contain(x2, y2) {
    const { cx, cy, r: r2, r0, startAngle, endAngle, largeArc } = this.$shapeProps;
    const dx = x2 - cx;
    const dy = y2 - cy;
    const d = Math.sqrt(dx * dx + dy * dy);
    if (d > r2 || d < r0) {
      return false;
    }
    let rad = Math.acos(dx / d);
    if (dx >= 0 && dy <= 0) {
      rad = normalizeRad(-rad);
    } else if (dx <= 0 && dy <= 0) {
      rad = normalizeRad(-rad);
    }
    return isBetween$1(rad, startAngle, endAngle, largeArc);
  }
  intersect(boundingRect) {
    return this.getBoundingRect().intersect(boundingRect);
  }
}
function create_if_block$m(ctx2) {
  let g;
  let raw_value = (
    /*$shapeProps*/
    ctx2[1].svg + ""
  );
  let g_levels = [
    {
      .../*baseProps*/
      ctx2[2],
      .../*$props*/
      ctx2[3]
    }
  ];
  let g_data = {};
  for (let i2 = 0; i2 < g_levels.length; i2 += 1) {
    g_data = assign$1(g_data, g_levels[i2]);
  }
  return {
    c() {
      g = svg_element("g");
      set_svg_attributes(g, g_data);
    },
    m(target, anchor) {
      insert(target, g, anchor);
      g.innerHTML = raw_value;
    },
    p(ctx3, dirty) {
      if (dirty & /*$shapeProps*/
      2 && raw_value !== (raw_value = /*$shapeProps*/
      ctx3[1].svg + ""))
        g.innerHTML = raw_value;
      set_svg_attributes(g, g_data = get_spread_update(g_levels, [
        dirty & /*baseProps, $props*/
        12 && {
          .../*baseProps*/
          ctx3[2],
          .../*$props*/
          ctx3[3]
        }
      ]));
    },
    d(detaching) {
      if (detaching) {
        detach(g);
      }
    }
  };
}
function create_fragment$u(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*shapeInstance*/
    ctx2[0] && create_if_block$m(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*shapeInstance*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$m(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$f($$self, $$props, $$invalidate) {
  let baseProps;
  let $inactive;
  let $visible;
  let $shapeProps;
  let $props;
  let { shapeInstance } = $$props;
  const { inactive, shapeProps, props, visible } = shapeInstance;
  component_subscribe($$self, inactive, (value) => $$invalidate(8, $inactive = value));
  component_subscribe($$self, shapeProps, (value) => $$invalidate(1, $shapeProps = value));
  component_subscribe($$self, props, (value) => $$invalidate(3, $props = value));
  component_subscribe($$self, visible, (value) => $$invalidate(9, $visible = value));
  $$self.$$set = ($$props2) => {
    if ("shapeInstance" in $$props2)
      $$invalidate(0, shapeInstance = $$props2.shapeInstance);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$shapeProps, $visible, $inactive*/
    770) {
      $$invalidate(2, baseProps = (() => {
        const { x: x2, y: y2 } = $shapeProps;
        return {
          transform: `translate(${asValidNumber(x2)},${asValidNumber(y2)})`,
          visibility: $visible ? "" : "hidden",
          ...$inactive ? { opacity: 0.2 } : {}
        };
      })());
    }
  };
  return [
    shapeInstance,
    $shapeProps,
    baseProps,
    $props,
    inactive,
    shapeProps,
    props,
    visible,
    $inactive,
    $visible
  ];
}
class Component13 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$f, create_fragment$u, safe_not_equal, { shapeInstance: 0 });
  }
}
class SvgShape extends BaseShape {
  constructor(option) {
    var _a2;
    super(option);
    __publicField(this, "type", "svg");
    __publicField(this, "shapeProps", writable({
      x: 0,
      y: 0,
      svg: "",
      width: 0,
      height: 0
    }));
    __publicField(this, "props");
    __publicField(this, "component", Component13);
    this.shapeProps.update((shapeProps) => {
      return {
        ...shapeProps,
        ...option
      };
    });
    this.shapeProps.subscribe(() => {
      this.apply();
    });
    this.props = (_a2 = option.props) != null ? _a2 : readable({});
  }
  get $shapeProps() {
    return get_store_value(this.shapeProps);
  }
  _getBoundingRect() {
    const rect = new BoundingRect();
    rect.visible = get_store_value(this.visible);
    rect.x = asValidNumber(this.$shapeProps.x);
    rect.y = asValidNumber(this.$shapeProps.y);
    rect.width = asValidNumber(this.$shapeProps.width, false);
    rect.height = asValidNumber(this.$shapeProps.height, false);
    return rect;
  }
  _contain(x2, y2) {
    return this.getBoundingRect().contain(x2, y2);
  }
  intersect(boundingRect) {
    return this.getBoundingRect().intersect(boundingRect);
  }
}
function pointInPolyline(point2, points) {
  const { length: len } = points;
  let counter = 0;
  let xInter;
  let p1 = points[0];
  for (let i2 = 1; i2 <= len; i2++) {
    const p2 = points[i2 % len];
    const minY = Math.min(p1.y, p2.y);
    const maxY = Math.max(p1.y, p2.y);
    const maxX = Math.max(p1.x, p2.x);
    if (p1.y !== p2.y && minY < point2.y && point2.y <= maxY && point2.x <= maxX) {
      xInter = (point2.y - p1.y) * (p2.x - p1.x) / (p2.y - p1.y) + p1.x;
      if (p1.x === p2.x || point2.x <= xInter) {
        counter++;
      }
    }
    p1 = p2;
  }
  return counter % 2 === 1;
}
let isLoaded = false;
function flattenShapes(shapes) {
  const results = [];
  processShapes(shapes, (shape, parentX, parentY) => {
    results.push({
      parentX,
      parentY,
      shape
    });
  });
  return results;
}
function sortShapes(shapes) {
  shapes.sort((a2, b) => {
    return get_store_value(b.shape.priority) - get_store_value(a2.shape.priority);
  });
}
function containShapes(x2, y2, shapes, testShape) {
  const results = [];
  const process2 = (shapes2, parentX = 0, parentY = 0) => {
    for (let i2 = 0; i2 < shapes2.length; i2++) {
      const shape = shapes2[i2];
      if (shape.type === "group") {
        const { x: groupX, y: groupY, children: children2 } = shape.$shapeProps;
        process2(children2, parentX + groupX, parentY + groupY);
      } else {
        if (testShape(shape, parentX, parentY) && shape.contain(x2 - parentX, y2 - parentY)) {
          results.push(shape);
        }
      }
    }
  };
  process2(shapes);
  return results;
}
function processShapes(shapes, callback) {
  const process2 = (shapes2, parentX = 0, parentY = 0) => {
    for (let i2 = 0; i2 < shapes2.length; i2++) {
      const shape = shapes2[i2];
      if (shape.type === "group") {
        const { x: x2, y: y2, children: children2 } = shape.$shapeProps;
        process2(children2, parentX + x2, parentY + y2);
      } else {
        callback(shape, parentX, parentY);
      }
    }
  };
  process2(shapes);
}
async function load() {
  if (isLoaded) {
    return;
  }
  isLoaded = true;
}
function instance_1$D($$self, $$props, $$invalidate) {
  let $xScale;
  let $yScale;
  let $layout;
  let $isColorActive;
  let $getColor;
  let $innerWidth;
  let $margin;
  let $innerHeight;
  const instance2 = getInstance();
  const { innerWidth, innerHeight, margin, focused, chartStore, contentShapes, focusable } = instance2;
  component_subscribe($$self, innerWidth, (value) => $$invalidate(15, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(17, $innerHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(16, $margin = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$f) {
    throw new Error();
  }
  const { option, data, xDomain, seriesDomain, xScale, yScale, hoveredX, hoveredSeries, isFocused, toggleFocused, seriesColumn, colorUtils: { colorDomain, colorRange, getColor, isColorActive }, layout } = chartStore;
  component_subscribe($$self, xScale, (value) => $$invalidate(10, $xScale = value));
  component_subscribe($$self, yScale, (value) => $$invalidate(11, $yScale = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(14, $getColor = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(13, $isColorActive = value));
  component_subscribe($$self, layout, (value) => $$invalidate(12, $layout = value));
  let shapes;
  let rects;
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$layout, $xScale, $margin, $innerHeight, $innerWidth*/
    234496) {
      {
        $$invalidate(9, rects = xDomain.map((x2) => {
          var _a2, _b;
          return new RectShape({
            data: { x: x2 },
            ...$layout === "vertical" ? {
              x: ((_a2 = $xScale(x2)) != null ? _a2 : 0) - $xScale.step() / 2,
              y: $margin.top,
              width: $xScale.step(),
              height: $innerHeight
            } : {
              x: $margin.left,
              y: ((_b = $xScale(x2)) != null ? _b : 0) - $xScale.step() / 2,
              width: $innerWidth,
              height: $xScale.step()
            },
            hoverable: true,
            events: {
              mouseenter: readable(() => {
                hoveredX.set(x2);
              }),
              mouseleave: readable(() => {
                hoveredX.set(null);
              })
            },
            props: readable({ fill: "transparent" })
          });
        }));
      }
    }
    if ($$self.$$.dirty[0] & /*$getColor, $layout, $isColorActive, $xScale, $yScale*/
    31744) {
      {
        $$invalidate(8, shapes = seriesDomain.flatMap((series, i2) => {
          var _a2, _b;
          const record = data.find((d) => d.series === series);
          if (!record) {
            return [];
          }
          const color2 = $getColor(record.color);
          return [
            new GroupShape({
              data: { series },
              children: [
                new PolylineShape({
                  clickable: true,
                  data: { series },
                  layout: $layout,
                  smooth: option.smooth,
                  points: xDomain.flatMap((x2) => {
                    var _a3;
                    const record2 = data.find((d) => d.x === x2 && d.series === series);
                    if (!record2) {
                      return [];
                    }
                    if (!$isColorActive(record2.color)) {
                      return [];
                    }
                    const value = record2.y;
                    const xPos = (_a3 = $xScale(x2)) != null ? _a3 : 0;
                    const yPos = $yScale(value);
                    if ($layout === "vertical") {
                      return [[asValidNumber(xPos), asValidNumber(yPos)]];
                    }
                    return [[asValidNumber(yPos), asValidNumber(xPos)]];
                  }),
                  inactive: derived([focused], ([$focused]) => {
                    return $focused.length > 0 && $focused.every((focused2) => focused2[seriesColumn.key] !== series);
                  }),
                  props: readable({
                    stroke: color2,
                    "stroke-width": "2px",
                    fill: "transparent",
                    "stroke-dasharray": ((_b = (_a2 = option.configs) == null ? void 0 : _a2[i2]) == null ? void 0 : _b.dashed) ? 8 : void 0
                  })
                }),
                ...xDomain.flatMap((x2) => {
                  var _a3, _b2;
                  const record2 = data.find((d) => d.x === x2 && d.series === series);
                  if (!record2) {
                    return [];
                  }
                  if (!$isColorActive(record2.color)) {
                    return [];
                  }
                  const value = record2.y;
                  const circle = new CircleShape({
                    data: { series, x: x2 },
                    ...$layout === "vertical" ? { cx: (_a3 = $xScale(x2)) != null ? _a3 : 0, cy: $yScale(value) } : { cx: $yScale(value), cy: (_b2 = $xScale(x2)) != null ? _b2 : 0 },
                    r: 4,
                    clickable: true,
                    events: {
                      click: derived([focusable], ([$focusable]) => {
                        if ($focusable) {
                          toggleFocused(get_store_value(focused), x2, series);
                        }
                      }),
                      mouseenter: readable(() => {
                        hoveredX.set(x2);
                        hoveredSeries.set(series);
                      }),
                      mouseleave: readable(() => {
                        hoveredX.set(null);
                        hoveredSeries.set(null);
                      })
                    },
                    focused: derived([focused], ([$focused]) => {
                      return isFocused($focused, x2, series);
                    }),
                    inactive: derived([focused], ([$focused]) => {
                      return !isFocused($focused, x2, series) && $focused.length > 0;
                    }),
                    hoverable: true,
                    priority: readable(100),
                    hovered: derived([hoveredX, hoveredSeries], ([$hoveredX, $hoveredSeries]) => {
                      return $hoveredX === x2 && $hoveredSeries === series;
                    }),
                    props: readable({ fill: color2 })
                  });
                  return [circle];
                })
              ]
            })
          ];
        }));
      }
    }
    if ($$self.$$.dirty[0] & /*rects, shapes*/
    768) {
      {
        contentShapes.set([...rects, ...shapes]);
      }
    }
  };
  return [
    innerWidth,
    innerHeight,
    margin,
    xScale,
    yScale,
    getColor,
    isColorActive,
    layout,
    shapes,
    rects,
    $xScale,
    $yScale,
    $layout,
    $isColorActive,
    $getColor,
    $innerWidth,
    $margin,
    $innerHeight
  ];
}
let Bar$3 = class Bar extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$D, null, safe_not_equal, {}, null, [-1, -1]);
  }
};
function instance$e($$self, $$props, $$invalidate) {
  let $xScale;
  let $yScale;
  let $layout;
  let $total;
  let $percent;
  let $getColor;
  let $isColorActive;
  let $innerWidth;
  let $margin;
  let $innerHeight;
  const { innerWidth, innerHeight, margin, focused, focusable, contentShapes, chartStore } = getInstance();
  component_subscribe($$self, innerWidth, (value) => $$invalidate(20, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(22, $innerHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(21, $margin = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$f) {
    throw new Error();
  }
  const { option, xDomain, seriesDomain, percent, xScale, yScale, total, data, hoveredX, hoveredSeries, isFocused, toggleFocused, seriesColumn, colorUtils: { colorDomain, colorRange, getColor, isColorActive }, layout } = chartStore;
  component_subscribe($$self, percent, (value) => $$invalidate(17, $percent = value));
  component_subscribe($$self, xScale, (value) => $$invalidate(13, $xScale = value));
  component_subscribe($$self, yScale, (value) => $$invalidate(14, $yScale = value));
  component_subscribe($$self, total, (value) => $$invalidate(16, $total = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(18, $getColor = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(19, $isColorActive = value));
  component_subscribe($$self, layout, (value) => $$invalidate(15, $layout = value));
  let shapes;
  let circles;
  let rects;
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$layout, $xScale, $margin, $innerHeight, $innerWidth*/
    7380992) {
      {
        $$invalidate(12, rects = xDomain.map((x2) => {
          var _a2, _b;
          return new RectShape({
            data: { x: x2 },
            ...$layout === "vertical" ? {
              x: ((_a2 = $xScale(x2)) != null ? _a2 : 0) - $xScale.step() / 2,
              y: $margin.top,
              width: $xScale.step(),
              height: $innerHeight
            } : {
              x: $margin.left,
              y: ((_b = $xScale(x2)) != null ? _b : 0) - $xScale.step() / 2,
              width: $innerWidth,
              height: $xScale.step()
            },
            hoverable: true,
            events: {
              mouseenter: readable(() => {
                hoveredX.set(x2);
              }),
              mouseleave: readable(() => {
                hoveredX.set(null);
              })
            },
            props: readable({ fill: "transparent" })
          });
        }));
      }
    }
    if ($$self.$$.dirty[0] & /*$isColorActive, $getColor, $layout, $percent, $total, $xScale, $yScale*/
    1040384) {
      {
        let xPrev = new Array(xDomain.length).fill(0);
        $$invalidate(10, shapes = seriesDomain.flatMap((series, index2) => {
          const records = data.filter((d) => d.series === series);
          if (records.length === 0) {
            return [];
          }
          if (!$isColorActive(records[0].color)) {
            return [];
          }
          const color2 = $getColor(records[0].color);
          const res = [
            new GroupShape({
              data: { series },
              children: [
                new PolylineShape({
                  clickable: false,
                  data: { series },
                  layout: $layout,
                  smooth: option.smooth,
                  points: xDomain.map((x2, i2) => {
                    var _a2, _b, _c, _d;
                    const record = records.find((d) => d.x === x2);
                    const yValue = asValidNumber(record == null ? void 0 : record.y);
                    const value = $percent ? (yValue + xPrev[i2]) / $total({ x: x2 }) : yValue + xPrev[i2];
                    if ($layout === "vertical") {
                      return [(_a2 = $xScale(x2)) != null ? _a2 : 0, (_b = $yScale(value)) != null ? _b : 0];
                    }
                    return [(_c = $yScale(value)) != null ? _c : 0, (_d = $xScale(x2)) != null ? _d : 0];
                  }),
                  inactive: derived([focused], ([$focused]) => {
                    return $focused.length > 0 && $focused.every((focused2) => focused2[seriesColumn.key] !== series);
                  }),
                  props: readable({
                    stroke: color2,
                    fill: "transparent",
                    "stroke-width": "2px"
                  })
                }),
                new AreaShape({
                  clickable: false,
                  data: { series },
                  layout: $layout,
                  smooth: option.smooth,
                  points: [
                    ...xDomain.map((x2, i2) => {
                      var _a2, _b;
                      const record = records.find((d) => d.x === x2);
                      const yValue = asValidNumber(record == null ? void 0 : record.y);
                      const value = $percent ? (yValue + xPrev[i2]) / $total({ x: x2 }) : yValue + xPrev[i2];
                      const y2 = $yScale(value);
                      const value0 = $percent ? xPrev[i2] / $total({ x: x2 }) : xPrev[i2];
                      const y0 = $yScale(value0);
                      if ($layout === "vertical") {
                        return { x: (_a2 = $xScale(x2)) != null ? _a2 : 0, y0, y1: y2 };
                      } else {
                        return { y: (_b = $xScale(x2)) != null ? _b : 0, x0: y0, x1: y2 };
                      }
                    })
                  ],
                  inactive: derived([focused], ([$focused]) => {
                    return $focused.length > 0 && $focused.every((focused2) => focused2[seriesColumn.key] !== series);
                  }),
                  props: readable({
                    fill: chroma(color2).alpha(0.6).css(),
                    "stroke-width": "2px"
                  })
                })
              ]
            })
          ];
          xDomain.forEach((x2, i2) => {
            const record = records.find((d) => d.x === x2);
            xPrev[i2] += asValidNumber(record == null ? void 0 : record.y);
          });
          return res;
        }));
      }
    }
    if ($$self.$$.dirty[0] & /*$isColorActive, $getColor, $percent, $total, $layout, $xScale, $yScale*/
    1040384) {
      {
        let xPrev = new Array(xDomain.length).fill(0);
        const _circles = [];
        seriesDomain.forEach((series, index2) => {
          const records = data.filter((d) => d.series === series);
          if (records.length === 0) {
            return [];
          }
          if (!$isColorActive(records[0].color)) {
            return [];
          }
          const color2 = $getColor(records[0].color);
          xDomain.forEach((x2, i2) => {
            var _a2, _b;
            const record = records.find((d) => d.x === x2);
            const yValue = asValidNumber(record == null ? void 0 : record.y);
            const value = $percent ? (yValue + xPrev[i2]) / $total({ x: x2 }) : yValue + xPrev[i2];
            const circle = new CircleShape({
              data: { series, x: x2 },
              ...$layout === "vertical" ? { cx: (_a2 = $xScale(x2)) != null ? _a2 : 0, cy: $yScale(value) } : { cx: $yScale(value), cy: (_b = $xScale(x2)) != null ? _b : 0 },
              r: 4,
              hoverable: true,
              events: {
                mouseenter: readable(() => {
                  hoveredX.set(x2);
                  hoveredSeries.set(series);
                }),
                mouseleave: readable(() => {
                  hoveredX.set(null);
                  hoveredSeries.set(null);
                }),
                click: derived([focusable], ([$focusable]) => {
                  if ($focusable) {
                    toggleFocused(get_store_value(focused), x2, series);
                  }
                })
              },
              priority: readable(100),
              hovered: derived([hoveredX, hoveredSeries], ([$hoveredX, $hoveredSeries]) => {
                return $hoveredX === x2 && $hoveredSeries === series;
              }),
              clickable: true,
              focused: derived([focused], ([$focused]) => {
                return isFocused($focused, x2, series);
              }),
              inactive: derived([focused], ([$focused]) => {
                return !isFocused($focused, x2, series) && $focused.length > 0;
              }),
              props: readable({ fill: color2 })
            });
            _circles.push(circle);
          });
          xDomain.forEach((x2, i2) => {
            const record = records.find((d) => d.x === x2);
            xPrev[i2] += asValidNumber(record == null ? void 0 : record.y);
          });
        });
        $$invalidate(11, circles = _circles);
      }
    }
    if ($$self.$$.dirty[0] & /*rects, shapes, circles*/
    7168) {
      {
        contentShapes.set([...rects, ...shapes, ...circles]);
      }
    }
  };
  return [
    innerWidth,
    innerHeight,
    margin,
    percent,
    xScale,
    yScale,
    total,
    getColor,
    isColorActive,
    layout,
    shapes,
    circles,
    rects,
    $xScale,
    $yScale,
    $layout,
    $total,
    $percent,
    $getColor,
    $isColorActive,
    $innerWidth,
    $margin,
    $innerHeight
  ];
}
let StackBar$2 = class StackBar extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$e, null, safe_not_equal, {}, null, [-1, -1]);
  }
};
function create_else_block$7(ctx2) {
  let vbar;
  let current;
  vbar = new Bar$3({});
  return {
    c() {
      create_component(vbar.$$.fragment);
    },
    m(target, anchor) {
      mount_component(vbar, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(vbar.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(vbar.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(vbar, detaching);
    }
  };
}
function create_if_block$l(ctx2) {
  let vstackbar;
  let current;
  vstackbar = new StackBar$2({});
  return {
    c() {
      create_component(vstackbar.$$.fragment);
    },
    m(target, anchor) {
      mount_component(vstackbar, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(vstackbar.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(vstackbar.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(vstackbar, detaching);
    }
  };
}
function create_fragment$t(ctx2) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$l, create_else_block$7];
  const if_blocks = [];
  function select_block_type(ctx3, dirty) {
    if (
      /*$stack*/
      ctx3[0]
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx2);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx3);
      if (current_block_type_index !== previous_block_index) {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx3);
          if_block.c();
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if_blocks[current_block_type_index].d(detaching);
    }
  };
}
function instance_1$C($$self, $$props, $$invalidate) {
  let $getColor;
  let $total;
  let $percent;
  let $stack;
  let $layout;
  let $chartWidth;
  let $chartHeight;
  let $yRange;
  let $mousePosition;
  let $hoveredX;
  const instance2 = getInstance();
  const { mousePosition, tooltipShown, tooltipPosition, xAxisConfig, yAxisConfig, legend, chartWidth, chartHeight, chartStore, colorLegendConfig } = instance2;
  component_subscribe($$self, mousePosition, (value) => $$invalidate(18, $mousePosition = value));
  component_subscribe($$self, chartWidth, (value) => $$invalidate(15, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(16, $chartHeight = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$f) {
    throw new Error();
  }
  const { option, stack, hoveredX, xColumn, xDomain, yColumn, yRange, percent, seriesColumn, data, seriesDomain, colorColumn, colorUtils: { colorDomain, colorRange, getColor }, layout, total } = chartStore;
  component_subscribe($$self, stack, (value) => $$invalidate(0, $stack = value));
  component_subscribe($$self, hoveredX, (value) => $$invalidate(19, $hoveredX = value));
  component_subscribe($$self, yRange, (value) => $$invalidate(17, $yRange = value));
  component_subscribe($$self, percent, (value) => $$invalidate(13, $percent = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(11, $getColor = value));
  component_subscribe($$self, layout, (value) => $$invalidate(14, $layout = value));
  component_subscribe($$self, total, (value) => $$invalidate(12, $total = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$hoveredX, $mousePosition*/
    786432) {
      {
        if ($hoveredX != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$layout, $chartWidth, $chartHeight, $yRange*/
    245760) {
      {
        const xAxis = ({ margin }) => {
          var _a2, _b, _c, _d, _e, _f;
          const xScale = point$1().padding(0.5).domain(xDomain).range($layout === "vertical" ? [margin.left, $chartWidth - margin.right] : [$chartHeight - margin.bottom, margin.top]);
          return new CategoryAxisConfig({
            show: (_b = (_a2 = option.xAxis) == null ? void 0 : _a2.show) != null ? _b : true,
            showTitle: (_d = (_c = option.xAxis) == null ? void 0 : _c.showTitle) != null ? _d : false,
            showTicks: (_f = (_e = option.xAxis) == null ? void 0 : _e.showTicks) != null ? _f : true,
            title: xColumn.title,
            step: xScale.step(),
            ticks: xDomain.map((tick2) => {
              var _a3;
              return {
                value: tick2,
                label: xColumn.formatter(tick2),
                pos: (_a3 = xScale(tick2)) != null ? _a3 : 0,
                active: derived([hoveredX], ([$hoveredX2]) => {
                  return $hoveredX2 === tick2;
                })
              };
            })
          });
        };
        const yAxis = ({ margin }) => {
          var _a2, _b, _c, _d, _e, _f;
          const yScale = linear().domain([$yRange[0], $yRange[1]]).range($layout === "vertical" ? [$chartHeight - margin.bottom, margin.top] : [margin.left, $chartWidth - margin.right]).nice();
          return new ValueAxisConfig({
            show: (_b = (_a2 = option.yAxis) == null ? void 0 : _a2.show) != null ? _b : true,
            showTitle: (_d = (_c = option.yAxis) == null ? void 0 : _c.showTitle) != null ? _d : false,
            showTicks: (_f = (_e = option.yAxis) == null ? void 0 : _e.showTicks) != null ? _f : true,
            title: yColumn.title,
            scale: yScale,
            axisFormatter: yColumn.axisFormatter
          });
        };
        if ($layout === "vertical") {
          xAxisConfig.set(xAxis);
          yAxisConfig.set(yAxis);
        } else {
          xAxisConfig.set(yAxis);
          yAxisConfig.set(xAxis);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$stack, $percent, $total*/
    12289) {
      {
        instance2.tableConfig.set({
          columns: [
            {
              ...seriesColumn,
              key: "name",
              type: "dimension",
              align: "left"
            },
            {
              ...xColumn,
              key: "x",
              type: "dimension",
              align: "left"
            },
            {
              ...yColumn,
              key: "y",
              type: "metric",
              align: "right"
            }
          ],
          data: data.map((d) => {
            var _a2;
            return {
              x: d.x,
              name: d.series,
              y: $stack && $percent ? ((_a2 = d.y) != null ? _a2 : 0) / $total({ x: d.x }) : d.y
            };
          })
        });
      }
    }
    if ($$self.$$.dirty[0] & /*$getColor*/
    2048) {
      {
        if (colorColumn.type === "value") {
          colorLegendConfig.set({
            show: true,
            type: "value",
            column: colorColumn,
            min: colorRange[0],
            max: colorRange[1],
            getColor: (value) => $getColor(value * (colorRange[1] - colorRange[0]) + colorRange[0])
          });
        } else if (colorColumn.type === "category") {
          colorLegendConfig.set({
            show: true,
            type: "category",
            formatter: colorColumn.formatter,
            domain: colorDomain,
            getColor: (value) => $getColor(value)
          });
        }
      }
    }
  };
  return [
    $stack,
    mousePosition,
    chartWidth,
    chartHeight,
    stack,
    hoveredX,
    yRange,
    percent,
    getColor,
    layout,
    total,
    $getColor,
    $total,
    $percent,
    $layout,
    $chartWidth,
    $chartHeight,
    $yRange,
    $mousePosition,
    $hoveredX
  ];
}
let Content$g = class Content extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$C, create_fragment$t, safe_not_equal, {}, null, [-1, -1]);
  }
};
const LineContent = Content$g;
const fixedDelimiter = "|";
const escapeCharacter = "\\";
function escapeElement(element2) {
  return element2.replace(
    new RegExp(`[|]`, "g"),
    (match2) => `${escapeCharacter}${match2}`
  );
}
function tupleToString(tuple) {
  return tuple.map((element2) => escapeElement(element2.toString())).join(fixedDelimiter);
}
class CachedMap {
  constructor(options) {
    __publicField(this, "map", /* @__PURE__ */ new Map());
    __publicField(this, "data");
    __publicField(this, "key");
    __publicField(this, "cached", false);
    this.data = options.data;
    this.key = options.key;
  }
  setMap() {
    if (this.cached)
      return;
    this.data.forEach((item) => {
      const raw = this.key(item);
      const key = tupleToString(raw);
      this.map.set(key, item);
    });
    this.cached = true;
  }
  get(raw) {
    this.setMap();
    const key = tupleToString(raw);
    return this.map.get(key);
  }
}
var noop = { value: () => {
} };
function dispatch() {
  for (var i2 = 0, n2 = arguments.length, _2 = {}, t2; i2 < n2; ++i2) {
    if (!(t2 = arguments[i2] + "") || t2 in _2 || /[\s.]/.test(t2))
      throw new Error("illegal type: " + t2);
    _2[t2] = [];
  }
  return new Dispatch(_2);
}
function Dispatch(_2) {
  this._ = _2;
}
function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t2) {
    var name = "", i2 = t2.indexOf(".");
    if (i2 >= 0)
      name = t2.slice(i2 + 1), t2 = t2.slice(0, i2);
    if (t2 && !types.hasOwnProperty(t2))
      throw new Error("unknown type: " + t2);
    return { type: t2, name };
  });
}
Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _2 = this._, T2 = parseTypenames(typename + "", _2), t2, i2 = -1, n2 = T2.length;
    if (arguments.length < 2) {
      while (++i2 < n2)
        if ((t2 = (typename = T2[i2]).type) && (t2 = get(_2[t2], typename.name)))
          return t2;
      return;
    }
    if (callback != null && typeof callback !== "function")
      throw new Error("invalid callback: " + callback);
    while (++i2 < n2) {
      if (t2 = (typename = T2[i2]).type)
        _2[t2] = set(_2[t2], typename.name, callback);
      else if (callback == null)
        for (t2 in _2)
          _2[t2] = set(_2[t2], typename.name, null);
    }
    return this;
  },
  copy: function() {
    var copy2 = {}, _2 = this._;
    for (var t2 in _2)
      copy2[t2] = _2[t2].slice();
    return new Dispatch(copy2);
  },
  call: function(type2, that) {
    if ((n2 = arguments.length - 2) > 0)
      for (var args = new Array(n2), i2 = 0, n2, t2; i2 < n2; ++i2)
        args[i2] = arguments[i2 + 2];
    if (!this._.hasOwnProperty(type2))
      throw new Error("unknown type: " + type2);
    for (t2 = this._[type2], i2 = 0, n2 = t2.length; i2 < n2; ++i2)
      t2[i2].value.apply(that, args);
  },
  apply: function(type2, that, args) {
    if (!this._.hasOwnProperty(type2))
      throw new Error("unknown type: " + type2);
    for (var t2 = this._[type2], i2 = 0, n2 = t2.length; i2 < n2; ++i2)
      t2[i2].value.apply(that, args);
  }
};
function get(type2, name) {
  for (var i2 = 0, n2 = type2.length, c2; i2 < n2; ++i2) {
    if ((c2 = type2[i2]).name === name) {
      return c2.value;
    }
  }
}
function set(type2, name, callback) {
  for (var i2 = 0, n2 = type2.length; i2 < n2; ++i2) {
    if (type2[i2].name === name) {
      type2[i2] = noop, type2 = type2.slice(0, i2).concat(type2.slice(i2 + 1));
      break;
    }
  }
  if (callback != null)
    type2.push({ name, value: callback });
  return type2;
}
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1e3, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f2) {
  setTimeout(f2, 17);
};
function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
  clockNow = 0;
}
function Timer() {
  this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function")
      throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail)
        taskTail._next = this;
      else
        taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};
function timer(callback, delay, time) {
  var t2 = new Timer();
  t2.restart(callback, delay, time);
  return t2;
}
function timerFlush() {
  now();
  ++frame;
  var t2 = taskHead, e3;
  while (t2) {
    if ((e3 = clockNow - t2._time) >= 0)
      t2._call.call(void 0, e3);
    t2 = t2._next;
  }
  --frame;
}
function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}
function poke() {
  var now2 = clock.now(), delay = now2 - clockLast;
  if (delay > pokeDelay)
    clockSkew -= delay, clockLast = now2;
}
function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time)
        time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}
function sleep(time) {
  if (frame)
    return;
  if (timeout)
    timeout = clearTimeout(timeout);
  var delay = time - clockNow;
  if (delay > 24) {
    if (time < Infinity)
      timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval)
      interval = clearInterval(interval);
  } else {
    if (!interval)
      clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}
function tree_add(d) {
  const x2 = +this._x.call(null, d), y2 = +this._y.call(null, d);
  return add(this.cover(x2, y2), x2, y2, d);
}
function add(tree, x2, y2, d) {
  if (isNaN(x2) || isNaN(y2))
    return tree;
  var parent, node2 = tree._root, leaf = { data: d }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i2, j;
  if (!node2)
    return tree._root = leaf, tree;
  while (node2.length) {
    if (right = x2 >= (xm = (x0 + x1) / 2))
      x0 = xm;
    else
      x1 = xm;
    if (bottom = y2 >= (ym = (y0 + y1) / 2))
      y0 = ym;
    else
      y1 = ym;
    if (parent = node2, !(node2 = node2[i2 = bottom << 1 | right]))
      return parent[i2] = leaf, tree;
  }
  xp = +tree._x.call(null, node2.data);
  yp = +tree._y.call(null, node2.data);
  if (x2 === xp && y2 === yp)
    return leaf.next = node2, parent ? parent[i2] = leaf : tree._root = leaf, tree;
  do {
    parent = parent ? parent[i2] = new Array(4) : tree._root = new Array(4);
    if (right = x2 >= (xm = (x0 + x1) / 2))
      x0 = xm;
    else
      x1 = xm;
    if (bottom = y2 >= (ym = (y0 + y1) / 2))
      y0 = ym;
    else
      y1 = ym;
  } while ((i2 = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
  return parent[j] = node2, parent[i2] = leaf, tree;
}
function addAll(data) {
  var d, i2, n2 = data.length, x2, y2, xz = new Array(n2), yz = new Array(n2), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
  for (i2 = 0; i2 < n2; ++i2) {
    if (isNaN(x2 = +this._x.call(null, d = data[i2])) || isNaN(y2 = +this._y.call(null, d)))
      continue;
    xz[i2] = x2;
    yz[i2] = y2;
    if (x2 < x0)
      x0 = x2;
    if (x2 > x1)
      x1 = x2;
    if (y2 < y0)
      y0 = y2;
    if (y2 > y1)
      y1 = y2;
  }
  if (x0 > x1 || y0 > y1)
    return this;
  this.cover(x0, y0).cover(x1, y1);
  for (i2 = 0; i2 < n2; ++i2) {
    add(this, xz[i2], yz[i2], data[i2]);
  }
  return this;
}
function tree_cover(x2, y2) {
  if (isNaN(x2 = +x2) || isNaN(y2 = +y2))
    return this;
  var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x2)) + 1;
    y1 = (y0 = Math.floor(y2)) + 1;
  } else {
    var z = x1 - x0 || 1, node2 = this._root, parent, i2;
    while (x0 > x2 || x2 >= x1 || y0 > y2 || y2 >= y1) {
      i2 = (y2 < y0) << 1 | x2 < x0;
      parent = new Array(4), parent[i2] = node2, node2 = parent, z *= 2;
      switch (i2) {
        case 0:
          x1 = x0 + z, y1 = y0 + z;
          break;
        case 1:
          x0 = x1 - z, y1 = y0 + z;
          break;
        case 2:
          x1 = x0 + z, y0 = y1 - z;
          break;
        case 3:
          x0 = x1 - z, y0 = y1 - z;
          break;
      }
    }
    if (this._root && this._root.length)
      this._root = node2;
  }
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
}
function tree_data() {
  var data = [];
  this.visit(function(node2) {
    if (!node2.length)
      do
        data.push(node2.data);
      while (node2 = node2.next);
  });
  return data;
}
function tree_extent(_2) {
  return arguments.length ? this.cover(+_2[0][0], +_2[0][1]).cover(+_2[1][0], +_2[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function Quad(node2, x0, y0, x1, y1) {
  this.node = node2;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
}
function tree_find(x2, y2, radius) {
  var data, x0 = this._x0, y0 = this._y0, x1, y1, x22, y22, x3 = this._x1, y3 = this._y1, quads = [], node2 = this._root, q, i2;
  if (node2)
    quads.push(new Quad(node2, x0, y0, x3, y3));
  if (radius == null)
    radius = Infinity;
  else {
    x0 = x2 - radius, y0 = y2 - radius;
    x3 = x2 + radius, y3 = y2 + radius;
    radius *= radius;
  }
  while (q = quads.pop()) {
    if (!(node2 = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x22 = q.x1) < x0 || (y22 = q.y1) < y0)
      continue;
    if (node2.length) {
      var xm = (x1 + x22) / 2, ym = (y1 + y22) / 2;
      quads.push(
        new Quad(node2[3], xm, ym, x22, y22),
        new Quad(node2[2], x1, ym, xm, y22),
        new Quad(node2[1], xm, y1, x22, ym),
        new Quad(node2[0], x1, y1, xm, ym)
      );
      if (i2 = (y2 >= ym) << 1 | x2 >= xm) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i2];
        quads[quads.length - 1 - i2] = q;
      }
    } else {
      var dx = x2 - +this._x.call(null, node2.data), dy = y2 - +this._y.call(null, node2.data), d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x2 - d, y0 = y2 - d;
        x3 = x2 + d, y3 = y2 + d;
        data = node2.data;
      }
    }
  }
  return data;
}
function tree_remove(d) {
  if (isNaN(x2 = +this._x.call(null, d)) || isNaN(y2 = +this._y.call(null, d)))
    return this;
  var parent, node2 = this._root, retainer, previous, next2, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x2, y2, xm, ym, right, bottom, i2, j;
  if (!node2)
    return this;
  if (node2.length)
    while (true) {
      if (right = x2 >= (xm = (x0 + x1) / 2))
        x0 = xm;
      else
        x1 = xm;
      if (bottom = y2 >= (ym = (y0 + y1) / 2))
        y0 = ym;
      else
        y1 = ym;
      if (!(parent = node2, node2 = node2[i2 = bottom << 1 | right]))
        return this;
      if (!node2.length)
        break;
      if (parent[i2 + 1 & 3] || parent[i2 + 2 & 3] || parent[i2 + 3 & 3])
        retainer = parent, j = i2;
    }
  while (node2.data !== d)
    if (!(previous = node2, node2 = node2.next))
      return this;
  if (next2 = node2.next)
    delete node2.next;
  if (previous)
    return next2 ? previous.next = next2 : delete previous.next, this;
  if (!parent)
    return this._root = next2, this;
  next2 ? parent[i2] = next2 : delete parent[i2];
  if ((node2 = parent[0] || parent[1] || parent[2] || parent[3]) && node2 === (parent[3] || parent[2] || parent[1] || parent[0]) && !node2.length) {
    if (retainer)
      retainer[j] = node2;
    else
      this._root = node2;
  }
  return this;
}
function removeAll(data) {
  for (var i2 = 0, n2 = data.length; i2 < n2; ++i2)
    this.remove(data[i2]);
  return this;
}
function tree_root() {
  return this._root;
}
function tree_size() {
  var size = 0;
  this.visit(function(node2) {
    if (!node2.length)
      do
        ++size;
      while (node2 = node2.next);
  });
  return size;
}
function tree_visit(callback) {
  var quads = [], q, node2 = this._root, child, x0, y0, x1, y1;
  if (node2)
    quads.push(new Quad(node2, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node2 = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node2.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node2[3])
        quads.push(new Quad(child, xm, ym, x1, y1));
      if (child = node2[2])
        quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node2[1])
        quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node2[0])
        quads.push(new Quad(child, x0, y0, xm, ym));
    }
  }
  return this;
}
function tree_visitAfter(callback) {
  var quads = [], next2 = [], q;
  if (this._root)
    quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node2 = q.node;
    if (node2.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node2[0])
        quads.push(new Quad(child, x0, y0, xm, ym));
      if (child = node2[1])
        quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node2[2])
        quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node2[3])
        quads.push(new Quad(child, xm, ym, x1, y1));
    }
    next2.push(q);
  }
  while (q = next2.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
}
function defaultX(d) {
  return d[0];
}
function tree_x(_2) {
  return arguments.length ? (this._x = _2, this) : this._x;
}
function defaultY(d) {
  return d[1];
}
function tree_y(_2) {
  return arguments.length ? (this._y = _2, this) : this._y;
}
function quadtree(nodes, x2, y2) {
  var tree = new Quadtree(x2 == null ? defaultX : x2, y2 == null ? defaultY : y2, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}
function Quadtree(x2, y2, x0, y0, x1, y1) {
  this._x = x2;
  this._y = y2;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = void 0;
}
function leaf_copy(leaf) {
  var copy2 = { data: leaf.data }, next2 = copy2;
  while (leaf = leaf.next)
    next2 = next2.next = { data: leaf.data };
  return copy2;
}
var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function() {
  var copy2 = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node2 = this._root, nodes, child;
  if (!node2)
    return copy2;
  if (!node2.length)
    return copy2._root = leaf_copy(node2), copy2;
  nodes = [{ source: node2, target: copy2._root = new Array(4) }];
  while (node2 = nodes.pop()) {
    for (var i2 = 0; i2 < 4; ++i2) {
      if (child = node2.source[i2]) {
        if (child.length)
          nodes.push({ source: child, target: node2.target[i2] = new Array(4) });
        else
          node2.target[i2] = leaf_copy(child);
      }
    }
  }
  return copy2;
};
treeProto.add = tree_add;
treeProto.addAll = addAll;
treeProto.cover = tree_cover;
treeProto.data = tree_data;
treeProto.extent = tree_extent;
treeProto.find = tree_find;
treeProto.remove = tree_remove;
treeProto.removeAll = removeAll;
treeProto.root = tree_root;
treeProto.size = tree_size;
treeProto.visit = tree_visit;
treeProto.visitAfter = tree_visitAfter;
treeProto.x = tree_x;
treeProto.y = tree_y;
function constant$1(x2) {
  return function() {
    return x2;
  };
}
function jiggle(random) {
  return (random() - 0.5) * 1e-6;
}
function x$1(d) {
  return d.x + d.vx;
}
function y$1(d) {
  return d.y + d.vy;
}
function forceCollide(radius) {
  var nodes, radii, random, strength = 1, iterations = 1;
  if (typeof radius !== "function")
    radius = constant$1(radius == null ? 1 : +radius);
  function force() {
    var i2, n2 = nodes.length, tree, node2, xi, yi, ri, ri2;
    for (var k = 0; k < iterations; ++k) {
      tree = quadtree(nodes, x$1, y$1).visitAfter(prepare);
      for (i2 = 0; i2 < n2; ++i2) {
        node2 = nodes[i2];
        ri = radii[node2.index], ri2 = ri * ri;
        xi = node2.x + node2.vx;
        yi = node2.y + node2.vy;
        tree.visit(apply);
      }
    }
    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r2 = ri + rj;
      if (data) {
        if (data.index > node2.index) {
          var x2 = xi - data.x - data.vx, y2 = yi - data.y - data.vy, l2 = x2 * x2 + y2 * y2;
          if (l2 < r2 * r2) {
            if (x2 === 0)
              x2 = jiggle(random), l2 += x2 * x2;
            if (y2 === 0)
              y2 = jiggle(random), l2 += y2 * y2;
            l2 = (r2 - (l2 = Math.sqrt(l2))) / l2 * strength;
            node2.vx += (x2 *= l2) * (r2 = (rj *= rj) / (ri2 + rj));
            node2.vy += (y2 *= l2) * r2;
            data.vx -= x2 * (r2 = 1 - r2);
            data.vy -= y2 * r2;
          }
        }
        return;
      }
      return x0 > xi + r2 || x1 < xi - r2 || y0 > yi + r2 || y1 < yi - r2;
    }
  }
  function prepare(quad) {
    if (quad.data)
      return quad.r = radii[quad.data.index];
    for (var i2 = quad.r = 0; i2 < 4; ++i2) {
      if (quad[i2] && quad[i2].r > quad.r) {
        quad.r = quad[i2].r;
      }
    }
  }
  function initialize() {
    if (!nodes)
      return;
    var i2, n2 = nodes.length, node2;
    radii = new Array(n2);
    for (i2 = 0; i2 < n2; ++i2)
      node2 = nodes[i2], radii[node2.index] = +radius(node2, i2, nodes);
  }
  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.iterations = function(_2) {
    return arguments.length ? (iterations = +_2, force) : iterations;
  };
  force.strength = function(_2) {
    return arguments.length ? (strength = +_2, force) : strength;
  };
  force.radius = function(_2) {
    return arguments.length ? (radius = typeof _2 === "function" ? _2 : constant$1(+_2), initialize(), force) : radius;
  };
  return force;
}
function index$e(d) {
  return d.index;
}
function find(nodeById, nodeId) {
  var node2 = nodeById.get(nodeId);
  if (!node2)
    throw new Error("node not found: " + nodeId);
  return node2;
}
function forceLink(links) {
  var id2 = index$e, strength = defaultStrength, strengths, distance2 = constant$1(30), distances, nodes, count2, bias, random, iterations = 1;
  if (links == null)
    links = [];
  function defaultStrength(link) {
    return 1 / Math.min(count2[link.source.index], count2[link.target.index]);
  }
  function force(alpha) {
    for (var k = 0, n2 = links.length; k < iterations; ++k) {
      for (var i2 = 0, link, source, target, x2, y2, l2, b; i2 < n2; ++i2) {
        link = links[i2], source = link.source, target = link.target;
        x2 = target.x + target.vx - source.x - source.vx || jiggle(random);
        y2 = target.y + target.vy - source.y - source.vy || jiggle(random);
        l2 = Math.sqrt(x2 * x2 + y2 * y2);
        l2 = (l2 - distances[i2]) / l2 * alpha * strengths[i2];
        x2 *= l2, y2 *= l2;
        target.vx -= x2 * (b = bias[i2]);
        target.vy -= y2 * b;
        source.vx += x2 * (b = 1 - b);
        source.vy += y2 * b;
      }
    }
  }
  function initialize() {
    if (!nodes)
      return;
    var i2, n2 = nodes.length, m2 = links.length, nodeById = new Map(nodes.map((d, i3) => [id2(d, i3, nodes), d])), link;
    for (i2 = 0, count2 = new Array(n2); i2 < m2; ++i2) {
      link = links[i2], link.index = i2;
      if (typeof link.source !== "object")
        link.source = find(nodeById, link.source);
      if (typeof link.target !== "object")
        link.target = find(nodeById, link.target);
      count2[link.source.index] = (count2[link.source.index] || 0) + 1;
      count2[link.target.index] = (count2[link.target.index] || 0) + 1;
    }
    for (i2 = 0, bias = new Array(m2); i2 < m2; ++i2) {
      link = links[i2], bias[i2] = count2[link.source.index] / (count2[link.source.index] + count2[link.target.index]);
    }
    strengths = new Array(m2), initializeStrength();
    distances = new Array(m2), initializeDistance();
  }
  function initializeStrength() {
    if (!nodes)
      return;
    for (var i2 = 0, n2 = links.length; i2 < n2; ++i2) {
      strengths[i2] = +strength(links[i2], i2, links);
    }
  }
  function initializeDistance() {
    if (!nodes)
      return;
    for (var i2 = 0, n2 = links.length; i2 < n2; ++i2) {
      distances[i2] = +distance2(links[i2], i2, links);
    }
  }
  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.links = function(_2) {
    return arguments.length ? (links = _2, initialize(), force) : links;
  };
  force.id = function(_2) {
    return arguments.length ? (id2 = _2, force) : id2;
  };
  force.iterations = function(_2) {
    return arguments.length ? (iterations = +_2, force) : iterations;
  };
  force.strength = function(_2) {
    return arguments.length ? (strength = typeof _2 === "function" ? _2 : constant$1(+_2), initializeStrength(), force) : strength;
  };
  force.distance = function(_2) {
    return arguments.length ? (distance2 = typeof _2 === "function" ? _2 : constant$1(+_2), initializeDistance(), force) : distance2;
  };
  return force;
}
const a = 1664525;
const c = 1013904223;
const m = 4294967296;
function lcg() {
  let s2 = 1;
  return () => (s2 = (a * s2 + c) % m) / m;
}
function x(d) {
  return d.x;
}
function y(d) {
  return d.y;
}
var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));
function forceSimulation(nodes) {
  var simulation, alpha = 1, alphaMin = 1e-3, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = /* @__PURE__ */ new Map(), stepper = timer(step), event = dispatch("tick", "end"), random = lcg();
  if (nodes == null)
    nodes = [];
  function step() {
    tick2();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }
  function tick2(iterations) {
    var i2, n2 = nodes.length, node2;
    if (iterations === void 0)
      iterations = 1;
    for (var k = 0; k < iterations; ++k) {
      alpha += (alphaTarget - alpha) * alphaDecay;
      forces.forEach(function(force) {
        force(alpha);
      });
      for (i2 = 0; i2 < n2; ++i2) {
        node2 = nodes[i2];
        if (node2.fx == null)
          node2.x += node2.vx *= velocityDecay;
        else
          node2.x = node2.fx, node2.vx = 0;
        if (node2.fy == null)
          node2.y += node2.vy *= velocityDecay;
        else
          node2.y = node2.fy, node2.vy = 0;
      }
    }
    return simulation;
  }
  function initializeNodes() {
    for (var i2 = 0, n2 = nodes.length, node2; i2 < n2; ++i2) {
      node2 = nodes[i2], node2.index = i2;
      if (node2.fx != null)
        node2.x = node2.fx;
      if (node2.fy != null)
        node2.y = node2.fy;
      if (isNaN(node2.x) || isNaN(node2.y)) {
        var radius = initialRadius * Math.sqrt(0.5 + i2), angle = i2 * initialAngle;
        node2.x = radius * Math.cos(angle);
        node2.y = radius * Math.sin(angle);
      }
      if (isNaN(node2.vx) || isNaN(node2.vy)) {
        node2.vx = node2.vy = 0;
      }
    }
  }
  function initializeForce(force) {
    if (force.initialize)
      force.initialize(nodes, random);
    return force;
  }
  initializeNodes();
  return simulation = {
    tick: tick2,
    restart: function() {
      return stepper.restart(step), simulation;
    },
    stop: function() {
      return stepper.stop(), simulation;
    },
    nodes: function(_2) {
      return arguments.length ? (nodes = _2, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
    },
    alpha: function(_2) {
      return arguments.length ? (alpha = +_2, simulation) : alpha;
    },
    alphaMin: function(_2) {
      return arguments.length ? (alphaMin = +_2, simulation) : alphaMin;
    },
    alphaDecay: function(_2) {
      return arguments.length ? (alphaDecay = +_2, simulation) : +alphaDecay;
    },
    alphaTarget: function(_2) {
      return arguments.length ? (alphaTarget = +_2, simulation) : alphaTarget;
    },
    velocityDecay: function(_2) {
      return arguments.length ? (velocityDecay = 1 - _2, simulation) : 1 - velocityDecay;
    },
    randomSource: function(_2) {
      return arguments.length ? (random = _2, forces.forEach(initializeForce), simulation) : random;
    },
    force: function(name, _2) {
      return arguments.length > 1 ? (_2 == null ? forces.delete(name) : forces.set(name, initializeForce(_2)), simulation) : forces.get(name);
    },
    find: function(x2, y2, radius) {
      var i2 = 0, n2 = nodes.length, dx, dy, d2, node2, closest;
      if (radius == null)
        radius = Infinity;
      else
        radius *= radius;
      for (i2 = 0; i2 < n2; ++i2) {
        node2 = nodes[i2];
        dx = x2 - node2.x;
        dy = y2 - node2.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius)
          closest = node2, radius = d2;
      }
      return closest;
    },
    on: function(name, _2) {
      return arguments.length > 1 ? (event.on(name, _2), simulation) : event.on(name);
    }
  };
}
function forceManyBody() {
  var nodes, node2, random, alpha, strength = constant$1(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
  function force(_2) {
    var i2, n2 = nodes.length, tree = quadtree(nodes, x, y).visitAfter(accumulate);
    for (alpha = _2, i2 = 0; i2 < n2; ++i2)
      node2 = nodes[i2], tree.visit(apply);
  }
  function initialize() {
    if (!nodes)
      return;
    var i2, n2 = nodes.length, node3;
    strengths = new Array(n2);
    for (i2 = 0; i2 < n2; ++i2)
      node3 = nodes[i2], strengths[node3.index] = +strength(node3, i2, nodes);
  }
  function accumulate(quad) {
    var strength2 = 0, q, c2, weight = 0, x2, y2, i2;
    if (quad.length) {
      for (x2 = y2 = i2 = 0; i2 < 4; ++i2) {
        if ((q = quad[i2]) && (c2 = Math.abs(q.value))) {
          strength2 += q.value, weight += c2, x2 += c2 * q.x, y2 += c2 * q.y;
        }
      }
      quad.x = x2 / weight;
      quad.y = y2 / weight;
    } else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do
        strength2 += strengths[q.data.index];
      while (q = q.next);
    }
    quad.value = strength2;
  }
  function apply(quad, x1, _2, x2) {
    if (!quad.value)
      return true;
    var x3 = quad.x - node2.x, y2 = quad.y - node2.y, w = x2 - x1, l2 = x3 * x3 + y2 * y2;
    if (w * w / theta2 < l2) {
      if (l2 < distanceMax2) {
        if (x3 === 0)
          x3 = jiggle(random), l2 += x3 * x3;
        if (y2 === 0)
          y2 = jiggle(random), l2 += y2 * y2;
        if (l2 < distanceMin2)
          l2 = Math.sqrt(distanceMin2 * l2);
        node2.vx += x3 * quad.value * alpha / l2;
        node2.vy += y2 * quad.value * alpha / l2;
      }
      return true;
    } else if (quad.length || l2 >= distanceMax2)
      return;
    if (quad.data !== node2 || quad.next) {
      if (x3 === 0)
        x3 = jiggle(random), l2 += x3 * x3;
      if (y2 === 0)
        y2 = jiggle(random), l2 += y2 * y2;
      if (l2 < distanceMin2)
        l2 = Math.sqrt(distanceMin2 * l2);
    }
    do
      if (quad.data !== node2) {
        w = strengths[quad.data.index] * alpha / l2;
        node2.vx += x3 * w;
        node2.vy += y2 * w;
      }
    while (quad = quad.next);
  }
  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.strength = function(_2) {
    return arguments.length ? (strength = typeof _2 === "function" ? _2 : constant$1(+_2), initialize(), force) : strength;
  };
  force.distanceMin = function(_2) {
    return arguments.length ? (distanceMin2 = _2 * _2, force) : Math.sqrt(distanceMin2);
  };
  force.distanceMax = function(_2) {
    return arguments.length ? (distanceMax2 = _2 * _2, force) : Math.sqrt(distanceMax2);
  };
  force.theta = function(_2) {
    return arguments.length ? (theta2 = _2 * _2, force) : Math.sqrt(theta2);
  };
  return force;
}
function count(node2) {
  var sum2 = 0, children2 = node2.children, i2 = children2 && children2.length;
  if (!i2)
    sum2 = 1;
  else
    while (--i2 >= 0)
      sum2 += children2[i2].value;
  node2.value = sum2;
}
function node_count() {
  return this.eachAfter(count);
}
function node_each(callback, that) {
  let index2 = -1;
  for (const node2 of this) {
    callback.call(that, node2, ++index2, this);
  }
  return this;
}
function node_eachBefore(callback, that) {
  var node2 = this, nodes = [node2], children2, i2, index2 = -1;
  while (node2 = nodes.pop()) {
    callback.call(that, node2, ++index2, this);
    if (children2 = node2.children) {
      for (i2 = children2.length - 1; i2 >= 0; --i2) {
        nodes.push(children2[i2]);
      }
    }
  }
  return this;
}
function node_eachAfter(callback, that) {
  var node2 = this, nodes = [node2], next2 = [], children2, i2, n2, index2 = -1;
  while (node2 = nodes.pop()) {
    next2.push(node2);
    if (children2 = node2.children) {
      for (i2 = 0, n2 = children2.length; i2 < n2; ++i2) {
        nodes.push(children2[i2]);
      }
    }
  }
  while (node2 = next2.pop()) {
    callback.call(that, node2, ++index2, this);
  }
  return this;
}
function node_find(callback, that) {
  let index2 = -1;
  for (const node2 of this) {
    if (callback.call(that, node2, ++index2, this)) {
      return node2;
    }
  }
}
function node_sum(value) {
  return this.eachAfter(function(node2) {
    var sum2 = +value(node2.data) || 0, children2 = node2.children, i2 = children2 && children2.length;
    while (--i2 >= 0)
      sum2 += children2[i2].value;
    node2.value = sum2;
  });
}
function node_sort(compare) {
  return this.eachBefore(function(node2) {
    if (node2.children) {
      node2.children.sort(compare);
    }
  });
}
function node_path(end) {
  var start = this, ancestor = leastCommonAncestor(start, end), nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
}
function leastCommonAncestor(a2, b) {
  if (a2 === b)
    return a2;
  var aNodes = a2.ancestors(), bNodes = b.ancestors(), c2 = null;
  a2 = aNodes.pop();
  b = bNodes.pop();
  while (a2 === b) {
    c2 = a2;
    a2 = aNodes.pop();
    b = bNodes.pop();
  }
  return c2;
}
function node_ancestors() {
  var node2 = this, nodes = [node2];
  while (node2 = node2.parent) {
    nodes.push(node2);
  }
  return nodes;
}
function node_descendants() {
  return Array.from(this);
}
function node_leaves() {
  var leaves = [];
  this.eachBefore(function(node2) {
    if (!node2.children) {
      leaves.push(node2);
    }
  });
  return leaves;
}
function node_links() {
  var root2 = this, links = [];
  root2.each(function(node2) {
    if (node2 !== root2) {
      links.push({ source: node2.parent, target: node2 });
    }
  });
  return links;
}
function* node_iterator() {
  var node2 = this, current, next2 = [node2], children2, i2, n2;
  do {
    current = next2.reverse(), next2 = [];
    while (node2 = current.pop()) {
      yield node2;
      if (children2 = node2.children) {
        for (i2 = 0, n2 = children2.length; i2 < n2; ++i2) {
          next2.push(children2[i2]);
        }
      }
    }
  } while (next2.length);
}
function hierarchy(data, children2) {
  if (data instanceof Map) {
    data = [void 0, data];
    if (children2 === void 0)
      children2 = mapChildren;
  } else if (children2 === void 0) {
    children2 = objectChildren;
  }
  var root2 = new Node(data), node2, nodes = [root2], child, childs, i2, n2;
  while (node2 = nodes.pop()) {
    if ((childs = children2(node2.data)) && (n2 = (childs = Array.from(childs)).length)) {
      node2.children = childs;
      for (i2 = n2 - 1; i2 >= 0; --i2) {
        nodes.push(child = childs[i2] = new Node(childs[i2]));
        child.parent = node2;
        child.depth = node2.depth + 1;
      }
    }
  }
  return root2.eachBefore(computeHeight);
}
function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}
function objectChildren(d) {
  return d.children;
}
function mapChildren(d) {
  return Array.isArray(d) ? d[1] : null;
}
function copyData(node2) {
  if (node2.data.value !== void 0)
    node2.value = node2.data.value;
  node2.data = node2.data.data;
}
function computeHeight(node2) {
  var height = 0;
  do
    node2.height = height;
  while ((node2 = node2.parent) && node2.height < ++height);
}
function Node(data) {
  this.data = data;
  this.depth = this.height = 0;
  this.parent = null;
}
Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  find: node_find,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy,
  [Symbol.iterator]: node_iterator
};
function required(f2) {
  if (typeof f2 !== "function")
    throw new Error();
  return f2;
}
function constantZero() {
  return 0;
}
function constant(x2) {
  return function() {
    return x2;
  };
}
function roundNode(node2) {
  node2.x0 = Math.round(node2.x0);
  node2.y0 = Math.round(node2.y0);
  node2.x1 = Math.round(node2.x1);
  node2.y1 = Math.round(node2.y1);
}
function treemapDice(parent, x0, y0, x1, y1) {
  var nodes = parent.children, node2, i2 = -1, n2 = nodes.length, k = parent.value && (x1 - x0) / parent.value;
  while (++i2 < n2) {
    node2 = nodes[i2], node2.y0 = y0, node2.y1 = y1;
    node2.x0 = x0, node2.x1 = x0 += node2.value * k;
  }
}
function treemapSlice(parent, x0, y0, x1, y1) {
  var nodes = parent.children, node2, i2 = -1, n2 = nodes.length, k = parent.value && (y1 - y0) / parent.value;
  while (++i2 < n2) {
    node2 = nodes[i2], node2.x0 = x0, node2.x1 = x1;
    node2.y0 = y0, node2.y1 = y0 += node2.value * k;
  }
}
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n2 = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
  while (i0 < n2) {
    dx = x1 - x0, dy = y1 - y0;
    do
      sumValue = nodes[i1++].value;
    while (!sumValue && i1 < n2);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);
    for (; i1 < n2; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue)
        minValue = nodeValue;
      if (nodeValue > maxValue)
        maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) {
        sumValue -= nodeValue;
        break;
      }
      minRatio = newRatio;
    }
    rows.push(row = { value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1) });
    if (row.dice)
      treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else
      treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }
  return rows;
}
const squarify = function custom(ratio) {
  function squarify2(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }
  squarify2.ratio = function(x2) {
    return custom((x2 = +x2) > 1 ? x2 : 1);
  };
  return squarify2;
}(phi);
function treemap() {
  var tile = squarify, round2 = false, dx = 1, dy = 1, paddingStack = [0], paddingInner = constantZero, paddingTop = constantZero, paddingRight = constantZero, paddingBottom = constantZero, paddingLeft = constantZero;
  function treemap2(root2) {
    root2.x0 = root2.y0 = 0;
    root2.x1 = dx;
    root2.y1 = dy;
    root2.eachBefore(positionNode);
    paddingStack = [0];
    if (round2)
      root2.eachBefore(roundNode);
    return root2;
  }
  function positionNode(node2) {
    var p2 = paddingStack[node2.depth], x0 = node2.x0 + p2, y0 = node2.y0 + p2, x1 = node2.x1 - p2, y1 = node2.y1 - p2;
    if (x1 < x0)
      x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0)
      y0 = y1 = (y0 + y1) / 2;
    node2.x0 = x0;
    node2.y0 = y0;
    node2.x1 = x1;
    node2.y1 = y1;
    if (node2.children) {
      p2 = paddingStack[node2.depth + 1] = paddingInner(node2) / 2;
      x0 += paddingLeft(node2) - p2;
      y0 += paddingTop(node2) - p2;
      x1 -= paddingRight(node2) - p2;
      y1 -= paddingBottom(node2) - p2;
      if (x1 < x0)
        x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0)
        y0 = y1 = (y0 + y1) / 2;
      tile(node2, x0, y0, x1, y1);
    }
  }
  treemap2.round = function(x2) {
    return arguments.length ? (round2 = !!x2, treemap2) : round2;
  };
  treemap2.size = function(x2) {
    return arguments.length ? (dx = +x2[0], dy = +x2[1], treemap2) : [dx, dy];
  };
  treemap2.tile = function(x2) {
    return arguments.length ? (tile = required(x2), treemap2) : tile;
  };
  treemap2.padding = function(x2) {
    return arguments.length ? treemap2.paddingInner(x2).paddingOuter(x2) : treemap2.paddingInner();
  };
  treemap2.paddingInner = function(x2) {
    return arguments.length ? (paddingInner = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingInner;
  };
  treemap2.paddingOuter = function(x2) {
    return arguments.length ? treemap2.paddingTop(x2).paddingRight(x2).paddingBottom(x2).paddingLeft(x2) : treemap2.paddingTop();
  };
  treemap2.paddingTop = function(x2) {
    return arguments.length ? (paddingTop = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingTop;
  };
  treemap2.paddingRight = function(x2) {
    return arguments.length ? (paddingRight = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingRight;
  };
  treemap2.paddingBottom = function(x2) {
    return arguments.length ? (paddingBottom = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingBottom;
  };
  treemap2.paddingLeft = function(x2) {
    return arguments.length ? (paddingLeft = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingLeft;
  };
  return treemap2;
}
function Transform2(k, x2, y2) {
  this.k = k;
  this.x = x2;
  this.y = y2;
}
Transform2.prototype = {
  constructor: Transform2,
  scale: function(k) {
    return k === 1 ? this : new Transform2(this.k * k, this.x, this.y);
  },
  translate: function(x2, y2) {
    return x2 === 0 & y2 === 0 ? this : new Transform2(this.k, this.x + this.k * x2, this.y + this.k * y2);
  },
  apply: function(point2) {
    return [point2[0] * this.k + this.x, point2[1] * this.k + this.y];
  },
  applyX: function(x2) {
    return x2 * this.k + this.x;
  },
  applyY: function(y2) {
    return y2 * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x2) {
    return (x2 - this.x) / this.k;
  },
  invertY: function(y2) {
    return (y2 - this.y) / this.k;
  },
  rescaleX: function(x2) {
    return x2.copy().domain(x2.range().map(this.invertX, this).map(x2.invert, x2));
  },
  rescaleY: function(y2) {
    return y2.copy().domain(y2.range().map(this.invertY, this).map(y2.invert, y2));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
Transform2.prototype;
function instance$d($$self, $$props, $$invalidate) {
  let groups;
  let $font;
  let $label;
  let $yScale;
  let $margin;
  let $chartHeight;
  let $layout;
  let $getColor;
  let $isColorActive;
  let $xScale;
  let $innerWidth;
  let $innerHeight;
  const { innerWidth, innerHeight, chartWidth, chartHeight, margin, focused, label, chartStore, contentShapes, font, focusable } = getInstance();
  component_subscribe($$self, innerWidth, (value) => $$invalidate(21, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(22, $innerHeight = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(16, $chartHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(15, $margin = value));
  component_subscribe($$self, label, (value) => $$invalidate(13, $label = value));
  component_subscribe($$self, font, (value) => $$invalidate(12, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== "bar") {
    throw new Error();
  }
  const { xDomain, xScale, yScale, yColumn, seriesDomain, hoveredX, hoveredSeries, isFocused, xColumn, seriesColumn, colorUtils: { getColor, isColorActive }, data, dataMap, layout, barPadding } = chartStore;
  component_subscribe($$self, xScale, (value) => $$invalidate(20, $xScale = value));
  component_subscribe($$self, yScale, (value) => $$invalidate(14, $yScale = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(18, $getColor = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(19, $isColorActive = value));
  component_subscribe($$self, layout, (value) => $$invalidate(17, $layout = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$layout, $xScale, $margin, $innerHeight, $innerWidth, $isColorActive, $getColor, $chartHeight, $yScale, $label, $font*/
    8384512) {
      $$invalidate(11, groups = (() => {
        const groups2 = xDomain.map((x2, xIndex) => {
          var _a2, _b;
          const xShape = new RectShape({
            ...$layout === "vertical" ? {
              x: ((_a2 = $xScale(x2)) != null ? _a2 : 0) - $xScale.step() / 2,
              y: $margin.top,
              width: $xScale.step(),
              height: $innerHeight
            } : {
              x: $margin.left,
              y: ((_b = $xScale(x2)) != null ? _b : 0) - $xScale.step() / 2,
              width: $innerWidth,
              height: $xScale.step()
            },
            data: { x: x2 },
            hoverable: true,
            priority: readable(10),
            events: {
              mouseenter: readable(() => {
                hoveredX.set(x2);
              }),
              mouseleave: readable(() => {
                hoveredX.set(null);
              })
            },
            props: readable({ fill: "transparent" })
          });
          const scale = xColumn.key === seriesColumn.key ? band().padding(barPadding).domain([x2]).range([0, $xScale.step()]) : band().padding(barPadding).domain(seriesDomain).range([0, $xScale.step()]);
          return new GroupShape({
            children: [
              xShape,
              ...seriesDomain.flatMap((series, seriesIndex) => {
                var _a3, _b2, _c, _d, _e;
                const record = dataMap.get([x2, series]);
                if (!record) {
                  return [];
                }
                if (!$isColorActive(record.color)) {
                  return [];
                }
                const value = record.y;
                const color2 = $getColor(record.color);
                if (value === 0) {
                  return [];
                }
                const seriesShape = new RectShape({
                  ...$layout === "vertical" ? {
                    x: xShape.$shapeProps.x + ((_a3 = scale(series)) != null ? _a3 : 0),
                    width: scale.bandwidth(),
                    ...computeHeight$1({
                      y1: $chartHeight - $margin.bottom,
                      y2: $yScale(value)
                    })
                  } : {
                    y: xShape.$shapeProps.y + ((_b2 = scale(series)) != null ? _b2 : 0),
                    height: scale.bandwidth(),
                    ...computeWidth({ x1: $margin.left, x2: $yScale(value) })
                  },
                  data: { x: x2, series },
                  clickable: true,
                  hoverable: true,
                  priority: readable(100),
                  events: {
                    click: derived([focusable], ([$focusable]) => () => {
                      if ($focusable) {
                        focused.update(($focused) => {
                          if (isFocused($focused, x2, series)) {
                            return $focused.filter((focused2) => !(focused2[xColumn.key] === x2 && focused2[seriesColumn.key] === series));
                          } else {
                            return [
                              ...$focused,
                              {
                                [xColumn.key]: x2,
                                [seriesColumn.key]: series
                              }
                            ];
                          }
                        });
                      }
                    }),
                    mouseenter: readable(() => {
                      hoveredX.set(x2);
                      hoveredSeries.set(series);
                    }),
                    mouseleave: readable(() => {
                      hoveredX.set(null);
                      hoveredSeries.set(null);
                    })
                  },
                  hovered: derived([hoveredX, hoveredSeries], ([$hoveredX, $hoveredSeries]) => {
                    return $hoveredX === x2 && $hoveredSeries === series;
                  }),
                  focused: derived([focused], ([$focused]) => {
                    return isFocused($focused, x2, series);
                  }),
                  inactive: derived([focused], ([$focused]) => {
                    const active = isFocused($focused, x2, series);
                    return $focused.length > 0 && !active;
                  }),
                  props: readable({ fill: color2 })
                });
                const valueAsText = yColumn.formatter(value);
                const labelShape = new TextShape({
                  text: valueAsText,
                  x: seriesShape.$shapeProps.x + seriesShape.$shapeProps.width / 2,
                  y: seriesShape.$shapeProps.y + seriesShape.$shapeProps.height / 2,
                  width: seriesShape.$shapeProps.width,
                  height: seriesShape.$shapeProps.height,
                  backgroundColor: color2,
                  textAlign: "center",
                  textBaseline: "middle",
                  inactive: derived([focused], ([$focused]) => {
                    const active = isFocused($focused, x2, series);
                    return $focused.length > 0 && !active;
                  }),
                  fontSize: (_d = (_c = $label.font) == null ? void 0 : _c.size) != null ? _d : $font.size,
                  fontFamily: ((_e = $label.font) == null ? void 0 : _e.family) || $font.family || DEFAULT_FONT_FAMILY
                });
                return [seriesShape, labelShape];
              })
            ]
          });
        });
        return groups2;
      })());
    }
    if ($$self.$$.dirty[0] & /*groups*/
    2048) {
      {
        contentShapes.set(groups);
      }
    }
  };
  return [
    innerWidth,
    innerHeight,
    chartHeight,
    margin,
    label,
    font,
    xScale,
    yScale,
    getColor,
    isColorActive,
    layout,
    groups,
    $font,
    $label,
    $yScale,
    $margin,
    $chartHeight,
    $layout,
    $getColor,
    $isColorActive,
    $xScale,
    $innerWidth,
    $innerHeight
  ];
}
let Bar$2 = class Bar2 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$d, null, safe_not_equal, {}, null, [-1, -1]);
  }
};
function instance$c($$self, $$props, $$invalidate) {
  let scale;
  let groups;
  let $font;
  let $label;
  let $percent;
  let $yScale;
  let $layout;
  let $getColor;
  let $total;
  let $isColorActive;
  let $xScale;
  let $innerWidth;
  let $margin;
  let $innerHeight;
  const { innerWidth, chartWidth, innerHeight, chartHeight, margin, focused, chartStore, contentShapes, label, font, focusable } = getInstance();
  component_subscribe($$self, innerWidth, (value) => $$invalidate(23, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(25, $innerHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(24, $margin = value));
  component_subscribe($$self, label, (value) => $$invalidate(15, $label = value));
  component_subscribe($$self, font, (value) => $$invalidate(14, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== "bar") {
    throw new Error();
  }
  const { data, dataMap, percent, xDomain, xScale, yScale, yColumn, seriesDomain, total, hoveredX, hoveredSeries, isFocused, xColumn, seriesColumn, colorUtils: { getColor, isColorActive }, layout, barPadding } = chartStore;
  component_subscribe($$self, percent, (value) => $$invalidate(16, $percent = value));
  component_subscribe($$self, xScale, (value) => $$invalidate(22, $xScale = value));
  component_subscribe($$self, yScale, (value) => $$invalidate(17, $yScale = value));
  component_subscribe($$self, total, (value) => $$invalidate(20, $total = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(19, $getColor = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(21, $isColorActive = value));
  component_subscribe($$self, layout, (value) => $$invalidate(18, $layout = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$xScale*/
    4194304) {
      $$invalidate(13, scale = band().padding(barPadding).domain(["0"]).range([0, $xScale.step()]));
    }
    if ($$self.$$.dirty[0] & /*$total, $layout, $xScale, $margin, $innerHeight, $innerWidth, $isColorActive, $percent, $getColor, scale, $yScale, $label, $font*/
    67100672) {
      $$invalidate(12, groups = (() => {
        const groups2 = xDomain.map((x2, xIndex) => {
          var _a2, _b;
          const t2 = $total({ x: x2 });
          const xShape = new RectShape({
            ...$layout === "vertical" ? {
              x: ((_a2 = $xScale(x2)) != null ? _a2 : 0) - $xScale.step() / 2,
              y: $margin.top,
              width: $xScale.step(),
              height: $innerHeight
            } : {
              x: $margin.left,
              y: ((_b = $xScale(x2)) != null ? _b : 0) - $xScale.step() / 2,
              width: $innerWidth,
              height: $xScale.step()
            },
            data: { x: x2 },
            hoverable: true,
            events: {
              mouseenter: readable(() => {
                hoveredX.set(x2);
              }),
              mouseleave: readable(() => {
                hoveredX.set(null);
              })
            },
            priority: readable(10),
            props: readable({ fill: "transparent" })
          });
          let prev2 = 0;
          return new GroupShape({
            children: [
              xShape,
              ...seriesDomain.flatMap((name, seriesIndex) => {
                var _a3, _b2, _c, _d, _e, _f;
                const record = dataMap.get([x2, name]);
                if (!record) {
                  return [];
                }
                if (!$isColorActive(record.color)) {
                  return [];
                }
                const currentValue = prev2 + asValidNumber(record.y);
                const prevValue = prev2;
                prev2 += record.y;
                const value = asValidNumber($percent ? $total({ x: x2, name }) / t2 : $total({ x: x2, name }));
                const color2 = $getColor(record.color);
                const seriesShape = new RectShape({
                  ...$layout === "vertical" ? {
                    x: xShape.$shapeProps.x + ((_a3 = scale("0")) != null ? _a3 : 0),
                    width: scale.bandwidth(),
                    ...computeHeight$1({
                      y1: $yScale(asValidNumber($percent ? currentValue / t2 : currentValue)),
                      y2: $yScale(asValidNumber($percent ? prevValue / t2 : prevValue))
                    })
                  } : {
                    y: xShape.$shapeProps.y + ((_b2 = scale("0")) != null ? _b2 : 0),
                    height: scale.bandwidth(),
                    ...computeWidth({
                      x1: $yScale(asValidNumber($percent ? currentValue / t2 : currentValue)),
                      x2: $yScale(asValidNumber($percent ? prevValue / t2 : prevValue))
                    })
                  },
                  data: { x: x2, name },
                  clickable: true,
                  hoverable: true,
                  priority: readable(100),
                  hovered: derived([hoveredX, hoveredSeries], ([$hoveredX, $hoveredSeries]) => $hoveredX === x2 && $hoveredSeries === name),
                  focused: derived([focused], ([$focused]) => {
                    return isFocused($focused, x2, name);
                  }),
                  inactive: derived([focused], ([$focused]) => {
                    const active = isFocused($focused, x2, name);
                    return $focused.length > 0 && !active;
                  }),
                  events: {
                    click: derived([focusable], ([$focusable]) => () => {
                      if ($focusable) {
                        focused.update(($focused) => {
                          if (isFocused($focused, x2, name)) {
                            return $focused.filter((focused2) => !(focused2[xColumn.key] === x2 && focused2[seriesColumn.key] === name));
                          } else {
                            return [
                              ...$focused,
                              {
                                [xColumn.key]: x2,
                                [seriesColumn.key]: name
                              }
                            ];
                          }
                        });
                      }
                    }),
                    mouseenter: readable(() => {
                      hoveredX.set(x2);
                      hoveredSeries.set(name);
                    }),
                    mouseleave: readable(() => {
                      hoveredX.set(null);
                      hoveredSeries.set(null);
                    })
                  },
                  props: readable({ fill: color2 })
                });
                return [
                  seriesShape,
                  new TextShape({
                    text: yColumn.formatter(value),
                    x: seriesShape.$shapeProps.x + seriesShape.$shapeProps.width / 2,
                    y: seriesShape.$shapeProps.y + seriesShape.$shapeProps.height / 2,
                    width: seriesShape.$shapeProps.width,
                    height: seriesShape.$shapeProps.height,
                    textAlign: "center",
                    textBaseline: "middle",
                    inactive: derived([focused], ([$focused]) => {
                      const active = isFocused($focused, x2, name);
                      return $focused.length > 0 && !active;
                    }),
                    backgroundColor: color2,
                    fontSize: (_d = (_c = $label.font) == null ? void 0 : _c.size) != null ? _d : $font.size,
                    fontFamily: (_f = ((_e = $label.font) == null ? void 0 : _e.family) || $font.family) != null ? _f : DEFAULT_FONT_FAMILY
                  })
                ];
              })
            ]
          });
        });
        return groups2;
      })());
    }
    if ($$self.$$.dirty[0] & /*groups*/
    4096) {
      {
        contentShapes.set(groups);
      }
    }
  };
  return [
    innerWidth,
    innerHeight,
    margin,
    label,
    font,
    percent,
    xScale,
    yScale,
    total,
    getColor,
    isColorActive,
    layout,
    groups,
    scale,
    $font,
    $label,
    $percent,
    $yScale,
    $layout,
    $getColor,
    $total,
    $isColorActive,
    $xScale,
    $innerWidth,
    $margin,
    $innerHeight
  ];
}
let StackBar$1 = class StackBar2 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$c, null, safe_not_equal, {}, null, [-1, -1]);
  }
};
function create_else_block$6(ctx2) {
  let vbar;
  let current;
  vbar = new Bar$2({});
  return {
    c() {
      create_component(vbar.$$.fragment);
    },
    m(target, anchor) {
      mount_component(vbar, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(vbar.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(vbar.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(vbar, detaching);
    }
  };
}
function create_if_block$k(ctx2) {
  let vstackbar;
  let current;
  vstackbar = new StackBar$1({});
  return {
    c() {
      create_component(vstackbar.$$.fragment);
    },
    m(target, anchor) {
      mount_component(vstackbar, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(vstackbar.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(vstackbar.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(vstackbar, detaching);
    }
  };
}
function create_fragment$s(ctx2) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block$k, create_else_block$6];
  const if_blocks = [];
  function select_block_type(ctx3, dirty) {
    if (
      /*$stack*/
      ctx3[0]
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx2);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx3);
      if (current_block_type_index !== previous_block_index) {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx3);
          if_block.c();
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if_blocks[current_block_type_index].d(detaching);
    }
  };
}
function instance_1$B($$self, $$props, $$invalidate) {
  let guideLines;
  let $margin;
  let $chartHeight;
  let $yScale;
  let $chartWidth;
  let $layout;
  let $total;
  let $percent;
  let $stack;
  let $getColor;
  let $yRange;
  let $mousePosition;
  let $hoveredX;
  const instance2 = getInstance();
  const { tooltipPosition, tooltipShown, mousePosition, xAxisConfig, yAxisConfig, ySubAxisConfig, chartWidth, chartHeight, chartStore, colorLegendConfig, guideShapes, margin } = instance2;
  component_subscribe($$self, mousePosition, (value) => $$invalidate(23, $mousePosition = value));
  component_subscribe($$self, chartWidth, (value) => $$invalidate(17, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(15, $chartHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(14, $margin = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== "bar") {
    throw new Error();
  }
  const { option, layout, stack, hoveredX, seriesColumn, xColumn, xDomain, data, yColumn, yRange, percent, colorColumn, colorUtils: { colorDomain, colorRange, getColor }, total, yScale } = chartStore;
  component_subscribe($$self, layout, (value) => $$invalidate(18, $layout = value));
  component_subscribe($$self, stack, (value) => $$invalidate(0, $stack = value));
  component_subscribe($$self, hoveredX, (value) => $$invalidate(24, $hoveredX = value));
  component_subscribe($$self, yRange, (value) => $$invalidate(22, $yRange = value));
  component_subscribe($$self, percent, (value) => $$invalidate(20, $percent = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(21, $getColor = value));
  component_subscribe($$self, total, (value) => $$invalidate(19, $total = value));
  component_subscribe($$self, yScale, (value) => $$invalidate(16, $yScale = value));
  $$self.$$.update = () => {
    var _a2, _b;
    if ($$self.$$.dirty[0] & /*$hoveredX, $mousePosition*/
    25165824) {
      {
        if ($hoveredX != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$layout, $chartWidth, $chartHeight, $yRange*/
    4620288) {
      {
        const xAxis = ({ margin: margin2 }) => {
          var _a3, _b2, _c, _d, _e, _f, _g;
          const xScale = point$1().padding(0.5).domain(xDomain).range($layout === "vertical" ? [margin2.left, $chartWidth - margin2.right] : [$chartHeight - margin2.bottom, margin2.top]);
          return new CategoryAxisConfig({
            show: (_b2 = (_a3 = option.xAxis) == null ? void 0 : _a3.show) != null ? _b2 : true,
            showTitle: (_d = (_c = option.xAxis) == null ? void 0 : _c.showTitle) != null ? _d : false,
            showTicks: (_f = (_e = option.xAxis) == null ? void 0 : _e.showTicks) != null ? _f : true,
            title: xColumn.title,
            step: xScale.step(),
            ticks: xDomain.map((tick2) => {
              var _a4;
              return {
                value: tick2,
                label: xColumn.formatter(tick2),
                pos: (_a4 = xScale(tick2)) != null ? _a4 : 0,
                active: derived([hoveredX], ([$hoveredX2]) => {
                  return $hoveredX2 === tick2;
                })
              };
            }),
            rotation: (_g = option.xAxis) == null ? void 0 : _g.rotation
          });
        };
        const yAxis = ({ margin: margin2 }) => {
          var _a3, _b2, _c, _d, _e, _f, _g;
          const yScale2 = linear().domain([$yRange[0], $yRange[1]]).range($layout === "vertical" ? [$chartHeight - margin2.bottom, margin2.top] : [margin2.left, $chartWidth - margin2.right]).nice();
          return new ValueAxisConfig({
            show: (_b2 = (_a3 = option.yAxis) == null ? void 0 : _a3.show) != null ? _b2 : true,
            showTitle: (_d = (_c = option.yAxis) == null ? void 0 : _c.showTitle) != null ? _d : false,
            showTicks: (_f = (_e = option.yAxis) == null ? void 0 : _e.showTicks) != null ? _f : true,
            title: yColumn.title,
            scale: yScale2,
            axisFormatter: yColumn.axisFormatter,
            rotation: (_g = option.yAxis) == null ? void 0 : _g.rotation
          });
        };
        if ($layout === "vertical") {
          xAxisConfig.set(xAxis);
          yAxisConfig.set(yAxis);
        } else {
          xAxisConfig.set(yAxis);
          yAxisConfig.set(xAxis);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$getColor*/
    2097152) {
      {
        if (colorColumn.type === "value") {
          colorLegendConfig.set({
            show: true,
            type: "value",
            column: colorColumn,
            min: colorRange[0],
            max: colorRange[1],
            getColor: (value) => $getColor(value * (colorRange[1] - colorRange[0]) + colorRange[0])
          });
        } else if (colorColumn.type === "category") {
          colorLegendConfig.set({
            show: true,
            type: "category",
            formatter: colorColumn.formatter,
            domain: colorDomain,
            getColor: (value) => $getColor(value)
          });
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$stack, $percent, $total*/
    1572865) {
      {
        instance2.tableConfig.set({
          columns: [
            {
              ...seriesColumn,
              key: "name",
              type: "dimension",
              align: "left"
            },
            {
              ...xColumn,
              key: "x",
              type: "dimension",
              align: "left"
            },
            {
              ...yColumn,
              key: "y",
              type: "metric",
              align: "right"
            }
          ],
          data: data.map((d) => {
            var _a3;
            return {
              x: d.x,
              name: d.series,
              y: $stack && $percent ? ((_a3 = d.y) != null ? _a3 : 0) / $total({ x: d.x }) : d.y
            };
          })
        });
      }
    }
    if ($$self.$$.dirty[0] & /*$layout, $yScale, $margin, $chartWidth, $chartHeight*/
    507904) {
      $$invalidate(13, guideLines = (_b = (_a2 = option.guideLines) == null ? void 0 : _a2.flatMap((n2) => {
        if (n2.data.yAxis != null) {
          if ($layout === "vertical") {
            return [
              new LineShape({
                y1: $yScale(n2.data.yAxis),
                y2: $yScale(n2.data.yAxis),
                x1: $margin.left,
                x2: $chartWidth - $margin.right,
                props: readable({
                  fill: "transparent",
                  stroke: "#aaa",
                  "stroke-width": 2,
                  "stroke-dasharray": "8px 8px"
                })
              })
            ];
          }
          return [
            new LineShape({
              x1: $yScale(n2.data.yAxis),
              x2: $yScale(n2.data.yAxis),
              y1: $margin.top,
              y2: $chartHeight - $margin.bottom,
              props: readable({
                fill: "transparent",
                stroke: "#aaa",
                "stroke-width": 2,
                "stroke-dasharray": "8px 8px"
              })
            })
          ];
        }
        return [];
      })) != null ? _b : []);
    }
    if ($$self.$$.dirty[0] & /*guideLines*/
    8192) {
      {
        guideShapes.set([...guideLines]);
      }
    }
  };
  return [
    $stack,
    mousePosition,
    chartWidth,
    chartHeight,
    margin,
    layout,
    stack,
    hoveredX,
    yRange,
    percent,
    getColor,
    total,
    yScale,
    guideLines,
    $margin,
    $chartHeight,
    $yScale,
    $chartWidth,
    $layout,
    $total,
    $percent,
    $getColor,
    $yRange,
    $mousePosition,
    $hoveredX
  ];
}
let Content$f = class Content2 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$B, create_fragment$s, safe_not_equal, {}, null, [-1, -1]);
  }
};
function get_each_context$7(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[23] = list[i2];
  child_ctx[25] = i2;
  return child_ctx;
}
function create_if_block$j(ctx2) {
  let div2;
  let div0;
  let t0_value = (
    /*$hoveredX*/
    (ctx2[1] ? (
      /*xColumn*/
      ctx2[13].formatter(
        /*$hoveredX*/
        ctx2[1]
      )
    ) : "") + ""
  );
  let t0;
  let t1;
  let div1;
  let each_value = ensure_array_like(
    /*xColumn*/
    ctx2[13].key === /*seriesColumn*/
    ctx2[8].key ? [
      /*$hoveredX*/
      ctx2[1]
    ] : (
      /*seriesDomain*/
      ctx2[9]
    )
  );
  let each_blocks = [];
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    each_blocks[i2] = create_each_block$7(get_each_context$7(ctx2, each_value, i2));
  }
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      t0 = text(t0_value);
      t1 = space();
      div1 = element("div");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      attr(div2, "style", tooltipOuter.toString());
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append$2(div2, div0);
      append$2(div0, t0);
      append$2(div2, t1);
      append$2(div2, div1);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(div1, null);
        }
      }
    },
    p(ctx3, dirty) {
      if (dirty & /*$hoveredX*/
      2 && t0_value !== (t0_value = /*$hoveredX*/
      (ctx3[1] ? (
        /*xColumn*/
        ctx3[13].formatter(
          /*$hoveredX*/
          ctx3[1]
        )
      ) : "") + ""))
        set_data(t0, t0_value);
      if (dirty & /*yColumn, $total, $hoveredX, xColumn, seriesColumn, seriesDomain, $stack, $percent, radius, $getColor, findRecord*/
      156479) {
        each_value = ensure_array_like(
          /*xColumn*/
          ctx3[13].key === /*seriesColumn*/
          ctx3[8].key ? [
            /*$hoveredX*/
            ctx3[1]
          ] : (
            /*seriesDomain*/
            ctx3[9]
          )
        );
        let i2;
        for (i2 = 0; i2 < each_value.length; i2 += 1) {
          const child_ctx = get_each_context$7(ctx3, each_value, i2);
          if (each_blocks[i2]) {
            each_blocks[i2].p(child_ctx, dirty);
          } else {
            each_blocks[i2] = create_each_block$7(child_ctx);
            each_blocks[i2].c();
            each_blocks[i2].m(div1, null);
          }
        }
        for (; i2 < each_blocks.length; i2 += 1) {
          each_blocks[i2].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    d(detaching) {
      if (detaching) {
        detach(div2);
      }
      destroy_each(each_blocks, detaching);
    }
  };
}
function create_else_block$5(ctx2) {
  let t_value = (
    /*yColumn*/
    ctx2[14].formatter(
      /*$total*/
      ctx2[5]({
        x: (
          /*$hoveredX*/
          ctx2[1]
        ),
        name: (
          /*s*/
          ctx2[23]
        )
      })
    ) + ""
  );
  let t2;
  return {
    c() {
      t2 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t2, anchor);
    },
    p(ctx3, dirty) {
      if (dirty & /*$total, $hoveredX*/
      34 && t_value !== (t_value = /*yColumn*/
      ctx3[14].formatter(
        /*$total*/
        ctx3[5]({
          x: (
            /*$hoveredX*/
            ctx3[1]
          ),
          name: (
            /*s*/
            ctx3[23]
          )
        })
      ) + ""))
        set_data(t2, t_value);
    },
    d(detaching) {
      if (detaching) {
        detach(t2);
      }
    }
  };
}
function create_if_block_1$6(ctx2) {
  let t_value = (
    /*yColumn*/
    ctx2[14].formatter(
      /*$total*/
      ctx2[5]({
        x: (
          /*$hoveredX*/
          ctx2[1]
        ),
        name: (
          /*s*/
          ctx2[23]
        )
      }) / /*$total*/
      ctx2[5]({ x: (
        /*$hoveredX*/
        ctx2[1]
      ) })
    ) + ""
  );
  let t2;
  return {
    c() {
      t2 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t2, anchor);
    },
    p(ctx3, dirty) {
      if (dirty & /*$total, $hoveredX*/
      34 && t_value !== (t_value = /*yColumn*/
      ctx3[14].formatter(
        /*$total*/
        ctx3[5]({
          x: (
            /*$hoveredX*/
            ctx3[1]
          ),
          name: (
            /*s*/
            ctx3[23]
          )
        }) / /*$total*/
        ctx3[5]({ x: (
          /*$hoveredX*/
          ctx3[1]
        ) })
      ) + ""))
        set_data(t2, t_value);
    },
    d(detaching) {
      if (detaching) {
        detach(t2);
      }
    }
  };
}
function create_each_block$7(ctx2) {
  let div3;
  let div0;
  let div0_style_value;
  let t0;
  let div1;
  let t1_value = (
    /*seriesColumn*/
    ctx2[8].formatter(
      /*s*/
      ctx2[23]
    ) + ""
  );
  let t1;
  let t2;
  let div2;
  let t3;
  function select_block_type(ctx3, dirty) {
    if (
      /*$stack*/
      ctx3[3] && /*$percent*/
      ctx3[4]
    )
      return create_if_block_1$6;
    return create_else_block$5;
  }
  let current_block_type = select_block_type(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      var _a2;
      div3 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = text(t1_value);
      t2 = space();
      div2 = element("div");
      if_block.c();
      t3 = space();
      attr(div0, "style", div0_style_value = symbol({
        width: (
          /*radius*/
          ctx2[0]
        ),
        height: (
          /*radius*/
          ctx2[0]
        ),
        color: (
          /*$getColor*/
          ctx2[2](
            /*findRecord*/
            (_a2 = ctx2[17](
              /*$hoveredX*/
              ctx2[1],
              /*s*/
              ctx2[23]
            )) == null ? void 0 : _a2.color
          )
        )
      }));
      attr(div1, "style", tooltipItemLabel);
      attr(div2, "style", tooltipItemValue);
      attr(div3, "style", tooltipItem);
    },
    m(target, anchor) {
      insert(target, div3, anchor);
      append$2(div3, div0);
      append$2(div3, t0);
      append$2(div3, div1);
      append$2(div1, t1);
      append$2(div3, t2);
      append$2(div3, div2);
      if_block.m(div2, null);
      append$2(div3, t3);
    },
    p(ctx3, dirty) {
      var _a2;
      if (dirty & /*radius, $getColor, $hoveredX*/
      7 && div0_style_value !== (div0_style_value = symbol({
        width: (
          /*radius*/
          ctx3[0]
        ),
        height: (
          /*radius*/
          ctx3[0]
        ),
        color: (
          /*$getColor*/
          ctx3[2](
            /*findRecord*/
            (_a2 = ctx3[17](
              /*$hoveredX*/
              ctx3[1],
              /*s*/
              ctx3[23]
            )) == null ? void 0 : _a2.color
          )
        )
      }))) {
        attr(div0, "style", div0_style_value);
      }
      if (dirty & /*$hoveredX*/
      2 && t1_value !== (t1_value = /*seriesColumn*/
      ctx3[8].formatter(
        /*s*/
        ctx3[23]
      ) + ""))
        set_data(t1, t1_value);
      if (current_block_type === (current_block_type = select_block_type(ctx3)) && if_block) {
        if_block.p(ctx3, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx3);
        if (if_block) {
          if_block.c();
          if_block.m(div2, null);
        }
      }
    },
    d(detaching) {
      if (detaching) {
        detach(div3);
      }
      if_block.d();
    }
  };
}
function create_fragment$r(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*$hoveredX*/
    ctx2[1] != null && create_if_block$j(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*$hoveredX*/
        ctx3[1] != null
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$j(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$A($$self, $$props, $$invalidate) {
  let radius;
  let $font;
  let $tooltip;
  let $hoveredX;
  let $getColor;
  let $stack;
  let $percent;
  let $total;
  const instance2 = getInstance();
  const { chartStore, font, tooltip } = instance2;
  component_subscribe($$self, font, (value) => $$invalidate(18, $font = value));
  component_subscribe($$self, tooltip, (value) => $$invalidate(19, $tooltip = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== "bar" && (chartStore == null ? void 0 : chartStore.type) !== "line") {
    throw new Error();
  }
  const { seriesColumn, seriesDomain, stack, percent, total, xColumn, yColumn, hoveredX, colorUtils: { getColor }, dataMap } = chartStore;
  component_subscribe($$self, stack, (value) => $$invalidate(3, $stack = value));
  component_subscribe($$self, percent, (value) => $$invalidate(4, $percent = value));
  component_subscribe($$self, total, (value) => $$invalidate(5, $total = value));
  component_subscribe($$self, hoveredX, (value) => $$invalidate(1, $hoveredX = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(2, $getColor = value));
  function findRecord(x2, series) {
    return dataMap.get([x2, series]);
  }
  $$self.$$.update = () => {
    var _a2, _b;
    if ($$self.$$.dirty & /*$tooltip, $font*/
    786432) {
      $$invalidate(0, radius = (_b = (_a2 = $tooltip.font) == null ? void 0 : _a2.size) != null ? _b : $font.size);
    }
  };
  return [
    radius,
    $hoveredX,
    $getColor,
    $stack,
    $percent,
    $total,
    font,
    tooltip,
    seriesColumn,
    seriesDomain,
    stack,
    percent,
    total,
    xColumn,
    yColumn,
    hoveredX,
    getColor,
    findRecord,
    $font,
    $tooltip
  ];
}
let TooltipContent$b = class TooltipContent extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$A, create_fragment$r, safe_not_equal, {});
  }
};
const chartTypes = ["bar", "line"];
let Store$f = class Store {
  constructor(instance2) {
    __publicField(this, "type");
    __publicField(this, "intance");
    __publicField(this, "option");
    __publicField(this, "data");
    __publicField(this, "dataMap");
    __publicField(this, "layout");
    __publicField(this, "xColumn");
    __publicField(this, "yColumn");
    __publicField(this, "seriesColumn");
    __publicField(this, "colorColumn");
    __publicField(this, "colorUtils");
    __publicField(this, "xDomain");
    __publicField(this, "seriesDomain");
    __publicField(this, "total");
    __publicField(this, "stack");
    __publicField(this, "percent");
    __publicField(this, "xScale");
    __publicField(this, "yScale");
    __publicField(this, "yRange");
    __publicField(this, "barPadding");
    __publicField(this, "hoveredX");
    __publicField(this, "hoveredSeries");
    __publicField(this, "isFocused");
    __publicField(this, "toggleFocused");
    var _a2, _b, _c, _d, _e;
    this.intance = instance2;
    const { chartWidth, chartHeight, margin, focused } = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    this.type = option.type;
    const layout = writable((_a2 = option.layout) != null ? _a2 : "vertical");
    const stack = writable(option.stack);
    const percent = writable(option.stack && option.percent);
    const xColumn = parseCategoryColumn({
      column: (_b = option.xColumn) != null ? _b : {
        key: "__X__"
      }
    });
    const yColumn = parseValueColumn({
      column: {
        ...option.yColumn,
        ...option.percent ? {
          formatter: formatPercent,
          axisFormatter: axisFormatPercent
        } : {}
      }
    });
    const seriesColumn = parseCategoryColumn({
      column: (_c = option.seriesColumn) != null ? _c : {
        key: "__SERIES__"
      }
    });
    let colorColumn;
    if (option.colorColumn) {
      colorColumn = option.colorColumn.type === "category" ? parseCategoryColumn({
        column: option.colorColumn
      }) : parseValueColumn({
        column: option.colorColumn
      });
    } else {
      colorColumn = seriesColumn;
    }
    this.colorColumn = colorColumn;
    const hoveredX = writable(null);
    const hoveredSeries = writable(null);
    const data = dataMapper((_d = option.data) != null ? _d : [], [
      { key: "x", column: xColumn },
      {
        key: "y",
        column: yColumn
      },
      { key: "series", column: seriesColumn },
      { key: "color", column: colorColumn }
    ]).filter(
      (x2, i2, self2) => i2 === self2.findIndex((y2) => x2.x === y2.x && x2.series === y2.series)
    );
    this.dataMap = new CachedMap({
      data,
      key: (row) => [row.x, row.series]
    });
    this.data = data;
    const xDomain = [
      ...xColumn.domain || new Group(data, (row) => row.x).keys()
    ];
    const seriesDomain = [
      ...seriesColumn.domain || new Group(data, (row) => row.series).keys()
    ];
    const valueByXDomain = /* @__PURE__ */ new Map();
    xDomain.forEach((x2) => {
      let total2 = 0;
      data.forEach((record) => {
        if (record.x === x2) {
          total2 += asValidNumber(record.y);
        }
      });
      valueByXDomain.set(x2, total2);
    });
    sortDomain({
      column: xColumn,
      valueByDomain: valueByXDomain,
      domain: xDomain
    });
    const valueBySeriesDomain = /* @__PURE__ */ new Map();
    seriesDomain.forEach((x2) => {
      let total2 = 0;
      data.forEach((record) => {
        if (record.series === x2) {
          total2 += asValidNumber(record.y);
        }
      });
      valueBySeriesDomain.set(x2, total2);
    });
    sortDomain({
      column: seriesColumn,
      valueByDomain: valueBySeriesDomain,
      domain: seriesDomain
    });
    const colorUtils = parseColorUtils({ colorColumn, data, instance: instance2 });
    this.colorUtils = colorUtils;
    const { isColorActive, colorDomain } = colorUtils;
    if (colorColumn.type === "category") {
      const valueByColorDomain = /* @__PURE__ */ new Map();
      colorDomain.forEach((x2) => {
        let total2 = 0;
        data.forEach((record) => {
          if (record.series === x2) {
            total2 += asValidNumber(record.y);
          }
        });
        valueByColorDomain.set(x2, total2);
      });
      sortDomain({
        column: seriesColumn,
        valueByDomain: valueByColorDomain,
        domain: colorDomain
      });
    }
    const total = derived([isColorActive], ([$isColorActive]) => {
      return ({ x: x2, name }) => {
        return sum(
          data.filter((d) => {
            if (x2 == null) {
              return true;
            }
            return d.x === x2;
          }).filter((d) => {
            if (name == null) {
              return true;
            }
            return d.series === name;
          }).filter((d) => $isColorActive(d.color)),
          (d) => d.y
        );
      };
    });
    const xScale = derived(
      [margin, chartWidth, chartHeight, layout],
      ([margin2, chartWidth2, chartHeight2, layout2]) => {
        return point$1().padding(0.5).domain(xDomain).range(
          layout2 === "vertical" ? [margin2.left, chartWidth2 - margin2.right] : [chartHeight2 - margin2.bottom, margin2.top]
        );
      }
    );
    const yRange = derived(
      [isColorActive, stack, percent],
      ([$isColorActive, stack2, percent2]) => {
        var _a3, _b2;
        if (stack2 && percent2) {
          return [0, 1];
        }
        const g = new Group(
          data,
          (d) => stack2 ? [d.x] : [d.x, d.series],
          (d) => $isColorActive(d.color),
          (d) => sum(d, (d2) => d2.y)
        );
        return [
          (_a3 = yColumn.min) != null ? _a3 : min$1(g.storeData, (d) => d.value),
          (_b2 = yColumn.max) != null ? _b2 : max$1(g.storeData, (d) => d.value)
        ];
      }
    );
    const yScale = derived(
      [yRange, margin, chartWidth, chartHeight, layout],
      ([yRange2, margin2, chartWidth2, chartHeight2, layout2]) => {
        return linear().domain([yRange2[0], yRange2[1]]).range(
          layout2 === "vertical" ? [chartHeight2 - margin2.bottom, margin2.top] : [margin2.left, chartWidth2 - margin2.right]
        ).nice();
      }
    );
    function isFocused($focused, x2, name) {
      return $focused.some(
        (focused2) => focused2[xColumn.key] === x2 && focused2[seriesColumn.key] === name
      );
    }
    function toggleFocused($focused, x2, name) {
      if (isFocused($focused, x2, name)) {
        focused.update((focused2) => {
          return focused2.filter(
            (focused3) => !(focused3[xColumn.key] === x2 && focused3[seriesColumn.key] === name)
          );
        });
      } else {
        focused.update((focused2) => {
          return [
            ...focused2,
            {
              [xColumn.key]: x2,
              [seriesColumn.key]: name
            }
          ];
        });
      }
    }
    this.option = option;
    this.layout = layout;
    this.xColumn = xColumn;
    this.yColumn = yColumn;
    this.seriesColumn = seriesColumn;
    this.xDomain = xDomain;
    this.seriesDomain = seriesDomain;
    this.total = total;
    this.stack = stack;
    this.percent = percent;
    this.xScale = xScale;
    this.yScale = yScale;
    this.yRange = yRange;
    this.hoveredX = hoveredX;
    this.hoveredSeries = hoveredSeries;
    this.isFocused = isFocused;
    this.toggleFocused = toggleFocused;
    this.barPadding = (_e = option.barPadding) != null ? _e : 0.2;
    instance2.setTimeoutIfBrowser(() => {
      if (this.type === "bar") {
        instance2.chartContent.set(Content$f);
      } else {
        instance2.chartContent.set(LineContent);
      }
      instance2.tooltipContent.set(TooltipContent$b);
    });
    instance2.menuExtraButtons.set([
      // {
      //     key: 'switch',
      //     title: '線グラフに切り替え',
      //     onClick: () => {
      //         instance.option.update((option) => {
      //             return { ...option, type: 'line' } as any;
      //         });
      //     }
      // },
      // {
      //     key: 'stack',
      //     title: '積み上げ',
      //     onClick: () => {
      //         stack.update((stack) => !stack);
      //     }
      // },
      // {
      //     key: 'stack',
      //     title: '比率',
      //     onClick: () => {
      //         percent.update((value) => !value);
      //     }
      // }
    ]);
  }
};
const index$d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$f,
  chartTypes
}, Symbol.toStringTag, { value: "Module" }));
const headerWidth = 200;
function instance_1$z($$self, $$props, $$invalidate) {
  let xCellWidth;
  let yCellHeight;
  let $font;
  let $innerHeight;
  let $innerWidth;
  const instance2 = getInstance();
  const { chartWidth, chartHeight, font, margin, chartStore, contentShapes, focused, focusable, mousePosition, innerWidth, innerHeight } = instance2;
  component_subscribe($$self, font, (value) => $$invalidate(5, $font = value));
  component_subscribe($$self, innerWidth, (value) => $$invalidate(7, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(6, $innerHeight = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== "crossTable") {
    throw new Error();
  }
  const { xColumn, yColumn, valueColumn, xDomain, yDomain, isFocused, toggleFocused, data } = chartStore;
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$innerWidth*/
    128) {
      $$invalidate(4, xCellWidth = ($innerWidth - headerWidth) / xDomain.length);
    }
    if ($$self.$$.dirty & /*$innerHeight*/
    64) {
      $$invalidate(3, yCellHeight = ($innerHeight - headerWidth) / yDomain.length);
    }
    if ($$self.$$.dirty & /*xCellWidth, $font, yCellHeight*/
    56) {
      {
        const xCells = [];
        xDomain.forEach((value, i2) => {
          const width = xCellWidth;
          const height = headerWidth;
          const rect = new RectShape({
            width,
            height,
            props: readable({
              fill: "none",
              stroke: "#ddd",
              "stroke-width": 0.5
            })
          });
          const text2 = new TextShape({
            fontFamily: $font.family,
            fontSize: $font.size,
            width,
            height,
            x: width / 2,
            y: height / 2,
            textAlign: "center",
            textBaseline: "middle",
            overflow: "ellipsis",
            text: `${value}`
          });
          xCells.push(new GroupShape({
            x: i2 * xCellWidth,
            children: [rect, text2]
          }));
        });
        const xGroup = new GroupShape({ x: headerWidth, children: xCells });
        const yCells = [];
        yDomain.forEach((value, i2) => {
          const width = headerWidth;
          const height = yCellHeight;
          const rect = new RectShape({
            width,
            height,
            props: readable({
              fill: "none",
              stroke: "#ddd",
              "stroke-width": 0.5
            })
          });
          const text2 = new TextShape({
            fontFamily: $font.family,
            fontSize: $font.size,
            width,
            height,
            x: width / 2,
            y: height / 2,
            textAlign: "center",
            textBaseline: "middle",
            overflow: "ellipsis",
            text: `${value}`
          });
          yCells.push(new GroupShape({
            y: i2 * yCellHeight,
            children: [rect, text2]
          }));
        });
        const yGroup = new GroupShape({ y: headerWidth, children: yCells });
        const valueGroup = new GroupShape({
          x: headerWidth,
          y: headerWidth,
          children: xDomain.map((xValue, xIndex) => {
            return new GroupShape({
              x: xIndex * xCellWidth,
              children: yDomain.map((yValue, yIndex) => {
                const width = xCellWidth;
                const height = yCellHeight;
                const record = data.find((row) => {
                  return row.x === xValue && row.y === yValue;
                });
                const rect = new RectShape({
                  width,
                  height,
                  props: readable({
                    fill: "none",
                    stroke: "#ddd",
                    "stroke-width": 0.5
                  })
                });
                const text2 = new TextShape({
                  fontFamily: $font.family,
                  fontSize: $font.size,
                  width,
                  height,
                  x: width / 2,
                  y: height / 2,
                  textAlign: "center",
                  textBaseline: "middle",
                  overflow: "ellipsis"
                });
                if (record) {
                  const valueText = valueColumn.formatter(record.value);
                  text2.shapeProps.update((n2) => ({ ...n2, text: valueText }));
                }
                return new GroupShape({
                  y: yIndex * yCellHeight,
                  children: [rect, text2]
                });
              })
            });
          })
        });
        contentShapes.set([xGroup, yGroup, valueGroup]);
      }
    }
  };
  return [
    font,
    innerWidth,
    innerHeight,
    yCellHeight,
    xCellWidth,
    $font,
    $innerHeight,
    $innerWidth
  ];
}
let Content$e = class Content3 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$z, null, safe_not_equal, {});
  }
};
const chartType$e = "crossTable";
const defaultOption$3 = {};
let Store$e = class Store2 {
  constructor(instance2) {
    __publicField(this, "type", chartType$e);
    __publicField(this, "instance");
    __publicField(this, "data");
    __publicField(this, "xColumn");
    __publicField(this, "xDomain");
    __publicField(this, "yColumn");
    __publicField(this, "yDomain");
    __publicField(this, "valueColumn");
    __publicField(this, "isFocused");
    __publicField(this, "toggleFocused");
    const { focused } = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    const {
      data: _data,
      xColumn: _xColumn,
      yColumn: _yColumn,
      valueColumn: _valueColumn
    } = option;
    const xColumn = parseCategoryColumn({ column: _xColumn });
    const yColumn = parseCategoryColumn({ column: _yColumn });
    const valueColumn = parseValueColumn({ column: _valueColumn });
    const data = dataMapper(_data != null ? _data : [], [
      { key: "x", column: xColumn },
      { key: "y", column: yColumn },
      { key: "value", column: valueColumn }
    ]);
    function isFocused($focused, kvs) {
      return $focused.some(
        (focused2) => Object.keys(kvs).every((key) => focused2[key] === kvs[key])
      );
    }
    function toggleFocused($focused, kvs) {
      if (Object.keys(kvs).length === 0) {
        return;
      }
      if (isFocused($focused, kvs)) {
        focused.update((focused2) => {
          return focused2.filter(
            (focused3) => !Object.keys(kvs).every(
              (key) => focused3[key] === kvs[key]
            )
          );
        });
      } else {
        focused.update((focused2) => {
          return [
            ...focused2,
            {
              ...kvs
            }
          ];
        });
      }
    }
    this.instance = instance2;
    this.data = data != null ? data : [];
    this.xColumn = xColumn;
    const xDomain = [
      ...xColumn.domain || new Group(data, (row) => row.x).keys()
    ];
    this.xDomain = xDomain;
    this.yColumn = yColumn;
    const yDomain = [
      ...yColumn.domain || new Group(data, (row) => row.y).keys()
    ];
    this.yDomain = yDomain;
    this.valueColumn = valueColumn;
    this.isFocused = isFocused;
    this.toggleFocused = toggleFocused;
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$e);
    });
  }
};
const index$c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$e,
  chartType: chartType$e,
  defaultOption: defaultOption$3
}, Symbol.toStringTag, { value: "Module" }));
function instance_1$y($$self, $$props, $$invalidate) {
  let $option;
  const instance2 = getInstance();
  const { chartStore } = instance2;
  if ((chartStore == null ? void 0 : chartStore.type) !== "custom") {
    throw new Error();
  }
  const { option } = chartStore;
  component_subscribe($$self, option, (value) => $$invalidate(1, $option = value));
  let ctx2 = {};
  onMount(() => {
    if ($option.onMount) {
      $option.onMount({
        instance: instance2,
        option: $option.customOptions,
        ctx: ctx2
      });
    }
  });
  onDestroy(() => {
    if ($option.onDestroy) {
      $option.onDestroy({
        instance: instance2,
        option: $option.customOptions,
        ctx: ctx2
      });
    }
  });
  return [option];
}
let Content$d = class Content4 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$y, null, safe_not_equal, {});
  }
};
const chartType$d = "custom";
let Store$d = class Store3 {
  constructor(instance2) {
    __publicField(this, "type");
    __publicField(this, "instance");
    __publicField(this, "option");
    this.instance = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    this.type = option.type;
    this.option = chartOption;
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$d);
    });
  }
};
const rowHeight = 40;
const columnPadding = 8;
const headerBgColor = "#f4f4f4";
const borderColor = "#e8e8e8";
const THUMB_WIDTH = 10;
function instance_1$x($$self, $$props, $$invalidate) {
  let innerWidth;
  let innerHeight;
  let tableWidth;
  let tableHeight;
  let actualHeight;
  let scrollHeight;
  let viewYPercent;
  let viewYActual;
  let showScroll;
  let thumbHeight;
  let formattedColumns;
  let totalWidth;
  let thumbWidthX;
  let actualWidth;
  let scrollWidth;
  let viewXPercent;
  let viewXActual;
  let showScrollX;
  let header;
  let Row;
  let $mousePosition;
  let $margin;
  let $viewX;
  let $viewY;
  let $scrollDragging;
  let $hoverColor;
  let $font;
  let $chartHeight;
  let $chartWidth;
  let $hoveredCell;
  const instance2 = getInstance();
  const { chartWidth, chartHeight, font, margin, chartStore, contentShapes, focused, focusable, mousePosition, tooltipPosition, tooltipShown } = instance2;
  component_subscribe($$self, chartWidth, (value) => $$invalidate(41, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(40, $chartHeight = value));
  component_subscribe($$self, font, (value) => $$invalidate(39, $font = value));
  component_subscribe($$self, margin, (value) => $$invalidate(34, $margin = value));
  component_subscribe($$self, mousePosition, (value) => $$invalidate(33, $mousePosition = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== "dataTable") {
    throw new Error();
  }
  const { rows, columns, isFocused, toggleFocused, focusedCell, hoveredCell, hoverColor } = chartStore;
  component_subscribe($$self, hoveredCell, (value) => $$invalidate(42, $hoveredCell = value));
  component_subscribe($$self, hoverColor, (value) => $$invalidate(38, $hoverColor = value));
  let hoveredLink = writable(null);
  let viewY = writable(0);
  component_subscribe($$self, viewY, (value) => $$invalidate(36, $viewY = value));
  let viewX = writable(0);
  component_subscribe($$self, viewX, (value) => $$invalidate(35, $viewX = value));
  const body = new GroupShape({});
  let bodyChildren = [];
  let scrollDragging = writable(null);
  component_subscribe($$self, scrollDragging, (value) => $$invalidate(37, $scrollDragging = value));
  const scrollbar = new RectShape({
    clickable: true,
    hoverable: true,
    events: {
      mousedown: readable(() => {
        scrollDragging.set("y");
      }),
      mouseup: readable(() => {
        scrollDragging.set(null);
      })
    },
    props: derived([scrollDragging], ([$scrollDragging2]) => ({
      fill: $scrollDragging2 === "y" ? "rgba(0,0,0,0.3)" : "rgba(0,0,0,0.1)"
    })),
    priority: readable(2e3)
  });
  const scrollbarX = new RectShape({
    clickable: true,
    hoverable: true,
    events: {
      mousedown: readable(() => {
        scrollDragging.set("x");
      }),
      mouseup: readable(() => {
        scrollDragging.set(null);
      })
    },
    props: derived([scrollDragging], ([$scrollDragging2]) => ({
      fill: $scrollDragging2 === "x" ? "rgba(0,0,0,0.3)" : "rgba(0,0,0,0.1)"
    })),
    priority: readable(2e3)
  });
  let intervalid = null;
  let backgroundPressed = null;
  const scrollBackground = new RectShape({
    props: readable({ fill: "rgba(0, 0, 0, 0.05)" }),
    clickable: true,
    hoverable: true,
    events: {
      mousedown: () => {
        $$invalidate(12, backgroundPressed = "y");
      },
      mouseup: () => {
        $$invalidate(12, backgroundPressed = null);
      }
    },
    priority: readable(1e3)
  });
  const scrollBackgroundX = new RectShape({
    props: readable({ fill: "rgba(0, 0, 0, 0.05)" }),
    clickable: true,
    hoverable: true,
    events: {
      mousedown: () => {
        $$invalidate(12, backgroundPressed = "x");
      },
      mouseup: () => {
        $$invalidate(12, backgroundPressed = null);
      }
    },
    priority: readable(1e3)
  });
  $$self.$$.update = () => {
    if ($$self.$$.dirty[1] & /*$hoveredCell, $mousePosition*/
    2052) {
      {
        if ($hoveredCell != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty[1] & /*$chartWidth, $margin*/
    1032) {
      $$invalidate(23, innerWidth = $chartWidth - $margin.left - $margin.right);
    }
    if ($$self.$$.dirty[1] & /*$chartHeight, $margin*/
    520) {
      $$invalidate(16, innerHeight = $chartHeight - $margin.top - $margin.bottom);
    }
    if ($$self.$$.dirty[0] & /*innerWidth*/
    8388608) {
      $$invalidate(26, tableWidth = innerWidth);
    }
    if ($$self.$$.dirty[0] & /*innerHeight*/
    65536) {
      $$invalidate(18, tableHeight = innerHeight - rowHeight);
    }
    if ($$self.$$.dirty[0] & /*tableHeight, innerHeight*/
    327680) {
      $$invalidate(28, thumbHeight = Math.min(Math.max(20, tableHeight * tableHeight / (rowHeight * rows.length)), innerHeight));
    }
    if ($$self.$$.dirty[0] & /*tableHeight, thumbHeight*/
    268697600) {
      $$invalidate(22, actualHeight = tableHeight - thumbHeight);
    }
    if ($$self.$$.dirty[0] & /*tableHeight*/
    262144) {
      $$invalidate(21, scrollHeight = rowHeight * rows.length - tableHeight);
    }
    if ($$self.$$.dirty[0] & /*scrollHeight*/
    2097152 | $$self.$$.dirty[1] & /*$viewY*/
    32) {
      {
        if (scrollHeight < 0) {
          set_store_value(viewY, $viewY = 0, $viewY);
        } else if ($viewY >= scrollHeight) {
          set_store_value(viewY, $viewY = scrollHeight, $viewY);
        } else if ($viewY < 0) {
          set_store_value(viewY, $viewY = 0, $viewY);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*tableWidth*/
    67108864) {
      $$invalidate(30, formattedColumns = (() => {
        let totalWidth2 = 0;
        let nonWidthCount = 0;
        columns.forEach((column2) => {
          if (column2.width != null) {
            totalWidth2 += column2.width;
          } else {
            nonWidthCount += 1;
          }
        });
        let remainWidth = tableWidth - totalWidth2;
        if (remainWidth < 0) {
          remainWidth = 0;
        }
        const avgWidth = remainWidth / nonWidthCount;
        let prevWidth = 0;
        return columns.map((column2) => {
          let width = 0;
          if (column2.width != null) {
            width = column2.width;
          } else if (column2.minWidth != null) {
            width = Math.max(column2.minWidth, avgWidth);
          } else {
            width = avgWidth;
          }
          const formattedColumn = { ...column2, width, x: prevWidth };
          prevWidth += width;
          return formattedColumn;
        });
      })());
    }
    if ($$self.$$.dirty[0] & /*formattedColumns*/
    1073741824) {
      $$invalidate(29, totalWidth = formattedColumns.map((c2) => c2.width).reduce((prev2, column2) => prev2 + column2, 0));
    }
    if ($$self.$$.dirty[0] & /*totalWidth, tableWidth*/
    603979776) {
      $$invalidate(19, scrollWidth = Math.floor(totalWidth) - tableWidth);
    }
    if ($$self.$$.dirty[0] & /*scrollWidth, scrollHeight*/
    2621440 | $$self.$$.dirty[1] & /*$mousePosition, $margin, $viewX, $viewY*/
    60) {
      {
        instance2.events.listen("wheel", (ev) => {
          const mp = $mousePosition;
          if (!mp) {
            return;
          }
          if (mp[1] < $margin.top + rowHeight) {
            return;
          }
          if (Math.abs(ev.deltaX) > Math.abs(ev.deltaY)) {
            if (ev.deltaX > 0 && $viewX < scrollWidth) {
              ev.preventDefault();
              ev.stopPropagation();
            }
            if (ev.deltaX < 0 && $viewX > 0) {
              ev.preventDefault();
              ev.stopPropagation();
            }
            set_store_value(viewX, $viewX += ev.deltaX, $viewX);
            if ($viewX >= scrollWidth) {
              set_store_value(viewX, $viewX = scrollWidth, $viewX);
            } else if ($viewX < 0) {
              set_store_value(viewX, $viewX = 0, $viewX);
            }
          } else {
            if (ev.deltaY > 0 && $viewY < scrollHeight) {
              ev.preventDefault();
              ev.stopPropagation();
            }
            if (ev.deltaY < 0 && $viewY > 0) {
              ev.preventDefault();
              ev.stopPropagation();
            }
            set_store_value(viewY, $viewY += ev.deltaY, $viewY);
            if ($viewY >= scrollHeight) {
              set_store_value(viewY, $viewY = scrollHeight, $viewY);
            } else if ($viewY < 0) {
              set_store_value(viewY, $viewY = 0, $viewY);
            }
          }
        });
      }
    }
    if ($$self.$$.dirty[0] & /*scrollHeight*/
    2097152 | $$self.$$.dirty[1] & /*$viewY*/
    32) {
      $$invalidate(32, viewYPercent = $viewY / scrollHeight);
    }
    if ($$self.$$.dirty[0] & /*actualHeight*/
    4194304 | $$self.$$.dirty[1] & /*viewYPercent*/
    2) {
      $$invalidate(27, viewYActual = viewYPercent * actualHeight);
    }
    if ($$self.$$.dirty[0] & /*scrollHeight*/
    2097152) {
      $$invalidate(15, showScroll = scrollHeight > 0);
    }
    if ($$self.$$.dirty[0] & /*tableWidth, totalWidth, innerWidth*/
    612368384) {
      $$invalidate(25, thumbWidthX = Math.min(Math.max(20, tableWidth * tableWidth / totalWidth), innerWidth));
    }
    if ($$self.$$.dirty[0] & /*tableWidth, thumbWidthX*/
    100663296) {
      $$invalidate(20, actualWidth = tableWidth - thumbWidthX);
    }
    if ($$self.$$.dirty[0] & /*scrollWidth*/
    524288 | $$self.$$.dirty[1] & /*$viewX*/
    16) {
      {
        if (scrollWidth < 0) {
          set_store_value(viewX, $viewX = 0, $viewX);
        } else if ($viewX >= scrollWidth) {
          set_store_value(viewX, $viewX = scrollWidth, $viewX);
        } else if ($viewX < 0) {
          set_store_value(viewX, $viewX = 0, $viewX);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*scrollWidth*/
    524288 | $$self.$$.dirty[1] & /*$viewX*/
    16) {
      $$invalidate(31, viewXPercent = $viewX / scrollWidth);
    }
    if ($$self.$$.dirty[0] & /*actualWidth*/
    1048576 | $$self.$$.dirty[1] & /*viewXPercent*/
    1) {
      $$invalidate(24, viewXActual = viewXPercent * actualWidth);
    }
    if ($$self.$$.dirty[0] & /*scrollWidth*/
    524288) {
      $$invalidate(14, showScrollX = scrollWidth > 0);
    }
    if ($$self.$$.dirty[0] & /*formattedColumns, tableWidth*/
    1140850688 | $$self.$$.dirty[1] & /*$margin, $font*/
    264) {
      $$invalidate(13, header = new GroupShape({
        x: 0,
        y: $margin.top,
        children: [
          ...formattedColumns.flatMap((column2, columnIndex) => {
            let x2 = 0;
            let textAlign = "left";
            switch (column2.align || "left") {
              case "left":
                x2 = 0;
                textAlign = "left";
                break;
              case "center":
                x2 = column2.width / 2;
                textAlign = "center";
                break;
              case "right":
                x2 = column2.width;
                textAlign = "right";
                break;
            }
            const text2 = new TextShape({
              fontSize: $font.size,
              fontFamily: $font.family || DEFAULT_FONT_FAMILY,
              x: column2.x + x2,
              y: rowHeight / 2,
              width: column2.width,
              height: rowHeight,
              textAlign,
              textBaseline: "middle",
              text: column2.title,
              backgroundColor: headerBgColor,
              overflow: "ellipsis",
              padding: columnPadding
            });
            return [
              new RectShape({
                x: column2.x,
                y: 0,
                width: column2.width,
                height: rowHeight,
                props: readable({ stroke: borderColor, fill: headerBgColor }),
                priority: readable(100),
                hoverable: true,
                // clickable: true,
                events: {
                  // click: () => {},
                  mouseenter: readable(() => {
                    hoveredCell.set(null);
                  }),
                  mouseleave: readable(() => {
                    hoveredCell.set(null);
                  })
                }
              }),
              text2
            ];
          }),
          new RectShape({
            x: 0,
            y: 0,
            width: tableWidth,
            height: rowHeight,
            props: readable({
              // stroke: borderColor,
              fill: "none"
            }),
            hoverable: true,
            clickable: true,
            priority: readable(500)
          })
        ]
      }));
    }
    if ($$self.$$.dirty[0] & /*Row, formattedColumns, totalWidth*/
    1610743808 | $$self.$$.dirty[1] & /*$font, $hoverColor*/
    384) {
      $$invalidate(17, Row = class Row {
        constructor(row, rowIndex) {
          __publicField(this, "row");
          __publicField(this, "rowIndex");
          __publicField(this, "shape", null);
          this.row = row;
          this.rowIndex = rowIndex;
        }
        makeShape(y2) {
          if (this.shape) {
            this.shape.shapeProps.update((n2) => ({ ...n2, y: y2 }));
            return this.shape;
          }
          const { row, rowIndex } = this;
          const kvs = {};
          formattedColumns.forEach((column2) => {
            if (column2.asKey && column2.getValue) {
              kvs[column2.key] = column2.getValue(row, rowIndex);
            }
          });
          this.shape = new GroupShape({
            y: y2,
            children: [
              ...formattedColumns.flatMap((column2, columnIndex) => {
                var _a2;
                let backgroundColor = rowIndex % 2 === 0 ? "#fff" : "#fafafa";
                const { background } = column2;
                if (background) {
                  if (typeof background === "string") {
                    backgroundColor = background;
                  } else if (typeof background === "function") {
                    backgroundColor = background(row, rowIndex);
                  } else {
                    const scale = linear().range(background.colors).domain(background.domain);
                    const value = background.value(row, rowIndex);
                    const color2 = value ? scale(value) : null;
                    if (color2) {
                      backgroundColor = color2;
                    }
                  }
                }
                let backgroundWidth = 1;
                const { backgroundWidth: _backgroundWidth } = column2;
                if (_backgroundWidth) {
                  if (typeof _backgroundWidth === "number") {
                    backgroundWidth = _backgroundWidth;
                  } else if (typeof _backgroundWidth === "function") {
                    backgroundWidth = _backgroundWidth(row, rowIndex);
                  }
                }
                if (backgroundWidth > 1) {
                  backgroundWidth = 1;
                }
                if (backgroundWidth < 0) {
                  backgroundWidth = 0;
                }
                const shapes = [];
                if (column2.type === "progressbar") {
                  const barWidth2 = column2.width - columnPadding * 2;
                  shapes.push(new RectShape({
                    x: columnPadding,
                    y: 16,
                    width: barWidth2,
                    height: rowHeight - 32,
                    props: readable({ fill: borderColor })
                  }));
                  const values = column2.values(row, rowIndex);
                  const colors2 = column2.colors;
                  const total = column2.total ? column2.total(row, rowIndex) : sum$1(values);
                  let prevWidth = 0;
                  values.forEach((value, i2) => {
                    let rate = value / total;
                    if (rate > 1) {
                      rate = 1;
                    }
                    shapes.push(new RectShape({
                      x: columnPadding + prevWidth,
                      y: 16,
                      width: barWidth2 * rate,
                      height: rowHeight - 32,
                      props: readable({ fill: colors2[i2] })
                    }));
                    prevWidth += barWidth2 * rate;
                  });
                } else if (column2.type === "simple") {
                  const { color: color2, color2: color22 } = column2;
                  let textColor = void 0;
                  let textColor2 = void 0;
                  if (color2) {
                    if (typeof color2 === "string") {
                      textColor = color2;
                    } else if (typeof color2 === "function") {
                      textColor = color2(row, rowIndex);
                    }
                  }
                  if (color22) {
                    if (typeof color22 === "string") {
                      textColor2 = color22;
                    } else if (typeof color22 === "function") {
                      textColor2 = color22(row, rowIndex);
                    }
                  }
                  const value = column2.render(row, rowIndex) || null;
                  const value2 = column2.render2 ? column2.render2(row, rowIndex) : null;
                  const link = column2.link ? column2.link(row, rowIndex) : null;
                  const link2 = column2.link2 ? column2.link2(row, rowIndex) : null;
                  let textAlign = "left";
                  let x2 = 0;
                  switch ((_a2 = column2.align) != null ? _a2 : "left") {
                    case "left":
                      x2 = columnPadding;
                      textAlign = "left";
                      break;
                    case "center":
                      x2 = column2.width / 2;
                      textAlign = "center";
                      break;
                    case "right":
                      x2 = column2.width - columnPadding;
                      textAlign = "right";
                      break;
                  }
                  if (value != null) {
                    shapes.push(new TextShape({
                      fontSize: $font.size,
                      fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                      x: x2,
                      y: value2 == null ? rowHeight / 2 : (rowHeight - 8) / 4 + 4,
                      textAlign,
                      textBaseline: "middle",
                      text: value != null ? value : "",
                      width: column2.width - columnPadding * 2,
                      height: rowHeight,
                      padding: 0,
                      overflow: "ellipsis",
                      backgroundColor,
                      props: readable({ fill: textColor != null ? textColor : void 0 }),
                      ...link ? {
                        priority: readable(200),
                        link,
                        hoverable: true,
                        clickable: true,
                        hovered: derived([hoveredLink], ([$hoveredLink]) => {
                          return $hoveredLink === `${rowIndex}:${columnIndex}:2`;
                        }),
                        events: {
                          mouseenter: readable(() => {
                            hoveredLink.set(`${rowIndex}:${columnIndex}:2`);
                          }),
                          mouseleave: readable(() => {
                            hoveredLink.set(null);
                          }),
                          click: readable(() => {
                            if (link2) {
                              window.open(link, "_blank");
                            }
                          })
                        }
                      } : {}
                    }));
                  }
                  if (value2 != null) {
                    shapes.push(new TextShape({
                      fontSize: $font.size,
                      fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                      x: x2,
                      y: value == null ? rowHeight / 2 : 3 * (rowHeight - 8) / 4 + 4,
                      textAlign: "left",
                      textBaseline: "middle",
                      text: value2,
                      width: column2.width - columnPadding * 2,
                      height: rowHeight,
                      padding: 0,
                      overflow: "ellipsis",
                      backgroundColor,
                      props: readable({ fill: textColor2 != null ? textColor2 : void 0 }),
                      ...link2 ? {
                        priority: readable(200),
                        link: link2,
                        hoverable: true,
                        clickable: true,
                        hovered: derived([hoveredLink], ([$hoveredLink]) => {
                          return $hoveredLink === `${rowIndex}:${columnIndex}:2`;
                        }),
                        events: {
                          mouseenter: readable(() => {
                            hoveredLink.set(`${rowIndex}:${columnIndex}:2`);
                          }),
                          mouseleave: readable(() => {
                            hoveredLink.set(null);
                          }),
                          click: readable(() => {
                            if (link2) {
                              window.open(link2, "_blank");
                            }
                          })
                        }
                      } : {}
                    }));
                  }
                } else if (column2.type === "image") {
                  const { width, imageUrl, size } = column2;
                  let x2 = (width - size.width) / 2;
                  if (x2 < 0) {
                    x2 = 0;
                  }
                  let y22 = (rowHeight - size.height) / 2;
                  if (y22 < 0) {
                    y22 = 0;
                  }
                  let url = null;
                  if (typeof imageUrl === "string" || imageUrl instanceof Promise) {
                    url = imageUrl;
                  } else if (typeof imageUrl === "function") {
                    url = imageUrl(row, rowIndex);
                  }
                  if (url) {
                    shapes.push(new ImageShape({
                      x: x2,
                      y: y22,
                      width: size.width,
                      height: size.height,
                      image: url
                    }));
                  }
                } else if (column2.type === "svg") {
                  const { width, svg: _svg, size } = column2;
                  let x2 = (width - size.width) / 2;
                  if (x2 < 0) {
                    x2 = 0;
                  }
                  let y22 = (rowHeight - size.height) / 2;
                  if (y22 < 0) {
                    y22 = 0;
                  }
                  let svg = null;
                  if (typeof _svg === "string") {
                    svg = _svg;
                  } else if (typeof _svg === "function") {
                    svg = _svg(row, rowIndex);
                  }
                  if (svg) {
                    shapes.push(new SvgShape({
                      x: x2,
                      y: y22,
                      width: size.width,
                      height: size.height,
                      svg
                    }));
                  }
                }
                return new GroupShape({
                  x: column2.x,
                  children: [
                    new RectShape({
                      x: 0,
                      y: 0,
                      width: column2.width * backgroundWidth,
                      height: rowHeight,
                      props: derived([hoveredCell], ([$hoveredCell2]) => {
                        return { fill: backgroundColor };
                      })
                    }),
                    new RectShape({
                      x: 0,
                      y: 0,
                      width: column2.width,
                      height: rowHeight,
                      hoverable: true,
                      clickable: true,
                      ...column2.onClick ? { clickable: true } : {},
                      events: {
                        mouseenter: readable(() => {
                          hoveredCell.set([rowIndex, columnIndex]);
                        }),
                        mouseleave: readable(() => {
                          hoveredCell.set(null);
                        }),
                        click: derived([focusable, focused], ([$focusable, $focused]) => {
                          return () => {
                            if ($focusable) {
                              focusedCell.set([rowIndex, columnIndex]);
                              toggleFocused($focused, kvs);
                            }
                            if (column2.onClick) {
                              column2.onClick(row);
                            }
                          };
                        })
                      },
                      props: readable({ stroke: borderColor, fill: "none" })
                    }),
                    // new RectShape({
                    //     x: column.x,
                    //     y: 0,
                    //     width: column.width,
                    //     height: rowHeight,
                    //     props: derived([hoveredCell], ([$hoveredCell]) => {
                    //         const hovered =
                    //             $hoveredCell != null &&
                    //             $hoveredCell[0] === rowIndex;
                    //         return {
                    //             fill: hovered ? 'rgba(0,0,0,0.05)' : 'none'
                    //         };
                    //     })
                    // }),
                    ...shapes
                  ]
                });
              }),
              new RectShape({
                x: 0,
                y: 0,
                width: totalWidth,
                height: rowHeight,
                props: derived([hoveredCell], ([$hoveredCell2]) => {
                  return {
                    // stroke: borderColor,
                    fill: "none"
                  };
                })
              }),
              new RectShape({
                x: 0,
                y: 0,
                width: totalWidth,
                height: rowHeight,
                focused: derived([focused], ([$focused]) => isFocused($focused, kvs)),
                props: derived([hoveredCell], ([$hoveredCell2]) => {
                  const hovered = $hoveredCell2 != null && $hoveredCell2[0] === rowIndex;
                  return { fill: hovered ? $hoverColor : "none" };
                })
              })
            ]
          });
          return this.shape;
        }
      });
    }
    if ($$self.$$.dirty[0] & /*Row, bodyChildren*/
    132096) {
      {
        bodyChildren == null ? void 0 : bodyChildren.forEach((child) => {
          if (child.shape) {
            setTimeout(() => {
              var _a2;
              (_a2 = child.shape) == null ? void 0 : _a2.destroy();
            });
          }
        });
        $$invalidate(10, bodyChildren = []);
      }
    }
    if ($$self.$$.dirty[0] & /*innerWidth, viewYActual, thumbHeight*/
    411041792 | $$self.$$.dirty[1] & /*$margin*/
    8) {
      {
        scrollbar.shapeProps.update((n2) => ({
          ...n2,
          x: $margin.left + innerWidth - THUMB_WIDTH,
          y: viewYActual + $margin.top + rowHeight,
          // header分
          width: THUMB_WIDTH,
          height: thumbHeight
        }));
        scrollbar.apply();
      }
    }
    if ($$self.$$.dirty[0] & /*viewXActual, innerHeight, thumbWidthX*/
    50397184 | $$self.$$.dirty[1] & /*$margin*/
    8) {
      {
        scrollbarX.shapeProps.update((n2) => ({
          ...n2,
          x: viewXActual + $margin.left,
          y: $margin.top + innerHeight - THUMB_WIDTH,
          width: thumbWidthX,
          height: THUMB_WIDTH
        }));
        scrollbarX.apply();
      }
    }
    if ($$self.$$.dirty[0] & /*intervalid, backgroundPressed, tableHeight, viewYActual, thumbHeight, tableWidth, viewXActual, thumbWidthX*/
    520361984) {
      {
        if (intervalid) {
          clearInterval(intervalid);
          $$invalidate(11, intervalid = null);
        }
        if (backgroundPressed === "y") {
          $$invalidate(11, intervalid = setInterval(
            () => {
              const mp = get_store_value(mousePosition);
              const $margin2 = get_store_value(margin);
              if (!mp) {
                return;
              }
              const y2 = mp[1] - rowHeight - $margin2.top;
              const increment = tableHeight;
              if (y2 > viewYActual + thumbHeight) {
                viewY.update((y22) => y22 + increment);
              } else if (y2 < viewYActual) {
                viewY.update((y22) => y22 - increment);
              }
            },
            100
          ));
        }
        if (backgroundPressed === "x") {
          $$invalidate(11, intervalid = setInterval(
            () => {
              const mp = get_store_value(mousePosition);
              const $margin2 = get_store_value(margin);
              if (!mp) {
                return;
              }
              const x2 = mp[0] - $margin2.left;
              const increment = tableWidth;
              if (x2 > viewXActual + thumbWidthX) {
                viewX.update((x22) => x22 + increment);
              } else if (x2 < viewXActual) {
                viewX.update((x22) => x22 - increment);
              }
            },
            100
          ));
        }
      }
    }
    if ($$self.$$.dirty[0] & /*innerWidth, innerHeight*/
    8454144 | $$self.$$.dirty[1] & /*$margin*/
    8) {
      {
        scrollBackground.shapeProps.update((n2) => ({
          ...n2,
          x: $margin.left + innerWidth - THUMB_WIDTH,
          y: $margin.top + rowHeight,
          width: THUMB_WIDTH,
          height: innerHeight - rowHeight
        }));
        scrollBackground.apply();
      }
    }
    if ($$self.$$.dirty[0] & /*innerHeight, innerWidth*/
    8454144 | $$self.$$.dirty[1] & /*$margin*/
    8) {
      {
        scrollBackgroundX.shapeProps.update((n2) => ({
          ...n2,
          x: $margin.left,
          y: $margin.top + innerHeight - THUMB_WIDTH,
          width: innerWidth,
          height: THUMB_WIDTH
        }));
        scrollBackgroundX.apply();
      }
    }
    if ($$self.$$.dirty[0] & /*actualHeight, scrollHeight, actualWidth, scrollWidth*/
    7864320 | $$self.$$.dirty[1] & /*$mousePosition, $scrollDragging*/
    68) {
      {
        instance2.events.listen("customdrag", (e3) => {
          const mp = $mousePosition;
          if (!mp) {
            return;
          }
          if ($scrollDragging === "y") {
            const y2 = e3.detail.deltaY;
            let newViewY = y2 / actualHeight * scrollHeight;
            viewY.update((y22) => y22 - newViewY);
          }
          if ($scrollDragging === "x") {
            const y2 = e3.detail.deltaX;
            let newViewX = y2 / actualWidth * scrollWidth;
            viewX.update((x2) => x2 - newViewX);
          }
        });
      }
    }
    if ($$self.$$.dirty[0] & /*tableHeight, bodyChildren, Row, innerHeight, header*/
    467968 | $$self.$$.dirty[1] & /*$viewY, $viewX, $margin*/
    56) {
      (() => {
        let flg = false;
        const shapes = [];
        for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
          const y2 = rowIndex * rowHeight;
          if (y2 >= $viewY - rowHeight && y2 < $viewY + tableHeight) {
            let row = rows[rowIndex];
            if (!bodyChildren[rowIndex]) {
              $$invalidate(10, bodyChildren[rowIndex] = new Row(row, rowIndex), bodyChildren);
            }
            let rowY = y2 - $viewY;
            if (rowY < -rowHeight) {
              rowY = -rowHeight;
            }
            if (rowY > innerHeight) {
              rowY = innerHeight;
            }
            const shape = bodyChildren[rowIndex].makeShape(rowY);
            shapes.push(shape);
            flg = true;
          } else if (flg) {
            break;
          }
        }
        header.shapeProps.update((n2) => ({ ...n2, x: -$viewX }));
        header.apply();
        body.shapeProps.update((n2) => ({
          ...n2,
          x: -$viewX,
          y: $margin.top + rowHeight,
          children: shapes
        }));
        body.apply();
      })();
    }
    if ($$self.$$.dirty[0] & /*showScroll, showScrollX, header*/
    57344 | $$self.$$.dirty[1] & /*$mousePosition*/
    4) {
      {
        const scrollShapes = [
          ...showScroll ? [scrollbar, scrollBackground] : [],
          ...showScrollX ? [scrollbarX, scrollBackgroundX] : []
        ];
        contentShapes.set([body, header, ...$mousePosition ? scrollShapes : []]);
      }
    }
  };
  {
    instance2.events.listen("mouseup", () => {
      scrollDragging.set(null);
      $$invalidate(12, backgroundPressed = null);
    });
    document.addEventListener("mouseup", () => {
      scrollDragging.set(null);
      $$invalidate(12, backgroundPressed = null);
    });
  }
  return [
    chartWidth,
    chartHeight,
    font,
    margin,
    mousePosition,
    hoveredCell,
    hoverColor,
    viewY,
    viewX,
    scrollDragging,
    bodyChildren,
    intervalid,
    backgroundPressed,
    header,
    showScrollX,
    showScroll,
    innerHeight,
    Row,
    tableHeight,
    scrollWidth,
    actualWidth,
    scrollHeight,
    actualHeight,
    innerWidth,
    viewXActual,
    thumbWidthX,
    tableWidth,
    viewYActual,
    thumbHeight,
    totalWidth,
    formattedColumns,
    viewXPercent,
    viewYPercent,
    $mousePosition,
    $margin,
    $viewX,
    $viewY,
    $scrollDragging,
    $hoverColor,
    $font,
    $chartHeight,
    $chartWidth,
    $hoveredCell
  ];
}
let Content$c = class Content5 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$x, null, safe_not_equal, {}, null, [-1, -1]);
  }
};
const chartType$c = "dataTable";
const defaultOption$2 = {};
let Store$c = class Store4 {
  constructor(instance2) {
    __publicField(this, "type", chartType$c);
    __publicField(this, "instance");
    __publicField(this, "data");
    __publicField(this, "rows");
    __publicField(this, "columns");
    __publicField(this, "isFocused");
    __publicField(this, "toggleFocused");
    __publicField(this, "focusedCell", writable(null));
    __publicField(this, "hoveredCell", writable(null));
    __publicField(this, "hoverColor", writable("rgba(0,0,0,0.05)"));
    var _a2;
    const { focused } = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    const { columns, data: rows } = option;
    function isFocused($focused, kvs) {
      return $focused.some(
        (focused2) => Object.keys(kvs).every((key) => focused2[key] === kvs[key])
      );
    }
    function toggleFocused($focused, kvs) {
      if (Object.keys(kvs).length === 0) {
        return;
      }
      if (isFocused($focused, kvs)) {
        focused.update((focused2) => {
          return focused2.filter(
            (focused3) => !Object.keys(kvs).every(
              (key) => focused3[key] === kvs[key]
            )
          );
        });
      } else {
        focused.update((focused2) => {
          return [
            ...focused2,
            {
              ...kvs
            }
          ];
        });
      }
    }
    if (option.hoverColor != null) {
      this.hoverColor.set(option.hoverColor);
    }
    this.instance = instance2;
    this.data = (_a2 = option.data) != null ? _a2 : [];
    this.rows = rows != null ? rows : [];
    this.columns = columns;
    this.isFocused = isFocused;
    this.toggleFocused = toggleFocused;
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$c);
    });
  }
};
const index$b = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$c,
  chartType: chartType$c,
  defaultOption: defaultOption$2
}, Symbol.toStringTag, { value: "Module" }));
function round(num) {
  const n2 = Math.floor(num);
  return n2;
}
function dist(point1, point2) {
  return Math.pow(point1[0] - point2[0], 2) + Math.pow(point1[1] - point2[1], 2);
}
function instance_1$w($$self, $$props, $$invalidate) {
  let features2;
  let flatPoints;
  let geoMeta;
  let $zoom;
  let $innerHeight;
  let $margin;
  let $innerWidth;
  let $getColor;
  let $yScale;
  let $xScale;
  let $isColorActive;
  let $chartHeight;
  let $chartWidth;
  let $innerMousePosition;
  let $mousePosition;
  let $activeSerie;
  const instance2 = getInstance();
  const { ssr, chartWidth, chartHeight, margin, mousePosition, innerMousePosition, tooltipPosition, tooltipShown, focused, focusable, tooltip, chartStore, contentShapes, colorLegendConfig, innerWidth, innerHeight } = instance2;
  component_subscribe($$self, chartWidth, (value) => $$invalidate(27, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(26, $chartHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(20, $margin = value));
  component_subscribe($$self, mousePosition, (value) => $$invalidate(29, $mousePosition = value));
  component_subscribe($$self, innerMousePosition, (value) => $$invalidate(28, $innerMousePosition = value));
  component_subscribe($$self, innerWidth, (value) => $$invalidate(21, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(19, $innerHeight = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$b) {
    throw new Error();
  }
  const { activeSerie, getColor, data, isColorActive, colorColumn, colorDomain, colorRange, zoom, xScale, yScale, geoJson: geoJson2, canZoom, propertyKey } = chartStore;
  component_subscribe($$self, activeSerie, (value) => $$invalidate(30, $activeSerie = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(22, $getColor = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(25, $isColorActive = value));
  component_subscribe($$self, zoom, (value) => $$invalidate(18, $zoom = value));
  component_subscribe($$self, xScale, (value) => $$invalidate(24, $xScale = value));
  component_subscribe($$self, yScale, (value) => $$invalidate(23, $yScale = value));
  function lowerPrecision(coordinates) {
    let prev2 = null;
    const newCoordinates = coordinates.flatMap(([x2, y2]) => {
      const current = [round(x2), round(y2)];
      if (prev2 && prev2[0] === current[0] && prev2[1] === current[1]) {
        return [];
      }
      prev2 = current;
      return [current];
    });
    if (!isValidCoordinates(newCoordinates)) {
      return [];
    }
    return newCoordinates;
  }
  function isValidCoordinates(coordinates) {
    var _a2, _b, _c, _d;
    if (coordinates.length < 3) {
      return false;
    }
    const xmin = (_a2 = min$1(coordinates, (d) => d[0])) != null ? _a2 : 0;
    const xmax = (_b = max$1(coordinates, (d) => d[0])) != null ? _b : 0;
    const ymin = (_c = min$1(coordinates, (d) => d[1])) != null ? _c : 0;
    const ymax = (_d = max$1(coordinates, (d) => d[1])) != null ? _d : 0;
    const w = xmax - xmin;
    const h2 = ymax - ymin;
    if (w < 1 || h2 < 1 || w * h2 < 16) {
      return false;
    }
    return true;
  }
  function getGeoInfo(coordinates) {
    var _a2, _b, _c, _d;
    const xmin = (_a2 = min$1(coordinates, (d) => d[0])) != null ? _a2 : 0;
    const xmax = (_b = max$1(coordinates, (d) => d[0])) != null ? _b : 0;
    const ymin = (_c = min$1(coordinates, (d) => d[1])) != null ? _c : 0;
    const ymax = (_d = max$1(coordinates, (d) => d[1])) != null ? _d : 0;
    return {
      xmin,
      xmax,
      ymin,
      ymax,
      center: [(xmax - xmin) / 2 + xmin, (ymax - ymin) / 2 + ymin]
    };
  }
  let polygons;
  const group = new GroupShape({ children: [] });
  const polygons2shape = {};
  function sleep2(time = 0) {
    return new Promise((r2) => instance2.setTimeout(r2, time));
  }
  const counter = writable(0);
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$activeSerie, $mousePosition*/
    1610612736) {
      {
        if ($activeSerie != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$xScale, $yScale, $innerMousePosition, $zoom*/
    293863424) {
      {
        if (canZoom) {
          instance2.events.listen("wheel", (e3) => {
            var _a2, _b, _c, _d;
            e3.preventDefault();
            e3.stopPropagation();
            if (!$xScale || !$yScale) {
              return;
            }
            if (!$innerMousePosition) {
              return;
            }
            if ($innerMousePosition[0] < $xScale.range()[0] || $innerMousePosition[0] > $xScale.range()[1]) {
              return;
            }
            if ($innerMousePosition[1] < $yScale.range()[0] || $innerMousePosition[1] > $yScale.range()[1]) {
              return;
            }
            const [xmin, xmax] = $xScale.domain();
            const [ymin, ymax] = $yScale.domain();
            const xValue = $xScale.invert($innerMousePosition[0]);
            const deltaX = -(e3.deltaY * (xmax - xmin)) / 100 / 10;
            const biasX = (xValue - xmin) / (xmax - xmin);
            const yValue = $yScale.invert($innerMousePosition[1]);
            const deltaY = -(e3.deltaY * (ymax - ymin)) / 100 / 10;
            const biasY = (yValue - ymin) / (ymax - ymin);
            zoom.set({
              xmin: Math.max(0, ((_a2 = $zoom == null ? void 0 : $zoom.xmin) != null ? _a2 : xmin) + deltaX * biasX),
              xmax: Math.min(1, ((_b = $zoom == null ? void 0 : $zoom.xmax) != null ? _b : xmax) - deltaX * (1 - biasX)),
              ymin: Math.max(0, ((_c = $zoom == null ? void 0 : $zoom.ymin) != null ? _c : ymin) + deltaY * biasY),
              ymax: Math.min(1, ((_d = $zoom == null ? void 0 : $zoom.ymax) != null ? _d : ymax) - deltaY * (1 - biasY))
            });
          });
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$zoom, $xScale, $yScale, $innerMousePosition, $chartWidth, $chartHeight*/
    495190016) {
      {
        if (canZoom) {
          instance2.events.listen("customdrag", (e3) => {
            var _a2, _b, _c, _d;
            const { deltaX, deltaY } = e3.detail;
            if (!$zoom) {
              return;
            }
            if (!$xScale || !$yScale) {
              return;
            }
            if (!$innerMousePosition) {
              return;
            }
            if ($innerMousePosition[0] < $xScale.range()[0] || $innerMousePosition[0] > $xScale.range()[1]) {
              return;
            }
            if ($innerMousePosition[1] < $yScale.range()[0] || $innerMousePosition[1] > $yScale.range()[1]) {
              return;
            }
            const [xmin, xmax] = $xScale.domain();
            const [ymin, ymax] = $yScale.domain();
            const xDiff = xmax - xmin;
            const yDiff = ymax - ymin;
            const deltaXValue = xDiff * (deltaX / $chartWidth);
            const deltaYValue = yDiff * (deltaY / $chartHeight);
            let xZoomMin = ((_a2 = $zoom == null ? void 0 : $zoom.xmin) != null ? _a2 : xmin) + deltaXValue;
            let xZoomMax = ((_b = $zoom == null ? void 0 : $zoom.xmax) != null ? _b : xmax) + deltaXValue;
            let yZoomMin = ((_c = $zoom == null ? void 0 : $zoom.ymin) != null ? _c : ymin) + deltaYValue;
            let yZoomMax = ((_d = $zoom == null ? void 0 : $zoom.ymax) != null ? _d : ymax) + deltaYValue;
            if (xZoomMin < 0) {
              const d = 0 - xZoomMin;
              xZoomMin = 0;
              xZoomMax += d;
            }
            if (xZoomMax > 1) {
              const d = xZoomMax - 1;
              xZoomMax = 1;
              xZoomMin -= d;
            }
            if (yZoomMin < 0) {
              const d = 0 - yZoomMin;
              yZoomMin = 0;
              yZoomMax += d;
            }
            if (yZoomMax > 1) {
              const d = yZoomMax - 1;
              yZoomMax = 1;
              yZoomMin -= d;
            }
            zoom.set({
              xmin: xZoomMin,
              xmax: xZoomMax,
              ymin: yZoomMin,
              ymax: yZoomMax
            });
          });
        }
      }
    }
    if ($$self.$$.dirty[0] & /*features*/
    65536) {
      $$invalidate(17, flatPoints = flatGeoPoints(features2));
    }
    if ($$self.$$.dirty[0] & /*flatPoints*/
    131072) {
      $$invalidate(15, geoMeta = (() => {
        var _a2, _b, _c, _d;
        const xmin = (_a2 = min$1(flatPoints, (d) => d[0])) != null ? _a2 : 0;
        const xmax = (_b = max$1(flatPoints, (d) => d[0])) != null ? _b : 0;
        const ymin = (_c = min$1(flatPoints, (d) => d[1])) != null ? _c : 0;
        const ymax = (_d = max$1(flatPoints, (d) => d[1])) != null ? _d : 0;
        const xrange = xmax - xmin;
        const yrange = ymax - ymin;
        return { xmin, xmax, ymin, ymax, xrange, yrange };
      })());
    }
    if ($$self.$$.dirty[0] & /*features*/
    65536) {
      $$invalidate(13, polygons = (() => {
        let polygonIndex = 0;
        return features2.flatMap((f2) => {
          if (f2.geometry.type === "Polygon") {
            return f2.geometry.coordinates.map((coordinates) => {
              return {
                properties: f2.properties,
                polygonIndex: polygonIndex++,
                coordinates,
                ...getGeoInfo(coordinates)
              };
            });
          }
          if (f2.geometry.type === "MultiPolygon") {
            return f2.geometry.coordinates.flatMap((coordinates) => {
              return coordinates.map((coordinates2) => {
                return {
                  properties: f2.properties,
                  polygonIndex: polygonIndex++,
                  coordinates: coordinates2,
                  ...getGeoInfo(coordinates2)
                };
              });
            });
          }
          return [];
        });
      })());
    }
    if ($$self.$$.dirty[0] & /*$margin*/
    1048576) {
      {
        group.shapeProps.update((n2) => {
          return { ...n2, x: $margin.left, y: $margin.top };
        });
      }
    }
    if ($$self.$$.dirty[0] & /*polygons*/
    8192) {
      {
        const shapes = [];
        polygons.forEach((polygon) => {
          const index2 = polygon.polygonIndex;
          const shape = new GroupShape({});
          $$invalidate(14, polygons2shape[index2] = shape, polygons2shape);
          shapes.push(shape);
        });
        group.shapeProps.update((n2) => ({ ...n2, children: shapes }));
        group.apply();
      }
    }
    if ($$self.$$.dirty[0] & /*geoMeta, $innerWidth, $innerHeight, $zoom, polygons, polygons2shape, $isColorActive, $getColor, $xScale, $yScale*/
    65855488) {
      (async () => {
        counter.update((n2) => n2 + 1);
        const id2 = get_store_value(counter);
        let t0 = performance.now();
        async function wait() {
          let t1 = performance.now();
          if (t1 - t0 > 16) {
            await sleep2();
            t0 = performance.now();
            if (id2 !== get_store_value(counter)) {
              return true;
            }
          }
          return false;
        }
        const { xmin, xmax, ymin, ymax, xrange, yrange } = geoMeta;
        let xRate = xrange / $innerWidth;
        let yRate = yrange / $innerHeight;
        let xLength = $innerWidth;
        let yLength = $innerHeight;
        if (xRate > yRate) {
          yLength = yrange / xRate;
        } else {
          xLength = xrange / yRate;
        }
        let halfWidth = ($innerWidth - xLength) / 2;
        let halfHeight = ($innerHeight - yLength) / 2;
        const scaleX = linear().domain([xmin, xmax]).range([halfWidth / $innerWidth, (xLength + halfWidth) / $innerWidth]);
        const scaleY = linear().domain([ymin, ymax]).range([(yLength + halfHeight) / $innerHeight, halfHeight / $innerHeight]);
        const viewCenter = $zoom ? [
          scaleX.invert(($zoom.xmax - $zoom.xmin) / 2 + $zoom.xmin),
          scaleY.invert(($zoom.ymax - $zoom.ymin) / 2 + $zoom.ymin)
        ] : [scaleX.invert(0.5), scaleY.invert(0.5)];
        const sortedPolygons = [...polygons].sort((a2, b) => dist(a2.center, viewCenter) - dist(b.center, viewCenter));
        for (let i2 = 0; i2 < polygons.length; i2++) {
          const shape = polygons2shape[i2];
          shape.visible.set(false);
          shape.shapeProps.update((n2) => ({ ...n2, children: [] }));
        }
        for (let i2 = 0; i2 < sortedPolygons.length; i2++) {
          if (!ssr && await wait()) {
            return;
          }
          const polygon = sortedPolygons[i2];
          if ($zoom) {
            if (scaleX(polygon.xmax) < $zoom.xmin) {
              continue;
            }
            if (scaleX(polygon.xmin) > $zoom.xmax) {
              continue;
            }
            if (scaleY(polygon.ymin) < $zoom.ymin) {
              continue;
            }
            if (scaleY(polygon.ymax) > $zoom.ymax) {
              continue;
            }
          }
          const shape = polygons2shape[polygon.polygonIndex];
          const key = polygon.properties[propertyKey];
          const coordinates = polygon.coordinates;
          const color2 = (() => {
            const record = data.find((d) => d.series === key);
            if (!record) {
              return "#fff";
            }
            if (!$isColorActive(record.color)) {
              return "#fff";
            }
            return $getColor(record.color);
          })();
          shape.visible.set(true);
          shape.shapeProps.update((n2) => {
            return {
              ...n2,
              children: [
                new PolylineShape({
                  instance: instance2,
                  hoverable: true,
                  events: {
                    mouseenter: readable(() => {
                      activeSerie.set(key);
                    }),
                    mouseleave: readable(() => {
                      activeSerie.set(null);
                    })
                  },
                  hovered: derived([activeSerie], ([$activeSerie2]) => {
                    return $activeSerie2 === key;
                  }),
                  points: lowerPrecision(coordinates.map(([x2, y2]) => [$xScale(scaleX(x2)), $yScale(scaleY(y2))])),
                  props: readable({
                    fill: color2,
                    stroke: "#999",
                    "stroke-width": 0.5
                  })
                })
              ]
            };
          });
          shape.apply();
        }
        return group;
      })();
    }
    if ($$self.$$.dirty[0] & /*$getColor*/
    4194304) {
      {
        if (colorColumn.type === "value") {
          colorLegendConfig.set({
            show: true,
            type: "value",
            column: colorColumn,
            min: colorRange[0],
            max: colorRange[1],
            getColor: (value) => $getColor(value * (colorRange[1] - colorRange[0]) + colorRange[0])
          });
        } else if (colorColumn.type === "category") {
          colorLegendConfig.set({
            show: true,
            type: "category",
            formatter: colorColumn.formatter,
            domain: colorDomain,
            getColor: (value) => $getColor(value)
          });
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$margin, $innerWidth, $innerHeight, $zoom*/
    3932160) {
      {
        contentShapes.set([
          new RectShape({
            x: $margin.left,
            y: $margin.top,
            width: $innerWidth,
            height: $innerHeight,
            props: readable({ fill: "none" })
          }),
          group,
          ...$zoom ? [
            new TextShape({
              x: $margin.left + $innerWidth,
              y: $margin.top + $innerHeight,
              textAlign: "right",
              textBaseline: "bottom",
              text: `${(1 / ($zoom.xmax - $zoom.xmin) * 100).toFixed(1)}%`
            })
          ] : []
        ]);
      }
    }
  };
  $$invalidate(16, features2 = (() => {
    const json = JSON.parse(JSON.stringify(geoJson2.features));
    return json;
  })());
  return [
    chartWidth,
    chartHeight,
    margin,
    mousePosition,
    innerMousePosition,
    innerWidth,
    innerHeight,
    activeSerie,
    getColor,
    isColorActive,
    zoom,
    xScale,
    yScale,
    polygons,
    polygons2shape,
    geoMeta,
    features2,
    flatPoints,
    $zoom,
    $innerHeight,
    $margin,
    $innerWidth,
    $getColor,
    $yScale,
    $xScale,
    $isColorActive,
    $chartHeight,
    $chartWidth,
    $innerMousePosition,
    $mousePosition,
    $activeSerie
  ];
}
let Content$b = class Content6 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$w, null, safe_not_equal, {}, null, [-1, -1]);
  }
};
const type = "FeatureCollection";
const features = [
  {
    type: "Feature",
    properties: {
      pref_j: "北海道",
      pref: "Hokkaido",
      name: "JP-01"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            144.85190660119997,
            43.046189441887265
          ],
          [
            144.78152238728381,
            43.05383839759986
          ],
          [
            144.72255505687406,
            42.984399134853966
          ],
          [
            144.75294674896168,
            42.93266623395459
          ],
          [
            144.63144505546367,
            42.95080235814001
          ],
          [
            144.48575467032578,
            42.93953224802442
          ],
          [
            144.37503540405748,
            42.96728527937235
          ],
          [
            144.35886384715477,
            42.99900450896275
          ],
          [
            144.3146844175996,
            43.006050794623135
          ],
          [
            144.2283390210339,
            42.997475939427574
          ],
          [
            144.14638658803176,
            42.976980737959686
          ],
          [
            144.04307415372685,
            42.93899110435936
          ],
          [
            143.9143655293542,
            42.87164778331333
          ],
          [
            143.69068156595318,
            42.71292556332046
          ],
          [
            143.60148361911857,
            42.644809437666154
          ],
          [
            143.44445290305023,
            42.48942851067858
          ],
          [
            143.38971404721715,
            42.416905092081166
          ],
          [
            143.32135839252092,
            42.303065753851115
          ],
          [
            143.30778759632287,
            42.244830286831295
          ],
          [
            143.33590465679288,
            42.20157744082257
          ],
          [
            143.3081134246633,
            42.080080296255545
          ],
          [
            143.3098954299445,
            42.04750175059363
          ],
          [
            143.25721273087493,
            41.999688230593634
          ],
          [
            143.2405699042695,
            41.948236256874445
          ],
          [
            143.1972135360347,
            41.95725227904378
          ],
          [
            143.1344355996975,
            42.027678670892996
          ],
          [
            143.00947882046066,
            42.08152581719508
          ],
          [
            142.96498379489663,
            42.118264472785334
          ],
          [
            142.90888504331937,
            42.13254854718566
          ],
          [
            142.81476155890417,
            42.14132828196253
          ],
          [
            142.76156901751813,
            42.17403085897018
          ],
          [
            142.6703503375769,
            42.19160761883487
          ],
          [
            142.58375598811006,
            42.24339171613469
          ],
          [
            142.4768588541455,
            42.27366737739568
          ],
          [
            142.44373382103845,
            42.30438363261726
          ],
          [
            142.40527247245262,
            42.309256138487754
          ],
          [
            142.27580823894695,
            42.37612936443593
          ],
          [
            142.1949697571411,
            42.44722646618262
          ],
          [
            142.1357657461044,
            42.46673158254359
          ],
          [
            142.02711180920852,
            42.48419114090707
          ],
          [
            141.89913035406116,
            42.57726708759544
          ],
          [
            141.81030761999094,
            42.610511153580546
          ],
          [
            141.63027079045642,
            42.63635254631822
          ],
          [
            141.52856869561697,
            42.61267462842386
          ],
          [
            141.41958745987165,
            42.57502544180457
          ],
          [
            141.32463460029032,
            42.528215916247575
          ],
          [
            141.20573141336973,
            42.45332329111053
          ],
          [
            141.14902690042297,
            42.436157660021294
          ],
          [
            141.09918995541233,
            42.40127804023059
          ],
          [
            140.9950102045937,
            42.301608669317716
          ],
          [
            140.94275552437455,
            42.31952240987238
          ],
          [
            140.950982375741,
            42.3474468306295
          ],
          [
            140.91702509003497,
            42.369115728880246
          ],
          [
            140.87133822656313,
            42.46024040424768
          ],
          [
            140.78275195737382,
            42.50418512063097
          ],
          [
            140.76902788533994,
            42.542105231055494
          ],
          [
            140.6998918303688,
            42.58580933086115
          ],
          [
            140.64670842368372,
            42.58693288446373
          ],
          [
            140.58271371421702,
            42.56619166715636
          ],
          [
            140.53697891226233,
            42.58749007611857
          ],
          [
            140.46149124543842,
            42.58200201564835
          ],
          [
            140.376960172233,
            42.508510784877224
          ],
          [
            140.32063129166485,
            42.42893263628059
          ],
          [
            140.28093556124736,
            42.33582788514964
          ],
          [
            140.28656550111955,
            42.25250210852413
          ],
          [
            140.34643265786875,
            42.2251627542888
          ],
          [
            140.3872981879827,
            42.22220861754416
          ],
          [
            140.51320333539928,
            42.13023054221579
          ],
          [
            140.58307426876436,
            42.10814398371261
          ],
          [
            140.7101560394401,
            42.1384285449687
          ],
          [
            140.76126582456368,
            42.11555942495987
          ],
          [
            140.8029842519464,
            42.07523878441551
          ],
          [
            140.8212927327287,
            42.03414414295189
          ],
          [
            140.8794229504828,
            42.0050128609277
          ],
          [
            140.95049600742723,
            41.93671410293633
          ],
          [
            140.95990519033808,
            41.91586587354492
          ],
          [
            141.0110114468159,
            41.89388708061494
          ],
          [
            141.0741496089244,
            41.88741438523614
          ],
          [
            141.15023025297324,
            41.85280670791175
          ],
          [
            141.18292118924523,
            41.81799433588518
          ],
          [
            141.15585070775253,
            41.7842993669603
          ],
          [
            141.11002929618599,
            41.785286943073416
          ],
          [
            141.07404553652944,
            41.742191274161286
          ],
          [
            140.96308350478787,
            41.7107070758987
          ],
          [
            140.93383042489629,
            41.73520370152993
          ],
          [
            140.79137673262323,
            41.77330371067185
          ],
          [
            140.7243318007336,
            41.77203378144485
          ],
          [
            140.69861996275523,
            41.817093076705014
          ],
          [
            140.63260168161327,
            41.81320264574568
          ],
          [
            140.60079385189437,
            41.74152637633444
          ],
          [
            140.52711341871606,
            41.7005393036823
          ],
          [
            140.4552082030056,
            41.69451601030787
          ],
          [
            140.43459386879388,
            41.659046840586555
          ],
          [
            140.42925375356552,
            41.53498624736959
          ],
          [
            140.25819387421507,
            41.48048543704555
          ],
          [
            140.19967814120506,
            41.39809499011332
          ],
          [
            140.12848455169816,
            41.43077897695309
          ],
          [
            140.08476509775872,
            41.42300541983319
          ],
          [
            140.0372943985963,
            41.45067471855605
          ],
          [
            139.98577475596838,
            41.551095840038556
          ],
          [
            139.98315149586153,
            41.60794746206083
          ],
          [
            140.00865616722658,
            41.691804983946945
          ],
          [
            140.067615262,
            41.76057570073281
          ],
          [
            140.07011308869664,
            41.8047284976306
          ],
          [
            140.1101703008034,
            41.80577992649954
          ],
          [
            140.1411006489144,
            41.91617523524892
          ],
          [
            140.12023017537823,
            42.00252309967243
          ],
          [
            140.0193902720953,
            42.11712590511681
          ],
          [
            139.92101884962585,
            42.136304765375904
          ],
          [
            139.8626759320646,
            42.21900703805083
          ],
          [
            139.79549306978046,
            42.230679576808996
          ],
          [
            139.76741882474445,
            42.3035518900557
          ],
          [
            139.78027941979605,
            42.35172299749022
          ],
          [
            139.83366525061405,
            42.40091319534481
          ],
          [
            139.85279215727746,
            42.464476480771644
          ],
          [
            139.84660173334078,
            42.52855515289605
          ],
          [
            139.82310184046153,
            42.61303234017645
          ],
          [
            139.8674541413658,
            42.664811665356794
          ],
          [
            139.93534745182356,
            42.689373115013765
          ],
          [
            140.032918694427,
            42.68877231429258
          ],
          [
            140.068226861983,
            42.72133039864448
          ],
          [
            140.1443040161585,
            42.75467929149585
          ],
          [
            140.1852775511303,
            42.8250797953773
          ],
          [
            140.23724501204057,
            42.79312323198849
          ],
          [
            140.24578714018696,
            42.768334866253525
          ],
          [
            140.30448777771997,
            42.77747140904419
          ],
          [
            140.30599530622888,
            42.8289062235098
          ],
          [
            140.34664231044303,
            42.857502172678736
          ],
          [
            140.4159700784654,
            42.941652668891045
          ],
          [
            140.52194863252515,
            42.9908955587701
          ],
          [
            140.50783195540083,
            43.04320203929525
          ],
          [
            140.42981908359073,
            43.14220786058819
          ],
          [
            140.35677442050542,
            43.18260775933033
          ],
          [
            140.3244816698365,
            43.22098020546689
          ],
          [
            140.36007211553041,
            43.316137482794055
          ],
          [
            140.4522422655211,
            43.33885556816653
          ],
          [
            140.48076266927595,
            43.37567634018218
          ],
          [
            140.57977041113523,
            43.31010386444778
          ],
          [
            140.62998579195317,
            43.294815449156744
          ],
          [
            140.64068097054374,
            43.2662074985425
          ],
          [
            140.7169170617046,
            43.24978315431683
          ],
          [
            140.77395319065033,
            43.227200200209744
          ],
          [
            140.8201275449465,
            43.194138335435454
          ],
          [
            140.91588886306835,
            43.211382405790566
          ],
          [
            140.92568860771718,
            43.227488384297054
          ],
          [
            141.01620993462342,
            43.23881706203694
          ],
          [
            141.0044080763895,
            43.200908349262946
          ],
          [
            141.04133322497648,
            43.1790320128555
          ],
          [
            141.16215593786373,
            43.14414789945406
          ],
          [
            141.2240516160501,
            43.16520239942679
          ],
          [
            141.32693761076104,
            43.22773387382367
          ],
          [
            141.42356507279638,
            43.32856776086316
          ],
          [
            141.42784802786738,
            43.420199863887525
          ],
          [
            141.35855931226538,
            43.51788641872129
          ],
          [
            141.38591286470722,
            43.589681517881246
          ],
          [
            141.35087784379928,
            43.644414027885
          ],
          [
            141.3292361285243,
            43.72474340646982
          ],
          [
            141.38731645984925,
            43.80635934984491
          ],
          [
            141.49400763526947,
            43.83658936226351
          ],
          [
            141.50997772644618,
            43.855624590215406
          ],
          [
            141.57706458773538,
            43.86865020936825
          ],
          [
            141.6277433518301,
            43.922108458472835
          ],
          [
            141.6609554572805,
            44.01526819831599
          ],
          [
            141.65321480919653,
            44.14251092920181
          ],
          [
            141.65790433803437,
            44.24096692971427
          ],
          [
            141.647769743887,
            44.31425133266315
          ],
          [
            141.67794801732975,
            44.33127303817948
          ],
          [
            141.71007612497885,
            44.39259992225234
          ],
          [
            141.75679413923143,
            44.457120468715544
          ],
          [
            141.76761137107033,
            44.55572596793351
          ],
          [
            141.78673068003494,
            44.58562404275757
          ],
          [
            141.7918667932603,
            44.64277618361693
          ],
          [
            141.78234059434055,
            44.7306921090148
          ],
          [
            141.7394534340122,
            44.88098219882549
          ],
          [
            141.6638086625281,
            45.03135379389936
          ],
          [
            141.58877480497029,
            45.150726927476285
          ],
          [
            141.56910311126907,
            45.2013884924357
          ],
          [
            141.5725203295155,
            45.236736056305666
          ],
          [
            141.61454469226703,
            45.28027823309826
          ],
          [
            141.61907340672943,
            45.31185005911202
          ],
          [
            141.65462248895557,
            45.35086550566111
          ],
          [
            141.63461212525905,
            45.423838786758864
          ],
          [
            141.66625804230014,
            45.43434627454992
          ],
          [
            141.69605777934996,
            45.397168222799166
          ],
          [
            141.8012204923135,
            45.408164660573476
          ],
          [
            141.83906346711285,
            45.42256113890679
          ],
          [
            141.87878801893459,
            45.46130772381469
          ],
          [
            141.87959297392686,
            45.495604708855595
          ],
          [
            141.93739810574402,
            45.52262185105238
          ],
          [
            141.96884748961926,
            45.48356098309627
          ],
          [
            142.01843706839782,
            45.45397363316239
          ],
          [
            142.05244787782243,
            45.40042608033117
          ],
          [
            142.16919731400856,
            45.33984239408558
          ],
          [
            142.27445221616082,
            45.235150134657054
          ],
          [
            142.41348340420197,
            45.115475267350114
          ],
          [
            142.50764377338905,
            45.040222740285785
          ],
          [
            142.53421270635087,
            45.02862419310957
          ],
          [
            142.5440410482916,
            44.98705485439534
          ],
          [
            142.73922735559992,
            44.75987464158054
          ],
          [
            142.86281932304584,
            44.675068698523155
          ],
          [
            142.95443238934564,
            44.5988039595139
          ],
          [
            142.98849386373413,
            44.5616444947054
          ],
          [
            143.10051263463984,
            44.49785356396252
          ],
          [
            143.20907558132035,
            44.44308144289349
          ],
          [
            143.23204443863952,
            44.423050317592924
          ],
          [
            143.34896553670782,
            44.37039595606009
          ],
          [
            143.36330709531114,
            44.33796520761211
          ],
          [
            143.46387746946286,
            44.28764427314777
          ],
          [
            143.7201155338866,
            44.194917198094885
          ],
          [
            143.70755748659778,
            44.15782012377277
          ],
          [
            143.7211783606952,
            44.12015924236759
          ],
          [
            143.7566803871155,
            44.100491592540486
          ],
          [
            143.83817661320907,
            44.107910735268995
          ],
          [
            143.93513981972694,
            44.08574949837075
          ],
          [
            143.99604620586047,
            44.13498252228722
          ],
          [
            144.18878676305695,
            44.103197715275364
          ],
          [
            144.2480619483762,
            44.11196027332805
          ],
          [
            144.25515861905825,
            44.03926070378154
          ],
          [
            144.28556478230982,
            44.01956715116014
          ],
          [
            144.29906346830842,
            43.9826010671131
          ],
          [
            144.36260870427427,
            43.95592577336969
          ],
          [
            144.4573407331986,
            43.93439434536986
          ],
          [
            144.6318044884967,
            43.91687026208542
          ],
          [
            144.79558001521502,
            43.93165643947097
          ],
          [
            144.84857776662452,
            43.973610534782246
          ],
          [
            144.91106325543998,
            44.00420748129273
          ],
          [
            144.93435868345847,
            44.041139831000805
          ],
          [
            145.00526510966804,
            44.07908520401255
          ],
          [
            145.01532470585408,
            44.10019421061991
          ],
          [
            145.0692088544606,
            44.123698983292996
          ],
          [
            145.1354491136684,
            44.1703517577803
          ],
          [
            145.19217826395268,
            44.19548412341942
          ],
          [
            145.2256714399299,
            44.248227198474645
          ],
          [
            145.30634834567013,
            44.31236848544139
          ],
          [
            145.34113629890803,
            44.326773277262305
          ],
          [
            145.36165107955208,
            44.25102624428779
          ],
          [
            145.32862692067732,
            44.191286873377045
          ],
          [
            145.25947708934413,
            44.13292288512453
          ],
          [
            145.24494337683348,
            44.068082461002405
          ],
          [
            145.15516970760072,
            43.98265625760893
          ],
          [
            145.0937875067033,
            43.89049913982021
          ],
          [
            145.098813713184,
            43.86080420771364
          ],
          [
            145.06046717416615,
            43.80397882747428
          ],
          [
            145.06880091752495,
            43.74878681583057
          ],
          [
            145.09202830702182,
            43.728156859399014
          ],
          [
            145.14180307221773,
            43.64779894181806
          ],
          [
            145.2010974055709,
            43.615911941743505
          ],
          [
            145.24406584341114,
            43.52699118282388
          ],
          [
            145.26283407578902,
            43.43758534583518
          ],
          [
            145.3154359703788,
            43.350919218012905
          ],
          [
            145.23595567125668,
            43.35037423839606
          ],
          [
            145.24340368160017,
            43.322878178811024
          ],
          [
            145.29470079879434,
            43.32346116236735
          ],
          [
            145.3274512253233,
            43.284799294025845
          ],
          [
            145.3859447582887,
            43.26372272732306
          ],
          [
            145.4132931412895,
            43.291593357926146
          ],
          [
            145.4927052852656,
            43.26648173088454
          ],
          [
            145.52214611768724,
            43.30683781814966
          ],
          [
            145.62333399278305,
            43.36326651313435
          ],
          [
            145.6505003205653,
            43.39138856072939
          ],
          [
            145.72124064582877,
            43.383248849263815
          ],
          [
            145.80855926284192,
            43.38794257398057
          ],
          [
            145.81107716147682,
            43.367745556549934
          ],
          [
            145.7549889166659,
            43.33733982320757
          ],
          [
            145.62899517118288,
            43.31867162856221
          ],
          [
            145.55738803225856,
            43.25809505012357
          ],
          [
            145.55672105702834,
            43.219540912273466
          ],
          [
            145.51541523784263,
            43.19035081308663
          ],
          [
            145.37096117391317,
            43.182235563412654
          ],
          [
            145.2897947802188,
            43.17173974077827
          ],
          [
            145.2254528734823,
            43.14212379779104
          ],
          [
            145.17069199280607,
            43.15038071976603
          ],
          [
            145.12219928264088,
            43.13241297882264
          ],
          [
            145.08447146798423,
            43.044892246399755
          ],
          [
            145.03005142989468,
            43.02820830715285
          ],
          [
            145.02476705737547,
            42.999786755498434
          ],
          [
            144.96031267675423,
            42.980512047424305
          ],
          [
            144.88163069085527,
            42.98451493348369
          ],
          [
            144.83600638025518,
            43.03345187082068
          ],
          [
            144.85190660119997,
            43.046189441887265
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "福島県",
      pref: "Fukushima",
      name: "JP-07"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            140.93100708083023,
            37.89612649186597
          ],
          [
            140.9509040988294,
            37.8402004968065
          ],
          [
            140.98734253904405,
            37.82278616795829
          ],
          [
            140.98813519499558,
            37.776675138508324
          ],
          [
            141.00813430841117,
            37.74996789905492
          ],
          [
            141.02405007021525,
            37.64598282054106
          ],
          [
            141.0262823666584,
            37.57458638034062
          ],
          [
            141.04226377467947,
            37.482988674543805
          ],
          [
            141.03417592149611,
            37.37274043453637
          ],
          [
            141.0005544668326,
            37.1836325700905
          ],
          [
            140.9990208715622,
            37.110463679067635
          ],
          [
            140.9768807847028,
            37.06724360296058
          ],
          [
            140.96948197694113,
            36.97307986180662
          ],
          [
            140.84199313589173,
            36.90888542384281
          ],
          [
            140.80120597988136,
            36.893898791146675
          ],
          [
            140.79279772740637,
            36.85862119687852
          ],
          [
            140.695086499973,
            36.88868915773225
          ],
          [
            140.56506118437224,
            36.91261949001994
          ],
          [
            140.59334980082625,
            36.8800629540208
          ],
          [
            140.538112184848,
            36.85896601217773
          ],
          [
            140.51375774223658,
            36.82332743754788
          ],
          [
            140.4635287579266,
            36.79173658685843
          ],
          [
            140.43843450047882,
            36.821524192186615
          ],
          [
            140.37718085922828,
            36.83793098089008
          ],
          [
            140.3641768309542,
            36.88429306696531
          ],
          [
            140.32684459825947,
            36.891175785456355
          ],
          [
            140.30269752355352,
            36.92700352124483
          ],
          [
            140.2641667911699,
            36.933299706429665
          ],
          [
            140.24022584600317,
            37.000400379399395
          ],
          [
            140.20323975782964,
            37.02396414875332
          ],
          [
            140.19474933492566,
            37.06338215135392
          ],
          [
            140.13733059680933,
            37.106592097553694
          ],
          [
            140.04574181412409,
            37.13654777288123
          ],
          [
            139.90235833197073,
            37.154295893795826
          ],
          [
            139.84756493627302,
            37.139405552233875
          ],
          [
            139.7528543015831,
            37.07095268722584
          ],
          [
            139.6732269259533,
            37.0577888590237
          ],
          [
            139.61125520801895,
            37.01369907712965
          ],
          [
            139.45693922225817,
            36.953964341144065
          ],
          [
            139.3933187712639,
            36.91082501476832
          ],
          [
            139.23372441573144,
            36.94229442780851
          ],
          [
            139.25543763608403,
            36.989204297627005
          ],
          [
            139.24341579837738,
            37.01545930434904
          ],
          [
            139.26020146668188,
            37.044974316300674
          ],
          [
            139.23528041242602,
            37.1134807534302
          ],
          [
            139.25300291464364,
            37.158414359988065
          ],
          [
            139.16617831616222,
            37.23204988191449
          ],
          [
            139.2128635686936,
            37.28719967722365
          ],
          [
            139.237857615147,
            37.37355782475714
          ],
          [
            139.20470872904926,
            37.40609263279281
          ],
          [
            139.22345565517816,
            37.44916521724546
          ],
          [
            139.25905978651423,
            37.447030899049935
          ],
          [
            139.35154985206532,
            37.46808903202695
          ],
          [
            139.39748326295623,
            37.45989192101873
          ],
          [
            139.41438139216177,
            37.51017762375081
          ],
          [
            139.4571544768579,
            37.51797724645291
          ],
          [
            139.54328375238006,
            37.51204599779691
          ],
          [
            139.5701204448439,
            37.5393609881909
          ],
          [
            139.56496263164135,
            37.59740694463239
          ],
          [
            139.54691655949944,
            37.63179600844701
          ],
          [
            139.61809563278408,
            37.68880276227584
          ],
          [
            139.62406643017357,
            37.71022781496319
          ],
          [
            139.6802738479586,
            37.775396140604485
          ],
          [
            139.7412726432231,
            37.82032989242511
          ],
          [
            139.78292460921546,
            37.832061571366296
          ],
          [
            139.81012032465395,
            37.80323306997408
          ],
          [
            139.85835106973042,
            37.82677249954637
          ],
          [
            139.878983953004,
            37.81038985611119
          ],
          [
            139.957997183662,
            37.81470945919789
          ],
          [
            139.99257963689774,
            37.75869708087811
          ],
          [
            140.05337146653318,
            37.77096724805205
          ],
          [
            140.12673496530743,
            37.73385527986221
          ],
          [
            140.17193889412042,
            37.755985619192096
          ],
          [
            140.2371505015272,
            37.74649669496727
          ],
          [
            140.28241200602383,
            37.798285192690145
          ],
          [
            140.26232548396166,
            37.834938219653324
          ],
          [
            140.2798958801449,
            37.976666427625304
          ],
          [
            140.3511670211035,
            37.950234273781035
          ],
          [
            140.39870424176794,
            37.97444360012466
          ],
          [
            140.46758037461623,
            37.93825609852997
          ],
          [
            140.48312772082562,
            37.90180138327517
          ],
          [
            140.55897104715308,
            37.90998049050208
          ],
          [
            140.66043983455037,
            37.900909872384545
          ],
          [
            140.69196753340532,
            37.85098967183535
          ],
          [
            140.69431261459326,
            37.80327320117851
          ],
          [
            140.72662874125527,
            37.78160082442905
          ],
          [
            140.7760081336253,
            37.78162373765869
          ],
          [
            140.8578333049127,
            37.802744405891836
          ],
          [
            140.8576982076796,
            37.89172359435894
          ],
          [
            140.93100708083023,
            37.89612649186597
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "山形県",
      pref: "Yamagata",
      name: "JP-06"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            140.54742099962812,
            38.88963758788338
          ],
          [
            140.53879401715258,
            38.8714145032236
          ],
          [
            140.59849716227896,
            38.825787862196314
          ],
          [
            140.6039840016561,
            38.78349312565836
          ],
          [
            140.63458081498317,
            38.76009892193085
          ],
          [
            140.60645921955887,
            38.704019199354725
          ],
          [
            140.6207389274552,
            38.67627515946172
          ],
          [
            140.58763629901927,
            38.63408662970974
          ],
          [
            140.53758112602196,
            38.634167850464344
          ],
          [
            140.5783430655784,
            38.57041843333983
          ],
          [
            140.5551363247405,
            38.53099985096755
          ],
          [
            140.6131370761296,
            38.453509596110244
          ],
          [
            140.5807106428667,
            38.43753460631041
          ],
          [
            140.563387161821,
            38.3772325795491
          ],
          [
            140.5215950583069,
            38.34975143787524
          ],
          [
            140.52969449535138,
            38.320788045458194
          ],
          [
            140.4928228148051,
            38.30267281638411
          ],
          [
            140.4712270272766,
            38.26944120512687
          ],
          [
            140.4798513661719,
            38.18122478046692
          ],
          [
            140.41744676005476,
            38.10331629039354
          ],
          [
            140.41771706930265,
            38.08055848261085
          ],
          [
            140.3741189487459,
            38.05719560685529
          ],
          [
            140.30330979661252,
            38.05367426355343
          ],
          [
            140.2758136975374,
            38.03586647731913
          ],
          [
            140.2798958801449,
            37.976666427625304
          ],
          [
            140.26232548396166,
            37.834938219653324
          ],
          [
            140.28241200602383,
            37.798285192690145
          ],
          [
            140.2371505015272,
            37.74649669496727
          ],
          [
            140.17193889412042,
            37.755985619192096
          ],
          [
            140.12673496530743,
            37.73385527986221
          ],
          [
            140.05337146653318,
            37.77096724805205
          ],
          [
            139.99257963689774,
            37.75869708087811
          ],
          [
            139.957997183662,
            37.81470945919789
          ],
          [
            139.878983953004,
            37.81038985611119
          ],
          [
            139.85835106973042,
            37.82677249954637
          ],
          [
            139.81012032465395,
            37.80323306997408
          ],
          [
            139.78292460921546,
            37.832061571366296
          ],
          [
            139.7412726432231,
            37.82032989242511
          ],
          [
            139.71598696676904,
            37.85404123123085
          ],
          [
            139.68199726957602,
            37.84740023046887
          ],
          [
            139.63854295412057,
            37.87992527117786
          ],
          [
            139.62481791886412,
            37.91841558015718
          ],
          [
            139.65447251900736,
            37.99701476260961
          ],
          [
            139.6552083670898,
            38.035686513844404
          ],
          [
            139.6801273881278,
            38.04332504952047
          ],
          [
            139.69091232159977,
            38.11836820365161
          ],
          [
            139.68227318752778,
            38.17186050807387
          ],
          [
            139.71322340873115,
            38.206628102371596
          ],
          [
            139.79051711596244,
            38.198002498405074
          ],
          [
            139.86059659534283,
            38.23162034167936
          ],
          [
            139.89882854777358,
            38.29312927158838
          ],
          [
            139.8166270508299,
            38.3559636381767
          ],
          [
            139.74975733246194,
            38.359728774173746
          ],
          [
            139.70548799319369,
            38.4071880205243
          ],
          [
            139.7217674142737,
            38.49628873692621
          ],
          [
            139.5999524280632,
            38.52192971315657
          ],
          [
            139.54806301343513,
            38.55309331332139
          ],
          [
            139.56436254725614,
            38.59548835161062
          ],
          [
            139.6097220132236,
            38.669088584576166
          ],
          [
            139.6985877457242,
            38.73054256843274
          ],
          [
            139.7466328004426,
            38.77450743874533
          ],
          [
            139.77948040786174,
            38.83684983268663
          ],
          [
            139.8141612769329,
            38.95043589894725
          ],
          [
            139.83986984656315,
            38.98527605007473
          ],
          [
            139.87913297946426,
            39.0958371305974
          ],
          [
            139.8695757626385,
            39.11826843848424
          ],
          [
            140.00774014065547,
            39.123047826074504
          ],
          [
            140.0623799817871,
            39.13356485362704
          ],
          [
            140.07578181231355,
            39.08618804934207
          ],
          [
            140.11450222349123,
            39.0783558961011
          ],
          [
            140.150749694271,
            39.04963568997219
          ],
          [
            140.20258519251675,
            39.034794807693935
          ],
          [
            140.2664688811706,
            39.031398476880135
          ],
          [
            140.31070239691041,
            39.01356684519135
          ],
          [
            140.36226854829175,
            39.026049702785755
          ],
          [
            140.3762349748668,
            38.99447336631807
          ],
          [
            140.43194200851292,
            38.99198834489846
          ],
          [
            140.4511505712607,
            38.971969536711626
          ],
          [
            140.4621142394068,
            38.919549849107696
          ],
          [
            140.49435171861228,
            38.89900149240243
          ],
          [
            140.54742099962812,
            38.88963758788338
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "宮城県",
      pref: "Miyagi",
      name: "JP-04"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            140.93100708083023,
            37.89612649186597
          ],
          [
            140.8576982076796,
            37.89172359435894
          ],
          [
            140.8578333049127,
            37.802744405891836
          ],
          [
            140.7760081336253,
            37.78162373765869
          ],
          [
            140.72662874125527,
            37.78160082442905
          ],
          [
            140.69431261459326,
            37.80327320117851
          ],
          [
            140.69196753340532,
            37.85098967183535
          ],
          [
            140.66043983455037,
            37.900909872384545
          ],
          [
            140.55897104715308,
            37.90998049050208
          ],
          [
            140.48312772082562,
            37.90180138327517
          ],
          [
            140.46758037461623,
            37.93825609852997
          ],
          [
            140.39870424176794,
            37.97444360012466
          ],
          [
            140.3511670211035,
            37.950234273781035
          ],
          [
            140.2798958801449,
            37.976666427625304
          ],
          [
            140.2758136975374,
            38.03586647731913
          ],
          [
            140.30330979661252,
            38.05367426355343
          ],
          [
            140.3741189487459,
            38.05719560685529
          ],
          [
            140.41771706930265,
            38.08055848261085
          ],
          [
            140.41744676005476,
            38.10331629039354
          ],
          [
            140.4798513661719,
            38.18122478046692
          ],
          [
            140.4712270272766,
            38.26944120512687
          ],
          [
            140.4928228148051,
            38.30267281638411
          ],
          [
            140.52969449535138,
            38.320788045458194
          ],
          [
            140.5215950583069,
            38.34975143787524
          ],
          [
            140.563387161821,
            38.3772325795491
          ],
          [
            140.5807106428667,
            38.43753460631041
          ],
          [
            140.6131370761296,
            38.453509596110244
          ],
          [
            140.5551363247405,
            38.53099985096755
          ],
          [
            140.5783430655784,
            38.57041843333983
          ],
          [
            140.53758112602196,
            38.634167850464344
          ],
          [
            140.58763629901927,
            38.63408662970974
          ],
          [
            140.6207389274552,
            38.67627515946172
          ],
          [
            140.60645921955887,
            38.704019199354725
          ],
          [
            140.63458081498317,
            38.76009892193085
          ],
          [
            140.6039840016561,
            38.78349312565836
          ],
          [
            140.59849716227896,
            38.825787862196314
          ],
          [
            140.53879401715258,
            38.8714145032236
          ],
          [
            140.54742099962812,
            38.88963758788338
          ],
          [
            140.56200403979105,
            38.8730472885342
          ],
          [
            140.6144899627956,
            38.894057926460015
          ],
          [
            140.64519861314497,
            38.888482176424205
          ],
          [
            140.77364651488682,
            38.958138818775225
          ],
          [
            140.8245173856211,
            38.96408606427052
          ],
          [
            140.8814568432067,
            38.92783022884993
          ],
          [
            140.94335289352065,
            38.91502454401941
          ],
          [
            140.99151816979992,
            38.875212848943804
          ],
          [
            141.093564824789,
            38.88780555955342
          ],
          [
            141.13984551705727,
            38.87756500907816
          ],
          [
            141.14667736962215,
            38.856369916661315
          ],
          [
            141.10446928484816,
            38.82323900718952
          ],
          [
            141.1388160045205,
            38.79031845894228
          ],
          [
            141.25608862437386,
            38.76053388156857
          ],
          [
            141.2724400490209,
            38.79697978251007
          ],
          [
            141.30680317742843,
            38.81951300140024
          ],
          [
            141.42161264131937,
            38.7798859849251
          ],
          [
            141.4542641757011,
            38.810924818959734
          ],
          [
            141.45058168652136,
            38.874766864877806
          ],
          [
            141.48310320864815,
            38.90255559856569
          ],
          [
            141.49013905335235,
            38.99786071756781
          ],
          [
            141.56673033068907,
            38.99593143311813
          ],
          [
            141.63181290919056,
            38.9707105077656
          ],
          [
            141.6513786027854,
            38.902393935287364
          ],
          [
            141.59034292226124,
            38.88460411571949
          ],
          [
            141.59021492361038,
            38.82201267384774
          ],
          [
            141.52024042569673,
            38.78811267391269
          ],
          [
            141.52981661115138,
            38.74930304154858
          ],
          [
            141.56537025289327,
            38.73370681248338
          ],
          [
            141.51600940083748,
            38.68901763101924
          ],
          [
            141.46882630153874,
            38.67320598399587
          ],
          [
            141.48518961743133,
            38.64153002115158
          ],
          [
            141.5296218438596,
            38.63746507565491
          ],
          [
            141.51730618897173,
            38.60398303109757
          ],
          [
            141.46697382000022,
            38.561421661625054
          ],
          [
            141.5462293017969,
            38.52436279668493
          ],
          [
            141.48548041045967,
            38.509770907378666
          ],
          [
            141.4974677451641,
            38.47981362780926
          ],
          [
            141.46820084035116,
            38.438484708222596
          ],
          [
            141.4995443343583,
            38.41537189557301
          ],
          [
            141.53383274170645,
            38.33991387993055
          ],
          [
            141.5394244546373,
            38.30269624615992
          ],
          [
            141.46713050140468,
            38.305957828184795
          ],
          [
            141.46821450122195,
            38.32689698465498
          ],
          [
            141.42990916585697,
            38.364742666429215
          ],
          [
            141.35974977745093,
            38.41317580869951
          ],
          [
            141.30756738545702,
            38.414675485105604
          ],
          [
            141.207117067887,
            38.39178118338721
          ],
          [
            141.15996245628946,
            38.36444510506221
          ],
          [
            141.12625878139013,
            38.379732821859484
          ],
          [
            141.07734095215267,
            38.379058325381045
          ],
          [
            141.04517819549548,
            38.31279798131378
          ],
          [
            141.08548796985326,
            38.29334869571326
          ],
          [
            141.02637214317076,
            38.26643135821398
          ],
          [
            140.9680914907806,
            38.190426244234544
          ],
          [
            140.92948944576693,
            38.09346301043833
          ],
          [
            140.91431252884706,
            37.99347233594501
          ],
          [
            140.93100708083023,
            37.89612649186597
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "岩手県",
      pref: "Iwate",
      name: "JP-03"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            141.68265513724884,
            40.45040206511684
          ],
          [
            141.77134115370188,
            40.34520225640186
          ],
          [
            141.77453671458048,
            40.32138985076483
          ],
          [
            141.8155519652532,
            40.27239841209325
          ],
          [
            141.8335311516106,
            40.21987770188511
          ],
          [
            141.79908130244468,
            40.2040630895411
          ],
          [
            141.8769061025384,
            40.14393803130372
          ],
          [
            141.82975926918053,
            40.11489145460876
          ],
          [
            141.83368441705733,
            40.07427205686872
          ],
          [
            141.87668496803707,
            40.04915040060866
          ],
          [
            141.89973100858904,
            40.01655477640298
          ],
          [
            141.93645543604867,
            40.00947309667874
          ],
          [
            141.96179318383287,
            39.94601261520698
          ],
          [
            141.93980729357608,
            39.93918096810221
          ],
          [
            141.97114267143988,
            39.88472263729178
          ],
          [
            141.99549364320708,
            39.778407659886234
          ],
          [
            141.98334285922698,
            39.73711470638834
          ],
          [
            141.9862863620827,
            39.68284584132198
          ],
          [
            142.0161015450456,
            39.655081084791334
          ],
          [
            142.0370935918966,
            39.572491853743955
          ],
          [
            142.06788155897127,
            39.56238080103256
          ],
          [
            142.06228533935766,
            39.526017205548904
          ],
          [
            141.9913807115475,
            39.483767925676894
          ],
          [
            141.95614062302556,
            39.475109127465906
          ],
          [
            141.97658278830474,
            39.43924115897076
          ],
          [
            142.03596063356696,
            39.48354311434516
          ],
          [
            142.06146252054236,
            39.47131411211979
          ],
          [
            142.02964380429796,
            39.41587650234261
          ],
          [
            141.983059016461,
            39.40837615030596
          ],
          [
            141.93828869742273,
            39.38470175059033
          ],
          [
            141.9756821912254,
            39.33760278142761
          ],
          [
            141.9707441185029,
            39.31318740487526
          ],
          [
            141.90687851996447,
            39.3094280835378
          ],
          [
            141.88671631524426,
            39.26871598838379
          ],
          [
            141.95527110251572,
            39.22214770873575
          ],
          [
            141.90418315709977,
            39.20512657021535
          ],
          [
            141.8872855870385,
            39.15588782162028
          ],
          [
            141.90249406991003,
            39.11951208651945
          ],
          [
            141.86067567240207,
            39.103709825365364
          ],
          [
            141.80934390353593,
            39.102593084283136
          ],
          [
            141.84962110136308,
            39.036894360547336
          ],
          [
            141.7318887383935,
            39.014076992757154
          ],
          [
            141.69852598189436,
            38.94535916186595
          ],
          [
            141.63181290919056,
            38.9707105077656
          ],
          [
            141.56673033068907,
            38.99593143311813
          ],
          [
            141.49013905335235,
            38.99786071756781
          ],
          [
            141.48310320864815,
            38.90255559856569
          ],
          [
            141.45058168652136,
            38.874766864877806
          ],
          [
            141.4542641757011,
            38.810924818959734
          ],
          [
            141.42161264131937,
            38.7798859849251
          ],
          [
            141.30680317742843,
            38.81951300140024
          ],
          [
            141.2724400490209,
            38.79697978251007
          ],
          [
            141.25608862437386,
            38.76053388156857
          ],
          [
            141.1388160045205,
            38.79031845894228
          ],
          [
            141.10446928484816,
            38.82323900718952
          ],
          [
            141.14667736962215,
            38.856369916661315
          ],
          [
            141.13984551705727,
            38.87756500907816
          ],
          [
            141.093564824789,
            38.88780555955342
          ],
          [
            140.99151816979992,
            38.875212848943804
          ],
          [
            140.94335289352065,
            38.91502454401941
          ],
          [
            140.8814568432067,
            38.92783022884993
          ],
          [
            140.8245173856211,
            38.96408606427052
          ],
          [
            140.77364651488682,
            38.958138818775225
          ],
          [
            140.76419226935363,
            39.00022583520205
          ],
          [
            140.81027819492178,
            39.05727791956944
          ],
          [
            140.75262670769615,
            39.08620626201092
          ],
          [
            140.77473809678182,
            39.16774799905496
          ],
          [
            140.76480808910313,
            39.19779509763886
          ],
          [
            140.78851918424044,
            39.23856369355387
          ],
          [
            140.7177619588039,
            39.272668817660666
          ],
          [
            140.69271232503647,
            39.31353571286677
          ],
          [
            140.70337804300902,
            39.34336723361457
          ],
          [
            140.6530784732438,
            39.390876660806036
          ],
          [
            140.68113877134496,
            39.4186128286697
          ],
          [
            140.6767291293147,
            39.44821769954367
          ],
          [
            140.72431022090146,
            39.48061520561038
          ],
          [
            140.7543129759798,
            39.57045947079257
          ],
          [
            140.80461762762675,
            39.611706516450425
          ],
          [
            140.82159163467017,
            39.68805688886293
          ],
          [
            140.78426849623614,
            39.728948333876566
          ],
          [
            140.8482374250654,
            39.79295770914856
          ],
          [
            140.78657639654986,
            39.823430132008234
          ],
          [
            140.78214716989493,
            39.86769180850203
          ],
          [
            140.8257789805517,
            39.8862415238709
          ],
          [
            140.87784071449184,
            39.874343454851406
          ],
          [
            140.84533143298808,
            39.97497329550133
          ],
          [
            140.8558149587637,
            40.015385743660474
          ],
          [
            140.84451137385844,
            40.07460176264473
          ],
          [
            140.87715503255242,
            40.09795978777809
          ],
          [
            140.85911493115162,
            40.17123548572449
          ],
          [
            140.90517687302304,
            40.222021478058664
          ],
          [
            140.9549722758729,
            40.24770936171338
          ],
          [
            141.01173106952245,
            40.21800098865744
          ],
          [
            141.07635923436342,
            40.25265567298887
          ],
          [
            141.10006172407472,
            40.28101206570445
          ],
          [
            141.17251135834408,
            40.31008656678634
          ],
          [
            141.19759596284842,
            40.3078520849254
          ],
          [
            141.26295294095905,
            40.34975843775917
          ],
          [
            141.31706884896573,
            40.37278230125607
          ],
          [
            141.35099154657482,
            40.33105163777921
          ],
          [
            141.48287871601502,
            40.3751773760698
          ],
          [
            141.5356346761853,
            40.34738689023837
          ],
          [
            141.58676564066158,
            40.380561179815864
          ],
          [
            141.58658250322705,
            40.40697272491718
          ],
          [
            141.68265513724884,
            40.45040206511684
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "秋田県",
      pref: "Akita",
      name: "JP-05"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            140.87947218852437,
            40.499391943275825
          ],
          [
            140.82847995759175,
            40.476129618811
          ],
          [
            140.86011128932677,
            40.41638886811267
          ],
          [
            140.89198362439626,
            40.423472182233006
          ],
          [
            140.97260997893005,
            40.43074728300145
          ],
          [
            140.9952506898634,
            40.35320558151271
          ],
          [
            140.95747756354035,
            40.32272637138922
          ],
          [
            140.9549722758729,
            40.24770936171338
          ],
          [
            140.90517687302304,
            40.222021478058664
          ],
          [
            140.85911493115162,
            40.17123548572449
          ],
          [
            140.87715503255242,
            40.09795978777809
          ],
          [
            140.84451137385844,
            40.07460176264473
          ],
          [
            140.8558149587637,
            40.015385743660474
          ],
          [
            140.84533143298808,
            39.97497329550133
          ],
          [
            140.87784071449184,
            39.874343454851406
          ],
          [
            140.8257789805517,
            39.8862415238709
          ],
          [
            140.78214716989493,
            39.86769180850203
          ],
          [
            140.78657639654986,
            39.823430132008234
          ],
          [
            140.8482374250654,
            39.79295770914856
          ],
          [
            140.78426849623614,
            39.728948333876566
          ],
          [
            140.82159163467017,
            39.68805688886293
          ],
          [
            140.80461762762675,
            39.611706516450425
          ],
          [
            140.7543129759798,
            39.57045947079257
          ],
          [
            140.72431022090146,
            39.48061520561038
          ],
          [
            140.6767291293147,
            39.44821769954367
          ],
          [
            140.68113877134496,
            39.4186128286697
          ],
          [
            140.6530784732438,
            39.390876660806036
          ],
          [
            140.70337804300902,
            39.34336723361457
          ],
          [
            140.69271232503647,
            39.31353571286677
          ],
          [
            140.7177619588039,
            39.272668817660666
          ],
          [
            140.78851918424044,
            39.23856369355387
          ],
          [
            140.76480808910313,
            39.19779509763886
          ],
          [
            140.77473809678182,
            39.16774799905496
          ],
          [
            140.75262670769615,
            39.08620626201092
          ],
          [
            140.81027819492178,
            39.05727791956944
          ],
          [
            140.76419226935363,
            39.00022583520205
          ],
          [
            140.77364651488682,
            38.958138818775225
          ],
          [
            140.64519861314497,
            38.888482176424205
          ],
          [
            140.6144899627956,
            38.894057926460015
          ],
          [
            140.56200403979105,
            38.8730472885342
          ],
          [
            140.54742099962812,
            38.88963758788338
          ],
          [
            140.49435171861228,
            38.89900149240243
          ],
          [
            140.4621142394068,
            38.919549849107696
          ],
          [
            140.4511505712607,
            38.971969536711626
          ],
          [
            140.43194200851292,
            38.99198834489846
          ],
          [
            140.3762349748668,
            38.99447336631807
          ],
          [
            140.36226854829175,
            39.026049702785755
          ],
          [
            140.31070239691041,
            39.01356684519135
          ],
          [
            140.2664688811706,
            39.031398476880135
          ],
          [
            140.20258519251675,
            39.034794807693935
          ],
          [
            140.150749694271,
            39.04963568997219
          ],
          [
            140.11450222349123,
            39.0783558961011
          ],
          [
            140.07578181231355,
            39.08618804934207
          ],
          [
            140.0623799817871,
            39.13356485362704
          ],
          [
            140.00774014065547,
            39.123047826074504
          ],
          [
            139.8695757626385,
            39.11826843848424
          ],
          [
            139.90647996188272,
            39.18998643225026
          ],
          [
            139.8924180885802,
            39.208742696779744
          ],
          [
            139.93017107828587,
            39.28872534974294
          ],
          [
            139.96646147878545,
            39.294503189164395
          ],
          [
            140.0140466988137,
            39.38392147636223
          ],
          [
            140.04707587055324,
            39.513038871506296
          ],
          [
            140.06340523169723,
            39.64717143539587
          ],
          [
            140.05820132876144,
            39.72644514367635
          ],
          [
            140.03403166228287,
            39.80453481440434
          ],
          [
            140.0064175491912,
            39.846339814837336
          ],
          [
            139.92460198426318,
            39.899685803822074
          ],
          [
            139.8586812705223,
            39.895769483085864
          ],
          [
            139.8468872766496,
            39.863055723210614
          ],
          [
            139.74028205140078,
            39.87144611332371
          ],
          [
            139.70833802831433,
            39.92377883838385
          ],
          [
            139.6928315139847,
            39.99534806630835
          ],
          [
            139.79991725000735,
            39.956711658997484
          ],
          [
            139.84611755124817,
            39.971901998308546
          ],
          [
            139.88834293929082,
            40.002741366951014
          ],
          [
            139.94533035465693,
            40.073077878110155
          ],
          [
            139.98683436450455,
            40.161177714299846
          ],
          [
            140.01535138853694,
            40.265089963373576
          ],
          [
            140.02500803358137,
            40.35338175654043
          ],
          [
            139.93681660218965,
            40.429085540601314
          ],
          [
            139.97281194377152,
            40.42667828892613
          ],
          [
            140.06831153936955,
            40.468906849220154
          ],
          [
            140.10762426486244,
            40.435864952730256
          ],
          [
            140.18562956936543,
            40.44245520764734
          ],
          [
            140.2202275923723,
            40.43116859869935
          ],
          [
            140.27889348440928,
            40.445869123805075
          ],
          [
            140.3406761900193,
            40.44309369749526
          ],
          [
            140.36138459381954,
            40.47837659489801
          ],
          [
            140.43721970801067,
            40.47830928996972
          ],
          [
            140.5325616338777,
            40.41102064190598
          ],
          [
            140.585766420902,
            40.4290880075514
          ],
          [
            140.66130752725513,
            40.404483138926146
          ],
          [
            140.75183837426002,
            40.43869200618904
          ],
          [
            140.8035616057488,
            40.44871397709405
          ],
          [
            140.81046921544856,
            40.48713900072894
          ],
          [
            140.84468349364886,
            40.5073455317204
          ],
          [
            140.87947218852437,
            40.499391943275825
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "青森県",
      pref: "Aomori",
      name: "JP-02"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            141.68265513724884,
            40.45040206511684
          ],
          [
            141.58658250322705,
            40.40697272491718
          ],
          [
            141.58676564066158,
            40.380561179815864
          ],
          [
            141.5356346761853,
            40.34738689023837
          ],
          [
            141.48287871601502,
            40.3751773760698
          ],
          [
            141.35099154657482,
            40.33105163777921
          ],
          [
            141.31706884896573,
            40.37278230125607
          ],
          [
            141.26295294095905,
            40.34975843775917
          ],
          [
            141.19759596284842,
            40.3078520849254
          ],
          [
            141.17251135834408,
            40.31008656678634
          ],
          [
            141.10006172407472,
            40.28101206570445
          ],
          [
            141.07635923436342,
            40.25265567298887
          ],
          [
            141.01173106952245,
            40.21800098865744
          ],
          [
            140.9549722758729,
            40.24770936171338
          ],
          [
            140.95747756354035,
            40.32272637138922
          ],
          [
            140.9952506898634,
            40.35320558151271
          ],
          [
            140.97260997893005,
            40.43074728300145
          ],
          [
            140.89198362439626,
            40.423472182233006
          ],
          [
            140.94084833092512,
            40.47854924343733
          ],
          [
            140.87947218852437,
            40.499391943275825
          ],
          [
            140.84468349364886,
            40.5073455317204
          ],
          [
            140.81046921544856,
            40.48713900072894
          ],
          [
            140.8035616057488,
            40.44871397709405
          ],
          [
            140.75183837426002,
            40.43869200618904
          ],
          [
            140.66130752725513,
            40.404483138926146
          ],
          [
            140.585766420902,
            40.4290880075514
          ],
          [
            140.5325616338777,
            40.41102064190598
          ],
          [
            140.43721970801067,
            40.47830928996972
          ],
          [
            140.36138459381954,
            40.47837659489801
          ],
          [
            140.3406761900193,
            40.44309369749526
          ],
          [
            140.27889348440928,
            40.445869123805075
          ],
          [
            140.2202275923723,
            40.43116859869935
          ],
          [
            140.18562956936543,
            40.44245520764734
          ],
          [
            140.10762426486244,
            40.435864952730256
          ],
          [
            140.06831153936955,
            40.468906849220154
          ],
          [
            139.97281194377152,
            40.42667828892613
          ],
          [
            139.93681660218965,
            40.429085540601314
          ],
          [
            139.94987413296283,
            40.497132213866095
          ],
          [
            139.94018372031871,
            40.55275979323825
          ],
          [
            139.92036601358558,
            40.584613727130694
          ],
          [
            139.87522261642548,
            40.581665687912626
          ],
          [
            139.860743321578,
            40.61575863814414
          ],
          [
            139.9370895637189,
            40.65556511356897
          ],
          [
            139.99392913223576,
            40.734724786899434
          ],
          [
            140.0538343807688,
            40.76915040981389
          ],
          [
            140.12112981093006,
            40.742180794453596
          ],
          [
            140.190244723308,
            40.78213619657186
          ],
          [
            140.22211794285266,
            40.77935550117937
          ],
          [
            140.27222633547103,
            40.835991188348004
          ],
          [
            140.3018564465577,
            40.91684127577027
          ],
          [
            140.31838707896662,
            40.99982367177671
          ],
          [
            140.31883338421036,
            41.09329185027946
          ],
          [
            140.28411279928494,
            41.1222848098304
          ],
          [
            140.32175619666475,
            41.14810805076803
          ],
          [
            140.32960985334478,
            41.218732580397884
          ],
          [
            140.37497779959656,
            41.247341621625104
          ],
          [
            140.46748122925106,
            41.181844909021464
          ],
          [
            140.54885263861567,
            41.228230801260324
          ],
          [
            140.60458669521674,
            41.213823941501595
          ],
          [
            140.64304016657854,
            41.17431531758676
          ],
          [
            140.63157812746317,
            41.09741347660248
          ],
          [
            140.6604789155981,
            40.94838841688911
          ],
          [
            140.67897878426592,
            40.883022458187796
          ],
          [
            140.73293463709393,
            40.83033500802029
          ],
          [
            140.80578394176953,
            40.841680837213616
          ],
          [
            140.86932567452044,
            40.90953139620555
          ],
          [
            140.86078100291334,
            40.97244080243337
          ],
          [
            140.8792412095875,
            41.00972080969674
          ],
          [
            140.94800426778204,
            40.992624116098895
          ],
          [
            140.9987488918403,
            40.93636475370349
          ],
          [
            141.0645104059761,
            40.913379262234656
          ],
          [
            141.09726177583872,
            40.87493279709485
          ],
          [
            141.15086823099423,
            40.88048441561936
          ],
          [
            141.19047232295068,
            40.91933917376248
          ],
          [
            141.23727828196732,
            41.02160090917112
          ],
          [
            141.24594580785245,
            41.10391190121844
          ],
          [
            141.2787200596842,
            41.15877274588509
          ],
          [
            141.2493789198526,
            41.22194155642035
          ],
          [
            141.1874966477308,
            41.27703420605591
          ],
          [
            141.1625676435429,
            41.27955941452061
          ],
          [
            141.1133127784173,
            41.21340677631843
          ],
          [
            141.0547511509394,
            41.18259672673532
          ],
          [
            140.97913927932535,
            41.19889507491176
          ],
          [
            140.94592155606205,
            41.17403131074359
          ],
          [
            140.8700512713227,
            41.16575336766654
          ],
          [
            140.8111690207998,
            41.127540333385944
          ],
          [
            140.76424522557886,
            41.147510782949134
          ],
          [
            140.76445989446515,
            41.19416368958676
          ],
          [
            140.78508148666577,
            41.23070085249072
          ],
          [
            140.79869410530878,
            41.32123487110095
          ],
          [
            140.82030640372088,
            41.34625984493436
          ],
          [
            140.83879360832614,
            41.412954880381804
          ],
          [
            140.90858980570846,
            41.494444913349
          ],
          [
            140.92413385937468,
            41.53462681941752
          ],
          [
            141.00280006119482,
            41.48558108707181
          ],
          [
            141.0669339876577,
            41.48217516456733
          ],
          [
            141.12142945369013,
            41.44813581538045
          ],
          [
            141.1927509795284,
            41.38717109774952
          ],
          [
            141.24609043964415,
            41.36160287256571
          ],
          [
            141.29867509429155,
            41.35071145271066
          ],
          [
            141.39745162856175,
            41.380294405938905
          ],
          [
            141.4609577965039,
            41.43106667289661
          ],
          [
            141.45954604228788,
            41.381015953552655
          ],
          [
            141.43972451963722,
            41.34924485754833
          ],
          [
            141.4054612451843,
            41.24000673707786
          ],
          [
            141.38880803822764,
            41.15570307192145
          ],
          [
            141.39507682569456,
            41.131360524827585
          ],
          [
            141.385470885189,
            41.00266346507846
          ],
          [
            141.39324178160086,
            40.88670312294743
          ],
          [
            141.43247341277296,
            40.681571253299595
          ],
          [
            141.4745740797465,
            40.581383589000694
          ],
          [
            141.52723486322986,
            40.5288653032696
          ],
          [
            141.57622216506795,
            40.54308745579692
          ],
          [
            141.63414442226772,
            40.484132490360345
          ],
          [
            141.68265513724884,
            40.45040206511684
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "東京都",
      pref: "Tokyo",
      name: "JP-13"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            139.54760618860263,
            35.77413673109621
          ],
          [
            139.56283096669677,
            35.76177311818409
          ],
          [
            139.64088737764476,
            35.79792919636388
          ],
          [
            139.6899194254188,
            35.80087937798148
          ],
          [
            139.74482834730688,
            35.78279983772033
          ],
          [
            139.76768976851002,
            35.8175376700172
          ],
          [
            139.82510701105008,
            35.81126627786582
          ],
          [
            139.89374022523293,
            35.78280137284695
          ],
          [
            139.8793664816038,
            35.76842007267261
          ],
          [
            139.9186885100921,
            35.69775639071975
          ],
          [
            139.88712927272246,
            35.67933320326337
          ],
          [
            139.8836934569924,
            35.64567725910434
          ],
          [
            139.83129107536433,
            35.656870270844706
          ],
          [
            139.7726784597091,
            35.646049562222814
          ],
          [
            139.75046766389147,
            35.62552626380131
          ],
          [
            139.7831846018733,
            35.577141953734184
          ],
          [
            139.77639929133008,
            35.53443061516811
          ],
          [
            139.70341890352515,
            35.536561635321156
          ],
          [
            139.6677945417521,
            35.58657998466685
          ],
          [
            139.61840553837072,
            35.61394328036393
          ],
          [
            139.5253919173495,
            35.642729384190666
          ],
          [
            139.47129179639296,
            35.601081551374314
          ],
          [
            139.5072285626119,
            35.57577954752985
          ],
          [
            139.45703220227185,
            35.52926225290691
          ],
          [
            139.3991623637555,
            35.584298481618625
          ],
          [
            139.29009994156218,
            35.612410683717634
          ],
          [
            139.25231825265047,
            35.60163901794023
          ],
          [
            139.21469122039613,
            35.647122848039814
          ],
          [
            139.1842068339055,
            35.644989071083465
          ],
          [
            139.13097281518765,
            35.671817333463224
          ],
          [
            139.10850873906136,
            35.6896399103694
          ],
          [
            139.02950581233242,
            35.71651780832572
          ],
          [
            138.99252204614,
            35.75546244476023
          ],
          [
            138.94403516649484,
            35.85466218251434
          ],
          [
            138.979081897632,
            35.884885644181985
          ],
          [
            139.02390376425873,
            35.89737619169328
          ],
          [
            139.0501252234181,
            35.878693419407576
          ],
          [
            139.1473802381467,
            35.86271938369693
          ],
          [
            139.19360890033792,
            35.840180374698015
          ],
          [
            139.30004723964754,
            35.835108399278546
          ],
          [
            139.32455171959697,
            35.79601231346094
          ],
          [
            139.3796869030016,
            35.76709342142446
          ],
          [
            139.44074917545672,
            35.76693658323843
          ],
          [
            139.5374592021952,
            35.79055161895732
          ],
          [
            139.54760618860263,
            35.77413673109621
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "栃木県",
      pref: "Tochigi",
      name: "JP-09"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            140.2641667911699,
            36.933299706429665
          ],
          [
            140.24852603183427,
            36.92182530867925
          ],
          [
            140.25153081367947,
            36.85222346888104
          ],
          [
            140.2668693093357,
            36.824705148505856
          ],
          [
            140.2537902313345,
            36.783650149362984
          ],
          [
            140.26216790004742,
            36.748363551061026
          ],
          [
            140.29249700103037,
            36.71255726386866
          ],
          [
            140.23094826870127,
            36.69960994678934
          ],
          [
            140.2491015898912,
            36.59947017283231
          ],
          [
            140.24921866954497,
            36.507857652444265
          ],
          [
            140.20267088786306,
            36.45427756968629
          ],
          [
            140.1851489151139,
            36.39827682442081
          ],
          [
            140.14415275166894,
            36.414007697867234
          ],
          [
            140.04222822981146,
            36.375542121552236
          ],
          [
            139.96541291223892,
            36.36699867040246
          ],
          [
            139.9130135940921,
            36.335053415165504
          ],
          [
            139.91073150992185,
            36.30127204490511
          ],
          [
            139.84838448032775,
            36.311137954092835
          ],
          [
            139.82199122562395,
            36.23986222662716
          ],
          [
            139.7273830757526,
            36.20155393741121
          ],
          [
            139.68783786235443,
            36.19973748234827
          ],
          [
            139.66476698903466,
            36.207136177891954
          ],
          [
            139.632719889545,
            36.27105264246037
          ],
          [
            139.560930502025,
            36.26729303103908
          ],
          [
            139.52478584108079,
            36.28460584723654
          ],
          [
            139.48097082711934,
            36.27135763351209
          ],
          [
            139.41571597668118,
            36.31591673405239
          ],
          [
            139.41502180517816,
            36.338130444690606
          ],
          [
            139.3702762367418,
            36.36609338224543
          ],
          [
            139.37871057069253,
            36.41466239999416
          ],
          [
            139.43646290146083,
            36.46604247893019
          ],
          [
            139.4181036027058,
            36.497422723790315
          ],
          [
            139.48292065588493,
            36.58330285450253
          ],
          [
            139.47113271447768,
            36.6029751352322
          ],
          [
            139.39784200339344,
            36.60220220466182
          ],
          [
            139.32928194148437,
            36.62773080164294
          ],
          [
            139.3370812280334,
            36.69257071314219
          ],
          [
            139.37176646039867,
            36.74680587769079
          ],
          [
            139.35073962241793,
            36.76356639077587
          ],
          [
            139.40639322924113,
            36.82948425286899
          ],
          [
            139.36638677597864,
            36.841965155490485
          ],
          [
            139.35636068457904,
            36.877967812917284
          ],
          [
            139.3933187712639,
            36.91082501476832
          ],
          [
            139.45693922225817,
            36.953964341144065
          ],
          [
            139.61125520801895,
            37.01369907712965
          ],
          [
            139.6732269259533,
            37.0577888590237
          ],
          [
            139.7528543015831,
            37.07095268722584
          ],
          [
            139.84756493627302,
            37.139405552233875
          ],
          [
            139.90235833197073,
            37.154295893795826
          ],
          [
            140.04574181412409,
            37.13654777288123
          ],
          [
            140.13733059680933,
            37.106592097553694
          ],
          [
            140.19474933492566,
            37.06338215135392
          ],
          [
            140.20323975782964,
            37.02396414875332
          ],
          [
            140.24022584600317,
            37.000400379399395
          ],
          [
            140.2641667911699,
            36.933299706429665
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "埼玉県",
      pref: "Saitama",
      name: "JP-11"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            139.66476698903466,
            36.207136177891954
          ],
          [
            139.68783786235443,
            36.19973748234827
          ],
          [
            139.69850745622648,
            36.152052445240145
          ],
          [
            139.7283426239609,
            36.090068107780276
          ],
          [
            139.77613312788722,
            36.09081816493295
          ],
          [
            139.81742595687564,
            36.03212551515321
          ],
          [
            139.81417235969323,
            35.99730487904314
          ],
          [
            139.86570700921695,
            35.92803029784271
          ],
          [
            139.899239715513,
            35.86661665260198
          ],
          [
            139.89374022523293,
            35.78280137284695
          ],
          [
            139.82510701105008,
            35.81126627786582
          ],
          [
            139.76768976851002,
            35.8175376700172
          ],
          [
            139.74482834730688,
            35.78279983772033
          ],
          [
            139.6899194254188,
            35.80087937798148
          ],
          [
            139.64088737764476,
            35.79792919636388
          ],
          [
            139.56283096669677,
            35.76177311818409
          ],
          [
            139.54760618860263,
            35.77413673109621
          ],
          [
            139.5374592021952,
            35.79055161895732
          ],
          [
            139.44074917545672,
            35.76693658323843
          ],
          [
            139.3796869030016,
            35.76709342142446
          ],
          [
            139.32455171959697,
            35.79601231346094
          ],
          [
            139.30004723964754,
            35.835108399278546
          ],
          [
            139.19360890033792,
            35.840180374698015
          ],
          [
            139.1473802381467,
            35.86271938369693
          ],
          [
            139.0501252234181,
            35.878693419407576
          ],
          [
            139.02390376425873,
            35.89737619169328
          ],
          [
            138.979081897632,
            35.884885644181985
          ],
          [
            138.94403516649484,
            35.85466218251434
          ],
          [
            138.87748039250363,
            35.84818662295078
          ],
          [
            138.81360606645947,
            35.86232615784687
          ],
          [
            138.7907510912227,
            35.8920863588181
          ],
          [
            138.72885454053798,
            35.90927585548374
          ],
          [
            138.73924315240836,
            35.93925483095995
          ],
          [
            138.71270729912848,
            35.98521592986725
          ],
          [
            138.74910209482567,
            36.01663047050595
          ],
          [
            138.82858123808705,
            36.03731200272982
          ],
          [
            138.84616522016242,
            36.06645160680164
          ],
          [
            138.89831181843257,
            36.09081594556875
          ],
          [
            138.93120752136895,
            36.08826717987566
          ],
          [
            139.0431190057846,
            36.1484019967506
          ],
          [
            139.05630219363184,
            36.18089798151819
          ],
          [
            139.12933016944882,
            36.28332394789708
          ],
          [
            139.16386636022497,
            36.2789416415959
          ],
          [
            139.23714029588967,
            36.24627098103114
          ],
          [
            139.2668947482302,
            36.25056360056606
          ],
          [
            139.3176193295597,
            36.23041730376116
          ],
          [
            139.35096604754335,
            36.254329787479264
          ],
          [
            139.46458746467832,
            36.18926581055772
          ],
          [
            139.53411983294853,
            36.192651238103274
          ],
          [
            139.58786451432573,
            36.21038243959024
          ],
          [
            139.62894687453166,
            36.19515277599704
          ],
          [
            139.66476698903466,
            36.207136177891954
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "神奈川県",
      pref: "Kanagawa",
      name: "JP-14"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            139.77639929133008,
            35.53443061516811
          ],
          [
            139.76546210315138,
            35.51384117768467
          ],
          [
            139.68180789618094,
            35.47826220630697
          ],
          [
            139.64451018582096,
            35.475987072444774
          ],
          [
            139.67822450096827,
            35.43042664411876
          ],
          [
            139.62598936291403,
            35.401514202788526
          ],
          [
            139.65693353355846,
            35.34166301421762
          ],
          [
            139.64918140368115,
            35.288410350423014
          ],
          [
            139.69658156638516,
            35.26401984369037
          ],
          [
            139.73907822965856,
            35.26172846525129
          ],
          [
            139.72493025179003,
            35.211942948900315
          ],
          [
            139.68967261670105,
            35.20845116803912
          ],
          [
            139.65550053593176,
            35.18321946963391
          ],
          [
            139.65621415471824,
            35.137506572684714
          ],
          [
            139.62831702125084,
            35.13679010328976
          ],
          [
            139.59912462600198,
            35.23938940411018
          ],
          [
            139.56727861597008,
            35.28436701223408
          ],
          [
            139.52578159875281,
            35.30163336341204
          ],
          [
            139.43800151715175,
            35.318936333517506
          ],
          [
            139.33010165852826,
            35.312202309245414
          ],
          [
            139.20529569418267,
            35.275354903360714
          ],
          [
            139.1479352488244,
            35.23948328392006
          ],
          [
            139.13637872188065,
            35.14923582223775
          ],
          [
            139.11152958929335,
            35.141399382647066
          ],
          [
            139.0305909077395,
            35.1498466385443
          ],
          [
            139.02753375535673,
            35.1754769007298
          ],
          [
            138.98766702034254,
            35.20086360822993
          ],
          [
            138.97552154068637,
            35.26374857889434
          ],
          [
            139.00523188070684,
            35.29052820772422
          ],
          [
            139.010507148965,
            35.338362316436495
          ],
          [
            138.99976878118252,
            35.40165703089994
          ],
          [
            138.91625337785723,
            35.40059584351664
          ],
          [
            138.9276484878501,
            35.43741745117915
          ],
          [
            138.95886948269194,
            35.46236534303307
          ],
          [
            139.0278291386846,
            35.48116477073011
          ],
          [
            139.08572093587526,
            35.512113379589785
          ],
          [
            139.12930054280045,
            35.564256192514314
          ],
          [
            139.13097281518765,
            35.671817333463224
          ],
          [
            139.1842068339055,
            35.644989071083465
          ],
          [
            139.21469122039613,
            35.647122848039814
          ],
          [
            139.25231825265047,
            35.60163901794023
          ],
          [
            139.29009994156218,
            35.612410683717634
          ],
          [
            139.3991623637555,
            35.584298481618625
          ],
          [
            139.45703220227185,
            35.52926225290691
          ],
          [
            139.5072285626119,
            35.57577954752985
          ],
          [
            139.47129179639296,
            35.601081551374314
          ],
          [
            139.5253919173495,
            35.642729384190666
          ],
          [
            139.61840553837072,
            35.61394328036393
          ],
          [
            139.6677945417521,
            35.58657998466685
          ],
          [
            139.70341890352515,
            35.536561635321156
          ],
          [
            139.77639929133008,
            35.53443061516811
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "茨城県",
      pref: "Ibaraki",
      name: "JP-08"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            140.79279772740637,
            36.85862119687852
          ],
          [
            140.74664828777767,
            36.780625415276106
          ],
          [
            140.7167036479073,
            36.69266963392945
          ],
          [
            140.7164349941711,
            36.66145881383053
          ],
          [
            140.654474265985,
            36.5751167423987
          ],
          [
            140.6281347837918,
            36.496049300828815
          ],
          [
            140.61327542061687,
            36.481718782204055
          ],
          [
            140.6078863927706,
            36.42500614395812
          ],
          [
            140.62102765344244,
            36.36102189779678
          ],
          [
            140.58715378143094,
            36.31087432268106
          ],
          [
            140.5607672851973,
            36.29702197639451
          ],
          [
            140.57192711227268,
            36.18456956404207
          ],
          [
            140.61215904713941,
            36.08234618925765
          ],
          [
            140.67061153021334,
            35.97151310313957
          ],
          [
            140.68089689499575,
            35.97093827139359
          ],
          [
            140.74397676594037,
            35.86523818553388
          ],
          [
            140.82743762912048,
            35.75772925078199
          ],
          [
            140.85176712326043,
            35.74393114283797
          ],
          [
            140.82025138023283,
            35.739638320563955
          ],
          [
            140.7423211229915,
            35.78459900889218
          ],
          [
            140.68559585021765,
            35.8483552731105
          ],
          [
            140.63063708160382,
            35.85915034369059
          ],
          [
            140.59875508725844,
            35.903195917080424
          ],
          [
            140.51118435177202,
            35.958703238312225
          ],
          [
            140.48706361595774,
            35.92818125608358
          ],
          [
            140.42322468179006,
            35.90684791442968
          ],
          [
            140.35817922116024,
            35.89652378802884
          ],
          [
            140.31752372909844,
            35.86439450703068
          ],
          [
            140.27736301356873,
            35.87385801154601
          ],
          [
            140.14655223423708,
            35.84563204357009
          ],
          [
            140.12715981681353,
            35.870886972220184
          ],
          [
            139.99514999484452,
            35.90955234576109
          ],
          [
            139.93770543094539,
            35.94122240357015
          ],
          [
            139.93372056612225,
            35.96955687045416
          ],
          [
            139.8840973872078,
            35.98883313806528
          ],
          [
            139.87666700638363,
            36.01036295161898
          ],
          [
            139.77613312788722,
            36.09081816493295
          ],
          [
            139.7283426239609,
            36.090068107780276
          ],
          [
            139.69850745622648,
            36.152052445240145
          ],
          [
            139.68783786235443,
            36.19973748234827
          ],
          [
            139.7273830757526,
            36.20155393741121
          ],
          [
            139.82199122562395,
            36.23986222662716
          ],
          [
            139.84838448032775,
            36.311137954092835
          ],
          [
            139.91073150992185,
            36.30127204490511
          ],
          [
            139.9130135940921,
            36.335053415165504
          ],
          [
            139.96541291223892,
            36.36699867040246
          ],
          [
            140.04222822981146,
            36.375542121552236
          ],
          [
            140.14415275166894,
            36.414007697867234
          ],
          [
            140.1851489151139,
            36.39827682442081
          ],
          [
            140.20267088786306,
            36.45427756968629
          ],
          [
            140.24921866954497,
            36.507857652444265
          ],
          [
            140.2491015898912,
            36.59947017283231
          ],
          [
            140.23094826870127,
            36.69960994678934
          ],
          [
            140.29249700103037,
            36.71255726386866
          ],
          [
            140.26216790004742,
            36.748363551061026
          ],
          [
            140.2537902313345,
            36.783650149362984
          ],
          [
            140.2668693093357,
            36.824705148505856
          ],
          [
            140.25153081367947,
            36.85222346888104
          ],
          [
            140.24852603183427,
            36.92182530867925
          ],
          [
            140.2641667911699,
            36.933299706429665
          ],
          [
            140.30269752355352,
            36.92700352124483
          ],
          [
            140.32684459825947,
            36.891175785456355
          ],
          [
            140.3641768309542,
            36.88429306696531
          ],
          [
            140.37718085922828,
            36.83793098089008
          ],
          [
            140.43843450047882,
            36.821524192186615
          ],
          [
            140.4635287579266,
            36.79173658685843
          ],
          [
            140.51375774223658,
            36.82332743754788
          ],
          [
            140.538112184848,
            36.85896601217773
          ],
          [
            140.59334980082625,
            36.8800629540208
          ],
          [
            140.56506118437224,
            36.91261949001994
          ],
          [
            140.695086499973,
            36.88868915773225
          ],
          [
            140.79279772740637,
            36.85862119687852
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "群馬県",
      pref: "Gunma",
      name: "JP-10"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            139.66476698903466,
            36.207136177891954
          ],
          [
            139.62894687453166,
            36.19515277599704
          ],
          [
            139.58786451432573,
            36.21038243959024
          ],
          [
            139.53411983294853,
            36.192651238103274
          ],
          [
            139.46458746467832,
            36.18926581055772
          ],
          [
            139.35096604754335,
            36.254329787479264
          ],
          [
            139.3176193295597,
            36.23041730376116
          ],
          [
            139.2668947482302,
            36.25056360056606
          ],
          [
            139.23714029588967,
            36.24627098103114
          ],
          [
            139.16386636022497,
            36.2789416415959
          ],
          [
            139.12933016944882,
            36.28332394789708
          ],
          [
            139.05630219363184,
            36.18089798151819
          ],
          [
            139.0431190057846,
            36.1484019967506
          ],
          [
            138.93120752136895,
            36.08826717987566
          ],
          [
            138.89831181843257,
            36.09081594556875
          ],
          [
            138.84616522016242,
            36.06645160680164
          ],
          [
            138.82858123808705,
            36.03731200272982
          ],
          [
            138.74910209482567,
            36.01663047050595
          ],
          [
            138.71270729912848,
            35.98521592986725
          ],
          [
            138.63144495586718,
            36.02830896652856
          ],
          [
            138.64418613069589,
            36.04982404851799
          ],
          [
            138.63068802068832,
            36.09124479335538
          ],
          [
            138.63706368392448,
            36.17492744129538
          ],
          [
            138.60224596348039,
            36.24894340916488
          ],
          [
            138.61233887529485,
            36.285630632951026
          ],
          [
            138.65353207215065,
            36.30302985831768
          ],
          [
            138.64834614980168,
            36.40746789375471
          ],
          [
            138.59170132218816,
            36.42431539945689
          ],
          [
            138.54046668622954,
            36.40277348162781
          ],
          [
            138.4887091955284,
            36.40090619420367
          ],
          [
            138.4007284881166,
            36.43526413999608
          ],
          [
            138.40398880313134,
            36.52121389832871
          ],
          [
            138.42901992656647,
            36.55646258892511
          ],
          [
            138.4287234101576,
            36.59779095634669
          ],
          [
            138.45833782385506,
            36.63408489804006
          ],
          [
            138.525231998016,
            36.65136304730397
          ],
          [
            138.51974533019253,
            36.689349596364764
          ],
          [
            138.54368381293435,
            36.70374961988282
          ],
          [
            138.6957692097514,
            36.73847184570369
          ],
          [
            138.72710178496777,
            36.76412019507956
          ],
          [
            138.76724679346503,
            36.746515140621305
          ],
          [
            138.81776293185703,
            36.76162293643779
          ],
          [
            138.8313113081882,
            36.794270937825786
          ],
          [
            138.91634542389778,
            36.850416304855905
          ],
          [
            138.93212368794073,
            36.893583806165786
          ],
          [
            138.9797226446212,
            36.891844321345154
          ],
          [
            138.96645832355793,
            36.97874724633296
          ],
          [
            139.03537502209042,
            36.9840092707641
          ],
          [
            139.0912449521353,
            37.01990380023796
          ],
          [
            139.09666900563664,
            37.05922632476876
          ],
          [
            139.17957902440799,
            36.99049582971504
          ],
          [
            139.18634106203683,
            36.960021698492085
          ],
          [
            139.23372441573144,
            36.94229442780851
          ],
          [
            139.3933187712639,
            36.91082501476832
          ],
          [
            139.35636068457904,
            36.877967812917284
          ],
          [
            139.36638677597864,
            36.841965155490485
          ],
          [
            139.40639322924113,
            36.82948425286899
          ],
          [
            139.35073962241793,
            36.76356639077587
          ],
          [
            139.37176646039867,
            36.74680587769079
          ],
          [
            139.3370812280334,
            36.69257071314219
          ],
          [
            139.32928194148437,
            36.62773080164294
          ],
          [
            139.39784200339344,
            36.60220220466182
          ],
          [
            139.47113271447768,
            36.6029751352322
          ],
          [
            139.48292065588493,
            36.58330285450253
          ],
          [
            139.4181036027058,
            36.497422723790315
          ],
          [
            139.43646290146083,
            36.46604247893019
          ],
          [
            139.37871057069253,
            36.41466239999416
          ],
          [
            139.3702762367418,
            36.36609338224543
          ],
          [
            139.41502180517816,
            36.338130444690606
          ],
          [
            139.41571597668118,
            36.31591673405239
          ],
          [
            139.48097082711934,
            36.27135763351209
          ],
          [
            139.52478584108079,
            36.28460584723654
          ],
          [
            139.560930502025,
            36.26729303103908
          ],
          [
            139.632719889545,
            36.27105264246037
          ],
          [
            139.66476698903466,
            36.207136177891954
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "千葉県",
      pref: "Chiba",
      name: "JP-12"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            139.77613312788722,
            36.09081816493295
          ],
          [
            139.87666700638363,
            36.01036295161898
          ],
          [
            139.8840973872078,
            35.98883313806528
          ],
          [
            139.93372056612225,
            35.96955687045416
          ],
          [
            139.93770543094539,
            35.94122240357015
          ],
          [
            139.99514999484452,
            35.90955234576109
          ],
          [
            140.12715981681353,
            35.870886972220184
          ],
          [
            140.14655223423708,
            35.84563204357009
          ],
          [
            140.27736301356873,
            35.87385801154601
          ],
          [
            140.31752372909844,
            35.86439450703068
          ],
          [
            140.35817922116024,
            35.89652378802884
          ],
          [
            140.42322468179006,
            35.90684791442968
          ],
          [
            140.48706361595774,
            35.92818125608358
          ],
          [
            140.51118435177202,
            35.958703238312225
          ],
          [
            140.59875508725844,
            35.903195917080424
          ],
          [
            140.63063708160382,
            35.85915034369059
          ],
          [
            140.68559585021765,
            35.8483552731105
          ],
          [
            140.7423211229915,
            35.78459900889218
          ],
          [
            140.82025138023283,
            35.739638320563955
          ],
          [
            140.85176712326043,
            35.74393114283797
          ],
          [
            140.86285988964346,
            35.702844109358196
          ],
          [
            140.80788326227952,
            35.71180799624537
          ],
          [
            140.75070869416274,
            35.693492514178594
          ],
          [
            140.71414861490058,
            35.7021235808659
          ],
          [
            140.65381677306442,
            35.688166519080475
          ],
          [
            140.6063401166503,
            35.66066831576776
          ],
          [
            140.49796093838515,
            35.579106531325934
          ],
          [
            140.45209748333338,
            35.528444082326445
          ],
          [
            140.41561046947484,
            35.47176626102864
          ],
          [
            140.39708135541943,
            35.41877435396162
          ],
          [
            140.39354391518086,
            35.34385622630083
          ],
          [
            140.41487109202106,
            35.308425154768635
          ],
          [
            140.40615598696922,
            35.23940958496422
          ],
          [
            140.38436029871616,
            35.18705916771076
          ],
          [
            140.35130885162562,
            35.1814934706209
          ],
          [
            140.32576596572565,
            35.139298137426415
          ],
          [
            140.2478743821386,
            35.133791098591146
          ],
          [
            140.2365997068807,
            35.116618975503016
          ],
          [
            140.13612124255297,
            35.1215925280333
          ],
          [
            140.1028087687441,
            35.07840697252087
          ],
          [
            140.03855276605697,
            35.05179386395559
          ],
          [
            139.9814489658268,
            35.01143160573356
          ],
          [
            139.96450021935786,
            34.94239060227426
          ],
          [
            139.9057131004036,
            34.90416933035363
          ],
          [
            139.84287995759544,
            34.90273609746812
          ],
          [
            139.7860781354443,
            34.972892318440366
          ],
          [
            139.8571653708767,
            34.994116614858754
          ],
          [
            139.82611532235742,
            35.038227007338946
          ],
          [
            139.82395276670837,
            35.11380072668621
          ],
          [
            139.8392716423271,
            35.13133961705664
          ],
          [
            139.81603652266597,
            35.17170810264124
          ],
          [
            139.82981042811065,
            35.20304467985813
          ],
          [
            139.8647549545865,
            35.21754490393525
          ],
          [
            139.8641899665464,
            35.254220626659055
          ],
          [
            139.81977395407387,
            35.31672837330002
          ],
          [
            139.84594262728513,
            35.37542020633452
          ],
          [
            139.88744940260733,
            35.361596834258144
          ],
          [
            139.91432179938835,
            35.380127432410305
          ],
          [
            139.8992018300483,
            35.4178559326744
          ],
          [
            139.94858080907315,
            35.442245616289306
          ],
          [
            139.96567083350922,
            35.46854212138838
          ],
          [
            140.0064316670309,
            35.47919044142444
          ],
          [
            140.06085116384827,
            35.543145193256606
          ],
          [
            140.09807068472094,
            35.55499178571645
          ],
          [
            140.08386920137258,
            35.596776556411754
          ],
          [
            140.0197326502359,
            35.65271005729966
          ],
          [
            139.94740237930574,
            35.679957931462944
          ],
          [
            139.93957454490373,
            35.64052005100988
          ],
          [
            139.8977212899676,
            35.61667260672169
          ],
          [
            139.8836934569924,
            35.64567725910434
          ],
          [
            139.88712927272246,
            35.67933320326337
          ],
          [
            139.9186885100921,
            35.69775639071975
          ],
          [
            139.8793664816038,
            35.76842007267261
          ],
          [
            139.89374022523293,
            35.78280137284695
          ],
          [
            139.899239715513,
            35.86661665260198
          ],
          [
            139.86570700921695,
            35.92803029784271
          ],
          [
            139.81417235969323,
            35.99730487904314
          ],
          [
            139.81742595687564,
            36.03212551515321
          ],
          [
            139.77613312788722,
            36.09081816493295
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "愛知県",
      pref: "Aichi",
      name: "JP-23"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            136.74939226591604,
            35.03698990473186
          ],
          [
            136.7504161401581,
            35.079802095432775
          ],
          [
            136.67280839527146,
            35.134726628027025
          ],
          [
            136.6779157134454,
            35.241006814519366
          ],
          [
            136.72284837299733,
            35.292168050651945
          ],
          [
            136.77185178286018,
            35.36921068738909
          ],
          [
            136.8340239972052,
            35.35588072937313
          ],
          [
            136.86461917797382,
            35.372303062766505
          ],
          [
            136.92137583957384,
            35.37908592804381
          ],
          [
            136.98691505110486,
            35.420234417824354
          ],
          [
            137.00214056095376,
            35.38141386725393
          ],
          [
            137.028162922216,
            35.37619174675732
          ],
          [
            137.0728399250942,
            35.32598991159007
          ],
          [
            137.06634790944463,
            35.3089168717065
          ],
          [
            137.16528801135348,
            35.283249405292636
          ],
          [
            137.1999640625413,
            35.25154499374385
          ],
          [
            137.30888347252056,
            35.291635344721705
          ],
          [
            137.38376667165417,
            35.260558338944186
          ],
          [
            137.4293282912381,
            35.22284028262385
          ],
          [
            137.5211931783946,
            35.28422670717741
          ],
          [
            137.56154531829486,
            35.28926073432052
          ],
          [
            137.5461485096556,
            35.25151481822677
          ],
          [
            137.57871703990185,
            35.19842827625316
          ],
          [
            137.6941486838531,
            35.23367155020326
          ],
          [
            137.7952794833931,
            35.2041122409682
          ],
          [
            137.83815701309118,
            35.212502851855376
          ],
          [
            137.81633681112484,
            35.18798834789655
          ],
          [
            137.82886191527507,
            35.1520091953652
          ],
          [
            137.7049252645213,
            35.015645986130245
          ],
          [
            137.68925002629777,
            34.956552496450136
          ],
          [
            137.6592709071658,
            34.944320060422555
          ],
          [
            137.64130485512456,
            34.89327513301359
          ],
          [
            137.50333396297967,
            34.8333866793335
          ],
          [
            137.48696492566162,
            34.81151363832454
          ],
          [
            137.47427769868898,
            34.749678418867774
          ],
          [
            137.49179556691925,
            34.702335972244306
          ],
          [
            137.4841324946557,
            34.6738888623006
          ],
          [
            137.3413072919937,
            34.64769678825611
          ],
          [
            137.14993658545484,
            34.592228760636935
          ],
          [
            137.0263157713174,
            34.588791989574936
          ],
          [
            137.0707078215661,
            34.661583202282294
          ],
          [
            137.11893982205186,
            34.634796260941314
          ],
          [
            137.20636846201853,
            34.67817068821792
          ],
          [
            137.25177300288303,
            34.68893964478927
          ],
          [
            137.28491135567455,
            34.73093369451741
          ],
          [
            137.32056809590873,
            34.73284391374482
          ],
          [
            137.32104378295688,
            34.771178283851135
          ],
          [
            137.28861383201598,
            34.81281406965411
          ],
          [
            137.22283724975534,
            34.816753190090466
          ],
          [
            137.1527452377087,
            34.7816162632105
          ],
          [
            137.11666240675032,
            34.79054647301607
          ],
          [
            137.0261060833901,
            34.7777950201303
          ],
          [
            136.99534247262477,
            34.824847091619766
          ],
          [
            136.9350023863155,
            34.856064610553304
          ],
          [
            136.9147207642109,
            34.77009878474261
          ],
          [
            136.97245046559706,
            34.71744866729352
          ],
          [
            136.94349586840644,
            34.70032484175968
          ],
          [
            136.88943817229318,
            34.72054404149317
          ],
          [
            136.84325134838375,
            34.76577141371949
          ],
          [
            136.86643366557865,
            34.83987090677018
          ],
          [
            136.82246165096225,
            34.90275095376734
          ],
          [
            136.82044662694398,
            34.96621580754612
          ],
          [
            136.88739775864784,
            35.05927420948985
          ],
          [
            136.8917722047465,
            35.09257131320825
          ],
          [
            136.82747442139382,
            35.08307000180834
          ],
          [
            136.83819425239102,
            35.0305083617129
          ],
          [
            136.7940496898515,
            35.0150597628518
          ],
          [
            136.74939226591604,
            35.03698990473186
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "福井県",
      pref: "Fukui",
      name: "JP-18"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            136.24399715959873,
            36.295453436100885
          ],
          [
            136.26688628302023,
            36.26496681924262
          ],
          [
            136.3012845314313,
            36.25825179534925
          ],
          [
            136.34426011932368,
            36.17284643391646
          ],
          [
            136.40928804531273,
            36.17220522674597
          ],
          [
            136.46420624500263,
            36.137545312767436
          ],
          [
            136.56007261771745,
            36.152985185274495
          ],
          [
            136.65840934792303,
            36.0696162385303
          ],
          [
            136.75476692066994,
            36.087134052256324
          ],
          [
            136.72661586152506,
            35.99588603309674
          ],
          [
            136.7525248380173,
            35.9567169679079
          ],
          [
            136.79342433384028,
            35.94568656201534
          ],
          [
            136.82864809001725,
            35.848873742060746
          ],
          [
            136.8022272825917,
            35.84400819282863
          ],
          [
            136.78928586157863,
            35.79938655798901
          ],
          [
            136.72357410160657,
            35.808142508779206
          ],
          [
            136.70982587329937,
            35.79195230545797
          ],
          [
            136.59970574029043,
            35.79858288968363
          ],
          [
            136.5702756238144,
            35.77739983617685
          ],
          [
            136.5229212593241,
            35.7882389138382
          ],
          [
            136.49633577389883,
            35.765591171279915
          ],
          [
            136.43065878102706,
            35.775004409836654
          ],
          [
            136.37662895496283,
            35.79513453545464
          ],
          [
            136.32857902838848,
            35.77506863263633
          ],
          [
            136.32689614374212,
            35.73130135719197
          ],
          [
            136.28019959666452,
            35.65940058064657
          ],
          [
            136.1908513942858,
            35.702345251111076
          ],
          [
            136.15035297423444,
            35.697768477111865
          ],
          [
            136.14802815913347,
            35.662464942571916
          ],
          [
            136.17748870906505,
            35.59507332223598
          ],
          [
            136.16330719685251,
            35.57105873714032
          ],
          [
            136.1083732817919,
            35.56886832908128
          ],
          [
            136.08216152623427,
            35.5403712748722
          ],
          [
            136.0483290293834,
            35.53477039383223
          ],
          [
            135.98183423277422,
            35.48675853181434
          ],
          [
            135.93876568273822,
            35.518062812929
          ],
          [
            135.91590362568317,
            35.470876213320246
          ],
          [
            135.9137859409176,
            35.43178919078736
          ],
          [
            135.89063683209895,
            35.403132625737456
          ],
          [
            135.8135241017537,
            35.413189623238665
          ],
          [
            135.80743161103965,
            35.38525810106958
          ],
          [
            135.76878060148252,
            35.35602119100561
          ],
          [
            135.70086155546278,
            35.343586456576624
          ],
          [
            135.64190736433594,
            35.36685779532819
          ],
          [
            135.53384860884333,
            35.377940651465174
          ],
          [
            135.5261233605328,
            35.42083448609829
          ],
          [
            135.49522282373562,
            35.42615055586492
          ],
          [
            135.45843824491288,
            35.46817012174016
          ],
          [
            135.47615277537028,
            35.505399905624294
          ],
          [
            135.45009645346872,
            35.520790027793254
          ],
          [
            135.48438836716673,
            35.55801951869889
          ],
          [
            135.51784937453974,
            35.49361213379731
          ],
          [
            135.5748429038179,
            35.49228589138311
          ],
          [
            135.62673189909796,
            35.533091026691
          ],
          [
            135.6266635313522,
            35.488712888258
          ],
          [
            135.7362302334827,
            35.493103128832324
          ],
          [
            135.7509421116901,
            35.53014244020902
          ],
          [
            135.68860211331204,
            35.54604992190067
          ],
          [
            135.7155701855763,
            35.5700383745194
          ],
          [
            135.74982161933,
            35.56653865534639
          ],
          [
            135.79872471140266,
            35.5249683019956
          ],
          [
            135.83439081064822,
            35.53737644806086
          ],
          [
            135.8495112570364,
            35.571490148089424
          ],
          [
            135.83250876761696,
            35.60293113001432
          ],
          [
            135.91360314355862,
            35.6092789742999
          ],
          [
            135.98609609025888,
            35.64236519336544
          ],
          [
            135.96318165636302,
            35.656620797494696
          ],
          [
            135.97086068607794,
            35.71198016722252
          ],
          [
            135.99370374813958,
            35.74885915752046
          ],
          [
            136.02235505155426,
            35.74522783749002
          ],
          [
            136.0435867764794,
            35.70530729936817
          ],
          [
            136.025369551374,
            35.68056171270139
          ],
          [
            136.07191786185527,
            35.66044863699738
          ],
          [
            136.09868349341835,
            35.72591586910163
          ],
          [
            136.1000085153251,
            35.77881549477321
          ],
          [
            136.07025362695595,
            35.824767582523194
          ],
          [
            135.9942613986617,
            35.888046526063356
          ],
          [
            135.99708282139107,
            35.93543813344881
          ],
          [
            135.9585844424026,
            35.9767599974302
          ],
          [
            135.9642517850846,
            35.9975999945501
          ],
          [
            136.01222370311405,
            36.0348213767655
          ],
          [
            136.02788753536177,
            36.09583439014896
          ],
          [
            136.09563151537157,
            36.15575053099143
          ],
          [
            136.16309394695475,
            36.250116330228195
          ],
          [
            136.24399715959873,
            36.295453436100885
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "石川県",
      pref: "Ishikawa",
      name: "JP-17"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            137.05058955055807,
            36.95960643306103
          ],
          [
            136.98498811972917,
            36.96609690046669
          ],
          [
            136.9309226386352,
            36.950536844710605
          ],
          [
            136.87908129423764,
            36.906192877565275
          ],
          [
            136.84883654019592,
            36.81324485698568
          ],
          [
            136.83897970063464,
            36.745068370403594
          ],
          [
            136.78917647873251,
            36.71874621871116
          ],
          [
            136.81565899673728,
            36.70027748269311
          ],
          [
            136.81850643426836,
            36.66751243981956
          ],
          [
            136.7860017841561,
            36.62957306262325
          ],
          [
            136.7884502031841,
            36.59271178617854
          ],
          [
            136.81719794416912,
            36.55235445189602
          ],
          [
            136.79500531604745,
            36.510630634060554
          ],
          [
            136.7966382404375,
            36.44436734823363
          ],
          [
            136.77788131494665,
            36.43090077771314
          ],
          [
            136.80569248534968,
            36.355417852570554
          ],
          [
            136.7843672456009,
            36.34211156142782
          ],
          [
            136.79237202579816,
            36.299041918986866
          ],
          [
            136.81467936925497,
            36.26625369875793
          ],
          [
            136.85170705279126,
            36.248290342137416
          ],
          [
            136.77340833480937,
            36.15722731515275
          ],
          [
            136.77848676664976,
            36.12947217329588
          ],
          [
            136.75476692066994,
            36.087134052256324
          ],
          [
            136.65840934792303,
            36.0696162385303
          ],
          [
            136.56007261771745,
            36.152985185274495
          ],
          [
            136.46420624500263,
            36.137545312767436
          ],
          [
            136.40928804531273,
            36.17220522674597
          ],
          [
            136.34426011932368,
            36.17284643391646
          ],
          [
            136.3012845314313,
            36.25825179534925
          ],
          [
            136.26688628302023,
            36.26496681924262
          ],
          [
            136.24399715959873,
            36.295453436100885
          ],
          [
            136.29955379898132,
            36.35182346406337
          ],
          [
            136.3350365395354,
            36.35947246877125
          ],
          [
            136.42661213051474,
            36.430092936143964
          ],
          [
            136.607068007319,
            36.62231259404821
          ],
          [
            136.66928488283858,
            36.701110860913374
          ],
          [
            136.7243025424358,
            36.78989356958874
          ],
          [
            136.76734007855458,
            36.90477096683219
          ],
          [
            136.7487555446985,
            36.929966638078646
          ],
          [
            136.7683437881415,
            36.96371278733221
          ],
          [
            136.7681598421472,
            37.00084352583734
          ],
          [
            136.72295277173885,
            37.05379945157772
          ],
          [
            136.7275833038802,
            37.134306599390925
          ],
          [
            136.6697148545664,
            37.147488826534854
          ],
          [
            136.6790942308712,
            37.20447474038333
          ],
          [
            136.73424885818244,
            37.28291353042596
          ],
          [
            136.72239859006535,
            37.32448497280943
          ],
          [
            136.81156377177658,
            37.38660695925627
          ],
          [
            136.86826747998387,
            37.40703188689707
          ],
          [
            136.92731754308633,
            37.39575021814126
          ],
          [
            137.0654023916776,
            37.451980119545176
          ],
          [
            137.12712153184626,
            37.493369697010216
          ],
          [
            137.18039786413644,
            37.4997029765571
          ],
          [
            137.27696866896085,
            37.533194915269824
          ],
          [
            137.32829139708167,
            37.528938851686014
          ],
          [
            137.36057478645148,
            37.450655417682086
          ],
          [
            137.25693858844696,
            37.43155770477387
          ],
          [
            137.2380093134007,
            37.390801791825986
          ],
          [
            137.26482386716935,
            37.327000972336826
          ],
          [
            137.23456813290176,
            37.29776292243179
          ],
          [
            137.1448113206279,
            37.29951802680656
          ],
          [
            137.09798445632094,
            37.278203548505374
          ],
          [
            137.0693351262011,
            37.21808384570796
          ],
          [
            137.00552332494823,
            37.18408025824673
          ],
          [
            136.93172548487016,
            37.233112710321954
          ],
          [
            136.8838689797474,
            37.164091481311466
          ],
          [
            136.89284646325976,
            37.1181986534206
          ],
          [
            136.9723129388504,
            37.047042131970414
          ],
          [
            137.0058506701377,
            37.057784186672144
          ],
          [
            137.0300998613638,
            37.10689811905817
          ],
          [
            137.05275453871485,
            37.09489935069487
          ],
          [
            137.04562191474966,
            37.03771381735465
          ],
          [
            137.05058955055807,
            36.95960643306103
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "岐阜県",
      pref: "Gifu",
      name: "JP-21"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            137.5873711717327,
            36.38979696553771
          ],
          [
            137.6520270139845,
            36.32209280860964
          ],
          [
            137.64742818156503,
            36.28909591350453
          ],
          [
            137.58345907303274,
            36.22081924380973
          ],
          [
            137.5910905479314,
            36.1640521030501
          ],
          [
            137.56789001555518,
            36.15395283271621
          ],
          [
            137.55402946731982,
            36.106941255503415
          ],
          [
            137.6146138979645,
            36.06197532656076
          ],
          [
            137.5899047283241,
            36.006341692562074
          ],
          [
            137.54324386063584,
            35.9824587952114
          ],
          [
            137.47626712129392,
            35.89397548198766
          ],
          [
            137.43534839148165,
            35.90530814003786
          ],
          [
            137.38115172044854,
            35.89254260915553
          ],
          [
            137.33632289791404,
            35.79877529971021
          ],
          [
            137.3913450985201,
            35.798718037798885
          ],
          [
            137.39944434208937,
            35.77549617861824
          ],
          [
            137.4595103547107,
            35.76134129144539
          ],
          [
            137.4983644344489,
            35.6872258956005
          ],
          [
            137.54538392463803,
            35.65130004501497
          ],
          [
            137.5137993991382,
            35.607905776481694
          ],
          [
            137.53767890746704,
            35.5844175451713
          ],
          [
            137.55165564193183,
            35.511633951968
          ],
          [
            137.6071977735688,
            35.53345758653458
          ],
          [
            137.63154534460617,
            35.469942130142826
          ],
          [
            137.5931031293594,
            35.44704475502416
          ],
          [
            137.63364762313952,
            35.39909209929591
          ],
          [
            137.59041347886335,
            35.39370934789425
          ],
          [
            137.60131623123618,
            35.33084197327762
          ],
          [
            137.56154531829486,
            35.28926073432052
          ],
          [
            137.5211931783946,
            35.28422670717741
          ],
          [
            137.4293282912381,
            35.22284028262385
          ],
          [
            137.38376667165417,
            35.260558338944186
          ],
          [
            137.30888347252056,
            35.291635344721705
          ],
          [
            137.1999640625413,
            35.25154499374385
          ],
          [
            137.16528801135348,
            35.283249405292636
          ],
          [
            137.06634790944463,
            35.3089168717065
          ],
          [
            137.0728399250942,
            35.32598991159007
          ],
          [
            137.028162922216,
            35.37619174675732
          ],
          [
            137.00214056095376,
            35.38141386725393
          ],
          [
            136.98691505110486,
            35.420234417824354
          ],
          [
            136.92137583957384,
            35.37908592804381
          ],
          [
            136.86461917797382,
            35.372303062766505
          ],
          [
            136.8340239972052,
            35.35588072937313
          ],
          [
            136.77185178286018,
            35.36921068738909
          ],
          [
            136.72284837299733,
            35.292168050651945
          ],
          [
            136.6779157134454,
            35.241006814519366
          ],
          [
            136.67280839527146,
            35.134726628027025
          ],
          [
            136.61540986829294,
            35.150116437668494
          ],
          [
            136.6047667716333,
            35.17510488065911
          ],
          [
            136.55992737292647,
            35.206642113368055
          ],
          [
            136.53390478981018,
            35.257010731111066
          ],
          [
            136.51102569325354,
            35.23854665400677
          ],
          [
            136.4664039866343,
            35.237944760684535
          ],
          [
            136.4151680556184,
            35.21767952348444
          ],
          [
            136.37735032858933,
            35.24328835917264
          ],
          [
            136.4443894886148,
            35.38948452182108
          ],
          [
            136.4117884390096,
            35.418587817664765
          ],
          [
            136.42618716980277,
            35.448345420988424
          ],
          [
            136.38666815137532,
            35.4889473242409
          ],
          [
            136.39941702007226,
            35.53118421237364
          ],
          [
            136.31666487433782,
            35.549064570063244
          ],
          [
            136.32429349120963,
            35.58476759434949
          ],
          [
            136.29332372954832,
            35.618463825012505
          ],
          [
            136.28019959666452,
            35.65940058064657
          ],
          [
            136.32689614374212,
            35.73130135719197
          ],
          [
            136.32857902838848,
            35.77506863263633
          ],
          [
            136.37662895496283,
            35.79513453545464
          ],
          [
            136.43065878102706,
            35.775004409836654
          ],
          [
            136.49633577389883,
            35.765591171279915
          ],
          [
            136.5229212593241,
            35.7882389138382
          ],
          [
            136.5702756238144,
            35.77739983617685
          ],
          [
            136.59970574029043,
            35.79858288968363
          ],
          [
            136.70982587329937,
            35.79195230545797
          ],
          [
            136.72357410160657,
            35.808142508779206
          ],
          [
            136.78928586157863,
            35.79938655798901
          ],
          [
            136.8022272825917,
            35.84400819282863
          ],
          [
            136.82864809001725,
            35.848873742060746
          ],
          [
            136.79342433384028,
            35.94568656201534
          ],
          [
            136.7525248380173,
            35.9567169679079
          ],
          [
            136.72661586152506,
            35.99588603309674
          ],
          [
            136.75476692066994,
            36.087134052256324
          ],
          [
            136.77848676664976,
            36.12947217329588
          ],
          [
            136.77340833480937,
            36.15722731515275
          ],
          [
            136.85170705279126,
            36.248290342137416
          ],
          [
            136.81467936925497,
            36.26625369875793
          ],
          [
            136.79237202579816,
            36.299041918986866
          ],
          [
            136.826976849186,
            36.302792809172956
          ],
          [
            136.85415133814365,
            36.34724485353573
          ],
          [
            136.90816499166854,
            36.3608023200361
          ],
          [
            136.9547932864057,
            36.33933970048158
          ],
          [
            137.0027735288926,
            36.287055472290845
          ],
          [
            137.05149259832825,
            36.32825314434274
          ],
          [
            137.0764378158479,
            36.38365488252032
          ],
          [
            137.16042056888284,
            36.45658724659233
          ],
          [
            137.2083148140997,
            36.431292879169185
          ],
          [
            137.27908743173174,
            36.46499110175632
          ],
          [
            137.31685198821106,
            36.46090803111298
          ],
          [
            137.35818439639837,
            36.43643785928338
          ],
          [
            137.46096778008553,
            36.41214227598693
          ],
          [
            137.5111888183663,
            36.42392573051305
          ],
          [
            137.55838991983788,
            36.387938920585356
          ],
          [
            137.5873711717327,
            36.38979696553771
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "三重県",
      pref: "Mie",
      name: "JP-24"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            136.67280839527146,
            35.134726628027025
          ],
          [
            136.7504161401581,
            35.079802095432775
          ],
          [
            136.74939226591604,
            35.03698990473186
          ],
          [
            136.67634442810677,
            35.00871617047629
          ],
          [
            136.66570389158917,
            34.97286109773714
          ],
          [
            136.63751237953565,
            34.95743069955949
          ],
          [
            136.64239152522563,
            34.90060171085418
          ],
          [
            136.61557982227606,
            34.85348922967952
          ],
          [
            136.54419026319061,
            34.773037091312425
          ],
          [
            136.5207653140443,
            34.693699638552715
          ],
          [
            136.54931476857118,
            34.67081865046187
          ],
          [
            136.5542478511369,
            34.61482518710329
          ],
          [
            136.64737295120997,
            34.58878776351924
          ],
          [
            136.66462068100202,
            34.5596246085525
          ],
          [
            136.73421465497185,
            34.53801211232988
          ],
          [
            136.7758518519602,
            34.508985250047914
          ],
          [
            136.81025048694102,
            34.508085934131635
          ],
          [
            136.86661039275043,
            34.481232768000275
          ],
          [
            136.87502210355083,
            34.45105147732668
          ],
          [
            136.919488711591,
            34.445354417493384
          ],
          [
            136.92727541326198,
            34.413741034464195
          ],
          [
            136.87208417884358,
            34.35180094938994
          ],
          [
            136.89840858131956,
            34.27528870989147
          ],
          [
            136.8403943083967,
            34.25225063115627
          ],
          [
            136.76544519998802,
            34.260137837687104
          ],
          [
            136.7595326069028,
            34.30689867201096
          ],
          [
            136.7158047855962,
            34.30209069905112
          ],
          [
            136.67715206151075,
            34.31559616493807
          ],
          [
            136.60283728677928,
            34.25760102293358
          ],
          [
            136.54903000869274,
            34.28263813802416
          ],
          [
            136.50984383660327,
            34.248451523833054
          ],
          [
            136.3641741831103,
            34.189219726603184
          ],
          [
            136.3396178002307,
            34.20465817226718
          ],
          [
            136.27823305600495,
            34.16141026345575
          ],
          [
            136.2846223461168,
            34.11764818300965
          ],
          [
            136.24827955862824,
            34.10277499975579
          ],
          [
            136.24299428915612,
            34.05915328880467
          ],
          [
            136.26979858434763,
            34.030215889811295
          ],
          [
            136.27214450203738,
            33.97293048200785
          ],
          [
            136.21027288466465,
            33.99870111226291
          ],
          [
            136.22756428892205,
            33.951056382191695
          ],
          [
            136.179947626229,
            33.91286800754902
          ],
          [
            136.10129077168295,
            33.8856196582839
          ],
          [
            136.04244156332643,
            33.79821305046296
          ],
          [
            136.01161143698644,
            33.723729363412694
          ],
          [
            135.94568837289842,
            33.732137442713096
          ],
          [
            135.90691557139408,
            33.7671480977139
          ],
          [
            135.8909438088634,
            33.80164497346409
          ],
          [
            135.8559199967976,
            33.82000755398674
          ],
          [
            135.85794315310284,
            33.87303485605612
          ],
          [
            135.87472993771607,
            33.86158690944228
          ],
          [
            135.90161991009296,
            33.88370944633717
          ],
          [
            135.88080563761278,
            33.909272477673376
          ],
          [
            135.9089888068979,
            33.91852279104296
          ],
          [
            135.9279539366337,
            33.94080299852167
          ],
          [
            135.96895655053515,
            33.9291534519814
          ],
          [
            136.01308468747055,
            33.96866767360992
          ],
          [
            136.00357956844965,
            34.00977855075546
          ],
          [
            136.01971566094005,
            34.03665163473735
          ],
          [
            136.0730007613976,
            34.033786091272994
          ],
          [
            136.10220837929575,
            34.09615582522488
          ],
          [
            136.10901186578144,
            34.18504545880008
          ],
          [
            136.13193525472232,
            34.251882935274615
          ],
          [
            136.09499317806547,
            34.301100701908005
          ],
          [
            136.10204116074664,
            34.33663892837612
          ],
          [
            136.06923279953216,
            34.389098781787204
          ],
          [
            136.0888568909568,
            34.42883642603339
          ],
          [
            136.12978955471726,
            34.4454261582419
          ],
          [
            136.2062485957526,
            34.448628581129384
          ],
          [
            136.2163678850512,
            34.52836034745402
          ],
          [
            136.16767474348572,
            34.5207020452308
          ],
          [
            136.15567882940218,
            34.55963668501614
          ],
          [
            136.0834806648309,
            34.55916134161293
          ],
          [
            136.0466342888107,
            34.60029572814473
          ],
          [
            136.0730204953989,
            34.63156053007951
          ],
          [
            136.0862555945766,
            34.67550874509763
          ],
          [
            136.0539373898006,
            34.73845304364484
          ],
          [
            136.02141318121784,
            34.79205095800073
          ],
          [
            136.0903205502253,
            34.81200982116643
          ],
          [
            136.13125418035344,
            34.88306905611119
          ],
          [
            136.166381080026,
            34.88792814656125
          ],
          [
            136.2506363392541,
            34.8578334085138
          ],
          [
            136.36585558757312,
            34.904979655157014
          ],
          [
            136.42116887716742,
            34.999669034207486
          ],
          [
            136.41854610747123,
            35.048213655509905
          ],
          [
            136.4410178234508,
            35.0642455771765
          ],
          [
            136.4353052849749,
            35.13072258510497
          ],
          [
            136.4545824846378,
            35.16161204070465
          ],
          [
            136.42462870990204,
            35.18455025670847
          ],
          [
            136.4151680556184,
            35.21767952348444
          ],
          [
            136.4664039866343,
            35.237944760684535
          ],
          [
            136.51102569325354,
            35.23854665400677
          ],
          [
            136.53390478981018,
            35.257010731111066
          ],
          [
            136.55992737292647,
            35.206642113368055
          ],
          [
            136.6047667716333,
            35.17510488065911
          ],
          [
            136.61540986829294,
            35.150116437668494
          ],
          [
            136.67280839527146,
            35.134726628027025
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "長野県",
      pref: "Nagano",
      name: "JP-20"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            138.6957692097514,
            36.73847184570369
          ],
          [
            138.54368381293435,
            36.70374961988282
          ],
          [
            138.51974533019253,
            36.689349596364764
          ],
          [
            138.525231998016,
            36.65136304730397
          ],
          [
            138.45833782385506,
            36.63408489804006
          ],
          [
            138.4287234101576,
            36.59779095634669
          ],
          [
            138.42901992656647,
            36.55646258892511
          ],
          [
            138.40398880313134,
            36.52121389832871
          ],
          [
            138.4007284881166,
            36.43526413999608
          ],
          [
            138.4887091955284,
            36.40090619420367
          ],
          [
            138.54046668622954,
            36.40277348162781
          ],
          [
            138.59170132218816,
            36.42431539945689
          ],
          [
            138.64834614980168,
            36.40746789375471
          ],
          [
            138.65353207215065,
            36.30302985831768
          ],
          [
            138.61233887529485,
            36.285630632951026
          ],
          [
            138.60224596348039,
            36.24894340916488
          ],
          [
            138.63706368392448,
            36.17492744129538
          ],
          [
            138.63068802068832,
            36.09124479335538
          ],
          [
            138.64418613069589,
            36.04982404851799
          ],
          [
            138.63144495586718,
            36.02830896652856
          ],
          [
            138.71270729912848,
            35.98521592986725
          ],
          [
            138.73924315240836,
            35.93925483095995
          ],
          [
            138.72885454053798,
            35.90927585548374
          ],
          [
            138.68562087734702,
            35.89391071574065
          ],
          [
            138.67615191292094,
            35.869881286317494
          ],
          [
            138.60673042296423,
            35.87851129488962
          ],
          [
            138.60396979771687,
            35.90924881725713
          ],
          [
            138.51074766100123,
            35.922494576995206
          ],
          [
            138.49012631957171,
            35.8964060116971
          ],
          [
            138.4544694917569,
            35.899864920977826
          ],
          [
            138.4446151783539,
            35.95016744141872
          ],
          [
            138.38185917190737,
            35.971455050011734
          ],
          [
            138.29583786770314,
            35.870009416555504
          ],
          [
            138.23275366380958,
            35.87648909759727
          ],
          [
            138.18546035925434,
            35.795590731730485
          ],
          [
            138.23679451371493,
            35.757896429369964
          ],
          [
            138.18026496143494,
            35.714598993299695
          ],
          [
            138.2179552026063,
            35.645133250187506
          ],
          [
            138.18407910173653,
            35.57302594416707
          ],
          [
            138.14592266965568,
            35.55687696533896
          ],
          [
            138.13950999159383,
            35.50120986627829
          ],
          [
            138.1553002640167,
            35.45896490198551
          ],
          [
            138.1214760818272,
            35.428601183151834
          ],
          [
            138.15266356973376,
            35.39789886520366
          ],
          [
            138.08745373283998,
            35.33795344260868
          ],
          [
            138.06097172836684,
            35.3470246704072
          ],
          [
            137.96597198483417,
            35.28387301387035
          ],
          [
            137.89532893747057,
            35.25788254335121
          ],
          [
            137.87308381160523,
            35.21915426805471
          ],
          [
            137.83815701309118,
            35.212502851855376
          ],
          [
            137.7952794833931,
            35.2041122409682
          ],
          [
            137.6941486838531,
            35.23367155020326
          ],
          [
            137.57871703990185,
            35.19842827625316
          ],
          [
            137.5461485096556,
            35.25151481822677
          ],
          [
            137.56154531829486,
            35.28926073432052
          ],
          [
            137.60131623123618,
            35.33084197327762
          ],
          [
            137.59041347886335,
            35.39370934789425
          ],
          [
            137.63364762313952,
            35.39909209929591
          ],
          [
            137.5931031293594,
            35.44704475502416
          ],
          [
            137.63154534460617,
            35.469942130142826
          ],
          [
            137.6071977735688,
            35.53345758653458
          ],
          [
            137.55165564193183,
            35.511633951968
          ],
          [
            137.53767890746704,
            35.5844175451713
          ],
          [
            137.5137993991382,
            35.607905776481694
          ],
          [
            137.54538392463803,
            35.65130004501497
          ],
          [
            137.4983644344489,
            35.6872258956005
          ],
          [
            137.4595103547107,
            35.76134129144539
          ],
          [
            137.39944434208937,
            35.77549617861824
          ],
          [
            137.3913450985201,
            35.798718037798885
          ],
          [
            137.33632289791404,
            35.79877529971021
          ],
          [
            137.38115172044854,
            35.89254260915553
          ],
          [
            137.43534839148165,
            35.90530814003786
          ],
          [
            137.47626712129392,
            35.89397548198766
          ],
          [
            137.54324386063584,
            35.9824587952114
          ],
          [
            137.5899047283241,
            36.006341692562074
          ],
          [
            137.6146138979645,
            36.06197532656076
          ],
          [
            137.55402946731982,
            36.106941255503415
          ],
          [
            137.56789001555518,
            36.15395283271621
          ],
          [
            137.5910905479314,
            36.1640521030501
          ],
          [
            137.58345907303274,
            36.22081924380973
          ],
          [
            137.64742818156503,
            36.28909591350453
          ],
          [
            137.6520270139845,
            36.32209280860964
          ],
          [
            137.5873711717327,
            36.38979696553771
          ],
          [
            137.63639271565054,
            36.429118356926125
          ],
          [
            137.66874814935872,
            36.50908433315428
          ],
          [
            137.6944057354,
            36.51056059710781
          ],
          [
            137.6875474925059,
            36.56174761189879
          ],
          [
            137.74432053415651,
            36.6123069408886
          ],
          [
            137.76163575488886,
            36.665002159023196
          ],
          [
            137.75004693901838,
            36.70425167379027
          ],
          [
            137.76257899424425,
            36.76628440927739
          ],
          [
            137.82003872008235,
            36.79831635447401
          ],
          [
            137.87647163549528,
            36.867045061883914
          ],
          [
            137.8615943286227,
            36.89163390219745
          ],
          [
            137.92088432246993,
            36.91998750934289
          ],
          [
            138.01382087678638,
            36.90371171268867
          ],
          [
            138.03243877133795,
            36.88098152376431
          ],
          [
            138.0033416778321,
            36.82649402530323
          ],
          [
            138.05196731786623,
            36.79998306956418
          ],
          [
            138.1149290998104,
            36.85033667858788
          ],
          [
            138.16281504687723,
            36.84428036520867
          ],
          [
            138.2135219732598,
            36.86969113074599
          ],
          [
            138.2957791432479,
            36.85530232230235
          ],
          [
            138.29765304648095,
            36.912370133977625
          ],
          [
            138.34295896103856,
            36.92078488558703
          ],
          [
            138.39469584207632,
            36.99720313091019
          ],
          [
            138.45513185439657,
            37.01962774923786
          ],
          [
            138.5246143100996,
            37.03035228738401
          ],
          [
            138.56586129157395,
            37.021230833975494
          ],
          [
            138.58671887900803,
            36.98818439137146
          ],
          [
            138.5828925454532,
            36.92832552802216
          ],
          [
            138.62645745363034,
            36.88200343238736
          ],
          [
            138.68682561979622,
            36.86288328134317
          ],
          [
            138.69534237699656,
            36.80689582703929
          ],
          [
            138.67294115123073,
            36.7700848553948
          ],
          [
            138.6957692097514,
            36.73847184570369
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "新潟県",
      pref: "Niigata",
      name: "JP-15"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            139.7412726432231,
            37.82032989242511
          ],
          [
            139.6802738479586,
            37.775396140604485
          ],
          [
            139.62406643017357,
            37.71022781496319
          ],
          [
            139.61809563278408,
            37.68880276227584
          ],
          [
            139.54691655949944,
            37.63179600844701
          ],
          [
            139.56496263164135,
            37.59740694463239
          ],
          [
            139.5701204448439,
            37.5393609881909
          ],
          [
            139.54328375238006,
            37.51204599779691
          ],
          [
            139.4571544768579,
            37.51797724645291
          ],
          [
            139.41438139216177,
            37.51017762375081
          ],
          [
            139.39748326295623,
            37.45989192101873
          ],
          [
            139.35154985206532,
            37.46808903202695
          ],
          [
            139.25905978651423,
            37.447030899049935
          ],
          [
            139.22345565517816,
            37.44916521724546
          ],
          [
            139.20470872904926,
            37.40609263279281
          ],
          [
            139.237857615147,
            37.37355782475714
          ],
          [
            139.2128635686936,
            37.28719967722365
          ],
          [
            139.16617831616222,
            37.23204988191449
          ],
          [
            139.25300291464364,
            37.158414359988065
          ],
          [
            139.23528041242602,
            37.1134807534302
          ],
          [
            139.26020146668188,
            37.044974316300674
          ],
          [
            139.24341579837738,
            37.01545930434904
          ],
          [
            139.25543763608403,
            36.989204297627005
          ],
          [
            139.23372441573144,
            36.94229442780851
          ],
          [
            139.18634106203683,
            36.960021698492085
          ],
          [
            139.17957902440799,
            36.99049582971504
          ],
          [
            139.09666900563664,
            37.05922632476876
          ],
          [
            139.0912449521353,
            37.01990380023796
          ],
          [
            139.03537502209042,
            36.9840092707641
          ],
          [
            138.96645832355793,
            36.97874724633296
          ],
          [
            138.9797226446212,
            36.891844321345154
          ],
          [
            138.93212368794073,
            36.893583806165786
          ],
          [
            138.91634542389778,
            36.850416304855905
          ],
          [
            138.8313113081882,
            36.794270937825786
          ],
          [
            138.81776293185703,
            36.76162293643779
          ],
          [
            138.76724679346503,
            36.746515140621305
          ],
          [
            138.72710178496777,
            36.76412019507956
          ],
          [
            138.6957692097514,
            36.73847184570369
          ],
          [
            138.67294115123073,
            36.7700848553948
          ],
          [
            138.69534237699656,
            36.80689582703929
          ],
          [
            138.68682561979622,
            36.86288328134317
          ],
          [
            138.62645745363034,
            36.88200343238736
          ],
          [
            138.5828925454532,
            36.92832552802216
          ],
          [
            138.58671887900803,
            36.98818439137146
          ],
          [
            138.56586129157395,
            37.021230833975494
          ],
          [
            138.5246143100996,
            37.03035228738401
          ],
          [
            138.45513185439657,
            37.01962774923786
          ],
          [
            138.39469584207632,
            36.99720313091019
          ],
          [
            138.34295896103856,
            36.92078488558703
          ],
          [
            138.29765304648095,
            36.912370133977625
          ],
          [
            138.2957791432479,
            36.85530232230235
          ],
          [
            138.2135219732598,
            36.86969113074599
          ],
          [
            138.16281504687723,
            36.84428036520867
          ],
          [
            138.1149290998104,
            36.85033667858788
          ],
          [
            138.05196731786623,
            36.79998306956418
          ],
          [
            138.0033416778321,
            36.82649402530323
          ],
          [
            138.03243877133795,
            36.88098152376431
          ],
          [
            138.01382087678638,
            36.90371171268867
          ],
          [
            137.92088432246993,
            36.91998750934289
          ],
          [
            137.8615943286227,
            36.89163390219745
          ],
          [
            137.87647163549528,
            36.867045061883914
          ],
          [
            137.82003872008235,
            36.79831635447401
          ],
          [
            137.76257899424425,
            36.76628440927739
          ],
          [
            137.71399080837614,
            36.89050162417251
          ],
          [
            137.71108011238096,
            36.9444058980936
          ],
          [
            137.66648310216368,
            36.950310017326125
          ],
          [
            137.63496433303584,
            36.98016964358698
          ],
          [
            137.7308841749501,
            37.00303385072707
          ],
          [
            137.83240853773603,
            37.04095807314601
          ],
          [
            137.9113744401166,
            37.06042306443459
          ],
          [
            138.00048827062517,
            37.11208618444354
          ],
          [
            138.04854653266202,
            37.12786234075599
          ],
          [
            138.09624775259522,
            37.17305744950979
          ],
          [
            138.16900166993332,
            37.16203670557393
          ],
          [
            138.23415144161117,
            37.17536215592352
          ],
          [
            138.34777367532192,
            37.249207004652874
          ],
          [
            138.41816511359696,
            37.30646870422601
          ],
          [
            138.49078733468002,
            37.352805440220294
          ],
          [
            138.54526152889588,
            37.369597309758696
          ],
          [
            138.6173782093219,
            37.4726404841154
          ],
          [
            138.66005472865882,
            37.523537618115796
          ],
          [
            138.7120787854545,
            37.55779206020693
          ],
          [
            138.76823388796907,
            37.64787366553337
          ],
          [
            138.7847121199258,
            37.718099909298026
          ],
          [
            138.82050386362909,
            37.79449033530073
          ],
          [
            138.8925332946943,
            37.85320424123312
          ],
          [
            139.00434072487323,
            37.91019356393177
          ],
          [
            139.07155469290402,
            37.95232201828276
          ],
          [
            139.2013425173089,
            37.98244743258487
          ],
          [
            139.31427666815412,
            38.04978936188644
          ],
          [
            139.36649883483224,
            38.09929548960356
          ],
          [
            139.42578512873828,
            38.17485728825937
          ],
          [
            139.44049055863718,
            38.24703981228119
          ],
          [
            139.45485301519955,
            38.38942975866783
          ],
          [
            139.54806301343513,
            38.55309331332139
          ],
          [
            139.5999524280632,
            38.52192971315657
          ],
          [
            139.7217674142737,
            38.49628873692621
          ],
          [
            139.70548799319369,
            38.4071880205243
          ],
          [
            139.74975733246194,
            38.359728774173746
          ],
          [
            139.8166270508299,
            38.3559636381767
          ],
          [
            139.89882854777358,
            38.29312927158838
          ],
          [
            139.86059659534283,
            38.23162034167936
          ],
          [
            139.79051711596244,
            38.198002498405074
          ],
          [
            139.71322340873115,
            38.206628102371596
          ],
          [
            139.68227318752778,
            38.17186050807387
          ],
          [
            139.69091232159977,
            38.11836820365161
          ],
          [
            139.6801273881278,
            38.04332504952047
          ],
          [
            139.6552083670898,
            38.035686513844404
          ],
          [
            139.65447251900736,
            37.99701476260961
          ],
          [
            139.62481791886412,
            37.91841558015718
          ],
          [
            139.63854295412057,
            37.87992527117786
          ],
          [
            139.68199726957602,
            37.84740023046887
          ],
          [
            139.71598696676904,
            37.85404123123085
          ],
          [
            139.7412726432231,
            37.82032989242511
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "静岡県",
      pref: "Shizuoka",
      name: "JP-22"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            137.4841324946557,
            34.6738888623006
          ],
          [
            137.49179556691925,
            34.702335972244306
          ],
          [
            137.47427769868898,
            34.749678418867774
          ],
          [
            137.48696492566162,
            34.81151363832454
          ],
          [
            137.50333396297967,
            34.8333866793335
          ],
          [
            137.64130485512456,
            34.89327513301359
          ],
          [
            137.6592709071658,
            34.944320060422555
          ],
          [
            137.68925002629777,
            34.956552496450136
          ],
          [
            137.7049252645213,
            35.015645986130245
          ],
          [
            137.82886191527507,
            35.1520091953652
          ],
          [
            137.81633681112484,
            35.18798834789655
          ],
          [
            137.83815701309118,
            35.212502851855376
          ],
          [
            137.87308381160523,
            35.21915426805471
          ],
          [
            137.89532893747057,
            35.25788254335121
          ],
          [
            137.96597198483417,
            35.28387301387035
          ],
          [
            138.06097172836684,
            35.3470246704072
          ],
          [
            138.08745373283998,
            35.33795344260868
          ],
          [
            138.15266356973376,
            35.39789886520366
          ],
          [
            138.1214760818272,
            35.428601183151834
          ],
          [
            138.1553002640167,
            35.45896490198551
          ],
          [
            138.13950999159383,
            35.50120986627829
          ],
          [
            138.14592266965568,
            35.55687696533896
          ],
          [
            138.18407910173653,
            35.57302594416707
          ],
          [
            138.2179552026063,
            35.645133250187506
          ],
          [
            138.25960998629841,
            35.55283081278281
          ],
          [
            138.2578595222934,
            35.47587169348658
          ],
          [
            138.24444108476018,
            35.45939177061368
          ],
          [
            138.25825228695018,
            35.40730708830587
          ],
          [
            138.2580203971609,
            35.3164844284983
          ],
          [
            138.2853530930566,
            35.30441138002161
          ],
          [
            138.32407346710278,
            35.327091871242445
          ],
          [
            138.3719190540945,
            35.300068440494066
          ],
          [
            138.3670737116791,
            35.270625647263586
          ],
          [
            138.39869539091177,
            35.2003578745573
          ],
          [
            138.43088768721043,
            35.180486018667665
          ],
          [
            138.49149874637834,
            35.168405358916736
          ],
          [
            138.53320302968376,
            35.200752889420805
          ],
          [
            138.514541374917,
            35.26196277229895
          ],
          [
            138.51221372846297,
            35.313789088756735
          ],
          [
            138.53501457917503,
            35.33062216912958
          ],
          [
            138.53182973086848,
            35.40927835118385
          ],
          [
            138.5588639169587,
            35.4340569648441
          ],
          [
            138.59742003589702,
            35.432701623744855
          ],
          [
            138.60919130600104,
            35.393173034301704
          ],
          [
            138.6711671842231,
            35.39287342288306
          ],
          [
            138.68048940549136,
            35.35770471355938
          ],
          [
            138.79957322548753,
            35.37670532019
          ],
          [
            138.87321998078528,
            35.38153963362132
          ],
          [
            138.91625337785723,
            35.40059584351664
          ],
          [
            138.99976878118252,
            35.40165703089994
          ],
          [
            139.010507148965,
            35.338362316436495
          ],
          [
            139.00523188070684,
            35.29052820772422
          ],
          [
            138.97552154068637,
            35.26374857889434
          ],
          [
            138.98766702034254,
            35.20086360822993
          ],
          [
            139.02753375535673,
            35.1754769007298
          ],
          [
            139.0305909077395,
            35.1498466385443
          ],
          [
            139.11152958929335,
            35.141399382647066
          ],
          [
            139.07474441854933,
            35.09174636558972
          ],
          [
            139.0739113706391,
            35.04687604175166
          ],
          [
            139.09954214081122,
            35.04617808749754
          ],
          [
            139.0942427593196,
            34.977568337842314
          ],
          [
            139.12859831067826,
            34.96896365678194
          ],
          [
            139.148806910218,
            34.93581599000276
          ],
          [
            139.13136257624205,
            34.87868443593574
          ],
          [
            139.07684329238356,
            34.841675294216664
          ],
          [
            139.05788945431956,
            34.78457365370181
          ],
          [
            139.00450907205067,
            34.751833950768145
          ],
          [
            138.95950342520328,
            34.668722809727626
          ],
          [
            138.90485879805107,
            34.62900099476664
          ],
          [
            138.82833743698995,
            34.604849199030326
          ],
          [
            138.7715686196776,
            34.6489590181099
          ],
          [
            138.79017735423892,
            34.66788463375314
          ],
          [
            138.73968310083714,
            34.705006694573505
          ],
          [
            138.77482727959176,
            34.75332142449733
          ],
          [
            138.75291672985324,
            34.800010846674674
          ],
          [
            138.75630302101783,
            34.885154956991144
          ],
          [
            138.78991986946292,
            34.90983516312661
          ],
          [
            138.7622484426651,
            34.97237746764141
          ],
          [
            138.7851794139914,
            35.02646364900475
          ],
          [
            138.8456692350549,
            35.01397288474257
          ],
          [
            138.89214030567973,
            35.032079545779936
          ],
          [
            138.87186582263152,
            35.07089274753472
          ],
          [
            138.8067469286252,
            35.116569552475696
          ],
          [
            138.6977549159264,
            35.13677334633962
          ],
          [
            138.6393574720328,
            35.11499176446366
          ],
          [
            138.5564908624499,
            35.10155085177307
          ],
          [
            138.53454405984542,
            35.05571257385947
          ],
          [
            138.49378484544863,
            35.03151570786553
          ],
          [
            138.52713316529193,
            34.99726236013739
          ],
          [
            138.50307342526278,
            34.974664812568044
          ],
          [
            138.41303864418927,
            34.942132180138465
          ],
          [
            138.35515389773602,
            34.91317621423315
          ],
          [
            138.32791700840932,
            34.8682386537212
          ],
          [
            138.33881911773088,
            34.83218626580982
          ],
          [
            138.3005703840216,
            34.77031013567748
          ],
          [
            138.2268779573022,
            34.72745589690738
          ],
          [
            138.19773470582913,
            34.66999676471462
          ],
          [
            138.19201889512405,
            34.60033782215767
          ],
          [
            138.07823526354164,
            34.64234560385727
          ],
          [
            137.97003100765994,
            34.66553223671503
          ],
          [
            137.91167824628562,
            34.66710436886537
          ],
          [
            137.79842634294698,
            34.645530041224085
          ],
          [
            137.6071149582733,
            34.68664235964838
          ],
          [
            137.59287087317034,
            34.74196924437585
          ],
          [
            137.64198605277997,
            34.78329740377423
          ],
          [
            137.6248600866094,
            34.80171028996973
          ],
          [
            137.52837073898257,
            34.75437936420036
          ],
          [
            137.5586131489072,
            34.71018921758912
          ],
          [
            137.59673453322497,
            34.678001268378544
          ],
          [
            137.4841324946557,
            34.6738888623006
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "富山県",
      pref: "Toyama",
      name: "JP-16"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            137.63496433303584,
            36.98016964358698
          ],
          [
            137.66648310216368,
            36.950310017326125
          ],
          [
            137.71108011238096,
            36.9444058980936
          ],
          [
            137.71399080837614,
            36.89050162417251
          ],
          [
            137.76257899424425,
            36.76628440927739
          ],
          [
            137.75004693901838,
            36.70425167379027
          ],
          [
            137.76163575488886,
            36.665002159023196
          ],
          [
            137.74432053415651,
            36.6123069408886
          ],
          [
            137.6875474925059,
            36.56174761189879
          ],
          [
            137.6944057354,
            36.51056059710781
          ],
          [
            137.66874814935872,
            36.50908433315428
          ],
          [
            137.63639271565054,
            36.429118356926125
          ],
          [
            137.5873711717327,
            36.38979696553771
          ],
          [
            137.55838991983788,
            36.387938920585356
          ],
          [
            137.5111888183663,
            36.42392573051305
          ],
          [
            137.46096778008553,
            36.41214227598693
          ],
          [
            137.35818439639837,
            36.43643785928338
          ],
          [
            137.31685198821106,
            36.46090803111298
          ],
          [
            137.27908743173174,
            36.46499110175632
          ],
          [
            137.2083148140997,
            36.431292879169185
          ],
          [
            137.16042056888284,
            36.45658724659233
          ],
          [
            137.0764378158479,
            36.38365488252032
          ],
          [
            137.05149259832825,
            36.32825314434274
          ],
          [
            137.0027735288926,
            36.287055472290845
          ],
          [
            136.9547932864057,
            36.33933970048158
          ],
          [
            136.90816499166854,
            36.3608023200361
          ],
          [
            136.85415133814365,
            36.34724485353573
          ],
          [
            136.826976849186,
            36.302792809172956
          ],
          [
            136.79237202579816,
            36.299041918986866
          ],
          [
            136.7843672456009,
            36.34211156142782
          ],
          [
            136.80569248534968,
            36.355417852570554
          ],
          [
            136.77788131494665,
            36.43090077771314
          ],
          [
            136.7966382404375,
            36.44436734823363
          ],
          [
            136.79500531604745,
            36.510630634060554
          ],
          [
            136.81719794416912,
            36.55235445189602
          ],
          [
            136.7884502031841,
            36.59271178617854
          ],
          [
            136.7860017841561,
            36.62957306262325
          ],
          [
            136.81850643426836,
            36.66751243981956
          ],
          [
            136.81565899673728,
            36.70027748269311
          ],
          [
            136.78917647873251,
            36.71874621871116
          ],
          [
            136.83897970063464,
            36.745068370403594
          ],
          [
            136.84883654019592,
            36.81324485698568
          ],
          [
            136.87908129423764,
            36.906192877565275
          ],
          [
            136.9309226386352,
            36.950536844710605
          ],
          [
            136.98498811972917,
            36.96609690046669
          ],
          [
            137.05058955055807,
            36.95960643306103
          ],
          [
            137.03269290180458,
            36.92356872718066
          ],
          [
            136.98390605009953,
            36.87264102417319
          ],
          [
            136.99474768189273,
            36.84841741219018
          ],
          [
            137.0873118759066,
            36.782530529357345
          ],
          [
            137.18008021100633,
            36.757660715588976
          ],
          [
            137.24441502069993,
            36.76455569064913
          ],
          [
            137.33267820335638,
            36.76221342130503
          ],
          [
            137.39300853640128,
            36.80739261892095
          ],
          [
            137.43602085816306,
            36.93074584245093
          ],
          [
            137.49120259390753,
            36.95446616502362
          ],
          [
            137.57481600014924,
            36.96422648404309
          ],
          [
            137.63496433303584,
            36.98016964358698
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "山梨県",
      pref: "Yamanashi",
      name: "JP-19"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            138.72885454053798,
            35.90927585548374
          ],
          [
            138.7907510912227,
            35.8920863588181
          ],
          [
            138.81360606645947,
            35.86232615784687
          ],
          [
            138.87748039250363,
            35.84818662295078
          ],
          [
            138.94403516649484,
            35.85466218251434
          ],
          [
            138.99252204614,
            35.75546244476023
          ],
          [
            139.02950581233242,
            35.71651780832572
          ],
          [
            139.10850873906136,
            35.6896399103694
          ],
          [
            139.13097281518765,
            35.671817333463224
          ],
          [
            139.12930054280045,
            35.564256192514314
          ],
          [
            139.08572093587526,
            35.512113379589785
          ],
          [
            139.0278291386846,
            35.48116477073011
          ],
          [
            138.95886948269194,
            35.46236534303307
          ],
          [
            138.9276484878501,
            35.43741745117915
          ],
          [
            138.91625337785723,
            35.40059584351664
          ],
          [
            138.87321998078528,
            35.38153963362132
          ],
          [
            138.79957322548753,
            35.37670532019
          ],
          [
            138.68048940549136,
            35.35770471355938
          ],
          [
            138.6711671842231,
            35.39287342288306
          ],
          [
            138.60919130600104,
            35.393173034301704
          ],
          [
            138.59742003589702,
            35.432701623744855
          ],
          [
            138.5588639169587,
            35.4340569648441
          ],
          [
            138.53182973086848,
            35.40927835118385
          ],
          [
            138.53501457917503,
            35.33062216912958
          ],
          [
            138.51221372846297,
            35.313789088756735
          ],
          [
            138.514541374917,
            35.26196277229895
          ],
          [
            138.53320302968376,
            35.200752889420805
          ],
          [
            138.49149874637834,
            35.168405358916736
          ],
          [
            138.43088768721043,
            35.180486018667665
          ],
          [
            138.39869539091177,
            35.2003578745573
          ],
          [
            138.3670737116791,
            35.270625647263586
          ],
          [
            138.3719190540945,
            35.300068440494066
          ],
          [
            138.32407346710278,
            35.327091871242445
          ],
          [
            138.2853530930566,
            35.30441138002161
          ],
          [
            138.2580203971609,
            35.3164844284983
          ],
          [
            138.25825228695018,
            35.40730708830587
          ],
          [
            138.24444108476018,
            35.45939177061368
          ],
          [
            138.2578595222934,
            35.47587169348658
          ],
          [
            138.25960998629841,
            35.55283081278281
          ],
          [
            138.2179552026063,
            35.645133250187506
          ],
          [
            138.18026496143494,
            35.714598993299695
          ],
          [
            138.23679451371493,
            35.757896429369964
          ],
          [
            138.18546035925434,
            35.795590731730485
          ],
          [
            138.23275366380958,
            35.87648909759727
          ],
          [
            138.29583786770314,
            35.870009416555504
          ],
          [
            138.38185917190737,
            35.971455050011734
          ],
          [
            138.4446151783539,
            35.95016744141872
          ],
          [
            138.4544694917569,
            35.899864920977826
          ],
          [
            138.49012631957171,
            35.8964060116971
          ],
          [
            138.51074766100123,
            35.922494576995206
          ],
          [
            138.60396979771687,
            35.90924881725713
          ],
          [
            138.60673042296423,
            35.87851129488962
          ],
          [
            138.67615191292094,
            35.869881286317494
          ],
          [
            138.68562087734702,
            35.89391071574065
          ],
          [
            138.72885454053798,
            35.90927585548374
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "兵庫県",
      pref: "Hyogo",
      name: "JP-28"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            134.36990990668946,
            35.61036122739779
          ],
          [
            134.4057055261386,
            35.6159643535443
          ],
          [
            134.53881915311683,
            35.67033516412011
          ],
          [
            134.56058928443125,
            35.650678629148516
          ],
          [
            134.64855870743912,
            35.661362159583774
          ],
          [
            134.7082142686142,
            35.653939823712456
          ],
          [
            134.79857047833238,
            35.6704477111401
          ],
          [
            134.8421525793114,
            35.64263397272357
          ],
          [
            134.86702837729803,
            35.658031962562916
          ],
          [
            134.87379082992518,
            35.62110262529832
          ],
          [
            134.85578967654718,
            35.59348161294461
          ],
          [
            134.91907464029308,
            35.53780529506317
          ],
          [
            134.92692189560677,
            35.51246547162368
          ],
          [
            135.03557435660204,
            35.53968155466124
          ],
          [
            135.04874502838064,
            35.40736399044687
          ],
          [
            134.99127730140114,
            35.38582273324417
          ],
          [
            134.94595037655318,
            35.413351929364325
          ],
          [
            134.92346993153632,
            35.39427116721487
          ],
          [
            134.9215797329829,
            35.31524680456441
          ],
          [
            135.007501404668,
            35.28551874228447
          ],
          [
            135.0558221501028,
            35.25924848334462
          ],
          [
            135.1083527400699,
            35.26613274364268
          ],
          [
            135.1619071182234,
            35.257866242527676
          ],
          [
            135.16340986435912,
            35.219945485877275
          ],
          [
            135.20599411376125,
            35.16092142483008
          ],
          [
            135.22407364924243,
            35.164345774610396
          ],
          [
            135.27385052064534,
            35.177287357958555
          ],
          [
            135.30083659448465,
            35.14280832201502
          ],
          [
            135.34084145008921,
            35.15001453247144
          ],
          [
            135.38645389916078,
            35.129491743153835
          ],
          [
            135.40005796356107,
            35.077239699290885
          ],
          [
            135.35014946153865,
            35.05124135093151
          ],
          [
            135.3398386943423,
            35.02585930318424
          ],
          [
            135.34649720674307,
            34.964633124771474
          ],
          [
            135.39571118905903,
            34.94436912501177
          ],
          [
            135.4449692093637,
            34.89544056582796
          ],
          [
            135.41605782209732,
            34.819520465404906
          ],
          [
            135.45980559302532,
            34.750872189927165
          ],
          [
            135.44538042895047,
            34.71779202337909
          ],
          [
            135.4073465851123,
            34.69705100332902
          ],
          [
            135.35391354000316,
            34.69686702379573
          ],
          [
            135.34076248434855,
            34.71803108421541
          ],
          [
            135.23472179664824,
            34.69844846559875
          ],
          [
            135.17763512222515,
            34.669917833146144
          ],
          [
            135.18330332720078,
            34.64937772913577
          ],
          [
            135.10936009481227,
            34.641120356853484
          ],
          [
            135.06005055962785,
            34.6254963402823
          ],
          [
            135.01871681853007,
            34.64333429731592
          ],
          [
            134.96590838583737,
            34.646284380601784
          ],
          [
            134.8471598490273,
            34.71533504388723
          ],
          [
            134.82678910944335,
            34.70634285055782
          ],
          [
            134.74916688022617,
            34.767801794427896
          ],
          [
            134.70228856346117,
            34.77757601293739
          ],
          [
            134.57284117924954,
            34.75790070813339
          ],
          [
            134.52807914578733,
            34.7828975015817
          ],
          [
            134.5046447751876,
            34.76129130171763
          ],
          [
            134.4331062110572,
            34.76686458103557
          ],
          [
            134.41661589701656,
            34.731250823607034
          ],
          [
            134.36373851515768,
            34.74069066664533
          ],
          [
            134.32259614615506,
            34.72291194712354
          ],
          [
            134.3171078569038,
            34.80194188585816
          ],
          [
            134.2637169087973,
            34.82670371812303
          ],
          [
            134.26269196514005,
            34.88429728220667
          ],
          [
            134.29490263947264,
            34.90756155359718
          ],
          [
            134.2540885386106,
            34.946057207656224
          ],
          [
            134.2865846758304,
            34.995903044898014
          ],
          [
            134.26436369335252,
            35.01650779877097
          ],
          [
            134.30541858826433,
            35.040223776028775
          ],
          [
            134.34962295564188,
            35.09027765652179
          ],
          [
            134.36791818087798,
            35.147079955197995
          ],
          [
            134.4115148803374,
            35.186617783296924
          ],
          [
            134.38096993051067,
            35.218415586518745
          ],
          [
            134.40295490017047,
            35.24157090754058
          ],
          [
            134.43523560692495,
            35.229055931777246
          ],
          [
            134.51508733826788,
            35.277285134511494
          ],
          [
            134.50204058944297,
            35.32612963382395
          ],
          [
            134.5137147378727,
            35.353885407253195
          ],
          [
            134.47149581661915,
            35.3799324811332
          ],
          [
            134.47734515123383,
            35.42911892226565
          ],
          [
            134.44024706483728,
            35.44275065042636
          ],
          [
            134.4128093052544,
            35.515266130721585
          ],
          [
            134.42542933179095,
            35.541830955479796
          ],
          [
            134.4080066275993,
            35.589225373418145
          ],
          [
            134.36990990668946,
            35.61036122739779
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "京都府",
      pref: "Kyoto",
      name: "JP-26"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            134.86702837729803,
            35.658031962562916
          ],
          [
            134.92368095333933,
            35.64640028842592
          ],
          [
            134.9641022354273,
            35.66290742478652
          ],
          [
            134.9860875662739,
            35.69265048293813
          ],
          [
            135.02692597442362,
            35.69009728412689
          ],
          [
            135.0861043296044,
            35.73972654979292
          ],
          [
            135.22211703622168,
            35.77236038200074
          ],
          [
            135.28845058323986,
            35.72445819202334
          ],
          [
            135.30835434527566,
            35.69589338274335
          ],
          [
            135.30320792800015,
            35.66268068029147
          ],
          [
            135.26449524844082,
            35.66417963878872
          ],
          [
            135.24468861979193,
            35.62046851383453
          ],
          [
            135.19208067090548,
            35.569763660278355
          ],
          [
            135.23703407205298,
            35.55305818440915
          ],
          [
            135.28850504025812,
            35.516206051803636
          ],
          [
            135.45218691830726,
            35.591213296138264
          ],
          [
            135.48438836716673,
            35.55801951869889
          ],
          [
            135.45009645346872,
            35.520790027793254
          ],
          [
            135.47615277537028,
            35.505399905624294
          ],
          [
            135.45843824491288,
            35.46817012174016
          ],
          [
            135.49522282373562,
            35.42615055586492
          ],
          [
            135.5261233605328,
            35.42083448609829
          ],
          [
            135.53384860884333,
            35.377940651465174
          ],
          [
            135.64190736433594,
            35.36685779532819
          ],
          [
            135.70086155546278,
            35.343586456576624
          ],
          [
            135.76878060148252,
            35.35602119100561
          ],
          [
            135.80902168739513,
            35.31678319073695
          ],
          [
            135.84465246198013,
            35.2618390697045
          ],
          [
            135.8379865634794,
            35.226060012599156
          ],
          [
            135.85024349217124,
            35.12047871096232
          ],
          [
            135.83484656251952,
            35.055670713900255
          ],
          [
            135.81469256426018,
            35.04507929727115
          ],
          [
            135.87399285028553,
            34.95534177920348
          ],
          [
            135.86675430421585,
            34.892305030343536
          ],
          [
            135.89720352623502,
            34.87133280173354
          ],
          [
            135.93905714924028,
            34.89319839933293
          ],
          [
            135.94604416672132,
            34.85175836160475
          ],
          [
            136.00405295598043,
            34.84439461225954
          ],
          [
            136.0284782290934,
            34.819257136739246
          ],
          [
            136.02141318121784,
            34.79205095800073
          ],
          [
            136.0539373898006,
            34.73845304364484
          ],
          [
            136.01436689150788,
            34.70780184897506
          ],
          [
            135.97087949344746,
            34.742039654317125
          ],
          [
            135.92347997549038,
            34.74214410925018
          ],
          [
            135.89023669051477,
            34.709218825298464
          ],
          [
            135.81972257188315,
            34.71168913001923
          ],
          [
            135.75557835981235,
            34.72751971037288
          ],
          [
            135.72819221820217,
            34.77736711498149
          ],
          [
            135.74654960679712,
            34.80116235395081
          ],
          [
            135.6145619692881,
            34.97124252567076
          ],
          [
            135.57121559219968,
            34.96971650466312
          ],
          [
            135.53820732579635,
            34.92538089199905
          ],
          [
            135.48085133789414,
            34.95020306740798
          ],
          [
            135.47117215159082,
            34.99469009183263
          ],
          [
            135.3818747529179,
            35.01021260531527
          ],
          [
            135.3712240242418,
            35.04531759435538
          ],
          [
            135.4000579733508,
            35.07723979103896
          ],
          [
            135.38645397840068,
            35.12949177930195
          ],
          [
            135.34084145993597,
            35.15001449222082
          ],
          [
            135.3008366738081,
            35.14280825052457
          ],
          [
            135.27385050277934,
            35.177287293380225
          ],
          [
            135.22407364924243,
            35.164345774610396
          ],
          [
            135.20599411376125,
            35.16092142483008
          ],
          [
            135.16340986435912,
            35.219945485877275
          ],
          [
            135.1619071182234,
            35.257866242527676
          ],
          [
            135.1083527400699,
            35.26613274364268
          ],
          [
            135.0558221501028,
            35.25924848334462
          ],
          [
            135.007501404668,
            35.28551874228447
          ],
          [
            134.9215797329829,
            35.31524680456441
          ],
          [
            134.92346993153632,
            35.39427116721487
          ],
          [
            134.94595037655318,
            35.413351929364325
          ],
          [
            134.99127730140114,
            35.38582273324417
          ],
          [
            135.04874502838064,
            35.40736399044687
          ],
          [
            135.03557435660204,
            35.53968155466124
          ],
          [
            134.92692189560677,
            35.51246547162368
          ],
          [
            134.91907464029308,
            35.53780529506317
          ],
          [
            134.85578967654718,
            35.59348161294461
          ],
          [
            134.87379082992518,
            35.62110262529832
          ],
          [
            134.86702837729803,
            35.658031962562916
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "和歌山県",
      pref: "Wakayama",
      name: "JP-30"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            135.651140176078,
            34.38323925718185
          ],
          [
            135.68012407391825,
            34.27081779878596
          ],
          [
            135.71821915790116,
            34.2634709480051
          ],
          [
            135.72734291891845,
            34.220667936121195
          ],
          [
            135.64800120732514,
            34.21886547989016
          ],
          [
            135.62188530915162,
            34.158491469764655
          ],
          [
            135.5881642622424,
            34.14689956765698
          ],
          [
            135.578547633709,
            34.116128344247116
          ],
          [
            135.53973239550783,
            34.075433867204836
          ],
          [
            135.58031982184326,
            34.0579283564823
          ],
          [
            135.6222026650887,
            34.00953136903948
          ],
          [
            135.6401681392518,
            33.96719551454342
          ],
          [
            135.6098164719528,
            33.93160715277696
          ],
          [
            135.60642248878273,
            33.89904570964611
          ],
          [
            135.64792832716608,
            33.876915784267524
          ],
          [
            135.68647509720196,
            33.90400275632772
          ],
          [
            135.75600773277898,
            33.88518276651342
          ],
          [
            135.81654969752043,
            33.90560628874143
          ],
          [
            135.85794315310284,
            33.87303485605612
          ],
          [
            135.8559199967976,
            33.82000755398674
          ],
          [
            135.8909438088634,
            33.80164497346409
          ],
          [
            135.90691557139408,
            33.7671480977139
          ],
          [
            135.94568837289842,
            33.732137442713096
          ],
          [
            136.01161143698644,
            33.723729363412694
          ],
          [
            135.93978750551832,
            33.646079884118244
          ],
          [
            135.9521319268101,
            33.5776051934773
          ],
          [
            135.9170235227379,
            33.55246664438777
          ],
          [
            135.8000011483355,
            33.500137528146794
          ],
          [
            135.7721469012576,
            33.47573875242352
          ],
          [
            135.70161612902226,
            33.49306033699693
          ],
          [
            135.66406004998586,
            33.49066026769721
          ],
          [
            135.517508284009,
            33.5221566517088
          ],
          [
            135.40934224950075,
            33.57563290445111
          ],
          [
            135.39773693391604,
            33.62736717275494
          ],
          [
            135.34459909086638,
            33.68126835723117
          ],
          [
            135.39625246610152,
            33.703816170765066
          ],
          [
            135.37099435654048,
            33.73167909777575
          ],
          [
            135.31038368009965,
            33.76939937695562
          ],
          [
            135.18567977751547,
            33.81993393105128
          ],
          [
            135.1418370668203,
            33.88495041877462
          ],
          [
            135.07756261336738,
            33.90330743837635
          ],
          [
            135.0932036490792,
            33.99315420445101
          ],
          [
            135.15174775296393,
            34.007386698819495
          ],
          [
            135.17094653637574,
            34.031993281660064
          ],
          [
            135.1354984615481,
            34.06507781024068
          ],
          [
            135.105414655452,
            34.07105304831202
          ],
          [
            135.12555777869832,
            34.136634994128144
          ],
          [
            135.18566486283507,
            34.147902457731035
          ],
          [
            135.17995297738457,
            34.18696375401986
          ],
          [
            135.08844650821467,
            34.26082829875069
          ],
          [
            135.09348926014468,
            34.311749834456386
          ],
          [
            135.11149242273714,
            34.27186872151915
          ],
          [
            135.18456047068798,
            34.27891180103877
          ],
          [
            135.24901706933497,
            34.314318011147364
          ],
          [
            135.29332799716005,
            34.299187221331806
          ],
          [
            135.33900016149263,
            34.32923509691758
          ],
          [
            135.40558193433992,
            34.333842057480815
          ],
          [
            135.49052109589508,
            34.35494084088458
          ],
          [
            135.5129593616072,
            34.3390678457817
          ],
          [
            135.5768149795876,
            34.37588036548265
          ],
          [
            135.651140176078,
            34.38323925718185
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "滋賀県",
      pref: "Shiga",
      name: "JP-25"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            136.4151680556184,
            35.21767952348444
          ],
          [
            136.42462870990204,
            35.18455025670847
          ],
          [
            136.4545824846378,
            35.16161204070465
          ],
          [
            136.4353052849749,
            35.13072258510497
          ],
          [
            136.4410178234508,
            35.0642455771765
          ],
          [
            136.41854610747123,
            35.048213655509905
          ],
          [
            136.42116887716742,
            34.999669034207486
          ],
          [
            136.36585558757312,
            34.904979655157014
          ],
          [
            136.2506363392541,
            34.8578334085138
          ],
          [
            136.166381080026,
            34.88792814656125
          ],
          [
            136.13125418035344,
            34.88306905611119
          ],
          [
            136.0903205502253,
            34.81200982116643
          ],
          [
            136.02141318121784,
            34.79205095800073
          ],
          [
            136.0284782290934,
            34.819257136739246
          ],
          [
            136.00405295598043,
            34.84439461225954
          ],
          [
            135.94604416672132,
            34.85175836160475
          ],
          [
            135.93905714924028,
            34.89319839933293
          ],
          [
            135.89720352623502,
            34.87133280173354
          ],
          [
            135.86675430421585,
            34.892305030343536
          ],
          [
            135.87399285028553,
            34.95534177920348
          ],
          [
            135.81469256426018,
            35.04507929727115
          ],
          [
            135.83484656251952,
            35.055670713900255
          ],
          [
            135.85024349217124,
            35.12047871096232
          ],
          [
            135.8379865634794,
            35.226060012599156
          ],
          [
            135.84465246198013,
            35.2618390697045
          ],
          [
            135.80902168739513,
            35.31678319073695
          ],
          [
            135.76878060148252,
            35.35602119100561
          ],
          [
            135.80743161103965,
            35.38525810106958
          ],
          [
            135.8135241017537,
            35.413189623238665
          ],
          [
            135.89063683209895,
            35.403132625737456
          ],
          [
            135.9137859409176,
            35.43178919078736
          ],
          [
            135.91590362568317,
            35.470876213320246
          ],
          [
            135.93876568273822,
            35.518062812929
          ],
          [
            135.98183423277422,
            35.48675853181434
          ],
          [
            136.0483290293834,
            35.53477039383223
          ],
          [
            136.08216152623427,
            35.5403712748722
          ],
          [
            136.1083732817919,
            35.56886832908128
          ],
          [
            136.16330719685251,
            35.57105873714032
          ],
          [
            136.17748870906505,
            35.59507332223598
          ],
          [
            136.14802815913347,
            35.662464942571916
          ],
          [
            136.15035297423444,
            35.697768477111865
          ],
          [
            136.1908513942858,
            35.702345251111076
          ],
          [
            136.28019959666452,
            35.65940058064657
          ],
          [
            136.29332372954832,
            35.618463825012505
          ],
          [
            136.32429349120963,
            35.58476759434949
          ],
          [
            136.31666487433782,
            35.549064570063244
          ],
          [
            136.39941702007226,
            35.53118421237364
          ],
          [
            136.38666815137532,
            35.4889473242409
          ],
          [
            136.42618716980277,
            35.448345420988424
          ],
          [
            136.4117884390096,
            35.418587817664765
          ],
          [
            136.4443894886148,
            35.38948452182108
          ],
          [
            136.37735032858933,
            35.24328835917264
          ],
          [
            136.4151680556184,
            35.21767952348444
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "大阪府",
      pref: "Osaka",
      name: "JP-27"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            135.72819221820217,
            34.77736711498149
          ],
          [
            135.67325941370652,
            34.702663158049
          ],
          [
            135.67868526365797,
            34.678058706667144
          ],
          [
            135.65906123273027,
            34.614805679956575
          ],
          [
            135.68171560265378,
            34.58479240017226
          ],
          [
            135.65674481400671,
            34.561911248272956
          ],
          [
            135.67717750163007,
            34.52506681274247
          ],
          [
            135.68030493177056,
            34.4083702950911
          ],
          [
            135.651140176078,
            34.38323925718185
          ],
          [
            135.5768149795876,
            34.37588036548265
          ],
          [
            135.5129593616072,
            34.3390678457817
          ],
          [
            135.49052109589508,
            34.35494084088458
          ],
          [
            135.40558193433992,
            34.333842057480815
          ],
          [
            135.33900016149263,
            34.32923509691758
          ],
          [
            135.29332799716005,
            34.299187221331806
          ],
          [
            135.24901706933497,
            34.314318011147364
          ],
          [
            135.18456047068798,
            34.27891180103877
          ],
          [
            135.11149242273714,
            34.27186872151915
          ],
          [
            135.09348926014468,
            34.311749834456386
          ],
          [
            135.19283253587443,
            34.33579625908792
          ],
          [
            135.26638371662983,
            34.3772943583247
          ],
          [
            135.31880166272592,
            34.419056571193124
          ],
          [
            135.37084329564397,
            34.50047402737969
          ],
          [
            135.43212199434186,
            34.53144580197807
          ],
          [
            135.41043935299453,
            34.56067591246998
          ],
          [
            135.4442888476869,
            34.64472931193786
          ],
          [
            135.4073465851123,
            34.69705100332902
          ],
          [
            135.44538042895047,
            34.71779202337909
          ],
          [
            135.45980559302532,
            34.750872189927165
          ],
          [
            135.41605782209732,
            34.819520465404906
          ],
          [
            135.4449692093637,
            34.89544056582796
          ],
          [
            135.39571118905903,
            34.94436912501177
          ],
          [
            135.34649720674307,
            34.964633124771474
          ],
          [
            135.3398386943423,
            35.02585930318424
          ],
          [
            135.3712240242418,
            35.04531759435538
          ],
          [
            135.3818747529179,
            35.01021260531527
          ],
          [
            135.47117215159082,
            34.99469009183263
          ],
          [
            135.48085133789414,
            34.95020306740798
          ],
          [
            135.53820732579635,
            34.92538089199905
          ],
          [
            135.57121559219968,
            34.96971650466312
          ],
          [
            135.6145619692881,
            34.97124252567076
          ],
          [
            135.74654960679712,
            34.80116235395081
          ],
          [
            135.72819221820217,
            34.77736711498149
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "奈良県",
      pref: "Nara",
      name: "JP-29"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            135.72819221820217,
            34.77736711498149
          ],
          [
            135.75557835981235,
            34.72751971037288
          ],
          [
            135.81972257188315,
            34.71168913001923
          ],
          [
            135.89023669051477,
            34.709218825298464
          ],
          [
            135.92347997549038,
            34.74214410925018
          ],
          [
            135.97087949344746,
            34.742039654317125
          ],
          [
            136.01436689150788,
            34.70780184897506
          ],
          [
            136.0539373898006,
            34.73845304364484
          ],
          [
            136.0862555945766,
            34.67550874509763
          ],
          [
            136.0730204953989,
            34.63156053007951
          ],
          [
            136.0466342888107,
            34.60029572814473
          ],
          [
            136.0834806648309,
            34.55916134161293
          ],
          [
            136.15567882940218,
            34.55963668501614
          ],
          [
            136.16767474348572,
            34.5207020452308
          ],
          [
            136.2163678850512,
            34.52836034745402
          ],
          [
            136.2062485957526,
            34.448628581129384
          ],
          [
            136.12978955471726,
            34.4454261582419
          ],
          [
            136.0888568909568,
            34.42883642603339
          ],
          [
            136.06923279953216,
            34.389098781787204
          ],
          [
            136.10204116074664,
            34.33663892837612
          ],
          [
            136.09499317806547,
            34.301100701908005
          ],
          [
            136.13193525472232,
            34.251882935274615
          ],
          [
            136.10901186578144,
            34.18504545880008
          ],
          [
            136.10220837929575,
            34.09615582522488
          ],
          [
            136.0730007613976,
            34.033786091272994
          ],
          [
            136.01971566094005,
            34.03665163473735
          ],
          [
            136.00357956844965,
            34.00977855075546
          ],
          [
            135.97504954707418,
            33.98622980119097
          ],
          [
            135.92608745043287,
            33.98132348116401
          ],
          [
            135.8923583780962,
            33.945626297854545
          ],
          [
            135.9089888068979,
            33.91852279104296
          ],
          [
            135.88080563761278,
            33.909272477673376
          ],
          [
            135.87472993771607,
            33.86158690944228
          ],
          [
            135.85794315310284,
            33.87303485605612
          ],
          [
            135.81654969752043,
            33.90560628874143
          ],
          [
            135.75600773277898,
            33.88518276651342
          ],
          [
            135.68647509720196,
            33.90400275632772
          ],
          [
            135.64792832716608,
            33.876915784267524
          ],
          [
            135.60642248878273,
            33.89904570964611
          ],
          [
            135.6098164719528,
            33.93160715277696
          ],
          [
            135.6401681392518,
            33.96719551454342
          ],
          [
            135.6222026650887,
            34.00953136903948
          ],
          [
            135.58031982184326,
            34.0579283564823
          ],
          [
            135.53973239550783,
            34.075433867204836
          ],
          [
            135.578547633709,
            34.116128344247116
          ],
          [
            135.5881642622424,
            34.14689956765698
          ],
          [
            135.62188530915162,
            34.158491469764655
          ],
          [
            135.64800120732514,
            34.21886547989016
          ],
          [
            135.72734291891845,
            34.220667936121195
          ],
          [
            135.71821915790116,
            34.2634709480051
          ],
          [
            135.68012407391825,
            34.27081779878596
          ],
          [
            135.651140176078,
            34.38323925718185
          ],
          [
            135.68030493177056,
            34.4083702950911
          ],
          [
            135.67717750163007,
            34.52506681274247
          ],
          [
            135.65674481400671,
            34.561911248272956
          ],
          [
            135.68171560265378,
            34.58479240017226
          ],
          [
            135.65906123273027,
            34.614805679956575
          ],
          [
            135.67868526365797,
            34.678058706667144
          ],
          [
            135.67325941370652,
            34.702663158049
          ],
          [
            135.72819221820217,
            34.77736711498149
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "広島県",
      pref: "Hiroshima",
      name: "JP-34"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            133.13634570006275,
            35.07424345152892
          ],
          [
            133.1796054528063,
            35.067352264128104
          ],
          [
            133.24968560755678,
            35.07900125981971
          ],
          [
            133.26900756966342,
            35.05774566961197
          ],
          [
            133.3204296151667,
            34.9835467302562
          ],
          [
            133.29729838861573,
            34.955383781285995
          ],
          [
            133.29395883577956,
            34.903272138471266
          ],
          [
            133.3335585820256,
            34.837753915808804
          ],
          [
            133.37815584498284,
            34.808174766495014
          ],
          [
            133.364607352566,
            34.76726150907101
          ],
          [
            133.37433904486792,
            34.695188689445594
          ],
          [
            133.4033556656023,
            34.67177574780859
          ],
          [
            133.38349034626086,
            34.62153313820589
          ],
          [
            133.44623808678097,
            34.55636461238953
          ],
          [
            133.45642115125156,
            34.49988522045193
          ],
          [
            133.44491273557227,
            34.48414706305881
          ],
          [
            133.43128643798457,
            34.424154985341936
          ],
          [
            133.38495314226415,
            34.41934615273638
          ],
          [
            133.38385142700847,
            34.3817756502415
          ],
          [
            133.34638198686844,
            34.3655700188889
          ],
          [
            133.29297561637557,
            34.383230944715024
          ],
          [
            133.25165775438123,
            34.44111670224582
          ],
          [
            133.2094847554029,
            34.410636265333345
          ],
          [
            133.12722415357632,
            34.38258013760298
          ],
          [
            133.0929378803557,
            34.38872882130201
          ],
          [
            133.07938109722957,
            34.345608677540106
          ],
          [
            133.02628765817641,
            34.33097661825796
          ],
          [
            132.94394369068334,
            34.33772471528427
          ],
          [
            132.88863034525536,
            34.323926175528754
          ],
          [
            132.84718577169252,
            34.29177939672791
          ],
          [
            132.79786864938893,
            34.31208637255004
          ],
          [
            132.7727334861805,
            34.25326728839135
          ],
          [
            132.6963255514767,
            34.235101084794714
          ],
          [
            132.6366707820855,
            34.20188715449275
          ],
          [
            132.585406672626,
            34.21229281692025
          ],
          [
            132.5284243534871,
            34.164530093139376
          ],
          [
            132.5521114422013,
            34.14858235476908
          ],
          [
            132.53531719967927,
            34.09529802697587
          ],
          [
            132.46254864613294,
            34.082421984289965
          ],
          [
            132.44807837874848,
            34.10938625408187
          ],
          [
            132.48854199061836,
            34.13064278392867
          ],
          [
            132.5024460611752,
            34.18533396033997
          ],
          [
            132.54412577323203,
            34.20943421148911
          ],
          [
            132.530055219879,
            34.25515297016157
          ],
          [
            132.494719615185,
            34.3152280806817
          ],
          [
            132.4974856486827,
            34.348754114318425
          ],
          [
            132.37765891781643,
            34.36395311079703
          ],
          [
            132.32665849676144,
            34.34429708342129
          ],
          [
            132.28237523569013,
            34.286127902524704
          ],
          [
            132.23019281726167,
            34.254772460948104
          ],
          [
            132.24557531010566,
            34.21070143315468
          ],
          [
            132.14483634769937,
            34.23640678850585
          ],
          [
            132.14012273220771,
            34.2847677529159
          ],
          [
            132.10138205197134,
            34.34509123219518
          ],
          [
            132.06986580854488,
            34.356273748895404
          ],
          [
            132.06817039019265,
            34.46831828146714
          ],
          [
            132.0365845485035,
            34.50218900497878
          ],
          [
            132.052460372143,
            34.530353153710294
          ],
          [
            132.11363375249152,
            34.5625601112569
          ],
          [
            132.11628019228982,
            34.612496006645515
          ],
          [
            132.1582976792263,
            34.692470416367215
          ],
          [
            132.1307118012065,
            34.708019464419806
          ],
          [
            132.20286727134086,
            34.74874161391773
          ],
          [
            132.25963884970903,
            34.806785209355866
          ],
          [
            132.29810086998947,
            34.77657236217267
          ],
          [
            132.36674960171513,
            34.80084605458687
          ],
          [
            132.396739049717,
            34.77939023103912
          ],
          [
            132.43672597255988,
            34.82086288726323
          ],
          [
            132.48382241082177,
            34.79720728460062
          ],
          [
            132.53921804448612,
            34.79520195573327
          ],
          [
            132.61445310292615,
            34.84316430263282
          ],
          [
            132.7100332282483,
            34.84991278421305
          ],
          [
            132.70105716916493,
            34.88177476718599
          ],
          [
            132.6419407112678,
            34.904507936023535
          ],
          [
            132.68515360566158,
            34.95065203480174
          ],
          [
            132.75294923318089,
            34.96659293414537
          ],
          [
            132.82759039049148,
            35.06118919142047
          ],
          [
            132.8727829939583,
            35.10214371805688
          ],
          [
            132.95045692015157,
            35.07542323141617
          ],
          [
            133.0003049399682,
            35.09712046610792
          ],
          [
            133.0330387152616,
            35.068491645128304
          ],
          [
            133.0600921876465,
            35.08115749226839
          ],
          [
            133.13634570006275,
            35.07424345152892
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "島根県",
      pref: "Shimane",
      name: "JP-32"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            133.319121809507,
            35.412725452993385
          ],
          [
            133.2927742184401,
            35.31850907387311
          ],
          [
            133.3100230351646,
            35.26860643658122
          ],
          [
            133.25868905839192,
            35.26149870705134
          ],
          [
            133.1815516417508,
            35.234316763473224
          ],
          [
            133.19493818960666,
            35.16983259540009
          ],
          [
            133.15627885166248,
            35.14832611957392
          ],
          [
            133.13634570006275,
            35.07424345152892
          ],
          [
            133.0600921876465,
            35.08115749226839
          ],
          [
            133.0330387152616,
            35.068491645128304
          ],
          [
            133.0003049399682,
            35.09712046610792
          ],
          [
            132.95045692015157,
            35.07542323141617
          ],
          [
            132.8727829939583,
            35.10214371805688
          ],
          [
            132.82759039049148,
            35.06118919142047
          ],
          [
            132.75294923318089,
            34.96659293414537
          ],
          [
            132.68515360566158,
            34.95065203480174
          ],
          [
            132.6419407112678,
            34.904507936023535
          ],
          [
            132.70105716916493,
            34.88177476718599
          ],
          [
            132.7100332282483,
            34.84991278421305
          ],
          [
            132.61445310292615,
            34.84316430263282
          ],
          [
            132.53921804448612,
            34.79520195573327
          ],
          [
            132.48382241082177,
            34.79720728460062
          ],
          [
            132.43672597255988,
            34.82086288726323
          ],
          [
            132.396739049717,
            34.77939023103912
          ],
          [
            132.36674960171513,
            34.80084605458687
          ],
          [
            132.29810086998947,
            34.77657236217267
          ],
          [
            132.25963884970903,
            34.806785209355866
          ],
          [
            132.20286727134086,
            34.74874161391773
          ],
          [
            132.1307118012065,
            34.708019464419806
          ],
          [
            132.1582976792263,
            34.692470416367215
          ],
          [
            132.11628019228982,
            34.612496006645515
          ],
          [
            132.11363375249152,
            34.5625601112569
          ],
          [
            132.052460372143,
            34.530353153710294
          ],
          [
            132.0365845485035,
            34.50218900497878
          ],
          [
            132.06817039019265,
            34.46831828146714
          ],
          [
            132.03916333112429,
            34.46890156834855
          ],
          [
            131.9900450610743,
            34.41336190653852
          ],
          [
            132.01328989062333,
            34.38160098876298
          ],
          [
            131.94497206375593,
            34.32060054326555
          ],
          [
            131.91937503797914,
            34.33822195818907
          ],
          [
            131.86011005068536,
            34.30468265344762
          ],
          [
            131.7989264374328,
            34.31702183741701
          ],
          [
            131.77662748801708,
            34.333894491140704
          ],
          [
            131.76496079379288,
            34.381899487796765
          ],
          [
            131.79379304250736,
            34.43619349926641
          ],
          [
            131.71285476578424,
            34.428566628221866
          ],
          [
            131.6692436397938,
            34.510591403764074
          ],
          [
            131.70668862115727,
            34.53287392050395
          ],
          [
            131.7275710845614,
            34.57644362716512
          ],
          [
            131.69483678452147,
            34.62083040503553
          ],
          [
            131.69058214538853,
            34.67782215776273
          ],
          [
            131.7475057369154,
            34.67584642424292
          ],
          [
            131.82604820981913,
            34.69860498596706
          ],
          [
            131.887030881892,
            34.75663505273587
          ],
          [
            131.9904242519664,
            34.82891307716256
          ],
          [
            132.0117812001845,
            34.868150181241795
          ],
          [
            132.0406359429467,
            34.88031659105328
          ],
          [
            132.08412148827566,
            34.92998692497134
          ],
          [
            132.18377421827222,
            34.990982727059645
          ],
          [
            132.23658118890418,
            35.03499053302921
          ],
          [
            132.3100031209761,
            35.057126321373
          ],
          [
            132.3238733803754,
            35.0891062775298
          ],
          [
            132.3879890689939,
            35.130002671881286
          ],
          [
            132.41877622965882,
            35.18991679538256
          ],
          [
            132.52790501529745,
            35.24229702807308
          ],
          [
            132.57548552877319,
            35.272683868370635
          ],
          [
            132.6155755472752,
            35.281139336896814
          ],
          [
            132.6613223002117,
            35.328500716372496
          ],
          [
            132.67209020970046,
            35.40101103991852
          ],
          [
            132.64192672937708,
            35.4313803034981
          ],
          [
            132.72707370591192,
            35.47052880096935
          ],
          [
            132.8003998557079,
            35.48350959060105
          ],
          [
            132.83079530792637,
            35.50494278694685
          ],
          [
            132.9196691474058,
            35.51769362755055
          ],
          [
            132.96563704910557,
            35.5146609808956
          ],
          [
            132.98986039877315,
            35.54342622459771
          ],
          [
            133.05905288537787,
            35.5634845833935
          ],
          [
            133.06976266149465,
            35.58415727530581
          ],
          [
            133.12133795571606,
            35.57863450258615
          ],
          [
            133.21874361933024,
            35.548877199438145
          ],
          [
            133.19137677960506,
            35.52696000371745
          ],
          [
            133.15212612171163,
            35.53529145939176
          ],
          [
            133.13000340589937,
            35.509460285619625
          ],
          [
            133.14413496589177,
            35.47838083265508
          ],
          [
            133.12800899414253,
            35.45138436163987
          ],
          [
            133.1988783256266,
            35.43522194846373
          ],
          [
            133.21924972007403,
            35.45397046798128
          ],
          [
            133.319121809507,
            35.412725452993385
          ]
        ],
        [
          [
            132.97470882578878,
            35.42406024848702
          ],
          [
            133.0355189038739,
            35.43688210784202
          ],
          [
            133.05364107925934,
            35.46079670358584
          ],
          [
            132.9714011575559,
            35.48045758371585
          ],
          [
            132.87877929769286,
            35.46037429357989
          ],
          [
            132.90340571636878,
            35.40696161098726
          ],
          [
            132.97470882578878,
            35.42406024848702
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "鳥取県",
      pref: "Tottori",
      name: "JP-31"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            134.36990990668946,
            35.61036122739779
          ],
          [
            134.4080066275993,
            35.589225373418145
          ],
          [
            134.42542933179095,
            35.541830955479796
          ],
          [
            134.4128093052544,
            35.515266130721585
          ],
          [
            134.44024706483728,
            35.44275065042636
          ],
          [
            134.47734515123383,
            35.42911892226565
          ],
          [
            134.47149581661915,
            35.3799324811332
          ],
          [
            134.5137147378727,
            35.353885407253195
          ],
          [
            134.50204058944297,
            35.32612963382395
          ],
          [
            134.51508733826788,
            35.277285134511494
          ],
          [
            134.43523560692495,
            35.229055931777246
          ],
          [
            134.40295490017047,
            35.24157090754058
          ],
          [
            134.33651153581465,
            35.21931330552619
          ],
          [
            134.32128776282718,
            35.20179959510134
          ],
          [
            134.26777673344722,
            35.20842109306986
          ],
          [
            134.19416459246324,
            35.18944824055857
          ],
          [
            134.15304019618682,
            35.196372301773806
          ],
          [
            134.1641834779861,
            35.228100864160346
          ],
          [
            134.13371645029105,
            35.282913065412956
          ],
          [
            134.09772043256737,
            35.305858399948484
          ],
          [
            134.07005860193493,
            35.297166592894555
          ],
          [
            134.01248551304738,
            35.30677442627817
          ],
          [
            134.01474843342226,
            35.35036104574811
          ],
          [
            133.9340015136491,
            35.335119315181565
          ],
          [
            133.92513160135073,
            35.30680633768273
          ],
          [
            133.86175255074565,
            35.29214939730134
          ],
          [
            133.86586669267473,
            35.27234164487777
          ],
          [
            133.8179810462755,
            35.25316784962679
          ],
          [
            133.79908403410693,
            35.2928557984093
          ],
          [
            133.76236809491115,
            35.31109492373925
          ],
          [
            133.5957854961053,
            35.345477141433626
          ],
          [
            133.55466271689897,
            35.24179696702194
          ],
          [
            133.52243534585466,
            35.20819278142397
          ],
          [
            133.46697343142884,
            35.17527070702764
          ],
          [
            133.40733438893866,
            35.18588512482659
          ],
          [
            133.41260456241616,
            35.13366661942582
          ],
          [
            133.32525163035578,
            35.09343452968241
          ],
          [
            133.26900756966342,
            35.05774566961197
          ],
          [
            133.24968560755678,
            35.07900125981971
          ],
          [
            133.1796054528063,
            35.067352264128104
          ],
          [
            133.13634570006275,
            35.07424345152892
          ],
          [
            133.15627885166248,
            35.14832611957392
          ],
          [
            133.19493818960666,
            35.16983259540009
          ],
          [
            133.1815516417508,
            35.234316763473224
          ],
          [
            133.25868905839192,
            35.26149870705134
          ],
          [
            133.3100230351646,
            35.26860643658122
          ],
          [
            133.2927742184401,
            35.31850907387311
          ],
          [
            133.319121809507,
            35.412725452993385
          ],
          [
            133.325119232839,
            35.42264206919138
          ],
          [
            133.24924742757045,
            35.47071851506978
          ],
          [
            133.19837261319185,
            35.52912781143726
          ],
          [
            133.22399525466673,
            35.54695912040708
          ],
          [
            133.30862531430944,
            35.47130270087038
          ],
          [
            133.37418599334714,
            35.45681238390605
          ],
          [
            133.4235470952161,
            35.45894598326064
          ],
          [
            133.44744115883495,
            35.494811032669716
          ],
          [
            133.49732096057932,
            35.51563030298169
          ],
          [
            133.5868663251348,
            35.531819860560056
          ],
          [
            133.66529905691974,
            35.50768099628553
          ],
          [
            133.79053007746165,
            35.50088064790989
          ],
          [
            133.92726087416986,
            35.510582336619215
          ],
          [
            134.00035313608507,
            35.52522364849432
          ],
          [
            134.0344562389676,
            35.51857598111843
          ],
          [
            134.154419048338,
            35.531101164166465
          ],
          [
            134.27200293523654,
            35.56055140150065
          ],
          [
            134.29358877834898,
            35.589357238814394
          ],
          [
            134.36990990668946,
            35.61036122739779
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "山口県",
      pref: "Yamaguchi",
      name: "JP-35"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            131.69058214538853,
            34.67782215776273
          ],
          [
            131.69483678452147,
            34.62083040503553
          ],
          [
            131.7275710845614,
            34.57644362716512
          ],
          [
            131.70668862115727,
            34.53287392050395
          ],
          [
            131.6692436397938,
            34.510591403764074
          ],
          [
            131.71285476578424,
            34.428566628221866
          ],
          [
            131.79379304250736,
            34.43619349926641
          ],
          [
            131.76496079379288,
            34.381899487796765
          ],
          [
            131.77662748801708,
            34.333894491140704
          ],
          [
            131.7989264374328,
            34.31702183741701
          ],
          [
            131.86011005068536,
            34.30468265344762
          ],
          [
            131.91937503797914,
            34.33822195818907
          ],
          [
            131.94497206375593,
            34.32060054326555
          ],
          [
            132.01328989062333,
            34.38160098876298
          ],
          [
            131.9900450610743,
            34.41336190653852
          ],
          [
            132.03916333112429,
            34.46890156834855
          ],
          [
            132.06817039019265,
            34.46831828146714
          ],
          [
            132.06986580854488,
            34.356273748895404
          ],
          [
            132.10138205197134,
            34.34509123219518
          ],
          [
            132.14012273220771,
            34.2847677529159
          ],
          [
            132.14483634769937,
            34.23640678850585
          ],
          [
            132.24557531010566,
            34.21070143315468
          ],
          [
            132.2474759279527,
            34.16419248307908
          ],
          [
            132.2334775725821,
            34.126910429942065
          ],
          [
            132.19977421932217,
            34.10908638827983
          ],
          [
            132.22045929841212,
            34.04890346718063
          ],
          [
            132.21261492154684,
            34.001341705329786
          ],
          [
            132.18484132278707,
            33.96138071048884
          ],
          [
            132.12054117771444,
            33.958528033476114
          ],
          [
            132.13032444933165,
            33.883435966998
          ],
          [
            132.15949821898084,
            33.85061712112394
          ],
          [
            132.1175743168883,
            33.83192478137069
          ],
          [
            132.1172612629822,
            33.8775377498567
          ],
          [
            132.05297659382992,
            33.9157567105076
          ],
          [
            132.02419415177022,
            33.90199040973392
          ],
          [
            131.95932139169244,
            33.94825895410087
          ],
          [
            131.93627729370908,
            33.94731870554505
          ],
          [
            131.83609222338907,
            34.00964887478331
          ],
          [
            131.81594774028528,
            33.969278380531165
          ],
          [
            131.77066510166046,
            33.9789756689771
          ],
          [
            131.81842814438292,
            34.035436268445935
          ],
          [
            131.78794522250635,
            34.05473483199611
          ],
          [
            131.70959973678094,
            34.06051590297017
          ],
          [
            131.6977435325953,
            34.0464997230003
          ],
          [
            131.58310121064994,
            34.02158895253995
          ],
          [
            131.54510239722075,
            33.998701763134704
          ],
          [
            131.4502491397516,
            33.99547578390921
          ],
          [
            131.38569763647516,
            34.031204000252046
          ],
          [
            131.3779733061034,
            34.007929315357146
          ],
          [
            131.319325245661,
            33.95487543026578
          ],
          [
            131.26853901168656,
            33.922879387341204
          ],
          [
            131.15774730353897,
            33.95310625055867
          ],
          [
            131.1504728225407,
            34.0032596655374
          ],
          [
            131.04745898590826,
            34.04228775438593
          ],
          [
            131.00351313062936,
            34.016979555758404
          ],
          [
            130.99565821531814,
            33.98923235373147
          ],
          [
            130.92432074733506,
            33.94738699556067
          ],
          [
            130.9135227314379,
            33.964001809534466
          ],
          [
            130.91084744806676,
            34.06170769827491
          ],
          [
            130.8614038894497,
            34.10435967317197
          ],
          [
            130.89863135015943,
            34.13740534402388
          ],
          [
            130.93344498519588,
            34.189284842683435
          ],
          [
            130.92173446879144,
            34.239188513727285
          ],
          [
            130.86695389028566,
            34.28766635984974
          ],
          [
            130.88912105603896,
            34.344219338589426
          ],
          [
            130.9488563023643,
            34.35237758031961
          ],
          [
            131.03428211060697,
            34.38532663981772
          ],
          [
            131.07450304633954,
            34.424387975976735
          ],
          [
            131.12898677115066,
            34.412708848588075
          ],
          [
            131.15394203993932,
            34.37293121443336
          ],
          [
            131.2014199711332,
            34.389379858660455
          ],
          [
            131.30671654393797,
            34.38306531469841
          ],
          [
            131.33124408406752,
            34.4145885290584
          ],
          [
            131.39018999420395,
            34.416705769515346
          ],
          [
            131.4620229351161,
            34.486241411625635
          ],
          [
            131.4500697426531,
            34.51680486774247
          ],
          [
            131.49753270316242,
            34.53124216644891
          ],
          [
            131.58945460648627,
            34.61922632118327
          ],
          [
            131.6130452392638,
            34.66702364901047
          ],
          [
            131.67037558010762,
            34.65975771741718
          ],
          [
            131.69058214538853,
            34.67782215776273
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "岡山県",
      pref: "Okayama",
      name: "JP-33"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            134.40295490017047,
            35.24157090754058
          ],
          [
            134.38096993051067,
            35.218415586518745
          ],
          [
            134.4115148803374,
            35.186617783296924
          ],
          [
            134.36791818087798,
            35.147079955197995
          ],
          [
            134.34962295564188,
            35.09027765652179
          ],
          [
            134.30541858826433,
            35.040223776028775
          ],
          [
            134.26436369335252,
            35.01650779877097
          ],
          [
            134.2865846758304,
            34.995903044898014
          ],
          [
            134.2540885386106,
            34.946057207656224
          ],
          [
            134.29490263947264,
            34.90756155359718
          ],
          [
            134.26269196514005,
            34.88429728220667
          ],
          [
            134.2637169087973,
            34.82670371812303
          ],
          [
            134.3171078569038,
            34.80194188585816
          ],
          [
            134.32259614615506,
            34.72291194712354
          ],
          [
            134.29809227212326,
            34.73652302672026
          ],
          [
            134.2449293399049,
            34.702676142067695
          ],
          [
            134.1912903195268,
            34.652222337895694
          ],
          [
            134.17050221425785,
            34.65277095587722
          ],
          [
            134.1200818757254,
            34.58878359199424
          ],
          [
            134.04087234321676,
            34.580325939849665
          ],
          [
            134.02472018841453,
            34.55294704102362
          ],
          [
            133.95295785925487,
            34.51210805892344
          ],
          [
            133.93294251362332,
            34.45127136387833
          ],
          [
            133.83383555669104,
            34.47444356140059
          ],
          [
            133.78724258500338,
            34.43553042341554
          ],
          [
            133.75803375610104,
            34.468658815210354
          ],
          [
            133.70398322128867,
            34.47794826412402
          ],
          [
            133.6905475377449,
            34.512342097260436
          ],
          [
            133.6035785629233,
            34.49546106176367
          ],
          [
            133.56098832926173,
            34.46829863441445
          ],
          [
            133.4889453582763,
            34.44114258570101
          ],
          [
            133.44491273557227,
            34.48414706305881
          ],
          [
            133.45642115125156,
            34.49988522045193
          ],
          [
            133.44623808678097,
            34.55636461238953
          ],
          [
            133.38349034626086,
            34.62153313820589
          ],
          [
            133.4033556656023,
            34.67177574780859
          ],
          [
            133.37433904486792,
            34.695188689445594
          ],
          [
            133.364607352566,
            34.76726150907101
          ],
          [
            133.37815584498284,
            34.808174766495014
          ],
          [
            133.3335585820256,
            34.837753915808804
          ],
          [
            133.29395883577956,
            34.903272138471266
          ],
          [
            133.29729838861573,
            34.955383781285995
          ],
          [
            133.3204296151667,
            34.9835467302562
          ],
          [
            133.26900756966342,
            35.05774566961197
          ],
          [
            133.32525163035578,
            35.09343452968241
          ],
          [
            133.41260456241616,
            35.13366661942582
          ],
          [
            133.40733438893866,
            35.18588512482659
          ],
          [
            133.46697343142884,
            35.17527070702764
          ],
          [
            133.52243534585466,
            35.20819278142397
          ],
          [
            133.55466271689897,
            35.24179696702194
          ],
          [
            133.5957854961053,
            35.345477141433626
          ],
          [
            133.76236809491115,
            35.31109492373925
          ],
          [
            133.79908403410693,
            35.2928557984093
          ],
          [
            133.8179810462755,
            35.25316784962679
          ],
          [
            133.86586669267473,
            35.27234164487777
          ],
          [
            133.86175255074565,
            35.29214939730134
          ],
          [
            133.92513160135073,
            35.30680633768273
          ],
          [
            133.9340015136491,
            35.335119315181565
          ],
          [
            134.01474843342226,
            35.35036104574811
          ],
          [
            134.01248551304738,
            35.30677442627817
          ],
          [
            134.07005860193493,
            35.297166592894555
          ],
          [
            134.09772043256737,
            35.305858399948484
          ],
          [
            134.13371645029105,
            35.282913065412956
          ],
          [
            134.1641834779861,
            35.228100864160346
          ],
          [
            134.15304019618682,
            35.196372301773806
          ],
          [
            134.19416459246324,
            35.18944824055857
          ],
          [
            134.26777673344722,
            35.20842109306986
          ],
          [
            134.32128776282718,
            35.20179959510134
          ],
          [
            134.33651153581465,
            35.21931330552619
          ],
          [
            134.40295490017047,
            35.24157090754058
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "徳島県",
      pref: "Tokushima",
      name: "JP-36"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            133.66078262096275,
            33.88172480829132
          ],
          [
            133.6902778384224,
            33.91619647101904
          ],
          [
            133.67959748668784,
            34.01250031473547
          ],
          [
            133.78302526986235,
            34.080098724453855
          ],
          [
            133.9219775724304,
            34.11428079448257
          ],
          [
            133.99395974306984,
            34.07264736670665
          ],
          [
            134.07909966458848,
            34.12101676362222
          ],
          [
            134.12234563621027,
            34.11874709611684
          ],
          [
            134.15542498089303,
            34.16660977405473
          ],
          [
            134.208742879891,
            34.174695053868255
          ],
          [
            134.26608987963684,
            34.18328622390257
          ],
          [
            134.29720757099122,
            34.168896406722915
          ],
          [
            134.35897339559432,
            34.18392927734448
          ],
          [
            134.4194548746329,
            34.15776517156459
          ],
          [
            134.4401897763731,
            34.20794556545673
          ],
          [
            134.5323681177948,
            34.22686110786833
          ],
          [
            134.55913677914475,
            34.22138669032158
          ],
          [
            134.6249283695075,
            34.18076767190307
          ],
          [
            134.58836370823983,
            34.055138225265196
          ],
          [
            134.5889363017351,
            34.01106741738596
          ],
          [
            134.6431572840292,
            34.00331867812353
          ],
          [
            134.6693869862107,
            33.96134995676009
          ],
          [
            134.69909755082793,
            33.94974425550551
          ],
          [
            134.69812607728016,
            33.90494142838463
          ],
          [
            134.66748740323706,
            33.87917868624829
          ],
          [
            134.6661510720038,
            33.848565539279306
          ],
          [
            134.72960011681405,
            33.823651194546464
          ],
          [
            134.6200448318798,
            33.7866477615657
          ],
          [
            134.5807349269445,
            33.76244041235518
          ],
          [
            134.56402675269067,
            33.733302859131264
          ],
          [
            134.4394040725099,
            33.6633619973046
          ],
          [
            134.4025334416175,
            33.65999684546872
          ],
          [
            134.36989783890826,
            33.608402010512464
          ],
          [
            134.30549508648392,
            33.55002550536166
          ],
          [
            134.19586888886104,
            33.56075677193165
          ],
          [
            134.1759058481235,
            33.607077130364864
          ],
          [
            134.15044803602242,
            33.63073994643432
          ],
          [
            134.17475346911144,
            33.68413448681027
          ],
          [
            134.1223459760587,
            33.69605386552858
          ],
          [
            134.06730392851108,
            33.68871548198986
          ],
          [
            134.05531772106167,
            33.78459226915231
          ],
          [
            133.98452837253876,
            33.840910582195065
          ],
          [
            133.95118845063027,
            33.82908654550267
          ],
          [
            133.91350081495153,
            33.79121515366267
          ],
          [
            133.87236934073167,
            33.80612544774154
          ],
          [
            133.838386321733,
            33.84525775283052
          ],
          [
            133.74738378204705,
            33.836952616809874
          ],
          [
            133.666650142466,
            33.86606033754792
          ],
          [
            133.66078262096275,
            33.88172480829132
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "高知県",
      pref: "Kochi",
      name: "JP-39"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            132.65581568328506,
            32.9254814190207
          ],
          [
            132.67805315430988,
            32.94283886466871
          ],
          [
            132.6868095002634,
            32.99833184503844
          ],
          [
            132.66337099877728,
            33.10915196138803
          ],
          [
            132.72827526444246,
            33.170056202851626
          ],
          [
            132.74077374196852,
            33.20143578453957
          ],
          [
            132.77564817274785,
            33.206095461765536
          ],
          [
            132.77210605939342,
            33.241489464995105
          ],
          [
            132.79337131438345,
            33.27479594123696
          ],
          [
            132.89590540161277,
            33.312487425416094
          ],
          [
            132.9029090816951,
            33.3376106379652
          ],
          [
            132.8601268488726,
            33.36827958993611
          ],
          [
            132.82490261139287,
            33.42292155529632
          ],
          [
            132.82056155013447,
            33.472516121463215
          ],
          [
            132.95997672000158,
            33.466404600028405
          ],
          [
            133.01544854324706,
            33.48097789523197
          ],
          [
            133.03807506356702,
            33.52646381502003
          ],
          [
            133.06427894411715,
            33.54267105612455
          ],
          [
            133.04660613129508,
            33.57555856079052
          ],
          [
            133.07742587422732,
            33.65351809827432
          ],
          [
            133.11646850520728,
            33.66019175966135
          ],
          [
            133.12541675570583,
            33.698395932598046
          ],
          [
            133.16116723984217,
            33.73151732839562
          ],
          [
            133.19288121336794,
            33.793834524364854
          ],
          [
            133.25035153634687,
            33.78837123365814
          ],
          [
            133.26745039872955,
            33.823693093339394
          ],
          [
            133.3263948707757,
            33.81464560202646
          ],
          [
            133.35581838020553,
            33.834350659555355
          ],
          [
            133.4156994965452,
            33.839859630758106
          ],
          [
            133.4990175042906,
            33.82912080748803
          ],
          [
            133.55706651259223,
            33.882307231295556
          ],
          [
            133.58315879264512,
            33.86773220547286
          ],
          [
            133.66078262096275,
            33.88172480829132
          ],
          [
            133.666650142466,
            33.86606033754792
          ],
          [
            133.74738378204705,
            33.836952616809874
          ],
          [
            133.838386321733,
            33.84525775283052
          ],
          [
            133.87236934073167,
            33.80612544774154
          ],
          [
            133.91350081495153,
            33.79121515366267
          ],
          [
            133.95118845063027,
            33.82908654550267
          ],
          [
            133.98452837253876,
            33.840910582195065
          ],
          [
            134.05531772106167,
            33.78459226915231
          ],
          [
            134.06730392851108,
            33.68871548198986
          ],
          [
            134.1223459760587,
            33.69605386552858
          ],
          [
            134.17475346911144,
            33.68413448681027
          ],
          [
            134.15044803602242,
            33.63073994643432
          ],
          [
            134.1759058481235,
            33.607077130364864
          ],
          [
            134.19586888886104,
            33.56075677193165
          ],
          [
            134.30549508648392,
            33.55002550536166
          ],
          [
            134.24172288798175,
            33.463101273144524
          ],
          [
            134.20992723659197,
            33.39506893256522
          ],
          [
            134.18718637455675,
            33.29354733360057
          ],
          [
            134.11104764229023,
            33.29377236207734
          ],
          [
            134.1034349206913,
            33.32606935808576
          ],
          [
            134.03470262760413,
            33.37849723555488
          ],
          [
            134.03192640328413,
            33.41085207367435
          ],
          [
            133.9585500069948,
            33.44237997469501
          ],
          [
            133.93473302707523,
            33.487014915609976
          ],
          [
            133.82012631765727,
            33.51528216893455
          ],
          [
            133.7701573299836,
            33.51630770520486
          ],
          [
            133.72958850137425,
            33.538253739744135
          ],
          [
            133.60144981649685,
            33.519337229869976
          ],
          [
            133.56264390315624,
            33.496514658313124
          ],
          [
            133.43232543116585,
            33.43712653615228
          ],
          [
            133.3934671906674,
            33.40173902428186
          ],
          [
            133.3455369632826,
            33.40070279101958
          ],
          [
            133.31318744246553,
            33.37645588155192
          ],
          [
            133.2678793309057,
            33.36819032041703
          ],
          [
            133.2389598741952,
            33.29552347300577
          ],
          [
            133.24961979989055,
            33.232404793084356
          ],
          [
            133.2318001789487,
            33.19792540920123
          ],
          [
            133.17242442472292,
            33.152264486399545
          ],
          [
            133.14289085270175,
            33.097587889699426
          ],
          [
            133.10495314762434,
            33.072707064233825
          ],
          [
            133.09310684059304,
            33.033860744830776
          ],
          [
            133.03991719094256,
            33.03866528119659
          ],
          [
            133.00933982935695,
            33.01145995882334
          ],
          [
            132.98735643944102,
            32.93259916392024
          ],
          [
            133.00948070256973,
            32.88178187930643
          ],
          [
            132.94933968782962,
            32.85747009359645
          ],
          [
            132.95183223492285,
            32.81348544807508
          ],
          [
            133.00177444305982,
            32.782659561164685
          ],
          [
            133.02200042150233,
            32.7311850690103
          ],
          [
            133.00050984799446,
            32.72270870493591
          ],
          [
            132.94525459353883,
            32.765109952935234
          ],
          [
            132.9350269784984,
            32.78650591841571
          ],
          [
            132.83945805036294,
            32.78123638533394
          ],
          [
            132.79132176601522,
            32.74783117610541
          ],
          [
            132.7103036880848,
            32.79887975589757
          ],
          [
            132.6539990812614,
            32.78075583091712
          ],
          [
            132.6290688789258,
            32.800860977612174
          ],
          [
            132.656694378378,
            32.853964931446185
          ],
          [
            132.71706898135054,
            32.90844519645503
          ],
          [
            132.65581568328506,
            32.9254814190207
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "愛媛県",
      pref: "Ehime",
      name: "JP-38"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            133.5984425414343,
            34.04371168002969
          ],
          [
            133.65700375697952,
            34.02998068957257
          ],
          [
            133.67959748668784,
            34.01250031473547
          ],
          [
            133.6902778384224,
            33.91619647101904
          ],
          [
            133.66078262096275,
            33.88172480829132
          ],
          [
            133.58315879264512,
            33.86773220547286
          ],
          [
            133.55706651259223,
            33.882307231295556
          ],
          [
            133.4990175042906,
            33.82912080748803
          ],
          [
            133.4156994965452,
            33.839859630758106
          ],
          [
            133.35581838020553,
            33.834350659555355
          ],
          [
            133.3263948707757,
            33.81464560202646
          ],
          [
            133.26745039872955,
            33.823693093339394
          ],
          [
            133.25035153634687,
            33.78837123365814
          ],
          [
            133.19288121336794,
            33.793834524364854
          ],
          [
            133.16116723984217,
            33.73151732839562
          ],
          [
            133.12541675570583,
            33.698395932598046
          ],
          [
            133.11646850520728,
            33.66019175966135
          ],
          [
            133.07742587422732,
            33.65351809827432
          ],
          [
            133.04660613129508,
            33.57555856079052
          ],
          [
            133.06427894411715,
            33.54267105612455
          ],
          [
            133.03807506356702,
            33.52646381502003
          ],
          [
            133.01544854324706,
            33.48097789523197
          ],
          [
            132.95997672000158,
            33.466404600028405
          ],
          [
            132.82056155013447,
            33.472516121463215
          ],
          [
            132.82490261139287,
            33.42292155529632
          ],
          [
            132.8601268488726,
            33.36827958993611
          ],
          [
            132.9029090816951,
            33.3376106379652
          ],
          [
            132.89590540161277,
            33.312487425416094
          ],
          [
            132.79337131438345,
            33.27479594123696
          ],
          [
            132.77210605939342,
            33.241489464995105
          ],
          [
            132.77564817274785,
            33.206095461765536
          ],
          [
            132.74077374196852,
            33.20143578453957
          ],
          [
            132.72827526444246,
            33.170056202851626
          ],
          [
            132.66337099877728,
            33.10915196138803
          ],
          [
            132.6868095002634,
            32.99833184503844
          ],
          [
            132.67805315430988,
            32.94283886466871
          ],
          [
            132.65581568328506,
            32.9254814190207
          ],
          [
            132.599085150045,
            32.912713138155766
          ],
          [
            132.5734343439875,
            32.946868763816916
          ],
          [
            132.5129815131951,
            32.95030926301483
          ],
          [
            132.51626444484413,
            32.90338106994424
          ],
          [
            132.47763050020205,
            32.909761460270765
          ],
          [
            132.46990450586904,
            32.9356738017185
          ],
          [
            132.52801436224735,
            32.95978938449756
          ],
          [
            132.48437149570938,
            33.011385658020394
          ],
          [
            132.4787628659662,
            33.08400816344323
          ],
          [
            132.43341892376213,
            33.15370878878399
          ],
          [
            132.4469932714239,
            33.18440480303155
          ],
          [
            132.48949807168833,
            33.165017610668905
          ],
          [
            132.5149193527966,
            33.2152946820706
          ],
          [
            132.55028039966146,
            33.23420192901735
          ],
          [
            132.4834026051308,
            33.27489701536781
          ],
          [
            132.49834827719644,
            33.31190039852678
          ],
          [
            132.43271098289594,
            33.31997244002593
          ],
          [
            132.4179905720308,
            33.303515794717214
          ],
          [
            132.36899220040763,
            33.32485283002878
          ],
          [
            132.40856273789169,
            33.35335074956101
          ],
          [
            132.38722420746328,
            33.45971385052341
          ],
          [
            132.3066325224064,
            33.47300872484454
          ],
          [
            132.2369201753393,
            33.42552118396133
          ],
          [
            132.18215898447863,
            33.41197049836375
          ],
          [
            132.12925785883468,
            33.3634770918287
          ],
          [
            132.12099291077863,
            33.42001080956803
          ],
          [
            132.1561285506805,
            33.40692059045706
          ],
          [
            132.1716119404938,
            33.44534984348316
          ],
          [
            132.2247335844542,
            33.4443946112618
          ],
          [
            132.2958956888736,
            33.48744032951014
          ],
          [
            132.4178712097187,
            33.54445732586091
          ],
          [
            132.4568085622926,
            33.59473439198809
          ],
          [
            132.53129785937247,
            33.63757369336088
          ],
          [
            132.58563359770582,
            33.6535652096834
          ],
          [
            132.66162419176922,
            33.70774188917188
          ],
          [
            132.70048289138018,
            33.761045602498385
          ],
          [
            132.6899368901638,
            33.78830819634495
          ],
          [
            132.7103082138327,
            33.85417510871817
          ],
          [
            132.7106557831776,
            33.90692658767729
          ],
          [
            132.75545060123574,
            33.91122099692615
          ],
          [
            132.77200102259408,
            33.99930281107276
          ],
          [
            132.92929299256986,
            34.087881786184994
          ],
          [
            132.93629627625333,
            34.126920163959696
          ],
          [
            132.97868220338972,
            34.115912010629344
          ],
          [
            133.00690131046903,
            34.065809784034656
          ],
          [
            133.03657610969898,
            34.03951457832419
          ],
          [
            133.068336090895,
            33.97555489413495
          ],
          [
            133.13370999786068,
            33.927243329197815
          ],
          [
            133.2342673553021,
            33.95184453204779
          ],
          [
            133.2486588314261,
            33.97585901982981
          ],
          [
            133.3204755406635,
            33.99422246251639
          ],
          [
            133.3570162514559,
            33.97872600912373
          ],
          [
            133.45316907854777,
            33.98400329566243
          ],
          [
            133.51193164769896,
            33.96971328305378
          ],
          [
            133.54688636808265,
            33.98923625886132
          ],
          [
            133.5984425414343,
            34.04371168002969
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "香川県",
      pref: "Kagawa",
      name: "JP-37"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            134.4401897763731,
            34.20794556545673
          ],
          [
            134.4194548746329,
            34.15776517156459
          ],
          [
            134.35897339559432,
            34.18392927734448
          ],
          [
            134.29720757099122,
            34.168896406722915
          ],
          [
            134.26608987963684,
            34.18328622390257
          ],
          [
            134.208742879891,
            34.174695053868255
          ],
          [
            134.15542498089303,
            34.16660977405473
          ],
          [
            134.12234563621027,
            34.11874709611684
          ],
          [
            134.07909966458848,
            34.12101676362222
          ],
          [
            133.99395974306984,
            34.07264736670665
          ],
          [
            133.9219775724304,
            34.11428079448257
          ],
          [
            133.78302526986235,
            34.080098724453855
          ],
          [
            133.67959748668784,
            34.01250031473547
          ],
          [
            133.65700375697952,
            34.02998068957257
          ],
          [
            133.5984425414343,
            34.04371168002969
          ],
          [
            133.62710180947718,
            34.05279453761536
          ],
          [
            133.649363176626,
            34.186228532005465
          ],
          [
            133.62164736544688,
            34.23565473628553
          ],
          [
            133.69965991063668,
            34.23457143459039
          ],
          [
            133.82910645003722,
            34.32298636066839
          ],
          [
            133.82460113894896,
            34.35262420587655
          ],
          [
            133.89481186780802,
            34.35454268764017
          ],
          [
            133.9275105148237,
            34.38965376961936
          ],
          [
            134.00117497944868,
            34.35501113552829
          ],
          [
            134.07948443225771,
            34.34769527535979
          ],
          [
            134.12005387456975,
            34.35926064627215
          ],
          [
            134.12546182556403,
            34.39603082446062
          ],
          [
            134.16028560904914,
            34.38855560239092
          ],
          [
            134.1535838995781,
            34.340796840354606
          ],
          [
            134.2575064266438,
            34.34539089304632
          ],
          [
            134.26040480407707,
            34.28376539115102
          ],
          [
            134.30678974703255,
            34.27821555922252
          ],
          [
            134.3452674257105,
            34.253286931823666
          ],
          [
            134.39366530679322,
            34.25129607259774
          ],
          [
            134.4401897763731,
            34.20794556545673
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "沖縄県",
      pref: "Okinawa",
      name: "JP-47"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            128.15468533284886,
            26.7173113114938
          ],
          [
            128.16467463597888,
            26.74335073479143
          ],
          [
            128.22285326711625,
            26.788465266686842
          ],
          [
            128.25355212698062,
            26.84484355350326
          ],
          [
            128.3065951198373,
            26.84331282001453
          ],
          [
            128.32600525429316,
            26.782552536462813
          ],
          [
            128.31892390603494,
            26.735697215412394
          ],
          [
            128.29356194712835,
            26.71707459476789
          ],
          [
            128.2793282515049,
            26.676911533334277
          ],
          [
            128.23476908671523,
            26.630389349792708
          ],
          [
            128.1456277169712,
            26.622455032148597
          ],
          [
            128.1517218270572,
            26.59788242913379
          ],
          [
            128.13096839944026,
            26.555308672145753
          ],
          [
            128.05298935061515,
            26.520301992923997
          ],
          [
            128.00985826536413,
            26.514960212019567
          ],
          [
            128.0013435838638,
            26.48410314179255
          ],
          [
            127.94265331328813,
            26.44155557080817
          ],
          [
            127.88567800534724,
            26.45738622663333
          ],
          [
            127.83136029695324,
            26.426195973748094
          ],
          [
            127.87618424246023,
            26.381967243117145
          ],
          [
            127.79793063749015,
            26.265884932659677
          ],
          [
            127.78856693785309,
            26.226756331253235
          ],
          [
            127.76238913168854,
            26.210806659134395
          ],
          [
            127.79077430501421,
            26.171394919091124
          ],
          [
            127.79303242322628,
            26.13514835452305
          ],
          [
            127.74805200004116,
            26.11920589191131
          ],
          [
            127.7246799794367,
            26.090417182852757
          ],
          [
            127.65854820538836,
            26.081223843703782
          ],
          [
            127.66793897027762,
            26.127469998944072
          ],
          [
            127.63679167538342,
            26.199270007716184
          ],
          [
            127.67899170424595,
            26.226260485816788
          ],
          [
            127.70669638884328,
            26.27328190074588
          ],
          [
            127.72546256200633,
            26.27082394656482
          ],
          [
            127.76089172497231,
            26.310921161817223
          ],
          [
            127.71555374277392,
            26.403995029033545
          ],
          [
            127.76579185658693,
            26.43804226630253
          ],
          [
            127.79892311010174,
            26.43732687415435
          ],
          [
            127.81278387379957,
            26.46312590333348
          ],
          [
            127.96704778715544,
            26.550413291083466
          ],
          [
            127.98285295421381,
            26.585551991985508
          ],
          [
            127.89499341564046,
            26.61393035386614
          ],
          [
            127.87435136007105,
            26.68436472537639
          ],
          [
            127.9499777225711,
            26.708455771838008
          ],
          [
            128.00440151700644,
            26.68863581182493
          ],
          [
            127.98864897438493,
            26.646623904727985
          ],
          [
            128.02498384059308,
            26.627217163887696
          ],
          [
            128.08064786013125,
            26.644701155613234
          ],
          [
            128.1182911510297,
            26.70299519281857
          ],
          [
            128.15468533284886,
            26.7173113114938
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "鹿児島県",
      pref: "Kagoshima",
      name: "JP-46"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            130.36092865550893,
            32.16802544137668
          ],
          [
            130.4288489396418,
            32.11401558571568
          ],
          [
            130.50551731140123,
            32.140713637816944
          ],
          [
            130.62270457839062,
            32.156037074690374
          ],
          [
            130.72055287416183,
            32.10084122507515
          ],
          [
            130.70316218228402,
            32.05781921231269
          ],
          [
            130.77781061986357,
            32.01569347348111
          ],
          [
            130.78225658405648,
            31.98259514932402
          ],
          [
            130.81584037301715,
            31.941575471823914
          ],
          [
            130.85728487753622,
            31.938052683128756
          ],
          [
            130.89939357317303,
            31.8862145694561
          ],
          [
            130.8769415951618,
            31.815694762158028
          ],
          [
            130.9311124290768,
            31.78565784833102
          ],
          [
            130.98976204390587,
            31.778127083673258
          ],
          [
            131.01694915086702,
            31.746989047099508
          ],
          [
            131.0255278031803,
            31.66693941233926
          ],
          [
            131.0545808296862,
            31.633310298202964
          ],
          [
            131.07846655798758,
            31.66034818085187
          ],
          [
            131.1179347531993,
            31.629345669607098
          ],
          [
            131.16308697149145,
            31.636543864879826
          ],
          [
            131.18946529207497,
            31.62225573820219
          ],
          [
            131.2053596234002,
            31.580119370165715
          ],
          [
            131.2006740589409,
            31.517509319956233
          ],
          [
            131.1694959266356,
            31.49893699492069
          ],
          [
            131.16038312505674,
            31.46189008028392
          ],
          [
            131.1215493658939,
            31.474646531508835
          ],
          [
            131.06134833859338,
            31.445467077670823
          ],
          [
            131.02080864489724,
            31.394911546631356
          ],
          [
            131.01562853499686,
            31.35881334247137
          ],
          [
            131.10837310642935,
            31.331102392474943
          ],
          [
            131.07365430788724,
            31.29184663143384
          ],
          [
            131.08468928121837,
            31.248177796096446
          ],
          [
            131.0652480903223,
            31.227505026237644
          ],
          [
            131.01735210817952,
            31.228169914734078
          ],
          [
            130.9745457779611,
            31.146595043395475
          ],
          [
            130.87444222878054,
            31.09534864874851
          ],
          [
            130.80824137974636,
            31.087266447866654
          ],
          [
            130.7613720604059,
            31.055543451698952
          ],
          [
            130.71636859255904,
            31.044801199695264
          ],
          [
            130.68234452266114,
            31.003555066282626
          ],
          [
            130.66761138643767,
            31.08499469872522
          ],
          [
            130.74445205083993,
            31.13179841174503
          ],
          [
            130.76678310528231,
            31.18066909759056
          ],
          [
            130.7548301479665,
            31.19807544992297
          ],
          [
            130.7897306574993,
            31.251137746668235
          ],
          [
            130.802704038479,
            31.336852182772656
          ],
          [
            130.75581129153406,
            31.425275704762452
          ],
          [
            130.6985051964309,
            31.46319695271288
          ],
          [
            130.69831226871008,
            31.555576520838017
          ],
          [
            130.63934174382365,
            31.545218094539752
          ],
          [
            130.5910804285526,
            31.58891361975941
          ],
          [
            130.63050358371365,
            31.621759896268077
          ],
          [
            130.69635746449066,
            31.625111687389804
          ],
          [
            130.71907344277608,
            31.590873115153414
          ],
          [
            130.70663628118456,
            31.55760145527804
          ],
          [
            130.76709052433063,
            31.563768874315212
          ],
          [
            130.82290738818182,
            31.660101351579076
          ],
          [
            130.79188274476368,
            31.703280216310866
          ],
          [
            130.7303093806874,
            31.71005414257777
          ],
          [
            130.71725516381775,
            31.727933971227213
          ],
          [
            130.65984635450695,
            31.72841617847824
          ],
          [
            130.61646498658482,
            31.70076052496174
          ],
          [
            130.61888867793698,
            31.6567888555429
          ],
          [
            130.56166412638265,
            31.595787071373632
          ],
          [
            130.53127070581147,
            31.484298109042935
          ],
          [
            130.51316455123757,
            31.46543198225793
          ],
          [
            130.52549076373714,
            31.411965710027538
          ],
          [
            130.56528266754904,
            31.32230975093743
          ],
          [
            130.62273685208473,
            31.275820949425828
          ],
          [
            130.6640969204178,
            31.266106845363183
          ],
          [
            130.6577359824824,
            31.22076210986877
          ],
          [
            130.62605586068744,
            31.180964642038578
          ],
          [
            130.58803785825444,
            31.170198364043674
          ],
          [
            130.51555961802435,
            31.19862013501002
          ],
          [
            130.4694510182264,
            31.24760850340891
          ],
          [
            130.31582837188506,
            31.257301642904423
          ],
          [
            130.3080163611387,
            31.266783764677218
          ],
          [
            130.22525598013402,
            31.250217428136786
          ],
          [
            130.20983665415545,
            31.34718901791125
          ],
          [
            130.15245887652307,
            31.385150964482698
          ],
          [
            130.15522647397813,
            31.432172848151623
          ],
          [
            130.22540763996886,
            31.402234205001633
          ],
          [
            130.27261644851552,
            31.425423631130887
          ],
          [
            130.31302378446816,
            31.49077460475174
          ],
          [
            130.33487619649222,
            31.57894202935815
          ],
          [
            130.31560218296738,
            31.6585086966318
          ],
          [
            130.25277550508517,
            31.731193073124796
          ],
          [
            130.18898618628438,
            31.75689687917821
          ],
          [
            130.17331771894493,
            31.801308585636328
          ],
          [
            130.2243595404582,
            31.911080123114743
          ],
          [
            130.20918164912752,
            31.97190811389254
          ],
          [
            130.1782533168286,
            32.0025565426564
          ],
          [
            130.20220999796243,
            32.037245664143065
          ],
          [
            130.19918933097,
            32.07695610341211
          ],
          [
            130.1761348209619,
            32.10622725773849
          ],
          [
            130.2511985055989,
            32.12818566030618
          ],
          [
            130.2853886715245,
            32.108896062401335
          ],
          [
            130.35118221995688,
            32.13446127201237
          ],
          [
            130.36092865550893,
            32.16802544137668
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "宮崎県",
      pref: "Miyazaki",
      name: "JP-45"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            131.8818903440785,
            32.74510074848341
          ],
          [
            131.84584573166032,
            32.70881043035108
          ],
          [
            131.76260728470388,
            32.6583547346909
          ],
          [
            131.7728587754329,
            32.641956983237705
          ],
          [
            131.74219530170686,
            32.59181038860976
          ],
          [
            131.70886522340885,
            32.586751172253926
          ],
          [
            131.68199403090972,
            32.541704162535474
          ],
          [
            131.71747016342454,
            32.483394949761575
          ],
          [
            131.6503489315479,
            32.45756117710558
          ],
          [
            131.67611268665414,
            32.421339554752635
          ],
          [
            131.6430341601805,
            32.408097521535744
          ],
          [
            131.61428906716606,
            32.336771452284566
          ],
          [
            131.59269439905938,
            32.306747977888165
          ],
          [
            131.5757617637421,
            32.245721240547695
          ],
          [
            131.4653887375263,
            31.92014159342854
          ],
          [
            131.451017915942,
            31.831648261140845
          ],
          [
            131.4883839631943,
            31.785313718477237
          ],
          [
            131.46824129716816,
            31.752115980693837
          ],
          [
            131.46129191260653,
            31.669285105222333
          ],
          [
            131.4692966001908,
            31.645270273976994
          ],
          [
            131.4202132846488,
            31.605546643448648
          ],
          [
            131.38143234456007,
            31.554599072656675
          ],
          [
            131.38889814614646,
            31.48580012601423
          ],
          [
            131.36314553695271,
            31.4717844241265
          ],
          [
            131.3655594597618,
            31.42070634107716
          ],
          [
            131.30948091753706,
            31.390675990902494
          ],
          [
            131.25424187163347,
            31.38072539993657
          ],
          [
            131.20437277790225,
            31.453843207509237
          ],
          [
            131.16038312505674,
            31.46189008028392
          ],
          [
            131.1694959266356,
            31.49893699492069
          ],
          [
            131.2006740589409,
            31.517509319956233
          ],
          [
            131.2053596234002,
            31.580119370165715
          ],
          [
            131.18946529207497,
            31.62225573820219
          ],
          [
            131.16308697149145,
            31.636543864879826
          ],
          [
            131.1179347531993,
            31.629345669607098
          ],
          [
            131.07846655798758,
            31.66034818085187
          ],
          [
            131.0545808296862,
            31.633310298202964
          ],
          [
            131.0255278031803,
            31.66693941233926
          ],
          [
            131.01694915086702,
            31.746989047099508
          ],
          [
            130.98976204390587,
            31.778127083673258
          ],
          [
            130.9311124290768,
            31.78565784833102
          ],
          [
            130.8769415951618,
            31.815694762158028
          ],
          [
            130.89939357317303,
            31.8862145694561
          ],
          [
            130.85728487753622,
            31.938052683128756
          ],
          [
            130.81584037301715,
            31.941575471823914
          ],
          [
            130.78225658405648,
            31.98259514932402
          ],
          [
            130.77781061986357,
            32.01569347348111
          ],
          [
            130.70316218228402,
            32.05781921231269
          ],
          [
            130.72055287416183,
            32.10084122507515
          ],
          [
            130.85739916013503,
            32.09979330262324
          ],
          [
            130.90674358559912,
            32.13389852140892
          ],
          [
            130.93321750957114,
            32.11615132878062
          ],
          [
            130.9744380922721,
            32.121592889461134
          ],
          [
            131.0022467330045,
            32.16948072919829
          ],
          [
            131.09709182549514,
            32.152202785170786
          ],
          [
            131.10055309101156,
            32.2016399339144
          ],
          [
            131.0416079117112,
            32.25807331074993
          ],
          [
            131.07879026056082,
            32.281478257492246
          ],
          [
            131.11181585211602,
            32.33015932551987
          ],
          [
            131.0735375020547,
            32.35843266165015
          ],
          [
            131.0680141274176,
            32.40761574537364
          ],
          [
            131.01973494751553,
            32.43904777852119
          ],
          [
            131.0094020785579,
            32.51529887800591
          ],
          [
            131.01943456137252,
            32.5492683432133
          ],
          [
            131.05392734679765,
            32.588466386819896
          ],
          [
            131.0871226956693,
            32.57944252662674
          ],
          [
            131.11969109862622,
            32.59926506875473
          ],
          [
            131.1147921992545,
            32.63897028784781
          ],
          [
            131.18031932672545,
            32.712514160686034
          ],
          [
            131.2350349457468,
            32.744360928166635
          ],
          [
            131.25539704074635,
            32.81628014571319
          ],
          [
            131.32945319666712,
            32.83301567384578
          ],
          [
            131.3592263774987,
            32.804085516734084
          ],
          [
            131.42119140460406,
            32.81194662599231
          ],
          [
            131.46439609264291,
            32.83114558497517
          ],
          [
            131.5172755127482,
            32.80104079223396
          ],
          [
            131.51273750197893,
            32.769518332330136
          ],
          [
            131.5687914138649,
            32.75406332574989
          ],
          [
            131.59241778399783,
            32.77531234175202
          ],
          [
            131.668913617326,
            32.76661529795002
          ],
          [
            131.71039445730824,
            32.77216757076223
          ],
          [
            131.73755236403713,
            32.833060426982364
          ],
          [
            131.85870410230854,
            32.82155711223303
          ],
          [
            131.84652101479463,
            32.73745817930597
          ],
          [
            131.8818903440785,
            32.74510074848341
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "熊本県",
      pref: "Kumamoto",
      name: "JP-43"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            130.8397735407476,
            33.10406980680028
          ],
          [
            130.88713002170007,
            33.08668400017709
          ],
          [
            130.91716357526695,
            33.05306241556272
          ],
          [
            130.94673644079367,
            33.05291904258252
          ],
          [
            130.97017298322,
            33.023853150824216
          ],
          [
            131.01436408917624,
            33.04754681345646
          ],
          [
            131.02396304393199,
            33.08779496439451
          ],
          [
            130.97843381557644,
            33.14067262069918
          ],
          [
            130.98883100279446,
            33.17580447523711
          ],
          [
            131.06074226761177,
            33.194927629874066
          ],
          [
            131.1171620352697,
            33.17836346259829
          ],
          [
            131.16144872250018,
            33.14054015335966
          ],
          [
            131.1746425990496,
            33.082945419130816
          ],
          [
            131.21668754051814,
            33.05357402620819
          ],
          [
            131.22647033408145,
            33.01929399353402
          ],
          [
            131.26362933710857,
            32.976383003616995
          ],
          [
            131.24590798085407,
            32.938953047163274
          ],
          [
            131.26451760979285,
            32.879000792475516
          ],
          [
            131.32945319666712,
            32.83301567384578
          ],
          [
            131.25539704074635,
            32.81628014571319
          ],
          [
            131.2350349457468,
            32.744360928166635
          ],
          [
            131.18031932672545,
            32.712514160686034
          ],
          [
            131.1147921992545,
            32.63897028784781
          ],
          [
            131.11969109862622,
            32.59926506875473
          ],
          [
            131.0871226956693,
            32.57944252662674
          ],
          [
            131.05392734679765,
            32.588466386819896
          ],
          [
            131.01943456137252,
            32.5492683432133
          ],
          [
            131.0094020785579,
            32.51529887800591
          ],
          [
            131.01973494751553,
            32.43904777852119
          ],
          [
            131.0680141274176,
            32.40761574537364
          ],
          [
            131.0735375020547,
            32.35843266165015
          ],
          [
            131.11181585211602,
            32.33015932551987
          ],
          [
            131.07879026056082,
            32.281478257492246
          ],
          [
            131.0416079117112,
            32.25807331074993
          ],
          [
            131.10055309101156,
            32.2016399339144
          ],
          [
            131.09709182549514,
            32.152202785170786
          ],
          [
            131.0022467330045,
            32.16948072919829
          ],
          [
            130.9744380922721,
            32.121592889461134
          ],
          [
            130.93321750957114,
            32.11615132878062
          ],
          [
            130.90674358559912,
            32.13389852140892
          ],
          [
            130.85739916013503,
            32.09979330262324
          ],
          [
            130.72055287416183,
            32.10084122507515
          ],
          [
            130.62270457839062,
            32.156037074690374
          ],
          [
            130.50551731140123,
            32.140713637816944
          ],
          [
            130.4288489396418,
            32.11401558571568
          ],
          [
            130.36092865550893,
            32.16802544137668
          ],
          [
            130.4022860725242,
            32.23553381642232
          ],
          [
            130.4635277170867,
            32.277181874246025
          ],
          [
            130.4716847371087,
            32.32716833544035
          ],
          [
            130.51355393862033,
            32.39219507667271
          ],
          [
            130.5745890052748,
            32.434375548567154
          ],
          [
            130.54237628568615,
            32.495436715497284
          ],
          [
            130.57354389126743,
            32.509776293801416
          ],
          [
            130.56239868090282,
            32.537849348807825
          ],
          [
            130.60960510030736,
            32.5936470749419
          ],
          [
            130.61369094935523,
            32.63149337054132
          ],
          [
            130.45973209171746,
            32.60692627218622
          ],
          [
            130.4509645104382,
            32.62399080880862
          ],
          [
            130.53787922914591,
            32.66501512449769
          ],
          [
            130.56727691087272,
            32.69900408652606
          ],
          [
            130.6083853431993,
            32.71313791493688
          ],
          [
            130.59760180906918,
            32.77550117429629
          ],
          [
            130.61238451888866,
            32.79800505638039
          ],
          [
            130.5647584685513,
            32.84207544246741
          ],
          [
            130.52270610329916,
            32.853489462479736
          ],
          [
            130.52767189342978,
            32.878386679860505
          ],
          [
            130.44256805898766,
            32.92830867796017
          ],
          [
            130.42995533671566,
            32.98713419077732
          ],
          [
            130.4140710194521,
            33.002325389201246
          ],
          [
            130.4838751729212,
            33.00163480287254
          ],
          [
            130.51596378124245,
            33.012199979091164
          ],
          [
            130.4949227368491,
            33.04905369586775
          ],
          [
            130.56581926802642,
            33.08732805267189
          ],
          [
            130.5800803329809,
            33.115999434466545
          ],
          [
            130.6602384926535,
            33.11763544388221
          ],
          [
            130.66637435731627,
            33.15517297798269
          ],
          [
            130.7324629684615,
            33.154463434522555
          ],
          [
            130.7708955922929,
            33.12435817396286
          ],
          [
            130.8397735407476,
            33.10406980680028
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "大分県",
      pref: "Oita",
      name: "JP-44"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            131.8818903440785,
            32.74510074848341
          ],
          [
            131.84652101479463,
            32.73745817930597
          ],
          [
            131.85870410230854,
            32.82155711223303
          ],
          [
            131.73755236403713,
            32.833060426982364
          ],
          [
            131.71039445730824,
            32.77216757076223
          ],
          [
            131.668913617326,
            32.76661529795002
          ],
          [
            131.59241778399783,
            32.77531234175202
          ],
          [
            131.5687914138649,
            32.75406332574989
          ],
          [
            131.51273750197893,
            32.769518332330136
          ],
          [
            131.5172755127482,
            32.80104079223396
          ],
          [
            131.46439609264291,
            32.83114558497517
          ],
          [
            131.42119140460406,
            32.81194662599231
          ],
          [
            131.3592263774987,
            32.804085516734084
          ],
          [
            131.32945319666712,
            32.83301567384578
          ],
          [
            131.26451760979285,
            32.879000792475516
          ],
          [
            131.24590798085407,
            32.938953047163274
          ],
          [
            131.26362933710857,
            32.976383003616995
          ],
          [
            131.22647033408145,
            33.01929399353402
          ],
          [
            131.21668754051814,
            33.05357402620819
          ],
          [
            131.1746425990496,
            33.082945419130816
          ],
          [
            131.16144872250018,
            33.14054015335966
          ],
          [
            131.1171620352697,
            33.17836346259829
          ],
          [
            131.06074226761177,
            33.194927629874066
          ],
          [
            130.98883100279446,
            33.17580447523711
          ],
          [
            130.97843381557644,
            33.14067262069918
          ],
          [
            131.02396304393199,
            33.08779496439451
          ],
          [
            131.01436408917624,
            33.04754681345646
          ],
          [
            130.97017298322,
            33.023853150824216
          ],
          [
            130.94673644079367,
            33.05291904258252
          ],
          [
            130.91716357526695,
            33.05306241556272
          ],
          [
            130.88713002170007,
            33.08668400017709
          ],
          [
            130.8397735407476,
            33.10406980680028
          ],
          [
            130.86602007081402,
            33.12671108561797
          ],
          [
            130.88714496804468,
            33.18661091740499
          ],
          [
            130.8363356537238,
            33.21081939821461
          ],
          [
            130.82480734356295,
            33.25347260843968
          ],
          [
            130.8607574172131,
            33.26675527435305
          ],
          [
            130.866103091033,
            33.292944807604115
          ],
          [
            130.83537609295297,
            33.34359989113839
          ],
          [
            130.88456286867307,
            33.38931225572461
          ],
          [
            130.8948984684939,
            33.44606340117824
          ],
          [
            130.97290374417062,
            33.50558402083852
          ],
          [
            131.04394808712755,
            33.51008492975432
          ],
          [
            131.11743905058614,
            33.50254624165828
          ],
          [
            131.1631563162027,
            33.50839620834469
          ],
          [
            131.18948897035887,
            33.562750281386066
          ],
          [
            131.17271913751878,
            33.58846326981976
          ],
          [
            131.18467943021315,
            33.616703202318675
          ],
          [
            131.20924326106064,
            33.61575323354777
          ],
          [
            131.28947920296025,
            33.57833537722563
          ],
          [
            131.40552120536276,
            33.572189173894685
          ],
          [
            131.51570059554274,
            33.66901273640966
          ],
          [
            131.5858847419831,
            33.69263954184698
          ],
          [
            131.69350886875435,
            33.639254234697766
          ],
          [
            131.73329889089968,
            33.58065318309214
          ],
          [
            131.74500988231324,
            33.54261594944242
          ],
          [
            131.72569985461848,
            33.46502237505815
          ],
          [
            131.70108573697772,
            33.40593407365912
          ],
          [
            131.6342752304425,
            33.423773538291826
          ],
          [
            131.64300873689285,
            33.37487665501116
          ],
          [
            131.59683117016507,
            33.34990499081484
          ],
          [
            131.49878520907546,
            33.36038527127954
          ],
          [
            131.50737912706856,
            33.27528454450104
          ],
          [
            131.58930685035313,
            33.24567239053535
          ],
          [
            131.61387896681336,
            33.261965119466254
          ],
          [
            131.69188364050456,
            33.2792227045506
          ],
          [
            131.73700164285157,
            33.24759487891915
          ],
          [
            131.80776800459552,
            33.24217211412365
          ],
          [
            131.89212793446703,
            33.26868878331924
          ],
          [
            131.89173773582107,
            33.245331326418004
          ],
          [
            131.82328946379147,
            33.16603004958291
          ],
          [
            131.81075689723647,
            33.12193302469762
          ],
          [
            131.87119439164988,
            33.13151916805883
          ],
          [
            131.8812035761166,
            33.078007885454085
          ],
          [
            131.93274389830088,
            33.074434726371756
          ],
          [
            131.9010828794409,
            33.00991534146985
          ],
          [
            131.90314945318593,
            32.97750969517586
          ],
          [
            131.9832648236484,
            32.93930071256025
          ],
          [
            131.98456968604017,
            32.86339945965599
          ],
          [
            131.93597496146836,
            32.784737736370744
          ],
          [
            131.88864197155763,
            32.80342792053509
          ],
          [
            131.8818903440785,
            32.74510074848341
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "福岡県",
      pref: "Fukuoka",
      name: "JP-40"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            131.18467943021315,
            33.616703202318675
          ],
          [
            131.17271913751878,
            33.58846326981976
          ],
          [
            131.18948897035887,
            33.562750281386066
          ],
          [
            131.1631563162027,
            33.50839620834469
          ],
          [
            131.11743905058614,
            33.50254624165828
          ],
          [
            131.04394808712755,
            33.51008492975432
          ],
          [
            130.97290374417062,
            33.50558402083852
          ],
          [
            130.8948984684939,
            33.44606340117824
          ],
          [
            130.88456286867307,
            33.38931225572461
          ],
          [
            130.83537609295297,
            33.34359989113839
          ],
          [
            130.866103091033,
            33.292944807604115
          ],
          [
            130.8607574172131,
            33.26675527435305
          ],
          [
            130.82480734356295,
            33.25347260843968
          ],
          [
            130.8363356537238,
            33.21081939821461
          ],
          [
            130.88714496804468,
            33.18661091740499
          ],
          [
            130.86602007081402,
            33.12671108561797
          ],
          [
            130.8397735407476,
            33.10406980680028
          ],
          [
            130.7708955922929,
            33.12435817396286
          ],
          [
            130.7324629684615,
            33.154463434522555
          ],
          [
            130.66637435731627,
            33.15517297798269
          ],
          [
            130.6602384926535,
            33.11763544388221
          ],
          [
            130.5800803329809,
            33.115999434466545
          ],
          [
            130.56581926802642,
            33.08732805267189
          ],
          [
            130.4949227368491,
            33.04905369586775
          ],
          [
            130.51596378124245,
            33.012199979091164
          ],
          [
            130.4838751729212,
            33.00163480287254
          ],
          [
            130.4140710194521,
            33.002325389201246
          ],
          [
            130.42506669699802,
            33.052811035744455
          ],
          [
            130.39702003580774,
            33.10812152168838
          ],
          [
            130.3558081603684,
            33.140558479471245
          ],
          [
            130.34251182864574,
            33.208367739944926
          ],
          [
            130.4173909091721,
            33.26842175118615
          ],
          [
            130.46775873869467,
            33.2868891190803
          ],
          [
            130.50955332459114,
            33.34360198600346
          ],
          [
            130.54187626121166,
            33.36644999871231
          ],
          [
            130.53689862294164,
            33.43824955583234
          ],
          [
            130.51232599173554,
            33.44946559008061
          ],
          [
            130.45815406341927,
            33.42538236253281
          ],
          [
            130.42849653915513,
            33.39692077929406
          ],
          [
            130.39639824024246,
            33.42820676889186
          ],
          [
            130.3558376778223,
            33.43328759700337
          ],
          [
            130.27125993505132,
            33.47985761347189
          ],
          [
            130.19873002858608,
            33.48114715315708
          ],
          [
            130.04017746901036,
            33.47021146808252
          ],
          [
            130.0827441285352,
            33.50675347027281
          ],
          [
            130.1226859973658,
            33.50888305064493
          ],
          [
            130.15390775597234,
            33.5371575370657
          ],
          [
            130.11897925943867,
            33.573976987558915
          ],
          [
            130.15413009232958,
            33.621147580475515
          ],
          [
            130.20731297954538,
            33.64778774135871
          ],
          [
            130.27267100474393,
            33.582673348667974
          ],
          [
            130.35937547277388,
            33.59226542621971
          ],
          [
            130.40308679997045,
            33.612487427248546
          ],
          [
            130.4278994262133,
            33.6882536246056
          ],
          [
            130.47084698813006,
            33.773905980471675
          ],
          [
            130.44557966697298,
            33.7946365849518
          ],
          [
            130.4877444567191,
            33.851054379781104
          ],
          [
            130.5295287858686,
            33.876228130716314
          ],
          [
            130.60973099165167,
            33.87932992236726
          ],
          [
            130.65546511110983,
            33.894152584193805
          ],
          [
            130.7009355393515,
            33.93875683841152
          ],
          [
            130.75708597930992,
            33.920302952164285
          ],
          [
            130.85703494012196,
            33.92896955242403
          ],
          [
            130.8930708994559,
            33.89636631693628
          ],
          [
            130.93254015166482,
            33.90864132140636
          ],
          [
            130.97637125821848,
            33.95857793307523
          ],
          [
            131.02348571484,
            33.960011011819226
          ],
          [
            130.98405571094136,
            33.882046003860324
          ],
          [
            130.99343091858677,
            33.85103193801554
          ],
          [
            130.9603958563374,
            33.839057640848786
          ],
          [
            130.96665485105805,
            33.809460430758385
          ],
          [
            130.9983886316967,
            33.79653105981322
          ],
          [
            131.00054256339325,
            33.75728436616568
          ],
          [
            131.04096631618907,
            33.68984996425632
          ],
          [
            131.09378373785364,
            33.62364060868814
          ],
          [
            131.18467943021315,
            33.616703202318675
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "佐賀県",
      pref: "Saga",
      name: "JP-41"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            129.79082560630926,
            33.34041842839981
          ],
          [
            129.83151020495333,
            33.304173278051415
          ],
          [
            129.8718083404934,
            33.39363427951239
          ],
          [
            129.79107473521347,
            33.448259638421014
          ],
          [
            129.80646309493403,
            33.48567094810456
          ],
          [
            129.8612059758267,
            33.54220087955702
          ],
          [
            129.8973140795081,
            33.549425105069886
          ],
          [
            129.94756201189088,
            33.52796138736821
          ],
          [
            129.93859796237177,
            33.482783858599376
          ],
          [
            129.9940980995837,
            33.4474554963859
          ],
          [
            130.04017746901036,
            33.47021146808252
          ],
          [
            130.19873002858608,
            33.48114715315708
          ],
          [
            130.27125993505132,
            33.47985761347189
          ],
          [
            130.3558376778223,
            33.43328759700337
          ],
          [
            130.39639824024246,
            33.42820676889186
          ],
          [
            130.42849653915513,
            33.39692077929406
          ],
          [
            130.45815406341927,
            33.42538236253281
          ],
          [
            130.51232599173554,
            33.44946559008061
          ],
          [
            130.53689862294164,
            33.43824955583234
          ],
          [
            130.54187626121166,
            33.36644999871231
          ],
          [
            130.50955332459114,
            33.34360198600346
          ],
          [
            130.46775873869467,
            33.2868891190803
          ],
          [
            130.4173909091721,
            33.26842175118615
          ],
          [
            130.34251182864574,
            33.208367739944926
          ],
          [
            130.3558081603684,
            33.140558479471245
          ],
          [
            130.28789056989203,
            33.14713212513581
          ],
          [
            130.24719066675914,
            33.191868193901115
          ],
          [
            130.1493853689383,
            33.11240972106423
          ],
          [
            130.1446392893441,
            33.073255783054414
          ],
          [
            130.16923963863235,
            33.051799898562976
          ],
          [
            130.2035801163878,
            32.9570880346952
          ],
          [
            130.08656701370302,
            32.97497116750473
          ],
          [
            130.000764801775,
            33.025781394927826
          ],
          [
            129.982466458592,
            33.05734503204802
          ],
          [
            129.94229637102458,
            33.07180834471596
          ],
          [
            129.95135647239624,
            33.109996709623616
          ],
          [
            129.93860400280002,
            33.16528154234381
          ],
          [
            129.9056202483641,
            33.15797458921267
          ],
          [
            129.81726873413237,
            33.18446155098755
          ],
          [
            129.80995037584867,
            33.24262167532743
          ],
          [
            129.75878151758877,
            33.290616668522915
          ],
          [
            129.79082560630926,
            33.34041842839981
          ]
        ]
      ]
    }
  },
  {
    type: "Feature",
    properties: {
      pref_j: "長崎県",
      pref: "Nagasaki",
      name: "JP-42"
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [
            129.79082560630926,
            33.34041842839981
          ],
          [
            129.75878151758877,
            33.290616668522915
          ],
          [
            129.80995037584867,
            33.24262167532743
          ],
          [
            129.81726873413237,
            33.18446155098755
          ],
          [
            129.9056202483641,
            33.15797458921267
          ],
          [
            129.93860400280002,
            33.16528154234381
          ],
          [
            129.95135647239624,
            33.109996709623616
          ],
          [
            129.94229637102458,
            33.07180834471596
          ],
          [
            129.982466458592,
            33.05734503204802
          ],
          [
            130.000764801775,
            33.025781394927826
          ],
          [
            130.08656701370302,
            32.97497116750473
          ],
          [
            130.2035801163878,
            32.9570880346952
          ],
          [
            130.2015056887093,
            32.92917431901053
          ],
          [
            130.10640345145177,
            32.86274089842535
          ],
          [
            130.12627021322302,
            32.84112718338728
          ],
          [
            130.1868281870365,
            32.84191899536868
          ],
          [
            130.2341184327694,
            32.86598286872223
          ],
          [
            130.2947640389935,
            32.87948076877656
          ],
          [
            130.3410802253438,
            32.855226083867585
          ],
          [
            130.3771899005592,
            32.78849218578165
          ],
          [
            130.37270493011346,
            32.73757654891074
          ],
          [
            130.34561523012067,
            32.70869093075255
          ],
          [
            130.34451476984023,
            32.67207696696883
          ],
          [
            130.30187172607017,
            32.65169381367283
          ],
          [
            130.26515604243943,
            32.65241111706494
          ],
          [
            130.233111595585,
            32.611839451090795
          ],
          [
            130.18915664593695,
            32.60076258712905
          ],
          [
            130.12985387664173,
            32.64014998043724
          ],
          [
            130.13313178736465,
            32.67843873749896
          ],
          [
            130.19944651910563,
            32.71816348224462
          ],
          [
            130.20984345721396,
            32.73826097966319
          ],
          [
            130.17915540298395,
            32.794514992605585
          ],
          [
            130.0872385663512,
            32.79513085898026
          ],
          [
            130.02479928167128,
            32.75863295735269
          ],
          [
            129.9565676234851,
            32.74280754882793
          ],
          [
            129.89591462731067,
            32.66179536220872
          ],
          [
            129.79074840137434,
            32.61466346270867
          ],
          [
            129.82695075107344,
            32.70807502498284
          ],
          [
            129.80256694099458,
            32.77621710234362
          ],
          [
            129.74609386064276,
            32.82231162454559
          ],
          [
            129.68454410458097,
            32.85349122706426
          ],
          [
            129.65207077198133,
            32.931226107663505
          ],
          [
            129.62667308459282,
            32.95753092692825
          ],
          [
            129.65260138974347,
            32.99881613554507
          ],
          [
            129.67721992366677,
            33.099217393058325
          ],
          [
            129.7103869567082,
            33.088126901193036
          ],
          [
            129.75018482412943,
            33.05392905702496
          ],
          [
            129.73225384812605,
            33.00217846268658
          ],
          [
            129.80019901804295,
            33.008602424138374
          ],
          [
            129.81846335024645,
            32.94749153360089
          ],
          [
            129.79996038323043,
            32.863975290579106
          ],
          [
            129.86903569264072,
            32.84439530761511
          ],
          [
            129.894293506787,
            32.868334758952564
          ],
          [
            129.93087978863545,
            32.85708627386855
          ],
          [
            129.9726027073494,
            32.87197730525217
          ],
          [
            129.93098975174374,
            32.92552251422648
          ],
          [
            129.9455700843266,
            33.015405439156744
          ],
          [
            129.87678947047718,
            33.06422437246664
          ],
          [
            129.85005576294665,
            33.05553318812549
          ],
          [
            129.7860060074819,
            33.08312016287708
          ],
          [
            129.7427633799571,
            33.06127211142267
          ],
          [
            129.70661065242425,
            33.152545432160444
          ],
          [
            129.65085170758528,
            33.170655400106384
          ],
          [
            129.65348960020694,
            33.188700549337916
          ],
          [
            129.5652393717273,
            33.21959744475626
          ],
          [
            129.5873204132373,
            33.3046605408709
          ],
          [
            129.56220834499211,
            33.3245237511402
          ],
          [
            129.57714491844442,
            33.380100926104035
          ],
          [
            129.67433420437527,
            33.3618068339092
          ],
          [
            129.70631007888196,
            33.34553351896686
          ],
          [
            129.7451693520753,
            33.367130978952524
          ],
          [
            129.79082560630926,
            33.34041842839981
          ]
        ]
      ]
    }
  }
];
const _geoJson = {
  type,
  features
};
const geoJson = JSON.parse(JSON.stringify(_geoJson));
geoJson.features.forEach((feature) => {
  var _a2, _b;
  if (feature.properties.name === "JP-47" && feature.geometry.type === "Polygon") {
    const adjustX = 143;
    const adjustY = 32;
    const rate = 2;
    const flatPoints = feature.geometry.coordinates.flat();
    const minX = (_a2 = min$1(flatPoints, (d) => d[0])) != null ? _a2 : 0;
    const minY = (_b = min$1(flatPoints, (d) => d[1])) != null ? _b : 0;
    feature.geometry.coordinates.forEach((coordinate) => {
      coordinate.forEach((point2) => {
        point2[0] = adjustX + (point2[0] - minX) * rate;
        point2[1] = adjustY + (point2[1] - minY) * rate;
      });
    });
  }
});
const japanGeoJson = geoJson;
function create_if_block$i(ctx2) {
  let div4;
  let div3;
  let div0;
  let div0_style_value;
  let t0;
  let div1;
  let t1_value = (
    /*seriesColumn*/
    ctx2[4].formatter(
      /*$activeSerie*/
      ctx2[0]
    ) + ""
  );
  let t1;
  let t2;
  let div2;
  let t3_value = (
    /*activeData*/
    ctx2[1].formattedValue + ""
  );
  let t3;
  return {
    c() {
      div4 = element("div");
      div3 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = text(t1_value);
      t2 = space();
      div2 = element("div");
      t3 = text(t3_value);
      attr(div0, "style", div0_style_value = symbol({
        width: (
          /*$font*/
          ctx2[2].size
        ),
        height: (
          /*$font*/
          ctx2[2].size
        ),
        color: (
          /*activeData*/
          ctx2[1].color
        )
      }));
      attr(div1, "style", tooltipItemLabel);
      attr(div2, "style", tooltipItemValue);
      attr(div3, "style", tooltipItem);
      attr(div4, "style", tooltipOuter.toString());
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append$2(div4, div3);
      append$2(div3, div0);
      append$2(div3, t0);
      append$2(div3, div1);
      append$2(div1, t1);
      append$2(div3, t2);
      append$2(div3, div2);
      append$2(div2, t3);
    },
    p(ctx3, dirty) {
      if (dirty & /*$font, activeData*/
      6 && div0_style_value !== (div0_style_value = symbol({
        width: (
          /*$font*/
          ctx3[2].size
        ),
        height: (
          /*$font*/
          ctx3[2].size
        ),
        color: (
          /*activeData*/
          ctx3[1].color
        )
      }))) {
        attr(div0, "style", div0_style_value);
      }
      if (dirty & /*$activeSerie*/
      1 && t1_value !== (t1_value = /*seriesColumn*/
      ctx3[4].formatter(
        /*$activeSerie*/
        ctx3[0]
      ) + ""))
        set_data(t1, t1_value);
      if (dirty & /*activeData*/
      2 && t3_value !== (t3_value = /*activeData*/
      ctx3[1].formattedValue + ""))
        set_data(t3, t3_value);
    },
    d(detaching) {
      if (detaching) {
        detach(div4);
      }
    }
  };
}
function create_fragment$q(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*activeData*/
    ctx2[1] != null && /*$activeSerie*/
    ctx2[0] != null && create_if_block$i(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*activeData*/
        ctx3[1] != null && /*$activeSerie*/
        ctx3[0] != null
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$i(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$v($$self, $$props, $$invalidate) {
  let activeData;
  let $getColor;
  let $isColorActive;
  let $activeSerie;
  let $font;
  const instance2 = getInstance();
  const { chartStore, font } = instance2;
  component_subscribe($$self, font, (value) => $$invalidate(2, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$b) {
    throw new Error();
  }
  const { seriesColumn, activeSerie, data, getColor, colorColumn, isColorActive } = chartStore;
  component_subscribe($$self, activeSerie, (value) => $$invalidate(0, $activeSerie = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(8, $getColor = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(9, $isColorActive = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeSerie, $isColorActive, $getColor*/
    769) {
      $$invalidate(1, activeData = (() => {
        if (!chartStore) {
          throw new Error();
        }
        if ($activeSerie == null) {
          return null;
        }
        const record = data.find((d) => d.series === $activeSerie);
        if (!record) {
          return null;
        }
        if (!$isColorActive(record.color)) {
          return null;
        }
        let color2 = $getColor(record.color);
        let value = record.color;
        let formattedValue = colorColumn.type === "category" ? colorColumn.formatter(value) : colorColumn.formatter(value);
        return { color: color2, value, formattedValue };
      })());
    }
  };
  return [
    $activeSerie,
    activeData,
    $font,
    font,
    seriesColumn,
    activeSerie,
    getColor,
    isColorActive,
    $getColor,
    $isColorActive
  ];
}
let TooltipContent$a = class TooltipContent2 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$v, create_fragment$q, safe_not_equal, {});
  }
};
const chartType$b = "geoMap";
function flatGeoPoints(features2) {
  return features2.flatMap((feature) => {
    return feature.geometry.type === "Polygon" ? feature.geometry.coordinates.flat() : feature.geometry.coordinates.flat().flat();
  });
}
let Store$b = class Store5 {
  constructor(instance2) {
    __publicField(this, "type", chartType$b);
    __publicField(this, "option");
    __publicField(this, "data");
    __publicField(this, "canZoom");
    __publicField(this, "geoJson");
    __publicField(this, "propertyKey");
    __publicField(this, "zoom");
    __publicField(this, "seriesColumn");
    __publicField(this, "colorColumn");
    __publicField(this, "colorDomain");
    __publicField(this, "colorRange");
    __publicField(this, "getColor");
    __publicField(this, "isColorActive");
    __publicField(this, "activeSerie");
    // scale
    __publicField(this, "makeXScale");
    __publicField(this, "makeYScale");
    __publicField(this, "xScale");
    __publicField(this, "yScale");
    var _a2, _b, _c, _d;
    const {
      innerWidth,
      innerHeight,
      colorLegendActives,
      color: color2,
      focused,
      margin
    } = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    this.canZoom = (_a2 = option.canZoom) != null ? _a2 : false;
    this.geoJson = (_b = option.geoJson) != null ? _b : japanGeoJson;
    this.propertyKey = (_c = option.propertyKey) != null ? _c : "name";
    const activeSerie = writable(null);
    const seriesColumn = parseCategoryColumn({
      column: option.seriesColumn
    });
    const colorColumn = option.colorColumn.type === "category" ? parseCategoryColumn({
      column: option.colorColumn
    }) : parseValueColumn({
      column: option.colorColumn
    });
    this.colorColumn = colorColumn;
    const data = dataMapper((_d = option.data) != null ? _d : [], [
      { key: "series", column: seriesColumn },
      { key: "color", column: colorColumn }
    ]).filter(
      (x2, i2, self2) => i2 === self2.findIndex((y2) => x2.series === y2.series)
    );
    this.data = data;
    const { colorDomain, colorRange, getColor, isColorActive } = parseColorUtils({ colorColumn, data, instance: instance2 });
    const zoom = writable(null);
    this.zoom = zoom;
    const makeXScale = derived(
      [innerWidth, zoom],
      ([innerWidth2, zoom2]) => (args) => {
        if (zoom2) {
          return linear().domain([zoom2.xmin, zoom2.xmax]).range([0, innerWidth2]);
        }
        return linear().domain([0, 1]).range([0, innerWidth2]);
      }
    );
    const xScale = derived(
      [makeXScale, margin],
      ([makeXScale2, margin2]) => makeXScale2({ margin: margin2 })
    );
    const makeYScale = derived(
      [innerHeight, zoom],
      ([innerHeight2, zoom2]) => (args) => {
        if (zoom2) {
          return linear().domain([zoom2.ymin, zoom2.ymax]).range([0, innerHeight2]);
        }
        return linear().domain([0, 1]).range([0, innerHeight2]);
      }
    );
    const yScale = derived(
      [makeYScale, margin],
      ([makeYScale2, margin2]) => makeYScale2({ margin: margin2 })
    );
    this.makeXScale = makeXScale;
    this.makeYScale = makeYScale;
    this.xScale = xScale;
    this.yScale = yScale;
    this.colorDomain = colorDomain;
    this.colorRange = colorRange;
    this.getColor = getColor;
    this.isColorActive = isColorActive;
    this.option = option;
    this.seriesColumn = seriesColumn;
    this.activeSerie = activeSerie;
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$b);
      instance2.tooltipContent.set(TooltipContent$a);
    });
  }
};
const index$a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$b,
  chartType: chartType$b,
  flatGeoPoints
}, Symbol.toStringTag, { value: "Module" }));
function instance$b($$self, $$props, $$invalidate) {
  let $yScale;
  let $xScale;
  let $layout;
  let $font;
  let $focused;
  let $getColor;
  let $isColorActive;
  const { focused, focusable, chartStore, contentShapes, font } = getInstance();
  component_subscribe($$self, focused, (value) => $$invalidate(12, $focused = value));
  component_subscribe($$self, font, (value) => $$invalidate(11, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$a) {
    throw new Error();
  }
  const { xDomain, yDomain, xScale, yScale, getColor, isColorActive, activeX, activeY, data, colorColumn, isFocused, toggleFocused, layout } = chartStore;
  component_subscribe($$self, xScale, (value) => $$invalidate(9, $xScale = value));
  component_subscribe($$self, yScale, (value) => $$invalidate(8, $yScale = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(13, $getColor = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(14, $isColorActive = value));
  component_subscribe($$self, layout, (value) => $$invalidate(10, $layout = value));
  let g;
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*g, $xScale, $isColorActive, $yScale, $getColor, $layout, $focused, $font*/
    32640) {
      {
        $$invalidate(7, g = new GroupShape({ children: [] }));
        xDomain.forEach((x2, i2) => {
          var _a2;
          const rowGroup = new GroupShape({ children: [] });
          g.$shapeProps.children.push(rowGroup);
          const xPos = ((_a2 = $xScale(x2)) != null ? _a2 : 0) - $xScale.step() / 2;
          yDomain.forEach((y2, j) => {
            var _a3;
            const record = data.find((d) => d.x === x2 && d.y === y2);
            if (!record) {
              return;
            }
            if (!$isColorActive(record.color)) {
              return;
            }
            const yPos = ((_a3 = $yScale(y2)) != null ? _a3 : 0) - $yScale.step() / 2;
            const color2 = $getColor(record.color);
            const rect = new RectShape({
              x: $layout === "vertical" ? xPos : yPos,
              y: $layout === "vertical" ? yPos : xPos,
              width: $layout === "vertical" ? $xScale.step() : $yScale.step(),
              height: $layout === "vertical" ? $yScale.step() : $xScale.step(),
              padding: 1,
              clickable: true,
              hoverable: true,
              focused: derived([focused], ([$focused2]) => {
                return isFocused($focused2, x2, y2);
              }),
              hovered: derived([activeX, activeY], ([$activeX, $activeY]) => {
                return $activeX === x2 && $activeY === y2;
              }),
              inactive: derived([focused], ([$focused2]) => {
                return !isFocused($focused2, x2, y2) && $focused2.length > 0;
              }),
              events: {
                click: derived([focusable], ([$focusable]) => () => {
                  if ($focusable) {
                    toggleFocused($focused, x2, y2);
                  }
                }),
                mouseenter: readable(() => {
                  activeX.set(x2);
                  activeY.set(y2);
                }),
                mouseleave: readable(() => {
                  activeX.set(null);
                  activeY.set(null);
                })
              },
              props: readable({ fill: color2 })
            });
            const text2 = new TextShape({
              fontSize: $font.size,
              fontFamily: $font.family || DEFAULT_FONT_FAMILY,
              x: $layout === "vertical" ? xPos + $xScale.step() / 2 : yPos + $yScale.step() / 2,
              y: $layout === "vertical" ? yPos + $yScale.step() / 2 : xPos + $xScale.step() / 2,
              textAlign: "center",
              textBaseline: "middle",
              inactive: derived([focused], ([$focused2]) => {
                return !isFocused($focused2, x2, y2) && $focused2.length > 0;
              }),
              text: colorColumn.type === "value" ? colorColumn.formatter(record.color) : colorColumn.formatter(record.color),
              backgroundColor: color2,
              width: $xScale.step(),
              height: $yScale.step()
            });
            rowGroup.$shapeProps.children.push(rect);
            rowGroup.$shapeProps.children.push(text2);
          });
        });
      }
    }
    if ($$self.$$.dirty & /*g*/
    128) {
      {
        contentShapes.set([g]);
      }
    }
  };
  return [
    focused,
    font,
    xScale,
    yScale,
    getColor,
    isColorActive,
    layout,
    g,
    $yScale,
    $xScale,
    $layout,
    $font,
    $focused,
    $getColor,
    $isColorActive
  ];
}
class Panels extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$b, null, safe_not_equal, {});
  }
}
function create_fragment$p(ctx2) {
  let panels;
  let current;
  panels = new Panels({});
  return {
    c() {
      create_component(panels.$$.fragment);
    },
    m(target, anchor) {
      mount_component(panels, target, anchor);
      current = true;
    },
    p: noop$2,
    i(local) {
      if (current)
        return;
      transition_in(panels.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(panels.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(panels, detaching);
    }
  };
}
function instance_1$u($$self, $$props, $$invalidate) {
  let $getColor;
  let $layout;
  let $chartWidth;
  let $chartHeight;
  let $mousePosition;
  let $activeY;
  let $activeX;
  const instance2 = getInstance();
  const { mousePosition, tooltipPosition, tooltipShown, chartWidth, chartHeight, xAxisConfig, yAxisConfig, chartStore, colorLegendConfig } = instance2;
  component_subscribe($$self, mousePosition, (value) => $$invalidate(11, $mousePosition = value));
  component_subscribe($$self, chartWidth, (value) => $$invalidate(9, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(10, $chartHeight = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$a) {
    throw new Error();
  }
  const { option: heatMapChartOption, activeX, activeY, xDomain, yDomain, xColumn, yColumn, colorColumn, colorRange, colorDomain, isColorActive, getColor, layout } = chartStore;
  component_subscribe($$self, activeX, (value) => $$invalidate(13, $activeX = value));
  component_subscribe($$self, activeY, (value) => $$invalidate(12, $activeY = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(7, $getColor = value));
  component_subscribe($$self, layout, (value) => $$invalidate(8, $layout = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeX, $activeY, $mousePosition*/
    14336) {
      {
        if ($activeX != null && $activeY != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty & /*$layout, $chartWidth, $chartHeight*/
    1792) {
      {
        const xAxis = ({ margin }) => {
          var _a2, _b, _c, _d, _e, _f;
          const xScale = point$1().padding(0.5).domain(xDomain).range($layout === "vertical" ? [margin.left, $chartWidth - margin.right] : [$chartHeight - margin.bottom, margin.top]);
          return new CategoryAxisConfig({
            show: (_b = (_a2 = heatMapChartOption.xAxis) == null ? void 0 : _a2.show) != null ? _b : true,
            showTitle: (_d = (_c = heatMapChartOption == null ? void 0 : heatMapChartOption.xAxis) == null ? void 0 : _c.showTitle) != null ? _d : false,
            showTicks: (_f = (_e = heatMapChartOption == null ? void 0 : heatMapChartOption.xAxis) == null ? void 0 : _e.showTicks) != null ? _f : true,
            title: xColumn.title,
            step: 0,
            ticks: xDomain.map((tick2) => {
              var _a3;
              return {
                value: tick2,
                label: xColumn.formatter(tick2),
                pos: (_a3 = xScale(tick2)) != null ? _a3 : 0
              };
            })
          });
        };
        const yAxis = ({ margin }) => {
          var _a2, _b, _c, _d, _e, _f;
          const yScale = point$1().padding(0.5).domain(yDomain).range($layout === "vertical" ? [$chartHeight - margin.bottom, margin.top] : [margin.left, $chartWidth - margin.right]);
          return new CategoryAxisConfig({
            show: (_b = (_a2 = heatMapChartOption.yAxis) == null ? void 0 : _a2.show) != null ? _b : true,
            showTitle: (_d = (_c = heatMapChartOption == null ? void 0 : heatMapChartOption.yAxis) == null ? void 0 : _c.showTitle) != null ? _d : false,
            showTicks: (_f = (_e = heatMapChartOption == null ? void 0 : heatMapChartOption.yAxis) == null ? void 0 : _e.showTicks) != null ? _f : true,
            title: yColumn.title,
            step: 0,
            ticks: yDomain.map((tick2) => {
              var _a3;
              return {
                value: tick2,
                label: yColumn.formatter(tick2),
                pos: (_a3 = yScale(tick2)) != null ? _a3 : 0
              };
            })
          });
        };
        xAxisConfig.set($layout === "vertical" ? xAxis : yAxis);
        yAxisConfig.set($layout === "vertical" ? yAxis : xAxis);
      }
    }
    if ($$self.$$.dirty & /*$getColor*/
    128) {
      {
        if (colorColumn.type === "value") {
          colorLegendConfig.set({
            show: true,
            type: "value",
            column: colorColumn,
            min: colorRange[0],
            max: colorRange[1],
            getColor: (value) => $getColor(value * (colorRange[1] - colorRange[0]) + colorRange[0])
          });
        } else if (colorColumn.type === "category") {
          colorLegendConfig.set({
            show: true,
            type: "category",
            formatter: colorColumn.formatter,
            domain: colorDomain,
            getColor: (value) => $getColor(value)
          });
        }
      }
    }
  };
  return [
    mousePosition,
    chartWidth,
    chartHeight,
    activeX,
    activeY,
    getColor,
    layout,
    $getColor,
    $layout,
    $chartWidth,
    $chartHeight,
    $mousePosition,
    $activeY,
    $activeX
  ];
}
let Content$a = class Content7 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$u, create_fragment$p, safe_not_equal, {});
  }
};
function create_if_block$h(ctx2) {
  let div2;
  let div0;
  let t0_value = (
    /*xColumn*/
    ctx2[3].formatter(
      /*$activeX*/
      ctx2[1]
    ) + ""
  );
  let t0;
  let t1;
  let t2_value = (
    /*yColumn*/
    ctx2[4].formatter(
      /*$activeY*/
      ctx2[0]
    ) + ""
  );
  let t2;
  let t3;
  let div1;
  let t4_value = (
    /*colorColumn*/
    (ctx2[5].type === "value" ? (
      /*colorColumn*/
      ctx2[5].formatter(
        /*activeValue*/
        ctx2[2].color
      )
    ) : (
      /*colorColumn*/
      ctx2[5].formatter(
        /*activeValue*/
        ctx2[2].color
      )
    )) + ""
  );
  let t4;
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      t0 = text(t0_value);
      t1 = space();
      t2 = text(t2_value);
      t3 = space();
      div1 = element("div");
      t4 = text(t4_value);
      attr(div0, "style", tooltipItemLabel);
      attr(div1, "style", tooltipItemValue);
      attr(div2, "style", tooltipOuter.toString());
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append$2(div2, div0);
      append$2(div0, t0);
      append$2(div0, t1);
      append$2(div0, t2);
      append$2(div2, t3);
      append$2(div2, div1);
      append$2(div1, t4);
    },
    p(ctx3, dirty) {
      if (dirty & /*$activeX*/
      2 && t0_value !== (t0_value = /*xColumn*/
      ctx3[3].formatter(
        /*$activeX*/
        ctx3[1]
      ) + ""))
        set_data(t0, t0_value);
      if (dirty & /*$activeY*/
      1 && t2_value !== (t2_value = /*yColumn*/
      ctx3[4].formatter(
        /*$activeY*/
        ctx3[0]
      ) + ""))
        set_data(t2, t2_value);
      if (dirty & /*activeValue*/
      4 && t4_value !== (t4_value = /*colorColumn*/
      (ctx3[5].type === "value" ? (
        /*colorColumn*/
        ctx3[5].formatter(
          /*activeValue*/
          ctx3[2].color
        )
      ) : (
        /*colorColumn*/
        ctx3[5].formatter(
          /*activeValue*/
          ctx3[2].color
        )
      )) + ""))
        set_data(t4, t4_value);
    },
    d(detaching) {
      if (detaching) {
        detach(div2);
      }
    }
  };
}
function create_fragment$o(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*activeValue*/
    ctx2[2] != null && /*$activeX*/
    ctx2[1] != null && /*$activeY*/
    ctx2[0] != null && create_if_block$h(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*activeValue*/
        ctx3[2] != null && /*$activeX*/
        ctx3[1] != null && /*$activeY*/
        ctx3[0] != null
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$h(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$t($$self, $$props, $$invalidate) {
  let activeValue;
  let $isColorActive;
  let $activeY;
  let $activeX;
  const instance2 = getInstance();
  const { chartStore } = instance2;
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$a) {
    throw new Error();
  }
  const { xColumn, yColumn, colorColumn, data, activeX, activeY, isColorActive } = chartStore;
  component_subscribe($$self, activeX, (value) => $$invalidate(1, $activeX = value));
  component_subscribe($$self, activeY, (value) => $$invalidate(0, $activeY = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(9, $isColorActive = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeX, $activeY, $isColorActive*/
    515) {
      $$invalidate(2, activeValue = (() => {
        if ($activeX == null || $activeY == null) {
          return null;
        }
        const record = data.find((d) => d.x === $activeX && d.y === $activeY);
        if (!record) {
          return null;
        }
        if (!$isColorActive(record.color)) {
          return null;
        }
        return record;
      })());
    }
  };
  return [
    $activeY,
    $activeX,
    activeValue,
    xColumn,
    yColumn,
    colorColumn,
    activeX,
    activeY,
    isColorActive,
    $isColorActive
  ];
}
let TooltipContent$9 = class TooltipContent3 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$t, create_fragment$o, safe_not_equal, {});
  }
};
const chartType$a = "heatMap";
let Store$a = class Store6 {
  constructor(instance2) {
    __publicField(this, "type", chartType$a);
    __publicField(this, "option");
    __publicField(this, "data");
    __publicField(this, "layout");
    __publicField(this, "xColumn");
    __publicField(this, "yColumn");
    __publicField(this, "colorColumn");
    __publicField(this, "colorDomain");
    __publicField(this, "colorRange");
    __publicField(this, "getColor");
    __publicField(this, "isColorActive");
    __publicField(this, "activeX");
    __publicField(this, "activeY");
    __publicField(this, "xDomain");
    __publicField(this, "yDomain");
    __publicField(this, "xScale");
    __publicField(this, "yScale");
    __publicField(this, "isFocused");
    __publicField(this, "toggleFocused");
    var _a2, _b;
    const { chartWidth, chartHeight, margin, focused } = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    const activeX = writable(null);
    const activeY = writable(null);
    const layout = writable((_a2 = option.layout) != null ? _a2 : "vertical");
    this.layout = layout;
    const xColumn = parseCategoryColumn({
      column: option.xColumn
    });
    const yColumn = parseCategoryColumn({
      column: option.yColumn
    });
    const colorColumn = option.colorColumn.type === "category" ? parseCategoryColumn({
      column: option.colorColumn
    }) : parseValueColumn({
      column: option.colorColumn
    });
    const data = dataMapper((_b = option.data) != null ? _b : [], [
      { key: "x", column: xColumn },
      { key: "y", column: yColumn },
      { key: "color", column: colorColumn }
    ]).filter(
      (x2, i2, self2) => i2 === self2.findIndex((y2) => x2.x === y2.x && x2.y === y2.y)
    );
    const xDomain = [
      ...xColumn.domain || new Group(data, (row) => row.x).keys()
    ];
    const valueByXDomain = /* @__PURE__ */ new Map();
    xDomain.forEach((x2) => {
      let total = 0;
      data.forEach((record) => {
        if (record.x === x2) {
          total += asValidNumber(record.y);
        }
      });
      valueByXDomain.set(x2, total);
    });
    sortDomain({
      column: xColumn,
      valueByDomain: valueByXDomain,
      domain: xDomain
    });
    const yDomain = [
      ...yColumn.domain || new Group(data, (row) => row.y).keys()
    ];
    const valueByYDomain = /* @__PURE__ */ new Map();
    yDomain.forEach((x2) => {
      let total = 0;
      data.forEach((record) => {
        if (record.x === x2) {
          total += asValidNumber(record.y);
        }
      });
      valueByYDomain.set(x2, total);
    });
    sortDomain({
      column: yColumn,
      valueByDomain: valueByYDomain,
      domain: yDomain
    });
    const xScale = derived(
      [margin, chartWidth, chartHeight, layout],
      ([margin2, chartWidth2, chartHeight2, layout2]) => {
        return point$1().padding(0.5).domain(xDomain).range(
          layout2 === "vertical" ? [margin2.left, chartWidth2 - margin2.right] : [chartHeight2 - margin2.bottom, margin2.top]
        );
      }
    );
    const yScale = derived(
      [margin, chartWidth, chartHeight, layout],
      ([margin2, chartWidth2, chartHeight2, layout2]) => {
        return point$1().padding(0.5).domain(yDomain).range(
          layout2 === "vertical" ? [chartHeight2 - margin2.bottom, margin2.top] : [margin2.left, chartWidth2 - margin2.right]
        );
      }
    );
    function isFocused($focused, x2, y2) {
      return $focused.some(
        (focused2) => focused2[xColumn.key] === x2 && focused2[yColumn.key] === y2
      );
    }
    function toggleFocused($focused, x2, y2) {
      if (isFocused($focused, x2, y2)) {
        focused.update((focused2) => {
          return focused2.filter(
            (focused3) => !(focused3[xColumn.key] === x2 && focused3[yColumn.key] === y2)
          );
        });
      } else {
        focused.update((focused2) => {
          return [
            ...focused2,
            {
              [xColumn.key]: x2,
              [yColumn.key]: y2
            }
          ];
        });
      }
    }
    this.option = option;
    this.xColumn = xColumn;
    this.yColumn = yColumn;
    this.colorColumn = colorColumn;
    this.data = data;
    this.xDomain = xDomain;
    this.yDomain = yDomain;
    this.xScale = xScale;
    this.yScale = yScale;
    this.activeX = activeX;
    this.activeY = activeY;
    this.isFocused = isFocused;
    this.toggleFocused = toggleFocused;
    const { colorDomain, colorRange, getColor, isColorActive } = parseColorUtils({ colorColumn, data, instance: instance2 });
    this.colorDomain = colorDomain;
    this.colorRange = colorRange;
    this.getColor = getColor;
    this.isColorActive = isColorActive;
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$a);
      instance2.tooltipContent.set(TooltipContent$9);
    });
    instance2.tableConfig.set({
      columns: [
        {
          ...xColumn,
          key: "x",
          type: "dimension",
          align: "left"
        },
        {
          ...yColumn,
          key: "y",
          type: "dimension",
          align: "left"
        },
        {
          ...colorColumn,
          key: "value",
          type: "metric",
          align: "right"
        }
      ],
      data: data.map((d) => {
        return {
          x: d.x,
          y: d.y,
          value: d.color
        };
      })
    });
  }
};
const index$9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$a,
  chartType: chartType$a
}, Symbol.toStringTag, { value: "Module" }));
function instance$a($$self, $$props, $$invalidate) {
  let groups;
  let $font;
  let $label;
  let $yScale, $$unsubscribe_yScale = noop$2, $$subscribe_yScale = () => ($$unsubscribe_yScale(), $$unsubscribe_yScale = subscribe(yScale, ($$value) => $$invalidate(17, $yScale = $$value)), yScale);
  let $margin;
  let $chartHeight;
  let $layout;
  let $getColor;
  let $isColorActive;
  let $xScale;
  let $innerWidth;
  let $innerHeight;
  $$self.$$.on_destroy.push(() => $$unsubscribe_yScale());
  const { innerWidth, innerHeight, chartWidth, chartHeight, margin, focused, label, chartStore, contentShapes, font, focusable } = getInstance();
  component_subscribe($$self, innerWidth, (value) => $$invalidate(24, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(25, $innerHeight = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(19, $chartHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(18, $margin = value));
  component_subscribe($$self, label, (value) => $$invalidate(16, $label = value));
  component_subscribe($$self, font, (value) => $$invalidate(15, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$9) {
    throw new Error();
  }
  let { yColumn } = $$props;
  let { yScale } = $$props;
  $$subscribe_yScale();
  let { yKey } = $$props;
  let { setShapes } = $$props;
  const { xDomain, xScale, seriesDomain, hoveredX, hoveredSeries, isFocused, xColumn, seriesColumn, colorUtils: { getColor, isColorActive }, data, layout, barPadding } = chartStore;
  component_subscribe($$self, xScale, (value) => $$invalidate(23, $xScale = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(21, $getColor = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(22, $isColorActive = value));
  component_subscribe($$self, layout, (value) => $$invalidate(20, $layout = value));
  $$self.$$set = ($$props2) => {
    if ("yColumn" in $$props2)
      $$invalidate(11, yColumn = $$props2.yColumn);
    if ("yScale" in $$props2)
      $$subscribe_yScale($$invalidate(0, yScale = $$props2.yScale));
    if ("yKey" in $$props2)
      $$invalidate(12, yKey = $$props2.yKey);
    if ("setShapes" in $$props2)
      $$invalidate(13, setShapes = $$props2.setShapes);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$layout, $xScale, $margin, $innerHeight, $innerWidth, $isColorActive, yKey, $getColor, $chartHeight, $yScale, yColumn, $label, $font*/
    67082240) {
      $$invalidate(14, groups = (() => {
        const groups2 = xDomain.map((x2, xIndex) => {
          var _a2, _b;
          const xShape = new RectShape({
            ...$layout === "vertical" ? {
              x: ((_a2 = $xScale(x2)) != null ? _a2 : 0) - $xScale.step() / 2,
              y: $margin.top,
              width: $xScale.step(),
              height: $innerHeight
            } : {
              x: $margin.left,
              y: ((_b = $xScale(x2)) != null ? _b : 0) - $xScale.step() / 2,
              width: $innerWidth,
              height: $xScale.step()
            },
            data: { x: x2 },
            hoverable: true,
            priority: readable(10),
            events: {
              mouseenter: readable(() => {
                hoveredX.set(x2);
              }),
              mouseleave: readable(() => {
                hoveredX.set(null);
              })
            },
            props: readable({ fill: "transparent" })
          });
          const scale = xColumn.key === seriesColumn.key ? band().padding(barPadding).domain([x2]).range([0, $xScale.step()]) : band().padding(barPadding).domain(seriesDomain).range([0, $xScale.step()]);
          return new GroupShape({
            children: [
              xShape,
              ...seriesDomain.flatMap((series, seriesIndex) => {
                var _a3, _b2, _c, _d, _e;
                const record = data.find((d) => d.x === x2 && d.series === series);
                if (!record) {
                  return [];
                }
                if (!$isColorActive(record.color)) {
                  return [];
                }
                const value = record[yKey];
                const color2 = $getColor(record.color);
                if (value === 0) {
                  return [];
                }
                const seriesShape = new RectShape({
                  ...$layout === "vertical" ? {
                    x: xShape.$shapeProps.x + ((_a3 = scale(series)) != null ? _a3 : 0),
                    width: scale.bandwidth(),
                    ...computeHeight$1({
                      y1: $chartHeight - $margin.bottom,
                      y2: $yScale(value)
                    })
                  } : {
                    y: xShape.$shapeProps.y + ((_b2 = scale(series)) != null ? _b2 : 0),
                    height: scale.bandwidth(),
                    ...computeWidth({ x1: $margin.left, x2: $yScale(value) })
                  },
                  data: { x: x2, series },
                  clickable: true,
                  hoverable: true,
                  priority: readable(100),
                  events: {
                    click: derived([focusable], ([$focusable]) => () => {
                      if ($focusable) {
                        focused.update(($focused) => {
                          if (isFocused($focused, x2, series)) {
                            return $focused.filter((focused2) => !(focused2[xColumn.key] === x2 && focused2[seriesColumn.key] === series));
                          } else {
                            return [
                              ...$focused,
                              {
                                [xColumn.key]: x2,
                                [seriesColumn.key]: series
                              }
                            ];
                          }
                        });
                      }
                    }),
                    mouseenter: readable(() => {
                      hoveredX.set(x2);
                      hoveredSeries.set(series);
                    }),
                    mouseleave: readable(() => {
                      hoveredX.set(null);
                      hoveredSeries.set(null);
                    })
                  },
                  hovered: derived([hoveredX, hoveredSeries], ([$hoveredX, $hoveredSeries]) => {
                    return $hoveredX === x2 && $hoveredSeries === series;
                  }),
                  focused: derived([focused], ([$focused]) => {
                    return isFocused($focused, x2, series);
                  }),
                  inactive: derived([focused], ([$focused]) => {
                    const active = isFocused($focused, x2, series);
                    return $focused.length > 0 && !active;
                  }),
                  props: readable({ fill: color2 })
                });
                const valueAsText = yColumn.formatter(value);
                const labelShape = new TextShape({
                  text: valueAsText,
                  x: seriesShape.$shapeProps.x + seriesShape.$shapeProps.width / 2,
                  y: seriesShape.$shapeProps.y + seriesShape.$shapeProps.height / 2,
                  width: seriesShape.$shapeProps.width,
                  height: seriesShape.$shapeProps.height,
                  backgroundColor: color2,
                  textAlign: "center",
                  textBaseline: "middle",
                  inactive: derived([focused], ([$focused]) => {
                    const active = isFocused($focused, x2, series);
                    return $focused.length > 0 && !active;
                  }),
                  fontSize: (_d = (_c = $label.font) == null ? void 0 : _c.size) != null ? _d : $font.size,
                  fontFamily: ((_e = $label.font) == null ? void 0 : _e.family) || $font.family || DEFAULT_FONT_FAMILY
                });
                return [seriesShape, labelShape];
              })
            ]
          });
        });
        return groups2;
      })());
    }
    if ($$self.$$.dirty[0] & /*setShapes, groups*/
    24576) {
      {
        setShapes(groups);
      }
    }
  };
  return [
    yScale,
    innerWidth,
    innerHeight,
    chartHeight,
    margin,
    label,
    font,
    xScale,
    getColor,
    isColorActive,
    layout,
    yColumn,
    yKey,
    setShapes,
    groups,
    $font,
    $label,
    $yScale,
    $margin,
    $chartHeight,
    $layout,
    $getColor,
    $isColorActive,
    $xScale,
    $innerWidth,
    $innerHeight
  ];
}
let Bar$1 = class Bar3 extends SvelteComponent {
  constructor(options) {
    super();
    init(
      this,
      options,
      instance$a,
      null,
      safe_not_equal,
      {
        yColumn: 11,
        yScale: 0,
        yKey: 12,
        setShapes: 13
      },
      null,
      [-1, -1]
    );
  }
};
function instance$9($$self, $$props, $$invalidate) {
  let scale;
  let groups;
  let $font;
  let $label;
  let $percent;
  let $yScale, $$unsubscribe_yScale = noop$2, $$subscribe_yScale = () => ($$unsubscribe_yScale(), $$unsubscribe_yScale = subscribe(yScale, ($$value) => $$invalidate(20, $yScale = $$value)), yScale);
  let $layout;
  let $getColor;
  let $total;
  let $isColorActive;
  let $xScale;
  let $innerWidth;
  let $margin;
  let $innerHeight;
  $$self.$$.on_destroy.push(() => $$unsubscribe_yScale());
  const { innerWidth, chartWidth, innerHeight, chartHeight, margin, focused, chartStore, contentShapes, label, font, focusable } = getInstance();
  component_subscribe($$self, innerWidth, (value) => $$invalidate(26, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(28, $innerHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(27, $margin = value));
  component_subscribe($$self, label, (value) => $$invalidate(18, $label = value));
  component_subscribe($$self, font, (value) => $$invalidate(17, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$9) {
    throw new Error();
  }
  let { yColumn } = $$props;
  let { yScale } = $$props;
  $$subscribe_yScale();
  let { yKey } = $$props;
  let { setShapes } = $$props;
  const { data, percent, xDomain, xScale, seriesDomain, total, hoveredX, hoveredSeries, isFocused, xColumn, seriesColumn, colorUtils: { getColor, isColorActive }, layout, barPadding } = chartStore;
  component_subscribe($$self, percent, (value) => $$invalidate(19, $percent = value));
  component_subscribe($$self, xScale, (value) => $$invalidate(25, $xScale = value));
  component_subscribe($$self, total, (value) => $$invalidate(23, $total = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(22, $getColor = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(24, $isColorActive = value));
  component_subscribe($$self, layout, (value) => $$invalidate(21, $layout = value));
  $$self.$$set = ($$props2) => {
    if ("yColumn" in $$props2)
      $$invalidate(12, yColumn = $$props2.yColumn);
    if ("yScale" in $$props2)
      $$subscribe_yScale($$invalidate(0, yScale = $$props2.yScale));
    if ("yKey" in $$props2)
      $$invalidate(13, yKey = $$props2.yKey);
    if ("setShapes" in $$props2)
      $$invalidate(14, setShapes = $$props2.setShapes);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$xScale*/
    33554432) {
      $$invalidate(16, scale = band().padding(barPadding).domain(["0"]).range([0, $xScale.step()]));
    }
    if ($$self.$$.dirty[0] & /*$total, $layout, $xScale, $margin, $innerHeight, $innerWidth, $isColorActive, yKey, $percent, $getColor, scale, $yScale, yColumn, $label, $font*/
    536817664) {
      $$invalidate(15, groups = (() => {
        const groups2 = xDomain.map((x2, xIndex) => {
          var _a2, _b;
          const t2 = $total({ x: x2 });
          const xShape = new RectShape({
            ...$layout === "vertical" ? {
              x: ((_a2 = $xScale(x2)) != null ? _a2 : 0) - $xScale.step() / 2,
              y: $margin.top,
              width: $xScale.step(),
              height: $innerHeight
            } : {
              x: $margin.left,
              y: ((_b = $xScale(x2)) != null ? _b : 0) - $xScale.step() / 2,
              width: $innerWidth,
              height: $xScale.step()
            },
            data: { x: x2 },
            hoverable: true,
            events: {
              mouseenter: readable(() => {
                hoveredX.set(x2);
              }),
              mouseleave: readable(() => {
                hoveredX.set(null);
              })
            },
            priority: readable(10),
            props: readable({ fill: "transparent" })
          });
          let prev2 = 0;
          return new GroupShape({
            children: [
              xShape,
              ...seriesDomain.flatMap((name, seriesIndex) => {
                var _a3, _b2, _c, _d, _e, _f;
                const record = data.find((d) => d.x === x2 && d.series === name);
                if (!record) {
                  return [];
                }
                if (!$isColorActive(record.color)) {
                  return [];
                }
                const currentValue = prev2 + asValidNumber(record[yKey]);
                const prevValue = prev2;
                prev2 += record[yKey];
                const value = asValidNumber($percent ? $total({ x: x2, name }) / t2 : $total({ x: x2, name }));
                const color2 = $getColor(record.color);
                const seriesShape = new RectShape({
                  ...$layout === "vertical" ? {
                    x: xShape.$shapeProps.x + ((_a3 = scale("0")) != null ? _a3 : 0),
                    width: scale.bandwidth(),
                    ...computeHeight$1({
                      y1: $yScale(asValidNumber($percent ? currentValue / t2 : currentValue)),
                      y2: $yScale(asValidNumber($percent ? prevValue / t2 : prevValue))
                    })
                  } : {
                    y: xShape.$shapeProps.y + ((_b2 = scale("0")) != null ? _b2 : 0),
                    height: scale.bandwidth(),
                    ...computeWidth({
                      x1: $yScale(asValidNumber($percent ? currentValue / t2 : currentValue)),
                      x2: $yScale(asValidNumber($percent ? prevValue / t2 : prevValue))
                    })
                  },
                  data: { x: x2, name },
                  clickable: true,
                  hoverable: true,
                  priority: readable(100),
                  hovered: derived([hoveredX, hoveredSeries], ([$hoveredX, $hoveredSeries]) => $hoveredX === x2 && $hoveredSeries === name),
                  focused: derived([focused], ([$focused]) => {
                    return isFocused($focused, x2, name);
                  }),
                  inactive: derived([focused], ([$focused]) => {
                    const active = isFocused($focused, x2, name);
                    return $focused.length > 0 && !active;
                  }),
                  events: {
                    click: derived([focusable], ([$focusable]) => () => {
                      if ($focusable) {
                        focused.update(($focused) => {
                          if (isFocused($focused, x2, name)) {
                            return $focused.filter((focused2) => !(focused2[xColumn.key] === x2 && focused2[seriesColumn.key] === name));
                          } else {
                            return [
                              ...$focused,
                              {
                                [xColumn.key]: x2,
                                [seriesColumn.key]: name
                              }
                            ];
                          }
                        });
                      }
                    }),
                    mouseenter: readable(() => {
                      hoveredX.set(x2);
                      hoveredSeries.set(name);
                    }),
                    mouseleave: readable(() => {
                      hoveredX.set(null);
                      hoveredSeries.set(null);
                    })
                  },
                  props: readable({ fill: color2 })
                });
                return [
                  seriesShape,
                  new TextShape({
                    text: yColumn.formatter(value),
                    x: seriesShape.$shapeProps.x + seriesShape.$shapeProps.width / 2,
                    y: seriesShape.$shapeProps.y + seriesShape.$shapeProps.height / 2,
                    width: seriesShape.$shapeProps.width,
                    height: seriesShape.$shapeProps.height,
                    textAlign: "center",
                    textBaseline: "middle",
                    inactive: derived([focused], ([$focused]) => {
                      const active = isFocused($focused, x2, name);
                      return $focused.length > 0 && !active;
                    }),
                    backgroundColor: color2,
                    fontSize: (_d = (_c = $label.font) == null ? void 0 : _c.size) != null ? _d : $font.size,
                    fontFamily: (_f = ((_e = $label.font) == null ? void 0 : _e.family) || $font.family) != null ? _f : DEFAULT_FONT_FAMILY
                  })
                ];
              })
            ]
          });
        });
        return groups2;
      })());
    }
    if ($$self.$$.dirty[0] & /*setShapes, groups*/
    49152) {
      {
        setShapes(groups);
      }
    }
  };
  return [
    yScale,
    innerWidth,
    innerHeight,
    margin,
    label,
    font,
    percent,
    xScale,
    total,
    getColor,
    isColorActive,
    layout,
    yColumn,
    yKey,
    setShapes,
    groups,
    scale,
    $font,
    $label,
    $percent,
    $yScale,
    $layout,
    $getColor,
    $total,
    $isColorActive,
    $xScale,
    $innerWidth,
    $margin,
    $innerHeight
  ];
}
class StackBar3 extends SvelteComponent {
  constructor(options) {
    super();
    init(
      this,
      options,
      instance$9,
      null,
      safe_not_equal,
      {
        yColumn: 12,
        yScale: 0,
        yKey: 13,
        setShapes: 14
      },
      null,
      [-1, -1]
    );
  }
}
function instance_1$s($$self, $$props, $$invalidate) {
  let $xScale;
  let $yScale, $$unsubscribe_yScale = noop$2, $$subscribe_yScale = () => ($$unsubscribe_yScale(), $$unsubscribe_yScale = subscribe(yScale, ($$value) => $$invalidate(12, $yScale = $$value)), yScale);
  let $layout;
  let $innerWidth;
  let $margin;
  let $innerHeight;
  $$self.$$.on_destroy.push(() => $$unsubscribe_yScale());
  const instance2 = getInstance();
  const { innerWidth, innerHeight, margin, focused, chartStore, contentShapes, focusable } = instance2;
  component_subscribe($$self, innerWidth, (value) => $$invalidate(14, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(16, $innerHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(15, $margin = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$9) {
    throw new Error();
  }
  let { yColumn } = $$props;
  let { yScale } = $$props;
  $$subscribe_yScale();
  let { yKey } = $$props;
  let { setShapes } = $$props;
  const { option, data, xDomain, xScale, hoveredX, hoveredSeries, isFocused, toggleFocused, layout } = chartStore;
  component_subscribe($$self, xScale, (value) => $$invalidate(11, $xScale = value));
  component_subscribe($$self, layout, (value) => $$invalidate(13, $layout = value));
  let shapes;
  let rects;
  $$self.$$set = ($$props2) => {
    if ("yColumn" in $$props2)
      $$invalidate(6, yColumn = $$props2.yColumn);
    if ("yScale" in $$props2)
      $$subscribe_yScale($$invalidate(0, yScale = $$props2.yScale));
    if ("yKey" in $$props2)
      $$invalidate(7, yKey = $$props2.yKey);
    if ("setShapes" in $$props2)
      $$invalidate(8, setShapes = $$props2.setShapes);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$layout, $xScale, $margin, $innerHeight, $innerWidth*/
    124928) {
      {
        $$invalidate(10, rects = xDomain.map((x2) => {
          var _a2, _b;
          return new RectShape({
            data: { x: x2 },
            ...$layout === "vertical" ? {
              x: ((_a2 = $xScale(x2)) != null ? _a2 : 0) - $xScale.step() / 2,
              y: $margin.top,
              width: $xScale.step(),
              height: $innerHeight
            } : {
              x: $margin.left,
              y: ((_b = $xScale(x2)) != null ? _b : 0) - $xScale.step() / 2,
              width: $innerWidth,
              height: $xScale.step()
            },
            hoverable: true,
            events: {
              mouseenter: readable(() => {
                hoveredX.set(x2);
              }),
              mouseleave: readable(() => {
                hoveredX.set(null);
              })
            },
            props: readable({ fill: "transparent" })
          });
        }));
      }
    }
    if ($$self.$$.dirty & /*$layout, yKey, $xScale, $yScale*/
    14464) {
      (() => {
        const color2 = "#999";
        $$invalidate(9, shapes = [
          new GroupShape({
            data: {},
            children: [
              new PolylineShape({
                clickable: true,
                data: {},
                layout: $layout,
                smooth: option.smooth,
                points: xDomain.flatMap((x2) => {
                  var _a2;
                  const record = data.find((d) => d.x === x2);
                  if (!record) {
                    return [];
                  }
                  const value = record[yKey];
                  const xPos = (_a2 = $xScale(x2)) != null ? _a2 : 0;
                  const yPos = $yScale(value);
                  if ($layout === "vertical") {
                    return [[asValidNumber(xPos), asValidNumber(yPos)]];
                  }
                  return [[asValidNumber(yPos), asValidNumber(xPos)]];
                }),
                // inactive: derived([focused], ([$focused]) => {
                //     return (
                //         $focused.length > 0 &&
                //         $focused.every(
                //             (focused) =>
                //                 focused[seriesColumn.key] !== series
                //         )
                //     );
                // }),
                props: readable({
                  stroke: color2,
                  "stroke-width": "2px",
                  fill: "transparent"
                })
                // 'stroke-dasharray': 8
              }),
              ...xDomain.flatMap((x2) => {
                var _a2, _b;
                const record = data.find((d) => d.x === x2);
                if (!record) {
                  return [];
                }
                const value = record[yKey];
                const circle = new CircleShape({
                  data: { x: x2 },
                  ...$layout === "vertical" ? { cx: (_a2 = $xScale(x2)) != null ? _a2 : 0, cy: $yScale(value) } : { cx: $yScale(value), cy: (_b = $xScale(x2)) != null ? _b : 0 },
                  r: 4,
                  clickable: true,
                  // events: {
                  //     click: derived([focusable], ([$focusable]) => {
                  //         if ($focusable) {
                  //             toggleFocused(get(focused), x, series);
                  //         }
                  //     }),
                  //     mouseenter: readable(() => {
                  //         hoveredX.set(x);
                  //         hoveredSeries.set(series);
                  //     }),
                  //     mouseleave: readable(() => {
                  //         hoveredX.set(null);
                  //         hoveredSeries.set(null);
                  //     })
                  // },
                  // focused: derived([focused], ([$focused]) => {
                  //     return isFocused($focused, x, series);
                  // }),
                  // inactive: derived([focused], ([$focused]) => {
                  //     return (
                  //         !isFocused($focused, x, series) &&
                  //         $focused.length > 0
                  //     );
                  // }),
                  // hoverable: true,
                  // priority: readable(100),
                  // hovered: derived(
                  //     [hoveredX, hoveredSeries],
                  //     ([$hoveredX, $hoveredSeries]) => {
                  //         return (
                  //             $hoveredX === x &&
                  //             $hoveredSeries === series
                  //         );
                  //     }
                  // ),
                  props: readable({ fill: color2 })
                });
                return [circle];
              })
            ]
          })
        ]);
      })();
    }
    if ($$self.$$.dirty & /*setShapes, rects, shapes*/
    1792) {
      {
        setShapes([...rects, ...shapes]);
      }
    }
  };
  return [
    yScale,
    innerWidth,
    innerHeight,
    margin,
    xScale,
    layout,
    yColumn,
    yKey,
    setShapes,
    shapes,
    rects,
    $xScale,
    $yScale,
    $layout,
    $innerWidth,
    $margin,
    $innerHeight
  ];
}
class Bar4 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$s, null, safe_not_equal, {
      yColumn: 6,
      yScale: 0,
      yKey: 7,
      setShapes: 8
    });
  }
}
function create_else_block$4(ctx2) {
  let vbar;
  let current;
  vbar = new Bar$1({
    props: {
      yColumn: (
        /*yColumn*/
        ctx2[8]
      ),
      yKey: "y",
      yScale: (
        /*yScale*/
        ctx2[15]
      ),
      setShapes: (
        /*func_1*/
        ctx2[35]
      )
    }
  });
  return {
    c() {
      create_component(vbar.$$.fragment);
    },
    m(target, anchor) {
      mount_component(vbar, target, anchor);
      current = true;
    },
    p: noop$2,
    i(local) {
      if (current)
        return;
      transition_in(vbar.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(vbar.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(vbar, detaching);
    }
  };
}
function create_if_block$g(ctx2) {
  let vstackbar;
  let current;
  vstackbar = new StackBar3({
    props: {
      yColumn: (
        /*yColumn*/
        ctx2[8]
      ),
      yKey: "y",
      yScale: (
        /*yScale*/
        ctx2[15]
      ),
      setShapes: (
        /*func*/
        ctx2[34]
      )
    }
  });
  return {
    c() {
      create_component(vstackbar.$$.fragment);
    },
    m(target, anchor) {
      mount_component(vstackbar, target, anchor);
      current = true;
    },
    p: noop$2,
    i(local) {
      if (current)
        return;
      transition_in(vstackbar.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(vstackbar.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(vstackbar, detaching);
    }
  };
}
function create_fragment$n(ctx2) {
  let current_block_type_index;
  let if_block;
  let t2;
  let vline;
  let current;
  const if_block_creators = [create_if_block$g, create_else_block$4];
  const if_blocks = [];
  function select_block_type(ctx3, dirty) {
    if (
      /*$stack*/
      ctx3[0]
    )
      return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx2);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
  vline = new Bar4({
    props: {
      yColumn: (
        /*ySubColumn*/
        ctx2[10]
      ),
      yKey: "ysub",
      yScale: (
        /*ySubScale*/
        ctx2[16]
      ),
      setShapes: (
        /*func_2*/
        ctx2[36]
      )
    }
  });
  return {
    c() {
      if_block.c();
      t2 = space();
      create_component(vline.$$.fragment);
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, t2, anchor);
      mount_component(vline, target, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx3);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx3, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx3);
          if_block.c();
        } else {
          if_block.p(ctx3, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(t2.parentNode, t2);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      transition_in(vline.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      transition_out(vline.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(t2);
      }
      if_blocks[current_block_type_index].d(detaching);
      destroy_component(vline, detaching);
    }
  };
}
function instance_1$r($$self, $$props, $$invalidate) {
  let guideLines;
  let $subShapes;
  let $mainShapes;
  let $margin;
  let $chartHeight;
  let $yScale;
  let $chartWidth;
  let $layout;
  let $total;
  let $percent;
  let $stack;
  let $getColor;
  let $ySubRange;
  let $yRange;
  let $mousePosition;
  let $hoveredX;
  const instance2 = getInstance();
  const { tooltipPosition, tooltipShown, mousePosition, xAxisConfig, yAxisConfig, ySubAxisConfig, chartWidth, chartHeight, chartStore, colorLegendConfig, guideShapes, margin, contentShapes } = instance2;
  component_subscribe($$self, mousePosition, (value) => $$invalidate(32, $mousePosition = value));
  component_subscribe($$self, chartWidth, (value) => $$invalidate(25, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(23, $chartHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(22, $margin = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$9) {
    throw new Error();
  }
  const { option, layout, stack, hoveredX, seriesColumn, xColumn, xDomain, data, yColumn, yRange, ySubColumn, ySubRange, percent, colorColumn, colorUtils: { colorDomain, colorRange, getColor }, total, yScale, ySubScale } = chartStore;
  component_subscribe($$self, layout, (value) => $$invalidate(26, $layout = value));
  component_subscribe($$self, stack, (value) => $$invalidate(0, $stack = value));
  component_subscribe($$self, hoveredX, (value) => $$invalidate(33, $hoveredX = value));
  component_subscribe($$self, yRange, (value) => $$invalidate(31, $yRange = value));
  component_subscribe($$self, ySubRange, (value) => $$invalidate(30, $ySubRange = value));
  component_subscribe($$self, percent, (value) => $$invalidate(28, $percent = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(29, $getColor = value));
  component_subscribe($$self, total, (value) => $$invalidate(27, $total = value));
  component_subscribe($$self, yScale, (value) => $$invalidate(24, $yScale = value));
  const mainShapes = writable([]);
  component_subscribe($$self, mainShapes, (value) => $$invalidate(21, $mainShapes = value));
  const subShapes = writable([]);
  component_subscribe($$self, subShapes, (value) => $$invalidate(20, $subShapes = value));
  const func = (shapes) => {
    mainShapes.set(shapes);
  };
  const func_1 = (shapes) => {
    mainShapes.set(shapes);
  };
  const func_2 = (shapes) => {
    subShapes.set(shapes);
  };
  $$self.$$.update = () => {
    var _a2, _b;
    if ($$self.$$.dirty[1] & /*$hoveredX, $mousePosition*/
    6) {
      {
        if ($hoveredX != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$layout, $chartWidth, $chartHeight, $ySubRange*/
    1182793728 | $$self.$$.dirty[1] & /*$yRange*/
    1) {
      {
        const xAxis = ({ margin: margin2 }) => {
          var _a3, _b2, _c, _d, _e, _f;
          const xScale = point$1().padding(0.5).domain(xDomain).range($layout === "vertical" ? [margin2.left, $chartWidth - margin2.right] : [$chartHeight - margin2.bottom, margin2.top]);
          return new CategoryAxisConfig({
            show: (_b2 = (_a3 = option.xAxis) == null ? void 0 : _a3.show) != null ? _b2 : true,
            showTitle: (_d = (_c = option.xAxis) == null ? void 0 : _c.showTitle) != null ? _d : false,
            showTicks: (_f = (_e = option.xAxis) == null ? void 0 : _e.showTicks) != null ? _f : true,
            title: xColumn.title,
            step: xScale.step(),
            ticks: xDomain.map((tick2) => {
              var _a4;
              return {
                value: tick2,
                label: xColumn.formatter(tick2),
                pos: (_a4 = xScale(tick2)) != null ? _a4 : 0,
                active: derived([hoveredX], ([$hoveredX2]) => {
                  return $hoveredX2 === tick2;
                })
              };
            })
          });
        };
        const yAxis = ({ margin: margin2 }) => {
          var _a3, _b2, _c, _d, _e, _f;
          const yScale2 = linear().domain([$yRange[0], $yRange[1]]).range($layout === "vertical" ? [$chartHeight - margin2.bottom, margin2.top] : [margin2.left, $chartWidth - margin2.right]).nice();
          return new ValueAxisConfig({
            show: (_b2 = (_a3 = option.yAxis) == null ? void 0 : _a3.show) != null ? _b2 : true,
            showTitle: (_d = (_c = option.yAxis) == null ? void 0 : _c.showTitle) != null ? _d : false,
            showTicks: (_f = (_e = option.yAxis) == null ? void 0 : _e.showTicks) != null ? _f : true,
            title: yColumn.title,
            scale: yScale2,
            axisFormatter: yColumn.axisFormatter
          });
        };
        const ySubAxis = ({ margin: margin2 }) => {
          var _a3, _b2, _c, _d, _e, _f;
          const ySubScale2 = linear().domain([$ySubRange[0], $ySubRange[1]]).range($layout === "vertical" ? [$chartHeight - margin2.bottom, margin2.top] : [margin2.left, $chartWidth - margin2.right]).nice();
          return new ValueAxisConfig({
            show: (_b2 = (_a3 = option.yAxis) == null ? void 0 : _a3.show) != null ? _b2 : true,
            showTitle: (_d = (_c = option.yAxis) == null ? void 0 : _c.showTitle) != null ? _d : false,
            showTicks: (_f = (_e = option.yAxis) == null ? void 0 : _e.showTicks) != null ? _f : true,
            title: ySubColumn.title,
            scale: ySubScale2,
            axisFormatter: ySubColumn.axisFormatter
          });
        };
        xAxisConfig.set(xAxis);
        yAxisConfig.set(yAxis);
        ySubAxisConfig.set(ySubAxis);
      }
    }
    if ($$self.$$.dirty[0] & /*$getColor*/
    536870912) {
      {
        if (colorColumn.type === "value") {
          colorLegendConfig.set({
            show: true,
            type: "value",
            column: colorColumn,
            min: colorRange[0],
            max: colorRange[1],
            getColor: (value) => $getColor(value * (colorRange[1] - colorRange[0]) + colorRange[0])
          });
        } else if (colorColumn.type === "category") {
          colorLegendConfig.set({
            show: true,
            type: "category",
            formatter: colorColumn.formatter,
            domain: colorDomain,
            getColor: (value) => $getColor(value)
          });
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$stack, $percent, $total*/
    402653185) {
      {
        instance2.tableConfig.set({
          columns: [
            {
              ...seriesColumn,
              key: "name",
              type: "dimension",
              align: "left"
            },
            {
              ...xColumn,
              key: "x",
              type: "dimension",
              align: "left"
            },
            {
              ...yColumn,
              key: "y",
              type: "metric",
              align: "right"
            }
          ],
          data: data.map((d) => {
            var _a3;
            return {
              x: d.x,
              name: d.series,
              y: $stack && $percent ? ((_a3 = d.y) != null ? _a3 : 0) / $total({ x: d.x }) : d.y
            };
          })
        });
      }
    }
    if ($$self.$$.dirty[0] & /*$layout, $yScale, $margin, $chartWidth, $chartHeight*/
    130023424) {
      $$invalidate(19, guideLines = (_b = (_a2 = option.guideLines) == null ? void 0 : _a2.flatMap((n2) => {
        if (n2.data.yAxis != null) {
          if ($layout === "vertical") {
            return [
              new LineShape({
                y1: $yScale(n2.data.yAxis),
                y2: $yScale(n2.data.yAxis),
                x1: $margin.left,
                x2: $chartWidth - $margin.right,
                props: readable({
                  fill: "transparent",
                  stroke: "#aaa",
                  "stroke-width": 2,
                  "stroke-dasharray": "8px 8px"
                })
              })
            ];
          }
          return [
            new LineShape({
              x1: $yScale(n2.data.yAxis),
              x2: $yScale(n2.data.yAxis),
              y1: $margin.top,
              y2: $chartHeight - $margin.bottom,
              props: readable({
                fill: "transparent",
                stroke: "#aaa",
                "stroke-width": 2,
                "stroke-dasharray": "8px 8px"
              })
            })
          ];
        }
        return [];
      })) != null ? _b : []);
    }
    if ($$self.$$.dirty[0] & /*guideLines*/
    524288) {
      {
        guideShapes.set([...guideLines]);
      }
    }
    if ($$self.$$.dirty[0] & /*$mainShapes, $subShapes*/
    3145728) {
      {
        contentShapes.set([...$mainShapes, ...$subShapes]);
      }
    }
  };
  return [
    $stack,
    mousePosition,
    chartWidth,
    chartHeight,
    margin,
    layout,
    stack,
    hoveredX,
    yColumn,
    yRange,
    ySubColumn,
    ySubRange,
    percent,
    getColor,
    total,
    yScale,
    ySubScale,
    mainShapes,
    subShapes,
    guideLines,
    $subShapes,
    $mainShapes,
    $margin,
    $chartHeight,
    $yScale,
    $chartWidth,
    $layout,
    $total,
    $percent,
    $getColor,
    $ySubRange,
    $yRange,
    $mousePosition,
    $hoveredX,
    func,
    func_1,
    func_2
  ];
}
let Content$9 = class Content8 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$r, create_fragment$n, safe_not_equal, {}, null, [-1, -1]);
  }
};
function get_each_context$6(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[23] = list[i2];
  child_ctx[25] = i2;
  return child_ctx;
}
function create_if_block$f(ctx2) {
  let div2;
  let div0;
  let t0_value = (
    /*$hoveredX*/
    (ctx2[1] ? (
      /*xColumn*/
      ctx2[13].formatter(
        /*$hoveredX*/
        ctx2[1]
      )
    ) : "") + ""
  );
  let t0;
  let t1;
  let div1;
  let each_value = ensure_array_like(
    /*xColumn*/
    ctx2[13].key === /*seriesColumn*/
    ctx2[8].key ? [
      /*$hoveredX*/
      ctx2[1]
    ] : (
      /*seriesDomain*/
      ctx2[9]
    )
  );
  let each_blocks = [];
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    each_blocks[i2] = create_each_block$6(get_each_context$6(ctx2, each_value, i2));
  }
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      t0 = text(t0_value);
      t1 = space();
      div1 = element("div");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      attr(div2, "style", tooltipOuter.toString());
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append$2(div2, div0);
      append$2(div0, t0);
      append$2(div2, t1);
      append$2(div2, div1);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(div1, null);
        }
      }
    },
    p(ctx3, dirty) {
      if (dirty & /*$hoveredX*/
      2 && t0_value !== (t0_value = /*$hoveredX*/
      (ctx3[1] ? (
        /*xColumn*/
        ctx3[13].formatter(
          /*$hoveredX*/
          ctx3[1]
        )
      ) : "") + ""))
        set_data(t0, t0_value);
      if (dirty & /*yColumn, $total, $hoveredX, xColumn, seriesColumn, seriesDomain, $stack, $percent, radius, $getColor, findRecord*/
      156479) {
        each_value = ensure_array_like(
          /*xColumn*/
          ctx3[13].key === /*seriesColumn*/
          ctx3[8].key ? [
            /*$hoveredX*/
            ctx3[1]
          ] : (
            /*seriesDomain*/
            ctx3[9]
          )
        );
        let i2;
        for (i2 = 0; i2 < each_value.length; i2 += 1) {
          const child_ctx = get_each_context$6(ctx3, each_value, i2);
          if (each_blocks[i2]) {
            each_blocks[i2].p(child_ctx, dirty);
          } else {
            each_blocks[i2] = create_each_block$6(child_ctx);
            each_blocks[i2].c();
            each_blocks[i2].m(div1, null);
          }
        }
        for (; i2 < each_blocks.length; i2 += 1) {
          each_blocks[i2].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    d(detaching) {
      if (detaching) {
        detach(div2);
      }
      destroy_each(each_blocks, detaching);
    }
  };
}
function create_else_block$3(ctx2) {
  let t_value = (
    /*yColumn*/
    ctx2[14].formatter(
      /*$total*/
      ctx2[5]({
        x: (
          /*$hoveredX*/
          ctx2[1]
        ),
        name: (
          /*s*/
          ctx2[23]
        )
      })
    ) + ""
  );
  let t2;
  return {
    c() {
      t2 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t2, anchor);
    },
    p(ctx3, dirty) {
      if (dirty & /*$total, $hoveredX*/
      34 && t_value !== (t_value = /*yColumn*/
      ctx3[14].formatter(
        /*$total*/
        ctx3[5]({
          x: (
            /*$hoveredX*/
            ctx3[1]
          ),
          name: (
            /*s*/
            ctx3[23]
          )
        })
      ) + ""))
        set_data(t2, t_value);
    },
    d(detaching) {
      if (detaching) {
        detach(t2);
      }
    }
  };
}
function create_if_block_1$5(ctx2) {
  let t_value = (
    /*yColumn*/
    ctx2[14].formatter(
      /*$total*/
      ctx2[5]({
        x: (
          /*$hoveredX*/
          ctx2[1]
        ),
        name: (
          /*s*/
          ctx2[23]
        )
      }) / /*$total*/
      ctx2[5]({ x: (
        /*$hoveredX*/
        ctx2[1]
      ) })
    ) + ""
  );
  let t2;
  return {
    c() {
      t2 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t2, anchor);
    },
    p(ctx3, dirty) {
      if (dirty & /*$total, $hoveredX*/
      34 && t_value !== (t_value = /*yColumn*/
      ctx3[14].formatter(
        /*$total*/
        ctx3[5]({
          x: (
            /*$hoveredX*/
            ctx3[1]
          ),
          name: (
            /*s*/
            ctx3[23]
          )
        }) / /*$total*/
        ctx3[5]({ x: (
          /*$hoveredX*/
          ctx3[1]
        ) })
      ) + ""))
        set_data(t2, t_value);
    },
    d(detaching) {
      if (detaching) {
        detach(t2);
      }
    }
  };
}
function create_each_block$6(ctx2) {
  let div3;
  let div0;
  let div0_style_value;
  let t0;
  let div1;
  let t1_value = (
    /*seriesColumn*/
    ctx2[8].formatter(
      /*s*/
      ctx2[23]
    ) + ""
  );
  let t1;
  let t2;
  let div2;
  let t3;
  function select_block_type(ctx3, dirty) {
    if (
      /*$stack*/
      ctx3[3] && /*$percent*/
      ctx3[4]
    )
      return create_if_block_1$5;
    return create_else_block$3;
  }
  let current_block_type = select_block_type(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      var _a2;
      div3 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = text(t1_value);
      t2 = space();
      div2 = element("div");
      if_block.c();
      t3 = space();
      attr(div0, "style", div0_style_value = symbol({
        width: (
          /*radius*/
          ctx2[0]
        ),
        height: (
          /*radius*/
          ctx2[0]
        ),
        color: (
          /*$getColor*/
          ctx2[2](
            /*findRecord*/
            (_a2 = ctx2[17](
              /*$hoveredX*/
              ctx2[1],
              /*s*/
              ctx2[23]
            )) == null ? void 0 : _a2.color
          )
        )
      }));
      attr(div1, "style", tooltipItemLabel);
      attr(div2, "style", tooltipItemValue);
      attr(div3, "style", tooltipItem);
    },
    m(target, anchor) {
      insert(target, div3, anchor);
      append$2(div3, div0);
      append$2(div3, t0);
      append$2(div3, div1);
      append$2(div1, t1);
      append$2(div3, t2);
      append$2(div3, div2);
      if_block.m(div2, null);
      append$2(div3, t3);
    },
    p(ctx3, dirty) {
      var _a2;
      if (dirty & /*radius, $getColor, $hoveredX*/
      7 && div0_style_value !== (div0_style_value = symbol({
        width: (
          /*radius*/
          ctx3[0]
        ),
        height: (
          /*radius*/
          ctx3[0]
        ),
        color: (
          /*$getColor*/
          ctx3[2](
            /*findRecord*/
            (_a2 = ctx3[17](
              /*$hoveredX*/
              ctx3[1],
              /*s*/
              ctx3[23]
            )) == null ? void 0 : _a2.color
          )
        )
      }))) {
        attr(div0, "style", div0_style_value);
      }
      if (dirty & /*$hoveredX*/
      2 && t1_value !== (t1_value = /*seriesColumn*/
      ctx3[8].formatter(
        /*s*/
        ctx3[23]
      ) + ""))
        set_data(t1, t1_value);
      if (current_block_type === (current_block_type = select_block_type(ctx3)) && if_block) {
        if_block.p(ctx3, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx3);
        if (if_block) {
          if_block.c();
          if_block.m(div2, null);
        }
      }
    },
    d(detaching) {
      if (detaching) {
        detach(div3);
      }
      if_block.d();
    }
  };
}
function create_fragment$m(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*$hoveredX*/
    ctx2[1] != null && create_if_block$f(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*$hoveredX*/
        ctx3[1] != null
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$f(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$q($$self, $$props, $$invalidate) {
  let radius;
  let $font;
  let $tooltip;
  let $hoveredX;
  let $getColor;
  let $stack;
  let $percent;
  let $total;
  const instance2 = getInstance();
  const { chartStore, font, tooltip } = instance2;
  component_subscribe($$self, font, (value) => $$invalidate(18, $font = value));
  component_subscribe($$self, tooltip, (value) => $$invalidate(19, $tooltip = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$9) {
    throw new Error();
  }
  const { seriesColumn, seriesDomain, stack, percent, total, xColumn, yColumn, hoveredX, colorUtils: { getColor }, data } = chartStore;
  component_subscribe($$self, stack, (value) => $$invalidate(3, $stack = value));
  component_subscribe($$self, percent, (value) => $$invalidate(4, $percent = value));
  component_subscribe($$self, total, (value) => $$invalidate(5, $total = value));
  component_subscribe($$self, hoveredX, (value) => $$invalidate(1, $hoveredX = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(2, $getColor = value));
  function findRecord(x2, series) {
    return data.find((d) => d.x === x2 && d.series === series);
  }
  $$self.$$.update = () => {
    var _a2, _b;
    if ($$self.$$.dirty & /*$tooltip, $font*/
    786432) {
      $$invalidate(0, radius = (_b = (_a2 = $tooltip.font) == null ? void 0 : _a2.size) != null ? _b : $font.size);
    }
  };
  return [
    radius,
    $hoveredX,
    $getColor,
    $stack,
    $percent,
    $total,
    font,
    tooltip,
    seriesColumn,
    seriesDomain,
    stack,
    percent,
    total,
    xColumn,
    yColumn,
    hoveredX,
    getColor,
    findRecord,
    $font,
    $tooltip
  ];
}
let TooltipContent$8 = class TooltipContent4 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$q, create_fragment$m, safe_not_equal, {});
  }
};
const chartType$9 = "multiAxis";
let Store$9 = class Store7 {
  constructor(instance2) {
    __publicField(this, "type");
    __publicField(this, "intance");
    __publicField(this, "option");
    __publicField(this, "data");
    __publicField(this, "layout");
    __publicField(this, "xColumn");
    __publicField(this, "yColumn");
    __publicField(this, "ySubColumn");
    __publicField(this, "seriesColumn");
    __publicField(this, "colorColumn");
    __publicField(this, "colorUtils");
    __publicField(this, "xDomain");
    __publicField(this, "seriesDomain");
    __publicField(this, "total");
    __publicField(this, "stack");
    __publicField(this, "percent");
    __publicField(this, "xScale");
    __publicField(this, "yScale");
    __publicField(this, "yRange");
    __publicField(this, "ySubScale");
    __publicField(this, "ySubRange");
    __publicField(this, "barPadding");
    __publicField(this, "hoveredX");
    __publicField(this, "hoveredSeries");
    __publicField(this, "isFocused");
    __publicField(this, "toggleFocused");
    var _a2, _b, _c, _d, _e;
    this.intance = instance2;
    const { chartWidth, chartHeight, margin, focused } = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    this.type = option.type;
    const layout = writable((_a2 = option.layout) != null ? _a2 : "vertical");
    const stack = writable(option.stack);
    const percent = writable(option.stack && option.percent);
    const xColumn = parseCategoryColumn({
      column: (_b = option.xColumn) != null ? _b : {
        key: "__X__"
      }
    });
    const yColumn = parseValueColumn({
      column: {
        ...option.yColumn,
        ...option.percent ? {
          formatter: formatPercent,
          axisFormatter: axisFormatPercent
        } : {}
      }
    });
    const ySubColumn = parseValueColumn({
      column: {
        ...option.ySubColumn,
        ...option.percent ? {
          formatter: formatPercent,
          axisFormatter: axisFormatPercent
        } : {}
      }
    });
    const seriesColumn = parseCategoryColumn({
      column: (_c = option.seriesColumn) != null ? _c : {
        key: "__SERIES__"
      }
    });
    let colorColumn;
    if (option.colorColumn) {
      colorColumn = option.colorColumn.type === "category" ? parseCategoryColumn({
        column: option.colorColumn
      }) : parseValueColumn({
        column: option.colorColumn
      });
    } else {
      colorColumn = seriesColumn;
    }
    this.colorColumn = colorColumn;
    const hoveredX = writable(null);
    const hoveredSeries = writable(null);
    const data = dataMapper((_d = option.data) != null ? _d : [], [
      { key: "x", column: xColumn },
      {
        key: "y",
        column: yColumn
      },
      {
        key: "ysub",
        column: ySubColumn
      },
      { key: "series", column: seriesColumn },
      { key: "color", column: colorColumn }
    ]).filter(
      (x2, i2, self2) => i2 === self2.findIndex((y2) => x2.x === y2.x && x2.series === y2.series)
    );
    this.data = data;
    const xDomain = [
      ...xColumn.domain || new Group(data, (row) => row.x).keys()
    ];
    const seriesDomain = [
      ...seriesColumn.domain || new Group(data, (row) => row.series).keys()
    ];
    const valueByXDomain = /* @__PURE__ */ new Map();
    xDomain.forEach((x2) => {
      let total2 = 0;
      data.forEach((record) => {
        if (record.x === x2) {
          total2 += asValidNumber(record.y);
        }
      });
      valueByXDomain.set(x2, total2);
    });
    sortDomain({
      column: xColumn,
      valueByDomain: valueByXDomain,
      domain: xDomain
    });
    const valueBySeriesDomain = /* @__PURE__ */ new Map();
    seriesDomain.forEach((x2) => {
      let total2 = 0;
      data.forEach((record) => {
        if (record.series === x2) {
          total2 += asValidNumber(record.y);
        }
      });
      valueBySeriesDomain.set(x2, total2);
    });
    sortDomain({
      column: seriesColumn,
      valueByDomain: valueBySeriesDomain,
      domain: seriesDomain
    });
    const colorUtils = parseColorUtils({ colorColumn, data, instance: instance2 });
    this.colorUtils = colorUtils;
    const { isColorActive, colorDomain } = colorUtils;
    if (colorColumn.type === "category") {
      const valueByColorDomain = /* @__PURE__ */ new Map();
      colorDomain.forEach((x2) => {
        let total2 = 0;
        data.forEach((record) => {
          if (record.series === x2) {
            total2 += asValidNumber(record.y);
          }
        });
        valueByColorDomain.set(x2, total2);
      });
      sortDomain({
        column: seriesColumn,
        valueByDomain: valueByColorDomain,
        domain: colorDomain
      });
    }
    const total = derived([isColorActive], ([$isColorActive]) => {
      return ({ x: x2, name }) => {
        return sum(
          data.filter((d) => {
            if (x2 == null) {
              return true;
            }
            return d.x === x2;
          }).filter((d) => {
            if (name == null) {
              return true;
            }
            return d.series === name;
          }).filter((d) => $isColorActive(d.color)),
          (d) => d.y
        );
      };
    });
    const xScale = derived(
      [margin, chartWidth, chartHeight, layout],
      ([margin2, chartWidth2, chartHeight2, layout2]) => {
        return point$1().padding(0.5).domain(xDomain).range(
          layout2 === "vertical" ? [margin2.left, chartWidth2 - margin2.right] : [chartHeight2 - margin2.bottom, margin2.top]
        );
      }
    );
    const yRange = derived(
      [isColorActive, stack, percent],
      ([$isColorActive, stack2, percent2]) => {
        var _a3, _b2;
        if (stack2 && percent2) {
          return [0, 1];
        }
        const g = new Group(
          data,
          (d) => stack2 ? [d.x] : [d.x, d.series],
          (d) => $isColorActive(d.color),
          (d) => sum(d, (d2) => d2.y)
        );
        return [
          (_a3 = yColumn.min) != null ? _a3 : min$1(g.storeData, (d) => d.value),
          (_b2 = yColumn.max) != null ? _b2 : max$1(g.storeData, (d) => d.value)
        ];
      }
    );
    const yScale = derived(
      [yRange, margin, chartWidth, chartHeight, layout],
      ([yRange2, margin2, chartWidth2, chartHeight2, layout2]) => {
        return linear().domain([yRange2[0], yRange2[1]]).range(
          layout2 === "vertical" ? [chartHeight2 - margin2.bottom, margin2.top] : [margin2.left, chartWidth2 - margin2.right]
        ).nice();
      }
    );
    const ySubRange = derived(
      [isColorActive, stack, percent],
      ([$isColorActive, stack2, percent2]) => {
        var _a3, _b2;
        if (stack2 && percent2) {
          return [0, 1];
        }
        const g = new Group(
          data,
          (d) => stack2 ? [d.x] : [d.x, d.series],
          (d) => $isColorActive(d.color),
          (d) => sum(d, (d2) => d2.ysub)
        );
        return [
          (_a3 = ySubColumn.min) != null ? _a3 : min$1(g.storeData, (d) => d.value),
          (_b2 = ySubColumn.max) != null ? _b2 : max$1(g.storeData, (d) => d.value)
        ];
      }
    );
    const ySubScale = derived(
      [ySubRange, margin, chartWidth, chartHeight, layout],
      ([ySubRange2, margin2, chartWidth2, chartHeight2, layout2]) => {
        return linear().domain([ySubRange2[0], ySubRange2[1]]).range(
          layout2 === "vertical" ? [chartHeight2 - margin2.bottom, margin2.top] : [margin2.left, chartWidth2 - margin2.right]
        ).nice();
      }
    );
    function isFocused($focused, x2, name) {
      return $focused.some(
        (focused2) => focused2[xColumn.key] === x2 && focused2[seriesColumn.key] === name
      );
    }
    function toggleFocused($focused, x2, name) {
      if (isFocused($focused, x2, name)) {
        focused.update((focused2) => {
          return focused2.filter(
            (focused3) => !(focused3[xColumn.key] === x2 && focused3[seriesColumn.key] === name)
          );
        });
      } else {
        focused.update((focused2) => {
          return [
            ...focused2,
            {
              [xColumn.key]: x2,
              [seriesColumn.key]: name
            }
          ];
        });
      }
    }
    this.option = option;
    this.layout = layout;
    this.xColumn = xColumn;
    this.yColumn = yColumn;
    this.ySubColumn = ySubColumn;
    this.seriesColumn = seriesColumn;
    this.xDomain = xDomain;
    this.seriesDomain = seriesDomain;
    this.total = total;
    this.stack = stack;
    this.percent = percent;
    this.xScale = xScale;
    this.yScale = yScale;
    this.yRange = yRange;
    this.ySubScale = ySubScale;
    this.ySubRange = ySubRange;
    this.hoveredX = hoveredX;
    this.hoveredSeries = hoveredSeries;
    this.isFocused = isFocused;
    this.toggleFocused = toggleFocused;
    this.barPadding = (_e = option.barPadding) != null ? _e : 0.2;
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$9);
      instance2.tooltipContent.set(TooltipContent$8);
    });
    instance2.menuExtraButtons.set([
      // {
      //     key: 'switch',
      //     title: '線グラフに切り替え',
      //     onClick: () => {
      //         instance.option.update((option) => {
      //             return { ...option, type: 'line' } as any;
      //         });
      //     }
      // },
      // {
      //     key: 'stack',
      //     title: '積み上げ',
      //     onClick: () => {
      //         stack.update((stack) => !stack);
      //     }
      // },
      // {
      //     key: 'stack',
      //     title: '比率',
      //     onClick: () => {
      //         percent.update((value) => !value);
      //     }
      // }
    ]);
  }
};
const index$8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$9,
  chartType: chartType$9
}, Symbol.toStringTag, { value: "Module" }));
function instance_1$p($$self, $$props, $$invalidate) {
  let mainColor;
  let tick2;
  let $innerHeight;
  let $margin;
  let $innerWidth;
  let $font;
  let $color;
  const instance2 = getInstance();
  const { ssr, font, innerWidth, innerHeight, margin, mousePosition, tooltipPosition, tooltipShown, focused, focusable, tooltip, chartStore, contentShapes, color: color2 } = instance2;
  component_subscribe($$self, font, (value) => $$invalidate(12, $font = value));
  component_subscribe($$self, innerWidth, (value) => $$invalidate(11, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(9, $innerHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(10, $margin = value));
  component_subscribe($$self, color2, (value) => $$invalidate(13, $color = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$8) {
    throw new Error();
  }
  const { nodes, edges, activeIndex } = chartStore;
  const simulation = forceSimulation();
  let activeNodes = [];
  let activeLinks = [];
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$color*/
    8192) {
      $$invalidate(7, mainColor = $color.colors[0]);
    }
    if ($$self.$$.dirty & /*tick*/
    256) {
      {
        tick2();
      }
    }
    if ($$self.$$.dirty & /*activeNodes, mainColor, $font, activeLinks, $innerWidth, $innerHeight, $margin*/
    7904) {
      {
        let makeShape = function(scale, hideText) {
          return [
            ...activeNodes.flatMap((point2, i2) => {
              var _a2, _b, _c, _d, _e, _f, _g;
              const r2 = point2.r * scale;
              const circle = new CircleShape({
                cx: ((_a2 = point2.x) != null ? _a2 : 0) * scale,
                cy: ((_b = point2.y) != null ? _b : 0) * scale,
                r: r2,
                props: readable({ fill: chroma(mainColor).alpha(0.6).css() }),
                hoverable: true,
                hovered: derived([activeIndex], ([$activeIndex]) => $activeIndex === i2),
                events: {
                  mouseenter: readable(() => {
                    activeIndex.set(i2);
                  }),
                  mouseleave: readable(() => {
                    activeIndex.set(null);
                  })
                }
              });
              const circleHeight = circle.getBoundingRect().height;
              return [
                circle,
                ...hideText ? [] : [
                  new TextShape({
                    text: point2.text,
                    textAlign: "center",
                    textBaseline: point2.position === "inside" ? "middle" : "top",
                    x: ((_c = point2.x) != null ? _c : 0) * scale,
                    y: ((_d = point2.y) != null ? _d : 0) * scale + (point2.position === "inside" ? 0 : circleHeight / 2),
                    fontSize: (_f = (_e = point2.font) == null ? void 0 : _e.size) != null ? _f : $font.size,
                    fontFamily: ((_g = point2.font) == null ? void 0 : _g.family) || $font.family || DEFAULT_FONT_FAMILY
                  })
                ]
              ];
            }),
            ...activeLinks.map((link, i2) => {
              var _a2, _b, _c, _d;
              const source = link.source;
              const target = link.target;
              return new LineShape({
                x1: ((_a2 = source.x) != null ? _a2 : 0) * scale,
                x2: ((_b = target.x) != null ? _b : 0) * scale,
                y1: ((_c = source.y) != null ? _c : 0) * scale,
                y2: ((_d = target.y) != null ? _d : 0) * scale,
                props: readable({
                  stroke: chroma(mainColor).alpha(0.2).css()
                })
              });
            })
          ];
        };
        const g = new GroupShape({ children: makeShape(1, false) });
        const { width, height } = g.getBoundingRect();
        const minRate = Math.min(($innerWidth - 24) / width, ($innerHeight - 24) / height);
        g.shapeProps.update((n2) => ({
          ...n2,
          children: makeShape(minRate, false)
        }));
        g.apply();
        const rect = g.getBoundingRect();
        g.shapeProps.update((n2) => ({
          ...n2,
          x: $margin.left + ($innerWidth - rect.width) / 2 - rect.x,
          y: $margin.top + ($innerHeight - rect.height) / 2 - rect.y
        }));
        g.apply();
        contentShapes.set([g]);
      }
    }
  };
  $$invalidate(8, tick2 = () => {
    const initialNodes = JSON.parse(JSON.stringify(nodes));
    const links = JSON.parse(JSON.stringify(edges));
    const sim = simulation.nodes(initialNodes).force("links1", forceLink().links(links).distance((l2, i2) => {
      return (l2.target.r + l2.source.r) * 4;
    }).strength(1)).force("collide2", forceCollide().radius((d, i2) => d.r * 4).strength(1)).force("repulsion", forceManyBody().strength(-100));
    sim.alpha(1).tick(1e3);
    $$invalidate(5, activeNodes = simulation.nodes());
    $$invalidate(6, activeLinks = [...links]);
  });
  return [
    font,
    innerWidth,
    innerHeight,
    margin,
    color2,
    activeNodes,
    activeLinks,
    mainColor,
    tick2,
    $innerHeight,
    $margin,
    $innerWidth,
    $font,
    $color
  ];
}
let Content$8 = class Content9 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$p, null, safe_not_equal, {});
  }
};
function instance_1$o($$self) {
  const instance2 = getInstance();
  const { chartStore, font } = instance2;
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$8) {
    throw new Error();
  }
  return [];
}
let TooltipContent$7 = class TooltipContent5 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$o, null, safe_not_equal, {});
  }
};
const chartType$8 = "network";
let Store$8 = class Store8 {
  constructor(instance2) {
    __publicField(this, "type", chartType$8);
    __publicField(this, "option");
    __publicField(this, "nodes");
    __publicField(this, "edges");
    __publicField(this, "activeIndex", writable(null));
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    const { nodes, edges } = option;
    this.option = option;
    this.nodes = nodes;
    this.edges = edges;
    instance2.chartContent.set(Content$8);
    instance2.tooltipContent.set(TooltipContent$7);
  }
};
const beardLength$1 = 8;
const labelPadding$2 = 8;
function instance$8($$self, $$props, $$invalidate) {
  let getLabelPos;
  let shapes;
  let $margin;
  let $innerHeight;
  let $innerWidth;
  let $font;
  let $getColor;
  let $activeTotal;
  let $isColorActive;
  let $donut;
  const { chartWidth, chartHeight, innerWidth, innerHeight, margin, focused, focusable, chartStore, contentShapes, font } = getInstance();
  component_subscribe($$self, innerWidth, (value) => $$invalidate(17, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(16, $innerHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(15, $margin = value));
  component_subscribe($$self, font, (value) => $$invalidate(18, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$7) {
    throw new Error();
  }
  const { activeTotal, activeSerie, seriesColumn, seriesDomain, isFocused, toggleFocused, donut, colorUtils: { isColorActive, getColor }, data, labelFormatter, innerLabelFormatter } = chartStore;
  component_subscribe($$self, activeTotal, (value) => $$invalidate(20, $activeTotal = value));
  component_subscribe($$self, donut, (value) => $$invalidate(22, $donut = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(21, $isColorActive = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(19, $getColor = value));
  let radius = 0;
  let innerRadius = 0;
  let outerArc;
  let innerArc;
  let pieArc;
  const group = new GroupShape({ children: [] });
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$innerWidth, $innerHeight, radius, $donut*/
    4391168) {
      {
        $$invalidate(8, radius = Math.min($innerWidth, $innerHeight) / 2);
        if (radius > labelPadding$2 * 2) {
          $$invalidate(8, radius -= labelPadding$2 * 2);
        }
        $$invalidate(9, innerRadius = $donut ? radius / 2 : 0);
      }
    }
    if ($$self.$$.dirty[0] & /*radius, innerRadius*/
    768) {
      {
        $$invalidate(11, innerArc = arc().innerRadius(radius).outerRadius(radius));
        $$invalidate(10, outerArc = arc().innerRadius(radius + labelPadding$2).outerRadius(radius + labelPadding$2));
        $$invalidate(12, pieArc = arc().innerRadius(innerRadius).outerRadius(radius));
      }
    }
    if ($$self.$$.dirty[0] & /*outerArc*/
    1024) {
      $$invalidate(14, getLabelPos = (d) => {
        const midAngle = d.startAngle + (d.endAngle - d.startAngle) / 2;
        const labelX = (() => {
          const pos = outerArc.centroid(d);
          pos[0] = pos[0] + beardLength$1 * (midAngle < Math.PI ? 1 : -1);
          return pos[0];
        })();
        const labelY = (() => {
          const pos = outerArc.centroid(d);
          return pos[1];
        })();
        return {
          x: labelX,
          y: labelY,
          textAlign: (() => {
            return midAngle < Math.PI ? "left" : "right";
          })()
        };
      });
    }
    if ($$self.$$.dirty[0] & /*$activeTotal, $isColorActive, $getColor, radius, outerArc, innerArc, pieArc, getLabelPos, innerRadius, $font*/
    3956480) {
      $$invalidate(13, shapes = (() => {
        let prev2 = 0;
        return seriesDomain.flatMap((series, index2) => {
          if ($activeTotal === 0) {
            return [];
          }
          const record = data.find((d2) => d2.series === series);
          if (!record) {
            return [];
          }
          if (!$isColorActive(record.color)) {
            return [];
          }
          const value = asValidNumber(record.value / $activeTotal);
          const prevValue = prev2;
          const currentValue = value + prev2;
          prev2 += value;
          const color2 = $getColor(record.color);
          const angle = asValidNumber(value * (Math.PI * 2));
          const startAngle = asValidNumber(prevValue * (Math.PI * 2));
          const endAngle = asValidNumber(currentValue * (Math.PI * 2));
          const midAngle = startAngle + (endAngle - startAngle) / 2;
          const d = {
            innerRadius: radius,
            outerRadius: radius,
            startAngle,
            endAngle
          };
          const outerCentroid = outerArc.centroid(d);
          const innerCentroid = innerArc.centroid(d);
          const pieCenteroid = pieArc.centroid(d);
          const labelPos = getLabelPos(d);
          const label = labelFormatter ? labelFormatter(record) : null;
          const innerLabel = innerLabelFormatter ? innerLabelFormatter(record) : null;
          const sector = new SectorShape({
            clickable: true,
            events: {
              click: readable(() => {
                toggleFocused(get_store_value(focused), series);
              }),
              mouseenter: readable(() => {
                activeSerie.set(series);
              }),
              mouseleave: readable(() => {
                activeSerie.set(null);
              })
            },
            focused: derived([focused], ([$focused]) => {
              return isFocused($focused, series);
            }),
            hoverable: true,
            hovered: derived([activeSerie], ([$activeSerie]) => {
              return $activeSerie === series;
            }),
            inactive: derived([focused], ([$focused]) => {
              return $focused.length > 0 && !isFocused($focused, series);
            }),
            props: readable({ fill: color2 }),
            cx: 0,
            cy: 0,
            r: radius,
            r0: innerRadius,
            startAngle: startAngle - Math.PI / 2,
            endAngle: endAngle - Math.PI / 2,
            largeArc: angle > Math.PI,
            data: { series }
          });
          return [
            {
              data: d,
              labelVisible: false,
              labelData: { ...d },
              startAngle,
              endAngle,
              sector,
              line2: new LineShape({
                x1: innerCentroid[0],
                y1: innerCentroid[1],
                x2: outerCentroid[0],
                y2: outerCentroid[1],
                props: readable({ stroke: color2 }),
                inactive: derived([focused], ([$focused]) => {
                  return $focused.length > 0 && !isFocused($focused, series);
                })
              }),
              line: new LineShape({
                x1: outerCentroid[0],
                y1: outerCentroid[1],
                x2: labelPos.x,
                y2: labelPos.y,
                props: readable({ stroke: color2 }),
                inactive: derived([focused], ([$focused]) => {
                  return $focused.length > 0 && !isFocused($focused, series);
                })
              }),
              innerText: innerLabel ? new TextShape({
                data: { midAngle },
                padding: 0,
                x: pieCenteroid[0],
                y: pieCenteroid[1],
                textAlign: "center",
                textBaseline: "middle",
                text: innerLabel,
                fontSize: $font.size,
                fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                overflow: "ignore",
                backgroundColor: color2,
                inactive: derived([focused], ([$focused]) => {
                  return $focused.length > 0 && !isFocused($focused, series);
                })
              }) : null,
              text: label ? new TextShape({
                data: { midAngle },
                padding: 0,
                x: labelPos.x,
                y: labelPos.y,
                textAlign: (() => {
                  return midAngle < Math.PI ? "left" : "right";
                })(),
                textBaseline: "middle",
                text: label,
                fontSize: $font.size,
                fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                overflow: "ignore",
                props: readable({ fill: "#333" }),
                inactive: derived([focused], ([$focused]) => {
                  return $focused.length > 0 && !isFocused($focused, series);
                })
              }) : null
            }
          ];
        });
      })());
    }
    if ($$self.$$.dirty[0] & /*$innerWidth, $margin, $innerHeight*/
    229376) {
      {
        group.shapeProps.update((n2) => ({
          ...n2,
          x: $innerWidth / 2 + $margin.left,
          y: $innerHeight / 2 + $margin.top
        }));
      }
    }
    if ($$self.$$.dirty[0] & /*shapes, getLabelPos*/
    24576) {
      {
        let isOverlapped = function(target) {
          return visibleShapes.some((shape) => shape.intersect(target.getBoundingRect()));
        }, findOverlappingShapes = function(currentShape, index2) {
          if (!currentShape.text) {
            return [];
          }
          const find2 = shapes.find((nextShape, i2) => {
            if (i2 < index2) {
              return false;
            }
            if (!nextShape.text || !currentShape.text) {
              return false;
            }
            return nextShape.text.intersect(currentShape.text.getBoundingRect());
          });
          return find2 ? [find2] : [];
        }, normalizeArc = function(d) {
          if (d.startAngle < 0) {
            d.startAngle = 0;
          }
          if (d.endAngle < 0) {
            d.endAngle = 0;
          }
          if (d.startAngle > Math.PI * 2) {
            d.startAngle = Math.PI * 2;
          }
          if (d.endAngle > Math.PI * 2) {
            d.endAngle = Math.PI * 2;
          }
        };
        const visibleShapes = [];
        const unit2 = Math.PI * 2 / 360 / 2;
        const maxDiffAngle = Math.PI / 180 * 45;
        let n2 = 0;
        let flg = true;
        while (flg && n2++ < 100) {
          flg = false;
          shapes.forEach((shape, i2) => {
            const overlappingShapes = findOverlappingShapes(shape, i2 + 1);
            if (overlappingShapes.length > 0) {
              flg = true;
              if (shape.data.startAngle - shape.labelData.startAngle < maxDiffAngle) {
                shape.labelData.startAngle -= unit2;
                shape.labelData.endAngle -= unit2;
                normalizeArc(shape.labelData);
              }
              if (shape.text) {
                shape.text.shapeProps.update((n22) => ({ ...n22, ...getLabelPos(shape.labelData) }));
                shape.text.apply();
              }
              overlappingShapes.forEach((shape2) => {
                if (shape2.labelData.endAngle - shape2.data.endAngle < maxDiffAngle) {
                  shape2.labelData.startAngle += unit2;
                  shape2.labelData.endAngle += unit2;
                  normalizeArc(shape2.labelData);
                }
                if (shape2.text) {
                  shape2.text.shapeProps.update((n22) => ({ ...n22, ...getLabelPos(shape2.labelData) }));
                  shape2.text.apply();
                }
              });
            }
          });
        }
        shapes.forEach(({ sector, line: line2, line2: line22, text: text2, innerText }) => {
          if (innerText) {
            const rect = innerText.getBoundingRect();
            if (sector.contain(rect.x, rect.y) && sector.contain(rect.x + rect.width, rect.y) && sector.contain(rect.x, rect.y + rect.height) && sector.contain(rect.x + rect.width, rect.y + rect.height)) {
              if (isOverlapped(innerText)) {
                innerText.visible.set(false);
              } else {
                visibleShapes.push(innerText);
              }
            }
          }
          if (text2) {
            if (isOverlapped(text2)) {
              line2.visible.set(false);
              line22.visible.set(false);
              text2.visible.set(false);
            } else {
              const { x: x2, y: y2, textAlign } = text2.$shapeProps;
              const stepX = x2 + (textAlign === "left" ? -1 : 1) * beardLength$1;
              const stepY = y2;
              line2.shapeProps.update((n22) => ({
                ...n22,
                x1: stepX,
                y1: stepY,
                x2,
                y2
              }));
              line22.shapeProps.update((n22) => ({ ...n22, x2: stepX, y2: stepY }));
              visibleShapes.push(text2);
            }
          }
        });
        group.shapeProps.update((n22) => ({
          ...n22,
          children: [
            ...shapes.flatMap(({ sector }) => {
              return [sector];
            }),
            ...shapes.flatMap(({ line: line2, line2: line22, text: text2 }) => text2 ? [line2, line22] : []),
            ...shapes.flatMap(({ text: text2 }) => text2 ? [text2] : []),
            ...shapes.flatMap(({ innerText }) => innerText && visibleShapes.includes(innerText) ? [innerText] : [])
          ]
        }));
        contentShapes.set([group]);
      }
    }
  };
  return [
    innerWidth,
    innerHeight,
    margin,
    font,
    activeTotal,
    donut,
    isColorActive,
    getColor,
    radius,
    innerRadius,
    outerArc,
    innerArc,
    pieArc,
    shapes,
    getLabelPos,
    $margin,
    $innerHeight,
    $innerWidth,
    $font,
    $getColor,
    $activeTotal,
    $isColorActive,
    $donut
  ];
}
let Pie$1 = class Pie extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$8, null, safe_not_equal, {}, null, [-1, -1]);
  }
};
function create_fragment$l(ctx2) {
  let pie;
  let current;
  pie = new Pie$1({});
  return {
    c() {
      create_component(pie.$$.fragment);
    },
    m(target, anchor) {
      mount_component(pie, target, anchor);
      current = true;
    },
    p: noop$2,
    i(local) {
      if (current)
        return;
      transition_in(pie.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(pie.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(pie, detaching);
    }
  };
}
function instance_1$n($$self, $$props, $$invalidate) {
  let $getColor;
  let $mousePosition;
  let $activeSerie;
  const instance2 = getInstance();
  const { mousePosition, tooltipShown, tooltipPosition, legend, chartStore, colorLegendConfig } = instance2;
  component_subscribe($$self, mousePosition, (value) => $$invalidate(4, $mousePosition = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$7) {
    throw new Error();
  }
  const { activeSerie, colorColumn, colorUtils: { colorRange, colorDomain, getColor } } = chartStore;
  component_subscribe($$self, activeSerie, (value) => $$invalidate(5, $activeSerie = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(3, $getColor = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeSerie, $mousePosition*/
    48) {
      {
        if ($activeSerie != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty & /*$getColor*/
    8) {
      {
        if (colorColumn.type === "value") {
          colorLegendConfig.set({
            show: true,
            type: "value",
            column: colorColumn,
            min: colorRange[0],
            max: colorRange[1],
            getColor: (value) => $getColor(value * (colorRange[1] - colorRange[0]) + colorRange[0])
          });
        } else if (colorColumn.type === "category") {
          colorLegendConfig.set({
            show: true,
            type: "category",
            formatter: colorColumn.formatter,
            domain: colorDomain,
            getColor: (value) => $getColor(value)
          });
        }
      }
    }
  };
  return [mousePosition, activeSerie, getColor, $getColor, $mousePosition, $activeSerie];
}
let Content$7 = class Content10 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$n, create_fragment$l, safe_not_equal, {});
  }
};
function create_if_block$e(ctx2) {
  let div4;
  let div3;
  let div0;
  let div0_style_value;
  let t0;
  let div1;
  let t1_value = (
    /*seriesColumn*/
    ctx2[6].formatter(
      /*activeData*/
      ctx2[1].series
    ) + ""
  );
  let t1;
  let t2;
  let div2;
  let t3_value = (
    /*valueColumn*/
    ctx2[5].formatter(
      /*activeData*/
      ctx2[1].value
    ) + ""
  );
  let t3;
  return {
    c() {
      div4 = element("div");
      div3 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = text(t1_value);
      t2 = space();
      div2 = element("div");
      t3 = text(t3_value);
      attr(div0, "style", div0_style_value = symbol({
        width: (
          /*$font*/
          ctx2[2].size
        ),
        height: (
          /*$font*/
          ctx2[2].size
        ),
        color: (
          /*$getColor*/
          ctx2[3](
            /*activeData*/
            ctx2[1].color
          )
        )
      }));
      attr(div1, "style", tooltipItemLabel);
      attr(div2, "style", tooltipItemValue);
      attr(div3, "style", tooltipItem);
      attr(div4, "style", tooltipOuter.toString());
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append$2(div4, div3);
      append$2(div3, div0);
      append$2(div3, t0);
      append$2(div3, div1);
      append$2(div1, t1);
      append$2(div3, t2);
      append$2(div3, div2);
      append$2(div2, t3);
    },
    p(ctx3, dirty) {
      if (dirty & /*$font, $getColor, activeData*/
      14 && div0_style_value !== (div0_style_value = symbol({
        width: (
          /*$font*/
          ctx3[2].size
        ),
        height: (
          /*$font*/
          ctx3[2].size
        ),
        color: (
          /*$getColor*/
          ctx3[3](
            /*activeData*/
            ctx3[1].color
          )
        )
      }))) {
        attr(div0, "style", div0_style_value);
      }
      if (dirty & /*activeData*/
      2 && t1_value !== (t1_value = /*seriesColumn*/
      ctx3[6].formatter(
        /*activeData*/
        ctx3[1].series
      ) + ""))
        set_data(t1, t1_value);
      if (dirty & /*activeData*/
      2 && t3_value !== (t3_value = /*valueColumn*/
      ctx3[5].formatter(
        /*activeData*/
        ctx3[1].value
      ) + ""))
        set_data(t3, t3_value);
    },
    d(detaching) {
      if (detaching) {
        detach(div4);
      }
    }
  };
}
function create_fragment$k(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*activeData*/
    ctx2[1] != null && /*$activeSerie*/
    ctx2[0] != null && create_if_block$e(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*activeData*/
        ctx3[1] != null && /*$activeSerie*/
        ctx3[0] != null
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$e(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$m($$self, $$props, $$invalidate) {
  let activeData;
  let $activeSerie;
  let $font;
  let $getColor;
  const instance2 = getInstance();
  const { chartStore, font } = instance2;
  component_subscribe($$self, font, (value) => $$invalidate(2, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$7) {
    throw new Error();
  }
  const { valueColumn, seriesColumn, activeSerie, colorUtils: { getColor }, data } = chartStore;
  component_subscribe($$self, activeSerie, (value) => $$invalidate(0, $activeSerie = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(3, $getColor = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeSerie*/
    1) {
      $$invalidate(1, activeData = (() => {
        if ($activeSerie == null) {
          return null;
        }
        return data.find((d) => d.series === $activeSerie);
      })());
    }
  };
  return [
    $activeSerie,
    activeData,
    $font,
    $getColor,
    font,
    valueColumn,
    seriesColumn,
    activeSerie,
    getColor
  ];
}
let TooltipContent$6 = class TooltipContent6 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$m, create_fragment$k, safe_not_equal, {});
  }
};
const chartType$7 = "pie";
let Store$7 = class Store9 {
  constructor(instance2) {
    __publicField(this, "type", chartType$7);
    __publicField(this, "donut");
    __publicField(this, "data");
    __publicField(this, "seriesColumn");
    __publicField(this, "valueColumn");
    __publicField(this, "seriesDomain");
    __publicField(this, "activeTotal");
    __publicField(this, "activeSerie");
    __publicField(this, "colorColumn");
    __publicField(this, "colorUtils");
    __publicField(this, "labelFormatter");
    __publicField(this, "innerLabelFormatter");
    __publicField(this, "isFocused");
    __publicField(this, "toggleFocused");
    var _a2, _b, _c;
    const { chartWidth, chartHeight, focused, colorLegendActives } = instance2;
    const option = get_store_value(instance2.option);
    const donut = writable((_a2 = option.donut) != null ? _a2 : false);
    const activeSerie = writable(null);
    const seriesColumn = parseCategoryColumn({
      column: option.seriesColumn
    });
    const valueColumn = parseValueColumn({
      column: option.valueColumn
    });
    let colorColumn;
    if (option.colorColumn) {
      colorColumn = option.colorColumn.type === "category" ? parseCategoryColumn({
        column: option.colorColumn
      }) : parseValueColumn({
        column: option.colorColumn
      });
    } else {
      colorColumn = seriesColumn;
    }
    this.colorColumn = colorColumn;
    const data = dataMapper((_b = option.data) != null ? _b : [], [
      { key: "series", column: seriesColumn },
      { key: "value", column: valueColumn },
      { key: "color", column: colorColumn }
    ]).filter(
      (x2, i2, self2) => i2 === self2.findIndex((y2) => x2.series === y2.series)
    );
    const seriesDomain = [
      ...(_c = seriesColumn.domain) != null ? _c : new Group(data, (d) => d.series).keys()
    ];
    const { colorDomain, colorRange, isColorActive, getColor } = parseColorUtils({ colorColumn, data, instance: instance2 });
    this.colorUtils = { colorDomain, colorRange, isColorActive, getColor };
    const activeTotal = derived([isColorActive], ([$isColorActive]) => {
      return sum(data, (record) => {
        if ($isColorActive(record.color)) {
          return asValidNumber(record.value);
        }
        return 0;
      });
    });
    function isFocused($focused, name) {
      return $focused.some(
        (focused2) => focused2[seriesColumn.key] === name
      );
    }
    function toggleFocused($focused, name) {
      if (isFocused($focused, name)) {
        focused.update((focused2) => {
          return focused2.filter(
            (n2) => !(n2[seriesColumn.key] === name)
          );
        });
      } else {
        focused.update((focused2) => {
          return [...focused2, { [seriesColumn.key]: name }];
        });
      }
    }
    const defaultLabelFormatter = (r2) => {
      var _a3;
      return (_a3 = seriesColumn.formatter(r2.series)) != null ? _a3 : "";
    };
    const defaultInnerLabelFormatter = (r2) => {
      var _a3;
      return (_a3 = valueColumn.formatter(r2.value)) != null ? _a3 : "";
    };
    this.seriesColumn = seriesColumn;
    this.valueColumn = valueColumn;
    this.donut = donut;
    this.data = data;
    this.seriesDomain = seriesDomain;
    this.activeTotal = activeTotal;
    this.activeSerie = activeSerie;
    this.isFocused = isFocused;
    this.toggleFocused = toggleFocused;
    this.labelFormatter = option.labelFormatter === void 0 ? defaultLabelFormatter : option.labelFormatter;
    this.innerLabelFormatter = option.innerLabelFormatter === void 0 ? defaultInnerLabelFormatter : option.innerLabelFormatter;
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$7);
      instance2.tooltipContent.set(TooltipContent$6);
    });
    instance2.tableConfig.set({
      columns: [
        {
          ...seriesColumn,
          key: "name",
          type: "dimension",
          align: "left"
        },
        {
          ...valueColumn,
          key: "value",
          type: "metric",
          align: "right"
        }
      ],
      data: data.map((d) => {
        return {
          name: d.series,
          value: d.value
        };
      })
    });
  }
};
const index$7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$7,
  chartType: chartType$7
}, Symbol.toStringTag, { value: "Module" }));
const colors = {
  red: "#c34b67",
  orange: "#db821b",
  yellow: "#e8cb27",
  olive: "#acbe34",
  green: "#24a584",
  blue: "#2c8dd6",
  violet: "#6842b9",
  purple: "#a054b9",
  pink: "#de61a7",
  brown: "#986c50",
  gray: "#aaa"
};
const colorPalette = [
  colors.blue,
  colors.pink,
  colors.green,
  colors.yellow,
  colors.violet,
  colors.olive,
  colors.purple,
  colors.brown,
  colors.red,
  colors.orange
];
const barWidth = 20;
function instance_1$l($$self, $$props, $$invalidate) {
  let $innerHeight;
  let $innerWidth;
  let $mousePosition;
  let $activeDataIndex;
  const instance2 = getInstance();
  const { ssr, chartWidth, chartHeight, mousePosition, margin, tooltipShown, tooltipPosition, chartStore, xAxisConfig, yAxisConfig, focused, contentShapes, font, colorLegendConfig, focusable, innerHeight, innerWidth } = instance2;
  component_subscribe($$self, mousePosition, (value) => $$invalidate(6, $mousePosition = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(4, $innerHeight = value));
  component_subscribe($$self, innerWidth, (value) => $$invalidate(5, $innerWidth = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$6) {
    throw new Error();
  }
  const { data, activeDataIndex, layerColumns, valueColumn } = chartStore;
  component_subscribe($$self, activeDataIndex, (value) => $$invalidate(7, $activeDataIndex = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeDataIndex, $mousePosition*/
    192) {
      {
        if ($activeDataIndex != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty & /*$innerWidth, $innerHeight*/
    48) {
      {
        let clearInfo = function() {
          layerDomainInfo.forEach((layer) => {
            Object.keys(layer).forEach((key) => {
              layer[key].current = 0;
            });
          });
        };
        const keys = {};
        data.forEach((row) => {
          layerColumns.forEach((column2) => {
            keys[column2.valueGetter(row)] = null;
          });
        });
        const domain = Object.keys(keys);
        const layerValues = layerColumns.map((layer) => {
          const values = {};
          domain.forEach((value) => {
            const filtered = data.filter((row) => layer.valueGetter(row) === value);
            values[value] = sum(filtered, (row) => valueColumn.valueGetter(row));
          });
          return values;
        });
        const blockWidth = ($innerWidth - barWidth) / (layerColumns.length - 1);
        let total = 0;
        data.forEach((row) => {
          const value = valueColumn.valueGetter(row);
          if (value != null) {
            total += value;
          }
        });
        const scale = linear([0, $innerHeight]).domain([0, total]);
        const layerDomainInfo = layerColumns.map((layer) => {
          return {};
        });
        const shapes = layerColumns.map((layerColumn, index2) => {
          const values = layerValues[index2];
          let prevValue = 0;
          return new GroupShape({
            x: blockWidth * index2,
            y: 0,
            children: domain.flatMap((value, i2) => {
              const text2 = layerColumn.formatter(value);
              const color2 = colorPalette[i2 % colorPalette.length];
              const v2 = values[value];
              const info = {
                value: v2,
                position: prevValue,
                current: 0
              };
              layerDomainInfo[index2][value] = info;
              prevValue += v2;
              return [
                new RectShape({
                  x: 0,
                  y: scale(prevValue - v2),
                  width: barWidth,
                  height: scale(v2),
                  props: readable({ fill: color2 })
                }),
                ...v2 > 0 ? [
                  index2 === layerColumns.length - 1 ? new TextShape({
                    padding: 0,
                    x: 0,
                    y: scale(prevValue - v2) + scale(v2) / 2,
                    textAlign: "right",
                    textBaseline: "middle",
                    text: text2,
                    overflow: "hidden",
                    height: scale(v2)
                  }) : new TextShape({
                    padding: 0,
                    x: barWidth,
                    y: scale(prevValue - v2) + scale(v2) / 2,
                    textAlign: "left",
                    textBaseline: "middle",
                    text: text2,
                    overflow: "hidden",
                    height: scale(v2)
                  })
                ] : []
              ];
            })
          });
        });
        const sankeys = [];
        for (let i2 = 0; i2 < layerColumns.length - 1; i2++) {
          clearInfo();
          data.forEach((row, dataIndex) => {
            const layerA = layerColumns[i2];
            const layerB = layerColumns[i2 + 1];
            const valueA = layerA.valueGetter(row);
            const valueB = layerB.valueGetter(row);
            const a2 = layerDomainInfo[i2][valueA];
            const b = layerDomainInfo[i2 + 1][valueB];
            const value = valueColumn.valueGetter(row);
            const height = value == null ? 0 : scale(value);
            const s2 = new SankeyShape({
              ax: i2 * blockWidth + barWidth,
              ay: scale(a2.position) + scale(a2.current),
              cx: i2 * blockWidth + blockWidth,
              cy: scale(b.position) + scale(b.current),
              height,
              hoverable: true,
              hovered: derived([activeDataIndex], ([$activeDataIndex2]) => $activeDataIndex2 === dataIndex),
              events: {
                mouseenter: readable(() => {
                  activeDataIndex.set(dataIndex);
                }),
                mouseleave: readable(() => {
                  activeDataIndex.set(null);
                })
              },
              props: derived([activeDataIndex], ([$activeDataIndex2]) => ({
                fill: $activeDataIndex2 === dataIndex ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0.1)"
              }))
            });
            if (value != null) {
              a2.current += value;
              b.current += value;
            }
            sankeys.push(s2);
          });
        }
        contentShapes.set([...sankeys, ...shapes]);
      }
    }
  };
  return [
    mousePosition,
    innerHeight,
    innerWidth,
    activeDataIndex,
    $innerHeight,
    $innerWidth,
    $mousePosition,
    $activeDataIndex
  ];
}
let Content$6 = class Content11 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$l, null, safe_not_equal, {});
  }
};
function get_each_context$5(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[9] = list[i2];
  child_ctx[11] = i2;
  return child_ctx;
}
function create_if_block$d(ctx2) {
  let div4;
  let div2;
  let div0;
  let t1;
  let div1;
  let t2_value = (
    /*valueColumn*/
    ctx2[3].formatter(
      /*valueColumn*/
      ctx2[3].valueGetter(
        /*activeData*/
        ctx2[0]
      )
    ) + ""
  );
  let t2;
  let t3;
  let div3;
  let each_value = ensure_array_like(
    /*layerColumns*/
    ctx2[2]
  );
  let each_blocks = [];
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    each_blocks[i2] = create_each_block$5(get_each_context$5(ctx2, each_value, i2));
  }
  return {
    c() {
      div4 = element("div");
      div2 = element("div");
      div0 = element("div");
      div0.textContent = `${/*valueColumn*/
      ctx2[3].title}`;
      t1 = space();
      div1 = element("div");
      t2 = text(t2_value);
      t3 = space();
      div3 = element("div");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      attr(div0, "style", tooltipItemLabel);
      attr(div1, "style", tooltipItemValue);
      attr(div2, "style", tooltipItem);
      attr(div4, "style", tooltipOuter.toString());
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append$2(div4, div2);
      append$2(div2, div0);
      append$2(div2, t1);
      append$2(div2, div1);
      append$2(div1, t2);
      append$2(div4, t3);
      append$2(div4, div3);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(div3, null);
        }
      }
    },
    p(ctx3, dirty) {
      if (dirty & /*activeData*/
      1 && t2_value !== (t2_value = /*valueColumn*/
      ctx3[3].formatter(
        /*valueColumn*/
        ctx3[3].valueGetter(
          /*activeData*/
          ctx3[0]
        )
      ) + ""))
        set_data(t2, t2_value);
      if (dirty & /*layerColumns, activeData*/
      5) {
        each_value = ensure_array_like(
          /*layerColumns*/
          ctx3[2]
        );
        let i2;
        for (i2 = 0; i2 < each_value.length; i2 += 1) {
          const child_ctx = get_each_context$5(ctx3, each_value, i2);
          if (each_blocks[i2]) {
            each_blocks[i2].p(child_ctx, dirty);
          } else {
            each_blocks[i2] = create_each_block$5(child_ctx);
            each_blocks[i2].c();
            each_blocks[i2].m(div3, null);
          }
        }
        for (; i2 < each_blocks.length; i2 += 1) {
          each_blocks[i2].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    d(detaching) {
      if (detaching) {
        detach(div4);
      }
      destroy_each(each_blocks, detaching);
    }
  };
}
function create_each_block$5(ctx2) {
  let div2;
  let div0;
  let t1;
  let div1;
  let t2_value = (
    /*layerColumn*/
    ctx2[9].formatter(
      /*layerColumn*/
      ctx2[9].valueGetter(
        /*activeData*/
        ctx2[0]
      )
    ) + ""
  );
  let t2;
  let t3;
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      div0.textContent = `${/*layerColumn*/
      ctx2[9].title}`;
      t1 = space();
      div1 = element("div");
      t2 = text(t2_value);
      t3 = space();
      attr(div0, "style", tooltipItemLabel);
      attr(div1, "style", tooltipItemValue);
      attr(div2, "style", tooltipItem);
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append$2(div2, div0);
      append$2(div2, t1);
      append$2(div2, div1);
      append$2(div1, t2);
      append$2(div2, t3);
    },
    p(ctx3, dirty) {
      if (dirty & /*activeData*/
      1 && t2_value !== (t2_value = /*layerColumn*/
      ctx3[9].formatter(
        /*layerColumn*/
        ctx3[9].valueGetter(
          /*activeData*/
          ctx3[0]
        )
      ) + ""))
        set_data(t2, t2_value);
    },
    d(detaching) {
      if (detaching) {
        detach(div2);
      }
    }
  };
}
function create_fragment$j(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*activeData*/
    ctx2[0] && create_if_block$d(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*activeData*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$d(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$k($$self, $$props, $$invalidate) {
  let activeData;
  let $activeDataIndex;
  const instance2 = getInstance();
  const { chartStore, font } = instance2;
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$6) {
    throw new Error();
  }
  const { data, activeDataIndex, layerColumns, valueColumn } = chartStore;
  component_subscribe($$self, activeDataIndex, (value) => $$invalidate(4, $activeDataIndex = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeDataIndex*/
    16) {
      $$invalidate(0, activeData = $activeDataIndex == null ? null : data[$activeDataIndex]);
    }
  };
  return [activeData, activeDataIndex, layerColumns, valueColumn, $activeDataIndex];
}
let TooltipContent$5 = class TooltipContent7 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$k, create_fragment$j, safe_not_equal, {});
  }
};
const chartType$6 = "sankey";
let Store$6 = class Store10 {
  constructor(instance2) {
    __publicField(this, "type", chartType$6);
    __publicField(this, "option");
    __publicField(this, "data");
    __publicField(this, "layerColumns");
    __publicField(this, "valueColumn");
    __publicField(this, "activeDataIndex", writable(null));
    var _a2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    this.option = option;
    this.data = (_a2 = option.data) != null ? _a2 : [];
    this.layerColumns = option.layerColumns.map((column2) => {
      return parseCategoryColumn({ column: column2 });
    });
    this.valueColumn = parseValueColumn({ column: option.valueColumn });
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$6);
      instance2.tooltipContent.set(TooltipContent$5);
    });
  }
};
const index$6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$6,
  chartType: chartType$6
}, Symbol.toStringTag, { value: "Module" }));
function isBetween(domain, value) {
  return domain[0] <= value && domain[1] >= value;
}
function instance_1$j($$self, $$props, $$invalidate) {
  let guideLines;
  let $margin;
  let $chartWidth;
  let $yScale;
  let $chartHeight;
  let $xScale;
  let $sizeScale;
  let $isColorActive;
  let $font;
  let $yRange;
  let $xRange;
  let $zoom;
  let $mousePosition;
  let $makeYScale;
  let $makeXScale;
  let $activeDataIndex;
  let $getColor;
  const instance2 = getInstance();
  const { ssr, chartWidth, chartHeight, mousePosition, margin, tooltipShown, tooltipPosition, chartStore, xAxisConfig, yAxisConfig, focused, contentShapes, font, colorLegendConfig, focusable } = instance2;
  component_subscribe($$self, chartWidth, (value) => $$invalidate(23, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(25, $chartHeight = value));
  component_subscribe($$self, mousePosition, (value) => $$invalidate(33, $mousePosition = value));
  component_subscribe($$self, margin, (value) => $$invalidate(22, $margin = value));
  component_subscribe($$self, font, (value) => $$invalidate(29, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$5) {
    throw new Error();
  }
  const { option, makeXScale, makeYScale, xScale, yScale, sizeScale, activeDataIndex, xColumn, yColumn, sizeColumn, zoom, canZoom, xRange, yRange, isFocused, toggleFocused, data, colorColumn, colorUtils, opacity, textColumn } = chartStore;
  component_subscribe($$self, makeXScale, (value) => $$invalidate(35, $makeXScale = value));
  component_subscribe($$self, makeYScale, (value) => $$invalidate(34, $makeYScale = value));
  component_subscribe($$self, xScale, (value) => $$invalidate(26, $xScale = value));
  component_subscribe($$self, yScale, (value) => $$invalidate(24, $yScale = value));
  component_subscribe($$self, sizeScale, (value) => $$invalidate(27, $sizeScale = value));
  component_subscribe($$self, activeDataIndex, (value) => $$invalidate(36, $activeDataIndex = value));
  component_subscribe($$self, zoom, (value) => $$invalidate(32, $zoom = value));
  component_subscribe($$self, xRange, (value) => $$invalidate(31, $xRange = value));
  component_subscribe($$self, yRange, (value) => $$invalidate(30, $yRange = value));
  const { colorDomain, colorRange, isColorActive, getColor } = colorUtils;
  component_subscribe($$self, isColorActive, (value) => $$invalidate(28, $isColorActive = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(37, $getColor = value));
  const findOverlapped = (n2, list) => {
    return list.findIndex((item) => isOverlapped(n2, item));
  };
  const isOverlapped = (n1, n2) => {
    return n1.intersect(n2);
  };
  let activeCircles = [];
  let activeTexts = [];
  let circles = [];
  let texts = [];
  function isZero(n2) {
    return n2 > -ALPHA$1 && n2 < ALPHA$1;
  }
  let counter = 0;
  $$self.$$.update = () => {
    var _a2, _b;
    if ($$self.$$.dirty[1] & /*$getColor*/
    64) {
      {
        if (colorColumn.type === "value") {
          colorLegendConfig.set({
            show: true,
            type: "value",
            column: colorColumn,
            min: colorRange[0],
            max: colorRange[1],
            getColor: (value) => $getColor(value * (colorRange[1] - colorRange[0]) + colorRange[0])
          });
        } else if (colorColumn.type === "category") {
          colorLegendConfig.set({
            show: true,
            type: "category",
            formatter: colorColumn.formatter,
            domain: colorDomain,
            getColor: (value) => $getColor(value)
          });
        }
      }
    }
    if ($$self.$$.dirty[1] & /*$activeDataIndex, $mousePosition*/
    36) {
      {
        if ($activeDataIndex != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty[1] & /*$makeXScale, $makeYScale*/
    24) {
      {
        xAxisConfig.set(({ margin: margin2 }) => {
          var _a3, _b2, _c, _d, _e, _f, _g, _h;
          const xScale2 = $makeXScale({ margin: margin2 });
          return new ValueAxisConfig({
            show: (_b2 = (_a3 = option.xAxis) == null ? void 0 : _a3.show) != null ? _b2 : true,
            showTitle: (_d = (_c = option.xAxis) == null ? void 0 : _c.showTitle) != null ? _d : false,
            showTicks: (_f = (_e = option.xAxis) == null ? void 0 : _e.showTicks) != null ? _f : true,
            minText: (_g = option.xAxis) == null ? void 0 : _g.minText,
            maxText: (_h = option.xAxis) == null ? void 0 : _h.maxText,
            scale: xScale2,
            title: xColumn.title,
            axisFormatter: xColumn.axisFormatter
          });
        });
        yAxisConfig.set(({ margin: margin2 }) => {
          var _a3, _b2, _c, _d, _e, _f, _g, _h;
          const yScale2 = $makeYScale({ margin: margin2 });
          return new ValueAxisConfig({
            show: (_b2 = (_a3 = option.yAxis) == null ? void 0 : _a3.show) != null ? _b2 : true,
            showTitle: (_d = (_c = option.yAxis) == null ? void 0 : _c.showTitle) != null ? _d : false,
            showTicks: (_f = (_e = option.yAxis) == null ? void 0 : _e.showTicks) != null ? _f : true,
            minText: (_g = option.yAxis) == null ? void 0 : _g.minText,
            maxText: (_h = option.yAxis) == null ? void 0 : _h.maxText,
            scale: yScale2,
            title: yColumn.title,
            axisFormatter: yColumn.axisFormatter
          });
        });
      }
    }
    if ($$self.$$.dirty[0] & /*$xScale, $yScale, $yRange*/
    1157627904 | $$self.$$.dirty[1] & /*$mousePosition, $xRange, $zoom*/
    7) {
      {
        if (canZoom) {
          instance2.events.listen("wheel", (e3) => {
            var _a3, _b2, _c, _d;
            e3.preventDefault();
            e3.stopPropagation();
            if (!$xScale || !$yScale) {
              return;
            }
            if (!$mousePosition) {
              return;
            }
            if ($mousePosition[0] < $xScale.range()[0] || $mousePosition[0] > $xScale.range()[1]) {
              return;
            }
            if ($mousePosition[1] < $yScale.range()[1] || $mousePosition[1] > $yScale.range()[0]) {
              return;
            }
            const [xmin, xmax] = $xScale.domain();
            const [ymin, ymax] = $yScale.domain();
            const xValue = $xScale.invert($mousePosition[0]);
            const deltaX = -(e3.deltaY * (xmax - xmin)) / 100 / 10;
            const biasX = (xValue - xmin) / (xmax - xmin);
            const yValue = $yScale.invert($mousePosition[1]);
            const deltaY = -(e3.deltaY * (ymax - ymin)) / 100 / 10;
            const biasY = (yValue - ymin) / (ymax - ymin);
            zoom.set({
              xmin: Math.max($xRange[0], ((_a3 = $zoom == null ? void 0 : $zoom.xmin) != null ? _a3 : xmin) + deltaX * biasX),
              xmax: Math.min($xRange[1], ((_b2 = $zoom == null ? void 0 : $zoom.xmax) != null ? _b2 : xmax) - deltaX * (1 - biasX)),
              ymin: Math.max($yRange[0], ((_c = $zoom == null ? void 0 : $zoom.ymin) != null ? _c : ymin) + deltaY * biasY),
              ymax: Math.min($yRange[1], ((_d = $zoom == null ? void 0 : $zoom.ymax) != null ? _d : ymax) - deltaY * (1 - biasY))
            });
          });
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$xScale, $yScale, $chartWidth, $chartHeight, $yRange*/
    1199570944 | $$self.$$.dirty[1] & /*$mousePosition, $zoom, $xRange*/
    7) {
      {
        if (canZoom) {
          instance2.events.listen("customdrag", (e3) => {
            var _a3, _b2, _c, _d;
            const { deltaX, deltaY } = e3.detail;
            if (!$xScale || !$yScale) {
              return;
            }
            if (!$mousePosition) {
              return;
            }
            if ($mousePosition[0] < $xScale.range()[0] || $mousePosition[0] > $xScale.range()[1]) {
              return;
            }
            if ($mousePosition[1] < $yScale.range()[1] || $mousePosition[1] > $yScale.range()[0]) {
              return;
            }
            const [xmin, xmax] = $xScale.domain();
            const [ymin, ymax] = $yScale.domain();
            const xDiff = xmax - xmin;
            const yDiff = ymin - ymax;
            const deltaXValue = xDiff * (deltaX / $chartWidth);
            const deltaYValue = yDiff * (deltaY / $chartHeight);
            let xZoomMin = ((_a3 = $zoom == null ? void 0 : $zoom.xmin) != null ? _a3 : xmin) + deltaXValue;
            let xZoomMax = ((_b2 = $zoom == null ? void 0 : $zoom.xmax) != null ? _b2 : xmax) + deltaXValue;
            let yZoomMin = ((_c = $zoom == null ? void 0 : $zoom.ymin) != null ? _c : ymin) + deltaYValue;
            let yZoomMax = ((_d = $zoom == null ? void 0 : $zoom.ymax) != null ? _d : ymax) + deltaYValue;
            if (xZoomMin < $xRange[0]) {
              const d = $xRange[0] - xZoomMin;
              xZoomMin = $xRange[0];
              xZoomMax += d;
            }
            if (xZoomMax > $xRange[1]) {
              const d = xZoomMax - $xRange[1];
              xZoomMax = $xRange[1];
              xZoomMin -= d;
            }
            if (yZoomMin < $yRange[0]) {
              const d = $yRange[0] - yZoomMin;
              yZoomMin = $yRange[0];
              yZoomMax += d;
            }
            if (yZoomMax > $yRange[1]) {
              const d = yZoomMax - $yRange[1];
              yZoomMax = $yRange[1];
              yZoomMin -= d;
            }
            zoom.set({
              xmin: xZoomMin,
              xmax: xZoomMax,
              ymin: yZoomMin,
              ymax: yZoomMax
            });
          });
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$font*/
    536870912) {
      {
        $$invalidate(18, circles = []);
        $$invalidate(19, texts = []);
        data.sort((a2, b) => {
          return b.size - a2.size;
        });
        data.forEach((d, i2) => {
          $$invalidate(
            18,
            circles[i2] = new CircleShape({
              // cx: $xScale(d.x),
              // cy: $yScale(d.y),
              // r: $sizeScale(d.size),
              data: d,
              clickable: true,
              events: {
                click: derived([focusable], ([$focusable]) => () => {
                  if ($focusable) {
                    toggleFocused(get_store_value(focused), d.name, d.text);
                  }
                }),
                mouseenter: readable(() => {
                  activeDataIndex.set(i2);
                }),
                mouseleave: readable(() => {
                  activeDataIndex.set(null);
                })
              },
              focused: derived([focused], ([$focused]) => {
                return isFocused($focused, d.name, d.text);
              }),
              hoverable: true,
              hovered: derived([activeDataIndex], ([$activeDataIndex2]) => {
                return $activeDataIndex2 === i2;
              }),
              // inactive: derived([focused], ([$focused]) => {
              //     return (
              //         $focused.length > 0 &&
              //         !isFocused($focused, d.name, d.text)
              //     );
              // }),
              priority: readable(i2),
              props: derived([getColor, opacity], ([$getColor2, $opacity]) => {
                const color2 = $getColor2(d.color);
                return {
                  fill: chroma(color2).alpha($opacity).css()
                };
              })
              // opacity: $opacity
            }),
            circles
          );
          $$invalidate(
            19,
            //     return ( //         $focused.length > 0 &&
            texts[i2] = new TextShape({
              clickable: true,
              textAlign: "left",
              textBaseline: "top",
              // x: $xScale(d.x),
              // y: $yScale(d.y),
              fontSize: $font.size,
              fontFamily: $font.family,
              text: textColumn.formatter(d.text),
              data: d,
              padding: 0,
              hoverable: true,
              events: {
                click: derived([focusable], ([$focusable]) => () => {
                  if ($focusable) {
                    toggleFocused(get_store_value(focused), d.name, d.text);
                  }
                }),
                mouseenter: readable(() => {
                  activeDataIndex.set(i2);
                }),
                mouseleave: readable(() => {
                  activeDataIndex.set(null);
                })
              }
            }),
            // inactive: derived([focused], ([$focused]) => { //     return ( //         $focused.length > 0 &&
            texts
          );
        });
      }
    }
    if ($$self.$$.dirty[0] & /*circles, $xScale, $yScale, $isColorActive, $sizeScale, texts*/
    487325696) {
      {
        circles.forEach((circle) => {
          const d = circle.data;
          circle.visible.set(isBetween($xScale.domain(), d.x) && isBetween($yScale.domain(), d.y) && $isColorActive(d.color));
          circle.shapeProps.update((n2) => ({
            ...n2,
            cx: $xScale(d.x),
            cy: $yScale(d.y),
            r: $sizeScale(d.size)
          }));
        });
        texts.forEach((text2) => {
          const d = text2.data;
          text2.visible.set(isBetween($xScale.domain(), d.x) && isBetween($yScale.domain(), d.y) && $isColorActive(d.color));
          text2.shapeProps.update((n2) => ({ ...n2, x: $xScale(d.x), y: $yScale(d.y) }));
        });
      }
    }
    if ($$self.$$.dirty[0] & /*counter, circles, texts, $xScale, $yScale, $isColorActive, $margin, $chartWidth, $chartHeight, $sizeScale*/
    534511616) {
      (async () => {
        const id2 = $$invalidate(20, ++counter);
        $$invalidate(16, activeCircles = circles.filter((n2) => n2));
        $$invalidate(17, activeTexts = []);
        if (!ssr) {
          await new Promise((r2) => instance2.setTimeout(r2, 200));
          if (id2 !== counter) {
            return;
          }
        }
        const validRects = circles.filter((n2) => get_store_value(n2.visible)).map((n2) => {
          n2.apply();
          return n2.getBoundingRect();
        });
        for (let i2 = 0; i2 < data.length; i2++) {
          const d = data[i2];
          const shape = texts[i2];
          if (!(isBetween($xScale.domain(), d.x) && isBetween($yScale.domain(), d.y) && $isColorActive(d.color))) {
            continue;
          }
          shape.visible.set(true);
          const ANGLES_COUNT = 8;
          const MAX_PADDNG = 8;
          let flg = false;
          const angles = [];
          for (let j = 0; j < ANGLES_COUNT + 1; j++) {
            const rad = j * (Math.PI * 2 / ANGLES_COUNT);
            const dx = Math.cos(rad);
            const dy = Math.sin(rad);
            angles[j] = { dx, dy };
          }
          for (let pad = 0; pad < MAX_PADDNG + 1; pad += 1) {
            for (let j = 0; j < ANGLES_COUNT + 1; j++) {
              const x2 = $xScale(d.x);
              const y2 = $yScale(d.y);
              if (x2 < $margin.left || y2 < $margin.top || x2 > $chartWidth - $margin.right || y2 > $chartHeight - $margin.bottom) {
                continue;
              }
              const { dx, dy } = angles[j];
              const padding2 = $sizeScale(d.size) + pad + 1;
              shape.shapeProps.set({
                ...get_store_value(shape.shapeProps),
                textAlign: isZero(dx) ? "center" : dx > 0 ? "left" : "right",
                textBaseline: isZero(dy) ? "middle" : dy > 0 ? "top" : "bottom",
                x: x2 + (isZero(dx) ? 0 : dx > 0 ? 1 : -1) * padding2,
                y: y2 + (isZero(dy) ? 0 : dy > 0 ? 1 : -1) * padding2
              });
              shape.apply();
              const rect = shape.getBoundingRect();
              if (rect.x < $margin.left || rect.y < $margin.top || rect.x + rect.width > $chartWidth - $margin.right || rect.y + rect.height > $chartHeight - $margin.bottom) {
                continue;
              }
              const result = findOverlapped(rect, validRects);
              if (result === -1) {
                rect.visible = true;
                validRects.push(rect);
                shape.visible.set(true);
                flg = true;
                break;
              }
            }
            if (flg === true) {
              break;
            }
          }
          if (flg === false) {
            shape.visible.set(false);
          }
        }
        $$invalidate(17, activeTexts = texts.filter((n2) => n2));
      })();
    }
    if ($$self.$$.dirty[0] & /*$xScale, $margin, $chartHeight, $yScale, $chartWidth*/
    130023424) {
      $$invalidate(21, guideLines = (_b = (_a2 = option.guideLines) == null ? void 0 : _a2.flatMap((n2) => {
        if (n2.data.xAxis != null) {
          return [
            new LineShape({
              x1: $xScale(n2.data.xAxis),
              x2: $xScale(n2.data.xAxis),
              y1: $margin.top,
              y2: $chartHeight - $margin.bottom,
              props: readable({
                fill: "transparent",
                stroke: "#aaa",
                "stroke-width": 2,
                "stroke-dasharray": "8px 8px"
              })
            })
          ];
        }
        if (n2.data.yAxis != null) {
          return [
            new LineShape({
              y1: $yScale(n2.data.yAxis),
              y2: $yScale(n2.data.yAxis),
              x1: $margin.left,
              x2: $chartWidth - $margin.right,
              props: readable({
                fill: "transparent",
                stroke: "#aaa",
                "stroke-width": 2,
                "stroke-dasharray": "8px 8px"
              })
            })
          ];
        }
        return [];
      })) != null ? _b : []);
    }
    if ($$self.$$.dirty[0] & /*activeTexts, activeCircles, guideLines*/
    2293760) {
      {
        activeTexts.forEach((n2) => {
          n2.apply();
        });
        contentShapes.set([...activeTexts, ...activeCircles, ...guideLines]);
      }
    }
  };
  return [
    chartWidth,
    chartHeight,
    mousePosition,
    margin,
    font,
    makeXScale,
    makeYScale,
    xScale,
    yScale,
    sizeScale,
    activeDataIndex,
    zoom,
    xRange,
    yRange,
    isColorActive,
    getColor,
    activeCircles,
    activeTexts,
    circles,
    texts,
    counter,
    guideLines,
    $margin,
    $chartWidth,
    $yScale,
    $chartHeight,
    $xScale,
    $sizeScale,
    $isColorActive,
    $font,
    $yRange,
    $xRange,
    $zoom,
    $mousePosition,
    $makeYScale,
    $makeXScale,
    $activeDataIndex,
    $getColor
  ];
}
let Content$5 = class Content12 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$j, null, safe_not_equal, {}, null, [-1, -1, -1]);
  }
};
function get_each_context$4(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[16] = list[i2].key;
  child_ctx[17] = list[i2].column;
  child_ctx[19] = i2;
  return child_ctx;
}
function create_if_block$c(ctx2) {
  let div1;
  let div0;
  let div1_style_value;
  let each_value = ensure_array_like(
    /*columns*/
    ctx2[3]
  );
  let each_blocks = [];
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    each_blocks[i2] = create_each_block$4(get_each_context$4(ctx2, each_value, i2));
  }
  return {
    c() {
      div1 = element("div");
      div0 = element("div");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      attr(div1, "style", div1_style_value = new Style({
        ...tooltipOuter.cssObject,
        border: `2px solid ${/*$getColor*/
        ctx2[1](
          /*activeData*/
          ctx2[0].color
        )}`
      }).toString());
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append$2(div1, div0);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(div0, null);
        }
      }
    },
    p(ctx3, dirty) {
      if (dirty & /*columns, activeData*/
      9) {
        each_value = ensure_array_like(
          /*columns*/
          ctx3[3]
        );
        let i2;
        for (i2 = 0; i2 < each_value.length; i2 += 1) {
          const child_ctx = get_each_context$4(ctx3, each_value, i2);
          if (each_blocks[i2]) {
            each_blocks[i2].p(child_ctx, dirty);
          } else {
            each_blocks[i2] = create_each_block$4(child_ctx);
            each_blocks[i2].c();
            each_blocks[i2].m(div0, null);
          }
        }
        for (; i2 < each_blocks.length; i2 += 1) {
          each_blocks[i2].d(1);
        }
        each_blocks.length = each_value.length;
      }
      if (dirty & /*$getColor, activeData*/
      3 && div1_style_value !== (div1_style_value = new Style({
        ...tooltipOuter.cssObject,
        border: `2px solid ${/*$getColor*/
        ctx3[1](
          /*activeData*/
          ctx3[0].color
        )}`
      }).toString())) {
        attr(div1, "style", div1_style_value);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(div1);
      }
      destroy_each(each_blocks, detaching);
    }
  };
}
function create_else_block$2(ctx2) {
  let t_value = (
    /*column*/
    ctx2[17].formatter(
      /*activeData*/
      ctx2[0][
        /*key*/
        ctx2[16]
      ]
    ) + ""
  );
  let t2;
  return {
    c() {
      t2 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t2, anchor);
    },
    p(ctx3, dirty) {
      if (dirty & /*activeData*/
      1 && t_value !== (t_value = /*column*/
      ctx3[17].formatter(
        /*activeData*/
        ctx3[0][
          /*key*/
          ctx3[16]
        ]
      ) + ""))
        set_data(t2, t_value);
    },
    d(detaching) {
      if (detaching) {
        detach(t2);
      }
    }
  };
}
function create_if_block_1$4(ctx2) {
  let t_value = (
    /*column*/
    ctx2[17].formatter(
      /*activeData*/
      ctx2[0][
        /*key*/
        ctx2[16]
      ]
    ) + ""
  );
  let t2;
  return {
    c() {
      t2 = text(t_value);
    },
    m(target, anchor) {
      insert(target, t2, anchor);
    },
    p(ctx3, dirty) {
      if (dirty & /*activeData*/
      1 && t_value !== (t_value = /*column*/
      ctx3[17].formatter(
        /*activeData*/
        ctx3[0][
          /*key*/
          ctx3[16]
        ]
      ) + ""))
        set_data(t2, t_value);
    },
    d(detaching) {
      if (detaching) {
        detach(t2);
      }
    }
  };
}
function create_each_block$4(ctx2) {
  let div2;
  let div0;
  let t1;
  let div1;
  let t2;
  function select_block_type(ctx3, dirty) {
    if (
      /*column*/
      ctx3[17].type === "value"
    )
      return create_if_block_1$4;
    return create_else_block$2;
  }
  let current_block_type = select_block_type(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      div0.textContent = `${/*column*/
      ctx2[17].title || ""}`;
      t1 = space();
      div1 = element("div");
      if_block.c();
      t2 = space();
      attr(div0, "style", tooltipItemLabel);
      attr(div1, "style", tooltipItemValue);
      attr(div2, "style", tooltipItem);
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append$2(div2, div0);
      append$2(div2, t1);
      append$2(div2, div1);
      if_block.m(div1, null);
      append$2(div2, t2);
    },
    p(ctx3, dirty) {
      if_block.p(ctx3, dirty);
    },
    d(detaching) {
      if (detaching) {
        detach(div2);
      }
      if_block.d();
    }
  };
}
function create_fragment$i(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*activeData*/
    ctx2[0] != null && create_if_block$c(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*activeData*/
        ctx3[0] != null
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$c(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$i($$self, $$props, $$invalidate) {
  let activeData;
  let $activeDataIndex;
  let $getColor;
  const instance2 = getInstance();
  const { chartStore, font } = instance2;
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$5) {
    throw new Error();
  }
  const { data, textColumn, xColumn, yColumn, colorColumn, sizeColumn, colorUtils, activeDataIndex } = chartStore;
  component_subscribe($$self, activeDataIndex, (value) => $$invalidate(5, $activeDataIndex = value));
  const columns = [
    ...colorColumn ? [{ key: "color", column: colorColumn }] : [],
    { key: "text", column: textColumn },
    { key: "size", column: sizeColumn },
    { key: "x", column: xColumn },
    { key: "y", column: yColumn }
  ].filter((x2, i2, self2) => self2.findIndex((y2) => x2.column.key === y2.column.key) === i2);
  const { getColor } = colorUtils;
  component_subscribe($$self, getColor, (value) => $$invalidate(1, $getColor = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeDataIndex*/
    32) {
      $$invalidate(0, activeData = (() => {
        if ($activeDataIndex == null) {
          return null;
        }
        return data[$activeDataIndex];
      })());
    }
  };
  return [activeData, $getColor, activeDataIndex, columns, getColor, $activeDataIndex];
}
let TooltipContent$4 = class TooltipContent8 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$i, create_fragment$i, safe_not_equal, {});
  }
};
const chartType$5 = "scatter";
let Store$5 = class Store11 {
  constructor(instance2) {
    __publicField(this, "type", chartType$5);
    __publicField(this, "option");
    __publicField(this, "data");
    __publicField(this, "xColumn");
    __publicField(this, "yColumn");
    __publicField(this, "sizeColumn");
    __publicField(this, "colorColumn");
    __publicField(this, "textColumn");
    __publicField(this, "colorUtils");
    __publicField(this, "canZoom");
    __publicField(this, "xRange");
    __publicField(this, "yRange");
    __publicField(this, "makeXScale");
    __publicField(this, "makeYScale");
    __publicField(this, "xScale");
    __publicField(this, "yScale");
    __publicField(this, "sizeScale");
    __publicField(this, "activeDataIndex");
    __publicField(this, "zoom");
    __publicField(this, "opacity");
    __publicField(this, "isFocused");
    __publicField(this, "toggleFocused");
    __publicField(this, "fit");
    __publicField(this, "reset");
    var _a2, _b, _c;
    const { focused, chartWidth, chartHeight, margin, colorLegendActives } = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    const canZoom = (_a2 = option.zoom) != null ? _a2 : false;
    this.opacity = writable((_b = option == null ? void 0 : option.opacity) != null ? _b : 0.6);
    const activeDataIndex = writable(null);
    const zoom = writable(null);
    const textColumn = parseCategoryColumn({ column: option.textColumn });
    const xColumn = parseValueColumn({ column: option.xColumn });
    const yColumn = parseValueColumn({ column: option.yColumn });
    const sizeColumn = parseValueColumn({ column: option.sizeColumn });
    let colorColumn = null;
    if (option.colorColumn) {
      colorColumn = option.colorColumn.type === "category" ? parseCategoryColumn({
        column: option.colorColumn
      }) : parseValueColumn({
        column: option.colorColumn
      });
    } else {
      colorColumn = parseCategoryColumn({
        column: {
          key: "__COLOR__"
        }
      });
    }
    this.colorColumn = colorColumn;
    const data = dataMapper((_c = option.data) != null ? _c : [], [
      {
        key: "text",
        column: textColumn
      },
      {
        key: "x",
        column: xColumn
      },
      {
        key: "y",
        column: yColumn
      },
      {
        key: "size",
        column: sizeColumn
      },
      ...colorColumn ? [{ key: "color", column: colorColumn }] : []
    ]);
    this.colorUtils = parseColorUtils({ colorColumn, data, instance: instance2 });
    const { isColorActive } = this.colorUtils;
    const xRange = derived([isColorActive], ([$isColorActive]) => {
      var _a3, _b2, _c2, _d;
      const values = data.filter((d) => $isColorActive(d.color)).map((d) => +d.x);
      return [
        (_b2 = (_a3 = xColumn.min) != null ? _a3 : min$1(values)) != null ? _b2 : 0,
        (_d = (_c2 = xColumn.max) != null ? _c2 : max$1(values)) != null ? _d : 0
      ];
    });
    const yRange = derived([isColorActive], ([$isColorActive]) => {
      var _a3, _b2, _c2, _d;
      const values = data.filter((d) => $isColorActive(d.color)).map((d) => +d.y);
      return [
        (_b2 = (_a3 = yColumn.min) != null ? _a3 : min$1(values)) != null ? _b2 : 0,
        (_d = (_c2 = yColumn.max) != null ? _c2 : max$1(values)) != null ? _d : 0
      ];
    });
    const makeXScale = derived(
      [chartWidth, zoom, xRange],
      ([chartWidth2, zoom2, $xRange]) => (args) => {
        const { margin: margin2 } = args;
        if (zoom2) {
          return linear().domain([zoom2.xmin, zoom2.xmax]).range([margin2.left, chartWidth2 - margin2.right]);
        }
        return linear().domain($xRange).range([margin2.left, chartWidth2 - margin2.right]);
      }
    );
    const xScale = derived(
      [makeXScale, margin],
      ([makeXScale2, margin2]) => makeXScale2({ margin: margin2 })
    );
    const makeYScale = derived(
      [chartHeight, zoom, yRange],
      ([chartHeight2, zoom2, $yRange]) => (args) => {
        const { margin: margin2 } = args;
        if (zoom2) {
          return linear().domain([zoom2.ymin, zoom2.ymax]).range([chartHeight2 - margin2.bottom, margin2.top]);
        }
        return linear().domain($yRange).range([chartHeight2 - margin2.bottom, margin2.top]);
      }
    );
    const yScale = derived(
      [makeYScale, margin],
      ([makeYScale2, margin2]) => makeYScale2({ margin: margin2 })
    );
    const sizeScale = derived(
      [colorLegendActives],
      ([colorLegendActives2]) => {
        var _a3, _b2, _c2, _d, _e;
        const values = data.map((d) => +d.size);
        return linear().domain([
          (_b2 = (_a3 = sizeColumn.min) != null ? _a3 : min$1(values)) != null ? _b2 : 0,
          (_d = (_c2 = sizeColumn.max) != null ? _c2 : max$1(values)) != null ? _d : 0
        ]).range((_e = option.sizeRange) != null ? _e : [8, 24]);
      }
    );
    function isFocused($focused, name, text2) {
      return $focused.some(
        (focused2) => focused2[textColumn.key] === text2
      );
    }
    function toggleFocused($focused, name, text2) {
      if (isFocused($focused, name, text2)) {
        focused.update((focused2) => {
          return focused2.filter(
            (focused3) => !(focused3[textColumn.key] === text2)
          );
        });
      } else {
        focused.update((focused2) => {
          return [
            ...focused2,
            {
              // [seriesColumn.key]: name,
              [textColumn.key]: text2
            }
          ];
        });
      }
    }
    const fit = () => {
      var _a3, _b2, _c2, _d;
      get_store_value(colorLegendActives);
      const xValues = data.map((d) => +d.x);
      const yValues = data.map((d) => +d.y);
      zoom.set({
        xmin: (_a3 = min$1(xValues)) != null ? _a3 : 0,
        xmax: (_b2 = max$1(xValues)) != null ? _b2 : 0,
        ymin: (_c2 = min$1(yValues)) != null ? _c2 : 0,
        ymax: (_d = max$1(yValues)) != null ? _d : 0
      });
    };
    const reset = () => {
      zoom.set(null);
    };
    this.option = option;
    this.canZoom = canZoom;
    this.data = data;
    this.xColumn = xColumn;
    this.yColumn = yColumn;
    this.sizeColumn = sizeColumn;
    this.textColumn = textColumn;
    this.xRange = xRange;
    this.yRange = yRange;
    this.makeXScale = makeXScale;
    this.makeYScale = makeYScale;
    this.xScale = xScale;
    this.yScale = yScale;
    this.sizeScale = sizeScale;
    this.activeDataIndex = activeDataIndex;
    this.zoom = zoom;
    this.isFocused = isFocused;
    this.toggleFocused = toggleFocused;
    this.fit = fit;
    this.reset = reset;
    instance2.menuExtraButtons.set([
      {
        key: "fit",
        title: "フィット",
        onClick: fit
      },
      {
        key: "reset",
        title: "リセット",
        onClick: reset
      }
    ]);
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$5);
      instance2.tooltipContent.set(TooltipContent$4);
    });
    instance2.tableConfig.set({
      columns: [
        {
          ...colorColumn,
          key: "name",
          type: "dimension",
          align: "left"
        },
        {
          ...textColumn,
          key: "text",
          type: "dimension",
          align: "left"
        },
        {
          ...xColumn,
          key: "x",
          type: "metric",
          align: "right"
        },
        {
          ...yColumn,
          key: "y",
          type: "metric",
          align: "right"
        }
      ],
      data
    });
  }
};
const index$5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$5,
  chartType: chartType$5
}, Symbol.toStringTag, { value: "Module" }));
function instance_1$h($$self, $$props, $$invalidate) {
  let $innerHeight;
  let $innerWidth;
  const instance2 = getInstance();
  const { chartStore, innerWidth, innerHeight } = instance2;
  component_subscribe($$self, innerWidth, (value) => $$invalidate(3, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(2, $innerHeight = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== "scoreCard") {
    throw new Error();
  }
  const { option, data, metric } = chartStore;
  $$self.$$.update = () => {
    var _a2, _b;
    if ($$self.$$.dirty & /*$innerWidth, $innerHeight*/
    12) {
      {
        if (data.length > 0) {
          const d = data[0];
          const value = metric.valueGetter(d);
          const valueText = metric.formatter(value);
          const text2 = new TextShape({
            text: `${(_a2 = option.prefix) != null ? _a2 : ""}${valueText}${(_b = option.suffix) != null ? _b : ""}`,
            textAlign: "center",
            textBaseline: "middle",
            fontSize: 48,
            fontFamily: DEFAULT_FONT_FAMILY,
            props: readable({ fill: "#333" })
          });
          text2.getBoundingRect();
          text2.shapeProps.update((n2) => ({
            ...n2,
            x: $innerWidth / 2,
            y: $innerHeight / 2
          }));
          text2.apply();
          instance2.contentShapes.set([text2]);
        }
      }
    }
  };
  return [innerWidth, innerHeight, $innerHeight, $innerWidth];
}
let Content$4 = class Content13 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$h, null, safe_not_equal, {});
  }
};
const chartType$4 = "scoreCard";
let Store$4 = class Store12 {
  constructor(instance2) {
    __publicField(this, "type");
    __publicField(this, "intance");
    __publicField(this, "option");
    __publicField(this, "data");
    __publicField(this, "metric");
    var _a2;
    this.intance = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    this.type = option.type;
    this.option = option;
    this.data = (_a2 = option.data) != null ? _a2 : [];
    this.metric = parseValueColumn({ column: option.metric });
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$4);
    });
    instance2.menuExtraButtons.set([
      // {
      //     key: 'switch',
      //     title: '線グラフに切り替え',
      //     onClick: () => {
      //         instance.option.update((option) => {
      //             return { ...option, type: 'line' } as any;
      //         });
      //     }
      // },
      // {
      //     key: 'stack',
      //     title: '積み上げ',
      //     onClick: () => {
      //         stack.update((stack) => !stack);
      //     }
      // },
      // {
      //     key: 'stack',
      //     title: '比率',
      //     onClick: () => {
      //         percent.update((value) => !value);
      //     }
      // }
    ]);
  }
};
const index$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$4,
  chartType: chartType$4
}, Symbol.toStringTag, { value: "Module" }));
const beardLength = 8;
const labelPadding$1 = 8;
function instance$7($$self, $$props, $$invalidate) {
  let getLabelPos;
  let shapes;
  let $margin;
  let $innerHeight;
  let $innerWidth;
  let $font;
  let $activeTotal;
  let $getValue;
  let $isColorActive;
  const { chartWidth, chartHeight, innerWidth, innerHeight, margin, focused, focusable, chartStore, font } = getInstance();
  component_subscribe($$self, innerWidth, (value) => $$invalidate(20, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(19, $innerHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(18, $margin = value));
  component_subscribe($$self, font, (value) => $$invalidate(21, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$3) {
    throw new Error();
  }
  const { getValue, activeTotal, activeSerie, colorMap, isColorActive } = chartStore;
  component_subscribe($$self, getValue, (value) => $$invalidate(23, $getValue = value));
  component_subscribe($$self, activeTotal, (value) => $$invalidate(22, $activeTotal = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(24, $isColorActive = value));
  let { radius = 0 } = $$props;
  let { innerRadius = 0 } = $$props;
  let { contentShapes } = $$props;
  let { beard } = $$props;
  let { entry } = $$props;
  let { setContentShapes } = $$props;
  let outerArc;
  let innerArc;
  let pieArc;
  const group = new GroupShape({ children: [] });
  setContentShapes([group]);
  $$self.$$set = ($$props2) => {
    if ("radius" in $$props2)
      $$invalidate(7, radius = $$props2.radius);
    if ("innerRadius" in $$props2)
      $$invalidate(8, innerRadius = $$props2.innerRadius);
    if ("contentShapes" in $$props2)
      $$invalidate(9, contentShapes = $$props2.contentShapes);
    if ("beard" in $$props2)
      $$invalidate(10, beard = $$props2.beard);
    if ("entry" in $$props2)
      $$invalidate(11, entry = $$props2.entry);
    if ("setContentShapes" in $$props2)
      $$invalidate(12, setContentShapes = $$props2.setContentShapes);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*radius, innerRadius*/
    384) {
      {
        $$invalidate(14, innerArc = arc().innerRadius(radius).outerRadius(radius));
        $$invalidate(13, outerArc = arc().innerRadius(radius + labelPadding$1).outerRadius(radius + labelPadding$1));
        $$invalidate(15, pieArc = arc().innerRadius(innerRadius).outerRadius(radius));
      }
    }
    if ($$self.$$.dirty[0] & /*outerArc*/
    8192) {
      $$invalidate(17, getLabelPos = (d) => {
        const midAngle = d.startAngle + (d.endAngle - d.startAngle) / 2;
        const labelX = (() => {
          const pos = outerArc.centroid(d);
          pos[0] = pos[0] + beardLength * (midAngle < Math.PI ? 1 : -1);
          return pos[0];
        })();
        const labelY = (() => {
          const pos = outerArc.centroid(d);
          return pos[1];
        })();
        return {
          x: labelX,
          y: labelY,
          textAlign: (() => {
            return midAngle < Math.PI ? "left" : "right";
          })()
        };
      });
    }
    if ($$self.$$.dirty[0] & /*entry, $activeTotal, $isColorActive, $getValue, radius, outerArc, innerArc, pieArc, getLabelPos, innerRadius, $font, beard*/
    31649152) {
      $$invalidate(16, shapes = (() => {
        let prev2 = 0;
        return entry.seriesDomain.flatMap((series, index2) => {
          if ($activeTotal === 0) {
            return [];
          }
          const record = entry.data.find((d2) => d2.allSeries === series);
          if (!record) {
            return [];
          }
          if (!$isColorActive(record.allSeries)) {
            return [];
          }
          const value = asValidNumber($getValue(series) / $activeTotal);
          const prevValue = prev2;
          const currentValue = value + prev2;
          prev2 += value;
          const color2 = colorMap.get(series);
          const angle = asValidNumber(value * (Math.PI * 2));
          const startAngle = asValidNumber(prevValue * (Math.PI * 2));
          const endAngle = asValidNumber(currentValue * (Math.PI * 2));
          const midAngle = startAngle + (endAngle - startAngle) / 2;
          const d = {
            innerRadius: radius,
            outerRadius: radius,
            startAngle,
            endAngle
          };
          const outerCentroid = outerArc.centroid(d);
          const innerCentroid = innerArc.centroid(d);
          const pieCenteroid = pieArc.centroid(d);
          const labelPos = getLabelPos(d);
          const label = entry.labelFormatter ? entry.labelFormatter(record) : null;
          const innerLabel = entry.innerLabelFormatter ? entry.innerLabelFormatter(record) : null;
          const sector = new SectorShape({
            clickable: true,
            events: {
              click: readable(() => {
                entry.toggleFocused(get_store_value(focused), series);
              }),
              mouseenter: readable(() => {
                activeSerie.set(series);
              }),
              mouseleave: readable(() => {
                activeSerie.set(null);
              })
            },
            focused: derived([focused], ([$focused]) => {
              return entry.isFocused($focused, series);
            }),
            hoverable: true,
            hovered: derived([activeSerie], ([$activeSerie]) => {
              return $activeSerie === series;
            }),
            inactive: derived([focused], ([$focused]) => {
              return $focused.length > 0 && !entry.isFocused($focused, series);
            }),
            props: readable({ fill: color2, stroke: "#fff" }),
            // 'stroke-width': 1
            cx: 0,
            cy: 0,
            r: radius,
            r0: innerRadius,
            startAngle: startAngle - Math.PI / 2,
            endAngle: endAngle - Math.PI / 2,
            largeArc: angle > Math.PI,
            data: { series }
          });
          return [
            {
              data: d,
              labelVisible: false,
              labelData: { ...d },
              startAngle,
              endAngle,
              sector,
              line2: new LineShape({
                x1: innerCentroid[0],
                y1: innerCentroid[1],
                x2: outerCentroid[0],
                y2: outerCentroid[1],
                props: readable({ stroke: color2 })
              }),
              line: new LineShape({
                x1: outerCentroid[0],
                y1: outerCentroid[1],
                x2: labelPos.x,
                y2: labelPos.y,
                props: readable({ stroke: color2 })
              }),
              innerText: innerLabel ? new TextShape({
                data: { midAngle },
                padding: 0,
                x: pieCenteroid[0],
                y: pieCenteroid[1],
                textAlign: "center",
                textBaseline: "middle",
                text: innerLabel,
                fontSize: $font.size,
                fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                overflow: "ignore",
                backgroundColor: color2,
                inactive: derived([focused], ([$focused]) => {
                  return $focused.length > 0 && !entry.isFocused($focused, series);
                })
              }) : null,
              text: beard && label ? new TextShape({
                data: { midAngle },
                padding: 0,
                x: labelPos.x,
                y: labelPos.y,
                textAlign: (() => {
                  return midAngle < Math.PI ? "left" : "right";
                })(),
                textBaseline: "middle",
                text: label,
                fontSize: $font.size,
                fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                overflow: "ignore",
                props: readable({ fill: "#333" }),
                inactive: derived([focused], ([$focused]) => {
                  return $focused.length > 0 && !entry.isFocused($focused, series);
                })
              }) : null
            }
          ];
        });
      })());
    }
    if ($$self.$$.dirty[0] & /*$innerWidth, $margin, $innerHeight*/
    1835008) {
      {
        group.shapeProps.update((n2) => ({
          ...n2,
          x: $innerWidth / 2 + $margin.left,
          y: $innerHeight / 2 + $margin.top
        }));
      }
    }
    if ($$self.$$.dirty[0] & /*shapes, getLabelPos*/
    196608) {
      {
        let isOverlapped = function(target) {
          return visibleShapes.some((shape) => shape.intersect(target.getBoundingRect()));
        }, findOverlappingShapes = function(currentShape, index2) {
          if (!currentShape.text) {
            return [];
          }
          const find2 = shapes.find((nextShape, i2) => {
            if (i2 < index2) {
              return false;
            }
            if (!nextShape.text || !currentShape.text) {
              return false;
            }
            return nextShape.text.intersect(currentShape.text.getBoundingRect());
          });
          return find2 ? [find2] : [];
        }, normalizeArc = function(d) {
          if (d.startAngle < 0) {
            d.startAngle = 0;
          }
          if (d.endAngle < 0) {
            d.endAngle = 0;
          }
          if (d.startAngle > Math.PI * 2) {
            d.startAngle = Math.PI * 2;
          }
          if (d.endAngle > Math.PI * 2) {
            d.endAngle = Math.PI * 2;
          }
        };
        const visibleShapes = [];
        const unit2 = Math.PI * 2 / 360 / 2;
        const maxDiffAngle = Math.PI * 2 * 30 / 360;
        let n2 = 0;
        let flg = true;
        while (flg && n2++ < 100) {
          flg = false;
          shapes.forEach((shape, i2) => {
            const overlappingShapes = findOverlappingShapes(shape, i2 + 1);
            if (overlappingShapes.length > 0) {
              flg = true;
              if (shape.data.startAngle - shape.labelData.startAngle < maxDiffAngle) {
                shape.labelData.startAngle -= unit2;
                shape.labelData.endAngle -= unit2;
                normalizeArc(shape.labelData);
              }
              if (shape.text) {
                shape.text.shapeProps.update((n22) => ({ ...n22, ...getLabelPos(shape.labelData) }));
                shape.text.apply();
              }
              overlappingShapes.forEach((shape2) => {
                if (shape2.labelData.endAngle - shape2.data.endAngle < maxDiffAngle) {
                  shape2.labelData.startAngle += unit2;
                  shape2.labelData.endAngle += unit2;
                  normalizeArc(shape2.labelData);
                }
                if (shape2.text) {
                  shape2.text.shapeProps.update((n22) => ({ ...n22, ...getLabelPos(shape2.labelData) }));
                  shape2.text.apply();
                }
              });
            }
          });
        }
        shapes.forEach(({ sector, line: line2, line2: line22, text: text2, innerText }) => {
          if (innerText) {
            const rect = innerText.getBoundingRect();
            if (sector.contain(rect.x, rect.y) && sector.contain(rect.x + rect.width, rect.y) && sector.contain(rect.x, rect.y + rect.height) && sector.contain(rect.x + rect.width, rect.y + rect.height)) {
              if (isOverlapped(innerText)) {
                innerText.visible.set(false);
              } else {
                visibleShapes.push(innerText);
              }
            }
          }
          if (text2) {
            if (isOverlapped(text2)) {
              line2.visible.set(false);
              line22.visible.set(false);
              text2.visible.set(false);
            } else {
              const { x: x2, y: y2, textAlign } = text2.$shapeProps;
              const stepX = x2 + (textAlign === "left" ? -1 : 1) * beardLength;
              const stepY = y2;
              line2.shapeProps.update((n22) => ({
                ...n22,
                x1: stepX,
                y1: stepY,
                x2,
                y2
              }));
              line22.shapeProps.update((n22) => ({ ...n22, x2: stepX, y2: stepY }));
              visibleShapes.push(text2);
            }
          }
        });
        group.shapeProps.update((n22) => ({
          ...n22,
          children: [
            ...shapes.flatMap(({ sector }) => {
              return [sector];
            }),
            ...shapes.flatMap(({ line: line2, line2: line22, text: text2 }) => text2 ? [line2, line22] : []),
            ...shapes.flatMap(({ text: text2 }) => text2 ? [text2] : []),
            ...shapes.flatMap(({ innerText }) => innerText && visibleShapes.includes(innerText) ? [innerText] : [])
          ]
        }));
      }
    }
  };
  return [
    innerWidth,
    innerHeight,
    margin,
    font,
    getValue,
    activeTotal,
    isColorActive,
    radius,
    innerRadius,
    contentShapes,
    beard,
    entry,
    setContentShapes,
    outerArc,
    innerArc,
    pieArc,
    shapes,
    getLabelPos,
    $margin,
    $innerHeight,
    $innerWidth,
    $font,
    $activeTotal,
    $getValue,
    $isColorActive
  ];
}
class Pie2 extends SvelteComponent {
  constructor(options) {
    super();
    init(
      this,
      options,
      instance$7,
      null,
      safe_not_equal,
      {
        radius: 7,
        innerRadius: 8,
        contentShapes: 9,
        beard: 10,
        entry: 11,
        setContentShapes: 12
      },
      null,
      [-1, -1]
    );
  }
}
function get_each_context$3(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[25] = list[i2];
  child_ctx[27] = i2;
  return child_ctx;
}
function create_each_block$3(ctx2) {
  let pie;
  let current;
  function func(...args) {
    return (
      /*func*/
      ctx2[13](
        /*i*/
        ctx2[27],
        ...args
      )
    );
  }
  pie = new Pie2({
    props: {
      beard: (
        /*i*/
        ctx2[27] === /*entries*/
        ctx2[9].length - 1
      ),
      radius: (
        /*i*/
        (ctx2[27] + 2) * /*radius*/
        ctx2[0] / /*entries*/
        (ctx2[9].length + 1)
      ),
      innerRadius: (
        /*i*/
        (ctx2[27] + 1) * /*radius*/
        ctx2[0] / /*entries*/
        (ctx2[9].length + 1)
      ),
      entry: (
        /*entry*/
        ctx2[25]
      ),
      contentShapes: (
        /*shapes*/
        ctx2[1][
          /*i*/
          ctx2[27]
        ]
      ),
      setContentShapes: func
    }
  });
  return {
    c() {
      create_component(pie.$$.fragment);
    },
    m(target, anchor) {
      mount_component(pie, target, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      const pie_changes = {};
      if (dirty & /*radius*/
      1)
        pie_changes.radius = /*i*/
        (ctx2[27] + 2) * /*radius*/
        ctx2[0] / /*entries*/
        (ctx2[9].length + 1);
      if (dirty & /*radius*/
      1)
        pie_changes.innerRadius = /*i*/
        (ctx2[27] + 1) * /*radius*/
        ctx2[0] / /*entries*/
        (ctx2[9].length + 1);
      if (dirty & /*shapes*/
      2)
        pie_changes.contentShapes = /*shapes*/
        ctx2[1][
          /*i*/
          ctx2[27]
        ];
      if (dirty & /*shapes*/
      2)
        pie_changes.setContentShapes = func;
      pie.$set(pie_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(pie.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(pie.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(pie, detaching);
    }
  };
}
function create_if_block$b(ctx2) {
  let g;
  let g_transform_value;
  return {
    c() {
      g = svg_element("g");
      attr(g, "transform", g_transform_value = translate(
        /*$innerWidth*/
        (ctx2[4] - /*iconWidth*/
        ctx2[2]) / 2,
        /*$innerHeight*/
        (ctx2[3] - /*iconWidth*/
        ctx2[2]) / 2
      ));
    },
    m(target, anchor) {
      insert(target, g, anchor);
      g.innerHTML = /*iconHtml*/
      ctx2[5];
    },
    p(ctx3, dirty) {
      if (dirty & /*iconHtml*/
      32)
        g.innerHTML = /*iconHtml*/
        ctx3[5];
      if (dirty & /*$innerWidth, iconWidth, $innerHeight*/
      28 && g_transform_value !== (g_transform_value = translate(
        /*$innerWidth*/
        (ctx3[4] - /*iconWidth*/
        ctx3[2]) / 2,
        /*$innerHeight*/
        (ctx3[3] - /*iconWidth*/
        ctx3[2]) / 2
      ))) {
        attr(g, "transform", g_transform_value);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(g);
      }
    }
  };
}
function create_fragment$h(ctx2) {
  let t2;
  let if_block_anchor;
  let current;
  let each_value = ensure_array_like(
    /*entries*/
    ctx2[9]
  );
  let each_blocks = [];
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    each_blocks[i2] = create_each_block$3(get_each_context$3(ctx2, each_value, i2));
  }
  const out = (i2) => transition_out(each_blocks[i2], 1, 1, () => {
    each_blocks[i2] = null;
  });
  let if_block = (
    /*iconHtml*/
    ctx2[5] && create_if_block$b(ctx2)
  );
  return {
    c() {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      t2 = space();
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(target, anchor);
        }
      }
      insert(target, t2, anchor);
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx3, [dirty]) {
      if (dirty & /*entries, radius, shapes*/
      515) {
        each_value = ensure_array_like(
          /*entries*/
          ctx3[9]
        );
        let i2;
        for (i2 = 0; i2 < each_value.length; i2 += 1) {
          const child_ctx = get_each_context$3(ctx3, each_value, i2);
          if (each_blocks[i2]) {
            each_blocks[i2].p(child_ctx, dirty);
            transition_in(each_blocks[i2], 1);
          } else {
            each_blocks[i2] = create_each_block$3(child_ctx);
            each_blocks[i2].c();
            transition_in(each_blocks[i2], 1);
            each_blocks[i2].m(t2.parentNode, t2);
          }
        }
        group_outros();
        for (i2 = each_value.length; i2 < each_blocks.length; i2 += 1) {
          out(i2);
        }
        check_outros();
      }
      if (
        /*iconHtml*/
        ctx3[5]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$b(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i(local) {
      if (current)
        return;
      for (let i2 = 0; i2 < each_value.length; i2 += 1) {
        transition_in(each_blocks[i2]);
      }
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        transition_out(each_blocks[i2]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(t2);
        detach(if_block_anchor);
      }
      destroy_each(each_blocks, detaching);
      if (if_block)
        if_block.d(detaching);
    }
  };
}
const labelPadding = 8;
function translate(x2, y2) {
  return `translate(${x2},${y2})`;
}
function instance_1$g($$self, $$props, $$invalidate) {
  let iconWidth;
  let iconHtml;
  let $innerHeight;
  let $innerWidth;
  let $mousePosition;
  let $activeSerie;
  const instance2 = getInstance();
  const { mousePosition, tooltipShown, tooltipPosition, legend, chartStore, colorLegendConfig, innerWidth, innerHeight, contentShapes } = instance2;
  component_subscribe($$self, mousePosition, (value) => $$invalidate(11, $mousePosition = value));
  component_subscribe($$self, innerWidth, (value) => $$invalidate(4, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(3, $innerHeight = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$3) {
    throw new Error();
  }
  const { entries, activeSerie, domain, colorMap, option } = chartStore;
  component_subscribe($$self, activeSerie, (value) => $$invalidate(12, $activeSerie = value));
  let { radius = 0 } = $$props;
  let shapes = [];
  entries.forEach((_2, i2) => {
    $$invalidate(1, shapes[i2] = [], shapes);
  });
  const iconSvg = option.centerSvg;
  const func = (i2, shape) => {
    $$invalidate(1, shapes[i2] = shape, shapes);
  };
  $$self.$$set = ($$props2) => {
    if ("radius" in $$props2)
      $$invalidate(0, radius = $$props2.radius);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeSerie, $mousePosition*/
    6144) {
      {
        if ($activeSerie != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty & /*$innerWidth, $innerHeight, radius*/
    25) {
      {
        $$invalidate(0, radius = Math.min($innerWidth, $innerHeight) / 2);
        if (radius > labelPadding * 2) {
          $$invalidate(0, radius -= labelPadding * 2);
        }
      }
    }
    if ($$self.$$.dirty & /*shapes*/
    2) {
      {
        contentShapes.set(shapes.flatMap((shapes2) => shapes2));
      }
    }
    if ($$self.$$.dirty & /*radius*/
    1) {
      $$invalidate(2, iconWidth = radius / (entries.length + 1));
    }
    if ($$self.$$.dirty & /*iconWidth*/
    4) {
      $$invalidate(5, iconHtml = (() => {
        if (!iconSvg) {
          return null;
        }
        const div = document.createElement("div");
        div.innerHTML = iconSvg.trim();
        const svg = div.firstElementChild;
        if (svg) {
          svg.setAttributeNS("http://www.w3.org/2000/svg", "width", `${iconWidth}`);
          svg.setAttributeNS("http://www.w3.org/2000/svg", "height", `${iconWidth}`);
          return svg.outerHTML;
        }
        return null;
      })());
    }
  };
  {
    colorLegendConfig.set({
      show: true,
      type: "category",
      formatter: (value) => {
        const values = value.split(SPLITTER);
        return entries.map((entry, i2) => entry.seriesColumn.formatter(values[i2])).join(" ");
      },
      domain,
      getColor: (value) => colorMap.get(value) || "#333"
    });
  }
  return [
    radius,
    shapes,
    iconWidth,
    $innerHeight,
    $innerWidth,
    iconHtml,
    mousePosition,
    innerWidth,
    innerHeight,
    entries,
    activeSerie,
    $mousePosition,
    $activeSerie,
    func
  ];
}
let Content$3 = class Content14 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$g, create_fragment$h, safe_not_equal, { radius: 0 });
  }
};
function create_if_block$a(ctx2) {
  var _a2;
  let div4;
  let div3;
  let div0;
  let div0_style_value;
  let t0;
  let div1;
  let t1_value = (
    /*labels*/
    ((_a2 = ctx2[3]) == null ? void 0 : _a2.join(" ")) + ""
  );
  let t1;
  let t2;
  let div2;
  let t3_value = (
    /*selectedEntry*/
    ctx2[0].valueColumn.formatter(
      /*activeData*/
      ctx2[2].value
    ) + ""
  );
  let t3;
  return {
    c() {
      div4 = element("div");
      div3 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = text(t1_value);
      t2 = space();
      div2 = element("div");
      t3 = text(t3_value);
      attr(div0, "style", div0_style_value = symbol({
        width: (
          /*$font*/
          ctx2[4].size
        ),
        height: (
          /*$font*/
          ctx2[4].size
        ),
        color: (
          /*colorMap*/
          ctx2[7].get(
            /*$activeSerie*/
            ctx2[1]
          ) || "#333"
        )
      }));
      attr(div1, "style", tooltipItemLabel);
      attr(div2, "style", tooltipItemValue);
      attr(div3, "style", tooltipItem);
      attr(div4, "style", tooltipOuter.toString());
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append$2(div4, div3);
      append$2(div3, div0);
      append$2(div3, t0);
      append$2(div3, div1);
      append$2(div1, t1);
      append$2(div3, t2);
      append$2(div3, div2);
      append$2(div2, t3);
    },
    p(ctx3, dirty) {
      var _a3;
      if (dirty & /*$font, $activeSerie*/
      18 && div0_style_value !== (div0_style_value = symbol({
        width: (
          /*$font*/
          ctx3[4].size
        ),
        height: (
          /*$font*/
          ctx3[4].size
        ),
        color: (
          /*colorMap*/
          ctx3[7].get(
            /*$activeSerie*/
            ctx3[1]
          ) || "#333"
        )
      }))) {
        attr(div0, "style", div0_style_value);
      }
      if (dirty & /*labels*/
      8 && t1_value !== (t1_value = /*labels*/
      ((_a3 = ctx3[3]) == null ? void 0 : _a3.join(" ")) + ""))
        set_data(t1, t1_value);
      if (dirty & /*selectedEntry, activeData*/
      5 && t3_value !== (t3_value = /*selectedEntry*/
      ctx3[0].valueColumn.formatter(
        /*activeData*/
        ctx3[2].value
      ) + ""))
        set_data(t3, t3_value);
    },
    d(detaching) {
      if (detaching) {
        detach(div4);
      }
    }
  };
}
function create_fragment$g(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*activeData*/
    ctx2[2] != null && /*$activeSerie*/
    ctx2[1] != null && /*selectedEntry*/
    ctx2[0] != null && create_if_block$a(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*activeData*/
        ctx3[2] != null && /*$activeSerie*/
        ctx3[1] != null && /*selectedEntry*/
        ctx3[0] != null
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$a(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$f($$self, $$props, $$invalidate) {
  let seriesList;
  let entryIndex;
  let selectedEntries;
  let selectedEntry;
  let labels;
  let activeData;
  let $activeSerie;
  let $font;
  const instance2 = getInstance();
  const { chartStore, font } = instance2;
  component_subscribe($$self, font, (value) => $$invalidate(4, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$3) {
    throw new Error();
  }
  const { activeSerie, colorMap, entries } = chartStore;
  component_subscribe($$self, activeSerie, (value) => $$invalidate(1, $activeSerie = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeSerie*/
    2) {
      $$invalidate(8, seriesList = (() => {
        if (!$activeSerie) {
          return [];
        }
        return $activeSerie.split(SPLITTER);
      })());
    }
    if ($$self.$$.dirty & /*seriesList*/
    256) {
      $$invalidate(10, entryIndex = seriesList.length - 1);
    }
    if ($$self.$$.dirty & /*entryIndex*/
    1024) {
      $$invalidate(9, selectedEntries = entries.filter((_2, i2) => i2 <= entryIndex));
    }
    if ($$self.$$.dirty & /*entryIndex*/
    1024) {
      $$invalidate(0, selectedEntry = entries[entryIndex]);
    }
    if ($$self.$$.dirty & /*selectedEntries, seriesList*/
    768) {
      $$invalidate(3, labels = selectedEntries.map((entry, i2) => entry.seriesColumn.formatter(seriesList[i2])));
    }
    if ($$self.$$.dirty & /*$activeSerie, selectedEntry*/
    3) {
      $$invalidate(2, activeData = (() => {
        if ($activeSerie == null || selectedEntry == null) {
          return null;
        }
        return selectedEntry.data.find((d) => d.allSeries === $activeSerie);
      })());
    }
  };
  return [
    selectedEntry,
    $activeSerie,
    activeData,
    labels,
    $font,
    font,
    activeSerie,
    colorMap,
    seriesList,
    selectedEntries,
    entryIndex
  ];
}
let TooltipContent$3 = class TooltipContent9 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$f, create_fragment$g, safe_not_equal, {});
  }
};
const chartType$3 = "sunburst";
function nthColor(colors2, length2, index2) {
  return chroma.scale(colors2).colors(length2 + 2)[index2 + 1];
}
const SPLITTER = `__${Math.random().toString(36).slice(-8)}__`;
let Store$3 = class Store13 {
  constructor(instance2) {
    __publicField(this, "type", chartType$3);
    __publicField(this, "option");
    __publicField(this, "entries");
    __publicField(this, "activeSerie");
    __publicField(this, "domain");
    __publicField(this, "colorMap");
    __publicField(this, "isColorActive");
    __publicField(this, "data");
    __publicField(this, "getValue");
    __publicField(this, "activeTotal");
    const { chartWidth, chartHeight, focused, colorLegendActives } = instance2;
    const option = get_store_value(instance2.option);
    this.option = option;
    let optionData = option.data;
    let prevDomain = null;
    let stockSeriesColumns = [];
    const valueColumn = parseValueColumn({
      column: option.valueColumn
    });
    const activeSerie = writable(null);
    const isColorActive = derived(
      [colorLegendActives],
      ([$colorLegendActives]) => {
        return (value) => {
          return $colorLegendActives.includes(value);
        };
      }
    );
    this.isColorActive = isColorActive;
    this.activeSerie = activeSerie;
    this.domain = [];
    this.colorMap = /* @__PURE__ */ new Map();
    const data = dataMapper(optionData != null ? optionData : [], [
      ...option.entries.map((entryOption) => {
        return parseCategoryColumn({
          column: entryOption.seriesColumn
        });
      }).map((column2, i2) => ({
        key: `series__${i2}`,
        column: column2
      })),
      { key: "value", column: valueColumn }
    ]).filter((x2, i2, self2) => {
      x2.allSeries = option.entries.map((_2, i22) => x2[`series__${i22}`]).join(SPLITTER);
      const foundIndex = self2.findIndex(
        (y2) => option.entries.every(
          (_2, i22) => x2[`series__${i22}`] === y2[`series__${i22}`]
        )
      );
      if (i2 !== foundIndex) {
        self2[foundIndex].value += x2.value;
        return false;
      }
      return true;
    });
    this.data = data;
    function isEqual(series1, series2) {
      const series2split = series2.split(SPLITTER);
      return series1.split(SPLITTER).every((x2, i2) => x2 === series2split[i2]);
    }
    function isIn(series, series2) {
      return series.filter((s2) => isEqual(s2, series2)).length > option.entries.length - 1;
    }
    this.getValue = derived(
      [colorLegendActives],
      ([$colorLegendActives]) => {
        return (series) => {
          return sum(data, (record) => {
            if (isIn($colorLegendActives, record.allSeries)) {
              return asValidNumber(
                isEqual(series, record.allSeries) ? record.value : 0
              );
            }
            return 0;
          });
        };
      }
    );
    const activeTotal = derived(
      [colorLegendActives],
      ([$colorLegendActives]) => {
        return sum(data, (record) => {
          if (isIn($colorLegendActives, record.allSeries)) {
            return asValidNumber(record.value);
          }
          return 0;
        });
      }
    );
    this.activeTotal = activeTotal;
    this.entries = option.entries.map((entryOption, i2) => {
      const entry = {};
      const seriesColumn = parseCategoryColumn({
        column: entryOption.seriesColumn
      });
      let colorColumn;
      if (entryOption.colorColumn) {
        colorColumn = entryOption.colorColumn.type === "category" ? parseCategoryColumn({
          column: entryOption.colorColumn
        }) : parseValueColumn({
          column: entryOption.colorColumn
        });
      } else {
        colorColumn = seriesColumn;
      }
      stockSeriesColumns.push(seriesColumn);
      const _data = dataMapper(optionData != null ? optionData : [], [
        { key: "series", column: seriesColumn },
        { key: "value", column: valueColumn },
        { key: "color", column: colorColumn }
      ]);
      const data2 = dataMapper(optionData != null ? optionData : [], [
        { key: "series", column: seriesColumn },
        ...[...stockSeriesColumns].map((column2, i22) => ({
          key: `series__${i22}`,
          column: column2
        })),
        { key: "value", column: valueColumn },
        { key: "color", column: colorColumn }
      ]).filter((x2, i22, self2) => {
        x2.allSeries = [...stockSeriesColumns].map((_2, i3) => x2[`series__${i3}`]).join(SPLITTER);
        const foundIndex = self2.findIndex(
          (y2) => stockSeriesColumns.every(
            (column2, i3) => x2[`series__${i3}`] === y2[`series__${i3}`]
          )
        );
        if (i22 !== foundIndex) {
          self2[foundIndex].value += x2.value;
          return false;
        }
        return true;
      });
      const _seriesDomain = [
        ...seriesColumn.domain || new Group(_data, (d) => d.series).keys()
      ];
      let seriesDomain;
      if (prevDomain) {
        seriesDomain = prevDomain.flatMap(
          (prev2) => _seriesDomain.map((value, index2) => {
            const prevColor = chroma(
              this.colorMap.get(prev2) || "#000"
            );
            const key = prev2 + SPLITTER + value;
            const color2 = nthColor(
              ["#fff", prevColor.css(), "#000"],
              _seriesDomain.length,
              index2
            );
            this.colorMap.set(key, color2);
            return key;
          })
        );
      } else {
        seriesDomain = _seriesDomain.map((value, index2) => {
          var _a2;
          const color2 = ((_a2 = entryOption.colors) == null ? void 0 : _a2[index2]) || "#333";
          const key = value;
          this.colorMap.set(key, color2);
          return key;
        });
      }
      prevDomain = seriesDomain;
      this.domain = [...this.domain, ...seriesDomain];
      function isFocused($focused, name) {
        return $focused.some(
          (focused2) => focused2[seriesColumn.key] === name
        );
      }
      function toggleFocused($focused, name) {
        if (isFocused($focused, name)) {
          focused.update((focused2) => {
            return focused2.filter(
              (n2) => !(n2[seriesColumn.key] === name)
            );
          });
        } else {
          focused.update((focused2) => {
            return [...focused2, { [seriesColumn.key]: name }];
          });
        }
      }
      const defaultLabelFormatter = (r2) => {
        var _a2;
        return (_a2 = seriesColumn.formatter(r2.series)) != null ? _a2 : "";
      };
      const defaultInnerLabelFormatter = (r2) => {
        var _a2;
        return (_a2 = valueColumn.formatter(r2.value)) != null ? _a2 : "";
      };
      entry.stockSeriesColumns = stockSeriesColumns;
      entry.seriesColumn = seriesColumn;
      entry.valueColumn = valueColumn;
      entry.data = data2;
      entry.seriesDomain = seriesDomain;
      entry.isFocused = isFocused;
      entry.toggleFocused = toggleFocused;
      entry.labelFormatter = entryOption.labelFormatter === void 0 ? defaultLabelFormatter : entryOption.labelFormatter;
      entry.innerLabelFormatter = entryOption.innerLabelFormatter === void 0 ? defaultInnerLabelFormatter : entryOption.innerLabelFormatter;
      return entry;
    });
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$3);
      instance2.tooltipContent.set(TooltipContent$3);
    });
    instance2.tableConfig.set({
      columns: [
        // {
        //     ...seriesColumn,
        //     key: 'name',
        //     type: 'dimension' as 'dimension',
        //     align: 'left'
        // },
        // {
        //     ...valueColumn,
        //     key: 'value',
        //     type: 'metric' as 'metric',
        //     align: 'right'
        // }
      ],
      data: []
      // data: data.map((d) => {
      //     return {
      //         name: d.series,
      //         value: d.value
      //     };
      // })
    });
  }
};
const index$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SPLITTER,
  Store: Store$3,
  chartType: chartType$3
}, Symbol.toStringTag, { value: "Module" }));
function instance_1$e($$self, $$props, $$invalidate) {
  let $mousePosition;
  let $activeSerie;
  let $margin;
  let $getColor;
  let $chartHeight;
  let $chartWidth;
  let $isColorActive;
  const instance2 = getInstance();
  const { focused, chartWidth, chartHeight, mousePosition, tooltipShown, tooltipPosition, margin, legend, focusable, chartStore, contentShapes, colorLegendConfig } = instance2;
  component_subscribe($$self, chartWidth, (value) => $$invalidate(13, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(12, $chartHeight = value));
  component_subscribe($$self, mousePosition, (value) => $$invalidate(8, $mousePosition = value));
  component_subscribe($$self, margin, (value) => $$invalidate(10, $margin = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$2) {
    throw new Error();
  }
  const { data, seriesDomain, activeSerie, isFocused, toggleFocused, colorColumn, colorUtils } = chartStore;
  component_subscribe($$self, activeSerie, (value) => $$invalidate(9, $activeSerie = value));
  const { getColor, colorRange, colorDomain, isColorActive } = colorUtils;
  component_subscribe($$self, getColor, (value) => $$invalidate(11, $getColor = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(14, $isColorActive = value));
  let leaves = [];
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$getColor*/
    2048) {
      {
        if (colorColumn.type === "value") {
          colorLegendConfig.set({
            show: true,
            type: "value",
            column: colorColumn,
            min: colorRange[0],
            max: colorRange[1],
            getColor: (value) => $getColor(value * (colorRange[1] - colorRange[0]) + colorRange[0])
          });
        } else if (colorColumn.type === "category") {
          colorLegendConfig.set({
            show: true,
            type: "category",
            formatter: colorColumn.formatter,
            domain: colorDomain,
            getColor: (value) => $getColor(value)
          });
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$isColorActive, $chartWidth, $chartHeight, $margin, $getColor*/
    31744) {
      $$invalidate(7, leaves = (() => {
        if (data.length === 0) {
          return [];
        }
        const children2 = data.filter((d) => $isColorActive(d.color));
        if (children2.length > 0 && $chartWidth && $chartHeight) {
          const root2 = hierarchy({ name: "root", children: children2 });
          root2.sum(function(d) {
            return d.value;
          });
          treemap().size([
            $chartWidth - $margin.left - $margin.right,
            $chartHeight - $margin.top - $margin.bottom
          ]).padding(0)(root2);
          return root2.leaves().map((leaf) => {
            const color2 = $getColor(leaf.data.color);
            const group = new GroupShape({
              data: { index: leaf.data.index },
              children: [
                new RectShape({
                  props: readable({ fill: color2 }),
                  x: $margin.left + leaf.x0,
                  y: $margin.top + leaf.y0,
                  width: leaf.x1 - leaf.x0,
                  height: leaf.y1 - leaf.y0,
                  padding: 2,
                  clickable: true,
                  events: {
                    click: derived([focusable], ([$focusable]) => () => {
                      if ($focusable) {
                        toggleFocused(get_store_value(focused), leaf.data.series);
                      }
                    }),
                    mouseenter: readable(() => {
                      activeSerie.set(leaf.data.series);
                    }),
                    mouseleave: readable(() => {
                      activeSerie.set(null);
                    })
                  },
                  focused: derived([focused], ([$focused]) => {
                    return isFocused($focused, leaf.data.series);
                  }),
                  hoverable: true,
                  hovered: derived([activeSerie], ([$activeSerie2]) => {
                    return $activeSerie2 === leaf.data.series;
                  }),
                  inactive: derived([focused], ([$focused]) => {
                    return !isFocused($focused, leaf.data.series) && $focused.length > 0;
                  })
                }),
                new TextShape({
                  textAlign: "left",
                  textBaseline: "top",
                  text: leaf.data.series,
                  x: $margin.left + leaf.x0,
                  y: $margin.top + leaf.y0,
                  width: leaf.x1 - leaf.x0,
                  height: leaf.y1 - leaf.y0,
                  padding: 8,
                  backgroundColor: color2,
                  inactive: derived([focused], ([$focused]) => {
                    return !isFocused($focused, leaf.data.series) && $focused.length > 0;
                  })
                })
              ]
            });
            return group;
          });
        }
        return [];
      })());
    }
    if ($$self.$$.dirty[0] & /*$activeSerie, $mousePosition*/
    768) {
      {
        if ($activeSerie != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*leaves*/
    128) {
      {
        contentShapes.set(leaves);
      }
    }
  };
  return [
    chartWidth,
    chartHeight,
    mousePosition,
    margin,
    activeSerie,
    getColor,
    isColorActive,
    leaves,
    $mousePosition,
    $activeSerie,
    $margin,
    $getColor,
    $chartHeight,
    $chartWidth,
    $isColorActive
  ];
}
let Content$2 = class Content15 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$e, null, safe_not_equal, {}, null, [-1, -1]);
  }
};
function create_if_block$9(ctx2) {
  let div4;
  let div3;
  let div0;
  let div0_style_value;
  let t0;
  let div1;
  let t1_value = (
    /*seriesColumn*/
    ctx2[6].formatter(
      /*activeData*/
      ctx2[1].series
    ) + ""
  );
  let t1;
  let t2;
  let div2;
  let t3_value = (
    /*valueColumn*/
    ctx2[5].formatter(
      /*activeData*/
      ctx2[1].value
    ) + ""
  );
  let t3;
  return {
    c() {
      div4 = element("div");
      div3 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = text(t1_value);
      t2 = space();
      div2 = element("div");
      t3 = text(t3_value);
      attr(div0, "style", div0_style_value = symbol({
        width: (
          /*$font*/
          ctx2[2].size
        ),
        height: (
          /*$font*/
          ctx2[2].size
        ),
        color: (
          /*$getColor*/
          ctx2[3](
            /*activeData*/
            ctx2[1].color
          )
        )
      }));
      attr(div1, "style", tooltipItemLabel);
      attr(div2, "style", tooltipItemValue);
      attr(div3, "style", tooltipItem);
      attr(div4, "style", tooltipOuter.toString());
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append$2(div4, div3);
      append$2(div3, div0);
      append$2(div3, t0);
      append$2(div3, div1);
      append$2(div1, t1);
      append$2(div3, t2);
      append$2(div3, div2);
      append$2(div2, t3);
    },
    p(ctx3, dirty) {
      if (dirty & /*$font, $getColor, activeData*/
      14 && div0_style_value !== (div0_style_value = symbol({
        width: (
          /*$font*/
          ctx3[2].size
        ),
        height: (
          /*$font*/
          ctx3[2].size
        ),
        color: (
          /*$getColor*/
          ctx3[3](
            /*activeData*/
            ctx3[1].color
          )
        )
      }))) {
        attr(div0, "style", div0_style_value);
      }
      if (dirty & /*activeData*/
      2 && t1_value !== (t1_value = /*seriesColumn*/
      ctx3[6].formatter(
        /*activeData*/
        ctx3[1].series
      ) + ""))
        set_data(t1, t1_value);
      if (dirty & /*activeData*/
      2 && t3_value !== (t3_value = /*valueColumn*/
      ctx3[5].formatter(
        /*activeData*/
        ctx3[1].value
      ) + ""))
        set_data(t3, t3_value);
    },
    d(detaching) {
      if (detaching) {
        detach(div4);
      }
    }
  };
}
function create_fragment$f(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*activeData*/
    ctx2[1] != null && /*$activeSerie*/
    ctx2[0] != null && create_if_block$9(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*activeData*/
        ctx3[1] != null && /*$activeSerie*/
        ctx3[0] != null
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$9(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$d($$self, $$props, $$invalidate) {
  let activeData;
  let $activeSerie;
  let $font;
  let $getColor;
  const instance2 = getInstance();
  const { chartStore, font } = instance2;
  component_subscribe($$self, font, (value) => $$invalidate(2, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$2) {
    throw new Error();
  }
  const { valueColumn, seriesColumn, data, activeSerie, colorUtils: { getColor } } = chartStore;
  component_subscribe($$self, activeSerie, (value) => $$invalidate(0, $activeSerie = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(3, $getColor = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeSerie*/
    1) {
      $$invalidate(1, activeData = (() => {
        if ($activeSerie == null) {
          return null;
        }
        return data.find((d) => d.series === $activeSerie);
      })());
    }
  };
  return [
    $activeSerie,
    activeData,
    $font,
    $getColor,
    font,
    valueColumn,
    seriesColumn,
    activeSerie,
    getColor
  ];
}
let TooltipContent$2 = class TooltipContent10 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$d, create_fragment$f, safe_not_equal, {});
  }
};
const chartType$2 = "treeMap";
let Store$2 = class Store14 {
  constructor(instance2) {
    __publicField(this, "type", chartType$2);
    __publicField(this, "data");
    __publicField(this, "seriesColumn");
    __publicField(this, "valueColumn");
    __publicField(this, "colorColumn");
    __publicField(this, "colorUtils");
    __publicField(this, "seriesDomain");
    __publicField(this, "seriesMap");
    __publicField(this, "activeTotal");
    __publicField(this, "activeSerie");
    __publicField(this, "isFocused");
    __publicField(this, "toggleFocused");
    var _a2, _b;
    const { chartWidth, chartHeight, focused, colorLegendActives } = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    const activeSerie = writable(null);
    const seriesColumn = parseCategoryColumn({
      column: option.seriesColumn
    });
    const valueColumn = parseValueColumn({
      column: option.valueColumn
    });
    let colorColumn = null;
    if (option.colorColumn) {
      colorColumn = option.colorColumn.type === "category" ? parseCategoryColumn({
        column: option.colorColumn
      }) : parseValueColumn({
        column: option.colorColumn
      });
    } else {
      colorColumn = parseCategoryColumn({
        column: {
          key: "__COLOR__"
        }
      });
    }
    const data = dataMapper((_a2 = option.data) != null ? _a2 : [], [
      { key: "series", column: seriesColumn },
      { key: "value", column: valueColumn },
      { key: "color", column: colorColumn }
    ]).filter(
      (x2, i2, self2) => i2 === self2.findIndex((y2) => x2.series === y2.series)
    );
    this.colorColumn = colorColumn;
    this.colorUtils = parseColorUtils({ colorColumn, data, instance: instance2 });
    const seriesDomain = [
      ...(_b = seriesColumn.domain) != null ? _b : new Group(data, (d) => d.series).keys()
    ];
    data.sort(
      (a2, b) => seriesDomain.indexOf(a2.series) - seriesDomain.indexOf(b.series)
    );
    const seriesMap = /* @__PURE__ */ new Map();
    seriesDomain.forEach((name) => {
      const rows = data.filter((d) => d.series === name);
      if (rows) {
        seriesMap.set(name, {
          rows,
          name,
          value: sum$1(rows, (d) => d.value)
        });
      }
    });
    const activeTotal = derived(
      [colorLegendActives],
      ([colorLegendActives2]) => {
        return sum$1(seriesDomain, (d, i2) => {
          var _a3;
          return (_a3 = seriesMap.get(d)) == null ? void 0 : _a3.value;
        });
      }
    );
    function isFocused($focused, name) {
      return $focused.some(
        (focused2) => focused2[seriesColumn.key] === name
      );
    }
    function toggleFocused($focused, name) {
      if (isFocused($focused, name)) {
        focused.update((focused2) => {
          return focused2.filter(
            (focused3) => !(focused3[seriesColumn.key] === name)
          );
        });
      } else {
        focused.update((focused2) => {
          return [
            ...focused2,
            {
              [seriesColumn.key]: name
            }
          ];
        });
      }
    }
    this.seriesColumn = seriesColumn;
    this.valueColumn = valueColumn;
    this.data = data;
    this.seriesDomain = seriesDomain;
    this.seriesMap = seriesMap;
    this.activeTotal = activeTotal;
    this.activeSerie = activeSerie;
    this.isFocused = isFocused;
    this.toggleFocused = toggleFocused;
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$2);
      instance2.tooltipContent.set(TooltipContent$2);
    });
    instance2.tableConfig.set({
      columns: [
        {
          ...seriesColumn,
          key: "name",
          type: "dimension",
          align: "left"
        },
        {
          ...valueColumn,
          key: "value",
          type: "metric",
          align: "right"
        }
      ],
      data: data.map((d) => {
        return {
          name: d.series,
          value: d.value
        };
      })
    });
  }
};
const index$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$2,
  chartType: chartType$2
}, Symbol.toStringTag, { value: "Module" }));
function calcR(value) {
  const r2 = sqrt$1(value / Math.PI);
  return r2;
}
function getDigits(n2) {
  let digits = 10;
  while (n2 < Math.pow(10, digits)) {
    digits -= 1;
  }
  return digits + 1;
}
function calcDist(r1, r2, area2) {
  if (area2 < SMALL$1) {
    return r1 + r2;
  }
  if (r1 * r1 * Math.PI - area2 < SMALL$1 || r2 * r2 * Math.PI - area2 < SMALL$1) {
    return 0;
  }
  let current = Math.abs(r1 - r2);
  const targetDigits = -10;
  function calcByDigits(init2, max2, digits2) {
    let flg = false;
    let diff = Infinity;
    const unit2 = Math.pow(10, digits2);
    for (let d = init2; d < max2; d += unit2) {
      const d1 = (r1 * r1 - r2 * r2 + d * d) / (2 * d);
      const d2 = d - d1;
      const a2 = Math.pow(r1, 2) * Math.acos(d1 / r1) - d1 * sqrt$1(Math.pow(r1, 2) - Math.pow(d1, 2)) + Math.pow(r2, 2) * Math.acos(d2 / r2) - d2 * sqrt$1(Math.pow(r2, 2) - Math.pow(d2, 2));
      if (a2 >= area2 && a2 - area2 < diff) {
        diff = a2 - area2;
        current = d;
        flg = true;
      } else if (flg) {
        break;
      }
    }
    if (digits2 <= targetDigits) {
      return current;
    }
    return calcByDigits(current, current + unit2, digits2 - 1);
  }
  const digits = getDigits(r1 + r2);
  return calcByDigits(current, r1 + r2, digits);
}
const SMALL$1 = 1e-10;
function calcIntersect(x0, y0, r0, x1, y1, r1) {
  let a2, dx, dy, d, h2, rx, ry;
  let x2, y2;
  dx = x1 - x0;
  dy = y1 - y0;
  d = sqrt$1(dy * dy + dx * dx);
  if (r0 + r1 - d < SMALL$1) {
    throw new Error("no intersection");
  }
  if (d - Math.abs(r0 - r1) < SMALL$1) {
    throw new Error("no intersection");
  }
  a2 = (r0 * r0 - r1 * r1 + d * d) / (2 * d);
  x2 = x0 + dx * a2 / d;
  y2 = y0 + dy * a2 / d;
  h2 = sqrt$1(r0 * r0 - a2 * a2);
  rx = -dy * (h2 / d);
  ry = dx * (h2 / d);
  let xi = x2 + rx;
  let xiPrime = x2 - rx;
  let yi = y2 + ry;
  let yiPrime = y2 - ry;
  if (yi < 0) {
    return [xi, yi];
  }
  return [xiPrime, yiPrime];
}
const SMALL = 1e-10;
function instance_1$c($$self, $$props, $$invalidate) {
  let $innerHeight;
  let $margin;
  let $innerWidth;
  let $color;
  let $colorLegendActives;
  let $legend;
  let $mousePosition;
  let $activeSerie;
  const instance2 = getInstance();
  const { innerWidth, innerHeight, chartStore, contentShapes, legend, tooltipShown, tooltipPosition, mousePosition, focused, colorLegendActives, margin, color: color2, focusable } = instance2;
  component_subscribe($$self, innerWidth, (value) => $$invalidate(10, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(8, $innerHeight = value));
  component_subscribe($$self, legend, (value) => $$invalidate(13, $legend = value));
  component_subscribe($$self, mousePosition, (value) => $$invalidate(14, $mousePosition = value));
  component_subscribe($$self, colorLegendActives, (value) => $$invalidate(12, $colorLegendActives = value));
  component_subscribe($$self, margin, (value) => $$invalidate(9, $margin = value));
  component_subscribe($$self, color2, (value) => $$invalidate(11, $color = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$1) {
    throw new Error();
  }
  const { data, seriesColumn, seriesDomain, isFocused, toggleFocused, activeSerie } = chartStore;
  component_subscribe($$self, activeSerie, (value) => $$invalidate(15, $activeSerie = value));
  $$self.$$.update = () => {
    var _a2, _b, _c, _d, _e, _f;
    if ($$self.$$.dirty & /*$activeSerie, $mousePosition*/
    49152) {
      {
        if ($activeSerie != null) {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        } else {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty & /*$legend, $color*/
    10240) {
      {
        instance2.colorLegendConfig.set({
          show: $legend.show,
          max: 3,
          type: "category",
          formatter: seriesColumn.formatter,
          domain: seriesDomain,
          getColor: (s2) => {
            return $color.colors[seriesDomain.indexOf(s2)];
          }
        });
      }
    }
    if ($$self.$$.dirty & /*$colorLegendActives, $color, $innerWidth, $innerHeight, $margin*/
    7936) {
      {
        const keys = seriesDomain.filter((key) => $colorLegendActives.includes(key)).filter((key) => {
          var _a3;
          return ((_a3 = data.getTotalValue([key])) != null ? _a3 : 0) > 0;
        }).slice(0, 3);
        keys.sort((a2, b) => {
          var _a3, _b2;
          return ((_a3 = data.getTotalValue([b])) != null ? _a3 : 0) - ((_b2 = data.getTotalValue([a2])) != null ? _b2 : 0);
        });
        const colors2 = keys.map((key) => $color.colors[seriesDomain.indexOf(key)]);
        let valueAB = (_a2 = data.getTotalValue([keys[0], keys[1]])) != null ? _a2 : 0;
        let valueAC = (_b = data.getTotalValue([keys[0], keys[2]])) != null ? _b : 0;
        let valueBC = (_c = data.getTotalValue([keys[1], keys[2]])) != null ? _c : 0;
        let valueA = (_d = data.getTotalValue([keys[0]])) != null ? _d : 0;
        let valueB = (_e = data.getTotalValue([keys[1]])) != null ? _e : 0;
        let valueC = (_f = data.getTotalValue([keys[2]])) != null ? _f : 0;
        const maxValue = Math.max(valueA, valueB, valueC) / 100;
        valueA /= maxValue;
        valueB /= maxValue;
        valueC /= maxValue;
        valueAB /= maxValue;
        valueAC /= maxValue;
        valueBC /= maxValue;
        const rA = calcR(valueA);
        const rB = calcR(valueB);
        const rC = calcR(valueC);
        let distAB = calcDist(rA, rB, valueAB);
        let distAC = calcDist(rA, rC, valueAC);
        let distBC = calcDist(rB, rC, valueBC);
        if (keys.length === 1) {
          const getShapes = (scale) => {
            return [
              new CircleShape({
                cx: 0,
                cy: 0,
                r: rA * scale,
                padding: 1,
                priority: readable(3),
                events: {
                  click: derived([focusable], ([$focusable]) => () => {
                    if ($focusable) {
                      toggleFocused(get_store_value(focused), "0");
                    }
                  }),
                  mouseenter: readable(() => {
                    activeSerie.set([keys[0]]);
                  }),
                  mouseleave: readable(() => {
                    activeSerie.set(null);
                  })
                },
                clickable: true,
                focused: derived([focused], ([$focused]) => isFocused($focused, "0")),
                inactive: derived([focused], ([$focused]) => $focused.length > 0 && !isFocused($focused, "0")),
                hoverable: true,
                hovered: derived([activeSerie], ([$activeSerie2]) => $activeSerie2 != null && $activeSerie2.includes(keys[0])),
                props: readable({ fill: chroma(colors2[0]).alpha(1).css() })
              }).apply()
            ];
          };
          const group = new GroupShape({ children: getShapes(1) });
          let rect = group.apply().getBoundingRect();
          const xRate = $innerWidth / rect.width;
          const yRate = $innerHeight / rect.height;
          const minRate = Math.min(xRate, yRate);
          group.shapeProps.update((n2) => ({ ...n2, children: getShapes(minRate) }));
          rect = group.apply().getBoundingRect();
          group.shapeProps.update((n2) => ({
            ...n2,
            x: $margin.left + ($innerWidth - rect.width) / 2 - rect.x,
            y: $margin.top + ($innerHeight - rect.height) / 2 - rect.y
          }));
          group.apply();
          contentShapes.set([group]);
        } else if (keys.length === 2) {
          const getShapes = (scale) => {
            const xA = 0;
            const yA = 0;
            const xB = distAB * scale;
            const yB = 0;
            const circles = [{ x: xA, y: yA, r: rA * scale }, { x: xB, y: yB, r: rB * scale }];
            const configs = {};
            keys.forEach((n2, i2) => {
              const color22 = colors2[i2];
              configs[n2] = {
                color: color22,
                circle: new CircleShape({
                  cx: circles[i2].x,
                  cy: circles[i2].y,
                  r: circles[i2].r,
                  padding: 1,
                  priority: readable(3),
                  clickable: true,
                  focused: derived([focused], ([$focused]) => isFocused($focused, String(i2))),
                  inactive: derived([focused], ([$focused]) => $focused.length > 0 && !isFocused($focused, String(i2))),
                  events: {
                    click: derived([focusable], ([$focusable]) => () => {
                      if ($focusable) {
                        toggleFocused(get_store_value(focused), String(i2));
                      }
                    }),
                    mouseenter: readable(() => {
                      activeSerie.set([n2]);
                    }),
                    mouseleave: readable(() => {
                      activeSerie.set(null);
                    })
                  },
                  hoverable: true,
                  hovered: derived([activeSerie], ([$activeSerie2]) => $activeSerie2 != null && $activeSerie2.length === 1 && $activeSerie2[0] === n2),
                  props: readable({ fill: chroma(color22).alpha(1).css() })
                }).apply()
              };
            });
            const shapes = [[keys[0]], [keys[1]], [keys[0], keys[1]]].map((n2, i2) => {
              n2.sort((a2, b) => seriesDomain.indexOf(a2) - seriesDomain.indexOf(b));
              if (n2.length === 1) {
                const circle = configs[n2[0]].circle;
                circle.priority = readable(n2.length);
                return circle;
              }
              return new CircleOverlapShape({
                priority: readable(n2.length),
                clickable: true,
                focused: derived([focused], ([$focused]) => isFocused($focused, String(i2))),
                inactive: derived([focused], ([$focused]) => $focused.length > 0 && !isFocused($focused, String(i2))),
                events: {
                  click: derived([focusable], ([$focusable]) => () => {
                    if ($focusable) {
                      toggleFocused(get_store_value(focused), String(i2));
                    }
                  }),
                  mouseenter: readable(() => {
                    activeSerie.set(n2);
                  }),
                  mouseleave: readable(() => {
                    activeSerie.set(null);
                  })
                },
                hoverable: true,
                hovered: derived([activeSerie], ([$activeSerie2]) => $activeSerie2 != null && $activeSerie2.length === n2.length && n2.every((n22, i22) => n22 === $activeSerie2[i22])),
                circles: n2.map((key) => configs[key].circle),
                props: readable({
                  fill: chroma.average(n2.map((key) => configs[key].color)).css()
                })
              });
            });
            return shapes;
          };
          const group = new GroupShape({ children: getShapes(1) });
          let rect = group.apply().getBoundingRect();
          const xRate = $innerWidth / rect.width;
          const yRate = $innerHeight / rect.height;
          const minRate = Math.min(xRate, yRate);
          group.shapeProps.update((n2) => ({ ...n2, children: getShapes(minRate) }));
          rect = group.apply().getBoundingRect();
          group.shapeProps.update((n2) => ({
            ...n2,
            x: $margin.left + ($innerWidth - rect.width) / 2 - rect.x,
            y: $margin.top + ($innerHeight - rect.height) / 2 - rect.y
          }));
          group.apply();
          contentShapes.set([group]);
        } else if (keys.length === 3) {
          const getShapes = (scale) => {
            try {
              let xA = 0;
              let yA = 0;
              let xB = 0;
              let yB = 0;
              let xC = 0;
              let yC = 0;
              const noOverlapCount = (valueAB < SMALL ? 1 : 0) + (valueAC < SMALL ? 1 : 0) + (valueBC < SMALL ? 1 : 0);
              const completeOverlapCount = (distAB < SMALL ? 1 : 0) + (distAC < SMALL ? 1 : 0) + (distBC < SMALL ? 1 : 0);
              if (noOverlapCount === 3) {
                xA = 0;
                yA = 0;
                xB = (rA + rB) * scale;
                yB = 0;
                const res = calcIntersect(xA, yA, distAC * scale, xB, yB, distBC * scale);
                xC = res[0];
                yC = res[1];
              } else if (completeOverlapCount === 3) {
                xA = 0;
                yA = 0;
                xB = 0;
                yB = 0;
                xC = 0;
                yC = 0;
              } else if (noOverlapCount === 2 && completeOverlapCount === 0) {
                if (valueAB < SMALL && valueAC < SMALL) {
                  xB = 0;
                  yB = 0;
                  xC = distBC * scale;
                  yC = 0;
                  const res = calcIntersect(xB, yB, distAB * scale, xC, yC, distAC * scale);
                  xA = res[0];
                  yA = res[1];
                } else if (valueAB < SMALL && valueBC < SMALL) {
                  xA = 0;
                  yA = 0;
                  xC = distAC * scale;
                  yC = 0;
                  const res = calcIntersect(xA, yA, distAB * scale, xC, yC, distBC * scale);
                  xB = res[0];
                  yB = res[1];
                } else if (valueAC < SMALL && valueBC < SMALL) {
                  xA = 0;
                  yA = 0;
                  xB = distAB * scale;
                  yB = 0;
                  const res = calcIntersect(xA, yA, distAC * scale, xB, yB, distBC * scale);
                  xC = res[0];
                  yC = res[1];
                } else {
                  throw new Error("invalid pattern");
                }
              } else if (noOverlapCount === 2 && completeOverlapCount === 1) {
                if (valueAB < SMALL && valueAC < SMALL) {
                  xB = 0;
                  yB = 0;
                  xC = 0;
                  yC = 0;
                  xA = (rB + rA) * scale;
                  yA = 0;
                } else if (valueAB < SMALL && valueBC < SMALL) {
                  xA = 0;
                  yA = 0;
                  xC = 0;
                  yC = 0;
                  xB = (rA + rB) * scale;
                  yB = 0;
                } else if (valueAC < SMALL && valueBC < SMALL) {
                  xA = 0;
                  yA = 0;
                  xB = 0;
                  yB = 0;
                  xC = (rA + rC) * scale;
                  yC = 0;
                } else {
                  throw new Error("invalid pattern");
                }
              } else if (completeOverlapCount === 2) {
                if (distAB < SMALL && distAC < SMALL) {
                  const d = distBC * scale;
                  xB = 0;
                  yB = 0;
                  xC = d;
                  yC = 0;
                  xA = d / 2;
                  yA = 0;
                } else if (distAB < SMALL && distBC < SMALL) {
                  const d = distAC * scale;
                  xA = 0;
                  yA = 0;
                  xC = d;
                  yC = 0;
                  xB = d / 2;
                  yB = 0;
                } else if (distAC < SMALL && distBC < SMALL) {
                  const d = distAB * scale;
                  xA = 0;
                  yA = 0;
                  xB = d;
                  yB = 0;
                  xC = d / 2;
                  yC = 0;
                } else {
                  throw new Error("invalid pattern");
                }
              } else if (noOverlapCount === 1 && completeOverlapCount === 0) {
                if (valueAB < SMALL) {
                  xC = 0;
                  yC = 0;
                  xA = -distAC * scale;
                  yA = 0;
                  xB = distBC * scale;
                  yB = 0;
                } else if (valueAC < SMALL) {
                  xB = 0;
                  yB = 0;
                  xA = -distAB * scale;
                  yA = 0;
                  xC = distBC * scale;
                  yC = 0;
                } else if (valueBC < SMALL) {
                  xA = 0;
                  yA = 0;
                  xB = -distAB * scale;
                  yB = 0;
                  xC = distAC * scale;
                  yC = 0;
                } else {
                  throw new Error("invalid pattern");
                }
              } else if (completeOverlapCount === 1) {
                if (distAB < SMALL) {
                  xA = 0;
                  yA = 0;
                  xC = distAC * scale;
                  yC = 0;
                  xB = (distAC - distBC) * scale;
                  yB = 0;
                } else if (distAC < SMALL) {
                  xA = 0;
                  yA = 0;
                  xB = distAB * scale;
                  yB = 0;
                  xC = (distAB - distBC) * scale;
                  yC = 0;
                } else if (distBC < SMALL) {
                  xB = 0;
                  yB = 0;
                  xA = distAB * scale;
                  yA = 0;
                  xC = (distAB - distAC) * scale;
                  yC = 0;
                } else {
                  throw new Error("invalid pattern");
                }
              } else {
                if (distAB + distAC < distBC) {
                  distBC = distAB + distAC - SMALL * 10;
                }
                if (distAB + distBC < distAC) {
                  distAC = distAB + distBC - SMALL * 10;
                }
                if (distAC + distBC < distAB) {
                  distAB = distAC + distBC - SMALL * 10;
                }
                xA = 0;
                yA = 0;
                xB = distAB * scale;
                yB = 0;
                const res = calcIntersect(xA, yA, distAC * scale, xB, yB, distBC * scale);
                xC = res[0];
                yC = res[1];
              }
              const circles = [
                { x: xA, y: yA, r: rA * scale },
                { x: xB, y: yB, r: rB * scale },
                { x: xC, y: yC, r: rC * scale }
              ];
              const configs = {};
              keys.forEach((n2, i2) => {
                const color22 = colors2[i2];
                configs[n2] = {
                  color: color22,
                  circle: new CircleShape({
                    cx: circles[i2].x,
                    cy: circles[i2].y,
                    r: circles[i2].r,
                    padding: 1,
                    priority: readable(3),
                    clickable: true,
                    focused: derived([focused], ([$focused]) => isFocused($focused, String(i2))),
                    inactive: derived([focused], ([$focused]) => $focused.length > 0 && !isFocused($focused, String(i2))),
                    events: {
                      click: derived([focusable], ([$focusable]) => () => {
                        if ($focusable) {
                          toggleFocused(get_store_value(focused), String(i2));
                        }
                      }),
                      mouseenter: readable(() => {
                        activeSerie.set([n2]);
                      }),
                      mouseleave: readable(() => {
                        activeSerie.set(null);
                      })
                    },
                    hoverable: true,
                    hovered: derived([activeSerie], ([$activeSerie2]) => $activeSerie2 != null && $activeSerie2.length === 1 && $activeSerie2[0] === n2),
                    props: readable({ fill: chroma(color22).alpha(1).css() })
                  }).apply()
                };
              });
              const shapes2 = [
                [keys[0]],
                [keys[1]],
                [keys[2]],
                [keys[0], keys[1]],
                [keys[0], keys[2]],
                [keys[1], keys[2]],
                [keys[0], keys[1], keys[2]]
              ].map((n2, i2) => {
                n2.sort((a2, b) => seriesDomain.indexOf(a2) - seriesDomain.indexOf(b));
                if (n2.length === 1) {
                  const circle = configs[n2[0]].circle;
                  circle.priority = readable(n2.length);
                  return circle;
                }
                return new CircleOverlapShape({
                  priority: readable(n2.length),
                  clickable: true,
                  focused: derived([focused], ([$focused]) => isFocused($focused, String(i2))),
                  inactive: derived([focused], ([$focused]) => $focused.length > 0 && !isFocused($focused, String(i2))),
                  events: {
                    click: derived([focusable], ([$focusable]) => () => {
                      if ($focusable) {
                        toggleFocused(get_store_value(focused), String(i2));
                      }
                    }),
                    mouseenter: readable(() => {
                      activeSerie.set(n2);
                    }),
                    mouseleave: readable(() => {
                      activeSerie.set(null);
                    })
                  },
                  hoverable: true,
                  hovered: derived([activeSerie], ([$activeSerie2]) => $activeSerie2 != null && $activeSerie2.length === n2.length && n2.every((n22, i22) => n22 === $activeSerie2[i22])),
                  circles: n2.map((key) => configs[key].circle),
                  props: readable({
                    fill: chroma.average(n2.map((key) => configs[key].color)).alpha(1).css()
                  })
                });
              });
              return shapes2;
            } catch (e3) {
              console.log(e3);
              return [];
            }
          };
          const shapes = getShapes(1);
          if (shapes.length > 0) {
            const group = new GroupShape({ children: shapes });
            let rect = group.apply().getBoundingRect();
            const xRate = $innerWidth / rect.width;
            const yRate = $innerHeight / rect.height;
            const minRate = Math.min(xRate, yRate);
            group.shapeProps.update((n2) => ({ ...n2, children: getShapes(minRate) }));
            rect = group.apply().getBoundingRect();
            group.shapeProps.update((n2) => ({
              ...n2,
              x: $margin.left + ($innerWidth - rect.width) / 2 - rect.x,
              y: $margin.top + ($innerHeight - rect.height) / 2 - rect.y
            }));
            group.apply();
            contentShapes.set([group]);
          } else {
            contentShapes.set([]);
          }
        } else {
          contentShapes.set([]);
        }
      }
    }
  };
  return [
    innerWidth,
    innerHeight,
    legend,
    mousePosition,
    colorLegendActives,
    margin,
    color2,
    activeSerie,
    $innerHeight,
    $margin,
    $innerWidth,
    $color,
    $colorLegendActives,
    $legend,
    $mousePosition,
    $activeSerie
  ];
}
let Content$1 = class Content16 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$c, null, safe_not_equal, {});
  }
};
function create_if_block$8(ctx2) {
  let div4;
  let div3;
  let div0;
  let div0_style_value;
  let t0;
  let div1;
  let t1_value = (
    /*$activeSerie*/
    ctx2[0].join(" & ") + ""
  );
  let t1;
  let t2;
  let div2;
  let t3_value = (
    /*valueColumn*/
    ctx2[8].formatter(
      /*value*/
      ctx2[1]
    ) + ""
  );
  let t3;
  return {
    c() {
      div4 = element("div");
      div3 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = text(t1_value);
      t2 = space();
      div2 = element("div");
      t3 = text(t3_value);
      attr(div0, "style", div0_style_value = symbol({
        width: (
          /*$font*/
          ctx2[2].size
        ),
        height: (
          /*$font*/
          ctx2[2].size
        ),
        color: chroma.average(
          /*$activeSerie*/
          ctx2[0].map(
            /*func*/
            ctx2[9]
          )
        ).css()
      }));
      attr(div1, "style", tooltipItemLabel);
      attr(div2, "style", tooltipItemValue);
      attr(div3, "style", tooltipItem);
      attr(div4, "style", tooltipOuter.toString());
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append$2(div4, div3);
      append$2(div3, div0);
      append$2(div3, t0);
      append$2(div3, div1);
      append$2(div1, t1);
      append$2(div3, t2);
      append$2(div3, div2);
      append$2(div2, t3);
    },
    p(ctx3, dirty) {
      if (dirty & /*$font, $activeSerie, $color*/
      13 && div0_style_value !== (div0_style_value = symbol({
        width: (
          /*$font*/
          ctx3[2].size
        ),
        height: (
          /*$font*/
          ctx3[2].size
        ),
        color: chroma.average(
          /*$activeSerie*/
          ctx3[0].map(
            /*func*/
            ctx3[9]
          )
        ).css()
      }))) {
        attr(div0, "style", div0_style_value);
      }
      if (dirty & /*$activeSerie*/
      1 && t1_value !== (t1_value = /*$activeSerie*/
      ctx3[0].join(" & ") + ""))
        set_data(t1, t1_value);
      if (dirty & /*value*/
      2 && t3_value !== (t3_value = /*valueColumn*/
      ctx3[8].formatter(
        /*value*/
        ctx3[1]
      ) + ""))
        set_data(t3, t3_value);
    },
    d(detaching) {
      if (detaching) {
        detach(div4);
      }
    }
  };
}
function create_fragment$e(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*$activeSerie*/
    ctx2[0] != null && create_if_block$8(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*$activeSerie*/
        ctx3[0] != null
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$8(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$b($$self, $$props, $$invalidate) {
  let value;
  let $activeSerie;
  let $font;
  let $color;
  const instance2 = getInstance();
  const { color: color2, chartStore, font } = instance2;
  component_subscribe($$self, color2, (value2) => $$invalidate(3, $color = value2));
  component_subscribe($$self, font, (value2) => $$invalidate(2, $font = value2));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType$1) {
    throw new Error();
  }
  const { data, activeSerie, seriesDomain, valueColumn } = chartStore;
  component_subscribe($$self, activeSerie, (value2) => $$invalidate(0, $activeSerie = value2));
  const func = (key) => $color.colors[seriesDomain.indexOf(key)];
  $$self.$$.update = () => {
    var _a2;
    if ($$self.$$.dirty & /*$activeSerie*/
    1) {
      $$invalidate(1, value = $activeSerie != null ? (_a2 = data.getTotalValue($activeSerie)) != null ? _a2 : 0 : 0);
    }
  };
  return [
    $activeSerie,
    value,
    $font,
    $color,
    color2,
    font,
    activeSerie,
    seriesDomain,
    valueColumn,
    func
  ];
}
let TooltipContent$1 = class TooltipContent11 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$b, create_fragment$e, safe_not_equal, {});
  }
};
const chartType$1 = "vennDiagram";
let Store$1 = class Store15 {
  constructor(instance2) {
    __publicField(this, "type", chartType$1);
    __publicField(this, "option");
    __publicField(this, "activeSerie");
    __publicField(this, "data");
    __publicField(this, "seriesColumn");
    __publicField(this, "valueColumn");
    __publicField(this, "seriesDomain");
    __publicField(this, "isFocused");
    __publicField(this, "toggleFocused");
    var _a2, _b;
    const { chartWidth, chartHeight, focused } = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    const activeSerie = writable(null);
    const seriesColumn = parseCategoryArrayColumn({
      column: option.seriesColumn
    });
    const valueColumn = parseValueColumn({
      column: option.valueColumn
    });
    const data = new Group(
      (_a2 = option.data) != null ? _a2 : [],
      (row) => seriesColumn.valueGetter(row),
      (d) => {
        return true;
      },
      (rows) => sum$1(rows, (d) => valueColumn.valueGetter(d))
    );
    const seriesDomain = [
      ...(_b = seriesColumn.domain) != null ? _b : data.keys().flatMap((n2) => n2).filter((x2, i2, self2) => self2.indexOf(x2) === i2)
    ];
    function isFocused($focused, name) {
      return $focused.some(
        (focused2) => focused2[seriesColumn.key] === name
      );
    }
    function toggleFocused($focused, name) {
      if (isFocused($focused, name)) {
        focused.update((focused2) => {
          return focused2.filter(
            (n2) => !(n2[seriesColumn.key] === name)
          );
        });
      } else {
        focused.update((focused2) => {
          return [...focused2, { [seriesColumn.key]: name }];
        });
      }
    }
    this.option = option;
    this.activeSerie = activeSerie;
    this.seriesColumn = seriesColumn;
    this.valueColumn = valueColumn;
    this.data = data;
    this.seriesDomain = seriesDomain;
    this.isFocused = isFocused;
    this.toggleFocused = toggleFocused;
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content$1);
      instance2.tooltipContent.set(TooltipContent$1);
    });
    instance2.tableConfig.set({
      columns: [
        {
          ...seriesColumn,
          key: "name",
          type: "dimension",
          align: "left"
        },
        {
          ...valueColumn,
          key: "value",
          type: "metric",
          align: "right"
        }
      ],
      data: data.storeData.map((d) => {
        return {
          name: d.key,
          value: d.value
        };
      })
    });
  }
};
const index$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store$1,
  chartType: chartType$1
}, Symbol.toStringTag, { value: "Module" }));
function half(n2) {
  return Math.floor(n2 / 2) + n2 % 2;
}
class Point3 {
  constructor(x2, y2) {
    __publicField(this, "x");
    __publicField(this, "y");
    this.x = x2;
    this.y = y2;
  }
}
class PointWithDist {
  constructor(x2, y2, center, chartWidth, chartHeight) {
    __publicField(this, "x");
    __publicField(this, "y");
    __publicField(this, "dist");
    this.x = x2;
    this.y = y2;
    const dx = (this.x - center.x) * chartHeight / chartWidth;
    const dy = this.y - center.y;
    this.dist = Math.sqrt(dx * dx + dy * dy);
  }
}
class CalcWordCloudContext {
  constructor(chartWidth, chartHeight, padding2, roughness) {
    __publicField(this, "grid");
    __publicField(this, "chartWidth");
    __publicField(this, "chartHeight");
    __publicField(this, "center");
    __publicField(this, "possiblePoints", []);
    __publicField(this, "padding");
    this.chartWidth = chartWidth;
    this.chartHeight = chartHeight;
    this.padding = padding2;
    this.grid = new Uint8Array(chartWidth * chartHeight);
    this.center = new Point3(half(chartWidth), half(chartHeight));
    const possiblePoints = [];
    for (let x2 = 0; x2 < chartWidth; x2++) {
      for (let y2 = 0; y2 < chartHeight; y2++) {
        this.grid[x2 * chartHeight + y2] = 0;
        possiblePoints.push(
          new PointWithDist(
            x2,
            y2,
            this.center,
            chartWidth,
            chartHeight
          )
        );
      }
    }
    possiblePoints.sort(
      (a2, b) => a2.dist === b.dist ? Math.random() : a2.dist - b.dist > 0 ? 1 : -1
    );
    this.possiblePoints = [];
    for (let i2 = 0; i2 < possiblePoints.length; i2++) {
      if (Math.random() < roughness) {
        this.possiblePoints.push(possiblePoints[i2]);
      }
    }
  }
  isGridEmpty(x2, y2) {
    const chartWidth = this.chartWidth;
    const chartHeight = this.chartHeight;
    const grid = this.grid;
    if (x2 < 0 || x2 >= chartWidth) {
      return false;
    }
    if (y2 < 0 || y2 >= chartHeight) {
      return false;
    }
    return grid[x2 * chartHeight + y2] === 0;
  }
  fillAllGrid(rect, fill) {
    const padding2 = this.padding;
    const x2 = Math.floor(rect.x);
    const y2 = Math.floor(rect.y);
    const width = Math.ceil(rect.width);
    const height = Math.ceil(rect.height);
    for (let dx = x2 - padding2; dx < x2 + width + padding2; dx++) {
      for (let dy = y2 - padding2; dy < y2 + height + padding2; dy++) {
        this.fillGrid(dx, dy, fill);
      }
    }
  }
  fillGrid(x2, y2, filled) {
    const chartWidth = this.chartWidth;
    const chartHeight = this.chartHeight;
    const grid = this.grid;
    if (x2 < 0 || x2 >= chartWidth) {
      return;
    }
    if (y2 < 0 || y2 >= chartHeight) {
      return;
    }
    grid[x2 * chartHeight + y2] = filled;
  }
  testEmpty(rect) {
    let dx;
    let dy;
    let i2 = Math.floor(rect.width);
    while (i2-- > 0) {
      dx = Math.floor(rect.x) + i2;
      dy = Math.floor(rect.y);
      if (this.isGridEmpty(dx, dy) === false) {
        return false;
      }
      dy = Math.floor(rect.y) + Math.floor(rect.height);
      if (this.isGridEmpty(dx, dy) === false) {
        return false;
      }
    }
    i2 = Math.floor(rect.height);
    while (i2-- > 0) {
      dx = Math.floor(rect.x);
      dy = Math.floor(rect.y) + i2;
      if (this.isGridEmpty(dx, dy) === false) {
        return false;
      }
      dx = Math.floor(rect.x) + Math.floor(rect.width);
      if (this.isGridEmpty(dx, dy) === false) {
        return false;
      }
    }
    return true;
  }
  findEmptySpace(rect) {
    const ctx2 = this;
    const points = this.possiblePoints;
    for (let i2 = 0; i2 < points.length; i2++) {
      const x2 = points[i2].x;
      const y2 = points[i2].y;
      rect.x = x2 - half(rect.width);
      rect.y = y2 - half(rect.height);
      if (ctx2.testEmpty(rect)) {
        return points[i2];
      }
    }
    return null;
  }
}
function instance_1$a($$self, $$props, $$invalidate) {
  let texts;
  let $margin;
  let $innerHeight;
  let $innerWidth;
  let $getColor;
  let $tooltip;
  let $font;
  let $sizeScale;
  let $isColorActive;
  let $activeDataIndex;
  let $mousePosition;
  const instance2 = getInstance();
  const { ssr, innerWidth, innerHeight, mousePosition, tooltipPosition, tooltipShown, focused, margin, chartStore, contentShapes, colorLegendConfig, option, focusable, tooltip, font } = instance2;
  component_subscribe($$self, innerWidth, (value) => $$invalidate(15, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(14, $innerHeight = value));
  component_subscribe($$self, mousePosition, (value) => $$invalidate(22, $mousePosition = value));
  component_subscribe($$self, margin, (value) => $$invalidate(13, $margin = value));
  component_subscribe($$self, tooltip, (value) => $$invalidate(17, $tooltip = value));
  component_subscribe($$self, font, (value) => $$invalidate(18, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType) {
    throw new Error();
  }
  const { data, sizeScale, activeDataIndex, textKey, isFocused, toggleFocused, sizeColumn, colorColumn, textColumn, colorUtils: { colorDomain, colorRange, getColor, isColorActive } } = chartStore;
  component_subscribe($$self, sizeScale, (value) => $$invalidate(19, $sizeScale = value));
  component_subscribe($$self, activeDataIndex, (value) => $$invalidate(21, $activeDataIndex = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(16, $getColor = value));
  component_subscribe($$self, isColorActive, (value) => $$invalidate(20, $isColorActive = value));
  let counter = 0;
  let activeTexts = [];
  const group = new GroupShape({ children: [] });
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$getColor*/
    65536) {
      {
        if (colorColumn.type === "value") {
          colorLegendConfig.set({
            show: true,
            type: "value",
            column: colorColumn,
            min: colorRange[0],
            max: colorRange[1],
            getColor: (value) => $getColor(value * (colorRange[1] - colorRange[0]) + colorRange[0])
          });
        } else if (colorColumn.type === "category") {
          colorLegendConfig.set({
            show: true,
            type: "category",
            formatter: colorColumn.formatter,
            domain: colorDomain,
            getColor: (value) => $getColor(value)
          });
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$activeDataIndex, $tooltip, $mousePosition*/
    6422528) {
      {
        if ($activeDataIndex != null && $tooltip.trigger === "hover") {
          tooltipShown.set(true);
          tooltipPosition.set($mousePosition);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$activeDataIndex, $tooltip*/
    2228224) {
      {
        if ($activeDataIndex != null && $tooltip.trigger === "focus") {
          tooltipShown.set(true);
          tooltipPosition.set(get_store_value(mousePosition));
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$activeDataIndex*/
    2097152) {
      {
        if ($activeDataIndex == null) {
          tooltipShown.set(false);
          tooltipPosition.set(null);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$isColorActive, $sizeScale, $font, $tooltip, $getColor*/
    2031616) {
      $$invalidate(12, texts = (() => {
        return data.flatMap((d, index2) => {
          if (!$isColorActive(d.color)) {
            return [];
          }
          const text2 = new TextShape({
            textAlign: "left",
            textBaseline: "top",
            fontSize: $sizeScale(d.size),
            fontFamily: $font.family || DEFAULT_FONT_FAMILY,
            text: d.text,
            data: d,
            visible: false,
            padding: 4,
            clickable: true,
            events: {
              click: derived([focusable, option], ([$focusable, $option]) => () => {
                if ($focusable) {
                  toggleFocused(get_store_value(focused), d.text);
                }
                if ($tooltip.trigger === "focus") {
                  activeDataIndex.set(index2);
                }
              }),
              mouseenter: derived([option], ([$option]) => () => {
                if ($tooltip.trigger === "hover") {
                  activeDataIndex.set(index2);
                }
              }),
              mouseleave: derived([option], ([$option]) => () => {
                if ($tooltip.trigger === "hover") {
                  activeDataIndex.set(null);
                }
              })
            },
            focused: derived([focused], ([$focused]) => {
              return isFocused($focused, d.text);
            }),
            hoverable: true,
            hovered: derived([activeDataIndex], ([$activeDataIndex2]) => {
              return $activeDataIndex2 === index2;
            }),
            inactive: derived([focused], ([$focused]) => {
              return $focused.length > 0 && !isFocused($focused, d.text);
            }),
            props: readable({ fill: $getColor(d.color) })
          });
          return [text2];
        });
      })());
    }
    if ($$self.$$.dirty[0] & /*counter, $innerWidth, $innerHeight, texts*/
    54272) {
      {
        const id2 = $$invalidate(10, ++counter);
        $$invalidate(11, activeTexts = []);
        (async () => {
          if (!ssr) {
            await tick();
            await new Promise((r2) => instance2.setTimeout(r2, 100));
            if (id2 !== counter) {
              return;
            }
          }
          const cw = Math.floor($innerWidth);
          const ch = Math.floor($innerHeight);
          const padding2 = 0;
          const roughness = 0.2;
          const ctx2 = new CalcWordCloudContext(cw, ch, padding2, roughness);
          const rects = texts.map((n2) => {
            n2.visible.set(false);
            const rect = n2.apply().getBoundingRect();
            return rect;
          });
          function callback(rect, i2) {
            if (id2 !== counter) {
              return false;
            }
            texts[i2].shapeProps.update((n2) => ({ ...n2, x: rect.x, y: rect.y }));
            texts[i2].visible.set(rect.visible);
            texts[i2].apply();
            $$invalidate(11, activeTexts = texts);
            return true;
          }
          await new Promise((resolve, reject) => {
            let index2 = 0;
            let t0 = performance.now();
            function loop(i2) {
              try {
                if (i2 >= rects.length) {
                  resolve();
                  return;
                }
                const rect = rects[i2];
                const res = ctx2.findEmptySpace(rect);
                if (res) {
                  rect.visible = true;
                  ctx2.fillAllGrid(rect, 1);
                } else {
                  rect.visible = false;
                }
                const result = callback(rect, i2);
                if (!result) {
                  resolve();
                  return;
                }
                if (ssr) {
                  loop(index2++);
                } else {
                  let t1 = performance.now();
                  if (t1 - t0 > 16) {
                    t0 = t1;
                    instance2.setTimeout(() => loop(index2++));
                  } else {
                    loop(index2++);
                  }
                }
              } catch (e3) {
                console.log(e3);
                resolve();
              }
            }
            if (ssr) {
              loop(index2++);
            } else {
              instance2.setTimeout(() => loop(index2++));
            }
          });
        })();
      }
    }
    if ($$self.$$.dirty[0] & /*$margin*/
    8192) {
      {
        group.shapeProps.update((n2) => ({ ...n2, x: $margin.left, y: $margin.top }));
      }
    }
    if ($$self.$$.dirty[0] & /*activeTexts*/
    2048) {
      {
        group.shapeProps.update((n2) => ({ ...n2, children: activeTexts }));
        contentShapes.set([group]);
      }
    }
  };
  {
    instance2.tableConfig.set({
      columns: [
        {
          ...textColumn,
          key: "text",
          type: "dimension",
          align: "left"
        },
        {
          ...sizeColumn,
          key: "size",
          type: "metric",
          align: "right"
        }
      ],
      data: data.map((d) => {
        return { text: d.text, size: d.size };
      })
    });
  }
  {
    instance2.events.listen("emptyclick", () => {
      activeDataIndex.set(null);
    });
  }
  return [
    innerWidth,
    innerHeight,
    mousePosition,
    margin,
    tooltip,
    font,
    sizeScale,
    activeDataIndex,
    getColor,
    isColorActive,
    counter,
    activeTexts,
    texts,
    $margin,
    $innerHeight,
    $innerWidth,
    $getColor,
    $tooltip,
    $font,
    $sizeScale,
    $isColorActive,
    $activeDataIndex,
    $mousePosition
  ];
}
class Content17 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$a, null, safe_not_equal, {}, null, [-1, -1]);
  }
}
function create_if_block$7(ctx2) {
  let div4;
  let div3;
  let div0;
  let div0_style_value;
  let t0;
  let div1;
  let t1_value = (
    /*activeData*/
    ctx2[1].text + ""
  );
  let t1;
  let t2;
  let div2;
  let t3_value = (
    /*sizeColumn*/
    ctx2[5].formatter(
      /*activeData*/
      ctx2[1].size
    ) + ""
  );
  let t3;
  return {
    c() {
      div4 = element("div");
      div3 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = text(t1_value);
      t2 = space();
      div2 = element("div");
      t3 = text(t3_value);
      attr(div0, "style", div0_style_value = symbol({
        width: (
          /*$font*/
          ctx2[2].size
        ),
        height: (
          /*$font*/
          ctx2[2].size
        ),
        color: (
          /*$getColor*/
          ctx2[3](
            /*activeData*/
            ctx2[1].color
          )
        )
      }));
      attr(div1, "style", tooltipItemLabel);
      attr(div2, "style", tooltipItemValue);
      attr(div3, "style", tooltipItem);
      attr(div4, "style", tooltipOuter.toString());
    },
    m(target, anchor) {
      insert(target, div4, anchor);
      append$2(div4, div3);
      append$2(div3, div0);
      append$2(div3, t0);
      append$2(div3, div1);
      append$2(div1, t1);
      append$2(div3, t2);
      append$2(div3, div2);
      append$2(div2, t3);
    },
    p(ctx3, dirty) {
      if (dirty & /*$font, $getColor, activeData*/
      14 && div0_style_value !== (div0_style_value = symbol({
        width: (
          /*$font*/
          ctx3[2].size
        ),
        height: (
          /*$font*/
          ctx3[2].size
        ),
        color: (
          /*$getColor*/
          ctx3[3](
            /*activeData*/
            ctx3[1].color
          )
        )
      }))) {
        attr(div0, "style", div0_style_value);
      }
      if (dirty & /*activeData*/
      2 && t1_value !== (t1_value = /*activeData*/
      ctx3[1].text + ""))
        set_data(t1, t1_value);
      if (dirty & /*activeData*/
      2 && t3_value !== (t3_value = /*sizeColumn*/
      ctx3[5].formatter(
        /*activeData*/
        ctx3[1].size
      ) + ""))
        set_data(t3, t3_value);
    },
    d(detaching) {
      if (detaching) {
        detach(div4);
      }
    }
  };
}
function create_fragment$d(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*activeData*/
    ctx2[1] != null && /*$activeDataIndex*/
    ctx2[0] != null && create_if_block$7(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, [dirty]) {
      if (
        /*activeData*/
        ctx3[1] != null && /*$activeDataIndex*/
        ctx3[0] != null
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$7(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$9($$self, $$props, $$invalidate) {
  let activeData;
  let $activeDataIndex;
  let $font;
  let $getColor;
  const instance2 = getInstance();
  const { chartStore, font } = instance2;
  component_subscribe($$self, font, (value) => $$invalidate(2, $font = value));
  if ((chartStore == null ? void 0 : chartStore.type) !== chartType) {
    throw new Error();
  }
  const { data, sizeColumn, activeDataIndex, colorUtils: { getColor } } = chartStore;
  component_subscribe($$self, activeDataIndex, (value) => $$invalidate(0, $activeDataIndex = value));
  component_subscribe($$self, getColor, (value) => $$invalidate(3, $getColor = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$activeDataIndex*/
    1) {
      $$invalidate(1, activeData = (() => {
        if ($activeDataIndex == null) {
          return null;
        }
        return data[$activeDataIndex];
      })());
    }
  };
  return [
    $activeDataIndex,
    activeData,
    $font,
    $getColor,
    font,
    sizeColumn,
    activeDataIndex,
    getColor
  ];
}
class TooltipContent12 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$9, create_fragment$d, safe_not_equal, {});
  }
}
const chartType = "wordCloud";
const defaultOption$1 = {};
class Store16 {
  constructor(instance2) {
    __publicField(this, "type", chartType);
    __publicField(this, "option");
    __publicField(this, "data");
    __publicField(this, "textKey");
    __publicField(this, "sizeColumn");
    __publicField(this, "colorColumn");
    __publicField(this, "textColumn");
    __publicField(this, "colorUtils");
    __publicField(this, "sizeScale");
    __publicField(this, "activeDataIndex");
    __publicField(this, "isFocused");
    __publicField(this, "toggleFocused");
    var _a2, _b, _c, _d;
    const { focused } = instance2;
    const chartOption = instance2.option;
    const option = get_store_value(chartOption);
    const sizeRange = (_a2 = option.sizeRange) != null ? _a2 : [12, 48];
    const activeDataIndex = writable(null);
    const textColumn = parseCategoryColumn({ column: option.textColumn });
    const sizeColumn = parseValueColumn({
      column: option.sizeColumn
    });
    let colorColumn = null;
    if (option.colorColumn) {
      colorColumn = option.colorColumn.type === "category" ? parseCategoryColumn({
        column: option.colorColumn
      }) : parseValueColumn({
        column: option.colorColumn
      });
    } else {
      colorColumn = parseValueColumn({
        column: option.sizeColumn
      });
    }
    this.colorColumn = colorColumn;
    const data = dataMapper((_b = option.data) != null ? _b : [], [
      { key: "text", column: textColumn },
      { key: "size", column: sizeColumn },
      { key: "color", column: colorColumn }
    ]).filter((item) => item.text).filter(
      (x2, i2, self2) => i2 === self2.findIndex(
        (y2) => x2.text === y2.text && ((colorColumn == null ? void 0 : colorColumn.type) === "value" ? true : x2.color === y2.color)
      )
    ).sort((a2, b) => b.size - a2.size);
    this.colorUtils = parseColorUtils({ colorColumn, data, instance: instance2 });
    const sizeScale = readable(
      linear().domain([
        (_c = min$1(data.map((d) => +d.size))) != null ? _c : 0,
        (_d = max$1(data.map((d) => +d.size))) != null ? _d : 0
      ]).range(sizeRange)
    );
    function isFocused($focused, name) {
      return $focused.some((focused2) => focused2[textColumn.key] === name);
    }
    function toggleFocused($focused, name) {
      if (isFocused($focused, name)) {
        focused.update((focused2) => {
          return focused2.filter(
            (focused3) => !(focused3[textColumn.key] === name)
          );
        });
      } else {
        focused.update((focused2) => {
          return [
            ...focused2,
            {
              [textColumn.key]: name
            }
          ];
        });
      }
    }
    this.option = option;
    this.data = data;
    this.textKey = textColumn.key;
    this.sizeColumn = sizeColumn;
    this.sizeScale = sizeScale;
    this.textColumn = textColumn;
    this.activeDataIndex = activeDataIndex;
    this.isFocused = isFocused;
    this.toggleFocused = toggleFocused;
    instance2.setTimeoutIfBrowser(() => {
      instance2.chartContent.set(Content17);
      instance2.tooltipContent.set(TooltipContent12);
    });
  }
}
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Store: Store16,
  chartType,
  defaultOption: defaultOption$1
}, Symbol.toStringTag, { value: "Module" }));
function floor(value) {
  const n2 = Math.floor(value);
  if (n2 < 0) {
    return 0;
  }
  return n2;
}
function resize(node2, light = false) {
  let cache2 = { width: 0, height: 0 };
  const dispatchResize = () => {
    try {
      const size = {
        width: floor(node2.clientWidth),
        height: floor(node2.clientHeight)
      };
      if (cache2.width === size.width && cache2.height === size.height) {
        return;
      }
      const event = new CustomEvent(
        "custom_resize",
        {
          detail: size
        }
      );
      node2.dispatchEvent(event);
      cache2 = size;
    } catch (e3) {
    }
  };
  let id2 = null;
  const handleResize = () => {
    if (id2 != null) {
      clearTimeout(id2);
    }
    const currentId = setTimeout(dispatchResize);
    id2 = currentId;
  };
  let destroy = () => {
  };
  if (light === false) {
    const ro = new ResizeObserver(handleResize);
    ro.observe(node2);
    destroy = () => {
      ro.disconnect();
    };
  }
  handleResize();
  return {
    destroy
  };
}
function create_fragment$c(ctx2) {
  let svg;
  let path0;
  let path1;
  return {
    c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      attr(path0, "d", "M0 0h24v24H0V0z");
      attr(path0, "fill", "none");
      attr(path1, "d", "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", "24px");
      attr(svg, "viewBox", "0 0 24 24");
      attr(svg, "width", "24px");
      attr(svg, "fill", "rgba(0,0,0,0.4)");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append$2(svg, path0);
      append$2(svg, path1);
    },
    p: noop$2,
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(svg);
      }
    }
  };
}
let Menu$1 = class Menu extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, null, create_fragment$c, safe_not_equal, {});
  }
};
function create_if_block_2$3(ctx2) {
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = (
    /*$tooltipContent*/
    ctx2[12]
  );
  function switch_props(ctx3, dirty) {
    return {};
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props());
  }
  return {
    c() {
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m(target, anchor) {
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$tooltipContent*/
      4096 && switch_value !== (switch_value = /*$tooltipContent*/
      ctx3[12])) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props());
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_if_block$6(ctx2) {
  let if_block_anchor;
  function select_block_type_1(ctx3, dirty) {
    if (
      /*html*/
      ctx3[0] != null
    )
      return create_if_block_1$3;
    return create_else_block$1;
  }
  let current_block_type = select_block_type_1(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (current_block_type === (current_block_type = select_block_type_1(ctx3)) && if_block) {
        if_block.p(ctx3, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx3);
        if (if_block) {
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if_block.d(detaching);
    }
  };
}
function create_else_block$1(ctx2) {
  let div;
  return {
    c() {
      div = element("div");
      div.textContent = "Loading...";
      attr(div, "style", new Style({ padding: 8 }).toString());
    },
    m(target, anchor) {
      insert(target, div, anchor);
    },
    p: noop$2,
    d(detaching) {
      if (detaching) {
        detach(div);
      }
    }
  };
}
function create_if_block_1$3(ctx2) {
  let div;
  let div_style_value;
  let mounted;
  let dispose;
  return {
    c() {
      var _a2;
      div = element("div");
      attr(div, "style", div_style_value = new Style({ padding: 8, .../*style*/
      (_a2 = ctx2[9]) != null ? _a2 : {} }).toString());
      attr(div, "contenteditable", "true");
      if (
        /*html*/
        ctx2[0] === void 0
      )
        add_render_callback(() => (
          /*div_input_handler*/
          ctx2[26].call(div)
        ));
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if (
        /*html*/
        ctx2[0] !== void 0
      ) {
        div.innerHTML = /*html*/
        ctx2[0];
      }
      if (!mounted) {
        dispose = listen(
          div,
          "input",
          /*div_input_handler*/
          ctx2[26]
        );
        mounted = true;
      }
    },
    p(ctx3, dirty) {
      var _a2;
      if (dirty[0] & /*style*/
      512 && div_style_value !== (div_style_value = new Style({ padding: 8, .../*style*/
      (_a2 = ctx3[9]) != null ? _a2 : {} }).toString())) {
        attr(div, "style", div_style_value);
      }
      if (dirty[0] & /*html*/
      1 && /*html*/
      ctx3[0] !== div.innerHTML) {
        div.innerHTML = /*html*/
        ctx3[0];
      }
    },
    d(detaching) {
      if (detaching) {
        detach(div);
      }
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$b(ctx2) {
  let div;
  let current_block_type_index;
  let if_block;
  let div_style_value;
  let current;
  let mounted;
  let dispose;
  const if_block_creators = [create_if_block$6, create_if_block_2$3];
  const if_blocks = [];
  function select_block_type(ctx3, dirty) {
    var _a2;
    if (
      /*$tooltip*/
      (_a2 = ctx3[1]) == null ? void 0 : _a2.html
    )
      return 0;
    if (
      /*$tooltipContent*/
      ctx3[12]
    )
      return 1;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx2))) {
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
  }
  return {
    c() {
      var _a2, _b, _c;
      div = element("div");
      if (if_block)
        if_block.c();
      attr(div, "style", div_style_value = styleToString({
        transition: (
          /*mount*/
          ctx2[8] ? `
            opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s,
            transform 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s
            ` : void 0
        ),
        boxSizing: "border-box",
        left: 0,
        top: 0,
        maxWidth: 400,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 1e3,
        position: "absolute",
        borderRadius: "2px",
        whiteSpace: "nowrap",
        // border: '1px solid #333',
        boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.4)",
        background: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fontSize: (
          /*$tooltip*/
          (_b = (_a2 = ctx2[1].font) == null ? void 0 : _a2.size) != null ? _b : (
            /*$font*/
            ctx2[11].size
          )
        ),
        fontFamily: (
          /*$tooltip*/
          ((_c = ctx2[1].font) == null ? void 0 : _c.family) || /*$font*/
          ctx2[11].family || DEFAULT_FONT_FAMILY
        ),
        opacity: (
          /*frameTooltipPosition*/
          ctx2[6] && /*frameTooltipShown*/
          ctx2[7] ? 1 : 0
        ),
        visibility: (
          /*showHtml*/
          ctx2[10] ? "visible" : "hidden"
        ),
        transform: (
          /*transform*/
          ctx2[5]
        )
      }));
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(div, null);
      }
      ctx2[27](div);
      current = true;
      if (!mounted) {
        dispose = [
          action_destroyer(resize.call(null, div)),
          listen(
            div,
            "custom_resize",
            /*custom_resize_handler*/
            ctx2[28]
          )
        ];
        mounted = true;
      }
    },
    p(ctx3, dirty) {
      var _a2, _b, _c;
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx3);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx3, dirty);
        }
      } else {
        if (if_block) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block = if_blocks[current_block_type_index];
          if (!if_block) {
            if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx3);
            if_block.c();
          } else {
            if_block.p(ctx3, dirty);
          }
          transition_in(if_block, 1);
          if_block.m(div, null);
        } else {
          if_block = null;
        }
      }
      if (!current || dirty[0] & /*mount, $tooltip, $font, frameTooltipPosition, frameTooltipShown, showHtml, transform*/
      3554 && div_style_value !== (div_style_value = styleToString({
        transition: (
          /*mount*/
          ctx3[8] ? `
            opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s,
            transform 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s
            ` : void 0
        ),
        boxSizing: "border-box",
        left: 0,
        top: 0,
        maxWidth: 400,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 1e3,
        position: "absolute",
        borderRadius: "2px",
        whiteSpace: "nowrap",
        // border: '1px solid #333',
        boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.4)",
        background: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fontSize: (
          /*$tooltip*/
          (_b = (_a2 = ctx3[1].font) == null ? void 0 : _a2.size) != null ? _b : (
            /*$font*/
            ctx3[11].size
          )
        ),
        fontFamily: (
          /*$tooltip*/
          ((_c = ctx3[1].font) == null ? void 0 : _c.family) || /*$font*/
          ctx3[11].family || DEFAULT_FONT_FAMILY
        ),
        opacity: (
          /*frameTooltipPosition*/
          ctx3[6] && /*frameTooltipShown*/
          ctx3[7] ? 1 : 0
        ),
        visibility: (
          /*showHtml*/
          ctx3[10] ? "visible" : "hidden"
        ),
        transform: (
          /*transform*/
          ctx3[5]
        )
      }))) {
        attr(div, "style", div_style_value);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(div);
      }
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d();
      }
      ctx2[27](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
const padding = 20;
function instance_1$8($$self, $$props, $$invalidate) {
  let $tooltip;
  let $tooltipShown;
  let $tooltipPosition;
  let $fullscreen;
  let $chartHeight;
  let $chartWidth;
  let $el;
  let $font;
  let $tooltipContent;
  const instance2 = getInstance();
  const { el, tooltip, chartWidth, chartHeight, fullscreen, tooltipShown, tooltipPosition, tooltipContent, font } = instance2;
  component_subscribe($$self, el, (value) => $$invalidate(32, $el = value));
  component_subscribe($$self, tooltip, (value) => $$invalidate(1, $tooltip = value));
  component_subscribe($$self, chartWidth, (value) => $$invalidate(31, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(30, $chartHeight = value));
  component_subscribe($$self, fullscreen, (value) => $$invalidate(29, $fullscreen = value));
  component_subscribe($$self, tooltipShown, (value) => $$invalidate(24, $tooltipShown = value));
  component_subscribe($$self, tooltipPosition, (value) => $$invalidate(25, $tooltipPosition = value));
  component_subscribe($$self, tooltipContent, (value) => $$invalidate(12, $tooltipContent = value));
  component_subscribe($$self, font, (value) => $$invalidate(11, $font = value));
  let tooltipEl;
  let tooltipWidth;
  let tooltipHeight;
  let transform = "";
  let frameTooltipPosition = null;
  let frameTooltipShown = false;
  let mount = false;
  onMount(() => {
    let frame2;
    async function loop() {
      frame2 = requestAnimationFrame(loop);
      $$invalidate(6, frameTooltipPosition = $tooltipPosition);
      $$invalidate(7, frameTooltipShown = false);
      if ($tooltipPosition && $el && tooltipWidth > 0 && tooltipHeight > 0) {
        const boundingRect = $el.getBoundingClientRect();
        const scaleX = boundingRect.width / $el.offsetWidth;
        const scaleY = boundingRect.height / $el.offsetHeight;
        const svgRect = $fullscreen ? { left: 0, top: 0 } : {
          left: boundingRect.left,
          top: boundingRect.top
        };
        const containerWidth = $fullscreen ? $chartWidth : document.body.clientWidth;
        const containerHeight = $fullscreen ? $chartHeight : document.body.clientHeight;
        let tooltipLeft = $tooltipPosition[0] * scaleX + svgRect.left + padding;
        if (tooltipLeft + tooltipWidth > containerWidth) {
          tooltipLeft = $tooltipPosition[0] * scaleX + svgRect.left - tooltipWidth - padding;
        }
        if (tooltipLeft < 0) {
          tooltipLeft = 0;
        }
        let tooltipTop = $tooltipPosition[1] * scaleY + svgRect.top + padding;
        if (tooltipTop + tooltipHeight > containerHeight) {
          tooltipTop = $tooltipPosition[1] * scaleY + svgRect.top - tooltipHeight - padding;
        }
        if (tooltipTop < 0) {
          tooltipTop = 0;
        }
        if (!$fullscreen) {
          tooltipLeft += window.scrollX;
          tooltipTop += window.scrollY;
        }
        $$invalidate(7, frameTooltipShown = true);
        $$invalidate(5, transform = `translate(${tooltipLeft}px,${tooltipTop}px)`);
        instance2.setTimeout(() => {
          $$invalidate(8, mount = true);
        });
      } else {
        $$invalidate(8, mount = false);
      }
    }
    loop();
    return () => cancelAnimationFrame(frame2);
  });
  let counter = 0;
  let html = null;
  let style = null;
  let htmlLoading = false;
  let showHtml = false;
  function div_input_handler() {
    html = this.innerHTML;
    $$invalidate(0, html), $$invalidate(22, counter), $$invalidate(1, $tooltip), $$invalidate(25, $tooltipPosition), $$invalidate(24, $tooltipShown);
  }
  function div_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      tooltipEl = $$value;
      $$invalidate(2, tooltipEl);
    });
  }
  const custom_resize_handler = (e3) => {
    $$invalidate(3, tooltipWidth = e3.detail.width);
    $$invalidate(4, tooltipHeight = e3.detail.height);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*counter, $tooltip, $tooltipPosition, $tooltipShown*/
    54525954) {
      {
        const id2 = $$invalidate(22, ++counter);
        $$invalidate(0, html = null);
        if (($tooltip == null ? void 0 : $tooltip.html) && $tooltipPosition && $tooltipShown) {
          const applyTooltipResponse = (tooltipResponse2) => {
            var _a2;
            if (tooltipResponse2 == null) {
              $$invalidate(0, html = null);
              $$invalidate(9, style = null);
            } else if (typeof tooltipResponse2 === "string") {
              $$invalidate(0, html = tooltipResponse2);
              $$invalidate(9, style = null);
            } else {
              $$invalidate(0, html = tooltipResponse2.html);
              $$invalidate(9, style = (_a2 = tooltipResponse2.style) != null ? _a2 : null);
            }
          };
          const tooltipResponse = $tooltip.html(instance2);
          if (tooltipResponse instanceof Promise) {
            $$invalidate(23, htmlLoading = true);
            tooltipResponse.then((tooltipResponse2) => {
              if (id2 === counter) {
                $$invalidate(23, htmlLoading = false);
                applyTooltipResponse(tooltipResponse2);
              }
            });
          } else {
            applyTooltipResponse(tooltipResponse);
          }
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$tooltip, html, htmlLoading*/
    8388611) {
      {
        if ($tooltip.html) {
          $$invalidate(10, showHtml = html != null || htmlLoading);
        } else {
          $$invalidate(10, showHtml = true);
        }
      }
    }
  };
  return [
    html,
    $tooltip,
    tooltipEl,
    tooltipWidth,
    tooltipHeight,
    transform,
    frameTooltipPosition,
    frameTooltipShown,
    mount,
    style,
    showHtml,
    $font,
    $tooltipContent,
    el,
    tooltip,
    chartWidth,
    chartHeight,
    fullscreen,
    tooltipShown,
    tooltipPosition,
    tooltipContent,
    font,
    counter,
    htmlLoading,
    $tooltipShown,
    $tooltipPosition,
    div_input_handler,
    div_binding,
    custom_resize_handler
  ];
}
class Tooltip extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$8, create_fragment$b, safe_not_equal, {}, null, [-1, -1]);
  }
}
function create_if_block$5(ctx2) {
  let previous_key = (
    /*titleShape*/
    ctx2[0].id
  );
  let key_block_anchor;
  let current;
  let key_block = create_key_block$1(ctx2);
  return {
    c() {
      key_block.c();
      key_block_anchor = empty();
    },
    m(target, anchor) {
      key_block.m(target, anchor);
      insert(target, key_block_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty & /*titleShape*/
      1 && safe_not_equal(previous_key, previous_key = /*titleShape*/
      ctx3[0].id)) {
        group_outros();
        transition_out(key_block, 1, 1, noop$2);
        check_outros();
        key_block = create_key_block$1(ctx3);
        key_block.c();
        transition_in(key_block, 1);
        key_block.m(key_block_anchor.parentNode, key_block_anchor);
      } else {
        key_block.p(ctx3, dirty);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(key_block);
      current = true;
    },
    o(local) {
      transition_out(key_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(key_block_anchor);
      }
      key_block.d(detaching);
    }
  };
}
function create_key_block$1(ctx2) {
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = (
    /*titleShape*/
    ctx2[0].component
  );
  function switch_props(ctx3, dirty) {
    return {
      props: { shapeInstance: (
        /*titleShape*/
        ctx3[0]
      ) }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    c() {
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m(target, anchor) {
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty & /*titleShape*/
      1 && switch_value !== (switch_value = /*titleShape*/
      ctx3[0].component)) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx3));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        const switch_instance_changes = {};
        if (dirty & /*titleShape*/
        1)
          switch_instance_changes.shapeInstance = /*titleShape*/
          ctx3[0];
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_fragment$a(ctx2) {
  let if_block_anchor;
  let current;
  let if_block = (
    /*titleShape*/
    ctx2[0] && create_if_block$5(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx3, [dirty]) {
      if (
        /*titleShape*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
          if (dirty & /*titleShape*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$5(ctx3);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$7($$self, $$props, $$invalidate) {
  let $chartWidth;
  let $baseMargin;
  let $font;
  let $title;
  const instance2 = getInstance();
  const { chartWidth, titleRect, font, title, baseMargin } = instance2;
  component_subscribe($$self, chartWidth, (value) => $$invalidate(5, $chartWidth = value));
  component_subscribe($$self, font, (value) => $$invalidate(7, $font = value));
  component_subscribe($$self, title, (value) => $$invalidate(8, $title = value));
  component_subscribe($$self, baseMargin, (value) => $$invalidate(6, $baseMargin = value));
  let titleShape;
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$title, $font, $baseMargin, $chartWidth, titleShape*/
    481) {
      {
        if ($title) {
          $$invalidate(0, titleShape = new TextShape({
            text: $title.text,
            textAlign: "left",
            textBaseline: "top",
            fontSize: 20,
            fontFamily: $font.family || DEFAULT_FONT_FAMILY,
            padding: 4,
            x: $baseMargin.left,
            y: $baseMargin.top,
            width: $chartWidth,
            overflow: "ellipsis",
            props: readable({})
            // 'font-weight': 700
          }));
          const { width, height } = titleShape.getBoundingRect();
          titleRect.set({ width, height });
        } else {
          $$invalidate(0, titleShape = void 0);
          titleRect.set({ width: 0, height: 0 });
        }
      }
    }
  };
  return [
    titleShape,
    chartWidth,
    font,
    title,
    baseMargin,
    $chartWidth,
    $baseMargin,
    $font,
    $title
  ];
}
class Title extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$7, create_fragment$a, safe_not_equal, {});
  }
}
function create_fragment$9(ctx2) {
  let textarea;
  let textarea_style_value;
  let mounted;
  let dispose;
  return {
    c() {
      var _a2;
      textarea = element("textarea");
      attr(textarea, "style", textarea_style_value = new Style({
        fontSize: (
          /*$font*/
          ctx2[2].size + "px"
        ),
        fontFamily: (
          /*$font*/
          (_a2 = ctx2[2].family) != null ? _a2 : DEFAULT_FONT_FAMILY
        ),
        width: "100%",
        height: "100%",
        border: "1px solid #eee",
        borderRadius: 0,
        padding: "8px",
        margin: 0,
        outline: 0,
        boxSizing: "border-box",
        color: "#333",
        resize: "none",
        .../*focused*/
        ctx2[0] ? {
          outlineColor: "rgba(0, 0, 0, 0.4)",
          outlineWidth: "2px",
          outlineStyle: "auto"
        } : {}
      }).toString());
      textarea.value = /*textData*/
      ctx2[1];
      textarea.readOnly = true;
    },
    m(target, anchor) {
      insert(target, textarea, anchor);
      if (!mounted) {
        dispose = [
          listen(
            textarea,
            "focus",
            /*focus_handler*/
            ctx2[8]
          ),
          listen(
            textarea,
            "blur",
            /*blur_handler*/
            ctx2[9]
          )
        ];
        mounted = true;
      }
    },
    p(ctx3, [dirty]) {
      var _a2;
      if (dirty & /*$font, focused*/
      5 && textarea_style_value !== (textarea_style_value = new Style({
        fontSize: (
          /*$font*/
          ctx3[2].size + "px"
        ),
        fontFamily: (
          /*$font*/
          (_a2 = ctx3[2].family) != null ? _a2 : DEFAULT_FONT_FAMILY
        ),
        width: "100%",
        height: "100%",
        border: "1px solid #eee",
        borderRadius: 0,
        padding: "8px",
        margin: 0,
        outline: 0,
        boxSizing: "border-box",
        color: "#333",
        resize: "none",
        .../*focused*/
        ctx3[0] ? {
          outlineColor: "rgba(0, 0, 0, 0.4)",
          outlineWidth: "2px",
          outlineStyle: "auto"
        } : {}
      }).toString())) {
        attr(textarea, "style", textarea_style_value);
      }
      if (dirty & /*textData*/
      2) {
        textarea.value = /*textData*/
        ctx3[1];
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(textarea);
      }
      mounted = false;
      run_all(dispose);
    }
  };
}
const DELIM = "	";
function instance$6($$self, $$props, $$invalidate) {
  let textData;
  let $data;
  let $dataColumns;
  let $font;
  const { font, dataColumns, data } = getInstance();
  component_subscribe($$self, font, (value) => $$invalidate(2, $font = value));
  component_subscribe($$self, dataColumns, (value) => $$invalidate(7, $dataColumns = value));
  component_subscribe($$self, data, (value) => $$invalidate(6, $data = value));
  let focused = false;
  const focus_handler = () => {
    $$invalidate(0, focused = true);
  };
  const blur_handler = () => {
    $$invalidate(0, focused = false);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$dataColumns, $data*/
    192) {
      $$invalidate(1, textData = (() => {
        if ($dataColumns == null || $data == null) {
          return "";
        }
        const columns = $dataColumns;
        return [
          columns.map((column2) => column2.title).join(DELIM),
          ...$data.map((row) => {
            return columns.map((column2) => {
              const value = column2.valueGetter(row);
              if (column2.type === "category") {
                return column2.formatter(value);
              } else if (column2.type === "value") {
                return column2.formatter(value);
              }
              return "";
            }).join(DELIM);
          })
        ].join("\n");
      })());
    }
  };
  return [
    focused,
    textData,
    $font,
    font,
    dataColumns,
    data,
    $data,
    $dataColumns,
    focus_handler,
    blur_handler
  ];
}
class TextArea2 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$6, create_fragment$9, safe_not_equal, {});
  }
}
function create_if_block$4(ctx2) {
  let previous_key = (
    /*subtitleShape*/
    ctx2[0].id
  );
  let key_block_anchor;
  let current;
  let key_block = create_key_block(ctx2);
  return {
    c() {
      key_block.c();
      key_block_anchor = empty();
    },
    m(target, anchor) {
      key_block.m(target, anchor);
      insert(target, key_block_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty & /*subtitleShape*/
      1 && safe_not_equal(previous_key, previous_key = /*subtitleShape*/
      ctx3[0].id)) {
        group_outros();
        transition_out(key_block, 1, 1, noop$2);
        check_outros();
        key_block = create_key_block(ctx3);
        key_block.c();
        transition_in(key_block, 1);
        key_block.m(key_block_anchor.parentNode, key_block_anchor);
      } else {
        key_block.p(ctx3, dirty);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(key_block);
      current = true;
    },
    o(local) {
      transition_out(key_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(key_block_anchor);
      }
      key_block.d(detaching);
    }
  };
}
function create_key_block(ctx2) {
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = (
    /*subtitleShape*/
    ctx2[0].component
  );
  function switch_props(ctx3, dirty) {
    return {
      props: { shapeInstance: (
        /*subtitleShape*/
        ctx3[0]
      ) }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    c() {
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m(target, anchor) {
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty & /*subtitleShape*/
      1 && switch_value !== (switch_value = /*subtitleShape*/
      ctx3[0].component)) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx3));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        const switch_instance_changes = {};
        if (dirty & /*subtitleShape*/
        1)
          switch_instance_changes.shapeInstance = /*subtitleShape*/
          ctx3[0];
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_fragment$8(ctx2) {
  let if_block_anchor;
  let current;
  let if_block = (
    /*subtitleShape*/
    ctx2[0] && create_if_block$4(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx3, [dirty]) {
      if (
        /*subtitleShape*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
          if (dirty & /*subtitleShape*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$4(ctx3);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$6($$self, $$props, $$invalidate) {
  let $font;
  let $chartWidth;
  let $titleRect;
  let $baseMargin;
  let $subtitle;
  const instance2 = getInstance();
  const { chartWidth, titleRect, subtitleRect, font, subtitle, baseMargin } = instance2;
  component_subscribe($$self, chartWidth, (value) => $$invalidate(7, $chartWidth = value));
  component_subscribe($$self, titleRect, (value) => $$invalidate(8, $titleRect = value));
  component_subscribe($$self, font, (value) => $$invalidate(6, $font = value));
  component_subscribe($$self, subtitle, (value) => $$invalidate(10, $subtitle = value));
  component_subscribe($$self, baseMargin, (value) => $$invalidate(9, $baseMargin = value));
  let subtitleShape;
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$subtitle, $font, $baseMargin, $titleRect, $chartWidth, subtitleShape*/
    1985) {
      {
        if ($subtitle) {
          $$invalidate(0, subtitleShape = new BoxTextShape({
            text: $subtitle.text,
            textAlign: "center",
            textBaseline: "top",
            fontSize: $font.size,
            fontFamily: $font.family || DEFAULT_FONT_FAMILY,
            padding: 4,
            x: $baseMargin.left,
            y: $baseMargin.top + $titleRect.height,
            width: $chartWidth,
            height: $font.size * 2,
            overflow: "ellipsis",
            props: readable({})
            // 'font-weight': 700
          }));
          const { width, height } = subtitleShape.getBoundingRect();
          subtitleRect.set({ width, height });
        } else {
          $$invalidate(0, subtitleShape = void 0);
          subtitleRect.set({ width: 0, height: 0 });
        }
      }
    }
  };
  return [
    subtitleShape,
    chartWidth,
    titleRect,
    font,
    subtitle,
    baseMargin,
    $font,
    $chartWidth,
    $titleRect,
    $baseMargin,
    $subtitle
  ];
}
class Subtitle extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$6, create_fragment$8, safe_not_equal, {});
  }
}
const methodMap = [
  [
    "requestFullscreen",
    "exitFullscreen",
    "fullscreenElement",
    "fullscreenEnabled",
    "fullscreenchange",
    "fullscreenerror"
  ],
  // New WebKit
  [
    "webkitRequestFullscreen",
    "webkitExitFullscreen",
    "webkitFullscreenElement",
    "webkitFullscreenEnabled",
    "webkitfullscreenchange",
    "webkitfullscreenerror"
  ],
  // Old WebKit
  [
    "webkitRequestFullScreen",
    "webkitCancelFullScreen",
    "webkitCurrentFullScreenElement",
    "webkitCancelFullScreen",
    "webkitfullscreenchange",
    "webkitfullscreenerror"
  ],
  [
    "mozRequestFullScreen",
    "mozCancelFullScreen",
    "mozFullScreenElement",
    "mozFullScreenEnabled",
    "mozfullscreenchange",
    "mozfullscreenerror"
  ],
  [
    "msRequestFullscreen",
    "msExitFullscreen",
    "msFullscreenElement",
    "msFullscreenEnabled",
    "MSFullscreenChange",
    "MSFullscreenError"
  ]
];
const nativeAPI = (() => {
  if (typeof document === "undefined") {
    return false;
  }
  const unprefixedMethods = methodMap[0];
  const returnValue = {};
  for (const methodList of methodMap) {
    const exitFullscreenMethod = methodList == null ? void 0 : methodList[1];
    if (exitFullscreenMethod in document) {
      for (const [index2, method] of methodList.entries()) {
        returnValue[unprefixedMethods[index2]] = method;
      }
      return returnValue;
    }
  }
  return false;
})();
const eventNameMap = {
  change: nativeAPI.fullscreenchange,
  error: nativeAPI.fullscreenerror
};
let screenfull = {
  // eslint-disable-next-line default-param-last
  request(element2 = document.documentElement, options) {
    return new Promise((resolve, reject) => {
      const onFullScreenEntered = () => {
        screenfull.off("change", onFullScreenEntered);
        resolve();
      };
      screenfull.on("change", onFullScreenEntered);
      const returnPromise = element2[nativeAPI.requestFullscreen](options);
      if (returnPromise instanceof Promise) {
        returnPromise.then(onFullScreenEntered).catch(reject);
      }
    });
  },
  exit() {
    return new Promise((resolve, reject) => {
      if (!screenfull.isFullscreen) {
        resolve();
        return;
      }
      const onFullScreenExit = () => {
        screenfull.off("change", onFullScreenExit);
        resolve();
      };
      screenfull.on("change", onFullScreenExit);
      const returnPromise = document[nativeAPI.exitFullscreen]();
      if (returnPromise instanceof Promise) {
        returnPromise.then(onFullScreenExit).catch(reject);
      }
    });
  },
  toggle(element2, options) {
    return screenfull.isFullscreen ? screenfull.exit() : screenfull.request(element2, options);
  },
  onchange(callback) {
    screenfull.on("change", callback);
  },
  onerror(callback) {
    screenfull.on("error", callback);
  },
  on(event, callback) {
    const eventName = eventNameMap[event];
    if (eventName) {
      document.addEventListener(eventName, callback, false);
    }
  },
  off(event, callback) {
    const eventName = eventNameMap[event];
    if (eventName) {
      document.removeEventListener(eventName, callback, false);
    }
  },
  raw: nativeAPI
};
Object.defineProperties(screenfull, {
  isFullscreen: {
    get: () => Boolean(document[nativeAPI.fullscreenElement])
  },
  element: {
    enumerable: true,
    get: () => {
      var _a2;
      return (_a2 = document[nativeAPI.fullscreenElement]) != null ? _a2 : void 0;
    }
  },
  isEnabled: {
    enumerable: true,
    // Coerce to boolean in case of old WebKit.
    get: () => Boolean(document[nativeAPI.fullscreenEnabled])
  }
});
if (!nativeAPI) {
  screenfull = { isEnabled: false };
}
const _screenfull = screenfull;
function get_each_context$2(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[37] = list[i2];
  child_ctx[39] = i2;
  return child_ctx;
}
function create_if_block$3(ctx2) {
  let div;
  let button0;
  let t0;
  let button0_disabled_value;
  let t1;
  let button1;
  let t2;
  let button1_disabled_value;
  let t3;
  let button2;
  let t4;
  let button2_disabled_value;
  let t5;
  let button3;
  let t6;
  let button3_disabled_value;
  let t7;
  let t8;
  let button4;
  let t9;
  let button4_style_value;
  let button4_disabled_value;
  let t10;
  let button5;
  let t11;
  let button5_style_value;
  let t12;
  let button6;
  let t13;
  let button6_style_value;
  let t14;
  let t15;
  let mounted;
  let dispose;
  let if_block0 = (
    /*screenfull*/
    ctx2[8].isEnabled && create_if_block_2$2(ctx2)
  );
  let if_block1 = (
    /*$focused*/
    ctx2[6].length > 0 && create_if_block_1$2(ctx2)
  );
  let each_value = ensure_array_like(
    /*$menuExtraButtons*/
    ctx2[7]
  );
  let each_blocks = [];
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    each_blocks[i2] = create_each_block$2(get_each_context$2(ctx2, each_value, i2));
  }
  return {
    c() {
      div = element("div");
      button0 = element("button");
      t0 = text("ダウンロード(PNG)");
      t1 = space();
      button1 = element("button");
      t2 = text("ダウンロード(JPEG)");
      t3 = space();
      button2 = element("button");
      t4 = text("ダウンロード(SVG)");
      t5 = space();
      button3 = element("button");
      t6 = text("クリップボードにコピー");
      t7 = space();
      if (if_block0)
        if_block0.c();
      t8 = space();
      button4 = element("button");
      t9 = text("チャート");
      t10 = space();
      button5 = element("button");
      t11 = text("テーブル");
      t12 = space();
      button6 = element("button");
      t13 = text("テキスト表示");
      t14 = space();
      if (if_block1)
        if_block1.c();
      t15 = space();
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      attr(
        button0,
        "style",
        /*menuItemStyle*/
        ctx2[18]
      );
      button0.disabled = button0_disabled_value = /*$chartContent*/
      ctx2[3] == null;
      attr(
        button1,
        "style",
        /*menuItemStyle*/
        ctx2[18]
      );
      button1.disabled = button1_disabled_value = /*$chartContent*/
      ctx2[3] == null;
      attr(
        button2,
        "style",
        /*menuItemStyle*/
        ctx2[18]
      );
      button2.disabled = button2_disabled_value = /*$chartContent*/
      ctx2[3] == null;
      attr(
        button3,
        "style",
        /*menuItemStyle*/
        ctx2[18]
      );
      button3.disabled = button3_disabled_value = /*$showType*/
      ctx2[4] !== "chart";
      attr(button4, "style", button4_style_value = /*menuItemStyle*/
      ctx2[18] + ";" + /*$showType*/
      (ctx2[4] === "chart" ? (
        /*focusedMenuItemStyle*/
        ctx2[19]
      ) : ""));
      button4.disabled = button4_disabled_value = /*$chartContent*/
      ctx2[3] == null;
      attr(button5, "style", button5_style_value = /*menuItemStyle*/
      ctx2[18] + ";" + /*$showType*/
      (ctx2[4] === "table" ? (
        /*focusedMenuItemStyle*/
        ctx2[19]
      ) : ""));
      attr(button6, "style", button6_style_value = "" + /*menuItemStyle*/
      (ctx2[18] + /*$showType*/
      (ctx2[4] === "text" ? (
        /*focusedMenuItemStyle*/
        ctx2[19]
      ) : "")));
      attr(
        div,
        "style",
        /*menuStyle*/
        ctx2[2]
      );
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append$2(div, button0);
      append$2(button0, t0);
      append$2(div, t1);
      append$2(div, button1);
      append$2(button1, t2);
      append$2(div, t3);
      append$2(div, button2);
      append$2(button2, t4);
      append$2(div, t5);
      append$2(div, button3);
      append$2(button3, t6);
      append$2(div, t7);
      if (if_block0)
        if_block0.m(div, null);
      append$2(div, t8);
      append$2(div, button4);
      append$2(button4, t9);
      append$2(div, t10);
      append$2(div, button5);
      append$2(button5, t11);
      append$2(div, t12);
      append$2(div, button6);
      append$2(button6, t13);
      append$2(div, t14);
      if (if_block1)
        if_block1.m(div, null);
      append$2(div, t15);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(div, null);
        }
      }
      ctx2[34](div);
      if (!mounted) {
        dispose = [
          listen(
            button0,
            "click",
            /*click_handler*/
            ctx2[24]
          ),
          listen(
            button1,
            "click",
            /*click_handler_1*/
            ctx2[25]
          ),
          listen(
            button2,
            "click",
            /*click_handler_2*/
            ctx2[26]
          ),
          listen(
            button3,
            "click",
            /*click_handler_3*/
            ctx2[27]
          ),
          listen(
            button4,
            "click",
            /*click_handler_5*/
            ctx2[29]
          ),
          listen(
            button5,
            "click",
            /*click_handler_6*/
            ctx2[30]
          ),
          listen(
            button6,
            "click",
            /*click_handler_7*/
            ctx2[31]
          )
        ];
        mounted = true;
      }
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$chartContent*/
      8 && button0_disabled_value !== (button0_disabled_value = /*$chartContent*/
      ctx3[3] == null)) {
        button0.disabled = button0_disabled_value;
      }
      if (dirty[0] & /*$chartContent*/
      8 && button1_disabled_value !== (button1_disabled_value = /*$chartContent*/
      ctx3[3] == null)) {
        button1.disabled = button1_disabled_value;
      }
      if (dirty[0] & /*$chartContent*/
      8 && button2_disabled_value !== (button2_disabled_value = /*$chartContent*/
      ctx3[3] == null)) {
        button2.disabled = button2_disabled_value;
      }
      if (dirty[0] & /*$showType*/
      16 && button3_disabled_value !== (button3_disabled_value = /*$showType*/
      ctx3[4] !== "chart")) {
        button3.disabled = button3_disabled_value;
      }
      if (
        /*screenfull*/
        ctx3[8].isEnabled
      )
        if_block0.p(ctx3, dirty);
      if (dirty[0] & /*$showType*/
      16 && button4_style_value !== (button4_style_value = /*menuItemStyle*/
      ctx3[18] + ";" + /*$showType*/
      (ctx3[4] === "chart" ? (
        /*focusedMenuItemStyle*/
        ctx3[19]
      ) : ""))) {
        attr(button4, "style", button4_style_value);
      }
      if (dirty[0] & /*$chartContent*/
      8 && button4_disabled_value !== (button4_disabled_value = /*$chartContent*/
      ctx3[3] == null)) {
        button4.disabled = button4_disabled_value;
      }
      if (dirty[0] & /*$showType*/
      16 && button5_style_value !== (button5_style_value = /*menuItemStyle*/
      ctx3[18] + ";" + /*$showType*/
      (ctx3[4] === "table" ? (
        /*focusedMenuItemStyle*/
        ctx3[19]
      ) : ""))) {
        attr(button5, "style", button5_style_value);
      }
      if (dirty[0] & /*$showType*/
      16 && button6_style_value !== (button6_style_value = "" + /*menuItemStyle*/
      (ctx3[18] + /*$showType*/
      (ctx3[4] === "text" ? (
        /*focusedMenuItemStyle*/
        ctx3[19]
      ) : "")))) {
        attr(button6, "style", button6_style_value);
      }
      if (
        /*$focused*/
        ctx3[6].length > 0
      ) {
        if (if_block1) {
          if_block1.p(ctx3, dirty);
        } else {
          if_block1 = create_if_block_1$2(ctx3);
          if_block1.c();
          if_block1.m(div, t15);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
      if (dirty[0] & /*menuItemStyle, $menuExtraButtons*/
      262272) {
        each_value = ensure_array_like(
          /*$menuExtraButtons*/
          ctx3[7]
        );
        let i2;
        for (i2 = 0; i2 < each_value.length; i2 += 1) {
          const child_ctx = get_each_context$2(ctx3, each_value, i2);
          if (each_blocks[i2]) {
            each_blocks[i2].p(child_ctx, dirty);
          } else {
            each_blocks[i2] = create_each_block$2(child_ctx);
            each_blocks[i2].c();
            each_blocks[i2].m(div, null);
          }
        }
        for (; i2 < each_blocks.length; i2 += 1) {
          each_blocks[i2].d(1);
        }
        each_blocks.length = each_value.length;
      }
      if (dirty[0] & /*menuStyle*/
      4) {
        attr(
          div,
          "style",
          /*menuStyle*/
          ctx3[2]
        );
      }
    },
    d(detaching) {
      if (detaching) {
        detach(div);
      }
      if (if_block0)
        if_block0.d();
      if (if_block1)
        if_block1.d();
      destroy_each(each_blocks, detaching);
      ctx2[34](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_if_block_2$2(ctx2) {
  let button_1;
  let t2;
  let button_1_disabled_value;
  let mounted;
  let dispose;
  return {
    c() {
      button_1 = element("button");
      t2 = text("フルスクリーン");
      attr(
        button_1,
        "style",
        /*menuItemStyle*/
        ctx2[18]
      );
      button_1.disabled = button_1_disabled_value = /*$chartContent*/
      ctx2[3] == null;
    },
    m(target, anchor) {
      insert(target, button_1, anchor);
      append$2(button_1, t2);
      if (!mounted) {
        dispose = listen(
          button_1,
          "click",
          /*click_handler_4*/
          ctx2[28]
        );
        mounted = true;
      }
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$chartContent*/
      8 && button_1_disabled_value !== (button_1_disabled_value = /*$chartContent*/
      ctx3[3] == null)) {
        button_1.disabled = button_1_disabled_value;
      }
    },
    d(detaching) {
      if (detaching) {
        detach(button_1);
      }
      mounted = false;
      dispose();
    }
  };
}
function create_if_block_1$2(ctx2) {
  let button_1;
  let t2;
  let mounted;
  let dispose;
  return {
    c() {
      button_1 = element("button");
      t2 = text("選択の解除");
      attr(
        button_1,
        "style",
        /*menuItemStyle*/
        ctx2[18]
      );
    },
    m(target, anchor) {
      insert(target, button_1, anchor);
      append$2(button_1, t2);
      if (!mounted) {
        dispose = listen(
          button_1,
          "click",
          /*click_handler_8*/
          ctx2[32]
        );
        mounted = true;
      }
    },
    p: noop$2,
    d(detaching) {
      if (detaching) {
        detach(button_1);
      }
      mounted = false;
      dispose();
    }
  };
}
function create_each_block$2(ctx2) {
  let button_1;
  let t0_value = (
    /*button*/
    ctx2[37].title + ""
  );
  let t0;
  let t1;
  let mounted;
  let dispose;
  function click_handler_9() {
    return (
      /*click_handler_9*/
      ctx2[33](
        /*button*/
        ctx2[37]
      )
    );
  }
  return {
    c() {
      button_1 = element("button");
      t0 = text(t0_value);
      t1 = space();
      attr(
        button_1,
        "style",
        /*menuItemStyle*/
        ctx2[18]
      );
    },
    m(target, anchor) {
      insert(target, button_1, anchor);
      append$2(button_1, t0);
      append$2(button_1, t1);
      if (!mounted) {
        dispose = listen(button_1, "click", click_handler_9);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (dirty[0] & /*$menuExtraButtons*/
      128 && t0_value !== (t0_value = /*button*/
      ctx2[37].title + ""))
        set_data(t0, t0_value);
    },
    d(detaching) {
      if (detaching) {
        detach(button_1);
      }
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$7(ctx2) {
  let if_block_anchor;
  let if_block = (
    /*$menuShown*/
    ctx2[0] && create_if_block$3(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p(ctx3, dirty) {
      if (
        /*$menuShown*/
        ctx3[0]
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
        } else {
          if_block = create_if_block$3(ctx3);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function isParent(el2, parent) {
  if (!el2) {
    return false;
  }
  if (el2 === document.body) {
    return false;
  }
  if (el2 === parent) {
    return true;
  }
  return isParent(el2.parentElement, parent);
}
function instance_1$5($$self, $$props, $$invalidate) {
  let menuStyle;
  let $font;
  let $menuButtonEl;
  let $menuShown;
  let $chartContent;
  let $showType;
  let $el;
  let $focused;
  let $menuExtraButtons;
  const screenfull2 = _screenfull;
  const instance2 = getInstance();
  const { el, menuShown, fullscreen, showType, menuButtonEl, focused, menuExtraButtons, chartContent, font } = instance2;
  component_subscribe($$self, el, (value) => $$invalidate(5, $el = value));
  component_subscribe($$self, menuShown, (value) => $$invalidate(0, $menuShown = value));
  component_subscribe($$self, showType, (value) => $$invalidate(4, $showType = value));
  component_subscribe($$self, menuButtonEl, (value) => $$invalidate(23, $menuButtonEl = value));
  component_subscribe($$self, focused, (value) => $$invalidate(6, $focused = value));
  component_subscribe($$self, menuExtraButtons, (value) => $$invalidate(7, $menuExtraButtons = value));
  component_subscribe($$self, chartContent, (value) => $$invalidate(3, $chartContent = value));
  component_subscribe($$self, font, (value) => $$invalidate(22, $font = value));
  let menu;
  const handler = (e3) => {
    if (isParent(e3.target, menu)) {
      return;
    }
    menuShown.set(false);
  };
  let top = 0;
  let left = 0;
  if (screenfull2.isEnabled) {
    screenfull2.on("change", (e3) => {
      fullscreen.set(screenfull2.isFullscreen);
    });
  }
  const menuItemStyle = styleToString({
    padding: "4px 8px",
    cursor: "pointer",
    background: "#fff",
    border: "none",
    width: "100%",
    textAlign: "left",
    margin: 0,
    fontSize: 10,
    fontFamily: $font.family || DEFAULT_FONT_FAMILY
  });
  const focusedMenuItemStyle = styleToString({ fontWeight: "bold", color: "#2c8dd6" });
  onDestroy(() => {
    document.removeEventListener("mousedown", handler);
  });
  const click_handler = async () => {
    await download(instance2, "png");
    menuShown.set(false);
  };
  const click_handler_1 = async () => {
    await download(instance2, "jpeg");
    menuShown.set(false);
  };
  const click_handler_2 = async () => {
    await download(instance2, "svg");
    menuShown.set(false);
  };
  const click_handler_3 = async () => {
    await copyToClipboard(instance2);
    menuShown.set(false);
  };
  const click_handler_4 = () => {
    if (screenfull2.isEnabled) {
      screenfull2.toggle($el);
    }
    menuShown.set(false);
  };
  const click_handler_5 = () => {
    showType.set("chart");
    menuShown.set(false);
  };
  const click_handler_6 = () => {
    showType.set("table");
    menuShown.set(false);
  };
  const click_handler_7 = () => {
    showType.set("text");
    menuShown.set(false);
  };
  const click_handler_8 = () => {
    focused.set([]);
  };
  const click_handler_9 = (button) => {
    button.onClick();
  };
  function div_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      menu = $$value;
      $$invalidate(1, menu);
    });
  }
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*$menuShown, $menuButtonEl*/
    8388609) {
      {
        if ($menuShown && $menuButtonEl) {
          const rect = $menuButtonEl.getBoundingClientRect();
          $$invalidate(21, left = rect.right - 200 + window.scrollX);
          $$invalidate(20, top = rect.bottom + window.scrollY);
          document.addEventListener("mousedown", handler);
        } else {
          document.removeEventListener("mousedown", handler);
        }
      }
    }
    if ($$self.$$.dirty[0] & /*top, left, $font*/
    7340032) {
      $$invalidate(2, menuStyle = styleToString({
        position: "absolute",
        top: `${top}px`,
        left: `${left}px`,
        zIndex: 1e4,
        padding: "8px 0",
        background: "#fff",
        borderRadius: "2px",
        width: "200px",
        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.4)",
        fontSize: "10px",
        fontFamily: $font.family || DEFAULT_FONT_FAMILY
      }));
    }
  };
  return [
    $menuShown,
    menu,
    menuStyle,
    $chartContent,
    $showType,
    $el,
    $focused,
    $menuExtraButtons,
    screenfull2,
    instance2,
    el,
    menuShown,
    showType,
    menuButtonEl,
    focused,
    menuExtraButtons,
    chartContent,
    font,
    menuItemStyle,
    focusedMenuItemStyle,
    top,
    left,
    $font,
    $menuButtonEl,
    click_handler,
    click_handler_1,
    click_handler_2,
    click_handler_3,
    click_handler_4,
    click_handler_5,
    click_handler_6,
    click_handler_7,
    click_handler_8,
    click_handler_9,
    div_binding
  ];
}
class Menu2 extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$5, create_fragment$7, safe_not_equal, {}, null, [-1, -1]);
  }
}
function create_fragment$6(ctx2) {
  let svg;
  let path;
  let svg_fill_value;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "M7 10l5 5 5-5H7z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", 6);
      attr(svg, "viewBox", "6 9 12 6");
      attr(svg, "width", 12);
      attr(svg, "fill", svg_fill_value = /*active*/
      ctx2[0] ? colors.blue : "#999");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append$2(svg, path);
    },
    p(ctx3, [dirty]) {
      if (dirty & /*active*/
      1 && svg_fill_value !== (svg_fill_value = /*active*/
      ctx3[0] ? colors.blue : "#999")) {
        attr(svg, "fill", svg_fill_value);
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(svg);
      }
    }
  };
}
function instance$5($$self, $$props, $$invalidate) {
  let { active = false } = $$props;
  $$self.$$set = ($$props2) => {
    if ("active" in $$props2)
      $$invalidate(0, active = $$props2.active);
  };
  return [active];
}
class ArrowDown extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$5, create_fragment$6, safe_not_equal, { active: 0 });
  }
}
const ArrowDown$1 = ArrowDown;
function create_fragment$5(ctx2) {
  let svg;
  let path;
  let svg_fill_value;
  return {
    c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "M7 14l5-5 5 5H7z");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "height", 6);
      attr(svg, "viewBox", "6 9 12 6");
      attr(svg, "width", 12);
      attr(svg, "fill", svg_fill_value = /*active*/
      ctx2[0] ? colors.blue : "#999");
    },
    m(target, anchor) {
      insert(target, svg, anchor);
      append$2(svg, path);
    },
    p(ctx3, [dirty]) {
      if (dirty & /*active*/
      1 && svg_fill_value !== (svg_fill_value = /*active*/
      ctx3[0] ? colors.blue : "#999")) {
        attr(svg, "fill", svg_fill_value);
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(svg);
      }
    }
  };
}
function instance$4($$self, $$props, $$invalidate) {
  let { active = false } = $$props;
  $$self.$$set = ($$props2) => {
    if ("active" in $$props2)
      $$invalidate(0, active = $$props2.active);
  };
  return [active];
}
class ArrowUp extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$4, create_fragment$5, safe_not_equal, { active: 0 });
  }
}
const ArrowUp$1 = ArrowUp;
const DataTable_svelte_svelte_type_style_lang = "";
function get_each_context$1(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[10] = list[i2];
  child_ctx[12] = i2;
  return child_ctx;
}
function get_each_context_1$1(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[13] = list[i2];
  return child_ctx;
}
function get_each_context_2$1(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[13] = list[i2];
  child_ctx[12] = i2;
  return child_ctx;
}
function create_if_block$2(ctx2) {
  let div2;
  let div0;
  let t2;
  let div1;
  let current;
  let mounted;
  let dispose;
  let each_value_2 = ensure_array_like(
    /*$tableConfig*/
    ctx2[2].columns
  );
  let each_blocks_1 = [];
  for (let i2 = 0; i2 < each_value_2.length; i2 += 1) {
    each_blocks_1[i2] = create_each_block_2$1(get_each_context_2$1(ctx2, each_value_2, i2));
  }
  const out = (i2) => transition_out(each_blocks_1[i2], 1, 1, () => {
    each_blocks_1[i2] = null;
  });
  let each_value = ensure_array_like(
    /*data*/
    ctx2[1]
  );
  let each_blocks = [];
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    each_blocks[i2] = create_each_block$1(get_each_context$1(ctx2, each_value, i2));
  }
  return {
    c() {
      div2 = element("div");
      div0 = element("div");
      for (let i2 = 0; i2 < each_blocks_1.length; i2 += 1) {
        each_blocks_1[i2].c();
      }
      t2 = space();
      div1 = element("div");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      attr(div0, "class", "header svelte-62114p");
      set_style(
        div0,
        "width",
        /*bodyWidth*/
        ctx2[3] + "px"
      );
      attr(div1, "class", "body svelte-62114p");
      attr(div2, "class", "table svelte-62114p");
    },
    m(target, anchor) {
      insert(target, div2, anchor);
      append$2(div2, div0);
      for (let i2 = 0; i2 < each_blocks_1.length; i2 += 1) {
        if (each_blocks_1[i2]) {
          each_blocks_1[i2].m(div0, null);
        }
      }
      append$2(div2, t2);
      append$2(div2, div1);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(div1, null);
        }
      }
      current = true;
      if (!mounted) {
        dispose = [
          action_destroyer(resize.call(null, div1)),
          listen(
            div1,
            "custom_resize",
            /*custom_resize_handler*/
            ctx2[9]
          )
        ];
        mounted = true;
      }
    },
    p(ctx3, dirty) {
      if (dirty & /*$tableConfig, sortConfigs*/
      5) {
        each_value_2 = ensure_array_like(
          /*$tableConfig*/
          ctx3[2].columns
        );
        let i2;
        for (i2 = 0; i2 < each_value_2.length; i2 += 1) {
          const child_ctx = get_each_context_2$1(ctx3, each_value_2, i2);
          if (each_blocks_1[i2]) {
            each_blocks_1[i2].p(child_ctx, dirty);
            transition_in(each_blocks_1[i2], 1);
          } else {
            each_blocks_1[i2] = create_each_block_2$1(child_ctx);
            each_blocks_1[i2].c();
            transition_in(each_blocks_1[i2], 1);
            each_blocks_1[i2].m(div0, null);
          }
        }
        group_outros();
        for (i2 = each_value_2.length; i2 < each_blocks_1.length; i2 += 1) {
          out(i2);
        }
        check_outros();
      }
      if (!current || dirty & /*bodyWidth*/
      8) {
        set_style(
          div0,
          "width",
          /*bodyWidth*/
          ctx3[3] + "px"
        );
      }
      if (dirty & /*$tableConfig, data*/
      6) {
        each_value = ensure_array_like(
          /*data*/
          ctx3[1]
        );
        let i2;
        for (i2 = 0; i2 < each_value.length; i2 += 1) {
          const child_ctx = get_each_context$1(ctx3, each_value, i2);
          if (each_blocks[i2]) {
            each_blocks[i2].p(child_ctx, dirty);
          } else {
            each_blocks[i2] = create_each_block$1(child_ctx);
            each_blocks[i2].c();
            each_blocks[i2].m(div1, null);
          }
        }
        for (; i2 < each_blocks.length; i2 += 1) {
          each_blocks[i2].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    i(local) {
      if (current)
        return;
      for (let i2 = 0; i2 < each_value_2.length; i2 += 1) {
        transition_in(each_blocks_1[i2]);
      }
      current = true;
    },
    o(local) {
      each_blocks_1 = each_blocks_1.filter(Boolean);
      for (let i2 = 0; i2 < each_blocks_1.length; i2 += 1) {
        transition_out(each_blocks_1[i2]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(div2);
      }
      destroy_each(each_blocks_1, detaching);
      destroy_each(each_blocks, detaching);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_each_block_2$1(ctx2) {
  let div1;
  let span;
  let t0_value = (
    /*column*/
    ctx2[13].title + ""
  );
  let t0;
  let t1;
  let div0;
  let button0;
  let arrowup;
  let t2;
  let button1;
  let arrowdown;
  let t3;
  let current;
  let mounted;
  let dispose;
  function func(...args) {
    return (
      /*func*/
      ctx2[5](
        /*column*/
        ctx2[13],
        ...args
      )
    );
  }
  arrowup = new ArrowUp$1({
    props: {
      active: (
        /*sortConfigs*/
        ctx2[0].some(func)
      )
    }
  });
  function click_handler() {
    return (
      /*click_handler*/
      ctx2[6](
        /*column*/
        ctx2[13]
      )
    );
  }
  function func_1(...args) {
    return (
      /*func_1*/
      ctx2[7](
        /*column*/
        ctx2[13],
        ...args
      )
    );
  }
  arrowdown = new ArrowDown$1({
    props: {
      active: (
        /*sortConfigs*/
        ctx2[0].some(func_1)
      )
    }
  });
  function click_handler_1() {
    return (
      /*click_handler_1*/
      ctx2[8](
        /*column*/
        ctx2[13]
      )
    );
  }
  return {
    c() {
      div1 = element("div");
      span = element("span");
      t0 = text(t0_value);
      t1 = space();
      div0 = element("div");
      button0 = element("button");
      create_component(arrowup.$$.fragment);
      t2 = space();
      button1 = element("button");
      create_component(arrowdown.$$.fragment);
      t3 = space();
      set_style(span, "flex", "1");
      attr(button0, "class", "arrow svelte-62114p");
      attr(button1, "class", "arrow svelte-62114p");
      set_style(div0, "display", "inline-block");
      set_style(div0, "vertical-align", "middle");
      set_style(div0, "margin-left", "8px");
      attr(div1, "class", "column svelte-62114p");
      set_style(
        div1,
        "text-align",
        /*column*/
        ctx2[13].align
      );
      set_style(div1, "vertical-align", "middle");
    },
    m(target, anchor) {
      insert(target, div1, anchor);
      append$2(div1, span);
      append$2(span, t0);
      append$2(div1, t1);
      append$2(div1, div0);
      append$2(div0, button0);
      mount_component(arrowup, button0, null);
      append$2(div0, t2);
      append$2(div0, button1);
      mount_component(arrowdown, button1, null);
      append$2(div1, t3);
      current = true;
      if (!mounted) {
        dispose = [
          listen(button0, "click", click_handler),
          listen(button1, "click", click_handler_1)
        ];
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if ((!current || dirty & /*$tableConfig*/
      4) && t0_value !== (t0_value = /*column*/
      ctx2[13].title + ""))
        set_data(t0, t0_value);
      const arrowup_changes = {};
      if (dirty & /*sortConfigs, $tableConfig*/
      5)
        arrowup_changes.active = /*sortConfigs*/
        ctx2[0].some(func);
      arrowup.$set(arrowup_changes);
      const arrowdown_changes = {};
      if (dirty & /*sortConfigs, $tableConfig*/
      5)
        arrowdown_changes.active = /*sortConfigs*/
        ctx2[0].some(func_1);
      arrowdown.$set(arrowdown_changes);
      if (!current || dirty & /*$tableConfig*/
      4) {
        set_style(
          div1,
          "text-align",
          /*column*/
          ctx2[13].align
        );
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(arrowup.$$.fragment, local);
      transition_in(arrowdown.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(arrowup.$$.fragment, local);
      transition_out(arrowdown.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(div1);
      }
      destroy_component(arrowup);
      destroy_component(arrowdown);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_each_block_1$1(ctx2) {
  let div;
  let span;
  let t_value = (
    /*row*/
    (ctx2[10][
      /*column*/
      ctx2[13].key
    ] != null ? (
      /*column*/
      ctx2[13].formatter ? (
        /*column*/
        ctx2[13].formatter(
          /*row*/
          ctx2[10][
            /*column*/
            ctx2[13].key
          ]
        )
      ) : (
        /*row*/
        ctx2[10][
          /*column*/
          ctx2[13].key
        ]
      )
    ) : "") + ""
  );
  let t2;
  return {
    c() {
      div = element("div");
      span = element("span");
      t2 = text(t_value);
      attr(div, "class", "column svelte-62114p");
      set_style(
        div,
        "text-align",
        /*column*/
        ctx2[13].align
      );
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append$2(div, span);
      append$2(span, t2);
    },
    p(ctx3, dirty) {
      if (dirty & /*data, $tableConfig*/
      6 && t_value !== (t_value = /*row*/
      (ctx3[10][
        /*column*/
        ctx3[13].key
      ] != null ? (
        /*column*/
        ctx3[13].formatter ? (
          /*column*/
          ctx3[13].formatter(
            /*row*/
            ctx3[10][
              /*column*/
              ctx3[13].key
            ]
          )
        ) : (
          /*row*/
          ctx3[10][
            /*column*/
            ctx3[13].key
          ]
        )
      ) : "") + ""))
        set_data(t2, t_value);
      if (dirty & /*$tableConfig*/
      4) {
        set_style(
          div,
          "text-align",
          /*column*/
          ctx3[13].align
        );
      }
    },
    d(detaching) {
      if (detaching) {
        detach(div);
      }
    }
  };
}
function create_each_block$1(ctx2) {
  let div;
  let t2;
  let each_value_1 = ensure_array_like(
    /*$tableConfig*/
    ctx2[2].columns
  );
  let each_blocks = [];
  for (let i2 = 0; i2 < each_value_1.length; i2 += 1) {
    each_blocks[i2] = create_each_block_1$1(get_each_context_1$1(ctx2, each_value_1, i2));
  }
  return {
    c() {
      div = element("div");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      t2 = space();
      attr(div, "class", "row svelte-62114p");
    },
    m(target, anchor) {
      insert(target, div, anchor);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(div, null);
        }
      }
      append$2(div, t2);
    },
    p(ctx3, dirty) {
      if (dirty & /*$tableConfig, data*/
      6) {
        each_value_1 = ensure_array_like(
          /*$tableConfig*/
          ctx3[2].columns
        );
        let i2;
        for (i2 = 0; i2 < each_value_1.length; i2 += 1) {
          const child_ctx = get_each_context_1$1(ctx3, each_value_1, i2);
          if (each_blocks[i2]) {
            each_blocks[i2].p(child_ctx, dirty);
          } else {
            each_blocks[i2] = create_each_block_1$1(child_ctx);
            each_blocks[i2].c();
            each_blocks[i2].m(div, t2);
          }
        }
        for (; i2 < each_blocks.length; i2 += 1) {
          each_blocks[i2].d(1);
        }
        each_blocks.length = each_value_1.length;
      }
    },
    d(detaching) {
      if (detaching) {
        detach(div);
      }
      destroy_each(each_blocks, detaching);
    }
  };
}
function create_fragment$4(ctx2) {
  let if_block_anchor;
  let current;
  let if_block = (
    /*$tableConfig*/
    ctx2[2] != null && create_if_block$2(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx3, [dirty]) {
      if (
        /*$tableConfig*/
        ctx3[2] != null
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
          if (dirty & /*$tableConfig*/
          4) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$2(ctx3);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance$3($$self, $$props, $$invalidate) {
  let data;
  let $tableConfig;
  const { tableConfig } = getInstance();
  component_subscribe($$self, tableConfig, (value) => $$invalidate(2, $tableConfig = value));
  let sortConfigs = [];
  let bodyWidth = 0;
  const func = (column2, c2) => c2.key === column2.key && c2.sortOrder === "ASCENDING";
  const click_handler = (column2) => {
    if (sortConfigs.some((c2) => c2.key === column2.key)) {
      $$invalidate(0, sortConfigs = sortConfigs.filter((c2) => c2.key !== column2.key));
    } else {
      $$invalidate(0, sortConfigs = [
        ...sortConfigs.filter((c2) => c2.key !== column2.key),
        { key: column2.key, sortOrder: "ASCENDING" }
      ]);
    }
  };
  const func_1 = (column2, c2) => c2.key === column2.key && c2.sortOrder === "DESCENDING";
  const click_handler_1 = (column2) => {
    if (sortConfigs.some((c2) => c2.key === column2.key)) {
      $$invalidate(0, sortConfigs = sortConfigs.filter((c2) => c2.key !== column2.key));
    } else {
      $$invalidate(0, sortConfigs = [
        ...sortConfigs.filter((c2) => c2.key !== column2.key),
        { key: column2.key, sortOrder: "DESCENDING" }
      ]);
    }
  };
  const custom_resize_handler = (e3) => {
    $$invalidate(3, bodyWidth = e3.detail.width);
  };
  $$self.$$.update = () => {
    var _a2;
    if ($$self.$$.dirty & /*$tableConfig*/
    4) {
      $$invalidate(1, data = [...(_a2 = $tableConfig == null ? void 0 : $tableConfig.data) != null ? _a2 : []]);
    }
    if ($$self.$$.dirty & /*data, sortConfigs, $tableConfig*/
    7) {
      {
        $$invalidate(1, data = data.sort((a2, b) => {
          for (let i2 = 0; i2 < sortConfigs.length; i2++) {
            const config = sortConfigs[i2];
            const column2 = $tableConfig == null ? void 0 : $tableConfig.columns.find((column22) => column22.key === config.key);
            if (column2) {
              if (column2.type === "dimension") {
                if (a2[config.key] !== b[config.key]) {
                  if (config.sortOrder === "ASCENDING") {
                    return a2[config.key].localeCompare(b[config.key]);
                  } else {
                    return b[config.key].localeCompare(a2[config.key]);
                  }
                }
              }
              if (column2.type === "metric") {
                if (a2[config.key] !== b[config.key]) {
                  if (config.sortOrder === "ASCENDING") {
                    return a2[config.key] - b[config.key];
                  } else {
                    return b[config.key] - a2[config.key];
                  }
                }
              }
            }
          }
          return 0;
        }));
      }
    }
  };
  return [
    sortConfigs,
    data,
    $tableConfig,
    bodyWidth,
    tableConfig,
    func,
    click_handler,
    func_1,
    click_handler_1,
    custom_resize_handler
  ];
}
class DataTable extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$3, create_fragment$4, safe_not_equal, {});
  }
}
const SPACE_AFTER_SYMBOL = 2;
const MARGIN_RIGHT = 4;
function instance_1$4($$self, $$props, $$invalidate) {
  let $legendRect;
  let $baseMargin;
  let $chartWidth;
  let $chartHeight;
  let $legend;
  let $font;
  let $colorLegendActives;
  let $symbol;
  let { config } = $$props;
  const instance2 = getInstance();
  const { chartHeight, chartWidth, legend, legendRect, colorLegendActives, font, baseMargin, symbol: symbol2, legendShapes } = instance2;
  component_subscribe($$self, chartHeight, (value) => $$invalidate(14, $chartHeight = value));
  component_subscribe($$self, chartWidth, (value) => $$invalidate(13, $chartWidth = value));
  component_subscribe($$self, legend, (value) => $$invalidate(15, $legend = value));
  component_subscribe($$self, legendRect, (value) => $$invalidate(11, $legendRect = value));
  component_subscribe($$self, colorLegendActives, (value) => $$invalidate(17, $colorLegendActives = value));
  component_subscribe($$self, font, (value) => $$invalidate(16, $font = value));
  component_subscribe($$self, baseMargin, (value) => $$invalidate(12, $baseMargin = value));
  component_subscribe($$self, symbol2, (value) => $$invalidate(18, $symbol = value));
  let activeGroup = null;
  let legendActiveList = [];
  function toggelActiveList(key) {
    if (legendActiveList.includes(key)) {
      $$invalidate(10, legendActiveList = legendActiveList.filter((n2) => n2 !== key));
    } else {
      const len = legendActiveList.length;
      if (config.max != null && len > config.max - 1) {
        $$invalidate(10, legendActiveList = legendActiveList.filter((_2, i2) => i2 !== len - 1));
      }
      $$invalidate(10, legendActiveList = [...legendActiveList, key]);
    }
  }
  $$self.$$set = ($$props2) => {
    if ("config" in $$props2)
      $$invalidate(8, config = $$props2.config);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*config*/
    256) {
      {
        const activeList = [];
        $$invalidate(10, legendActiveList = []);
        config.domain.forEach((key, i2) => {
          if (config.max == null || activeList.length < config.max) {
            activeList.push(key);
          }
        });
        $$invalidate(10, legendActiveList = activeList);
      }
    }
    if ($$self.$$.dirty & /*legendActiveList*/
    1024) {
      {
        colorLegendActives.update((value) => {
          return legendActiveList;
        });
      }
    }
    if ($$self.$$.dirty & /*$legend, config, $symbol, $font, $colorLegendActives, $chartWidth, activeGroup, $baseMargin, $chartHeight, $legendRect*/
    523008) {
      {
        if ($legend.show) {
          let row = 0;
          let rowWidth = 0;
          const groups = config.domain.map((key) => {
            var _a2, _b, _c;
            const label = config.formatter(key);
            let hovered = writable(false);
            const rect = new RectShape({
              clickable: true,
              x: 0,
              y: 0,
              width: 0,
              height: 0,
              props: readable({ opacity: 0 }),
              hoverable: true,
              events: {
                click: readable(() => {
                  toggelActiveList(key);
                }),
                mouseenter: readable(() => {
                  hovered.set(true);
                }),
                mouseleave: readable(() => {
                  hovered.set(false);
                })
              }
            });
            const color2 = config.getColor(key);
            let symbolShape;
            switch ($symbol.type) {
              case "circle":
                symbolShape = new CircleShape({
                  cx: $font.size / 2,
                  cy: 0,
                  r: $font.size / 2,
                  props: readable({ fill: color2 })
                });
                break;
              case "rect":
                symbolShape = new RectShape({
                  x: 0,
                  y: -$font.size / 2,
                  width: $font.size,
                  height: $font.size,
                  props: readable({ fill: color2 })
                });
                break;
              case "line":
                symbolShape = new GroupShape({
                  children: [
                    new RectShape({
                      x: 0,
                      y: -0.5,
                      width: $font.size * 2,
                      height: 1,
                      props: readable({ fill: color2 })
                    }),
                    new CircleShape({
                      cx: $font.size,
                      cy: 0,
                      r: $font.size / 2,
                      props: readable({ stroke: color2, fill: "#fff" })
                    })
                  ]
                });
                break;
            }
            const group = new GroupShape({
              props: readable({
                opacity: $colorLegendActives.includes(key) ? 1 : 0.2
              }),
              children: [
                rect,
                symbolShape,
                new TextShape({
                  textAlign: "left",
                  textBaseline: "middle",
                  x: symbolShape.apply().getBoundingRect().width + SPACE_AFTER_SYMBOL,
                  y: 0,
                  fontSize: (_b = (_a2 = $legend == null ? void 0 : $legend.font) == null ? void 0 : _a2.size) != null ? _b : $font.size,
                  fontFamily: ((_c = $legend == null ? void 0 : $legend.font) == null ? void 0 : _c.family) || $font.family || DEFAULT_FONT_FAMILY,
                  text: label,
                  visible: true
                })
              ]
            });
            return { group, rect };
          });
          const rows = [];
          let currentRow = new GroupShape({ y: 0 });
          rows.push(currentRow);
          switch ($legend.position) {
            case "bottom":
            case "top":
              groups.forEach(({ group, rect }) => {
                const { width: width2, height: height2 } = group.apply().getBoundingRect();
                if (rowWidth + width2 < $chartWidth) {
                  rowWidth += width2 + MARGIN_RIGHT;
                } else {
                  row += 1;
                  currentRow = new GroupShape({ y: row * height2 });
                  rows.push(currentRow);
                  rowWidth = width2 + MARGIN_RIGHT;
                }
                rect.shapeProps.set({
                  ...rect.$shapeProps,
                  width: width2,
                  height: height2,
                  y: -height2 / 2
                });
                rect.apply();
                group.shapeProps.set({
                  ...group.$shapeProps,
                  x: rowWidth - width2 - MARGIN_RIGHT,
                  y: height2 / 2
                });
                group.apply();
                currentRow.add(group);
              });
              break;
            case "left":
            case "right":
              groups.forEach(({ group, rect }) => {
                const { width: width2, height: height2 } = group.apply().getBoundingRect();
                row += 1;
                currentRow = new GroupShape({ y: row * height2 });
                rows.push(currentRow);
                rect.shapeProps.set({
                  ...rect.$shapeProps,
                  width: width2,
                  height: height2,
                  y: -height2 / 2
                });
                rect.apply();
                group.shapeProps.set({
                  ...group.$shapeProps,
                  x: 0,
                  y: height2 / 2
                });
                group.apply();
                currentRow.add(group);
              });
              break;
          }
          $$invalidate(9, activeGroup = new GroupShape({ children: rows }));
          const { width, height } = activeGroup.apply().getBoundingRect();
          legendRect.set({ width: width + 2, height: height + 2 });
          const innerWidth = $chartWidth - $baseMargin.left - $baseMargin.right;
          const innerHeight = $chartHeight - $baseMargin.top - $baseMargin.bottom;
          switch ($legend.position) {
            case "bottom":
            case "top":
              rows.forEach((row2) => {
                const rowWidth2 = row2.apply().getBoundingRect().width;
                row2.shapeProps.update((n2) => ({ ...n2, x: (innerWidth - rowWidth2) / 2 }));
              });
              break;
          }
          switch ($legend.position) {
            case "bottom":
              activeGroup.shapeProps.update((n2) => {
                return {
                  ...n2,
                  // x: (innerWidth - $legendRect.width) / 2,
                  y: $chartHeight - $baseMargin.top - $legendRect.height
                };
              });
              break;
            case "top":
              activeGroup.shapeProps.update((n2) => {
                return {
                  ...n2,
                  // x: (innerWidth - $legendRect.width) / 2,
                  y: $baseMargin.top
                };
              });
              break;
            case "left":
              activeGroup.shapeProps.update((n2) => {
                return {
                  ...n2,
                  x: $baseMargin.left,
                  y: (innerHeight - $legendRect.height) / 2
                };
              });
              break;
            case "right":
              activeGroup.shapeProps.update((n2) => {
                return {
                  ...n2,
                  x: $chartWidth - $baseMargin.left - $legendRect.width,
                  y: (innerHeight - $legendRect.height) / 2
                };
              });
              break;
          }
        }
      }
    }
    if ($$self.$$.dirty & /*activeGroup*/
    512) {
      {
        legendShapes.set(activeGroup ? [activeGroup] : []);
      }
    }
  };
  return [
    chartHeight,
    chartWidth,
    legend,
    legendRect,
    colorLegendActives,
    font,
    baseMargin,
    symbol2,
    config,
    activeGroup,
    legendActiveList,
    $legendRect,
    $baseMargin,
    $chartWidth,
    $chartHeight,
    $legend,
    $font,
    $colorLegendActives,
    $symbol
  ];
}
class Category extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$4, null, safe_not_equal, { config: 8 });
  }
}
function instance_1$3($$self, $$props, $$invalidate) {
  let $legendRect;
  let $baseMargin;
  let $chartWidth;
  let $chartHeight;
  let $legend;
  let $font;
  let { config } = $$props;
  const instance2 = getInstance();
  const { chartHeight, chartWidth, legend, legendRect, baseMargin, legendShapes, font } = instance2;
  component_subscribe($$self, chartHeight, (value) => $$invalidate(11, $chartHeight = value));
  component_subscribe($$self, chartWidth, (value) => $$invalidate(10, $chartWidth = value));
  component_subscribe($$self, legend, (value) => $$invalidate(12, $legend = value));
  component_subscribe($$self, legendRect, (value) => $$invalidate(8, $legendRect = value));
  component_subscribe($$self, baseMargin, (value) => $$invalidate(9, $baseMargin = value));
  component_subscribe($$self, font, (value) => $$invalidate(13, $font = value));
  let activeGroup = null;
  $$self.$$set = ($$props2) => {
    if ("config" in $$props2)
      $$invalidate(6, config = $$props2.config);
  };
  $$self.$$.update = () => {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    if ($$self.$$.dirty & /*$legend, $chartWidth, $baseMargin, $chartHeight, config, $font, activeGroup, $legendRect*/
    16320) {
      {
        if ($legend.show) {
          const innerWidth = $chartWidth - $baseMargin.left - $baseMargin.right;
          const innerHeight = $chartHeight - $baseMargin.top - $baseMargin.bottom;
          const rects = [];
          switch ($legend.position) {
            case "top":
            case "bottom":
              let legendWidth = innerWidth / 2;
              let legendHeight = 20;
              rects.push(new RectShape({
                x: 0,
                y: 0,
                width: legendWidth,
                height: legendHeight,
                props: readable({ fill: "#eee" })
                // stroke: '#eee'
              }));
              for (let i2 = 1; i2 < legendWidth - 2; i2 += 1) {
                const rect = new RectShape({
                  x: i2,
                  y: 1,
                  width: 2,
                  height: legendHeight - 2,
                  props: readable({ fill: config.getColor(i2 / legendWidth) })
                  // stroke: config.getColor(i / legendWidth)
                });
                rects.push(rect);
              }
              rects.push(
                new TextShape({
                  fontSize: (_b = (_a2 = $legend == null ? void 0 : $legend.font) == null ? void 0 : _a2.size) != null ? _b : $font.size,
                  fontFamily: ((_c = $legend == null ? void 0 : $legend.font) == null ? void 0 : _c.family) || $font.family || DEFAULT_FONT_FAMILY,
                  x: 0,
                  y: legendHeight,
                  textAlign: "center",
                  textBaseline: "top",
                  text: config.column.axisFormatter(config.min)
                }),
                new TextShape({
                  fontSize: (_e = (_d = $legend == null ? void 0 : $legend.font) == null ? void 0 : _d.size) != null ? _e : $font.size,
                  fontFamily: ((_f = $legend == null ? void 0 : $legend.font) == null ? void 0 : _f.family) || $font.family || DEFAULT_FONT_FAMILY,
                  x: legendWidth,
                  y: legendHeight,
                  textAlign: "center",
                  textBaseline: "top",
                  text: config.column.axisFormatter(config.max)
                })
              );
              $$invalidate(7, activeGroup = new GroupShape({ children: rects }));
              break;
            case "left":
            case "right":
              legendWidth = 20;
              legendHeight = innerHeight / 2;
              rects.push(new RectShape({
                x: 0,
                y: 0,
                width: legendWidth,
                height: legendHeight,
                props: readable({ fill: "#eee" })
                // stroke: '#eee'
              }));
              for (let i2 = 1; i2 < legendHeight - 2; i2 += 1) {
                const rect = new RectShape({
                  x: 1,
                  y: i2,
                  width: legendWidth - 2,
                  height: 2,
                  props: readable({ fill: config.getColor(i2 / legendHeight) })
                  // stroke: config.getColor(i / legendHeight)
                });
                rects.push(rect);
              }
              rects.push(
                new TextShape({
                  fontSize: (_h = (_g = $legend == null ? void 0 : $legend.font) == null ? void 0 : _g.size) != null ? _h : $font.size,
                  fontFamily: ((_i = $legend == null ? void 0 : $legend.font) == null ? void 0 : _i.family) || $font.family || DEFAULT_FONT_FAMILY,
                  x: legendWidth,
                  y: 0,
                  textAlign: "left",
                  textBaseline: "middle",
                  text: config.column.axisFormatter(config.min)
                }),
                new TextShape({
                  fontSize: (_k = (_j = $legend == null ? void 0 : $legend.font) == null ? void 0 : _j.size) != null ? _k : $font.size,
                  fontFamily: ((_l = $legend == null ? void 0 : $legend.font) == null ? void 0 : _l.family) || $font.family || DEFAULT_FONT_FAMILY,
                  x: legendWidth,
                  y: legendHeight,
                  textAlign: "left",
                  textBaseline: "middle",
                  text: config.column.axisFormatter(config.max)
                })
              );
              $$invalidate(7, activeGroup = new GroupShape({ children: rects }));
              break;
          }
          const { x: x2, y: y2, width, height } = activeGroup.apply().getBoundingRect();
          legendRect.set({ width: width + 2, height: height + 2 });
          switch ($legend.position) {
            case "bottom":
              activeGroup.shapeProps.update((n2) => {
                return {
                  ...n2,
                  x: (innerWidth - $legendRect.width) / 2 + $baseMargin.left - x2,
                  y: $chartHeight - $baseMargin.top - $legendRect.height - y2
                };
              });
              break;
            case "top":
              activeGroup.shapeProps.update((n2) => {
                return {
                  ...n2,
                  x: (innerWidth - $legendRect.width) / 2 + $baseMargin.left - x2,
                  y: $baseMargin.top - y2
                };
              });
              break;
            case "left":
              activeGroup.shapeProps.update((n2) => {
                return {
                  ...n2,
                  x: $baseMargin.left - x2,
                  y: (innerHeight - $legendRect.height) / 2 - y2
                };
              });
              break;
            case "right":
              activeGroup.shapeProps.update((n2) => {
                return {
                  ...n2,
                  x: $chartWidth - $baseMargin.left - $legendRect.width - x2,
                  y: (innerHeight - $legendRect.height) / 2 - y2
                };
              });
              break;
          }
        }
      }
    }
    if ($$self.$$.dirty & /*activeGroup*/
    128) {
      {
        legendShapes.set(activeGroup ? [activeGroup] : []);
      }
    }
  };
  return [
    chartHeight,
    chartWidth,
    legend,
    legendRect,
    baseMargin,
    font,
    config,
    activeGroup,
    $legendRect,
    $baseMargin,
    $chartWidth,
    $chartHeight,
    $legend,
    $font
  ];
}
class Value extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$3, null, safe_not_equal, { config: 6 });
  }
}
function create_if_block$1(ctx2) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block_1$1, create_if_block_2$1];
  const if_blocks = [];
  function select_block_type(ctx3, dirty) {
    if (
      /*$colorLegendConfig*/
      ctx3[0].type === "value"
    )
      return 0;
    if (
      /*$colorLegendConfig*/
      ctx3[0].type === "category"
    )
      return 1;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx2))) {
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
  }
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(target, anchor);
      }
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx3);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx3, dirty);
        }
      } else {
        if (if_block) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block = if_blocks[current_block_type_index];
          if (!if_block) {
            if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx3);
            if_block.c();
          } else {
            if_block.p(ctx3, dirty);
          }
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        } else {
          if_block = null;
        }
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d(detaching);
      }
    }
  };
}
function create_if_block_2$1(ctx2) {
  let category;
  let current;
  category = new Category({
    props: { config: (
      /*$colorLegendConfig*/
      ctx2[0]
    ) }
  });
  return {
    c() {
      create_component(category.$$.fragment);
    },
    m(target, anchor) {
      mount_component(category, target, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      const category_changes = {};
      if (dirty & /*$colorLegendConfig*/
      1)
        category_changes.config = /*$colorLegendConfig*/
        ctx3[0];
      category.$set(category_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(category.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(category.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(category, detaching);
    }
  };
}
function create_if_block_1$1(ctx2) {
  let value;
  let current;
  value = new Value({
    props: { config: (
      /*$colorLegendConfig*/
      ctx2[0]
    ) }
  });
  return {
    c() {
      create_component(value.$$.fragment);
    },
    m(target, anchor) {
      mount_component(value, target, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      const value_changes = {};
      if (dirty & /*$colorLegendConfig*/
      1)
        value_changes.config = /*$colorLegendConfig*/
        ctx3[0];
      value.$set(value_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(value.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(value.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(value, detaching);
    }
  };
}
function create_fragment$3(ctx2) {
  var _a2;
  let if_block_anchor;
  let current;
  let if_block = (
    /*$colorLegendConfig*/
    ((_a2 = ctx2[0]) == null ? void 0 : _a2.show) && create_if_block$1(ctx2)
  );
  return {
    c() {
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx3, [dirty]) {
      var _a3;
      if (
        /*$colorLegendConfig*/
        (_a3 = ctx3[0]) == null ? void 0 : _a3.show
      ) {
        if (if_block) {
          if_block.p(ctx3, dirty);
          if (dirty & /*$colorLegendConfig*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$1(ctx3);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function instance_1$2($$self, $$props, $$invalidate) {
  let $colorLegendConfig;
  const instance2 = getInstance();
  const { colorLegendConfig } = instance2;
  component_subscribe($$self, colorLegendConfig, (value) => $$invalidate(0, $colorLegendConfig = value));
  return [$colorLegendConfig, colorLegendConfig];
}
class Controller extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$2, create_fragment$3, safe_not_equal, {});
  }
}
const ColorLegend = Controller;
const tickWidth$1 = 4;
function instance$2($$self, $$props, $$invalidate) {
  let $margin;
  let $chartWidth;
  let $font;
  let $chartHeight;
  let $axisMargin;
  let $makeYSubAxisConfig;
  let $makeYAxisConfig;
  let $makeXAxisConfig;
  const { chartWidth, chartHeight, margin, axisMargin, xAxisConfig: makeXAxisConfig, yAxisConfig: makeYAxisConfig, ySubAxisConfig: makeYSubAxisConfig, font, axisShapes } = getInstance();
  component_subscribe($$self, chartWidth, (value) => $$invalidate(9, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(11, $chartHeight = value));
  component_subscribe($$self, margin, (value) => $$invalidate(8, $margin = value));
  component_subscribe($$self, axisMargin, (value) => $$invalidate(12, $axisMargin = value));
  component_subscribe($$self, makeXAxisConfig, (value) => $$invalidate(15, $makeXAxisConfig = value));
  component_subscribe($$self, makeYAxisConfig, (value) => $$invalidate(14, $makeYAxisConfig = value));
  component_subscribe($$self, makeYSubAxisConfig, (value) => $$invalidate(13, $makeYSubAxisConfig = value));
  component_subscribe($$self, font, (value) => $$invalidate(10, $font = value));
  const g = new GroupShape({ children: [] });
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$makeXAxisConfig, $margin, $makeYAxisConfig, $makeYSubAxisConfig, $chartWidth, $chartHeight, $axisMargin, $font*/
    65280) {
      (() => {
        g.clear();
        const xAxisConfig = $makeXAxisConfig({ margin: $margin });
        const yAxisConfig = $makeYAxisConfig({ margin: $margin });
        const ySubAxisConfig = $makeYSubAxisConfig({ margin: $margin });
        const innerWidth = $chartWidth - $margin.left - $margin.right;
        const innerHeight = $chartHeight - $margin.top - $margin.bottom;
        if (xAxisConfig != null && xAxisConfig.show) {
          const titleText = new TextShape({
            x: $margin.left + innerWidth / 2,
            y: $chartHeight - $margin.bottom + $axisMargin.bottom,
            textAlign: "center",
            textBaseline: "bottom",
            text: xAxisConfig.title || "",
            fontSize: $font.size,
            fontFamily: $font.family || DEFAULT_FONT_FAMILY,
            visible: true,
            overflow: "ignore",
            padding: 4,
            props: readable({ fill: "#999" })
          });
          const titleTexts = [];
          if (xAxisConfig.showTitle) {
            titleTexts.push(titleText);
          }
          if (xAxisConfig.minText != null) {
            titleTexts.push(new TextShape({
              x: $margin.left,
              y: $chartHeight - $margin.bottom + $axisMargin.bottom,
              textAlign: "left",
              textBaseline: "bottom",
              text: xAxisConfig.minText,
              fontSize: $font.size,
              fontFamily: $font.family || DEFAULT_FONT_FAMILY,
              visible: true,
              overflow: "ignore",
              padding: 4,
              props: readable({ fill: "#999" })
            }));
          }
          if (xAxisConfig.maxText != null) {
            titleTexts.push(new TextShape({
              x: $chartWidth - $margin.right,
              y: $chartHeight - $margin.bottom + $axisMargin.bottom,
              textAlign: "right",
              textBaseline: "bottom",
              text: xAxisConfig.maxText,
              fontSize: $font.size,
              fontFamily: $font.family || DEFAULT_FONT_FAMILY,
              visible: true,
              overflow: "ignore",
              padding: 4,
              props: readable({ fill: "#999" })
            }));
          }
          const xTitleGroup = new GroupShape({ children: titleTexts });
          g.add(xTitleGroup);
          const axisGroup = new GroupShape({ children: [] });
          g.add(axisGroup);
          if (xAxisConfig.showTicks) {
            const ticks2 = xAxisConfig.showTicks ? xAxisConfig.ticks.flatMap((tick2) => {
              const rotation = xAxisConfig.rotation;
              return new TextShape({
                fontSize: $font.size,
                fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                x: tick2.pos,
                y: $chartHeight - $margin.bottom + tickWidth$1,
                text: tick2.label,
                visible: true,
                padding: 4,
                ...rotation == null ? { textAlign: "center", textBaseline: "top" } : {
                  textAlign: "right",
                  textBaseline: "middle",
                  rotation: -rotation
                }
              });
            }) : [];
            const ticksGroup = new GroupShape({ children: ticks2 });
            axisGroup.shapeProps.update((n2) => {
              return {
                ...n2,
                children: [
                  new LineShape({
                    x1: $margin.left,
                    y1: $chartHeight - $margin.bottom,
                    x2: $chartWidth - $margin.right,
                    y2: $chartHeight - $margin.bottom,
                    props: readable({ stroke: "#ddd", fill: "none" })
                  }),
                  ...xAxisConfig.ticks.flatMap((tick2) => {
                    return new LineShape({
                      x1: tick2.pos,
                      y1: $chartHeight - $margin.bottom,
                      x2: tick2.pos,
                      y2: $chartHeight - $margin.bottom + tickWidth$1,
                      props: readable({ stroke: "#ddd", fill: "none" })
                    });
                  }),
                  ticksGroup
                ]
              };
            });
            let lastRect = null;
            for (let i2 = 0; i2 < ticks2.length; i2++) {
              ticks2[i2].visible.set(true);
              const rect = ticks2[i2].apply().getPolygon();
              if (lastRect && lastRect.intersect(rect)) {
                ticks2[i2].visible.set(false);
              } else {
                lastRect = rect;
              }
            }
            const tileGroup = new GroupShape({
              children: xAxisConfig.ticks.map((tick2) => {
                if (xAxisConfig.type === "value") {
                  return new LineShape({
                    x1: tick2.pos,
                    y1: $margin.top,
                    x2: tick2.pos,
                    y2: $chartHeight - $margin.bottom,
                    props: readable({
                      stroke: "#ddd",
                      fill: "none",
                      "stroke-dasharray": "4px 4px"
                    })
                  });
                } else if (xAxisConfig.type === "category") {
                  return new RectShape({
                    width: xAxisConfig.step,
                    height: $chartHeight - $margin.top - $margin.bottom,
                    x: tick2.pos - xAxisConfig.step / 2,
                    y: $margin.top,
                    props: tick2.active ? derived([tick2.active], ([$active]) => {
                      return {
                        fill: $active ? "rgba(0,0,0,0.1)" : "transparent"
                      };
                    }) : readable({})
                  });
                } else {
                  throw new Error();
                }
              })
            });
            g.add(tileGroup);
          }
        }
        if (yAxisConfig != null && yAxisConfig.show) {
          const titleText = new TextShape({
            x: $margin.left - $axisMargin.left,
            y: $margin.top + innerHeight / 2,
            textAlign: "center",
            textBaseline: "top",
            text: yAxisConfig.title || "",
            fontSize: $font.size,
            fontFamily: $font.family || DEFAULT_FONT_FAMILY,
            visible: true,
            rotation: -90,
            overflow: "ignore",
            padding: 4,
            props: readable({ fill: "#999" })
          });
          const titleTexts = [];
          if (yAxisConfig.showTitle) {
            titleTexts.push(titleText);
          }
          if (yAxisConfig.minText != null) {
            titleTexts.push(new TextShape({
              x: $margin.left - $axisMargin.left,
              y: $chartHeight - $margin.bottom,
              textAlign: "left",
              textBaseline: "top",
              text: yAxisConfig.minText,
              fontSize: $font.size,
              fontFamily: $font.family || DEFAULT_FONT_FAMILY,
              visible: true,
              rotation: -90,
              overflow: "ignore",
              padding: 4,
              props: readable({ fill: "#999" })
            }));
          }
          if (yAxisConfig.maxText != null) {
            titleTexts.push(new TextShape({
              x: $margin.left - $axisMargin.left,
              y: $margin.top,
              textAlign: "right",
              textBaseline: "top",
              text: yAxisConfig.maxText,
              fontSize: $font.size,
              fontFamily: $font.family || DEFAULT_FONT_FAMILY,
              visible: true,
              rotation: -90,
              overflow: "ignore",
              padding: 4,
              props: readable({ fill: "#999" })
            }));
          }
          const yTitleGroup = new GroupShape({ children: titleTexts });
          g.add(yTitleGroup);
          if (yAxisConfig.showTicks) {
            const axisGroup = new GroupShape({ children: [] });
            g.add(axisGroup);
            axisGroup.shapeProps.update((n2) => {
              return {
                ...n2,
                children: [
                  new LineShape({
                    x1: $margin.left,
                    y1: $margin.top,
                    x2: $margin.left,
                    y2: $chartHeight - $margin.bottom,
                    props: readable({ stroke: "#ddd", fill: "none" })
                  }),
                  ...yAxisConfig.ticks.flatMap((tick2) => {
                    return [
                      new LineShape({
                        x1: $margin.left,
                        y1: tick2.pos,
                        x2: $margin.left - tickWidth$1,
                        y2: tick2.pos,
                        props: readable({ stroke: "#ddd", fill: "none" })
                      }),
                      new TextShape({
                        fontSize: $font.size,
                        fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                        textAlign: "right",
                        textBaseline: "middle",
                        x: $margin.left - tickWidth$1,
                        y: tick2.pos,
                        text: tick2.label,
                        visible: true,
                        padding: 4
                      })
                    ];
                  })
                ]
              };
            });
            const tileGroup = new GroupShape({
              children: yAxisConfig.ticks.map((tick2) => {
                if (yAxisConfig.type === "value") {
                  return new LineShape({
                    x1: $margin.left,
                    y1: tick2.pos,
                    x2: $chartWidth - $margin.right,
                    y2: tick2.pos,
                    props: readable({
                      stroke: "#ddd",
                      fill: "none",
                      "stroke-dasharray": "4px 4px"
                    })
                  });
                } else if (yAxisConfig.type === "category") {
                  return new RectShape({
                    width: $chartWidth - $margin.right - $margin.left,
                    height: yAxisConfig.step,
                    x: $margin.left,
                    y: tick2.pos - yAxisConfig.step / 2,
                    props: tick2.active ? derived([tick2.active], ([$active]) => {
                      return {
                        fill: $active ? "rgba(0,0,0,0.1)" : "transparent"
                      };
                    }) : readable({})
                  });
                } else {
                  throw new Error();
                }
              })
            });
            g.add(tileGroup);
          }
        }
        if (ySubAxisConfig != null && ySubAxisConfig.show) {
          const titleText = new TextShape({
            x: $chartWidth - ($margin.right - $axisMargin.right),
            y: $margin.top + innerHeight / 2,
            textAlign: "center",
            textBaseline: "top",
            text: ySubAxisConfig.title || "",
            fontSize: $font.size,
            fontFamily: $font.family || DEFAULT_FONT_FAMILY,
            visible: true,
            rotation: -90,
            overflow: "ignore",
            padding: 4,
            props: readable({ fill: "#999" })
          });
          const titleTexts = [];
          if (ySubAxisConfig.showTitle) {
            titleTexts.push(titleText);
          }
          if (ySubAxisConfig.minText != null) {
            titleTexts.push(new TextShape({
              x: $chartWidth - ($margin.right - $axisMargin.right),
              y: $chartHeight - $margin.bottom,
              textAlign: "right",
              textBaseline: "top",
              text: ySubAxisConfig.minText,
              fontSize: $font.size,
              fontFamily: $font.family || DEFAULT_FONT_FAMILY,
              visible: true,
              rotation: -90,
              overflow: "ignore",
              padding: 4,
              props: readable({ fill: "#999" })
            }));
          }
          if (ySubAxisConfig.maxText != null) {
            titleTexts.push(new TextShape({
              x: $chartWidth - ($margin.right - $axisMargin.right),
              y: $margin.top,
              textAlign: "left",
              textBaseline: "top",
              text: ySubAxisConfig.maxText,
              fontSize: $font.size,
              fontFamily: $font.family || DEFAULT_FONT_FAMILY,
              visible: true,
              rotation: -90,
              overflow: "ignore",
              padding: 4,
              props: readable({ fill: "#999" })
            }));
          }
          const yTitleGroup = new GroupShape({ children: titleTexts });
          g.add(yTitleGroup);
          if (ySubAxisConfig.showTicks) {
            const axisGroup = new GroupShape({ children: [] });
            g.add(axisGroup);
            axisGroup.shapeProps.update((n2) => {
              return {
                ...n2,
                children: [
                  new LineShape({
                    x1: $chartWidth - $margin.right,
                    y1: $margin.top,
                    x2: $chartWidth - $margin.right,
                    y2: $chartHeight - $margin.bottom,
                    props: readable({ stroke: "#ddd", fill: "none" })
                  }),
                  ...ySubAxisConfig.ticks.flatMap((tick2) => {
                    return [
                      new LineShape({
                        x1: $chartWidth - $margin.right,
                        y1: tick2.pos,
                        x2: $chartWidth - ($margin.right - tickWidth$1),
                        y2: tick2.pos,
                        props: readable({ stroke: "#ddd", fill: "none" })
                      }),
                      new TextShape({
                        fontSize: $font.size,
                        fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                        textAlign: "left",
                        textBaseline: "middle",
                        x: $chartWidth - ($margin.right - tickWidth$1),
                        y: tick2.pos,
                        text: tick2.label,
                        visible: true,
                        padding: 4
                      })
                    ];
                  })
                ]
              };
            });
            const tileGroup = new GroupShape({
              children: ySubAxisConfig.ticks.map((tick2) => {
                if (ySubAxisConfig.type === "value") {
                  return new LineShape({
                    x1: $margin.left,
                    y1: tick2.pos,
                    x2: $chartWidth - $margin.right,
                    y2: tick2.pos,
                    props: readable({
                      stroke: "#ddd",
                      fill: "none",
                      "stroke-dasharray": "4px 4px"
                    })
                  });
                } else if (ySubAxisConfig.type === "category") {
                  return new RectShape({
                    width: $chartWidth - $margin.right - $margin.left,
                    height: ySubAxisConfig.step,
                    x: $margin.left,
                    y: tick2.pos - ySubAxisConfig.step / 2,
                    props: tick2.active ? derived([tick2.active], ([$active]) => {
                      return {
                        fill: $active ? "rgba(0,0,0,0.1)" : "transparent"
                      };
                    }) : readable({})
                  });
                } else {
                  throw new Error();
                }
              })
            });
            g.add(tileGroup);
          }
        }
        g == null ? void 0 : g.apply();
        axisShapes.set(g ? [g] : []);
      })();
    }
  };
  return [
    chartWidth,
    chartHeight,
    margin,
    axisMargin,
    makeXAxisConfig,
    makeYAxisConfig,
    makeYSubAxisConfig,
    font,
    $margin,
    $chartWidth,
    $font,
    $chartHeight,
    $axisMargin,
    $makeYSubAxisConfig,
    $makeYAxisConfig,
    $makeXAxisConfig
  ];
}
class Axis extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$2, null, safe_not_equal, {});
  }
}
const tickWidth = 4;
function instance$1($$self, $$props, $$invalidate) {
  let $chartHeight;
  let $font;
  let $chartWidth;
  let $makeYSubAxisConfig;
  let $makeYAxisConfig;
  let $makeXAxisConfig;
  const { chartWidth, chartHeight, margin, axisMargin, xAxisConfig: makeXAxisConfig, yAxisConfig: makeYAxisConfig, ySubAxisConfig: makeYSubAxisConfig, font, axisShapes } = getInstance();
  component_subscribe($$self, chartWidth, (value) => $$invalidate(8, $chartWidth = value));
  component_subscribe($$self, chartHeight, (value) => $$invalidate(6, $chartHeight = value));
  component_subscribe($$self, makeXAxisConfig, (value) => $$invalidate(11, $makeXAxisConfig = value));
  component_subscribe($$self, makeYAxisConfig, (value) => $$invalidate(10, $makeYAxisConfig = value));
  component_subscribe($$self, makeYSubAxisConfig, (value) => $$invalidate(9, $makeYSubAxisConfig = value));
  component_subscribe($$self, font, (value) => $$invalidate(7, $font = value));
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$makeXAxisConfig, $makeYAxisConfig, $makeYSubAxisConfig, $font, $chartWidth, $chartHeight*/
    4032) {
      (() => {
        const xAxisConfig = $makeXAxisConfig({
          margin: { top: 0, right: 0, bottom: 0, left: 0 }
        });
        const yAxisConfig = $makeYAxisConfig({
          margin: { top: 0, right: 0, bottom: 0, left: 0 }
        });
        const ySubAxisConfig = $makeYSubAxisConfig({
          margin: { top: 0, right: 0, bottom: 0, left: 0 }
        });
        let marginTop = 0;
        let marginRight = 0;
        let marginBottom = 0;
        let marginLeft = 0;
        if (xAxisConfig != null && xAxisConfig.show) {
          const xTitleGroup = new GroupShape({
            children: xAxisConfig.showTitle ? [
              new TextShape({
                x: 0,
                y: 0,
                textAlign: "center",
                textBaseline: "bottom",
                text: xAxisConfig.title || "",
                fontSize: $font.size,
                fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                visible: true
              })
            ] : []
          });
          const axisGroup = new GroupShape({
            children: xAxisConfig.showTicks ? xAxisConfig.ticks.map((tick2) => {
              const rotation = xAxisConfig.rotation;
              return new TextShape({
                fontSize: $font.size,
                fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                x: tick2.pos,
                y: 0,
                text: tick2.label,
                visible: true,
                ...rotation == null ? { textAlign: "center", textBaseline: "top" } : {
                  textAlign: "right",
                  textBaseline: "middle",
                  rotation: -rotation
                }
              });
            }) : []
          });
          const xTitleRect = xTitleGroup.apply().getBoundingRect();
          const axisGroupRect = axisGroup.apply().getBoundingRect();
          marginLeft = Math.max(axisGroupRect.x * -1 + 2, marginLeft);
          marginRight = Math.max(axisGroupRect.x + axisGroupRect.width - $chartWidth + 2, marginRight);
          marginBottom = Math.max(xTitleRect.height + axisGroupRect.height + tickWidth + 2, marginBottom);
          processShapes([xTitleGroup, axisGroup], (shape) => {
            shape.destroy();
          });
        }
        if (yAxisConfig != null && yAxisConfig.show) {
          const yTitleGroup = new GroupShape({
            children: yAxisConfig.showTitle ? [
              new TextShape({
                x: 0,
                y: 0,
                textAlign: "center",
                textBaseline: "top",
                text: yAxisConfig.title || "",
                fontSize: $font.size,
                fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                visible: true,
                rotation: -90
              })
            ] : []
          });
          const axisGroup = new GroupShape({
            children: yAxisConfig.showTicks ? yAxisConfig.ticks.map((tick2) => {
              return new TextShape({
                fontSize: $font.size,
                fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                textAlign: "right",
                textBaseline: "middle",
                x: 0,
                y: tick2.pos,
                text: tick2.label,
                visible: true
              });
            }) : []
          });
          const yTitleRect = yTitleGroup.apply().getBoundingRect();
          const axisGroupRect = axisGroup.apply().getBoundingRect();
          marginLeft = Math.max(yTitleRect.width + axisGroupRect.width + tickWidth + 2, marginLeft);
          marginTop = Math.max(axisGroupRect.y * -1 + 2, marginTop);
          marginBottom = Math.max(axisGroupRect.y + axisGroupRect.height - $chartHeight + 2, marginBottom);
          processShapes([yTitleGroup, axisGroup], (shape) => {
            shape.destroy();
          });
        }
        if (ySubAxisConfig != null && ySubAxisConfig.show) {
          const yTitleGroup = new GroupShape({
            children: ySubAxisConfig.showTitle ? [
              new TextShape({
                x: 0,
                y: 0,
                textAlign: "center",
                textBaseline: "top",
                text: ySubAxisConfig.title || "",
                fontSize: $font.size,
                fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                visible: true,
                rotation: -90
              })
            ] : []
          });
          const axisGroup = new GroupShape({
            children: ySubAxisConfig.showTicks ? ySubAxisConfig.ticks.map((tick2) => {
              return new TextShape({
                fontSize: $font.size,
                fontFamily: $font.family || DEFAULT_FONT_FAMILY,
                textAlign: "right",
                textBaseline: "middle",
                x: 0,
                y: tick2.pos,
                text: tick2.label,
                visible: true
              });
            }) : []
          });
          const yTitleRect = yTitleGroup.apply().getBoundingRect();
          const axisGroupRect = axisGroup.apply().getBoundingRect();
          marginRight = Math.max(yTitleRect.width + axisGroupRect.width + tickWidth + 2, marginRight);
          marginTop = Math.max(axisGroupRect.y * -1 + 2, marginTop);
          marginBottom = Math.max(axisGroupRect.y + axisGroupRect.height - $chartHeight + 2, marginBottom);
          processShapes([yTitleGroup, axisGroup], (shape) => {
            shape.destroy();
          });
        }
        axisMargin.update((axis) => {
          axis.top = marginTop;
          axis.left = marginLeft;
          axis.right = marginRight;
          axis.bottom = marginBottom;
          return axis;
        });
      })();
    }
  };
  return [
    chartWidth,
    chartHeight,
    makeXAxisConfig,
    makeYAxisConfig,
    makeYSubAxisConfig,
    font,
    $chartHeight,
    $font,
    $chartWidth,
    $makeYSubAxisConfig,
    $makeYAxisConfig,
    $makeXAxisConfig
  ];
}
class SimulateAxis extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance$1, null, safe_not_equal, {});
  }
}
function create_fragment$2(ctx2) {
  let div;
  let portal_action;
  let current;
  let mounted;
  let dispose;
  const default_slot_template = (
    /*#slots*/
    ctx2[2].default
  );
  const default_slot = create_slot(
    default_slot_template,
    ctx2,
    /*$$scope*/
    ctx2[1],
    null
  );
  return {
    c() {
      div = element("div");
      if (default_slot)
        default_slot.c();
      div.hidden = true;
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if (default_slot) {
        default_slot.m(div, null);
      }
      current = true;
      if (!mounted) {
        dispose = action_destroyer(portal_action = portal.call(
          null,
          div,
          /*target*/
          ctx2[0]
        ));
        mounted = true;
      }
    },
    p(ctx3, [dirty]) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/
        2)) {
          update_slot_base(
            default_slot,
            default_slot_template,
            ctx3,
            /*$$scope*/
            ctx3[1],
            !current ? get_all_dirty_from_scope(
              /*$$scope*/
              ctx3[1]
            ) : get_slot_changes(
              default_slot_template,
              /*$$scope*/
              ctx3[1],
              dirty,
              null
            ),
            null
          );
        }
      }
      if (portal_action && is_function(portal_action.update) && dirty & /*target*/
      1)
        portal_action.update.call(
          null,
          /*target*/
          ctx3[0]
        );
    },
    i(local) {
      if (current)
        return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(div);
      }
      if (default_slot)
        default_slot.d(detaching);
      mounted = false;
      dispose();
    }
  };
}
function portal(el, target = "body") {
  let targetEl;
  async function update2(newTarget) {
    target = newTarget;
    if (typeof target === "string") {
      targetEl = document.querySelector(target);
      if (targetEl === null) {
        await tick();
        targetEl = document.querySelector(target);
      }
      if (targetEl === null) {
        throw new Error("no element found");
      }
    } else if (target instanceof HTMLElement) {
      targetEl = target;
    } else {
      throw new TypeError();
    }
    targetEl.appendChild(el);
    el.hidden = false;
  }
  function destroy() {
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
  update2(target);
  return { update: update2, destroy };
}
function instance($$self, $$props, $$invalidate) {
  let { $$slots: slots = {}, $$scope } = $$props;
  let { target = "body" } = $$props;
  $$self.$$set = ($$props2) => {
    if ("target" in $$props2)
      $$invalidate(0, target = $$props2.target);
    if ("$$scope" in $$props2)
      $$invalidate(1, $$scope = $$props2.$$scope);
  };
  return [target, $$scope, slots];
}
class Portal extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance, create_fragment$2, safe_not_equal, { target: 0 });
  }
}
const Portal$1 = Portal;
function get_each_context(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[101] = list[i2];
  child_ctx[103] = i2;
  return child_ctx;
}
function get_each_context_1(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[101] = list[i2];
  child_ctx[103] = i2;
  return child_ctx;
}
function get_each_context_2(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[101] = list[i2];
  child_ctx[103] = i2;
  return child_ctx;
}
function get_each_context_3(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[101] = list[i2];
  child_ctx[103] = i2;
  return child_ctx;
}
function get_each_context_4(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[101] = list[i2];
  child_ctx[103] = i2;
  return child_ctx;
}
function get_each_context_5(ctx2, list, i2) {
  const child_ctx = ctx2.slice();
  child_ctx[101] = list[i2];
  child_ctx[103] = i2;
  return child_ctx;
}
function create_if_block_17(ctx2) {
  let portal2;
  let current;
  portal2 = new Portal$1({
    props: {
      target: (
        /*$fullscreen*/
        ctx2[14] ? (
          /*$el*/
          ctx2[12]
        ) : document.body
      ),
      $$slots: { default: [create_default_slot_1] },
      $$scope: { ctx: ctx2 }
    }
  });
  return {
    c() {
      create_component(portal2.$$.fragment);
    },
    m(target, anchor) {
      mount_component(portal2, target, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      const portal_changes = {};
      if (dirty[0] & /*$fullscreen, $el*/
      20480)
        portal_changes.target = /*$fullscreen*/
        ctx3[14] ? (
          /*$el*/
          ctx3[12]
        ) : document.body;
      if (dirty[3] & /*$$scope*/
      65536) {
        portal_changes.$$scope = { dirty, ctx: ctx3 };
      }
      portal2.$set(portal_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(portal2.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(portal2.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(portal2, detaching);
    }
  };
}
function create_default_slot_1(ctx2) {
  let tooltip_1;
  let current;
  tooltip_1 = new Tooltip({});
  return {
    c() {
      create_component(tooltip_1.$$.fragment);
    },
    m(target, anchor) {
      mount_component(tooltip_1, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(tooltip_1.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(tooltip_1.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(tooltip_1, detaching);
    }
  };
}
function create_if_block_16(ctx2) {
  let portal2;
  let current;
  portal2 = new Portal$1({
    props: {
      target: (
        /*$fullscreen*/
        ctx2[14] ? (
          /*$el*/
          ctx2[12]
        ) : document.body
      ),
      $$slots: { default: [create_default_slot] },
      $$scope: { ctx: ctx2 }
    }
  });
  return {
    c() {
      create_component(portal2.$$.fragment);
    },
    m(target, anchor) {
      mount_component(portal2, target, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      const portal_changes = {};
      if (dirty[0] & /*$fullscreen, $el*/
      20480)
        portal_changes.target = /*$fullscreen*/
        ctx3[14] ? (
          /*$el*/
          ctx3[12]
        ) : document.body;
      if (dirty[3] & /*$$scope*/
      65536) {
        portal_changes.$$scope = { dirty, ctx: ctx3 };
      }
      portal2.$set(portal_changes);
    },
    i(local) {
      if (current)
        return;
      transition_in(portal2.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(portal2.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(portal2, detaching);
    }
  };
}
function create_default_slot(ctx2) {
  let menu;
  let current;
  menu = new Menu2({});
  return {
    c() {
      create_component(menu.$$.fragment);
    },
    m(target, anchor) {
      mount_component(menu, target, anchor);
      current = true;
    },
    i(local) {
      if (current)
        return;
      transition_in(menu.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(menu.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(menu, detaching);
    }
  };
}
function create_if_block_15(ctx2) {
  let button;
  let menuicon;
  let button_style_value;
  let current;
  let mounted;
  let dispose;
  menuicon = new Menu$1({});
  return {
    c() {
      button = element("button");
      create_component(menuicon.$$.fragment);
      attr(button, "style", button_style_value = new Style({
        position: "absolute",
        cursor: "pointer",
        top: 0,
        right: 0,
        padding: 0,
        margin: 0,
        display: "flex",
        border: "none",
        borderRadius: "50%",
        background: "transparent",
        zIndex: 100,
        .../*menuButtonHovered*/
        ctx2[10] ? { background: "rgba(0, 0, 0, 0.1)" } : {}
      }).toString());
    },
    m(target, anchor) {
      insert(target, button, anchor);
      mount_component(menuicon, button, null);
      ctx2[79](button);
      current = true;
      if (!mounted) {
        dispose = [
          listen(
            button,
            "mouseenter",
            /*mouseenter_handler*/
            ctx2[77]
          ),
          listen(
            button,
            "mouseleave",
            /*mouseleave_handler*/
            ctx2[78]
          ),
          listen(
            button,
            "click",
            /*click_handler*/
            ctx2[80]
          )
        ];
        mounted = true;
      }
    },
    p(ctx3, dirty) {
      if (!current || dirty[0] & /*menuButtonHovered*/
      1024 && button_style_value !== (button_style_value = new Style({
        position: "absolute",
        cursor: "pointer",
        top: 0,
        right: 0,
        padding: 0,
        margin: 0,
        display: "flex",
        border: "none",
        borderRadius: "50%",
        background: "transparent",
        zIndex: 100,
        .../*menuButtonHovered*/
        ctx3[10] ? { background: "rgba(0, 0, 0, 0.1)" } : {}
      }).toString())) {
        attr(button, "style", button_style_value);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(menuicon.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(menuicon.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(button);
      }
      destroy_component(menuicon);
      ctx2[79](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_if_block_2(ctx2) {
  let div;
  let svg_1;
  let if_block0_anchor;
  let current_block_type_index;
  let if_block1;
  let if_block1_anchor;
  let svg_1_style_value;
  let div_style_value;
  let current;
  let mounted;
  let dispose;
  let if_block0 = (
    /*$downloading*/
    ctx2[21] && create_if_block_14(ctx2)
  );
  const if_block_creators = [create_if_block_4, create_if_block_5, create_else_block_1];
  const if_blocks = [];
  function select_block_type_1(ctx3, dirty) {
    if (
      /*$loading*/
      ctx3[23]
    )
      return 0;
    if (
      /*$error*/
      ctx3[24]
    )
      return 1;
    return 2;
  }
  current_block_type_index = select_block_type_1(ctx2);
  if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
  return {
    c() {
      div = element("div");
      svg_1 = svg_element("svg");
      if (if_block0)
        if_block0.c();
      if_block0_anchor = empty();
      if_block1.c();
      if_block1_anchor = empty();
      attr(svg_1, "style", svg_1_style_value = styleToString({
        userSelect: "none",
        fontSize: (
          /*$font*/
          ctx2[13].size
        ),
        fontFamily: (
          /*$font*/
          ctx2[13].family || DEFAULT_FONT_FAMILY
        )
      }));
      attr(
        svg_1,
        "width",
        /*$chartWidth*/
        ctx2[1]
      );
      attr(
        svg_1,
        "height",
        /*$chartHeight*/
        ctx2[0]
      );
      attr(div, "style", div_style_value = new Style({
        display: "inline-block",
        width: (
          /*$chartWidth*/
          ctx2[1]
        ),
        height: (
          /*$chartHeight*/
          ctx2[0]
        )
      }).toString());
    },
    m(target, anchor) {
      insert(target, div, anchor);
      append$2(div, svg_1);
      if (if_block0)
        if_block0.m(svg_1, null);
      append$2(svg_1, if_block0_anchor);
      if_blocks[current_block_type_index].m(svg_1, null);
      append$2(svg_1, if_block1_anchor);
      ctx2[81](svg_1);
      current = true;
      if (!mounted) {
        dispose = [
          listen(div, "dblclick", function() {
            if (is_function(
              /*$light*/
              ctx2[3] ? void 0 : (
                /*dblclick*/
                ctx2[63]
              )
            ))
              /*$light*/
              (ctx2[3] ? void 0 : (
                /*dblclick*/
                ctx2[63]
              )).apply(this, arguments);
          }),
          listen(div, "mousedown", function() {
            if (is_function(
              /*$light*/
              ctx2[3] ? void 0 : (
                /*mousedown*/
                ctx2[61]
              )
            ))
              /*$light*/
              (ctx2[3] ? void 0 : (
                /*mousedown*/
                ctx2[61]
              )).apply(this, arguments);
          }),
          listen(div, "mouseup", function() {
            if (is_function(
              /*$light*/
              ctx2[3] ? void 0 : (
                /*mouseup*/
                ctx2[62]
              )
            ))
              /*$light*/
              (ctx2[3] ? void 0 : (
                /*mouseup*/
                ctx2[62]
              )).apply(this, arguments);
          }),
          listen(div, "mousemove", function() {
            if (is_function(
              /*$light*/
              ctx2[3] ? void 0 : (
                /*mousemove*/
                ctx2[64]
              )
            ))
              /*$light*/
              (ctx2[3] ? void 0 : (
                /*mousemove*/
                ctx2[64]
              )).apply(this, arguments);
          }),
          listen(div, "mouseenter", function() {
            if (is_function(
              /*$light*/
              ctx2[3] ? void 0 : (
                /*mouseenter*/
                ctx2[65]
              )
            ))
              /*$light*/
              (ctx2[3] ? void 0 : (
                /*mouseenter*/
                ctx2[65]
              )).apply(this, arguments);
          }),
          listen(div, "mouseleave", function() {
            if (is_function(
              /*$light*/
              ctx2[3] ? void 0 : (
                /*mouseleave*/
                ctx2[66]
              )
            ))
              /*$light*/
              (ctx2[3] ? void 0 : (
                /*mouseleave*/
                ctx2[66]
              )).apply(this, arguments);
          }),
          listen(div, "contextmenu", function() {
            if (is_function(
              /*$light*/
              ctx2[3] ? void 0 : (
                /*contextmenu*/
                ctx2[67]
              )
            ))
              /*$light*/
              (ctx2[3] ? void 0 : (
                /*contextmenu*/
                ctx2[67]
              )).apply(this, arguments);
          }),
          listen(div, "wheel", function() {
            if (is_function(
              /*$light*/
              ctx2[3] ? void 0 : (
                /*wheel*/
                ctx2[68]
              )
            ))
              /*$light*/
              (ctx2[3] ? void 0 : (
                /*wheel*/
                ctx2[68]
              )).apply(this, arguments);
          }),
          listen(div, "scroll", function() {
            if (is_function(
              /*$light*/
              ctx2[3] ? void 0 : (
                /*scroll*/
                ctx2[69]
              )
            ))
              /*$light*/
              (ctx2[3] ? void 0 : (
                /*scroll*/
                ctx2[69]
              )).apply(this, arguments);
          })
        ];
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (
        /*$downloading*/
        ctx2[21]
      ) {
        if (if_block0) {
          if_block0.p(ctx2, dirty);
        } else {
          if_block0 = create_if_block_14(ctx2);
          if_block0.c();
          if_block0.m(svg_1, if_block0_anchor);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_1(ctx2);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx2, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block1 = if_blocks[current_block_type_index];
        if (!if_block1) {
          if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
          if_block1.c();
        } else {
          if_block1.p(ctx2, dirty);
        }
        transition_in(if_block1, 1);
        if_block1.m(svg_1, if_block1_anchor);
      }
      if (!current || dirty[0] & /*$font*/
      8192 && svg_1_style_value !== (svg_1_style_value = styleToString({
        userSelect: "none",
        fontSize: (
          /*$font*/
          ctx2[13].size
        ),
        fontFamily: (
          /*$font*/
          ctx2[13].family || DEFAULT_FONT_FAMILY
        )
      }))) {
        attr(svg_1, "style", svg_1_style_value);
      }
      if (!current || dirty[0] & /*$chartWidth*/
      2) {
        attr(
          svg_1,
          "width",
          /*$chartWidth*/
          ctx2[1]
        );
      }
      if (!current || dirty[0] & /*$chartHeight*/
      1) {
        attr(
          svg_1,
          "height",
          /*$chartHeight*/
          ctx2[0]
        );
      }
      if (!current || dirty[0] & /*$chartWidth, $chartHeight*/
      3 && div_style_value !== (div_style_value = new Style({
        display: "inline-block",
        width: (
          /*$chartWidth*/
          ctx2[1]
        ),
        height: (
          /*$chartHeight*/
          ctx2[0]
        )
      }).toString())) {
        attr(div, "style", div_style_value);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block1);
      current = true;
    },
    o(local) {
      transition_out(if_block1);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(div);
      }
      if (if_block0)
        if_block0.d();
      if_blocks[current_block_type_index].d();
      ctx2[81](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
function create_if_block_1(ctx2) {
  let textarea;
  let current;
  textarea = new TextArea2({});
  return {
    c() {
      create_component(textarea.$$.fragment);
    },
    m(target, anchor) {
      mount_component(textarea, target, anchor);
      current = true;
    },
    p: noop$2,
    i(local) {
      if (current)
        return;
      transition_in(textarea.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(textarea.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(textarea, detaching);
    }
  };
}
function create_if_block(ctx2) {
  let datatable;
  let current;
  datatable = new DataTable({});
  return {
    c() {
      create_component(datatable.$$.fragment);
    },
    m(target, anchor) {
      mount_component(datatable, target, anchor);
      current = true;
    },
    p: noop$2,
    i(local) {
      if (current)
        return;
      transition_in(datatable.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(datatable.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(datatable, detaching);
    }
  };
}
function create_if_block_14(ctx2) {
  let rect;
  let defs;
  return {
    c() {
      rect = svg_element("rect");
      defs = svg_element("defs");
      attr(rect, "x", 0);
      attr(rect, "y", 0);
      attr(
        rect,
        "width",
        /*$chartWidth*/
        ctx2[1]
      );
      attr(
        rect,
        "height",
        /*$chartHeight*/
        ctx2[0]
      );
      attr(
        rect,
        "fill",
        /*$background*/
        ctx2[22]
      );
    },
    m(target, anchor) {
      insert(target, rect, anchor);
      insert(target, defs, anchor);
      defs.innerHTML = /*fontStyle*/
      ctx2[70];
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$chartWidth*/
      2) {
        attr(
          rect,
          "width",
          /*$chartWidth*/
          ctx3[1]
        );
      }
      if (dirty[0] & /*$chartHeight*/
      1) {
        attr(
          rect,
          "height",
          /*$chartHeight*/
          ctx3[0]
        );
      }
      if (dirty[0] & /*$background*/
      4194304) {
        attr(
          rect,
          "fill",
          /*$background*/
          ctx3[22]
        );
      }
    },
    d(detaching) {
      if (detaching) {
        detach(rect);
        detach(defs);
      }
    }
  };
}
function create_else_block_1(ctx2) {
  let if_block0_anchor;
  let title;
  let subtitle;
  let simulateaxis;
  let axis;
  let colorlegend;
  let if_block1_anchor;
  let g2;
  let svg_1;
  let g1;
  let g0;
  let each_blocks = [];
  let each_1_lookup = /* @__PURE__ */ new Map();
  let g1_transform_value;
  let svg_1_width_value;
  let svg_1_height_value;
  let g2_transform_value;
  let current;
  let if_block0 = (
    /*$logo*/
    ctx2[2] && /*logoConfig*/
    ctx2[11] && create_if_block_13(ctx2)
  );
  title = new Title({});
  subtitle = new Subtitle({});
  simulateaxis = new SimulateAxis({});
  axis = new Axis({});
  colorlegend = new ColorLegend({});
  let if_block1 = (
    /*$chartContent*/
    ctx2[25] && create_if_block_12(ctx2)
  );
  let if_block2 = (
    /*$light*/
    ctx2[3] === false && create_if_block_11(ctx2)
  );
  let each_value_3 = ensure_array_like(
    /*$contentShapes*/
    ctx2[30]
  );
  const get_key = (ctx3) => (
    /*shape*/
    ctx3[101].id
  );
  for (let i2 = 0; i2 < each_value_3.length; i2 += 1) {
    let child_ctx = get_each_context_3(ctx2, each_value_3, i2);
    let key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i2] = create_each_block_3(key, child_ctx));
  }
  let if_block3 = (
    /*$light*/
    ctx2[3] === false && create_if_block_7(ctx2)
  );
  return {
    c() {
      if (if_block0)
        if_block0.c();
      if_block0_anchor = empty();
      create_component(title.$$.fragment);
      create_component(subtitle.$$.fragment);
      create_component(simulateaxis.$$.fragment);
      create_component(axis.$$.fragment);
      create_component(colorlegend.$$.fragment);
      if (if_block1)
        if_block1.c();
      if_block1_anchor = empty();
      if (if_block2)
        if_block2.c();
      g2 = svg_element("g");
      svg_1 = svg_element("svg");
      g1 = svg_element("g");
      g0 = svg_element("g");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      if (if_block3)
        if_block3.c();
      attr(g0, "class", "content");
      attr(g1, "transform", g1_transform_value = "translate(" + -/*$margin*/
      ctx2[4].left + "," + -/*$margin*/
      ctx2[4].top + ")");
      attr(svg_1, "width", svg_1_width_value = asValidNumber(
        /*$innerWidth*/
        ctx2[28],
        false
      ));
      attr(svg_1, "height", svg_1_height_value = asValidNumber(
        /*$innerHeight*/
        ctx2[29],
        false
      ));
      attr(g2, "transform", g2_transform_value = "translate(" + /*$margin*/
      ctx2[4].left + "," + /*$margin*/
      ctx2[4].top + ")");
    },
    m(target, anchor) {
      if (if_block0)
        if_block0.m(target, anchor);
      insert(target, if_block0_anchor, anchor);
      mount_component(title, target, anchor);
      mount_component(subtitle, target, anchor);
      mount_component(simulateaxis, target, anchor);
      mount_component(axis, target, anchor);
      mount_component(colorlegend, target, anchor);
      if (if_block1)
        if_block1.m(target, anchor);
      insert(target, if_block1_anchor, anchor);
      if (if_block2)
        if_block2.m(target, anchor);
      insert(target, g2, anchor);
      append$2(g2, svg_1);
      append$2(svg_1, g1);
      append$2(g1, g0);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(g0, null);
        }
      }
      if (if_block3)
        if_block3.m(g1, null);
      current = true;
    },
    p(ctx3, dirty) {
      if (
        /*$logo*/
        ctx3[2] && /*logoConfig*/
        ctx3[11]
      ) {
        if (if_block0) {
          if_block0.p(ctx3, dirty);
        } else {
          if_block0 = create_if_block_13(ctx3);
          if_block0.c();
          if_block0.m(if_block0_anchor.parentNode, if_block0_anchor);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      if (
        /*$chartContent*/
        ctx3[25]
      ) {
        if (if_block1) {
          if_block1.p(ctx3, dirty);
          if (dirty[0] & /*$chartContent*/
          33554432) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_12(ctx3);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (
        /*$light*/
        ctx3[3] === false
      ) {
        if (if_block2) {
          if_block2.p(ctx3, dirty);
          if (dirty[0] & /*$light*/
          8) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block_11(ctx3);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(g2.parentNode, g2);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      if (dirty[0] & /*$contentShapes*/
      1073741824) {
        each_value_3 = ensure_array_like(
          /*$contentShapes*/
          ctx3[30]
        );
        group_outros();
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx3, each_value_3, each_1_lookup, g0, outro_and_destroy_block, create_each_block_3, null, get_each_context_3);
        check_outros();
      }
      if (
        /*$light*/
        ctx3[3] === false
      ) {
        if (if_block3) {
          if_block3.p(ctx3, dirty);
          if (dirty[0] & /*$light*/
          8) {
            transition_in(if_block3, 1);
          }
        } else {
          if_block3 = create_if_block_7(ctx3);
          if_block3.c();
          transition_in(if_block3, 1);
          if_block3.m(g1, null);
        }
      } else if (if_block3) {
        group_outros();
        transition_out(if_block3, 1, 1, () => {
          if_block3 = null;
        });
        check_outros();
      }
      if (!current || dirty[0] & /*$margin*/
      16 && g1_transform_value !== (g1_transform_value = "translate(" + -/*$margin*/
      ctx3[4].left + "," + -/*$margin*/
      ctx3[4].top + ")")) {
        attr(g1, "transform", g1_transform_value);
      }
      if (!current || dirty[0] & /*$innerWidth*/
      268435456 && svg_1_width_value !== (svg_1_width_value = asValidNumber(
        /*$innerWidth*/
        ctx3[28],
        false
      ))) {
        attr(svg_1, "width", svg_1_width_value);
      }
      if (!current || dirty[0] & /*$innerHeight*/
      536870912 && svg_1_height_value !== (svg_1_height_value = asValidNumber(
        /*$innerHeight*/
        ctx3[29],
        false
      ))) {
        attr(svg_1, "height", svg_1_height_value);
      }
      if (!current || dirty[0] & /*$margin*/
      16 && g2_transform_value !== (g2_transform_value = "translate(" + /*$margin*/
      ctx3[4].left + "," + /*$margin*/
      ctx3[4].top + ")")) {
        attr(g2, "transform", g2_transform_value);
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(title.$$.fragment, local);
      transition_in(subtitle.$$.fragment, local);
      transition_in(simulateaxis.$$.fragment, local);
      transition_in(axis.$$.fragment, local);
      transition_in(colorlegend.$$.fragment, local);
      transition_in(if_block1);
      transition_in(if_block2);
      for (let i2 = 0; i2 < each_value_3.length; i2 += 1) {
        transition_in(each_blocks[i2]);
      }
      transition_in(if_block3);
      current = true;
    },
    o(local) {
      transition_out(title.$$.fragment, local);
      transition_out(subtitle.$$.fragment, local);
      transition_out(simulateaxis.$$.fragment, local);
      transition_out(axis.$$.fragment, local);
      transition_out(colorlegend.$$.fragment, local);
      transition_out(if_block1);
      transition_out(if_block2);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        transition_out(each_blocks[i2]);
      }
      transition_out(if_block3);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(if_block0_anchor);
        detach(if_block1_anchor);
        detach(g2);
      }
      if (if_block0)
        if_block0.d(detaching);
      destroy_component(title, detaching);
      destroy_component(subtitle, detaching);
      destroy_component(simulateaxis, detaching);
      destroy_component(axis, detaching);
      destroy_component(colorlegend, detaching);
      if (if_block1)
        if_block1.d(detaching);
      if (if_block2)
        if_block2.d(detaching);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d();
      }
      if (if_block3)
        if_block3.d();
    }
  };
}
function create_if_block_5(ctx2) {
  let g;
  let svg_1;
  let path0;
  let path1;
  let g_transform_value;
  let text_1;
  let text_1_x_value;
  let text_1_y_value;
  let text_1_font_family_value;
  function select_block_type_2(ctx3, dirty) {
    if (typeof /*$error*/
    ctx3[24] === "string")
      return create_if_block_6;
    return create_else_block;
  }
  let current_block_type = select_block_type_2(ctx2);
  let if_block = current_block_type(ctx2);
  return {
    c() {
      g = svg_element("g");
      svg_1 = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      text_1 = svg_element("text");
      if_block.c();
      attr(path0, "d", "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z");
      attr(path1, "d", "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z");
      attr(svg_1, "viewBox", "64 64 896 896");
      attr(svg_1, "focusable", "false");
      attr(svg_1, "width", "36");
      attr(svg_1, "height", "36");
      attr(svg_1, "fill", "rgba(0,0,0,0.2)");
      attr(g, "transform", g_transform_value = "translate(" + /*$chartWidth*/
      (ctx2[1] - 36) / 2 + "," + /*$chartHeight*/
      (ctx2[0] - 36) / 2 + ")");
      attr(text_1, "x", text_1_x_value = /*$chartWidth*/
      ctx2[1] / 2);
      attr(text_1, "y", text_1_y_value = /*$chartHeight*/
      ctx2[0] / 2 + 24);
      attr(text_1, "text-anchor", "middle");
      attr(text_1, "dominant-baseline", "hanging");
      attr(text_1, "fill", "rgba(0,0,0,0.2)");
      attr(text_1, "font-size", "12px");
      attr(text_1, "font-family", text_1_font_family_value = /*$font*/
      ctx2[13].family);
    },
    m(target, anchor) {
      insert(target, g, anchor);
      append$2(g, svg_1);
      append$2(svg_1, path0);
      append$2(svg_1, path1);
      insert(target, text_1, anchor);
      if_block.m(text_1, null);
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$chartWidth, $chartHeight*/
      3 && g_transform_value !== (g_transform_value = "translate(" + /*$chartWidth*/
      (ctx3[1] - 36) / 2 + "," + /*$chartHeight*/
      (ctx3[0] - 36) / 2 + ")")) {
        attr(g, "transform", g_transform_value);
      }
      if (current_block_type === (current_block_type = select_block_type_2(ctx3)) && if_block) {
        if_block.p(ctx3, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx3);
        if (if_block) {
          if_block.c();
          if_block.m(text_1, null);
        }
      }
      if (dirty[0] & /*$chartWidth*/
      2 && text_1_x_value !== (text_1_x_value = /*$chartWidth*/
      ctx3[1] / 2)) {
        attr(text_1, "x", text_1_x_value);
      }
      if (dirty[0] & /*$chartHeight*/
      1 && text_1_y_value !== (text_1_y_value = /*$chartHeight*/
      ctx3[0] / 2 + 24)) {
        attr(text_1, "y", text_1_y_value);
      }
      if (dirty[0] & /*$font*/
      8192 && text_1_font_family_value !== (text_1_font_family_value = /*$font*/
      ctx3[13].family)) {
        attr(text_1, "font-family", text_1_font_family_value);
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(g);
        detach(text_1);
      }
      if_block.d();
    }
  };
}
function create_if_block_4(ctx2) {
  let g1;
  let g0;
  let svg_1;
  let path;
  let animateTransform;
  let g1_transform_value;
  return {
    c() {
      g1 = svg_element("g");
      g0 = svg_element("g");
      svg_1 = svg_element("svg");
      path = svg_element("path");
      animateTransform = svg_element("animateTransform");
      attr(path, "d", "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z");
      attr(svg_1, "viewBox", "0 0 1024 1024");
      attr(svg_1, "width", "36");
      attr(svg_1, "height", "36");
      attr(svg_1, "fill", "rgba(0,0,0,0.2)");
      attr(animateTransform, "attributeName", "transform");
      attr(animateTransform, "type", "rotate");
      attr(animateTransform, "from", "0 18 18");
      attr(animateTransform, "to", "360 18 18");
      attr(animateTransform, "dur", "1s");
      attr(animateTransform, "repeatCount", "indefinite");
      attr(g1, "transform", g1_transform_value = "translate(" + /*$chartWidth*/
      (ctx2[1] - 36) / 2 + "," + /*$chartHeight*/
      (ctx2[0] - 36) / 2 + ")");
    },
    m(target, anchor) {
      insert(target, g1, anchor);
      append$2(g1, g0);
      append$2(g0, svg_1);
      append$2(svg_1, path);
      append$2(g0, animateTransform);
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$chartWidth, $chartHeight*/
      3 && g1_transform_value !== (g1_transform_value = "translate(" + /*$chartWidth*/
      (ctx3[1] - 36) / 2 + "," + /*$chartHeight*/
      (ctx3[0] - 36) / 2 + ")")) {
        attr(g1, "transform", g1_transform_value);
      }
    },
    i: noop$2,
    o: noop$2,
    d(detaching) {
      if (detaching) {
        detach(g1);
      }
    }
  };
}
function create_if_block_13(ctx2) {
  let image;
  let image_href_value;
  let image_width_value;
  let image_height_value;
  let image_x_value;
  let image_y_value;
  let image_opacity_value;
  return {
    c() {
      var _a2;
      image = svg_element("image");
      attr(image, "href", image_href_value = /*$logo*/
      ctx2[2].url);
      attr(image, "width", image_width_value = /*logoConfig*/
      ctx2[11].width);
      attr(image, "height", image_height_value = /*logoConfig*/
      ctx2[11].height);
      attr(image, "x", image_x_value = /*logoConfig*/
      ctx2[11].x);
      attr(image, "y", image_y_value = /*logoConfig*/
      ctx2[11].y);
      attr(image, "opacity", image_opacity_value = /*$logo*/
      (_a2 = ctx2[2].opacity) != null ? _a2 : 0.1);
    },
    m(target, anchor) {
      insert(target, image, anchor);
    },
    p(ctx3, dirty) {
      var _a2;
      if (dirty[0] & /*$logo*/
      4 && image_href_value !== (image_href_value = /*$logo*/
      ctx3[2].url)) {
        attr(image, "href", image_href_value);
      }
      if (dirty[0] & /*logoConfig*/
      2048 && image_width_value !== (image_width_value = /*logoConfig*/
      ctx3[11].width)) {
        attr(image, "width", image_width_value);
      }
      if (dirty[0] & /*logoConfig*/
      2048 && image_height_value !== (image_height_value = /*logoConfig*/
      ctx3[11].height)) {
        attr(image, "height", image_height_value);
      }
      if (dirty[0] & /*logoConfig*/
      2048 && image_x_value !== (image_x_value = /*logoConfig*/
      ctx3[11].x)) {
        attr(image, "x", image_x_value);
      }
      if (dirty[0] & /*logoConfig*/
      2048 && image_y_value !== (image_y_value = /*logoConfig*/
      ctx3[11].y)) {
        attr(image, "y", image_y_value);
      }
      if (dirty[0] & /*$logo*/
      4 && image_opacity_value !== (image_opacity_value = /*$logo*/
      (_a2 = ctx3[2].opacity) != null ? _a2 : 0.1)) {
        attr(image, "opacity", image_opacity_value);
      }
    },
    d(detaching) {
      if (detaching) {
        detach(image);
      }
    }
  };
}
function create_if_block_12(ctx2) {
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = (
    /*$chartContent*/
    ctx2[25]
  );
  function switch_props(ctx3, dirty) {
    return {
      props: { instance: (
        /*instance*/
        ctx3[32]
      ) }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    c() {
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m(target, anchor) {
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$chartContent*/
      33554432 && switch_value !== (switch_value = /*$chartContent*/
      ctx3[25])) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx3));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_if_block_11(ctx2) {
  let g0;
  let each_blocks_1 = [];
  let each0_lookup = /* @__PURE__ */ new Map();
  let g1;
  let each_blocks = [];
  let each1_lookup = /* @__PURE__ */ new Map();
  let current;
  let each_value_5 = ensure_array_like(
    /*$axisShapes*/
    ctx2[26]
  );
  const get_key = (ctx3) => (
    /*shape*/
    ctx3[101].id
  );
  for (let i2 = 0; i2 < each_value_5.length; i2 += 1) {
    let child_ctx = get_each_context_5(ctx2, each_value_5, i2);
    let key = get_key(child_ctx);
    each0_lookup.set(key, each_blocks_1[i2] = create_each_block_5(key, child_ctx));
  }
  let each_value_4 = ensure_array_like(
    /*$legendShapes*/
    ctx2[27]
  );
  const get_key_1 = (ctx3) => (
    /*shape*/
    ctx3[101].id
  );
  for (let i2 = 0; i2 < each_value_4.length; i2 += 1) {
    let child_ctx = get_each_context_4(ctx2, each_value_4, i2);
    let key = get_key_1(child_ctx);
    each1_lookup.set(key, each_blocks[i2] = create_each_block_4(key, child_ctx));
  }
  return {
    c() {
      g0 = svg_element("g");
      for (let i2 = 0; i2 < each_blocks_1.length; i2 += 1) {
        each_blocks_1[i2].c();
      }
      g1 = svg_element("g");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      attr(g0, "class", "axis");
    },
    m(target, anchor) {
      insert(target, g0, anchor);
      for (let i2 = 0; i2 < each_blocks_1.length; i2 += 1) {
        if (each_blocks_1[i2]) {
          each_blocks_1[i2].m(g0, null);
        }
      }
      insert(target, g1, anchor);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(g1, null);
        }
      }
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$axisShapes*/
      67108864) {
        each_value_5 = ensure_array_like(
          /*$axisShapes*/
          ctx3[26]
        );
        group_outros();
        each_blocks_1 = update_keyed_each(each_blocks_1, dirty, get_key, 1, ctx3, each_value_5, each0_lookup, g0, outro_and_destroy_block, create_each_block_5, null, get_each_context_5);
        check_outros();
      }
      if (dirty[0] & /*$legendShapes*/
      134217728) {
        each_value_4 = ensure_array_like(
          /*$legendShapes*/
          ctx3[27]
        );
        group_outros();
        each_blocks = update_keyed_each(each_blocks, dirty, get_key_1, 1, ctx3, each_value_4, each1_lookup, g1, outro_and_destroy_block, create_each_block_4, null, get_each_context_4);
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      for (let i2 = 0; i2 < each_value_5.length; i2 += 1) {
        transition_in(each_blocks_1[i2]);
      }
      for (let i2 = 0; i2 < each_value_4.length; i2 += 1) {
        transition_in(each_blocks[i2]);
      }
      current = true;
    },
    o(local) {
      for (let i2 = 0; i2 < each_blocks_1.length; i2 += 1) {
        transition_out(each_blocks_1[i2]);
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        transition_out(each_blocks[i2]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(g0);
        detach(g1);
      }
      for (let i2 = 0; i2 < each_blocks_1.length; i2 += 1) {
        each_blocks_1[i2].d();
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d();
      }
    }
  };
}
function create_each_block_5(key_1, ctx2) {
  let first;
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = asAny(
    /*shape*/
    ctx2[101].component
  );
  function switch_props(ctx3, dirty) {
    return {
      props: { shapeInstance: asAny(
        /*shape*/
        ctx3[101]
      ) }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (dirty[0] & /*$axisShapes*/
      67108864 && switch_value !== (switch_value = asAny(
        /*shape*/
        ctx2[101].component
      ))) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        const switch_instance_changes = {};
        if (dirty[0] & /*$axisShapes*/
        67108864)
          switch_instance_changes.shapeInstance = asAny(
            /*shape*/
            ctx2[101]
          );
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(first);
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_each_block_4(key_1, ctx2) {
  let first;
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = asAny(
    /*shape*/
    ctx2[101].component
  );
  function switch_props(ctx3, dirty) {
    return {
      props: { shapeInstance: asAny(
        /*shape*/
        ctx3[101]
      ) }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (dirty[0] & /*$legendShapes*/
      134217728 && switch_value !== (switch_value = asAny(
        /*shape*/
        ctx2[101].component
      ))) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        const switch_instance_changes = {};
        if (dirty[0] & /*$legendShapes*/
        134217728)
          switch_instance_changes.shapeInstance = asAny(
            /*shape*/
            ctx2[101]
          );
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(first);
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_each_block_3(key_1, ctx2) {
  let first;
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = asAny(
    /*shape*/
    ctx2[101].component
  );
  function switch_props(ctx3, dirty) {
    return {
      props: { shapeInstance: asAny(
        /*shape*/
        ctx3[101]
      ) }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (dirty[0] & /*$contentShapes*/
      1073741824 && switch_value !== (switch_value = asAny(
        /*shape*/
        ctx2[101].component
      ))) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        const switch_instance_changes = {};
        if (dirty[0] & /*$contentShapes*/
        1073741824)
          switch_instance_changes.shapeInstance = asAny(
            /*shape*/
            ctx2[101]
          );
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(first);
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_if_block_7(ctx2) {
  let g0;
  let each_blocks_2 = [];
  let each0_lookup = /* @__PURE__ */ new Map();
  let g1;
  let each_blocks_1 = [];
  let each1_lookup = /* @__PURE__ */ new Map();
  let g2;
  let each_blocks = [];
  let each2_lookup = /* @__PURE__ */ new Map();
  let current;
  let each_value_2 = ensure_array_like(
    /*$contentShapes*/
    ctx2[30]
  );
  const get_key = (ctx3) => (
    /*shape*/
    ctx3[101].id
  );
  for (let i2 = 0; i2 < each_value_2.length; i2 += 1) {
    let child_ctx = get_each_context_2(ctx2, each_value_2, i2);
    let key = get_key(child_ctx);
    each0_lookup.set(key, each_blocks_2[i2] = create_each_block_2(key, child_ctx));
  }
  let each_value_1 = ensure_array_like(
    /*$contentShapes*/
    ctx2[30]
  );
  const get_key_1 = (ctx3) => (
    /*shape*/
    ctx3[101].id
  );
  for (let i2 = 0; i2 < each_value_1.length; i2 += 1) {
    let child_ctx = get_each_context_1(ctx2, each_value_1, i2);
    let key = get_key_1(child_ctx);
    each1_lookup.set(key, each_blocks_1[i2] = create_each_block_1(key, child_ctx));
  }
  let each_value = ensure_array_like(
    /*$guideShapes*/
    ctx2[31]
  );
  const get_key_2 = (ctx3) => (
    /*shape*/
    ctx3[101].id
  );
  for (let i2 = 0; i2 < each_value.length; i2 += 1) {
    let child_ctx = get_each_context(ctx2, each_value, i2);
    let key = get_key_2(child_ctx);
    each2_lookup.set(key, each_blocks[i2] = create_each_block(key, child_ctx));
  }
  return {
    c() {
      g0 = svg_element("g");
      for (let i2 = 0; i2 < each_blocks_2.length; i2 += 1) {
        each_blocks_2[i2].c();
      }
      g1 = svg_element("g");
      for (let i2 = 0; i2 < each_blocks_1.length; i2 += 1) {
        each_blocks_1[i2].c();
      }
      g2 = svg_element("g");
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].c();
      }
      attr(g0, "class", "hovered");
      attr(g1, "class", "focused");
      attr(g2, "class", "guide");
    },
    m(target, anchor) {
      insert(target, g0, anchor);
      for (let i2 = 0; i2 < each_blocks_2.length; i2 += 1) {
        if (each_blocks_2[i2]) {
          each_blocks_2[i2].m(g0, null);
        }
      }
      insert(target, g1, anchor);
      for (let i2 = 0; i2 < each_blocks_1.length; i2 += 1) {
        if (each_blocks_1[i2]) {
          each_blocks_1[i2].m(g1, null);
        }
      }
      insert(target, g2, anchor);
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        if (each_blocks[i2]) {
          each_blocks[i2].m(g2, null);
        }
      }
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$contentShapes*/
      1073741824) {
        each_value_2 = ensure_array_like(
          /*$contentShapes*/
          ctx3[30]
        );
        group_outros();
        each_blocks_2 = update_keyed_each(each_blocks_2, dirty, get_key, 1, ctx3, each_value_2, each0_lookup, g0, outro_and_destroy_block, create_each_block_2, null, get_each_context_2);
        check_outros();
      }
      if (dirty[0] & /*$contentShapes*/
      1073741824) {
        each_value_1 = ensure_array_like(
          /*$contentShapes*/
          ctx3[30]
        );
        group_outros();
        each_blocks_1 = update_keyed_each(each_blocks_1, dirty, get_key_1, 1, ctx3, each_value_1, each1_lookup, g1, outro_and_destroy_block, create_each_block_1, null, get_each_context_1);
        check_outros();
      }
      if (dirty[1] & /*$guideShapes*/
      1) {
        each_value = ensure_array_like(
          /*$guideShapes*/
          ctx3[31]
        );
        group_outros();
        each_blocks = update_keyed_each(each_blocks, dirty, get_key_2, 1, ctx3, each_value, each2_lookup, g2, outro_and_destroy_block, create_each_block, null, get_each_context);
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      for (let i2 = 0; i2 < each_value_2.length; i2 += 1) {
        transition_in(each_blocks_2[i2]);
      }
      for (let i2 = 0; i2 < each_value_1.length; i2 += 1) {
        transition_in(each_blocks_1[i2]);
      }
      for (let i2 = 0; i2 < each_value.length; i2 += 1) {
        transition_in(each_blocks[i2]);
      }
      current = true;
    },
    o(local) {
      for (let i2 = 0; i2 < each_blocks_2.length; i2 += 1) {
        transition_out(each_blocks_2[i2]);
      }
      for (let i2 = 0; i2 < each_blocks_1.length; i2 += 1) {
        transition_out(each_blocks_1[i2]);
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        transition_out(each_blocks[i2]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(g0);
        detach(g1);
        detach(g2);
      }
      for (let i2 = 0; i2 < each_blocks_2.length; i2 += 1) {
        each_blocks_2[i2].d();
      }
      for (let i2 = 0; i2 < each_blocks_1.length; i2 += 1) {
        each_blocks_1[i2].d();
      }
      for (let i2 = 0; i2 < each_blocks.length; i2 += 1) {
        each_blocks[i2].d();
      }
    }
  };
}
function create_if_block_10(ctx2) {
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = asAny(
    /*shape*/
    ctx2[101].hoveredComponent
  );
  function switch_props(ctx3, dirty) {
    return {
      props: {
        shapeInstance: asAny(
          /*shape*/
          ctx3[101]
        ),
        state: "hover"
      }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    c() {
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m(target, anchor) {
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$contentShapes*/
      1073741824 && switch_value !== (switch_value = asAny(
        /*shape*/
        ctx3[101].hoveredComponent
      ))) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx3));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        const switch_instance_changes = {};
        if (dirty[0] & /*$contentShapes*/
        1073741824)
          switch_instance_changes.shapeInstance = asAny(
            /*shape*/
            ctx3[101]
          );
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_each_block_2(key_1, ctx2) {
  let first;
  let if_block_anchor;
  let current;
  let if_block = (
    /*shape*/
    ctx2[101].hoveredComponent && create_if_block_10(ctx2)
  );
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (
        /*shape*/
        ctx2[101].hoveredComponent
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty[0] & /*$contentShapes*/
          1073741824) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_10(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(first);
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_if_block_9(ctx2) {
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = asAny(
    /*shape*/
    ctx2[101].focusedComponent
  );
  function switch_props(ctx3, dirty) {
    return {
      props: {
        shapeInstance: asAny(
          /*shape*/
          ctx3[101]
        ),
        state: "focus"
      }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    c() {
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m(target, anchor) {
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$contentShapes*/
      1073741824 && switch_value !== (switch_value = asAny(
        /*shape*/
        ctx3[101].focusedComponent
      ))) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx3));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        const switch_instance_changes = {};
        if (dirty[0] & /*$contentShapes*/
        1073741824)
          switch_instance_changes.shapeInstance = asAny(
            /*shape*/
            ctx3[101]
          );
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_each_block_1(key_1, ctx2) {
  let first;
  let if_block_anchor;
  let current;
  let if_block = (
    /*shape*/
    ctx2[101].focusedComponent && create_if_block_9(ctx2)
  );
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (
        /*shape*/
        ctx2[101].focusedComponent
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty[0] & /*$contentShapes*/
          1073741824) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_9(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(first);
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_if_block_8(ctx2) {
  let switch_instance;
  let switch_instance_anchor;
  let current;
  var switch_value = asAny(
    /*shape*/
    ctx2[101].component
  );
  function switch_props(ctx3, dirty) {
    return {
      props: { shapeInstance: asAny(
        /*shape*/
        ctx3[101]
      ) }
    };
  }
  if (switch_value) {
    switch_instance = construct_svelte_component(switch_value, switch_props(ctx2));
  }
  return {
    c() {
      if (switch_instance)
        create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m(target, anchor) {
      if (switch_instance)
        mount_component(switch_instance, target, anchor);
      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p(ctx3, dirty) {
      if (dirty[1] & /*$guideShapes*/
      1 && switch_value !== (switch_value = asAny(
        /*shape*/
        ctx3[101].component
      ))) {
        if (switch_instance) {
          group_outros();
          const old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, () => {
            destroy_component(old_component, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance = construct_svelte_component(switch_value, switch_props(ctx3));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      } else if (switch_value) {
        const switch_instance_changes = {};
        if (dirty[1] & /*$guideShapes*/
        1)
          switch_instance_changes.shapeInstance = asAny(
            /*shape*/
            ctx3[101]
          );
        switch_instance.$set(switch_instance_changes);
      }
    },
    i(local) {
      if (current)
        return;
      if (switch_instance)
        transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o(local) {
      if (switch_instance)
        transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(switch_instance_anchor);
      }
      if (switch_instance)
        destroy_component(switch_instance, detaching);
    }
  };
}
function create_each_block(key_1, ctx2) {
  let first;
  let if_block_anchor;
  let current;
  let if_block = (
    /*shape*/
    ctx2[101].component && create_if_block_8(ctx2)
  );
  return {
    key: key_1,
    first: null,
    c() {
      first = empty();
      if (if_block)
        if_block.c();
      if_block_anchor = empty();
      this.first = first;
    },
    m(target, anchor) {
      insert(target, first, anchor);
      if (if_block)
        if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(new_ctx, dirty) {
      ctx2 = new_ctx;
      if (
        /*shape*/
        ctx2[101].component
      ) {
        if (if_block) {
          if_block.p(ctx2, dirty);
          if (dirty[1] & /*$guideShapes*/
          1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_8(ctx2);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, () => {
          if_block = null;
        });
        check_outros();
      }
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(first);
        detach(if_block_anchor);
      }
      if (if_block)
        if_block.d(detaching);
    }
  };
}
function create_else_block(ctx2) {
  let t_1;
  return {
    c() {
      t_1 = text("Error");
    },
    m(target, anchor) {
      insert(target, t_1, anchor);
    },
    p: noop$2,
    d(detaching) {
      if (detaching) {
        detach(t_1);
      }
    }
  };
}
function create_if_block_6(ctx2) {
  let t_1;
  return {
    c() {
      t_1 = text(
        /*$error*/
        ctx2[24]
      );
    },
    m(target, anchor) {
      insert(target, t_1, anchor);
    },
    p(ctx3, dirty) {
      if (dirty[0] & /*$error*/
      16777216)
        set_data(
          t_1,
          /*$error*/
          ctx3[24]
        );
    },
    d(detaching) {
      if (detaching) {
        detach(t_1);
      }
    }
  };
}
function create_fragment$1(ctx2) {
  let div;
  let t0;
  let t1;
  let t2;
  let current_block_type_index;
  let if_block3;
  let div_style_value;
  let resize_action;
  let current;
  let mounted;
  let dispose;
  let if_block0 = (
    /*$tooltip*/
    ctx2[15].show && create_if_block_17(ctx2)
  );
  let if_block1 = (
    /*$toolbox*/
    ctx2[16].show && create_if_block_16(ctx2)
  );
  let if_block2 = (
    /*$toolbox*/
    ctx2[16].show && /*isMouseOver*/
    (ctx2[7] || /*$menuShown*/
    ctx2[17]) && create_if_block_15(ctx2)
  );
  const if_block_creators = [create_if_block, create_if_block_1, create_if_block_2];
  const if_blocks = [];
  function select_block_type(ctx3, dirty) {
    if (
      /*$showType*/
      ctx3[19] === "table"
    )
      return 0;
    if (
      /*$showType*/
      ctx3[19] === "text"
    )
      return 1;
    if (
      /*$showType*/
      ctx3[19] === "chart"
    )
      return 2;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx2))) {
    if_block3 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx2);
  }
  return {
    c() {
      var _a2;
      div = element("div");
      if (if_block0)
        if_block0.c();
      t0 = space();
      if (if_block1)
        if_block1.c();
      t1 = space();
      if (if_block2)
        if_block2.c();
      t2 = space();
      if (if_block3)
        if_block3.c();
      attr(div, "style", div_style_value = new Style({
        fontFamily: (
          /*$font*/
          ctx2[13].family || DEFAULT_FONT_FAMILY
        ),
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
        display: "inline-block",
        background: (
          /*$fullscreen*/
          ctx2[14] ? "#fff" : void 0
        ),
        .../*hoveredShapes*/
        ctx2[9].length > 0 && get_store_value(
          /*hoveredShapes*/
          ctx2[9][0].clickable
        ) ? {
          cursor: (
            /*hoveredShapes*/
            (_a2 = ctx2[9][0].cursor) != null ? _a2 : "pointer"
          )
        } : {}
      }).toString());
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if (if_block0)
        if_block0.m(div, null);
      append$2(div, t0);
      if (if_block1)
        if_block1.m(div, null);
      append$2(div, t1);
      if (if_block2)
        if_block2.m(div, null);
      append$2(div, t2);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(div, null);
      }
      ctx2[82](div);
      current = true;
      if (!mounted) {
        dispose = [
          action_destroyer(resize_action = resize.call(
            null,
            div,
            /*$light*/
            ctx2[3] || /*ssr*/
            ctx2[59]
          )),
          listen(
            div,
            "custom_resize",
            /*onResize*/
            ctx2[71]
          ),
          listen(
            div,
            "mouseenter",
            /*mouseenter_handler_1*/
            ctx2[83]
          ),
          listen(
            div,
            "mouseleave",
            /*mouseleave_handler_1*/
            ctx2[84]
          )
        ];
        mounted = true;
      }
    },
    p(ctx3, dirty) {
      var _a2;
      if (
        /*$tooltip*/
        ctx3[15].show
      ) {
        if (if_block0) {
          if_block0.p(ctx3, dirty);
          if (dirty[0] & /*$tooltip*/
          32768) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_17(ctx3);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(div, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, () => {
          if_block0 = null;
        });
        check_outros();
      }
      if (
        /*$toolbox*/
        ctx3[16].show
      ) {
        if (if_block1) {
          if_block1.p(ctx3, dirty);
          if (dirty[0] & /*$toolbox*/
          65536) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_16(ctx3);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(div, t1);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, () => {
          if_block1 = null;
        });
        check_outros();
      }
      if (
        /*$toolbox*/
        ctx3[16].show && /*isMouseOver*/
        (ctx3[7] || /*$menuShown*/
        ctx3[17])
      ) {
        if (if_block2) {
          if_block2.p(ctx3, dirty);
          if (dirty[0] & /*$toolbox, isMouseOver, $menuShown*/
          196736) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block_15(ctx3);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(div, t2);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, () => {
          if_block2 = null;
        });
        check_outros();
      }
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx3);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx3, dirty);
        }
      } else {
        if (if_block3) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block3 = if_blocks[current_block_type_index];
          if (!if_block3) {
            if_block3 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx3);
            if_block3.c();
          } else {
            if_block3.p(ctx3, dirty);
          }
          transition_in(if_block3, 1);
          if_block3.m(div, null);
        } else {
          if_block3 = null;
        }
      }
      if (!current || dirty[0] & /*$font, $fullscreen, hoveredShapes*/
      25088 && div_style_value !== (div_style_value = new Style({
        fontFamily: (
          /*$font*/
          ctx3[13].family || DEFAULT_FONT_FAMILY
        ),
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
        display: "inline-block",
        background: (
          /*$fullscreen*/
          ctx3[14] ? "#fff" : void 0
        ),
        .../*hoveredShapes*/
        ctx3[9].length > 0 && get_store_value(
          /*hoveredShapes*/
          ctx3[9][0].clickable
        ) ? {
          cursor: (
            /*hoveredShapes*/
            (_a2 = ctx3[9][0].cursor) != null ? _a2 : "pointer"
          )
        } : {}
      }).toString())) {
        attr(div, "style", div_style_value);
      }
      if (resize_action && is_function(resize_action.update) && dirty[0] & /*$light*/
      8)
        resize_action.update.call(
          null,
          /*$light*/
          ctx3[3] || /*ssr*/
          ctx3[59]
        );
    },
    i(local) {
      if (current)
        return;
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(if_block2);
      transition_in(if_block3);
      current = true;
    },
    o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      transition_out(if_block2);
      transition_out(if_block3);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        detach(div);
      }
      if (if_block0)
        if_block0.d();
      if (if_block1)
        if_block1.d();
      if (if_block2)
        if_block2.d();
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d();
      }
      ctx2[82](null);
      mounted = false;
      run_all(dispose);
    }
  };
}
const dragSelect = false;
function instance_1$1($$self, $$props, $$invalidate) {
  let logoConfig;
  let $chartHeight;
  let $chartWidth;
  let $logo;
  let $el;
  let $light;
  let $focused;
  let $margin;
  let $option;
  let $font;
  let $fullscreen;
  let $tooltip;
  let $toolbox;
  let $menuShown;
  let $menuButtonEl;
  let $showType;
  let $svg;
  let $downloading;
  let $background;
  let $loading;
  let $error;
  let $chartContent;
  let $axisShapes;
  let $legendShapes;
  let $innerWidth;
  let $innerHeight;
  let $contentShapes;
  let $guideShapes;
  const instance2 = getInstance();
  let width = 0;
  let height = 0;
  let el = instance2.el;
  component_subscribe($$self, el, (value) => $$invalidate(12, $el = value));
  let svg = instance2.svg;
  component_subscribe($$self, svg, (value) => $$invalidate(20, $svg = value));
  let chartWidth = instance2.chartWidth;
  component_subscribe($$self, chartWidth, (value) => $$invalidate(1, $chartWidth = value));
  let chartHeight = instance2.chartHeight;
  component_subscribe($$self, chartHeight, (value) => $$invalidate(0, $chartHeight = value));
  let mousePosition = instance2.mousePosition;
  const { margin, innerWidth, innerHeight, option, fullscreen, chartContent, showType, menuShown, menuButtonEl, downloading, focused, font, logo, toolbox, contentShapes, legendShapes, axisShapes, guideShapes, loading, error, light, tooltip, ssr, hoverable, focusable, activeText, background, devicePixelRatio, tableConfig, dataColumns } = instance2;
  component_subscribe($$self, margin, (value) => $$invalidate(4, $margin = value));
  component_subscribe($$self, innerWidth, (value) => $$invalidate(28, $innerWidth = value));
  component_subscribe($$self, innerHeight, (value) => $$invalidate(29, $innerHeight = value));
  component_subscribe($$self, option, (value) => $$invalidate(76, $option = value));
  component_subscribe($$self, fullscreen, (value) => $$invalidate(14, $fullscreen = value));
  component_subscribe($$self, chartContent, (value) => $$invalidate(25, $chartContent = value));
  component_subscribe($$self, showType, (value) => $$invalidate(19, $showType = value));
  component_subscribe($$self, menuShown, (value) => $$invalidate(17, $menuShown = value));
  component_subscribe($$self, menuButtonEl, (value) => $$invalidate(18, $menuButtonEl = value));
  component_subscribe($$self, downloading, (value) => $$invalidate(21, $downloading = value));
  component_subscribe($$self, focused, (value) => $$invalidate(75, $focused = value));
  component_subscribe($$self, font, (value) => $$invalidate(13, $font = value));
  component_subscribe($$self, logo, (value) => $$invalidate(2, $logo = value));
  component_subscribe($$self, toolbox, (value) => $$invalidate(16, $toolbox = value));
  component_subscribe($$self, contentShapes, (value) => $$invalidate(30, $contentShapes = value));
  component_subscribe($$self, legendShapes, (value) => $$invalidate(27, $legendShapes = value));
  component_subscribe($$self, axisShapes, (value) => $$invalidate(26, $axisShapes = value));
  component_subscribe($$self, guideShapes, (value) => $$invalidate(31, $guideShapes = value));
  component_subscribe($$self, loading, (value) => $$invalidate(23, $loading = value));
  component_subscribe($$self, error, (value) => $$invalidate(24, $error = value));
  component_subscribe($$self, light, (value) => $$invalidate(3, $light = value));
  component_subscribe($$self, tooltip, (value) => $$invalidate(15, $tooltip = value));
  component_subscribe($$self, background, (value) => $$invalidate(22, $background = value));
  let dragStartPos = null;
  let dragEndPos = null;
  let draggingOriginPos = null;
  let draggingPrevPos = null;
  let isMouseOver = false;
  let isMouseDown = false;
  let isMouseMoved = false;
  let hoveredShapes = [];
  let mousedownShapes = [];
  function drag() {
    var _a2, _b, _c, _d;
    if ($el && dragStartPos && dragEndPos) {
      const xmin = (_a2 = min$1([dragStartPos[0], dragEndPos[0]])) != null ? _a2 : 0;
      const xmax = (_b = max$1([dragStartPos[0], dragEndPos[0]])) != null ? _b : 0;
      const ymin = (_c = min$1([dragStartPos[1], dragEndPos[1]])) != null ? _c : 0;
      const ymax = (_d = max$1([dragStartPos[1], dragEndPos[1]])) != null ? _d : 0;
      const shapes = [];
      processShapes([...get_store_value(legendShapes), ...get_store_value(contentShapes)], (shape, parentX, parentY) => {
        if (!get_store_value(shape.clickable)) {
          return;
        }
        if (shape.contain(xmin - parentX, ymin - parentY) && shape.contain(xmax - parentX, ymax - parentY)) {
          shapes.push(shape);
          return;
        }
        const rect = new RectShape({
          instance: instance2,
          x: xmin - parentX,
          y: ymin - parentY,
          width: xmax - xmin,
          height: ymax - ymin
        });
        if (rect.intersect(shape.getBoundingRect())) {
          shapes.push(shape);
          return;
        }
      });
      const evt = new MouseEvent("click");
      shapes.forEach((shape) => {
        shape.events.dispatch("click", evt);
      });
      $$invalidate(5, dragStartPos = null);
      $$invalidate(6, dragEndPos = null);
    }
  }
  function mousedown(e3) {
    if (e3.button !== 0) {
      return;
    }
    get_store_value(instance2.option);
    get_store_value(instance2.focusable);
    const $mousePosition = get_store_value(mousePosition);
    if (!$mousePosition) {
      return;
    }
    const [x2, y2] = $mousePosition;
    $$invalidate(8, isMouseDown = true);
    $$invalidate(5, dragStartPos = [x2, y2]);
    $$invalidate(6, dragEndPos = [x2, y2]);
    draggingOriginPos = [x2, y2];
    draggingPrevPos = [x2, y2];
    mousedownShapes = [];
    mousedownShapes.push(...containShapes(x2, y2, get_store_value(contentShapes), (shape) => get_store_value(shape.clickable)));
    mousedownShapes.push(...containShapes(x2, y2, get_store_value(legendShapes), (shape) => get_store_value(shape.clickable)));
    if (mousedownShapes.length > 0) {
      e3.preventDefault();
      e3.stopPropagation();
      mousedownShapes.sort((a2, b) => get_store_value(b.priority) - get_store_value(a2.priority));
      const evt = new MouseEvent("mousedown");
      mousedownShapes.find((shape) => {
        shape.events.dispatch("mousedown", evt);
        return true;
      });
    }
  }
  function mouseup(e3) {
    const $mousePosition = get_store_value(mousePosition);
    if (!$mousePosition) {
      return;
    }
    const option2 = get_store_value(instance2.option);
    get_store_value(instance2.focusable);
    const [x2, y2] = $mousePosition;
    if (isMouseDown && isMouseMoved && dragSelect) {
      $$invalidate(6, dragEndPos = [x2, y2]);
      drag();
    } else {
      const shapes = [];
      shapes.push(...containShapes(x2, y2, [...get_store_value(contentShapes), ...get_store_value(legendShapes)], (shape) => mousedownShapes.includes(shape) && get_store_value(shape.clickable)));
      if (shapes.length > 0) {
        e3.preventDefault();
        e3.stopPropagation();
        shapes.sort((a2, b) => get_store_value(b.priority) - get_store_value(a2.priority));
        const evt2 = new MouseEvent("mouseup");
        shapes.find((shape) => {
          shape.events.dispatch("mouseup", evt2);
          return true;
        });
        const clickEvent = new MouseEvent("click");
        shapes.find((shape) => {
          shape.events.dispatch("click", clickEvent);
          return true;
        });
        if (option2.onClick) {
          option2.onClick(shapes[0]);
        }
      } else {
        const evt2 = new MouseEvent("emptyclick");
        instance2.events.dispatch("emptyclick", evt2);
      }
    }
    const evt = new MouseEvent("mouseup");
    instance2.events.dispatch("mouseup", evt);
    $$invalidate(8, isMouseDown = false);
    isMouseMoved = false;
  }
  function dblclick(e3) {
    e3.preventDefault();
    e3.stopPropagation();
    const evt = new MouseEvent("emptydblclick");
    instance2.events.dispatch("emptydblclick", evt);
  }
  let _mousePosition = null;
  let mouseMoved = false;
  let frame2 = null;
  const loop = function() {
    $$invalidate(74, frame2 = requestAnimationFrame(loop));
    mousePosition.set(_mousePosition);
    if (!mouseMoved) {
      return;
    }
    mouseMoved = false;
    if (!isMouseOver) {
      return;
    }
    const $mousePosition = _mousePosition;
    if (!$mousePosition) {
      return;
    }
    const [x2, y2] = $mousePosition;
    if (isMouseDown) {
      isMouseMoved = true;
      $$invalidate(6, dragEndPos = [x2, y2]);
      if (draggingOriginPos && draggingPrevPos) {
        instance2.events.dispatch("customdrag", new CustomEvent(
          "customdrag",
          {
            detail: {
              deltaX: draggingPrevPos[0] - dragEndPos[0],
              deltaY: draggingPrevPos[1] - dragEndPos[1],
              originDeltaX: draggingOriginPos[0] - dragEndPos[0],
              originDeltaY: draggingOriginPos[1] - dragEndPos[1]
            }
          }
        ));
        draggingPrevPos = dragEndPos;
      }
    } else {
      const $contentShapes2 = get_store_value(contentShapes);
      const $legendShapes2 = get_store_value(legendShapes);
      const flatShapes = flattenShapes([...$contentShapes2, ...$legendShapes2]).filter(({ shape }) => get_store_value(shape.hoverable));
      sortShapes(flatShapes);
      const res = flatShapes.find(({ shape, parentX, parentY }) => shape.contain(x2 - parentX, y2 - parentY));
      const unhoveredShapes = hoveredShapes.filter((shape) => shape.id !== (res == null ? void 0 : res.shape.id));
      const evt = new MouseEvent("mouseleave");
      unhoveredShapes.forEach((shape) => {
        shape.events.dispatch("mouseleave", evt);
      });
      if (res) {
        const evt2 = new MouseEvent("mouseenter");
        if (hoveredShapes[0] !== res.shape) {
          $$invalidate(9, hoveredShapes = res ? [res.shape] : []);
          hoveredShapes.forEach((shape) => {
            shape.events.dispatch("mouseenter", evt2);
          });
        }
      } else {
        $$invalidate(9, hoveredShapes = []);
      }
    }
  };
  onDestroy(() => {
    if (frame2 != null) {
      cancelAnimationFrame(frame2);
    }
  });
  let t2 = 0;
  const mousemove = (e3) => {
    if (performance.now() - t2 < 16) {
      return;
    }
    const { left, top, width: width2, height: height2 } = $el.getBoundingClientRect();
    const scaleX = width2 / $el.offsetWidth;
    const scaleY = height2 / $el.offsetHeight;
    const x2 = (e3.clientX - left) / scaleY;
    const y2 = (e3.clientY - top) / scaleX;
    _mousePosition = [x2, y2];
    mouseMoved = true;
    t2 = performance.now();
  };
  function mouseenter(e3) {
    instance2.events.dispatch("mouseenter", e3);
  }
  function mouseleave(e3) {
    _mousePosition = null;
    const evt = new MouseEvent("mouseleave");
    hoveredShapes.forEach((shape) => {
      shape.events.dispatch("mouseleave", evt);
    });
    $$invalidate(9, hoveredShapes = []);
    instance2.events.dispatch("mouseleave", e3);
  }
  function contextmenu(e3) {
    $$invalidate(8, isMouseDown = false);
    instance2.events.dispatch("contextmenu", e3);
  }
  function wheel(e3) {
    instance2.events.dispatch("wheel", e3);
  }
  function scroll(e3) {
    instance2.events.dispatch("scroll", e3);
  }
  const fontStyle = `
        <style type="text/css">
            <![CDATA[
                @import url('https://fonts.googleapis.com/css?family=Noto+Sans+JP:400,700|Roboto:400,700|Noto+Color+Emoji');
            ]]>
        </style>
    `;
  onMount(() => {
    instance2.mainResolver();
  });
  function onResize(event) {
    $$invalidate(72, width = event.detail.width);
    $$invalidate(73, height = event.detail.height);
  }
  let menuButtonHovered = false;
  const mouseenter_handler = () => {
    $$invalidate(10, menuButtonHovered = true);
  };
  const mouseleave_handler = () => {
    $$invalidate(10, menuButtonHovered = false);
  };
  function button_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      $menuButtonEl = $$value;
      menuButtonEl.set($menuButtonEl);
    });
  }
  const click_handler = () => {
    menuShown.update((value) => {
      return !value;
    });
  };
  function svg_1_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      $svg = $$value;
      svg.set($svg);
    });
  }
  function div_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](() => {
      $el = $$value;
      el.set($el);
    });
  }
  const mouseenter_handler_1 = () => {
    $$invalidate(7, isMouseOver = true);
  };
  const mouseleave_handler_1 = () => {
    $$invalidate(7, isMouseOver = false);
  };
  $$self.$$.update = () => {
    var _a2, _b;
    if ($$self.$$.dirty[2] & /*$option, width, height*/
    19456) {
      {
        chartWidth.set((_a2 = $option == null ? void 0 : $option.width) != null ? _a2 : width);
        chartHeight.set((_b = $option == null ? void 0 : $option.height) != null ? _b : height);
      }
    }
    if ($$self.$$.dirty[0] & /*$chartWidth, $margin, $chartHeight*/
    19) {
      {
        innerWidth.set($chartWidth - $margin.left - $margin.right);
        innerHeight.set($chartHeight - $margin.top - $margin.bottom);
      }
    }
    if ($$self.$$.dirty[2] & /*$focused*/
    8192) {
      {
        instance2.onSelect($focused);
      }
    }
    if ($$self.$$.dirty[0] & /*$light*/
    8 | $$self.$$.dirty[2] & /*frame*/
    4096) {
      {
        if (frame2 != null) {
          cancelAnimationFrame(frame2);
        }
        if ($light === false) {
          $$invalidate(74, frame2 = requestAnimationFrame(loop));
        }
      }
    }
    if ($$self.$$.dirty[0] & /*$logo, $chartWidth, $chartHeight*/
    7) {
      $$invalidate(11, logoConfig = (() => {
        var _a3, _b2;
        if (!$logo || !$logo.show) {
          return null;
        }
        const width2 = (_a3 = $logo == null ? void 0 : $logo.width) != null ? _a3 : $chartWidth / 2;
        const height2 = (_b2 = $logo == null ? void 0 : $logo.width) != null ? _b2 : $chartWidth / 2;
        return {
          width: width2,
          height: height2,
          x: $chartWidth / 2 - width2 / 2,
          y: $chartHeight / 2 - height2 / 2
        };
      })());
    }
  };
  return [
    $chartHeight,
    $chartWidth,
    $logo,
    $light,
    $margin,
    dragStartPos,
    dragEndPos,
    isMouseOver,
    isMouseDown,
    hoveredShapes,
    menuButtonHovered,
    logoConfig,
    $el,
    $font,
    $fullscreen,
    $tooltip,
    $toolbox,
    $menuShown,
    $menuButtonEl,
    $showType,
    $svg,
    $downloading,
    $background,
    $loading,
    $error,
    $chartContent,
    $axisShapes,
    $legendShapes,
    $innerWidth,
    $innerHeight,
    $contentShapes,
    $guideShapes,
    instance2,
    el,
    svg,
    chartWidth,
    chartHeight,
    margin,
    innerWidth,
    innerHeight,
    option,
    fullscreen,
    chartContent,
    showType,
    menuShown,
    menuButtonEl,
    downloading,
    focused,
    font,
    logo,
    toolbox,
    contentShapes,
    legendShapes,
    axisShapes,
    guideShapes,
    loading,
    error,
    light,
    tooltip,
    ssr,
    background,
    mousedown,
    mouseup,
    dblclick,
    mousemove,
    mouseenter,
    mouseleave,
    contextmenu,
    wheel,
    scroll,
    fontStyle,
    onResize,
    width,
    height,
    frame2,
    $focused,
    $option,
    mouseenter_handler,
    mouseleave_handler,
    button_binding,
    click_handler,
    svg_1_binding,
    div_binding,
    mouseenter_handler_1,
    mouseleave_handler_1
  ];
}
class Main extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1$1, create_fragment$1, safe_not_equal, {}, null, [-1, -1, -1, -1]);
  }
}
const Main$1 = Main;
function create_fragment(ctx2) {
  let main;
  let current;
  main = new Main$1({});
  return {
    c() {
      create_component(main.$$.fragment);
    },
    m(target, anchor) {
      mount_component(main, target, anchor);
      current = true;
    },
    p: noop$2,
    i(local) {
      if (current)
        return;
      transition_in(main.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(main.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(main, detaching);
    }
  };
}
load();
function instance_1($$self, $$props, $$invalidate) {
  let { instance: instance2 } = $$props;
  setContext("instance", instance2);
  onMount(() => {
    $$invalidate(0, instance2.mounted = true, instance2);
  });
  $$self.$$set = ($$props2) => {
    if ("instance" in $$props2)
      $$invalidate(0, instance2 = $$props2.instance);
  };
  return [instance2];
}
let RaccoonChart$1 = class RaccoonChart extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance_1, create_fragment, safe_not_equal, { instance: 0 });
  }
};
const SvelteRaccoonChart = RaccoonChart$1;
function debounce(fn, interval2) {
  let timerId;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      fn.apply(null, args);
    }, interval2);
  };
}
const DEFAULT_FONT_FAMILY = '"Roboto", "Noto Sans JP", "Noto Color Emoji", sans-serif';
const isNode = typeof window === "undefined";
const defaultOption = {
  tooltip: {
    trigger: "hover"
  },
  focusable: false
};
function getInstance() {
  return getContext("instance");
}
class BaseAxisConfig {
  constructor() {
    __publicField(this, "show", true);
    __publicField(this, "title", null);
    __publicField(this, "showTitle", false);
    __publicField(this, "showTicks", true);
    __publicField(this, "step", 0);
    __publicField(this, "ticks", []);
    __publicField(this, "minText", null);
    __publicField(this, "maxText", null);
    __publicField(this, "rotation", null);
  }
}
class CategoryAxisConfig extends BaseAxisConfig {
  constructor(options) {
    var _a2, _b, _c, _d, _e;
    super();
    __publicField(this, "type", "category");
    this.show = options.show;
    this.title = options.title;
    this.showTitle = (_a2 = options.showTitle) != null ? _a2 : false;
    this.showTicks = (_b = options.showTicks) != null ? _b : true;
    this.step = options.step;
    this.ticks = options.ticks;
    this.minText = (_c = options.minText) != null ? _c : null;
    this.maxText = (_d = options.maxText) != null ? _d : null;
    this.rotation = (_e = options.rotation) != null ? _e : null;
  }
}
class ValueAxisConfig extends BaseAxisConfig {
  constructor(options) {
    var _a2, _b, _c, _d, _e;
    super();
    __publicField(this, "type", "value");
    this.show = options.show;
    this.title = options.title;
    this.showTitle = (_a2 = options.showTitle) != null ? _a2 : false;
    this.showTicks = (_b = options.showTicks) != null ? _b : true;
    this.minText = (_c = options.minText) != null ? _c : null;
    this.maxText = (_d = options.maxText) != null ? _d : null;
    this.rotation = (_e = options.rotation) != null ? _e : null;
    let tickSize = 5;
    do {
      const tickLabels = options.scale.ticks(tickSize).map((tick2) => options.axisFormatter(tick2));
      const unique = new Set(tickLabels).size === tickLabels.length;
      if (unique) {
        break;
      }
    } while (--tickSize > 0);
    this.ticks = options.scale.ticks(tickSize).map((tick2) => {
      return {
        value: tick2,
        label: options.axisFormatter(tick2),
        pos: options.scale(tick2)
      };
    });
  }
}
let instanceid = 1;
const instances = {};
class RaccoonChart2 {
  constructor(el, option) {
    __publicField(this, "datasourceid");
    __publicField(this, "id");
    __publicField(this, "svelteInstance");
    // static
    __publicField(this, "get", get_store_value);
    __publicField(this, "tick", tick);
    // Element
    __publicField(this, "el");
    __publicField(this, "svg");
    // option
    __publicField(this, "option");
    // promise
    __publicField(this, "load");
    __publicField(this, "_resolver", () => {
    });
    __publicField(this, "mainMounted");
    __publicField(this, "mainResolver", () => {
    });
    __publicField(this, "data", writable(null));
    __publicField(this, "error", writable(null));
    __publicField(this, "loading", writable(false));
    // size
    __publicField(this, "chartWidth", writable(0));
    __publicField(this, "chartHeight", writable(0));
    __publicField(this, "innerWidth", writable(0));
    __publicField(this, "innerHeight", writable(0));
    __publicField(this, "margin");
    __publicField(this, "baseMargin", writable({
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }));
    // cursor
    // cursor = writable<Property.Cursor>();
    // font
    __publicField(this, "font", writable({
      size: 12,
      family: DEFAULT_FONT_FAMILY
    }));
    // color
    __publicField(this, "color", writable({
      colors: colorPalette
    }));
    // title
    __publicField(this, "title", writable(null));
    __publicField(this, "titleRect", writable({ width: 0, height: 0 }));
    // subtitle
    __publicField(this, "subtitle", writable(null));
    __publicField(this, "subtitleRect", writable({ width: 0, height: 0 }));
    __publicField(this, "focusable", writable(false));
    __publicField(this, "hoverable", writable(true));
    // label
    __publicField(this, "label", writable({
      show: true,
      // position: 'auto',
      content: "value"
    }));
    // legend
    __publicField(this, "legend", writable({
      show: true,
      position: "bottom",
      align: "center"
    }));
    // toolip
    __publicField(this, "tooltip", writable({
      show: true,
      trigger: "hover"
    }));
    // toolbox
    __publicField(this, "toolbox", writable({
      show: true
    }));
    // logo
    __publicField(this, "logo", writable(null));
    // legend
    __publicField(this, "colorLegendActives", writable([]));
    // tooltip
    __publicField(this, "tooltipPosition", writable(null));
    __publicField(this, "tooltipShown", writable(false));
    // symbol
    __publicField(this, "symbol", writable({
      type: "circle"
    }));
    // serverside
    __publicField(this, "ssr", isNode);
    __publicField(this, "focused", writable([]));
    __publicField(this, "hovered", writable([]));
    // event
    __publicField(this, "onClick", () => {
    });
    __publicField(this, "onSelect", () => {
    });
    __publicField(this, "onChange", () => {
    });
    __publicField(this, "onFocusChange", () => {
    });
    // fullscreen
    __publicField(this, "fullscreen", writable(false));
    // axis
    __publicField(this, "axisMargin", writable({
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }));
    // download
    __publicField(this, "downloading", writable(false));
    // menu
    __publicField(this, "menuShown", writable(false));
    __publicField(this, "menuButtonEl", writable(null));
    // event
    __publicField(this, "mousePosition", writable(null));
    __publicField(this, "innerMousePosition");
    // active text
    __publicField(this, "activeText", writable(null));
    // chart store
    __publicField(this, "type");
    __publicField(this, "chartStore", null);
    // extendChartStore: ExtendChartStoreUnion | null = null;
    __publicField(this, "light", writable(false));
    __publicField(this, "background", writable("#fff"));
    __publicField(this, "devicePixelRatio", writable((_a = window.devicePixelRatio) != null ? _a : 1));
    __publicField(this, "mounted", false);
    __publicField(this, "unsubscribers", []);
    __publicField(this, "dataColumns", writable(null));
    __publicField(this, "chartContent", writable(null));
    __publicField(this, "tooltipContent", writable(null));
    __publicField(this, "contentShapes", writable([]));
    __publicField(this, "legendShapes", writable([]));
    __publicField(this, "axisShapes", writable([]));
    __publicField(this, "guideShapes", writable([]));
    __publicField(this, "legendRect", writable({ width: 0, height: 0 }));
    __publicField(this, "colorLegendConfig", writable(null));
    __publicField(this, "tableConfig", writable(null));
    __publicField(this, "menuExtraButtons", writable([]));
    __publicField(this, "xAxisConfig", writable(() => null));
    __publicField(this, "yAxisConfig", writable(() => null));
    __publicField(this, "ySubAxisConfig", writable(() => null));
    __publicField(this, "showType", writable("chart"));
    __publicField(this, "events", new EventDispatcher());
    __publicField(this, "promises", []);
    __publicField(this, "intervalIds", []);
    this.datasourceid = option.datasourceid;
    this.id = instanceid++;
    instances[this.id] = this;
    const o2 = Object.assign(
      {},
      defaultOption,
      option
    );
    this.el = writable(el);
    this.svg = writable(null);
    this.option = writable(o2);
    this.load = new Promise((resolve) => {
      this._resolver = resolve;
    });
    this.mainMounted = new Promise((resolve) => {
      this.mainResolver = resolve;
    });
    this.type = derived([this.option], ([option2]) => {
      var _a2;
      return (_a2 = option2.type) != null ? _a2 : null;
    });
    this.unsubscribers.push(
      this.option.subscribe((option2) => {
        var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
        if (option2.margin) {
          this.baseMargin.set(option2.margin);
        }
        const parsedDataColumns = (_a2 = option2.dataColumns) == null ? void 0 : _a2.flatMap((n2) => {
          if (n2.type === "category") {
            return [
              parseCategoryColumn({ column: n2 })
            ];
          } else if (n2.type === "value") {
            return [
              parseValueColumn({ column: n2 })
            ];
          }
          return [];
        });
        this.dataColumns.set(parsedDataColumns != null ? parsedDataColumns : null);
        this.ssr = (_b = option2.ssr) != null ? _b : false;
        this.font.set((_c = option2.font) != null ? _c : { size: 12 });
        if (option2.color) {
          this.color.update((value) => ({
            ...value,
            ...option2.color
          }));
        }
        this.light.set((_d = option2.light) != null ? _d : false);
        this.devicePixelRatio.set(
          (_f = (_e = option2.devicePixelRatio) != null ? _e : window.devicePixelRatio) != null ? _f : 1
        );
        this.title.set((_g = option2.title) != null ? _g : null);
        this.subtitle.set((_h = option2.subtitle) != null ? _h : null);
        this.focusable.set((_i = option2.focusable) != null ? _i : false);
        this.hoverable.set((_j = option2.hoverable) != null ? _j : true);
        if (option2.label) {
          this.label.set(option2.label);
        }
        if (option2.legend) {
          this.legend.set({
            ...option2.legend,
            show: (_k = option2.legend.show) != null ? _k : true,
            position: (_l = option2.legend.position) != null ? _l : "bottom"
          });
        }
        if (option2.tooltip) {
          this.tooltip.set({
            ...option2.tooltip,
            show: (_m = option2.tooltip.show) != null ? _m : true,
            trigger: (_o = (_n = option2.tooltip) == null ? void 0 : _n.trigger) != null ? _o : "hover"
          });
        }
        if (option2.toolbox) {
          this.toolbox.set({
            ...option2.toolbox,
            show: (_p = option2.toolbox.show) != null ? _p : true
          });
        }
        if (option2.logo) {
          this.logo.set(option2.logo);
        }
        if (option2.symbol) {
          this.symbol.set(option2.symbol);
        }
        if (option2.background) {
          this.background.set((_q = option2.background) != null ? _q : "#fff");
        }
        const emptyHandler2 = () => null;
        this.onChange = (_r = option2.onChange) != null ? _r : emptyHandler2;
        this.onFocusChange = (_s = option2.onFocusChange) != null ? _s : emptyHandler2;
        this.init();
      })
    );
    this.margin = derived(
      [
        this.legend,
        this.legendRect,
        this.axisMargin,
        this.baseMargin,
        this.titleRect,
        this.subtitleRect
      ],
      ([
        $legend,
        $legendRect,
        axisMargin,
        baseMargin,
        titleRect,
        subtitleRect
      ]) => {
        const margin = {
          top: baseMargin.top + axisMargin.top + titleRect.height + subtitleRect.height,
          right: baseMargin.right + axisMargin.right,
          bottom: baseMargin.bottom + axisMargin.bottom,
          left: baseMargin.left + axisMargin.left
        };
        switch ($legend.position) {
          case "top":
            margin.top += $legendRect.height;
            break;
          case "bottom":
            margin.bottom += $legendRect.height;
            break;
          case "left":
            margin.left += $legendRect.width;
            break;
          case "right":
            margin.right += $legendRect.width;
            break;
        }
        return margin;
      }
    );
    this.innerMousePosition = derived(
      [this.margin, this.mousePosition],
      ([$margin, $mousePosition]) => {
        if ($mousePosition == null) {
          return null;
        }
        const [x2, y2] = $mousePosition;
        if (x2 < $margin.left || y2 < $margin.top) {
          return null;
        }
        return [x2 - $margin.left, y2 - $margin.top];
      }
    );
    const triggerChange = debounce(() => {
      const instanceList = Object.values(instances);
      instanceList.filter((ins) => ins.id !== this.id).filter(
        (ins) => ins.mounted && ins.datasourceid === this.datasourceid
      ).forEach((ins) => {
        const filtered = instanceList.filter((ins2) => ins2.id !== ins.id).map((ins2) => get_store_value(ins2.focused)).filter((n2) => n2.length > 0);
        ins.onChange(filtered);
      });
    }, 500);
    this.unsubscribers.push(
      this.focused.subscribe(($focused) => {
        this.onFocusChange($focused);
        if (this.mounted && this.datasourceid) {
          triggerChange();
        }
      })
    );
    this.svelteInstance = new SvelteRaccoonChart({
      target: el,
      props: {
        instance: this
      }
    });
  }
  async init() {
    this.contentShapes.set([]);
    this.legendShapes.set([]);
    this.axisShapes.set([]);
    this.guideShapes.set([]);
    this.chartContent.set(null);
    this.tooltipContent.set(null);
    this.legendRect.set({ width: 0, height: 0 });
    this.menuExtraButtons.set([]);
    this.xAxisConfig.set(() => null);
    this.yAxisConfig.set(() => null);
    this.ySubAxisConfig.set(() => null);
    this.showType.set("chart");
    this.events = new EventDispatcher();
    const { data, error, loading } = get_store_value(this.option);
    this.data.set(data != null ? data : []);
    this.loading.set(loading != null ? loading : false);
    this.error.set(error);
    await tick();
    const type2 = get_store_value(this.type);
    if (type2) {
      if (type2 === "bar" || type2 === "line") {
        this.chartStore = new Store$f(this);
      } else if (type2 === chartType$c) {
        this.chartStore = new Store$c(this);
      } else if (type2 === chartType$e) {
        this.chartStore = new Store$e(this);
      } else if (type2 === chartType$b) {
        this.chartStore = new Store$b(this);
      } else if (type2 === chartType$a) {
        this.chartStore = new Store$a(this);
      } else if (type2 === chartType$8) {
        this.chartStore = new Store$8(this);
      } else if (type2 === chartType$7) {
        this.chartStore = new Store$7(this);
      } else if (type2 === chartType$3) {
        this.chartStore = new Store$3(this);
      } else if (type2 === chartType$5) {
        this.chartStore = new Store$5(this);
      } else if (type2 === chartType$2) {
        this.chartStore = new Store$2(this);
      } else if (type2 === chartType$1) {
        this.chartStore = new Store$1(this);
      } else if (type2 === chartType) {
        this.chartStore = new Store16(this);
      } else if (type2 === chartType$d) {
        this.chartStore = new Store$d(this);
      } else if (type2 === chartType$4) {
        this.chartStore = new Store$4(this);
      } else if (type2 === chartType$6) {
        this.chartStore = new Store$6(this);
      } else if (type2 === chartType$9) {
        this.chartStore = new Store$9(this);
      } else
        ;
    }
    this._resolver();
  }
  getSvg() {
    return get_store_value(this.svg);
  }
  exportSvgData() {
    return exportSvgData(this);
  }
  async exportImage() {
    return exportDataUrl(this, "png");
  }
  async exportDataUrl(imageType) {
    return exportDataUrl(this, imageType);
  }
  async wait() {
    await this.load;
    await this.mainMounted;
    await Promise.all(this.promises);
  }
  setTimeout(callback, time) {
    const id2 = setTimeout(callback, time);
    this.intervalIds.push(id2);
    return id2;
  }
  setTimeoutIfBrowser(callback) {
    if (this.ssr) {
      callback();
    } else {
      this.setTimeout(callback);
    }
  }
  destroy() {
    this.unsubscribers.forEach((unsubscribe) => {
      if (unsubscribe) {
        unsubscribe();
      }
    });
    this.unsubscribers = [];
    this.intervalIds.forEach((id2) => {
      clearInterval(id2);
    });
    this.svelteInstance.$destroy();
    delete instances[this.id];
  }
}
const jsDocument = document;
const document$1 = typeof window !== "undefined" ? window.document : null;
export {
  ALPHA$1 as ALPHA,
  AreaShape,
  AreaShapeComponent,
  index$d as BarChart,
  BoundingRect,
  BoxTextShape,
  CategoryAxisConfig,
  CircleOverlapShape,
  CircleShape,
  index$c as CrossTable,
  DEFAULT_FONT_FAMILY,
  index$b as DataTable,
  index$a as GeoMap,
  Group,
  GroupShape,
  GroupShapeComponent,
  index$9 as HeatMapChart,
  ImageShape,
  LineShape,
  LineShapeComponent,
  index$8 as MultiAxisChart,
  index$7 as PieChart,
  PolylineShape,
  PolylineShapeComponent,
  RaccoonChart2 as RaccoonChart,
  RectShape,
  index$6 as Sankey,
  SankeyShape,
  index$5 as ScatterChart,
  index$4 as ScoreCard,
  SectorShape,
  SectorShapeComponent,
  Style,
  index$3 as SunburstChart,
  SvgShape,
  TextShape,
  index$2 as TreeMapChart,
  ValueAxisConfig,
  index$1 as VennDiagram,
  index as WordCloud,
  asAny,
  asValidNumber,
  axisFormatPercent,
  base64ToBinary,
  binaryToUint8Array,
  colorPalette,
  colors,
  computeHeight$1 as computeHeight,
  computeWidth,
  consoleLog,
  containShapes,
  copyToClipboard,
  dataMapper,
  dataUrlToBase64,
  dataUrlToUint8Array,
  derived,
  document$1 as document,
  dotText,
  download,
  emptyHandler,
  exportCanvas,
  exportDataUrl,
  exportSvgData,
  flattenShapes,
  formatComma,
  formatPercent,
  get_store_value as get,
  getInstance,
  getString,
  instances,
  isLoaded,
  isValidNumber,
  jsDocument,
  load,
  measureHeight,
  measureText,
  newString,
  normalizeRad,
  parseCategoryArrayColumn,
  parseCategoryColumn,
  parseColorUtils,
  parseValueColumn,
  pointInPolyline,
  processShapes,
  readable,
  round$1 as round,
  sortDomain,
  sortShapes,
  sqrt$1 as sqrt,
  styleToString,
  sum,
  textAlignMap,
  textBaselineMap,
  textLength,
  textSubstr,
  uint8ArrayToBase64,
  writable
};
